module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "00ee":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "010e":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uzLatn = moment.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
            '_'
        ),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uzLatn;

})));


/***/ }),

/***/ "01b4":
/***/ (function(module, exports) {

var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    if (this.head) this.tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      this.head = entry.next;
      if (this.tail === entry) this.tail = null;
      return entry.item;
    }
  }
};

module.exports = Queue;


/***/ }),

/***/ "02fb":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ml = moment.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
            '_'
        ),
        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
            '_'
        ),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം',
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        },
    });

    return ml;

})));


/***/ }),

/***/ "0366":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var aCallable = __webpack_require__("59ed");

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : bind ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "036e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_quick_replies_vue_vue_type_style_index_0_id_dfab3daa_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ef98");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_quick_replies_vue_vue_type_style_index_0_id_dfab3daa_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_quick_replies_vue_vue_type_style_index_0_id_dfab3daa_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "03ec":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cv = moment.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
            '_'
        ),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
            '_'
        ),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (output) {
                var affix = /сехет$/i.exec(output)
                    ? 'рен'
                    : /ҫул$/i.exec(output)
                    ? 'тан'
                    : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return cv;

})));


/***/ }),

/***/ "0538":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var aCallable = __webpack_require__("59ed");
var isObject = __webpack_require__("861d");
var hasOwn = __webpack_require__("1a2d");
var arraySlice = __webpack_require__("f36a");

var Function = global.Function;
var concat = uncurryThis([].concat);
var join = uncurryThis([].join);
var factories = {};

var construct = function (C, argsLength, args) {
  if (!hasOwn(factories, argsLength)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    factories[argsLength] = Function('C,a', 'return new C(' + join(list, ',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
module.exports = Function.bind || function bind(that /* , ...args */) {
  var F = aCallable(this);
  var Prototype = F.prototype;
  var partArgs = arraySlice(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = concat(partArgs, arraySlice(arguments));
    return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
  };
  if (isObject(Prototype)) boundFunction.prototype = Prototype;
  return boundFunction;
};


/***/ }),

/***/ "0558":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nokkrar sekúndur'
                    : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
                    );
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return (
                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
                    );
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture
                            ? 'klukkustundir'
                            : 'klukkustundum')
                    );
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
            '_'
        ),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: 'klukkustund',
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return is;

})));


/***/ }),

/***/ "057f":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-object-getownpropertynames -- safe */
var classof = __webpack_require__("c6b6");
var toIndexedObject = __webpack_require__("fc6a");
var $getOwnPropertyNames = __webpack_require__("241c").f;
var arraySlice = __webpack_require__("4dae");

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) == 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var call = __webpack_require__("c65b");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPropertyKey = __webpack_require__("a04b");
var hasOwn = __webpack_require__("1a2d");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ "0721":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123
//! author : Kristian Sakarisson : https://github.com/sakarisson

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fo = moment.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
            '_'
        ),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fo;

})));


/***/ }),

/***/ "079e":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ja = moment.defineLocale('ja', {
        eras: [
            {
                since: '2019-05-01',
                offset: 1,
                name: '令和',
                narrow: '㋿',
                abbr: 'R',
            },
            {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: '平成',
                narrow: '㍻',
                abbr: 'H',
            },
            {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: '昭和',
                narrow: '㍼',
                abbr: 'S',
            },
            {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: '大正',
                narrow: '㍽',
                abbr: 'T',
            },
            {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: '明治',
                narrow: '㍾',
                abbr: 'M',
            },
            {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: '西暦',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: '紀元前',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function (input, match) {
            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm',
        },
        meridiemParse: /午前|午後/i,
        isPM: function (input) {
            return input === '午後';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[昨日] LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function (number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? '元年' : number + '年';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年',
        },
    });

    return ja;

})));


/***/ }),

/***/ "07fa":
/***/ (function(module, exports, __webpack_require__) {

var toLength = __webpack_require__("50c4");

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ "0a3c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return esDo;

})));


/***/ }),

/***/ "0a84":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arMa = moment.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arMa;

})));


/***/ }),

/***/ "0b42":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isArray = __webpack_require__("e8b5");
var isConstructor = __webpack_require__("68ee");
var isObject = __webpack_require__("861d");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');
var Array = global.Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "0caa":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['thoddea sekondamni', 'thodde sekond'],
            ss: [number + ' sekondamni', number + ' sekond'],
            m: ['eka mintan', 'ek minut'],
            mm: [number + ' mintamni', number + ' mintam'],
            h: ['eka voran', 'ek vor'],
            hh: [number + ' voramni', number + ' voram'],
            d: ['eka disan', 'ek dis'],
            dd: [number + ' disamni', number + ' dis'],
            M: ['eka mhoinean', 'ek mhoino'],
            MM: [number + ' mhoineamni', number + ' mhoine'],
            y: ['eka vorsan', 'ek voros'],
            yy: [number + ' vorsamni', number + ' vorsam'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months: {
            standalone: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
                '_'
            ),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokallim') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokallim';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        },
    });

    return gomLatn;

})));


/***/ }),

/***/ "0cb2":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var toObject = __webpack_require__("7b0b");

var floor = Math.floor;
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice(str, 0, position);
      case "'": return stringSlice(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "0d51":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

var String = global.String;

module.exports = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ "0e49":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCh = moment.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return frCh;

})));


/***/ }),

/***/ "0e6b":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enAu;

})));


/***/ }),

/***/ "0e81":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı",
    };

    var tr = moment.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
            '_'
        ),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
            '_'
        ),
        weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'öö' : 'ÖÖ';
            } else {
                return isLower ? 'ös' : 'ÖS';
            }
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function (input) {
            return input === 'ös' || input === 'ÖS';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            w: 'bir hafta',
            ww: '%d hafta',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'ıncı";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tr;

})));


/***/ }),

/***/ "0f14":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var da = moment.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return da;

})));


/***/ }),

/***/ "0f38":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tlPh = moment.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlPh;

})));


/***/ }),

/***/ "0ff2":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eu = moment.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
            '_'
        ),
        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
            '_'
        ),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eu;

})));


/***/ }),

/***/ "107c":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var global = __webpack_require__("da84");

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});


/***/ }),

/***/ "1081":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "10e8":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var th = moment.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
            '_'
        ),
        monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            w: '1 สัปดาห์',
            ww: '%d สัปดาห์',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี',
        },
    });

    return th;

})));


/***/ }),

/***/ "1276":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var apply = __webpack_require__("2ba4");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var isRegExp = __webpack_require__("44e7");
var anObject = __webpack_require__("825a");
var requireObjectCoercible = __webpack_require__("1d80");
var speciesConstructor = __webpack_require__("4840");
var advanceStringIndex = __webpack_require__("8aa5");
var toLength = __webpack_require__("50c4");
var toString = __webpack_require__("577e");
var getMethod = __webpack_require__("dc4a");
var arraySlice = __webpack_require__("4dae");
var callRegExpExec = __webpack_require__("14c3");
var regexpExec = __webpack_require__("9263");
var stickyHelpers = __webpack_require__("9f7f");
var fails = __webpack_require__("d039");

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min = Math.min;
var $push = [].push;
var exec = uncurryThis(/./.exec);
var push = uncurryThis($push);
var stringSlice = uncurryThis(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return call(nativeSplit, string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = call(regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          push(output, stringSlice(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) apply($push, output, arraySlice(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !exec(separatorCopy, '')) push(output, '');
      } else push(output, stringSlice(string, lastLastIndex));
      return output.length > lim ? arraySlice(output, 0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? call(splitter, separator, O, limit)
        : call(internalSplit, toString(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push(A, stringSlice(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push(A, stringSlice(S, p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);


/***/ }),

/***/ "13e9":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једне минуте'],
            mm: ['минут', 'минуте', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            dd: ['дан', 'дана', 'дана'],
            MM: ['месец', 'месеца', 'месеци'],
            yy: ['година', 'године', 'година'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
            '_'
        ),
        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'дан',
            dd: translator.translate,
            M: 'месец',
            MM: translator.translate,
            y: 'годину',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return srCyrl;

})));


/***/ }),

/***/ "14c3":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var anObject = __webpack_require__("825a");
var isCallable = __webpack_require__("1626");
var classof = __webpack_require__("c6b6");
var regexpExec = __webpack_require__("9263");

var TypeError = global.TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = call(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call(regexpExec, R, S);
  throw TypeError('RegExp#exec called on incompatible receiver');
};


/***/ }),

/***/ "159b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var DOMTokenListPrototype = __webpack_require__("785a");
var forEach = __webpack_require__("17c2");
var createNonEnumerableProperty = __webpack_require__("9112");

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);


/***/ }),

/***/ "1626":
/***/ (function(module, exports) {

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ "167b":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Occitan, lengadocian dialecte [oc-lnc]
//! author : Quentin PAGÈS : https://github.com/Quenty31

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ocLnc = moment.defineLocale('oc-lnc', {
        months: {
            standalone: 'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
                '_'
            ),
            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort: 'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: '[uèi a] LT',
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: '[ièr a] LT',
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4,
        },
    });

    return ocLnc;

})));


/***/ }),

/***/ "1788":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_button_vue_vue_type_style_index_0_id_2ec05ef6_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c9aa");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_button_vue_vue_type_style_index_0_id_2ec05ef6_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_button_vue_vue_type_style_index_0_id_2ec05ef6_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "17c2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__("b727").forEach;
var arrayMethodIsStrict = __webpack_require__("a640");

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ "19aa":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isPrototypeOf = __webpack_require__("3a9b");

var TypeError = global.TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw TypeError('Incorrect invocation');
};


/***/ }),

/***/ "19cd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_text_input_vue_vue_type_style_index_0_id_2840dc56_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cd54");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_text_input_vue_vue_type_style_index_0_id_2840dc56_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_text_input_vue_vue_type_style_index_0_id_2840dc56_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "19d6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1a2d":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var toObject = __webpack_require__("7b0b");

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ "1b45":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mt = moment.defineLocale('mt', {
        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays: 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
            '_'
        ),
        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mt;

})));


/***/ }),

/***/ "1be4":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "1c7e":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "1cdc":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");

module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);


/***/ }),

/***/ "1cfd":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Lybia) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            0: '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arLy = moment.defineLocale('ar-ly', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arLy;

})));


/***/ }),

/***/ "1d80":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

var TypeError = global.TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1dde":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "1ea6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_radio_button_vue_vue_type_style_index_0_id_12681963_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d332");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_radio_button_vue_vue_type_style_index_0_id_12681963_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_radio_button_vue_vue_type_style_index_0_id_12681963_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1fc1":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            dd: 'дзень_дні_дзён',
            MM: 'месяц_месяцы_месяцаў',
            yy: 'год_гады_гадоў',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
                '_'
            ),
            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
                '_'
            ),
        },
        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split(
            '_'
        ),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
                '_'
            ),
            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
                '_'
            ),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) &&
                        number % 100 !== 12 &&
                        number % 100 !== 13
                        ? number + '-і'
                        : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return be;

})));


/***/ }),

/***/ "201b":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/IrakliJani

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ka = moment.defineLocale('ka', {
        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
            '_'
        ),
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
                '_'
            ),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
                '_'
            ),
            isFormat: /(წინა|შემდეგ)/,
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return s.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function (
                    $0,
                    $1,
                    $2
                ) {
                    return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                });
            },
            past: function (s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
                return s;
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი',
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (
                number < 20 ||
                (number <= 100 && number % 20 === 0) ||
                number % 100 === 0
            ) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7,
        },
    });

    return ka;

})));


/***/ }),

/***/ "2266":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var bind = __webpack_require__("0366");
var call = __webpack_require__("c65b");
var anObject = __webpack_require__("825a");
var tryToString = __webpack_require__("0d51");
var isArrayIteratorMethod = __webpack_require__("e95a");
var lengthOfArrayLike = __webpack_require__("07fa");
var isPrototypeOf = __webpack_require__("3a9b");
var getIterator = __webpack_require__("9a1f");
var getIteratorMethod = __webpack_require__("35a1");
var iteratorClose = __webpack_require__("2a62");

var TypeError = global.TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};


/***/ }),

/***/ "22f8":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    return ko;

})));


/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("5926");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var setGlobal = __webpack_require__("ce4e");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "2421":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kurdish [ku]
//! author : Shahram Mebashar : https://github.com/ShahramMebashar

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        months = [
            'کانونی دووەم',
            'شوبات',
            'ئازار',
            'نیسان',
            'ئایار',
            'حوزەیران',
            'تەمموز',
            'ئاب',
            'ئەیلوول',
            'تشرینی یەكەم',
            'تشرینی دووەم',
            'كانونی یەکەم',
        ];

    var ku = moment.defineLocale('ku', {
        months: months,
        monthsShort: months,
        weekdays: 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
            '_'
        ),
        weekdaysShort: 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split(
            '_'
        ),
        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ku;

})));


/***/ }),

/***/ "2554":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bs;

})));


/***/ }),

/***/ "25f0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("e330");
var PROPER_FUNCTION_NAME = __webpack_require__("5e77").PROPER;
var redefine = __webpack_require__("6eeb");
var anObject = __webpack_require__("825a");
var isPrototypeOf = __webpack_require__("3a9b");
var $toString = __webpack_require__("577e");
var fails = __webpack_require__("d039");
var regExpFlags = __webpack_require__("ad6d");

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var n$ToString = RegExpPrototype[TO_STRING];
var getFlags = uncurryThis(regExpFlags);

var NOT_GENERIC = fails(function () { return n$ToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && n$ToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = $toString(R.source);
    var rf = R.flags;
    var f = $toString(rf === undefined && isPrototypeOf(RegExpPrototype, R) && !('flags' in RegExpPrototype) ? getFlags(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),

/***/ "2626":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("d066");
var definePropertyModule = __webpack_require__("9bf2");
var wellKnownSymbol = __webpack_require__("b622");
var DESCRIPTORS = __webpack_require__("83ab");

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ "26f9":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundė_sekundžių_sekundes',
        m: 'minutė_minutės_minutę',
        mm: 'minutės_minučių_minutes',
        h: 'valanda_valandos_valandą',
        hh: 'valandos_valandų_valandas',
        d: 'diena_dienos_dieną',
        dd: 'dienos_dienų_dienas',
        M: 'mėnuo_mėnesio_mėnesį',
        MM: 'mėnesiai_mėnesių_mėnesius',
        y: 'metai_metų_metus',
        yy: 'metai_metų_metus',
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix
            ? forms(key)[0]
            : isFuture
            ? forms(key)[1]
            : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return (
                result + translateSingular(number, withoutSuffix, key[0], isFuture)
            );
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
                '_'
            ),
            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
                '_'
            ),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
                '_'
            ),
            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
                '_'
            ),
            isFormat: /dddd HH:mm/,
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate,
            m: translateSingular,
            mm: translate,
            h: translateSingular,
            hh: translate,
            d: translateSingular,
            dd: translate,
            M: translateSingular,
            MM: translate,
            y: translateSingular,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function (number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lt;

})));


/***/ }),

/***/ "2921":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk
//! author : Chien Kira : https://github.com/chienkira

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var vi = moment.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
            '_'
        ),
        monthsShort: 'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
            '_'
        ),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function (input) {
            return /^ch$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            w: 'một tuần',
            ww: '%d tuần',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return vi;

})));


/***/ }),

/***/ "293c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return me;

})));


/***/ }),

/***/ "2a62":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("c65b");
var anObject = __webpack_require__("825a");
var getMethod = __webpack_require__("dc4a");

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ "2ba4":
/***/ (function(module, exports) {

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (bind ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ "2bfb":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var af = moment.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
            '_'
        ),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function (input) {
            return /^nm$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            ); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        },
    });

    return af;

})));


/***/ }),

/***/ "2c3e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DESCRIPTORS = __webpack_require__("83ab");
var MISSED_STICKY = __webpack_require__("9f7f").MISSED_STICKY;
var classof = __webpack_require__("c6b6");
var defineProperty = __webpack_require__("9bf2").f;
var getInternalState = __webpack_require__("69f3").get;

var RegExpPrototype = RegExp.prototype;
var TypeError = global.TypeError;

// `RegExp.prototype.sticky` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.sticky
if (DESCRIPTORS && MISSED_STICKY) {
  defineProperty(RegExpPrototype, 'sticky', {
    configurable: true,
    get: function () {
      if (this === RegExpPrototype) return undefined;
      // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.
      if (classof(this) === 'RegExp') {
        return !!getInternalState(this).sticky;
      }
      throw TypeError('Incompatible receiver, RegExp required');
    }
  });
}


/***/ }),

/***/ "2cf4":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var apply = __webpack_require__("2ba4");
var bind = __webpack_require__("0366");
var isCallable = __webpack_require__("1626");
var hasOwn = __webpack_require__("1a2d");
var fails = __webpack_require__("d039");
var html = __webpack_require__("1be4");
var arraySlice = __webpack_require__("f36a");
var createElement = __webpack_require__("cc12");
var IS_IOS = __webpack_require__("1cdc");
var IS_NODE = __webpack_require__("605d");

var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var Dispatch = global.Dispatch;
var Function = global.Function;
var MessageChannel = global.MessageChannel;
var String = global.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var location, defer, channel, port;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  location = global.location;
} catch (error) { /* empty */ }

var run = function (id) {
  if (hasOwn(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global.postMessage(String(id), location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      apply(isCallable(fn) ? fn : Function(fn), undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    isCallable(global.postMessage) &&
    !global.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails(post)
  ) {
    defer = post;
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ "2d00":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("342f");

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ "2e8c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uz = moment.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
            '_'
        ),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return uz;

})));


/***/ }),

/***/ "2ef0":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba"), __webpack_require__("62e4")(module)))

/***/ }),

/***/ "3012":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_message_composer_vue_vue_type_style_index_0_id_3e2f946a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8ed9");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_message_composer_vue_vue_type_style_index_0_id_3e2f946a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_message_composer_vue_vue_type_style_index_0_id_3e2f946a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "32c2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "32c4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_icon_vue_vue_type_style_index_0_id_23af1a56_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f0aa");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_icon_vue_vue_type_style_index_0_id_23af1a56_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_icon_vue_vue_type_style_index_0_id_23af1a56_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "3410":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var toObject = __webpack_require__("7b0b");
var nativeGetPrototypeOf = __webpack_require__("e163");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ "342f":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "35a1":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("f5df");
var getMethod = __webpack_require__("dc4a");
var Iterators = __webpack_require__("3f8c");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ "36a2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_file_message_vue_vue_type_style_index_0_id_2716a584_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e19a");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_file_message_vue_vue_type_style_index_0_id_2716a584_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_file_message_vue_vue_type_style_index_0_id_2716a584_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "37e8":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("aed9");
var definePropertyModule = __webpack_require__("9bf2");
var anObject = __webpack_require__("825a");
var toIndexedObject = __webpack_require__("fc6a");
var objectKeys = __webpack_require__("df75");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),

/***/ "3886":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enCa;

})));


/***/ }),

/***/ "39a6":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enGb;

})));


/***/ }),

/***/ "39bd":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';
                    break;
                case 'ss':
                    output = '%d सेकंद';
                    break;
                case 'm':
                    output = 'एक मिनिट';
                    break;
                case 'mm':
                    output = '%d मिनिटे';
                    break;
                case 'h':
                    output = 'एक तास';
                    break;
                case 'hh':
                    output = '%d तास';
                    break;
                case 'd':
                    output = 'एक दिवस';
                    break;
                case 'dd':
                    output = '%d दिवस';
                    break;
                case 'M':
                    output = 'एक महिना';
                    break;
                case 'MM':
                    output = '%d महिने';
                    break;
                case 'y':
                    output = 'एक वर्ष';
                    break;
                case 'yy':
                    output = '%d वर्षे';
                    break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';
                    break;
                case 'ss':
                    output = '%d सेकंदां';
                    break;
                case 'm':
                    output = 'एका मिनिटा';
                    break;
                case 'mm':
                    output = '%d मिनिटां';
                    break;
                case 'h':
                    output = 'एका तासा';
                    break;
                case 'hh':
                    output = '%d तासां';
                    break;
                case 'd':
                    output = 'एका दिवसा';
                    break;
                case 'dd':
                    output = '%d दिवसां';
                    break;
                case 'M':
                    output = 'एका महिन्या';
                    break;
                case 'MM':
                    output = '%d महिन्यां';
                    break;
                case 'y':
                    output = 'एका वर्षा';
                    break;
                case 'yy':
                    output = '%d वर्षां';
                    break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
            '_'
        ),
        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr,
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                return hour;
            } else if (
                meridiem === 'दुपारी' ||
                meridiem === 'सायंकाळी' ||
                meridiem === 'रात्री'
            ) {
                return hour >= 12 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour >= 0 && hour < 6) {
                return 'पहाटे';
            } else if (hour < 12) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return mr;

})));


/***/ }),

/***/ "3a39":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    var ne = moment.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
            '_'
        ),
        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
            '_'
        ),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ne;

})));


/***/ }),

/***/ "3a6c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Macau) [zh-mo]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Tan Yuanhong : https://github.com/le0tan

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhMo = moment.defineLocale('zh-mo', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'D/M/YYYY',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhMo;

})));


/***/ }),

/***/ "3a9b":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ "3b1b":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tajik [tg]
//! author : Orif N. Jr. : https://github.com/orif-jr

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум',
    };

    var tg = moment.defineLocale('tg', {
        months: {
            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
                '_'
            ),
            standalone: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
                '_'
            ),
        },
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
            '_'
        ),
        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Фардо соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол',
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1th is the first week of the year.
        },
    });

    return tg;

})));


/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");

var String = global.String;
var TypeError = global.TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw TypeError("Can't set " + String(argument) + ' as a prototype');
};


/***/ }),

/***/ "3c0d":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
            '_'
        ),
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
        monthsParse = [
            /^led/i,
            /^úno/i,
            /^bře/i,
            /^dub/i,
            /^kvě/i,
            /^(čvn|červen$|června)/i,
            /^(čvc|červenec|července)/i,
            /^srp/i,
            /^zář/i,
            /^říj/i,
            /^lis/i,
            /^pro/i,
        ],
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
        }
    }

    var cs = moment.defineLocale('cs', {
        months: months,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY',
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cs;

})));


/***/ }),

/***/ "3ca3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;
var toString = __webpack_require__("577e");
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "3de5":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '௧',
            2: '௨',
            3: '௩',
            4: '௪',
            5: '௫',
            6: '௬',
            7: '௭',
            8: '௮',
            9: '௯',
            0: '௦',
        },
        numberMap = {
            '௧': '1',
            '௨': '2',
            '௩': '3',
            '௪': '4',
            '௫': '5',
            '௬': '6',
            '௭': '7',
            '௮': '8',
            '௯': '9',
            '௦': '0',
        };

    var ta = moment.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
            '_'
        ),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
            '_'
        ),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm',
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்',
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ta;

})));


/***/ }),

/***/ "3e92":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '೧',
            2: '೨',
            3: '೩',
            4: '೪',
            5: '೫',
            6: '೬',
            7: '೭',
            8: '೮',
            9: '೯',
            0: '೦',
        },
        numberMap = {
            '೧': '1',
            '೨': '2',
            '೩': '3',
            '೪': '4',
            '೫': '5',
            '೬': '6',
            '೭': '7',
            '೮': '8',
            '೯': '9',
            '೦': '0',
        };

    var kn = moment.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
            '_'
        ),
        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
            '_'
        ),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ',
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function (number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return kn;

})));


/***/ }),

/***/ "3f8c":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "408a":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports = uncurryThis(1.0.valueOf);


/***/ }),

/***/ "41fb":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():undefined}("undefined"!=typeof self?self:this,(function(){return function(){var e={661:function(){"undefined"!=typeof window&&function(){for(var e=0,t=["ms","moz","webkit","o"],i=0;i<t.length&&!window.requestAnimationFrame;++i)window.requestAnimationFrame=window[t[i]+"RequestAnimationFrame"],window.cancelAnimationFrame=window[t[i]+"CancelAnimationFrame"]||window[t[i]+"CancelRequestAnimationFrame"];window.requestAnimationFrame||(window.requestAnimationFrame=function(t,i){var n=(new Date).getTime(),r=Math.max(0,16-(n-e)),o=window.setTimeout((function(){t(n+r)}),r);return e=n+r,o}),window.cancelAnimationFrame||(window.cancelAnimationFrame=function(e){clearTimeout(e)})}()}},t={};function i(n){var r=t[n];if(void 0!==r)return r.exports;var o=t[n]={exports:{}};return e[n](o,o.exports,i),o.exports}i.d=function(e,t){for(var n in t)i.o(t,n)&&!i.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]})},i.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},i.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var n={};return function(){"use strict";i.r(n),i.d(n,{Anchors:function(){return k},Category:function(){return J},Emoji:function(){return W},EmojiData:function(){return $},EmojiIndex:function(){return q},EmojiView:function(){return R},Picker:function(){return oe},Preview:function(){return Z},Search:function(){return K},Skins:function(){return X},frequently:function(){return w},sanitize:function(){return N},store:function(){return c},uncompress:function(){return v}});var e,t,r="emoji-mart",o=JSON,s="undefined"!=typeof window&&"localStorage"in window;function a(e,i){if(t)t(e,i);else{if(!s)return;try{window.localStorage["".concat(r,".").concat(e)]=o.stringify(i)}catch(e){}}}var c={update:function(e){for(var t in e)a(t,e[t])},set:a,get:function(t){if(e)return e(t);if(s){try{var i=window.localStorage["".concat(r,".").concat(t)]}catch(e){return}return i?JSON.parse(i):void 0}},setNamespace:function(e){r=e},setHandlers:function(i){i||(i={}),e=i.getter,t=i.setter}};function u(e){return u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},u(e)}function l(e,t){(null==t||t>e.length)&&(t=e.length);for(var i=0,n=new Array(t);i<t;i++)n[i]=e[i];return n}var h={name:"a",unified:"b",non_qualified:"c",has_img_apple:"d",has_img_google:"e",has_img_twitter:"f",has_img_facebook:"h",keywords:"j",sheet:"k",emoticons:"l",text:"m",short_names:"n",added_in:"o"},m=function(e){var t=[],i=function(e,i){e&&(Array.isArray(e)?e:[e]).forEach((function(e){(i?e.split(/[-|_|\s]+/):[e]).forEach((function(e){e=e.toLowerCase(),-1==t.indexOf(e)&&t.push(e)}))}))};return i(e.short_names,!0),i(e.name,!0),i(e.keywords,!1),i(e.emoticons,!1),t.join(",")};function d(e){var t,i=function(e,t){var i="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!i){if(Array.isArray(e)||(i=function(e,t){if(e){if("string"==typeof e)return l(e,t);var i=Object.prototype.toString.call(e).slice(8,-1);return"Object"===i&&e.constructor&&(i=e.constructor.name),"Map"===i||"Set"===i?Array.from(e):"Arguments"===i||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)?l(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){i&&(e=i);var n=0,r=function(){};return{s:r,n:function(){return n>=e.length?{done:!0}:{done:!1,value:e[n++]}},e:function(e){throw e},f:r}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var o,s=!0,a=!1;return{s:function(){i=i.call(e)},n:function(){var e=i.next();return s=e.done,e},e:function(e){a=!0,o=e},f:function(){try{s||null==i.return||i.return()}finally{if(a)throw o}}}}(Object.getOwnPropertyNames(e));try{for(i.s();!(t=i.n()).done;){var n=t.value,r=e[n];e[n]=r&&"object"===u(r)?d(r):r}}catch(e){i.e(e)}finally{i.f()}return Object.freeze(e)}var f,p,v=function(e){if(!e.compressed)return e;for(var t in e.compressed=!1,e.emojis){var i=e.emojis[t];for(var n in h)i[n]=i[h[n]],delete i[h[n]];i.short_names||(i.short_names=[]),i.short_names.unshift(t),i.sheet_x=i.sheet[0],i.sheet_y=i.sheet[1],delete i.sheet,i.text||(i.text=""),i.added_in||(i.added_in=6),i.added_in=i.added_in.toFixed(1),i.search=m(i)}return d(e)},j=["+1","grinning","kissing_heart","heart_eyes","laughing","stuck_out_tongue_winking_eye","sweat_smile","joy","scream","disappointed","unamused","weary","sob","sunglasses","heart","hankey"],y={};function g(){p=!0,f=c.get("frequently")}var w={add:function(e){p||g();var t=e.id;f||(f=y),f[t]||(f[t]=0),f[t]+=1,c.set("last",t),c.set("frequently",f)},get:function(e){if(p||g(),!f){y={};for(var t=[],i=Math.min(e,j.length),n=0;n<i;n++)y[j[n]]=parseInt((i-n)/4,10)+1,t.push(j[n]);return t}var r=e,o=[];for(var s in f)f.hasOwnProperty(s)&&o.push(s);var a=o.sort((function(e,t){return f[e]-f[t]})).reverse().slice(0,r),u=c.get("last");return u&&-1==a.indexOf(u)&&(a.pop(),a.push(u)),a}},_={activity:'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12m9.949 11H17.05c.224-2.527 1.232-4.773 1.968-6.113A9.966 9.966 0 0 1 21.949 11M13 11V2.051a9.945 9.945 0 0 1 4.432 1.564c-.858 1.491-2.156 4.22-2.392 7.385H13zm-2 0H8.961c-.238-3.165-1.536-5.894-2.393-7.385A9.95 9.95 0 0 1 11 2.051V11zm0 2v8.949a9.937 9.937 0 0 1-4.432-1.564c.857-1.492 2.155-4.221 2.393-7.385H11zm4.04 0c.236 3.164 1.534 5.893 2.392 7.385A9.92 9.92 0 0 1 13 21.949V13h2.04zM4.982 4.887C5.718 6.227 6.726 8.473 6.951 11h-4.9a9.977 9.977 0 0 1 2.931-6.113M2.051 13h4.9c-.226 2.527-1.233 4.771-1.969 6.113A9.972 9.972 0 0 1 2.051 13m16.967 6.113c-.735-1.342-1.744-3.586-1.968-6.113h4.899a9.961 9.961 0 0 1-2.931 6.113"/></svg>',custom:'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><g transform="translate(2.000000, 1.000000)"><rect id="Rectangle" x="8" y="0" width="3" height="21" rx="1.5"></rect><rect id="Rectangle" transform="translate(9.843, 10.549) rotate(60) translate(-9.843, -10.549) " x="8.343" y="0.049" width="3" height="21" rx="1.5"></rect><rect id="Rectangle" transform="translate(9.843, 10.549) rotate(-60) translate(-9.843, -10.549) " x="8.343" y="0.049" width="3" height="21" rx="1.5"></rect></g></svg>',flags:'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M0 0l6.084 24H8L1.916 0zM21 5h-4l-1-4H4l3 12h3l1 4h13L21 5zM6.563 3h7.875l2 8H8.563l-2-8zm8.832 10l-2.856 1.904L12.063 13h3.332zM19 13l-1.5-6h1.938l2 8H16l3-2z"/></svg>',foods:'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M17 4.978c-1.838 0-2.876.396-3.68.934.513-1.172 1.768-2.934 4.68-2.934a1 1 0 0 0 0-2c-2.921 0-4.629 1.365-5.547 2.512-.064.078-.119.162-.18.244C11.73 1.838 10.798.023 9.207.023 8.579.022 7.85.306 7 .978 5.027 2.54 5.329 3.902 6.492 4.999 3.609 5.222 0 7.352 0 12.969c0 4.582 4.961 11.009 9 11.009 1.975 0 2.371-.486 3-1 .629.514 1.025 1 3 1 4.039 0 9-6.418 9-11 0-5.953-4.055-8-7-8M8.242 2.546c.641-.508.943-.523.965-.523.426.169.975 1.405 1.357 3.055-1.527-.629-2.741-1.352-2.98-1.846.059-.112.241-.356.658-.686M15 21.978c-1.08 0-1.21-.109-1.559-.402l-.176-.146c-.367-.302-.816-.452-1.266-.452s-.898.15-1.266.452l-.176.146c-.347.292-.477.402-1.557.402-2.813 0-7-5.389-7-9.009 0-5.823 4.488-5.991 5-5.991 1.939 0 2.484.471 3.387 1.251l.323.276a1.995 1.995 0 0 0 2.58 0l.323-.276c.902-.78 1.447-1.251 3.387-1.251.512 0 5 .168 5 6 0 3.617-4.187 9-7 9"/></svg>',nature:'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M15.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 8M8.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 8"/><path d="M18.933 0h-.027c-.97 0-2.138.787-3.018 1.497-1.274-.374-2.612-.51-3.887-.51-1.285 0-2.616.133-3.874.517C7.245.79 6.069 0 5.093 0h-.027C3.352 0 .07 2.67.002 7.026c-.039 2.479.276 4.238 1.04 5.013.254.258.882.677 1.295.882.191 3.177.922 5.238 2.536 6.38.897.637 2.187.949 3.2 1.102C8.04 20.6 8 20.795 8 21c0 1.773 2.35 3 4 3 1.648 0 4-1.227 4-3 0-.201-.038-.393-.072-.586 2.573-.385 5.435-1.877 5.925-7.587.396-.22.887-.568 1.104-.788.763-.774 1.079-2.534 1.04-5.013C23.929 2.67 20.646 0 18.933 0M3.223 9.135c-.237.281-.837 1.155-.884 1.238-.15-.41-.368-1.349-.337-3.291.051-3.281 2.478-4.972 3.091-5.031.256.015.731.27 1.265.646-1.11 1.171-2.275 2.915-2.352 5.125-.133.546-.398.858-.783 1.313M12 22c-.901 0-1.954-.693-2-1 0-.654.475-1.236 1-1.602V20a1 1 0 1 0 2 0v-.602c.524.365 1 .947 1 1.602-.046.307-1.099 1-2 1m3-3.48v.02a4.752 4.752 0 0 0-1.262-1.02c1.092-.516 2.239-1.334 2.239-2.217 0-1.842-1.781-2.195-3.977-2.195-2.196 0-3.978.354-3.978 2.195 0 .883 1.148 1.701 2.238 2.217A4.8 4.8 0 0 0 9 18.539v-.025c-1-.076-2.182-.281-2.973-.842-1.301-.92-1.838-3.045-1.853-6.478l.023-.041c.496-.826 1.49-1.45 1.804-3.102 0-2.047 1.357-3.631 2.362-4.522C9.37 3.178 10.555 3 11.948 3c1.447 0 2.685.192 3.733.57 1 .9 2.316 2.465 2.316 4.48.313 1.651 1.307 2.275 1.803 3.102.035.058.068.117.102.178-.059 5.967-1.949 7.01-4.902 7.19m6.628-8.202c-.037-.065-.074-.13-.113-.195a7.587 7.587 0 0 0-.739-.987c-.385-.455-.648-.768-.782-1.313-.076-2.209-1.241-3.954-2.353-5.124.531-.376 1.004-.63 1.261-.647.636.071 3.044 1.764 3.096 5.031.027 1.81-.347 3.218-.37 3.235"/></svg>',objects:'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M12 0a9 9 0 0 0-5 16.482V21s2.035 3 5 3 5-3 5-3v-4.518A9 9 0 0 0 12 0zm0 2c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7 3.14-7 7-7zM9 17.477c.94.332 1.946.523 3 .523s2.06-.19 3-.523v.834c-.91.436-1.925.689-3 .689a6.924 6.924 0 0 1-3-.69v-.833zm.236 3.07A8.854 8.854 0 0 0 12 21c.965 0 1.888-.167 2.758-.451C14.155 21.173 13.153 22 12 22c-1.102 0-2.117-.789-2.764-1.453z"/><path d="M14.745 12.449h-.004c-.852-.024-1.188-.858-1.577-1.824-.421-1.061-.703-1.561-1.182-1.566h-.009c-.481 0-.783.497-1.235 1.537-.436.982-.801 1.811-1.636 1.791l-.276-.043c-.565-.171-.853-.691-1.284-1.794-.125-.313-.202-.632-.27-.913-.051-.213-.127-.53-.195-.634C7.067 9.004 7.039 9 6.99 9A1 1 0 0 1 7 7h.01c1.662.017 2.015 1.373 2.198 2.134.486-.981 1.304-2.058 2.797-2.075 1.531.018 2.28 1.153 2.731 2.141l.002-.008C14.944 8.424 15.327 7 16.979 7h.032A1 1 0 1 1 17 9h-.011c-.149.076-.256.474-.319.709a6.484 6.484 0 0 1-.311.951c-.429.973-.79 1.789-1.614 1.789"/></svg>',smileys:'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"/><path d="M8 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 8 7M16 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 7M15.232 15c-.693 1.195-1.87 2-3.349 2-1.477 0-2.655-.805-3.347-2H15m3-2H6a6 6 0 1 0 12 0"/></svg>',people:'<svg xmlns:svg="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24"> <path id="path3814" d="m 3.3591089,21.17726 c 0.172036,0.09385 4.265994,2.29837 8.8144451,2.29837 4.927767,0 8.670894,-2.211883 8.82782,-2.306019 0.113079,-0.06785 0.182268,-0.190051 0.182267,-0.321923 0,-3.03119 -0.929494,-5.804936 -2.617196,-7.810712 -1.180603,-1.403134 -2.661918,-2.359516 -4.295699,-2.799791 4.699118,-2.236258 3.102306,-9.28617162 -2.097191,-9.28617162 -5.1994978,0 -6.7963103,7.04991362 -2.097192,9.28617162 -1.6337821,0.440275 -3.1150971,1.396798 -4.2956991,2.799791 -1.687703,2.005776 -2.617196,4.779522 -2.617196,7.810712 1.2e-6,0.137378 0.075039,0.263785 0.195641,0.329572 z M 8.0439319,5.8308783 C 8.0439309,2.151521 12.492107,0.30955811 15.093491,2.9109411 17.694874,5.5123241 15.852911,9.9605006 12.173554,9.9605 9.8938991,9.9579135 8.0465186,8.1105332 8.0439319,5.8308783 Z m -1.688782,7.6894977 c 1.524535,-1.811449 3.5906601,-2.809035 5.8184041,-2.809035 2.227744,0 4.293869,0.997586 5.818404,2.809035 1.533639,1.822571 2.395932,4.339858 2.439152,7.108301 -0.803352,0.434877 -4.141636,2.096112 -8.257556,2.096112 -3.8062921,0 -7.3910861,-1.671043 -8.2573681,-2.104981 0.04505,-2.765017 0.906968,-5.278785 2.438964,-7.099432 z" /> <path id="path3816" d="M 12.173828 0.38867188 C 9.3198513 0.38867187 7.3770988 2.3672285 6.8652344 4.6308594 C 6.4218608 6.5916015 7.1153562 8.7676117 8.9648438 10.126953 C 7.6141249 10.677376 6.3550511 11.480944 5.3496094 12.675781 C 3.5629317 14.799185 2.6015625 17.701475 2.6015625 20.847656 C 2.6015654 21.189861 2.7894276 21.508002 3.0898438 21.671875 C 3.3044068 21.788925 7.4436239 24.039062 12.173828 24.039062 C 17.269918 24.039062 21.083568 21.776786 21.291016 21.652344 C 21.57281 21.483266 21.746097 21.176282 21.746094 20.847656 C 21.746094 17.701475 20.78277 14.799185 18.996094 12.675781 C 17.990455 11.480591 16.733818 10.675362 15.382812 10.125 C 17.231132 8.7655552 17.925675 6.5910701 17.482422 4.6308594 C 16.970557 2.3672285 15.027805 0.38867188 12.173828 0.38867188 z M 12.792969 2.3007812 C 13.466253 2.4161792 14.125113 2.7383941 14.695312 3.3085938 C 15.835712 4.4489931 15.985604 5.9473549 15.46875 7.1953125 C 14.951896 8.4432701 13.786828 9.3984378 12.173828 9.3984375 C 10.197719 9.3961954 8.607711 7.806187 8.6054688 5.8300781 C 8.6054683 4.2170785 9.5606362 3.0520102 10.808594 2.5351562 C 11.432573 2.2767293 12.119685 2.1853833 12.792969 2.3007812 z M 12.173828 11.273438 C 14.233647 11.273438 16.133674 12.185084 17.5625 13.882812 C 18.93069 15.508765 19.698347 17.776969 19.808594 20.283203 C 18.807395 20.800235 15.886157 22.162109 12.173828 22.162109 C 8.7614632 22.162109 5.6245754 20.787069 4.5390625 20.265625 C 4.6525896 17.766717 5.4203315 15.504791 6.7851562 13.882812 C 8.2139827 12.185084 10.11401 11.273438 12.173828 11.273438 z " /> </svg>',places:'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M6.5 12C5.122 12 4 13.121 4 14.5S5.122 17 6.5 17 9 15.879 9 14.5 7.878 12 6.5 12m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5M17.5 12c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.122-2.5-2.5-2.5m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5"/><path d="M22.482 9.494l-1.039-.346L21.4 9h.6c.552 0 1-.439 1-.992 0-.006-.003-.008-.003-.008H23c0-1-.889-2-1.984-2h-.642l-.731-1.717C19.262 3.012 18.091 2 16.764 2H7.236C5.909 2 4.738 3.012 4.357 4.283L3.626 6h-.642C1.889 6 1 7 1 8h.003S1 8.002 1 8.008C1 8.561 1.448 9 2 9h.6l-.043.148-1.039.346a2.001 2.001 0 0 0-1.359 2.097l.751 7.508a1 1 0 0 0 .994.901H3v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h6v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h1.096a.999.999 0 0 0 .994-.901l.751-7.508a2.001 2.001 0 0 0-1.359-2.097M6.273 4.857C6.402 4.43 6.788 4 7.236 4h9.527c.448 0 .834.43.963.857L19.313 9H4.688l1.585-4.143zM7 21H5v-1h2v1zm12 0h-2v-1h2v1zm2.189-3H2.811l-.662-6.607L3 11h18l.852.393L21.189 18z"/></svg>',recent:'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M13 4h-2l-.001 7H9v2h2v2h2v-2h4v-2h-4z"/><path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"/></svg>',symbols:'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M0 0h11v2H0zM4 11h3V6h4V4H0v2h4zM15.5 17c1.381 0 2.5-1.116 2.5-2.493s-1.119-2.493-2.5-2.493S13 13.13 13 14.507 14.119 17 15.5 17m0-2.986c.276 0 .5.222.5.493 0 .272-.224.493-.5.493s-.5-.221-.5-.493.224-.493.5-.493M21.5 19.014c-1.381 0-2.5 1.116-2.5 2.493S20.119 24 21.5 24s2.5-1.116 2.5-2.493-1.119-2.493-2.5-2.493m0 2.986a.497.497 0 0 1-.5-.493c0-.271.224-.493.5-.493s.5.222.5.493a.497.497 0 0 1-.5.493M22 13l-9 9 1.513 1.5 8.99-9.009zM17 11c2.209 0 4-1.119 4-2.5V2s.985-.161 1.498.949C23.01 4.055 23 6 23 6s1-1.119 1-3.135C24-.02 21 0 21 0h-2v6.347A5.853 5.853 0 0 0 17 6c-2.209 0-4 1.119-4 2.5s1.791 2.5 4 2.5M10.297 20.482l-1.475-1.585a47.54 47.54 0 0 1-1.442 1.129c-.307-.288-.989-1.016-2.045-2.183.902-.836 1.479-1.466 1.729-1.892s.376-.871.376-1.336c0-.592-.273-1.178-.818-1.759-.546-.581-1.329-.871-2.349-.871-1.008 0-1.79.293-2.344.879-.556.587-.832 1.181-.832 1.784 0 .813.419 1.748 1.256 2.805-.847.614-1.444 1.208-1.794 1.784a3.465 3.465 0 0 0-.523 1.833c0 .857.308 1.56.924 2.107.616.549 1.423.823 2.42.823 1.173 0 2.444-.379 3.813-1.137L8.235 24h2.819l-2.09-2.383 1.333-1.135zm-6.736-6.389a1.02 1.02 0 0 1 .73-.286c.31 0 .559.085.747.254a.849.849 0 0 1 .283.659c0 .518-.419 1.112-1.257 1.784-.536-.651-.805-1.231-.805-1.742a.901.901 0 0 1 .302-.669M3.74 22c-.427 0-.778-.116-1.057-.349-.279-.232-.418-.487-.418-.766 0-.594.509-1.288 1.527-2.083.968 1.134 1.717 1.946 2.248 2.438-.921.507-1.686.76-2.3.76"/></svg>'};function C(e,t,i,n,r,o,s,a){var c,u="function"==typeof e?e.options:e;if(t&&(u.render=t,u.staticRenderFns=i,u._compiled=!0),n&&(u.functional=!0),o&&(u._scopeId="data-v-"+o),s?(c=function(e){(e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),r&&r.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(s)},u._ssrRegister=c):r&&(c=a?function(){r.call(this,(u.functional?this.parent:this).$root.$options.shadowRoot)}:r),c)if(u.functional){u._injectStyles=c;var l=u.render;u.render=function(e,t){return c.call(t),l(e,t)}}else{var h=u.beforeCreate;u.beforeCreate=h?[].concat(h,c):[c]}return{exports:e,options:u}}var b=C({props:{i18n:{type:Object,required:!0},color:{type:String},categories:{type:Array,required:!0},activeCategory:{type:Object,default:function(){return{}}}},created:function(){this.svgs=_}},(function(){var e=this,t=e.$createElement,i=e._self._c||t;return i("div",{staticClass:"emoji-mart-anchors",attrs:{role:"tablist"}},e._l(e.categories,(function(t){return i("button",{key:t.id,class:{"emoji-mart-anchor":!0,"emoji-mart-anchor-selected":t.id==e.activeCategory.id},style:{color:t.id==e.activeCategory.id?e.color:""},attrs:{role:"tab","aria-label":t.name,"aria-selected":t.id==e.activeCategory.id,"data-title":e.i18n.categories[t.id]},on:{click:function(i){return e.$emit("click",t)}}},[i("div",{attrs:{"aria-hidden":"true"},domProps:{innerHTML:e._s(e.svgs[t.id])}}),e._v(" "),i("span",{staticClass:"emoji-mart-anchor-bar",style:{backgroundColor:e.color},attrs:{"aria-hidden":"true"}})])})),0)}),[],!1,null,null,null),k=b.exports;function E(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function S(e,t){for(var i=0;i<t.length;i++){var n=t[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function x(e,t,i){return t&&S(e.prototype,t),i&&S(e,i),e}var O=String.fromCodePoint||function(){var e,t,i=16384,n=[],r=-1,o=arguments.length;if(!o)return"";for(var s="";++r<o;){var a=Number(arguments[r]);if(!isFinite(a)||a<0||a>1114111||Math.floor(a)!=a)throw RangeError("Invalid code point: "+a);a<=65535?n.push(a):(e=55296+((a-=65536)>>10),t=a%1024+56320,n.push(e,t)),(r+1===o||n.length>i)&&(s+=String.fromCharCode.apply(null,n),n.length=0)}return s};function P(e){var t=e.split("-").map((function(e){return"0x".concat(e)}));return O.apply(null,t)}function A(e){return e.reduce((function(e,t){return-1===e.indexOf(t)&&e.push(t),e}),[])}function M(e,t){var i=A(e),n=A(t);return i.filter((function(e){return n.indexOf(e)>=0}))}function I(e,t){var i={};for(var n in e){var r=e[n],o=r;t.hasOwnProperty(n)&&(o=t[n]),"object"===u(o)&&(o=I(r,o)),i[n]=o}return i}function F(e,t){var i="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!i){if(Array.isArray(e)||(i=function(e,t){if(e){if("string"==typeof e)return z(e,t);var i=Object.prototype.toString.call(e).slice(8,-1);return"Object"===i&&e.constructor&&(i=e.constructor.name),"Map"===i||"Set"===i?Array.from(e):"Arguments"===i||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)?z(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){i&&(e=i);var n=0,r=function(){};return{s:r,n:function(){return n>=e.length?{done:!0}:{done:!1,value:e[n++]}},e:function(e){throw e},f:r}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var o,s=!0,a=!1;return{s:function(){i=i.call(e)},n:function(){var e=i.next();return s=e.done,e},e:function(e){a=!0,o=e},f:function(){try{s||null==i.return||i.return()}finally{if(a)throw o}}}}function z(e,t){(null==t||t>e.length)&&(t=e.length);for(var i=0,n=new Array(t);i<t;i++)n[i]=e[i];return n}var L=/^(?:\:([^\:]+)\:)(?:\:skin-tone-(\d)\:)?$/,T=["1F3FA","1F3FB","1F3FC","1F3FD","1F3FE","1F3FF"],q=function(){function e(t){var i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=i.emojisToShowFilter,r=i.include,o=i.exclude,s=i.custom,a=i.recent,c=i.recentLength,u=void 0===c?20:c;E(this,e),this._data=v(t),this._emojisFilter=n||null,this._include=r||null,this._exclude=o||null,this._custom=s||[],this._recent=a||w.get(u),this._emojis={},this._nativeEmojis={},this._emoticons={},this._categories=[],this._recentCategory={id:"recent",name:"Recent",emojis:[]},this._customCategory={id:"custom",name:"Custom",emojis:[]},this._searchIndex={},this.buildIndex(),Object.freeze(this)}return x(e,[{key:"buildIndex",value:function(){var e=this,t=this._data.categories;if(this._include&&(t=(t=t.filter((function(t){return e._include.includes(t.id)}))).sort((function(t,i){var n=e._include.indexOf(t.id),r=e._include.indexOf(i.id);return n<r?-1:n>r?1:0}))),t.forEach((function(t){if(e.isCategoryNeeded(t.id)){var i={id:t.id,name:t.name,emojis:[]};t.emojis.forEach((function(t){var n=e.addEmoji(t);n&&i.emojis.push(n)})),i.emojis.length&&e._categories.push(i)}})),this.isCategoryNeeded("custom")){if(this._custom.length>0){var i,n=F(this._custom);try{for(n.s();!(i=n.n()).done;){var r=i.value;this.addCustomEmoji(r)}}catch(e){n.e(e)}finally{n.f()}}this._customCategory.emojis.length&&this._categories.push(this._customCategory)}this.isCategoryNeeded("recent")&&(this._recent.length&&this._recent.map((function(t){var i,n=F(e._customCategory.emojis);try{for(n.s();!(i=n.n()).done;){var r=i.value;if(r.id===t)return void e._recentCategory.emojis.push(r)}}catch(e){n.e(e)}finally{n.f()}e.hasEmoji(t)&&e._recentCategory.emojis.push(e.emoji(t))})),this._recentCategory.emojis.length&&this._categories.unshift(this._recentCategory))}},{key:"findEmoji",value:function(e,t){var i=e.match(L);if(i&&(e=i[1],i[2]&&(t=parseInt(i[2],10))),this._data.aliases.hasOwnProperty(e)&&(e=this._data.aliases[e]),this._emojis.hasOwnProperty(e)){var n=this._emojis[e];return t?n.getSkin(t):n}return this._nativeEmojis.hasOwnProperty(e)?this._nativeEmojis[e]:null}},{key:"categories",value:function(){return this._categories}},{key:"emoji",value:function(e){this._data.aliases.hasOwnProperty(e)&&(e=this._data.aliases[e]);var t=this._emojis[e];if(!t)throw new Error("Can not find emoji by id: "+e);return t}},{key:"firstEmoji",value:function(){var e=this._emojis[Object.keys(this._emojis)[0]];if(!e)throw new Error("Can not get first emoji");return e}},{key:"hasEmoji",value:function(e){return this._data.aliases.hasOwnProperty(e)&&(e=this._data.aliases[e]),!!this._emojis[e]}},{key:"nativeEmoji",value:function(e){return this._nativeEmojis.hasOwnProperty(e)?this._nativeEmojis[e]:null}},{key:"search",value:function(e,t){var i=this;if(t||(t=75),!e.length)return null;if("-"==e||"-1"==e)return[this.emoji("-1")];var n,r=e.toLowerCase().split(/[\s|,|\-|_]+/);r.length>2&&(r=[r[0],r[1]]),n=r.map((function(e){for(var t=i._emojis,n=i._searchIndex,r=0,o=0;o<e.length;o++){var s=e[o];r++,n[s]||(n[s]={}),(n=n[s]).results||function(){var i={};for(var o in n.results=[],n.emojis={},t){var s=t[o],a=s._data.search,c=e.substr(0,r),u=a.indexOf(c);if(-1!=u){var l=u+1;c==o&&(l=0),n.results.push(s),n.emojis[o]=s,i[o]=l}}n.results.sort((function(e,t){return i[e.id]-i[t.id]}))}(),t=n.emojis}return n.results})).filter((function(e){return e}));var o=null;return(o=n.length>1?M.apply(null,n):n.length?n[0]:[])&&o.length>t&&(o=o.slice(0,t)),o}},{key:"addCustomEmoji",value:function(e){var t=Object.assign({},e,{id:e.short_names[0],custom:!0});t.search||(t.search=m(t));var i=new $(t);return this._emojis[i.id]=i,this._customCategory.emojis.push(i),i}},{key:"addEmoji",value:function(e){var t=this,i=this._data.emojis[e];if(!this.isEmojiNeeded(i))return!1;var n=new $(i);if(this._emojis[e]=n,n.native&&(this._nativeEmojis[n.native]=n),n._skins)for(var r in n._skins){var o=n._skins[r];o.native&&(this._nativeEmojis[o.native]=o)}return n.emoticons&&n.emoticons.forEach((function(i){t._emoticons[i]||(t._emoticons[i]=e)})),n}},{key:"isCategoryNeeded",value:function(e){var t=!this._include||!this._include.length||this._include.indexOf(e)>-1,i=!(!this._exclude||!this._exclude.length)&&this._exclude.indexOf(e)>-1;return!(!t||i)}},{key:"isEmojiNeeded",value:function(e){return!this._emojisFilter||this._emojisFilter(e)}}]),e}(),$=function(){function e(t){if(E(this,e),this._data=Object.assign({},t),this._skins=null,this._data.skin_variations)for(var i in this._skins=[],T){var n=T[i],r=this._data.skin_variations[n],o=Object.assign({},t);for(var s in r)o[s]=r[s];delete o.skin_variations,o.skin_tone=parseInt(i)+1,this._skins.push(new e(o))}for(var a in this._sanitized=N(this._data),this._sanitized)this[a]=this._sanitized[a];this.short_names=this._data.short_names,this.short_name=this._data.short_names[0],Object.freeze(this)}return x(e,[{key:"getSkin",value:function(e){return e&&"native"!=e&&this._skins?this._skins[e-1]:this}},{key:"getPosition",value:function(){var e=100/57,t=Math.round(e*this._data.sheet_x*100)/100,i=Math.round(e*this._data.sheet_y*100)/100;return"".concat(t,"% ").concat(i,"%")}},{key:"ariaLabel",value:function(){return[this.native].concat(this.short_names).filter(Boolean).join(", ")}}]),e}(),R=function(){function e(t,i,n,r,o,s,a){E(this,e),this._emoji=t,this._native=r,this._skin=i,this._set=n,this._fallback=o,this.canRender=this._canRender(),this.cssClass=this._cssClass(),this.cssStyle=this._cssStyle(a),this.content=this._content(),this.title=!0===s?t.short_name:null,this.ariaLabel=t.ariaLabel(),Object.freeze(this)}return x(e,[{key:"getEmoji",value:function(){return this._emoji.getSkin(this._skin)}},{key:"_canRender",value:function(){return this._isCustom()||this._isNative()||this._hasEmoji()||this._fallback}},{key:"_cssClass",value:function(){return["emoji-set-"+this._set,"emoji-type-"+this._emojiType()]}},{key:"_cssStyle",value:function(e){var t={};return this._isCustom()?t={backgroundImage:"url("+this.getEmoji()._data.imageUrl+")",backgroundSize:"100%",width:e+"px",height:e+"px"}:this._hasEmoji()&&!this._isNative()&&(t={backgroundPosition:this.getEmoji().getPosition()}),e&&(t=this._isNative()?Object.assign(t,{fontSize:Math.round(.95*e*10)/10+"px"}):Object.assign(t,{width:e+"px",height:e+"px"})),t}},{key:"_content",value:function(){return this._isCustom()?"":this._isNative()?this.getEmoji().native:this._hasEmoji()?"":this._fallback?this._fallback(this.getEmoji()):null}},{key:"_isNative",value:function(){return this._native}},{key:"_isCustom",value:function(){return this.getEmoji().custom}},{key:"_hasEmoji",value:function(){if(!this.getEmoji()._data)return!1;var e=this.getEmoji()._data["has_img_"+this._set];return void 0===e||e}},{key:"_emojiType",value:function(){return this._isCustom()?"custom":this._isNative()?"native":this._hasEmoji()?"image":"fallback"}}]),e}();function N(e){var t=e.name,i=e.short_names,n=e.skin_tone,r=e.skin_variations,o=e.emoticons,s=e.unified,a=e.custom,c=e.imageUrl,u=e.id||i[0],l=":".concat(u,":");return a?{id:u,name:t,colons:l,emoticons:o,custom:a,imageUrl:c}:(n&&(l+=":skin-tone-".concat(n,":")),{id:u,name:t,colons:l,emoticons:o,unified:s.toLowerCase(),skin:n||(r?1:null),native:P(s)})}function D(e,t,i){return t in e?Object.defineProperty(e,t,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[t]=i,e}var B={native:{type:Boolean,default:!1},tooltip:{type:Boolean,default:!1},fallback:{type:Function},skin:{type:Number,default:1},set:{type:String,default:"apple"},emoji:{type:[String,Object],required:!0},size:{type:Number,default:null},tag:{type:String,default:"span"}},H={perLine:{type:Number,default:9},maxSearchResults:{type:Number,default:75},emojiSize:{type:Number,default:24},title:{type:String,default:"Emoji Mart™"},emoji:{type:String,default:"department_store"},color:{type:String,default:"#ae65c5"},set:{type:String,default:"apple"},skin:{type:Number,default:null},defaultSkin:{type:Number,default:1},native:{type:Boolean,default:!1},emojiTooltip:{type:Boolean,default:!1},autoFocus:{type:Boolean,default:!1},i18n:{type:Object,default:function(){return{}}},showPreview:{type:Boolean,default:!0},showSearch:{type:Boolean,default:!0},showCategories:{type:Boolean,default:!0},showSkinTones:{type:Boolean,default:!0},infiniteScroll:{type:Boolean,default:!0},pickerStyles:{type:Object,default:function(){return{}}}};function U(e,t){var i=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),i.push.apply(i,n)}return i}function V(e){for(var t=1;t<arguments.length;t++){var i=null!=arguments[t]?arguments[t]:{};t%2?U(Object(i),!0).forEach((function(t){D(e,t,i[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(i)):U(Object(i)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(i,t))}))}return e}var W=C({props:V(V({},B),{},{data:{type:Object,required:!0}}),computed:{view:function(){return new R(this.emojiObject,this.skin,this.set,this.native,this.fallback,this.tooltip,this.size)},sanitizedData:function(){return this.emojiObject._sanitized},title:function(){return this.tooltip?this.emojiObject.short_name:null},emojiObject:function(){return"string"==typeof this.emoji?this.data.findEmoji(this.emoji):this.emoji}},created:function(){},methods:{onClick:function(){this.$emit("click",this.emojiObject)},onMouseEnter:function(){this.$emit("mouseenter",this.emojiObject)},onMouseLeave:function(){this.$emit("mouseleave",this.emojiObject)}}},(function(){var e=this,t=e.$createElement,i=e._self._c||t;return e.view.canRender?i(e.tag,{tag:"component",staticClass:"emoji-mart-emoji",attrs:{title:e.view.title,"aria-label":e.view.ariaLabel,"data-title":e.title},on:{mouseenter:e.onMouseEnter,mouseleave:e.onMouseLeave,click:e.onClick}},[i("span",{class:e.view.cssClass,style:e.view.cssStyle},[e._v(e._s(e.view.content))])]):e._e()}),[],!1,null,null,null).exports,J=C({props:{data:{type:Object,required:!0},i18n:{type:Object,required:!0},id:{type:String,required:!0},name:{type:String,required:!0},emojis:{type:Array},emojiProps:{type:Object,required:!0}},methods:{activeClass:function(e){return this.emojiProps.selectedEmoji&&this.emojiProps.selectedEmojiCategory&&this.emojiProps.selectedEmoji.id==e.id&&this.emojiProps.selectedEmojiCategory.id==this.id?"emoji-mart-emoji-selected":""}},computed:{isVisible:function(){return!!this.emojis},isSearch:function(){return"Search"==this.name},hasResults:function(){return this.emojis.length>0},emojiObjects:function(){var e=this;return this.emojis.map((function(t){return{emojiObject:t,emojiView:new R(t,e.emojiProps.skin,e.emojiProps.set,e.emojiProps.native,e.emojiProps.fallback,e.emojiProps.emojiTooltip,e.emojiProps.emojiSize)}}))}},components:{Emoji:W}},(function(){var e=this,t=e.$createElement,i=e._self._c||t;return e.isVisible&&(e.isSearch||e.hasResults)?i("section",{class:{"emoji-mart-category":!0,"emoji-mart-no-results":!e.hasResults},attrs:{"aria-label":e.i18n.categories[e.id]}},[i("div",{staticClass:"emoji-mart-category-label"},[i("h3",{staticClass:"emoji-mart-category-label"},[e._v(e._s(e.i18n.categories[e.id]))])]),e._v(" "),e._l(e.emojiObjects,(function(t){var n=t.emojiObject,r=t.emojiView;return[r.canRender?i("button",{key:n.id,staticClass:"emoji-mart-emoji",class:e.activeClass(n),attrs:{"aria-label":r.ariaLabel,role:"option","aria-selected":"false","aria-posinset":"1","aria-setsize":"1812",type:"button","data-title":n.short_name,title:r.title},on:{mouseenter:function(t){e.emojiProps.onEnter(r.getEmoji())},mouseleave:function(t){e.emojiProps.onLeave(r.getEmoji())},click:function(t){e.emojiProps.onClick(r.getEmoji())}}},[i("span",{class:r.cssClass,style:r.cssStyle},[e._v(e._s(r.content))])]):e._e()]})),e._v(" "),e.hasResults?e._e():i("div",[i("emoji",{attrs:{data:e.data,emoji:"sleuth_or_spy",native:e.emojiProps.native,skin:e.emojiProps.skin,set:e.emojiProps.set}}),e._v(" "),i("div",{staticClass:"emoji-mart-no-results-label"},[e._v(e._s(e.i18n.notfound))])],1)],2):e._e()}),[],!1,null,null,null).exports,X=C({props:{skin:{type:Number,required:!0}},data:function(){return{opened:!1}},methods:{onClick:function(e){this.opened&&e!=this.skin&&this.$emit("change",e),this.opened=!this.opened}}},(function(){var e=this,t=e.$createElement,i=e._self._c||t;return i("div",{class:{"emoji-mart-skin-swatches":!0,"emoji-mart-skin-swatches-opened":e.opened}},e._l(6,(function(t){return i("span",{key:t,class:{"emoji-mart-skin-swatch":!0,"emoji-mart-skin-swatch-selected":e.skin==t}},[i("span",{class:"emoji-mart-skin emoji-mart-skin-tone-"+t,on:{click:function(i){return e.onClick(t)}}})])})),0)}),[],!1,null,null,null).exports,Z=C({props:{data:{type:Object,required:!0},title:{type:String,required:!0},emoji:{type:[String,Object]},idleEmoji:{type:[String,Object],required:!0},showSkinTones:{type:Boolean,default:!0},emojiProps:{type:Object,required:!0},skinProps:{type:Object,required:!0},onSkinChange:{type:Function,required:!0}},computed:{emojiData:function(){return this.emoji?this.emoji:{}},emojiShortNames:function(){return this.emojiData.short_names},emojiEmoticons:function(){return this.emojiData.emoticons}},components:{Emoji:W,Skins:X}},(function(){var e=this,t=e.$createElement,i=e._self._c||t;return i("div",{staticClass:"emoji-mart-preview"},[e.emoji?[i("div",{staticClass:"emoji-mart-preview-emoji"},[i("emoji",{attrs:{data:e.data,emoji:e.emoji,native:e.emojiProps.native,skin:e.emojiProps.skin,set:e.emojiProps.set}})],1),e._v(" "),i("div",{staticClass:"emoji-mart-preview-data"},[i("div",{staticClass:"emoji-mart-preview-name"},[e._v(e._s(e.emoji.name))]),e._v(" "),i("div",{staticClass:"emoji-mart-preview-shortnames"},e._l(e.emojiShortNames,(function(t){return i("span",{key:t,staticClass:"emoji-mart-preview-shortname"},[e._v(":"+e._s(t)+":")])})),0),e._v(" "),i("div",{staticClass:"emoji-mart-preview-emoticons"},e._l(e.emojiEmoticons,(function(t){return i("span",{key:t,staticClass:"emoji-mart-preview-emoticon"},[e._v(e._s(t))])})),0)])]:[i("div",{staticClass:"emoji-mart-preview-emoji"},[i("emoji",{attrs:{data:e.data,emoji:e.idleEmoji,native:e.emojiProps.native,skin:e.emojiProps.skin,set:e.emojiProps.set}})],1),e._v(" "),i("div",{staticClass:"emoji-mart-preview-data"},[i("span",{staticClass:"emoji-mart-title-label"},[e._v(e._s(e.title))])]),e._v(" "),e.showSkinTones?i("div",{staticClass:"emoji-mart-preview-skins"},[i("skins",{attrs:{skin:e.skinProps.skin},on:{change:function(t){return e.onSkinChange(t)}}})],1):e._e()]],2)}),[],!1,null,null,null).exports,G=C({props:{data:{type:Object,required:!0},i18n:{type:Object,required:!0},autoFocus:{type:Boolean,default:!1},onSearch:{type:Function,required:!0},onArrowLeft:{type:Function,required:!1},onArrowRight:{type:Function,required:!1},onArrowDown:{type:Function,required:!1},onArrowUp:{type:Function,required:!1},onEnter:{type:Function,required:!1}},data:function(){return{value:""}},computed:{emojiIndex:function(){return this.data}},watch:{value:function(){this.$emit("search",this.value)}},methods:{clear:function(){this.value=""}},mounted:function(){var e=this.$el.querySelector("input");this.autoFocus&&e.focus()}},(function(){var e=this,t=e.$createElement,i=e._self._c||t;return i("div",{staticClass:"emoji-mart-search"},[i("input",{directives:[{name:"model",rawName:"v-model",value:e.value,expression:"value"}],attrs:{type:"text",placeholder:e.i18n.search,role:"textbox","aria-autocomplete":"list","aria-owns":"emoji-mart-list","aria-label":"Search for an emoji","aria-describedby":"emoji-mart-search-description"},domProps:{value:e.value},on:{keydown:[function(t){return!t.type.indexOf("key")&&e._k(t.keyCode,"left",37,t.key,["Left","ArrowLeft"])||"button"in t&&0!==t.button?null:function(t){return e.$emit("arrowLeft",t)}.apply(null,arguments)},function(t){return!t.type.indexOf("key")&&e._k(t.keyCode,"right",39,t.key,["Right","ArrowRight"])||"button"in t&&2!==t.button?null:function(){return e.$emit("arrowRight")}.apply(null,arguments)},function(t){return!t.type.indexOf("key")&&e._k(t.keyCode,"down",40,t.key,["Down","ArrowDown"])?null:function(){return e.$emit("arrowDown")}.apply(null,arguments)},function(t){return!t.type.indexOf("key")&&e._k(t.keyCode,"up",38,t.key,["Up","ArrowUp"])?null:function(t){return e.$emit("arrowUp",t)}.apply(null,arguments)},function(t){return!t.type.indexOf("key")&&e._k(t.keyCode,"enter",13,t.key,"Enter")?null:function(){return e.$emit("enter")}.apply(null,arguments)}],input:function(t){t.target.composing||(e.value=t.target.value)}}}),e._v(" "),i("span",{staticClass:"hidden",attrs:{id:"emoji-picker-search-description"}},[e._v("Use the left, right, up and down arrow keys to navigate the emoji search\n    results.")])])}),[],!1,null,null,null),K=G.exports;function Q(e,t){(null==t||t>e.length)&&(t=e.length);for(var i=0,n=new Array(t);i<t;i++)n[i]=e[i];return n}i(661);var Y=function(){function e(t){var i,n;E(this,e),this._vm=t,this._data=t.data,this._perLine=t.perLine,this._categories=[],(i=this._categories).push.apply(i,function(e){if(Array.isArray(e))return Q(e)}(n=this._data.categories())||function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(n)||function(e,t){if(e){if("string"==typeof e)return Q(e,t);var i=Object.prototype.toString.call(e).slice(8,-1);return"Object"===i&&e.constructor&&(i=e.constructor.name),"Map"===i||"Set"===i?Array.from(e):"Arguments"===i||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)?Q(e,t):void 0}}(n)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()),this._categories=this._categories.filter((function(e){return e.emojis.length>0})),this._categories[0].first=!0,Object.freeze(this._categories),this.activeCategory=this._categories[0],this.searchEmojis=null,this.previewEmoji=null,this.previewEmojiCategoryIdx=0,this.previewEmojiIdx=-1}return x(e,[{key:"onScroll",value:function(){for(var e=this._vm.$refs.scroll.scrollTop,t=this.filteredCategories[0],i=0,n=this.filteredCategories.length;i<n;i++){var r=this.filteredCategories[i],o=this._vm.getCategoryComponent(i);if(o&&o.$el.offsetTop-50>e)break;t=r}this.activeCategory=t}},{key:"allCategories",get:function(){return this._categories}},{key:"filteredCategories",get:function(){return this.searchEmojis?[{id:"search",name:"Search",emojis:this.searchEmojis}]:this._categories.filter((function(e){return e.emojis.length>0}))}},{key:"previewEmojiCategory",get:function(){return this.previewEmojiCategoryIdx>=0?this.filteredCategories[this.previewEmojiCategoryIdx]:null}},{key:"onAnchorClick",value:function(e){var t=this;if(!this.searchEmojis){var i=this.filteredCategories.indexOf(e),n=this._vm.getCategoryComponent(i);this._vm.infiniteScroll?function(){if(n){var i=n.$el.offsetTop;e.first&&(i=0),t._vm.$refs.scroll.scrollTop=i}}():this.activeCategory=this.filteredCategories[i]}}},{key:"onSearch",value:function(e){var t=this._data.search(e,this.maxSearchResults);this.searchEmojis=t,this.previewEmojiCategoryIdx=0,this.previewEmojiIdx=0,this.updatePreviewEmoji()}},{key:"onEmojiEnter",value:function(e){this.previewEmoji=e,this.previewEmojiIdx=-1,this.previewEmojiCategoryIdx=-1}},{key:"onEmojiLeave",value:function(e){this.previewEmoji=null}},{key:"onArrowLeft",value:function(){this.previewEmojiIdx>0?this.previewEmojiIdx-=1:(this.previewEmojiCategoryIdx-=1,this.previewEmojiCategoryIdx<0?this.previewEmojiCategoryIdx=0:this.previewEmojiIdx=this.filteredCategories[this.previewEmojiCategoryIdx].emojis.length-1),this.updatePreviewEmoji()}},{key:"onArrowRight",value:function(){this.previewEmojiIdx<this.emojisLength(this.previewEmojiCategoryIdx)-1?this.previewEmojiIdx+=1:(this.previewEmojiCategoryIdx+=1,this.previewEmojiCategoryIdx>=this.filteredCategories.length?this.previewEmojiCategoryIdx=this.filteredCategories.length-1:this.previewEmojiIdx=0),this.updatePreviewEmoji()}},{key:"onArrowDown",value:function(){if(-1==this.previewEmojiIdx)return this.onArrowRight();var e=this.filteredCategories[this.previewEmojiCategoryIdx].emojis.length,t=this._perLine;this.previewEmojiIdx+t>e&&(t=e%this._perLine);for(var i=0;i<t;i++)this.onArrowRight();this.updatePreviewEmoji()}},{key:"onArrowUp",value:function(){var e=this._perLine;this.previewEmojiIdx-e<0&&(e=this.previewEmojiCategoryIdx>0?this.filteredCategories[this.previewEmojiCategoryIdx-1].emojis.length%this._perLine:0);for(var t=0;t<e;t++)this.onArrowLeft();this.updatePreviewEmoji()}},{key:"updatePreviewEmoji",value:function(){var e=this;this.previewEmoji=this.filteredCategories[this.previewEmojiCategoryIdx].emojis[this.previewEmojiIdx],this._vm.$nextTick((function(){var t=e._vm.$refs.scroll,i=t.querySelector(".emoji-mart-emoji-selected"),n=t.offsetTop-t.offsetHeight;i&&i.offsetTop+i.offsetHeight>n+t.scrollTop&&(t.scrollTop+=i.offsetHeight),i&&i.offsetTop<t.scrollTop&&(t.scrollTop-=i.offsetHeight)}))}},{key:"emojisLength",value:function(e){return-1==e?0:this.filteredCategories[e].emojis.length}}]),e}();function ee(e,t){var i=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),i.push.apply(i,n)}return i}function te(e){for(var t=1;t<arguments.length;t++){var i=null!=arguments[t]?arguments[t]:{};t%2?ee(Object(i),!0).forEach((function(t){D(e,t,i[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(i)):ee(Object(i)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(i,t))}))}return e}var ie={search:"Search",notfound:"No Emoji Found",categories:{search:"Search Results",recent:"Frequently Used",smileys:"Smileys & Emotion",people:"People & Body",nature:"Animals & Nature",foods:"Food & Drink",activity:"Activity",places:"Travel & Places",objects:"Objects",symbols:"Symbols",flags:"Flags",custom:"Custom"}},ne={props:te(te({},H),{},{data:{type:Object,required:!0}}),data:function(){return{activeSkin:this.skin||c.get("skin")||this.defaultSkin,view:new Y(this)}},computed:{customStyles:function(){return te({width:this.calculateWidth+"px"},this.pickerStyles)},emojiProps:function(){return{native:this.native,skin:this.activeSkin,set:this.set,emojiTooltip:this.emojiTooltip,emojiSize:this.emojiSize,selectedEmoji:this.view.previewEmoji,selectedEmojiCategory:this.view.previewEmojiCategory,onEnter:this.onEmojiEnter.bind(this),onLeave:this.onEmojiLeave.bind(this),onClick:this.onEmojiClick.bind(this)}},skinProps:function(){return{skin:this.activeSkin}},calculateWidth:function(){return this.perLine*(this.emojiSize+12)+12+2+function(){if("undefined"==typeof document)return 0;var e=document.createElement("div");e.style.width="100px",e.style.height="100px",e.style.overflow="scroll",e.style.position="absolute",e.style.top="-9999px",document.body.appendChild(e);var t=e.offsetWidth-e.clientWidth;return document.body.removeChild(e),t}()},filteredCategories:function(){return this.view.filteredCategories},mergedI18n:function(){return Object.freeze(I(ie,this.i18n))},idleEmoji:function(){try{return this.data.emoji(this.emoji)}catch(e){return console.error("Default preview emoji `"+this.emoji+"` is not available, check the Picker `emoji` property"),console.error(e),this.data.firstEmoji()}}},methods:{onScroll:function(){this.infiniteScroll&&!this.waitingForPaint&&(this.waitingForPaint=!0,window.requestAnimationFrame(this.onScrollPaint.bind(this)))},onScrollPaint:function(){this.waitingForPaint=!1,this.view.onScroll()},onAnchorClick:function(e){this.view.onAnchorClick(e)},onSearch:function(e){this.view.onSearch(e)},onEmojiEnter:function(e){this.view.onEmojiEnter(e)},onEmojiLeave:function(e){this.view.onEmojiLeave(e)},onArrowLeft:function(e){var t=this.view.previewEmojiIdx;this.view.onArrowLeft(),e&&this.view.previewEmojiIdx!==t&&e.preventDefault()},onArrowRight:function(){this.view.onArrowRight()},onArrowDown:function(){this.view.onArrowDown()},onArrowUp:function(e){this.view.onArrowUp(),e.preventDefault()},onEnter:function(e){this.$emit("select",this.view.previewEmoji),w.add(this.view.previewEmoji)},onEmojiClick:function(e){this.$emit("select",e),w.add(e)},onSkinChange:function(e){this.activeSkin=e,c.update({skin:e}),this.$emit("skin-change",e)},getCategoryComponent:function(e){var t=this.$refs["categories_"+e];return t&&"0"in t?t[0]:t}},components:{Anchors:k,Category:J,Preview:Z,Search:K}},re=C(ne,(function(){var e=this,t=e.$createElement,i=e._self._c||t;return i("section",{staticClass:"emoji-mart emoji-mart-static",style:e.customStyles},[e.showCategories?i("div",{staticClass:"emoji-mart-bar emoji-mart-bar-anchors"},[i("anchors",{attrs:{data:e.data,i18n:e.mergedI18n,color:e.color,categories:e.view.allCategories,"active-category":e.view.activeCategory},on:{click:e.onAnchorClick}})],1):e._e(),e._v(" "),e._t("searchTemplate",(function(){return[e.showSearch?i("search",{ref:"search",attrs:{data:e.data,i18n:e.mergedI18n,"auto-focus":e.autoFocus,"on-search":e.onSearch},on:{search:e.onSearch,arrowLeft:e.onArrowLeft,arrowRight:e.onArrowRight,arrowDown:e.onArrowDown,arrowUp:e.onArrowUp,enter:e.onEnter}}):e._e()]}),{data:e.data,i18n:e.i18n,autoFocus:e.autoFocus,onSearch:e.onSearch}),e._v(" "),i("div",{ref:"scroll",staticClass:"emoji-mart-scroll",attrs:{role:"tabpanel"},on:{scroll:e.onScroll}},[i("div",{ref:"scrollContent",attrs:{id:"emoji-mart-list",role:"listbox","aria-expanded":"true"}},e._l(e.view.filteredCategories,(function(t,n){return i("category",{directives:[{name:"show",rawName:"v-show",value:e.infiniteScroll||t==e.view.activeCategory,expression:"infiniteScroll || category == view.activeCategory"}],key:t.id,ref:"categories_"+n,refInFor:!0,attrs:{data:e.data,i18n:e.mergedI18n,id:t.id,name:t.name,emojis:t.emojis,"emoji-props":e.emojiProps}})})),1)]),e._v(" "),e._t("previewTemplate",(function(){return[e.showPreview?i("div",{staticClass:"emoji-mart-bar emoji-mart-bar-preview"},[i("preview",{attrs:{data:e.data,title:e.title,emoji:e.view.previewEmoji,"idle-emoji":e.idleEmoji,"show-skin-tones":e.showSkinTones,"emoji-props":e.emojiProps,"skin-props":e.skinProps,"on-skin-change":e.onSkinChange}})],1):e._e()]}),{data:e.data,title:e.title,emoji:e.view.previewEmoji,idleEmoji:e.idleEmoji,showSkinTones:e.showSkinTones,emojiProps:e.emojiProps,skinProps:e.skinProps,onSkinChange:e.onSkinChange})],2)}),[],!1,null,null,null),oe=re.exports}(),n}()}));

/***/ }),

/***/ "423e":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arKw = moment.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arKw;

})));


/***/ }),

/***/ "428f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global;


/***/ }),

/***/ "440c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eng Minutt', 'enger Minutt'],
            h: ['eng Stonn', 'enger Stonn'],
            d: ['een Dag', 'engem Dag'],
            M: ['ee Mount', 'engem Mount'],
            y: ['ee Joer', 'engem Joer'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
            '_'
        ),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            },
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime,
            mm: '%d Minutten',
            h: processRelativeTime,
            hh: '%d Stonnen',
            d: processRelativeTime,
            dd: '%d Deeg',
            M: processRelativeTime,
            MM: '%d Méint',
            y: processRelativeTime,
            yy: '%d Joer',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lb;

})));


/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var Object = global.Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "44d2":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var create = __webpack_require__("7c73");
var definePropertyModule = __webpack_require__("9bf2");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "44de":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};


/***/ }),

/***/ "44e7":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var classof = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ "457d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "45b1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_pagination_vue_vue_type_style_index_0_id_ac112ad6_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("19d6");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_pagination_vue_vue_type_style_index_0_id_ac112ad6_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_pagination_vue_vue_type_style_index_0_id_ac112ad6_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "45ff":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "466d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__("c65b");
var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var anObject = __webpack_require__("825a");
var toLength = __webpack_require__("50c4");
var toString = __webpack_require__("577e");
var requireObjectCoercible = __webpack_require__("1d80");
var getMethod = __webpack_require__("dc4a");
var advanceStringIndex = __webpack_require__("8aa5");
var regExpExec = __webpack_require__("14c3");

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : getMethod(regexp, MATCH);
      return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ "4678":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "2bfb",
	"./af.js": "2bfb",
	"./ar": "8e73",
	"./ar-dz": "a356",
	"./ar-dz.js": "a356",
	"./ar-kw": "423e",
	"./ar-kw.js": "423e",
	"./ar-ly": "1cfd",
	"./ar-ly.js": "1cfd",
	"./ar-ma": "0a84",
	"./ar-ma.js": "0a84",
	"./ar-sa": "8230",
	"./ar-sa.js": "8230",
	"./ar-tn": "6d83",
	"./ar-tn.js": "6d83",
	"./ar.js": "8e73",
	"./az": "485c",
	"./az.js": "485c",
	"./be": "1fc1",
	"./be.js": "1fc1",
	"./bg": "84aa",
	"./bg.js": "84aa",
	"./bm": "a7fa",
	"./bm.js": "a7fa",
	"./bn": "9043",
	"./bn-bd": "9686",
	"./bn-bd.js": "9686",
	"./bn.js": "9043",
	"./bo": "d26a",
	"./bo.js": "d26a",
	"./br": "6887",
	"./br.js": "6887",
	"./bs": "2554",
	"./bs.js": "2554",
	"./ca": "d716",
	"./ca.js": "d716",
	"./cs": "3c0d",
	"./cs.js": "3c0d",
	"./cv": "03ec",
	"./cv.js": "03ec",
	"./cy": "9797",
	"./cy.js": "9797",
	"./da": "0f14",
	"./da.js": "0f14",
	"./de": "b469",
	"./de-at": "b3eb",
	"./de-at.js": "b3eb",
	"./de-ch": "bb71",
	"./de-ch.js": "bb71",
	"./de.js": "b469",
	"./dv": "598a",
	"./dv.js": "598a",
	"./el": "8d47",
	"./el.js": "8d47",
	"./en-au": "0e6b",
	"./en-au.js": "0e6b",
	"./en-ca": "3886",
	"./en-ca.js": "3886",
	"./en-gb": "39a6",
	"./en-gb.js": "39a6",
	"./en-ie": "e1d3",
	"./en-ie.js": "e1d3",
	"./en-il": "7333",
	"./en-il.js": "7333",
	"./en-in": "ec2e",
	"./en-in.js": "ec2e",
	"./en-nz": "6f50",
	"./en-nz.js": "6f50",
	"./en-sg": "b7e9",
	"./en-sg.js": "b7e9",
	"./eo": "65db",
	"./eo.js": "65db",
	"./es": "898b",
	"./es-do": "0a3c",
	"./es-do.js": "0a3c",
	"./es-mx": "b5b7",
	"./es-mx.js": "b5b7",
	"./es-us": "55c9",
	"./es-us.js": "55c9",
	"./es.js": "898b",
	"./et": "ec18",
	"./et.js": "ec18",
	"./eu": "0ff2",
	"./eu.js": "0ff2",
	"./fa": "8df4",
	"./fa.js": "8df4",
	"./fi": "81e9",
	"./fi.js": "81e9",
	"./fil": "d69a",
	"./fil.js": "d69a",
	"./fo": "0721",
	"./fo.js": "0721",
	"./fr": "9f26",
	"./fr-ca": "d9f8",
	"./fr-ca.js": "d9f8",
	"./fr-ch": "0e49",
	"./fr-ch.js": "0e49",
	"./fr.js": "9f26",
	"./fy": "7118",
	"./fy.js": "7118",
	"./ga": "5120",
	"./ga.js": "5120",
	"./gd": "f6b4",
	"./gd.js": "f6b4",
	"./gl": "8840",
	"./gl.js": "8840",
	"./gom-deva": "aaf2",
	"./gom-deva.js": "aaf2",
	"./gom-latn": "0caa",
	"./gom-latn.js": "0caa",
	"./gu": "e0c5",
	"./gu.js": "e0c5",
	"./he": "c7aa",
	"./he.js": "c7aa",
	"./hi": "dc4d",
	"./hi.js": "dc4d",
	"./hr": "4ba9",
	"./hr.js": "4ba9",
	"./hu": "5b14",
	"./hu.js": "5b14",
	"./hy-am": "d6b6",
	"./hy-am.js": "d6b6",
	"./id": "5038",
	"./id.js": "5038",
	"./is": "0558",
	"./is.js": "0558",
	"./it": "6e98",
	"./it-ch": "6f12",
	"./it-ch.js": "6f12",
	"./it.js": "6e98",
	"./ja": "079e",
	"./ja.js": "079e",
	"./jv": "b540",
	"./jv.js": "b540",
	"./ka": "201b",
	"./ka.js": "201b",
	"./kk": "6d79",
	"./kk.js": "6d79",
	"./km": "e81d",
	"./km.js": "e81d",
	"./kn": "3e92",
	"./kn.js": "3e92",
	"./ko": "22f8",
	"./ko.js": "22f8",
	"./ku": "2421",
	"./ku.js": "2421",
	"./ky": "9609",
	"./ky.js": "9609",
	"./lb": "440c",
	"./lb.js": "440c",
	"./lo": "b29d",
	"./lo.js": "b29d",
	"./lt": "26f9",
	"./lt.js": "26f9",
	"./lv": "b97c",
	"./lv.js": "b97c",
	"./me": "293c",
	"./me.js": "293c",
	"./mi": "688b",
	"./mi.js": "688b",
	"./mk": "6909",
	"./mk.js": "6909",
	"./ml": "02fb",
	"./ml.js": "02fb",
	"./mn": "958b",
	"./mn.js": "958b",
	"./mr": "39bd",
	"./mr.js": "39bd",
	"./ms": "ebe4",
	"./ms-my": "6403",
	"./ms-my.js": "6403",
	"./ms.js": "ebe4",
	"./mt": "1b45",
	"./mt.js": "1b45",
	"./my": "8689",
	"./my.js": "8689",
	"./nb": "6ce3",
	"./nb.js": "6ce3",
	"./ne": "3a39",
	"./ne.js": "3a39",
	"./nl": "facd",
	"./nl-be": "db29",
	"./nl-be.js": "db29",
	"./nl.js": "facd",
	"./nn": "b84c",
	"./nn.js": "b84c",
	"./oc-lnc": "167b",
	"./oc-lnc.js": "167b",
	"./pa-in": "f3ff",
	"./pa-in.js": "f3ff",
	"./pl": "8d57",
	"./pl.js": "8d57",
	"./pt": "f260",
	"./pt-br": "d2d4",
	"./pt-br.js": "d2d4",
	"./pt.js": "f260",
	"./ro": "972c",
	"./ro.js": "972c",
	"./ru": "957c",
	"./ru.js": "957c",
	"./sd": "6784",
	"./sd.js": "6784",
	"./se": "ffff",
	"./se.js": "ffff",
	"./si": "eda5",
	"./si.js": "eda5",
	"./sk": "7be6",
	"./sk.js": "7be6",
	"./sl": "8155",
	"./sl.js": "8155",
	"./sq": "c8f3",
	"./sq.js": "c8f3",
	"./sr": "cf1e",
	"./sr-cyrl": "13e9",
	"./sr-cyrl.js": "13e9",
	"./sr.js": "cf1e",
	"./ss": "52bd",
	"./ss.js": "52bd",
	"./sv": "5fbd",
	"./sv.js": "5fbd",
	"./sw": "74dc",
	"./sw.js": "74dc",
	"./ta": "3de5",
	"./ta.js": "3de5",
	"./te": "5cbb",
	"./te.js": "5cbb",
	"./tet": "576c",
	"./tet.js": "576c",
	"./tg": "3b1b",
	"./tg.js": "3b1b",
	"./th": "10e8",
	"./th.js": "10e8",
	"./tk": "5aff",
	"./tk.js": "5aff",
	"./tl-ph": "0f38",
	"./tl-ph.js": "0f38",
	"./tlh": "cf75",
	"./tlh.js": "cf75",
	"./tr": "0e81",
	"./tr.js": "0e81",
	"./tzl": "cf51",
	"./tzl.js": "cf51",
	"./tzm": "c109",
	"./tzm-latn": "b53d",
	"./tzm-latn.js": "b53d",
	"./tzm.js": "c109",
	"./ug-cn": "6117",
	"./ug-cn.js": "6117",
	"./uk": "ada2",
	"./uk.js": "ada2",
	"./ur": "5294",
	"./ur.js": "5294",
	"./uz": "2e8c",
	"./uz-latn": "010e",
	"./uz-latn.js": "010e",
	"./uz.js": "2e8c",
	"./vi": "2921",
	"./vi.js": "2921",
	"./x-pseudo": "fd7e",
	"./x-pseudo.js": "fd7e",
	"./yo": "7f33",
	"./yo.js": "7f33",
	"./zh-cn": "5c3a",
	"./zh-cn.js": "5c3a",
	"./zh-hk": "49ab",
	"./zh-hk.js": "49ab",
	"./zh-mo": "3a6c",
	"./zh-mo.js": "3a6c",
	"./zh-tw": "90ea",
	"./zh-tw.js": "90ea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4678";

/***/ }),

/***/ "4840":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aConstructor = __webpack_require__("5087");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aConstructor(S);
};


/***/ }),

/***/ "485a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");

var TypeError = global.TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "485c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı',
    };

    var az = moment.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
            '_'
        ),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
            '_'
        ),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'bir neçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il',
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function (number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = (number % 100) - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return az;

})));


/***/ }),

/***/ "4930":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__("2d00");
var fails = __webpack_require__("d039");

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "498a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $trim = __webpack_require__("58a8").trim;
var forcedStringTrimMethod = __webpack_require__("c8d2");

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),

/***/ "49ab":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd
//! author : Anthony : https://github.com/anthonylau

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhHk = moment.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1200) {
                return '上午';
            } else if (hm === 1200) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhHk;

})));


/***/ }),

/***/ "4ae1":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var getBuiltIn = __webpack_require__("d066");
var apply = __webpack_require__("2ba4");
var bind = __webpack_require__("0538");
var aConstructor = __webpack_require__("5087");
var anObject = __webpack_require__("825a");
var isObject = __webpack_require__("861d");
var create = __webpack_require__("7c73");
var fails = __webpack_require__("d039");

var nativeConstruct = getBuiltIn('Reflect', 'construct');
var ObjectPrototype = Object.prototype;
var push = [].push;

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});

var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});

var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aConstructor(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      apply(push, $args, args);
      return new (apply(bind, Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : ObjectPrototype);
    var result = apply(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ "4ae6":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():undefined}(this,function(){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var r={};return t.m=e,t.c=r,t.i=function(e){return e},t.d=function(e,r,n){t.o(e,r)||Object.defineProperty(e,r,{configurable:!1,enumerable:!0,get:n})},t.n=function(e){var r=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(r,"a",r),r},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="/dist/",t(t.s=0)}([function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e){var t=void 0;if("string"!=typeof e)try{t=JSON.stringify(e)}catch(e){throw"Failed to copy value to clipboard. Unknown type."}else t=e;var r=document.createElement("textarea");if(r.value=t,r.setAttribute("readonly",""),r.style.cssText="position:fixed;pointer-events:none;z-index:-9999;opacity:0;",document.body.appendChild(r),navigator.userAgent.match(/ipad|ipod|iphone/i)){r.contentEditable=!0,r.readOnly=!0;var n=document.createRange();n.selectNodeContents(r);var o=window.getSelection();o.removeAllRanges(),o.addRange(n),r.setSelectionRange(0,999999)}else r.select();var a=!1;try{a=document.execCommand("copy")}catch(e){console.warn(e)}return document.body.removeChild(r),a};t.default={install:function(e){e.prototype.$clipboard=n;var t=function(e){return function(){return"$"+e++}}(1),r={},o=function(e){e&&(r[e]=null,delete r[e])},a=function(e){var n=t();return r[n]=e,n};e.directive("clipboard",{bind:function(e,t){var o=t.arg,i=t.value;switch(o){case"error":var c=a(i);return void(e.dataset.clipboardErrorHandler=c);case"success":var d=a(i);return void(e.dataset.clipboardSuccessHandler=d);default:var l=function(o){if(t.hasOwnProperty("value")){var a={value:"function"==typeof i?i():i,event:o},c=n(a.value)?e.dataset.clipboardSuccessHandler:e.dataset.clipboardErrorHandler,d=r[c];d&&d(a)}},u=a(l);return e.dataset.clipboardClickHandler=u,void e.addEventListener("click",r[u])}},unbind:function(e){var t=e.dataset,n=t.clipboardSuccessHandler,a=t.clipboardErrorHandler,i=t.clipboardClickHandler;o(n),o(a),i&&(e.removeEventListener("click",r[i]),o(i))}})}}}])});
//# sourceMappingURL=index.min.js.map

/***/ }),

/***/ "4ba9":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
                '_'
            ),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
                '_'
            ),
        },
        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prošlu] [nedjelju] [u] LT';
                    case 3:
                        return '[prošlu] [srijedu] [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hr;

})));


/***/ }),

/***/ "4ccd":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4d63":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var isForced = __webpack_require__("94ca");
var inheritIfRequired = __webpack_require__("7156");
var createNonEnumerableProperty = __webpack_require__("9112");
var defineProperty = __webpack_require__("9bf2").f;
var getOwnPropertyNames = __webpack_require__("241c").f;
var isPrototypeOf = __webpack_require__("3a9b");
var isRegExp = __webpack_require__("44e7");
var toString = __webpack_require__("577e");
var regExpFlags = __webpack_require__("ad6d");
var stickyHelpers = __webpack_require__("9f7f");
var redefine = __webpack_require__("6eeb");
var fails = __webpack_require__("d039");
var hasOwn = __webpack_require__("1a2d");
var enforceInternalState = __webpack_require__("69f3").enforce;
var setSpecies = __webpack_require__("2626");
var wellKnownSymbol = __webpack_require__("b622");
var UNSUPPORTED_DOT_ALL = __webpack_require__("fce3");
var UNSUPPORTED_NCG = __webpack_require__("107c");

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var SyntaxError = global.SyntaxError;
var getFlags = uncurryThis(regExpFlags);
var exec = uncurryThis(RegExpPrototype.exec);
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);
// TODO: Use only propper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var MISSED_STICKY = stickyHelpers.MISSED_STICKY;
var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS &&
  (!CORRECT_NEW || MISSED_STICKY || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails(function () {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      result += chr + charAt(string, ++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      chr = chr + charAt(string, ++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (exec(IS_NCG, stringSlice(string, index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || hasOwn(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named[named.length] = [groupname, groupid];
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = isPrototypeOf(RegExpPrototype, this);
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || isPrototypeOf(RegExpPrototype, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = 'flags' in rawPattern ? rawPattern.flags : getFlags(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString(pattern);
    flags = flags === undefined ? '' : toString(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
      dotAll = !!flags && stringIndexOf(flags, 's') > -1;
      if (dotAll) flags = replace(flags, /s/g, '');
    }

    rawFlags = flags;

    if (MISSED_STICKY && 'sticky' in re1) {
      sticky = !!flags && stringIndexOf(flags, 'y') > -1;
      if (sticky && UNSUPPORTED_Y) flags = replace(flags, /y/g, '');
    }

    if (UNSUPPORTED_NCG) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  var proxy = function (key) {
    key in RegExpWrapper || defineProperty(RegExpWrapper, key, {
      configurable: true,
      get: function () { return NativeRegExp[key]; },
      set: function (it) { NativeRegExp[key] = it; }
    });
  };

  for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
    proxy(keys[index++]);
  }

  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  redefine(global, 'RegExp', RegExpWrapper);
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');


/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var toAbsoluteIndex = __webpack_require__("23cb");
var lengthOfArrayLike = __webpack_require__("07fa");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "4dae":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var toAbsoluteIndex = __webpack_require__("23cb");
var lengthOfArrayLike = __webpack_require__("07fa");
var createProperty = __webpack_require__("8418");

var Array = global.Array;
var max = Math.max;

module.exports = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = Array(max(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};


/***/ }),

/***/ "5038":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var id = moment.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return id;

})));


/***/ }),

/***/ "5087":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isConstructor = __webpack_require__("68ee");
var tryToString = __webpack_require__("0d51");

var TypeError = global.TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("5926");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "5120":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Irish or Irish Gaelic [ga]
//! author : André Silva : https://github.com/askpt

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Eanáir',
            'Feabhra',
            'Márta',
            'Aibreán',
            'Bealtaine',
            'Meitheamh',
            'Iúil',
            'Lúnasa',
            'Meán Fómhair',
            'Deireadh Fómhair',
            'Samhain',
            'Nollaig',
        ],
        monthsShort = [
            'Ean',
            'Feabh',
            'Márt',
            'Aib',
            'Beal',
            'Meith',
            'Iúil',
            'Lún',
            'M.F.',
            'D.F.',
            'Samh',
            'Noll',
        ],
        weekdays = [
            'Dé Domhnaigh',
            'Dé Luain',
            'Dé Máirt',
            'Dé Céadaoin',
            'Déardaoin',
            'Dé hAoine',
            'Dé Sathairn',
        ],
        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d míonna',
            y: 'bliain',
            yy: '%d bliain',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ga;

})));


/***/ }),

/***/ "5294":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوری',
            'فروری',
            'مارچ',
            'اپریل',
            'مئی',
            'جون',
            'جولائی',
            'اگست',
            'ستمبر',
            'اکتوبر',
            'نومبر',
            'دسمبر',
        ],
        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    var ur = moment.defineLocale('ur', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ur;

})));


/***/ }),

/***/ "52bd":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ss = moment.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
            '_'
        ),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
            '_'
        ),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka',
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ss;

})));


/***/ }),

/***/ "5319":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var apply = __webpack_require__("2ba4");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var fails = __webpack_require__("d039");
var anObject = __webpack_require__("825a");
var isCallable = __webpack_require__("1626");
var toIntegerOrInfinity = __webpack_require__("5926");
var toLength = __webpack_require__("50c4");
var toString = __webpack_require__("577e");
var requireObjectCoercible = __webpack_require__("1d80");
var advanceStringIndex = __webpack_require__("8aa5");
var getMethod = __webpack_require__("dc4a");
var getSubstitution = __webpack_require__("0cb2");
var regExpExec = __webpack_require__("14c3");
var wellKnownSymbol = __webpack_require__("b622");

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis([].concat);
var push = uncurryThis([].push);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? call(replacer, searchValue, O, replaceValue)
        : call(nativeReplace, toString(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString(result[0]);
        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          var replacement = toString(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


/***/ }),

/***/ "55c9":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta
//! author : chrisrodz : https://github.com/chrisrodz

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return esUs;

})));


/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.20.2',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2022 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var uncurryThis = __webpack_require__("e330");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "5756":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_vue_loader_lib_loaders_stylePostLoader_js_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_classic_min_css_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("bbf9");
/* harmony import */ var _mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_vue_loader_lib_loaders_stylePostLoader_js_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_classic_min_css_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_vue_loader_lib_loaders_stylePostLoader_js_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_classic_min_css_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "576c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo
//! author : Sonia Simoes : https://github.com/soniasimoes

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tet = moment.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tet;

})));


/***/ }),

/***/ "577e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var classof = __webpack_require__("f5df");

var String = global.String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};


/***/ }),

/***/ "5899":
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "58a8":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var requireObjectCoercible = __webpack_require__("1d80");
var toString = __webpack_require__("577e");
var whitespaces = __webpack_require__("5899");

var replace = uncurryThis(''.replace);
var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "5926":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- safe
  return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
};


/***/ }),

/***/ "598a":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'ޖެނުއަރީ',
            'ފެބްރުއަރީ',
            'މާރިޗު',
            'އޭޕްރީލު',
            'މޭ',
            'ޖޫން',
            'ޖުލައި',
            'އޯގަސްޓު',
            'ސެޕްޓެމްބަރު',
            'އޮކްޓޯބަރު',
            'ނޮވެމްބަރު',
            'ޑިސެމްބަރު',
        ],
        weekdays = [
            'އާދިއްތަ',
            'ހޯމަ',
            'އަންގާރަ',
            'ބުދަ',
            'ބުރާސްފަތި',
            'ހުކުރު',
            'ހޮނިހިރު',
        ];

    var dv = moment.defineLocale('dv', {
        months: months,
        monthsShort: months,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /މކ|މފ/,
        isPM: function (input) {
            return 'މފ' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return dv;

})));


/***/ }),

/***/ "59ed":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");
var tryToString = __webpack_require__("0d51");

var TypeError = global.TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ "5aff":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkmen [tk]
//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'ünji",
        4: "'ünji",
        100: "'ünji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy",
    };

    var tk = moment.defineLocale('tk', {
        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
            '_'
        ),
        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün sagat] LT',
            nextDay: '[ertir sagat] LT',
            nextWeek: '[indiki] dddd [sagat] LT',
            lastDay: '[düýn] LT',
            lastWeek: '[geçen] dddd [sagat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s soň',
            past: '%s öň',
            s: 'birnäçe sekunt',
            m: 'bir minut',
            mm: '%d minut',
            h: 'bir sagat',
            hh: '%d sagat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir aý',
            MM: '%d aý',
            y: 'bir ýyl',
            yy: '%d ýyl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'unjy";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tk;

})));


/***/ }),

/***/ "5b14":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner
//! author : Peter Viszt  : https://github.com/passatgt

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(
        ' '
    );
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix
                    ? 'néhány másodperc'
                    : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix)
                    ? ' másodperc'
                    : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (
            (isFuture ? '' : '[múlt] ') +
            '[' +
            weekEndings[this.day()] +
            '] LT[-kor]'
        );
    }

    var hu = moment.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
            '_'
        ),
        monthsShort: 'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm',
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function () {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function () {
                return week.call(this, false);
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return hu;

})));


/***/ }),

/***/ "5c3a":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhCn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            w: '1 周',
            ww: '%d 周',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年',
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return zhCn;

})));


/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "5ca8":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5cbb":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var te = moment.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
            '_'
        ),
        monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
            '_'
        ),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు',
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return te;

})));


/***/ }),

/***/ "5e77":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var hasOwn = __webpack_require__("1a2d");

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ "5ed5":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5fbd":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? ':e'
                        : b === 1
                        ? ':a'
                        : b === 2
                        ? ':a'
                        : b === 3
                        ? ':e'
                        : ':e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sv;

})));


/***/ }),

/***/ "605d":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");
var global = __webpack_require__("da84");

module.exports = classof(global.process) == 'process';


/***/ }),

/***/ "6069":
/***/ (function(module, exports) {

module.exports = typeof window == 'object';


/***/ }),

/***/ "6117":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uyghur (China) [ug-cn]
//! author: boyaq : https://github.com/boyaq

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل',
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return ugCn;

})));


/***/ }),

/***/ "62e4":
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "6336":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "63a2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_loading_spinner_vue_vue_type_style_index_0_id_2c824f0f_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("72f1");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_loading_spinner_vue_vue_type_style_index_0_id_2c824f0f_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_loading_spinner_vue_vue_type_style_index_0_id_2c824f0f_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6403":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var msMy = moment.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return msMy;

})));


/***/ }),

/***/ "6546":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_app_message_vue_vue_type_style_index_0_id_18db408b_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("99d9");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_app_message_vue_vue_type_style_index_0_id_18db408b_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_app_message_vue_vue_type_style_index_0_id_18db408b_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6547":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var toIntegerOrInfinity = __webpack_require__("5926");
var toString = __webpack_require__("577e");
var requireObjectCoercible = __webpack_require__("1d80");

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "65db":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean
//! comment : Vivakvo corrected the translation by colindean and miestasmia

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eo = moment.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd[n je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj',
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eo;

})));


/***/ }),

/***/ "65f0":
/***/ (function(module, exports, __webpack_require__) {

var arraySpeciesConstructor = __webpack_require__("0b42");

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ "66cb":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// TinyColor v1.4.2
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

(function(Math) {

var trimLeft = /^\s+/,
    trimRight = /\s+$/,
    tinyCounter = 0,
    mathRound = Math.round,
    mathMin = Math.min,
    mathMax = Math.max,
    mathRandom = Math.random;

function tinycolor (color, opts) {

    color = (color) ? color : '';
    opts = opts || { };

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
       return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
        return new tinycolor(color, opts);
    }

    var rgb = inputToRGB(color);
    this._originalInput = color,
    this._r = rgb.r,
    this._g = rgb.g,
    this._b = rgb.b,
    this._a = rgb.a,
    this._roundA = mathRound(100*this._a) / 100,
    this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) { this._r = mathRound(this._r); }
    if (this._g < 1) { this._g = mathRound(this._g); }
    if (this._b < 1) { this._b = mathRound(this._b); }

    this._ok = rgb.ok;
    this._tc_id = tinyCounter++;
}

tinycolor.prototype = {
    isDark: function() {
        return this.getBrightness() < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    isValid: function() {
        return this._ok;
    },
    getOriginalInput: function() {
      return this._originalInput;
    },
    getFormat: function() {
        return this._format;
    },
    getAlpha: function() {
        return this._a;
    },
    getBrightness: function() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r/255;
        GsRGB = rgb.g/255;
        BsRGB = rgb.b/255;

        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
    },
    setAlpha: function(value) {
        this._a = boundAlpha(value);
        this._roundA = mathRound(100*this._a) / 100;
        return this;
    },
    toHsv: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
    },
    toHsvString: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
        return (this._a == 1) ?
          "hsv("  + h + ", " + s + "%, " + v + "%)" :
          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
    },
    toHsl: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
    },
    toHslString: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
        return (this._a == 1) ?
          "hsl("  + h + ", " + s + "%, " + l + "%)" :
          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
    },
    toHex: function(allow3Char) {
        return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function(allow3Char) {
        return '#' + this.toHex(allow3Char);
    },
    toHex8: function(allow4Char) {
        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function(allow4Char) {
        return '#' + this.toHex8(allow4Char);
    },
    toRgb: function() {
        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
    },
    toRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function() {
        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
    },
    toPercentageRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function() {
        if (this._a === 0) {
            return "transparent";
        }

        if (this._a < 1) {
            return false;
        }

        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function(secondColor) {
        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";

        if (secondColor) {
            var s = tinycolor(secondColor);
            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }

        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
    },
    toString: function(format) {
        var formatSet = !!format;
        format = format || this._format;

        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) {
                return this.toName();
            }
            return this.toRgbString();
        }
        if (format === "rgb") {
            formattedString = this.toRgbString();
        }
        if (format === "prgb") {
            formattedString = this.toPercentageRgbString();
        }
        if (format === "hex" || format === "hex6") {
            formattedString = this.toHexString();
        }
        if (format === "hex3") {
            formattedString = this.toHexString(true);
        }
        if (format === "hex4") {
            formattedString = this.toHex8String(true);
        }
        if (format === "hex8") {
            formattedString = this.toHex8String();
        }
        if (format === "name") {
            formattedString = this.toName();
        }
        if (format === "hsl") {
            formattedString = this.toHslString();
        }
        if (format === "hsv") {
            formattedString = this.toHsvString();
        }

        return formattedString || this.toHexString();
    },
    clone: function() {
        return tinycolor(this.toString());
    },

    _applyModification: function(fn, args) {
        var color = fn.apply(null, [this].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function() {
        return this._applyModification(lighten, arguments);
    },
    brighten: function() {
        return this._applyModification(brighten, arguments);
    },
    darken: function() {
        return this._applyModification(darken, arguments);
    },
    desaturate: function() {
        return this._applyModification(desaturate, arguments);
    },
    saturate: function() {
        return this._applyModification(saturate, arguments);
    },
    greyscale: function() {
        return this._applyModification(greyscale, arguments);
    },
    spin: function() {
        return this._applyModification(spin, arguments);
    },

    _applyCombination: function(fn, args) {
        return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function() {
        return this._applyCombination(analogous, arguments);
    },
    complement: function() {
        return this._applyCombination(complement, arguments);
    },
    monochromatic: function() {
        return this._applyCombination(monochromatic, arguments);
    },
    splitcomplement: function() {
        return this._applyCombination(splitcomplement, arguments);
    },
    triad: function() {
        return this._applyCombination(triad, arguments);
    },
    tetrad: function() {
        return this._applyCombination(tetrad, arguments);
    }
};

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
tinycolor.fromRatio = function(color, opts) {
    if (typeof color == "object") {
        var newColor = {};
        for (var i in color) {
            if (color.hasOwnProperty(i)) {
                if (i === "a") {
                    newColor[i] = color[i];
                }
                else {
                    newColor[i] = convertToPercentage(color[i]);
                }
            }
        }
        color = newColor;
    }

    return tinycolor(color, opts);
};

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function inputToRGB(color) {

    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;

    if (typeof color == "string") {
        color = stringInputToObject(color);
    }

    if (typeof color == "object") {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb = hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l = convertToPercentage(color.l);
            rgb = hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }

        if (color.hasOwnProperty("a")) {
            a = color.a;
        }
    }

    a = boundAlpha(a);

    return {
        ok: ok,
        format: color.format || format,
        r: mathMin(255, mathMax(rgb.r, 0)),
        g: mathMin(255, mathMax(rgb.g, 0)),
        b: mathMin(255, mathMax(rgb.b, 0)),
        a: a
    };
}


// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function rgbToRgb(r, g, b){
    return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255
    };
}

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function rgbToHsl(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, l = (max + min) / 2;

    if(max == min) {
        h = s = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }

        h /= 6;
    }

    return { h: h, s: s, l: l };
}

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hslToRgb(h, s, l) {
    var r, g, b;

    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);

    function hue2rgb(p, q, t) {
        if(t < 0) t += 1;
        if(t > 1) t -= 1;
        if(t < 1/6) return p + (q - p) * 6 * t;
        if(t < 1/2) return q;
        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
    }

    if(s === 0) {
        r = g = b = l; // achromatic
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
    }

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function rgbToHsv(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, v = max;

    var d = max - min;
    s = max === 0 ? 0 : d / max;

    if(max == min) {
        h = 0; // achromatic
    }
    else {
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
 function hsvToRgb(h, s, v) {

    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);

    var i = Math.floor(h),
        f = h - i,
        p = v * (1 - s),
        q = v * (1 - f * s),
        t = v * (1 - (1 - f) * s),
        mod = i % 6,
        r = [v, q, p, p, t, v][mod],
        g = [t, v, v, q, p, p][mod],
        b = [p, p, t, v, v, q][mod];

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function rgbToHex(r, g, b, allow3Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }

    return hex.join("");
}

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function rgbaToHex(r, g, b, a, allow4Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16)),
        pad2(convertDecimalToHex(a))
    ];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }

    return hex.join("");
}

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function rgbaToArgbHex(r, g, b, a) {

    var hex = [
        pad2(convertDecimalToHex(a)),
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    return hex.join("");
}

// `equals`
// Can be called with any tinycolor input
tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) { return false; }
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};

tinycolor.random = function() {
    return tinycolor.fromRatio({
        r: mathRandom(),
        g: mathRandom(),
        b: mathRandom()
    });
};


// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

function desaturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function saturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function greyscale(color) {
    return tinycolor(color).desaturate(100);
}

function lighten (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

function brighten(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var rgb = tinycolor(color).toRgb();
    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
    return tinycolor(rgb);
}

function darken (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
}

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

function complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
}

function triad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
    ];
}

function tetrad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
    ];
}

function splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
    ];
}

function analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;

    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];

    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(tinycolor(hsl));
    }
    return ret;
}

function monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;

    while (results--) {
        ret.push(tinycolor({ h: h, s: s, v: v}));
        v = (v + modification) % 1;
    }

    return ret;
}

// Utility Functions
// ---------------------

tinycolor.mix = function(color1, color2, amount) {
    amount = (amount === 0) ? 0 : (amount || 50);

    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();

    var p = amount / 100;

    var rgba = {
        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
    };

    return tinycolor(rgba);
};


// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
tinycolor.readability = function(color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
};

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
tinycolor.isReadable = function(color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;

    out = false;

    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;

};

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
tinycolor.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size ;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors ;
    level = args.level;
    size = args.size;

    for (var i= 0; i < colorList.length ; i++) {
        readability = tinycolor.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = tinycolor(colorList[i]);
        }
    }

    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
        return bestColor;
    }
    else {
        args.includeFallbackColors=false;
        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
    }
};


// Big List of Colors
// ------------------
// <http://www.w3.org/TR/css3-color/#svg-color>
var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};

// Make it easy to access colors via `hexNames[hex]`
var hexNames = tinycolor.hexNames = flip(names);


// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function flip(o) {
    var flipped = { };
    for (var i in o) {
        if (o.hasOwnProperty(i)) {
            flipped[o[i]] = i;
        }
    }
    return flipped;
}

// Return a valid alpha value [0,1] with all invalid values being set to 1
function boundAlpha(a) {
    a = parseFloat(a);

    if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
    }

    return a;
}

// Take input from [0, n] and return it as [0, 1]
function bound01(n, max) {
    if (isOnePointZero(n)) { n = "100%"; }

    var processPercent = isPercentage(n);
    n = mathMin(max, mathMax(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
        n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if ((Math.abs(n - max) < 0.000001)) {
        return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return (n % max) / parseFloat(max);
}

// Force a number between 0 and 1
function clamp01(val) {
    return mathMin(1, mathMax(0, val));
}

// Parse a base-16 hex value into a base-10 integer
function parseIntFromHex(val) {
    return parseInt(val, 16);
}

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
}

// Check to see if string passed in is a percentage
function isPercentage(n) {
    return typeof n === "string" && n.indexOf('%') != -1;
}

// Force a hex value to have 2 characters
function pad2(c) {
    return c.length == 1 ? '0' + c : '' + c;
}

// Replace a decimal with it's percentage value
function convertToPercentage(n) {
    if (n <= 1) {
        n = (n * 100) + "%";
    }

    return n;
}

// Converts a decimal to a hex value
function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function convertHexToDecimal(h) {
    return (parseIntFromHex(h) / 255);
}

var matchers = (function() {

    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
})();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
}

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function stringInputToObject(color) {

    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
    var named = false;
    if (names[color]) {
        color = names[color];
        named = true;
    }
    else if (color == 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if ((match = matchers.rgb.exec(color))) {
        return { r: match[1], g: match[2], b: match[3] };
    }
    if ((match = matchers.rgba.exec(color))) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    if ((match = matchers.hsl.exec(color))) {
        return { h: match[1], s: match[2], l: match[3] };
    }
    if ((match = matchers.hsla.exec(color))) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    if ((match = matchers.hsv.exec(color))) {
        return { h: match[1], s: match[2], v: match[3] };
    }
    if ((match = matchers.hsva.exec(color))) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    if ((match = matchers.hex8.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex6.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
    }
    if ((match = matchers.hex4.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            a: convertHexToDecimal(match[4] + '' + match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex3.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            format: named ? "name" : "hex"
        };
    }

    return false;
}

function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {"level":"AA", "size":"small"};
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
        level = "AA";
    }
    if (size !== "small" && size !== "large") {
        size = "small";
    }
    return {"level":level, "size":size};
}

// Node: Export function
if ( true && module.exports) {
    module.exports = tinycolor;
}
// AMD/requirejs: Define the module
else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {return tinycolor;}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}
// Browser: Expose to window
else {}

})(Math);


/***/ }),

/***/ "6784":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوري',
            'فيبروري',
            'مارچ',
            'اپريل',
            'مئي',
            'جون',
            'جولاءِ',
            'آگسٽ',
            'سيپٽمبر',
            'آڪٽوبر',
            'نومبر',
            'ڊسمبر',
        ],
        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    var sd = moment.defineLocale('sd', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sd;

})));


/***/ }),

/***/ "67b1":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6887":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh',
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z',
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var monthsParse = [
            /^gen/i,
            /^c[ʼ\']hwe/i,
            /^meu/i,
            /^ebr/i,
            /^mae/i,
            /^(mez|eve)/i,
            /^gou/i,
            /^eos/i,
            /^gwe/i,
            /^her/i,
            /^du/i,
            /^ker/i,
        ],
        monthsRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsStrictRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        fullWeekdaysParse = [
            /^sul/i,
            /^lun/i,
            /^meurzh/i,
            /^merc[ʼ\']her/i,
            /^yaou/i,
            /^gwener/i,
            /^sadorn/i,
        ],
        shortWeekdaysParse = [
            /^Sul/i,
            /^Lun/i,
            /^Meu/i,
            /^Mer/i,
            /^Yao/i,
            /^Gwe/i,
            /^Sad/i,
        ],
        minWeekdaysParse = [
            /^Su/i,
            /^Lu/i,
            /^Me([^r]|$)/i,
            /^Mer/i,
            /^Ya/i,
            /^Gw/i,
            /^Sa/i,
        ];

    var br = moment.defineLocale('br', {
        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
            '_'
        ),
        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warcʼhoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Decʼh da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s ʼzo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function (number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
        isPM: function (token) {
            return token === 'g.m.';
        },
        meridiem: function (hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        },
    });

    return br;

})));


/***/ }),

/***/ "688b":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
            '_'
        ),
        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
            '_'
        ),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mi;

})));


/***/ }),

/***/ "68ee":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");
var classof = __webpack_require__("f5df");
var getBuiltIn = __webpack_require__("d066");
var inspectSource = __webpack_require__("8925");

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ "6909":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0
//! author : Sashko Todorov : https://github.com/bkyceh

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mk = moment.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'една минута',
            mm: '%d минути',
            h: 'еден час',
            hh: '%d часа',
            d: 'еден ден',
            dd: '%d дена',
            M: 'еден месец',
            MM: '%d месеци',
            y: 'една година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return mk;

})));


/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("7f9a");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var hasOwn = __webpack_require__("1a2d");
var shared = __webpack_require__("c6cd");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = uncurryThis(store.get);
  var wmhas = uncurryThis(store.has);
  var wmset = uncurryThis(store.set);
  set = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6ce3":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nb = moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dager',
            w: 'en uke',
            ww: '%d uker',
            M: 'en måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nb;

})));


/***/ }),

/***/ "6d79":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші',
    };

    var kk = moment.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
            '_'
        ),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
            '_'
        ),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return kk;

})));


/***/ }),

/***/ "6d83":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arTn;

})));


/***/ }),

/***/ "6e97":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_emoji_picker_vue_vue_type_style_index_0_id_5e1d87b0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5ed5");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_emoji_picker_vue_vue_type_style_index_0_id_5e1d87b0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_emoji_picker_vue_vue_type_style_index_0_id_5e1d87b0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6e98":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return it;

})));


/***/ }),

/***/ "6eeb":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");
var hasOwn = __webpack_require__("1a2d");
var createNonEnumerableProperty = __webpack_require__("9112");
var setGlobal = __webpack_require__("ce4e");
var inspectSource = __webpack_require__("8925");
var InternalStateModule = __webpack_require__("69f3");
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__("5e77").CONFIGURABLE;

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
      createNonEnumerableProperty(value, 'name', name);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "6f12":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian (Switzerland) [it-ch]
//! author : xfh : https://github.com/xfh

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var itCh = moment.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return itCh;

})));


/***/ }),

/***/ "6f50":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enNz = moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enNz;

})));


/***/ }),

/***/ "7118":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split(
            '_'
        ),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split(
            '_'
        );

    var fy = moment.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
            '_'
        ),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fy;

})));


/***/ }),

/***/ "7156":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");
var setPrototypeOf = __webpack_require__("d2bb");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "72f1":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7333":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Israel) [en-il]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIl = moment.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enIl;

})));


/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "746f":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var hasOwn = __webpack_require__("1a2d");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineProperty = __webpack_require__("9bf2").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "74dc":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sw = moment.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
            '_'
        ),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'hh:mm A',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'siku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sw;

})));


/***/ }),

/***/ "7609":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "785a":
/***/ (function(module, exports, __webpack_require__) {

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__("cc12");

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var requireObjectCoercible = __webpack_require__("1d80");

var Object = global.Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7be6":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
            '_'
        ),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return n > 1 && n < 5;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
        }
    }

    var sk = moment.defineLocale('sk', {
        months: months,
        monthsShort: monthsShort,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sk;

})));


/***/ }),

/***/ "7c73":
/***/ (function(module, exports, __webpack_require__) {

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__("825a");
var definePropertiesModule = __webpack_require__("37e8");
var enumBugKeys = __webpack_require__("7839");
var hiddenKeys = __webpack_require__("d012");
var html = __webpack_require__("1be4");
var documentCreateElement = __webpack_require__("cc12");
var sharedKey = __webpack_require__("f772");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),

/***/ "7db0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $find = __webpack_require__("b727").find;
var addToUnscopables = __webpack_require__("44d2");

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),

/***/ "7dd0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var call = __webpack_require__("c65b");
var IS_PURE = __webpack_require__("c430");
var FunctionName = __webpack_require__("5e77");
var isCallable = __webpack_require__("1626");
var createIteratorConstructor = __webpack_require__("9ed3");
var getPrototypeOf = __webpack_require__("e163");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");
var IteratorsCore = __webpack_require__("ae93");

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          redefine(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    redefine(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),

/***/ "7e6e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_colour_picker_vue_vue_type_style_index_2_id_fcc30a16_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e980");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_colour_picker_vue_vue_type_style_index_2_id_fcc30a16_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_colour_picker_vue_vue_type_style_index_2_id_fcc30a16_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7ef8":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7f33":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var yo = moment.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
            '_'
        ),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d',
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return yo;

})));


/***/ }),

/***/ "7f9a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");
var inspectSource = __webpack_require__("8925");

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "8155":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nekaj sekund'
                    : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sl;

})));


/***/ }),

/***/ "815f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_split_input_button_vue_vue_type_style_index_0_id_44831aca_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7ef8");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_split_input_button_vue_vue_type_style_index_0_id_44831aca_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_split_input_button_vue_vue_type_style_index_0_id_44831aca_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "81e9":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
            ' '
        ),
        numbersFuture = [
            'nolla',
            'yhden',
            'kahden',
            'kolmen',
            'neljän',
            'viiden',
            'kuuden',
            numbersPast[7],
            numbersPast[8],
            numbersPast[9],
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10
            ? isFuture
                ? numbersFuture[number]
                : numbersPast[number]
            : number;
    }

    var fi = moment.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
            '_'
        ),
        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
            '_'
        ),
        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
            '_'
        ),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fi;

})));


/***/ }),

/***/ "8230":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arSa = moment.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arSa;

})));


/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var String = global.String;
var TypeError = global.TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};


/***/ }),

/***/ "830c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "8418":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPropertyKey = __webpack_require__("a04b");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "84aa":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bg = moment.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Миналата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Миналия] dddd [в] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            w: 'седмица',
            ww: '%d седмици',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bg;

})));


/***/ }),

/***/ "84d2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_select_vue_vue_type_style_index_0_id_b645ef98_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5ca8");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_select_vue_vue_type_style_index_0_id_b645ef98_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_select_vue_vue_type_style_index_0_id_b645ef98_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "861d":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ "8689":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '၁',
            2: '၂',
            3: '၃',
            4: '၄',
            5: '၅',
            6: '၆',
            7: '၇',
            8: '၈',
            9: '၉',
            0: '၀',
        },
        numberMap = {
            '၁': '1',
            '၂': '2',
            '၃': '3',
            '၄': '4',
            '၅': '5',
            '၆': '6',
            '၇': '7',
            '၈': '8',
            '၉': '9',
            '၀': '0',
        };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
            '_'
        ),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
            '_'
        ),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်',
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return my;

})));


/***/ }),

/***/ "8840":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var gl = moment.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function () {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function () {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gl;

})));


/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "8925":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var isCallable = __webpack_require__("1626");
var store = __webpack_require__("c6cd");

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "898b":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));


/***/ }),

/***/ "8a5c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8aa5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ "8d47":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    var el = moment.defineLocale('el', {
        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
            '_'
        ),
        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
            '_'
        ),
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (
                typeof format === 'string' &&
                /D/.test(format.substring(0, format.indexOf('MMMM')))
            ) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
            '_'
        ),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function (input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L',
        },
        calendar: function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια',
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4st is the first week of the year.
        },
    });

    return el;

})));


/***/ }),

/***/ "8d57":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
            '_'
        ),
        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
            '_'
        ),
        monthsParse = [
            /^sty/i,
            /^lut/i,
            /^mar/i,
            /^kwi/i,
            /^maj/i,
            /^cze/i,
            /^lip/i,
            /^sie/i,
            /^wrz/i,
            /^paź/i,
            /^lis/i,
            /^gru/i,
        ];
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split(
            '_'
        ),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: '1 dzień',
            dd: '%d dni',
            w: 'tydzień',
            ww: translate,
            M: 'miesiąc',
            MM: translate,
            y: 'rok',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pl;

})));


/***/ }),

/***/ "8df4":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '۱',
            2: '۲',
            3: '۳',
            4: '۴',
            5: '۵',
            6: '۶',
            7: '۷',
            8: '۸',
            9: '۹',
            0: '۰',
        },
        numberMap = {
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9',
            '۰': '0',
        };

    var fa = moment.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        weekdays: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
            '_'
        ),
        weekdaysShort: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
            '_'
        ),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: '%d ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string
                .replace(/[۰-۹]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return fa;

})));


/***/ }),

/***/ "8e73":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var ar = moment.defineLocale('ar', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ar;

})));


/***/ }),

/***/ "8ed9":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8fb9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_vue_loader_lib_loaders_stylePostLoader_js_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_monolith_min_css_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e0f3");
/* harmony import */ var _mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_vue_loader_lib_loaders_stylePostLoader_js_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_monolith_min_css_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_vue_loader_lib_loaders_stylePostLoader_js_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_monolith_min_css_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9004":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_button_group_vue_vue_type_style_index_0_id_52123fc9_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e30c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_button_group_vue_vue_type_style_index_0_id_52123fc9_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_button_group_vue_vue_type_style_index_0_id_52123fc9_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9043":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bn = moment.defineLocale('bn', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
            '_'
        ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bn;

})));


/***/ }),

/***/ "90e3":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ "90ea":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhTw;

})));


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "9129":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");

// `Number.isNaN` method
// https://tc39.es/ecma262/#sec-number.isnan
$({ target: 'Number', stat: true }, {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return number != number;
  }
});


/***/ }),

/***/ "9263":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var toString = __webpack_require__("577e");
var regexpFlags = __webpack_require__("ad6d");
var stickyHelpers = __webpack_require__("9f7f");
var shared = __webpack_require__("5692");
var create = __webpack_require__("7c73");
var getInternalState = __webpack_require__("69f3").get;
var UNSUPPORTED_DOT_ALL = __webpack_require__("fce3");
var UNSUPPORTED_NCG = __webpack_require__("107c");

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis(''.charAt);
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call(nativeExec, re1, 'a');
  call(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice(match.input, charsAdded);
        match[0] = stringSlice(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      call(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "9379":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_text_message_vue_vue_type_style_index_0_id_c1c0df06_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("de75");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_text_message_vue_vue_type_style_index_0_id_c1c0df06_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_text_message_vue_vue_type_style_index_0_id_c1c0df06_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "957c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            ww: 'неделя_недели_недель',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет',
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i,
    ];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
                '_'
            ),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                '_'
            ),
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
        },
        weekdays: {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
                '_'
            ),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
                '_'
            ),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm',
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            w: 'неделя',
            ww: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ru;

})));


/***/ }),

/***/ "958b":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Mongolian [mn]
//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
            '_'
        ),
        monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function (input) {
            return input === 'ҮХ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        },
    });

    return mn;

})));


/***/ }),

/***/ "958e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_image_message_vue_vue_type_style_index_0_id_f8cd417a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fe95");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_image_message_vue_vue_type_style_index_0_id_f8cd417a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_image_message_vue_vue_type_style_index_0_id_f8cd417a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9609":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү',
    };

    var ky = moment.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
            '_'
        ),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
            '_'
        ),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
            '_'
        ),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ky;

})));


/***/ }),

/***/ "961c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_toggle_vue_vue_type_style_index_0_id_2476a5ac_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("457d");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_toggle_vue_vue_type_style_index_0_id_2476a5ac_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_toggle_vue_vue_type_style_index_0_id_2476a5ac_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9686":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali (Bangladesh) [bn-bd]
//! author : Asraf Hossain Patoary : https://github.com/ashwoolford

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bnBd = moment.defineLocale('bn-bd', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
            '_'
        ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },

        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ভোর') {
                return hour;
            } else if (meridiem === 'সকাল') {
                return hour;
            } else if (meridiem === 'দুপুর') {
                return hour >= 3 ? hour : hour + 12;
            } else if (meridiem === 'বিকাল') {
                return hour + 12;
            } else if (meridiem === 'সন্ধ্যা') {
                return hour + 12;
            }
        },

        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 6) {
                return 'ভোর';
            } else if (hour < 12) {
                return 'সকাল';
            } else if (hour < 15) {
                return 'দুপুর';
            } else if (hour < 18) {
                return 'বিকাল';
            } else if (hour < 20) {
                return 'সন্ধ্যা';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bnBd;

})));


/***/ }),

/***/ "96cf":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : undefined
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ "972c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly
//! author : Emanuel Cepoi : https://github.com/cepem

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                ss: 'secunde',
                mm: 'minute',
                hh: 'ore',
                dd: 'zile',
                ww: 'săptămâni',
                MM: 'luni',
                yy: 'ani',
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
            '_'
        ),
        monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural,
            m: 'un minut',
            mm: relativeTimeWithPlural,
            h: 'o oră',
            hh: relativeTimeWithPlural,
            d: 'o zi',
            dd: relativeTimeWithPlural,
            w: 'o săptămână',
            ww: relativeTimeWithPlural,
            M: 'o lună',
            MM: relativeTimeWithPlural,
            y: 'un an',
            yy: relativeTimeWithPlural,
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ro;

})));


/***/ }),

/***/ "9797":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
            '_'
        ),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
            '_'
        ),
        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
            '_'
        ),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '',
                    'af',
                    'il',
                    'ydd',
                    'ydd',
                    'ed',
                    'ed',
                    'ed',
                    'fed',
                    'fed',
                    'fed', // 1af to 10fed
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'fed', // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cy;

})));


/***/ }),

/***/ "98a1":
/***/ (function(module, exports, __webpack_require__) {

(function(e,t){ true?t(exports):undefined})(this,function(e){'use strict';var a=Math.floor;function i(e,t){return n(e)||r(e,t)||c(e,t)||g()}function d(e){return s(e)||l(e)||c(e)||h()}function s(e){if(Array.isArray(e))return p(e)}function n(e){if(Array.isArray(e))return e}function l(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)}function r(e,t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e)){var a=[],i=!0,d=!1,s=void 0;try{for(var n,l=e[Symbol.iterator]();!(i=(n=l.next()).done)&&(a.push(n.value),!(t&&a.length===t));i=!0);}catch(e){d=!0,s=e}finally{try{i||null==l["return"]||l["return"]()}finally{if(d)throw s}}return a}}function c(e,t){if(e){if("string"==typeof e)return p(e,t);var a=Object.prototype.toString.call(e).slice(8,-1);return"Object"===a&&e.constructor&&(a=e.constructor.name),"Map"===a||"Set"===a?Array.from(e):"Arguments"===a||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)?p(e,t):void 0}}function p(e,t){(null==t||t>e.length)&&(t=e.length);for(var a=0,d=Array(t);a<t;a++)d[a]=e[a];return d}function h(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function g(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function f(e,t){var a;if("undefined"==typeof Symbol||null==e[Symbol.iterator]){if(Array.isArray(e)||(a=c(e))||t&&e&&"number"==typeof e.length){a&&(e=a);var d=0,s=function(){};return{s:s,n:function(){return d>=e.length?{done:!0}:{done:!1,value:e[d++]}},e:function(t){throw t},f:s}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var n,l=!0,r=!1;return{s:function(){a=e[Symbol.iterator]()},n:function(){var e=a.next();return l=e.done,e},e:function(t){r=!0,n=t},f:function(){try{l||null==a.return||a.return()}finally{if(r)throw n}}}}function b(e,t){var a=e;do a=a.parentNode;while(!a.classList.contains("fresco-panel"));var i=a.id,s=i+"__",n=s.length,l=0===t.indexOf(s)?t.substring(n):t.substring(0),r=Array.from(a.querySelectorAll("input")),o=Array.from(a.querySelectorAll("textarea")),c=[].concat(d(r),d(o)),p=c.map(function(e){return{id:e.id,value:"file"===e.type?u(e):e.value}}),h=m(a),g=y(a);p=[].concat(d(p),d(h),d(g)),p=p.map(function(e){return e.id=e.id.substring(n),e});var f=new CustomEvent("fresco-panel-submit",{detail:{panelId:i,componentId:l,parsedValues:p}});document.dispatchEvent(f)}function u(e){return{fileName:e.dataset.fileName,base64:e.dataset.base64,contentType:e.dataset.contentType}}function m(e){for(var t=Array.from(e.querySelectorAll(".dropdown-container")),a=[],i=0,d=t;i<d.length;i++){for(var s,n=d[i],l=Array.from(n.querySelectorAll(".dropdown__options-opt")),r=!1,c=0,p=l;c<p.length;c++)if(s=p[c],s.classList.contains("selected")){a.push({id:n.id,value:s.id}),r=!0;break}r||a.push({id:n.id,value:""})}return a}function y(e){for(var t=Array.from(e.querySelectorAll(".ss-options-container")),a=[],i=0,d=t;i<d.length;i++){for(var s,n=d[i],l=Array.from(n.querySelectorAll(".ss__option")),r=!1,c=0,p=l;c<p.length;c++)if(s=p[c],s.classList.contains("selected")){a.push({id:n.id,value:s.id}),r=!0;break}r||a.push({id:n.id,value:""})}return a}function v(t){var a=se("button");switch(a.id=t.id,a.classList.add("btn"),a.innerText=t.label,a.classList.add("outline-primary"),t.style){case"fill":a.classList.add("fill"),a.classList.add("bg-primary");break;case"outline":a.classList.add("outline"),a.classList.add("text-primary"),a.classList.add("border-primary");break;case"text":a.classList.add("text"),a.classList.add("text-primary");}a.disabled=t.disabled,t.action&&!t.disabled&&("submit"===t.type&&a.setAttribute("submittable","true"),a.addEventListener("click",function(i){switch(t.action.type){case"submit":b(i.target,a.id);break;case"url":window.open(t.action.url,"_blank");}}));var i=ne("button-container");return i.appendChild(a),i}function _(e){function t(t){var a=new FileReader,n=t.size/1048576;return n>s?(h.style.display="flex",d.style.border="1px solid red",void(c.style.display="none")):void(h.style.display="none",d.style.border="1px solid #e2e8f0",a.addEventListener("load",function(){p.innerText=t.name,c.style.display="block";var d=a.result.split(","),s=i(d,2),n=s[0],l=s[1];g.dataset.base64=l,g.dataset.fileName=t.name,g.dataset.contentType=n.split(":")[1].split(";")[0],e.action&&"submit"===e.action.type&&b(g,g.id)}),a.readAsDataURL(t))}var d=ne("file-upload");d.style.border="failed"===e.saveState?"1px solid red":"1px solid #e2e8f0";var s=e.maxFileSize?e.maxFileSize:10,n=se("div");n.classList.add("file-upload__title-container");var l=se("div");l.innerHTML="<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"24\" viewBox=\"0 -960 960 960\" width=\"24\"><path d=\"M300-260q-92 0-156-64T80-480q0-92 64-156t156-64h420q66 0 113 47t47 113q0 66-47 113t-113 47H340q-42 0-71-29t-29-71q0-42 29-71t71-29h380v60H340q-17 0-28.5 11.5T300-480q0 17 11.5 28.5T340-440h380q42 0 71-29t29-71q0-42-29-71t-71-29H300q-66 0-113 47t-47 113q0 66 47 113t113 47h420v60H300Z\"/></svg>",l.alt="Attachment Icon",l.classList.add("file-upload__icon");var r=se("div");r.classList.add("file-upload__title"),r.innerText=e.label||"Add a file",n.appendChild(l),n.appendChild(r);var o=se("div");o.innerText="Max ".concat(s,"MB file"),o.classList.add("file-upload__subtitle");var c=se("div");c.classList.add("file-upload__file-added-text-container");var p=se("span");p.innerText="",p.style.display="block",p.classList.add("file-upload__file-added-text"),c.appendChild(p),c.style.display="none";var h=se("div");h.innerText="File is invalid",h.classList.add("file-upload__error-message"),h.style.display="failed"===e.saveState?"flex":"none";var g=se("input"),f=e.id?e.id:"file-input-"+Date.now()+"-"+a(1e3*Math.random());if(g.id=f,g.type="file",g.innerText=e.label,g.disabled=e.disabled,e.acceptedFileTypes){var u=e.acceptedFileTypes.join(",");g.setAttribute("accept",u)}return g.classList.add("file-upload__input"),g.addEventListener("change",function(){var e=document.getElementById(f);if(e&&e.files&&0<e.files.length){var a=e.files[0];t(a)}}),d.addEventListener("click",function(){return g.click()}),d.appendChild(n),d.appendChild(o),d.appendChild(c),d.appendChild(h),d.appendChild(g),d}function x(e){var t=L(e.id,e.label,e.saveState),a=w(e),i=se("div");i.classList.add("input-control-container"),i.appendChild(a);var d;if(e.action&&"saved"!==e.saveState&&(d=k(e.disabled,e.saveState,e.action,a),i.appendChild(d)),"saved"===e.saveState){var s=document.createElement("i");s.classList.add("saved-icon-container"),s.innerHTML="<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-check\"><polyline points=\"20 6 9 17 4 12\"></polyline></svg>",i.appendChild(s),a.disabled=!0}var n=ne("input-container");return n.appendChild(t),n.appendChild(i),n}function L(e,t,a){var i=se("label");return i.classList.add("label"),i.innerText=t,i.htmlFor=e,le(i,a),i}function w(e){var t=se("input");return t.id=e.id,t.classList.add("input"),t.placeholder=e.placeholder,t.disabled=e.disabled,t.value=e.value?e.value:"",t.classList.add("outline-primary"),le(t,e.saveState),t.addEventListener("keypress",function(a){var e=a.which||a.keyCode;if(13===e){var i=re(a.target),s=Array.prototype.slice.call(i.querySelectorAll(".btn")),n=Array.prototype.slice.call(i.querySelectorAll(".input")),l=Array.prototype.slice.call(i.querySelectorAll(".list-item")),r=[].concat(d(s.filter(function(e){return!e.disabled&&"true"===e.getAttribute("submittable")})),d(n.filter(function(e){return!e.disabled&&"true"===e.getAttribute("submittable")})),d(l.filter(function(e){return!e.classList.contains("disabled")&&"true"===e.getAttribute("submittable")})));if(!r.length)return;b(a.target,t.id)}}),t}function k(e,t,a,i){var d=se("button");return d.classList.add("btn"),d.classList.add("input-button"),d.classList.add("outline-primary"),d.classList.add("bg-primary"),d.disabled=e,le(d,t),i.classList.add("has-action"),e||("submit"===a.type&&d.setAttribute("submittable","true"),d.addEventListener("click",function(t){switch(a.type){case"submit":b(t.target,i.id);break;case"url":window.open(a.url,"_blank");}})),d.innerHTML="<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevron-right\"><polyline points=\"9 18 15 12 9 6\"></polyline></svg>",d}function C(e){var t=S(e.id,e.disabled,e.saveState),a=A(e.id,e.label),i=q(e.id,e.placeholder,e.disabled,e.saveState,e.options,e.value),d=E(e.options,e.value,i);if("saved"===e.saveState){var s=document.createElement("i");s.innerHTML="<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-check\"><polyline points=\"20 6 9 17 4 12\"></polyline></svg>",s.classList.add("saved-icon"),i.appendChild(s)}return t.appendChild(a),t.appendChild(i),t.appendChild(d),t}function S(e,t,a){var i=ne("dropdown-container");return i.id=e,(t||"saved"===a)&&i.classList.add("disabled"),le(i,a),i}function A(e,t){var a=se("label");return a.classList.add("label"),a.innerText=t,a.htmlFor=e,a}function E(e,t,a){var i=se("div");return i.classList.add("dropdown__options"),i.classList.add("dropdown__options--hidden"),e.forEach(function(e){var d=se("div");d.tabIndex=0,d.id=e.id,d.innerText=e.text,d.classList.add("dropdown__options-opt"),t&&t.length&&e.id===t&&d.classList.add("selected"),d.addEventListener("click",function(t){T(d,a,i,t)}),d.addEventListener("keypress",function(t){("Enter"===t.key||" "===t.key)&&(T(d,a,i,t),t.preventDefault())}),i.appendChild(d)}),i}function T(t,a,i,d){for(var e,s=Array.from(i.querySelectorAll(".dropdown__options-opt.selected")),n=0,l=s;n<l.length;n++)e=l[n],e.classList.remove("selected");t.classList.add("selected"),a.querySelector("span").innerText=t.innerText,i.classList.add("dropdown__options--hidden"),a.classList.remove("selected","outline-primary","shadow-primary"),d.stopPropagation()}function q(e,t,a,d,s,n){var l=se("div");l.tabIndex=0,l.classList.add("dropdown__button","text-primary");var r=se("span");if(r.innerText="Choose one...",t&&t.length&&(r.innerText=t),n&&n.length){var o=s.filter(function(e){return e.id===n}),c=i(o,1),p=c[0];r.innerText=p.text}l.appendChild(r);var h=se("i");return"saved"!==d&&(h.innerHTML="<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevron-down\"><polyline points=\"6 9 12 15 18 9\"></polyline></svg>",l.appendChild(h)),a||"saved"===d||(l.addEventListener("click",function(t){H(l,t)}),l.addEventListener("keypress",function(t){("Enter"===t.key||" "===t.key)&&(H(l,t),t.preventDefault())})),l}function H(t,a){var e=t.parentElement,i=e.querySelector(".dropdown__options");i.classList.contains("dropdown__options--hidden")?(M(),i.classList.remove("dropdown__options--hidden"),t.classList.add("selected","outline-primary","shadow-primary")):(i.classList.add("dropdown__options--hidden"),t.classList.remove("selected","outline-primary","shadow-primary")),a.stopPropagation()}function M(){for(var e,t=Array.from(document.querySelectorAll(".fresco-panel .dropdown-container")),a=0,i=t;a<i.length;a++)e=i[a],e.querySelector(".dropdown__options").classList.add("dropdown__options--hidden"),e.querySelector(".dropdown__button").classList.remove("selected","outline-primary","shadow-primary")}function j(e){var t=I(e.disabled,e.saveState,e.style),a=R(e.id,e.label),i=se("div");return i.classList.add("ss-options-container"),i.id=e.id,le(t,e.saveState),e.options.forEach(function(t){var a=B(t,e);a.tabIndex=0,i.appendChild(a)}),t.appendChild(a),t.appendChild(i),t}function I(e,t,a){var i=ne("ss-container");return(e||"saved"===t)&&i.classList.add("disabled"),"emoji"===a&&i.classList.add("emoji"),i}function R(e,t){var a=se("label");return a.classList.add("label"),a.innerText=t,a.htmlFor=e,a}function B(e,t){var a=t.disabled,i=t.value,d=t.saveState,s=t.style,n=se("div");return n.classList.add("ss__option"),n.classList.add("text-primary"),"emoji"!==s&&n.classList.add("border-primary"),n.id=e.id,n.innerText=e.text,i===e.id&&(n.classList.add("selected"),n.classList.add("bg-primary")),a||"saved"===d||(e.disabled?n.classList.add("disabled"):(n.addEventListener("click",function(a){return F(a,n,t.action)}),n.addEventListener("keypress",function(a){("Enter"===a.key||" "===a.key)&&(F(a,n,t.action),a.preventDefault())}))),n}function F(t,e,a){for(var i,d=e.parentElement,s=Array.from(d.querySelectorAll(".ss__option")),n=0,l=s;n<l.length;n++)i=l[n],i.classList.remove("selected"),i.classList.remove("bg-primary");e.classList.add("selected"),e.classList.add("bg-primary"),a&&"submit"===a.type&&b(t.target,e.id),t.stopPropagation()}function N(e){var t=se("label");t.classList.add("label"),t.innerText=e.label,t.htmlFor=e.id;var a=se("textarea");a.id=e.id,a.classList.add("input"),a.classList.add("textarea"),a.disabled=e.disabled,a.value=e.value?e.value:"",a.placeholder=e.placeholder,a.rows=5,a.classList.add("outline-primary"),e.error&&(a.classList.add("failed"),t.classList.add("failed"));var i=ne("textarea-container");return i.appendChild(t),i.appendChild(a),i}function P(e){var t=ne("list-container");return e.items.forEach(function(a){var e=se("div");e.classList.add("list-item-right");var i=se("div");i.id=a.id,i.classList.add("list-item");var d=D(a.image);d&&i.appendChild(d);var s=O(a.title,a.subtitle);e.appendChild(s);var n;a.action&&(i.classList.add("has-action"),i.classList.add("text-primary"),n=se("i"),n.classList.add("list-item__action","text-primary"),n.innerHTML="<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevron-right\"><polyline points=\"9 18 15 12 9 6\"></polyline></svg>",a.disabled?i.classList.add("disabled"):(i.tabIndex=0,"submit"===a.action.type&&i.setAttribute("submittable","true"),i.addEventListener("click",function(t){z(a,t)}),i.addEventListener("keypress",function(t){("Enter"===t.key||" "===t.key)&&(z(a,t),t.preventDefault())})),e.appendChild(n)),i.appendChild(e),t.appendChild(i)}),t}function z(t,a){switch(t.action.type){case"submit":b(a.target,t.id);break;case"url":window.open(t.action.url,"_blank");}}function D(e){var t;if(e){t=se("div"),t.classList.add("list-item__image-container");var a=se("img");a.classList.add("list-item__image"),a.src=e.url,t.style.width="48px",t.style.height="48px",e.width&&(t.style.width=e.width+"px"),e.height&&(t.style.height=e.height+"px"),e.rounded&&(a.style.borderRadius="50em"),t.appendChild(a)}return t}function O(e,t){var a=se("div");a.classList.add("list-item__text-container");var i=se("div");i.classList.add("list-item__title"),i.innerText=e,a.appendChild(i);var d;return t&&t.length&&(d=se("div"),d.classList.add("list-item__subtitle"),d.innerText=t),d&&a.appendChild(d),a}function U(e){return e.replace(RegExp("^"+(e.match(/^(\t| )+/)||"")[0],"gm"),"")}function V(e){return(e+"").replace(/"/g,"&quot;").replace(/</g,"&lt;").replace(/>/g,"&gt;")}function $(e){function a(e){var t=oe[e.replace(/\*/g,"_")[1]||""],a=c[c.length-1]==e;return t?t[1]?(c[a?"pop":"push"](e),t[0|a]):t[0]:e}function i(){for(var e="";c.length;)e+=a(c[c.length-1]);return e}var d,s,n,l,r,o=/((?:^|\n+)(?:\n---+|\* \*(?: \*)+)\n)|(?:^```(\w*)\n([\s\S]*?)\n```$)|((?:(?:^|\n+)(?:\t|  {2,}).+)+\n*)|((?:(?:^|\n)([>*+-]|\d+\.)\s+.*)+)|(?:\!\[([^\]]*?)\]\(([^\)]+?)\))|(\[)|(\](?:\(([^\)]+?)\))?)|(?:(?:^|\n+)([^\s].*)\n(\-{3,}|={3,})(?:\n+|$))|(?:(?:^|\n+)(#{1,3})\s*(.+)(?:\n+|$))|(?:`([^`].*?)`)|(  \n\n*|\n{2,}|__|\*\*|[_*])/gm,c=[],p="",h=0,g={};for(e=e.replace(/^\[(.+?)\]:\s*(.+)$/gm,function(e,t,a){return g[t.toLowerCase()]=a,""}).replace(/^\n+|\n+$/g,"");n=o.exec(e);){if(s=e.substring(h,n.index),h=o.lastIndex,d=n[0],s.match(/[^\\](\\\\)*\\$/));else n[3]||n[4]?d="<pre class=\"code "+(n[4]?"poetry":n[2].toLowerCase())+"\">"+U(V(n[3]||n[4]).replace(/^\n+|\n+$/g,""))+"</pre>":n[6]?(r=n[6],r.match(/\./)&&(n[5]=n[5].replace(/^\d+/gm,"")),l=$(U(n[5].replace(/^\s*[>*+.-]/gm,""))),">"===r?r="blockquote":(r=r.match(/\./)?"ol":"ul",l=l.replace(/^(.*)(\n|$)/gm,"<li>$1</li>")),d="<"+r+">"+l+"</"+r+">"):n[8]?d="<img src=\""+V(n[8])+"\" alt=\""+V(n[7])+"\">":n[10]?(p=p.replace("<a>","<a href=\""+V(n[11]||g[s.toLowerCase()])+"\">"),d=i()+"</a>"):n[9]?d="<a>":n[12]||n[14]?(r="h"+(n[14]?n[14].length:"="===n[13][0]?1:2),d="<"+r+">"+$(n[12]||n[15])+"</"+r+">"):n[16]?d="<code>"+V(n[16])+"</code>":(n[17]||n[1])&&(d=a(n[17]||"--"));p+=s,p+=d}return(p+e.substring(h)+i()).trim()}function G(e){var t=se("div");switch(t.classList.add("text"),e.align){case"right":t.classList.add("right");break;case"left":t.classList.add("left");break;case"center":case"centre":t.classList.add("center");}switch(e.style){case"muted":t.classList.add("muted");break;case"header":t.classList.add("header");break;case"error":t.classList.add("error");}t.innerHTML=$(e.text);var a=ne("text-container");return a.appendChild(t),a}function X(e){var t=ne("image-container");switch(e.align){case"left":t.classList.add("left");break;case"center":t.classList.add("center");break;case"right":t.classList.add("right");}var a=se("img");return a.classList.add("image"),a.src=e.url,e.rounded&&a.classList.add("rounded"),e.width&&(a.width=e.width),e.height&&(a.height=e.height),t.appendChild(a),t}function Z(e){var t=se("div");switch(t.classList.add("spacer"),e.size){case"xs":t.classList.add("xs");break;case"s":t.classList.add("s");break;case"m":t.classList.add("m");break;case"l":t.classList.add("l");break;case"xl":t.classList.add("xl");}var a=ne("spacer-container");return a.appendChild(t),a}function J(e){var t=se("div");t.classList.add("table"),e.items.forEach(function(e){var a=se("div");a.classList.add("row-key"),a.innerText=e.key;var i=se("div");i.classList.add("row-value"),i.innerText=e.value;var d=se("div");d.classList.add("table-row"),d.appendChild(a),d.appendChild(i),t.appendChild(d)});var a=ne("table-container");return a.appendChild(t),a}function K(){var e=se("div");e.classList.add("divider");var t=ne("divider-container");return t.appendChild(e),t}function Q(e,t,a,i){var d=!!(4<arguments.length&&arguments[4]!==void 0)&&arguments[4],s=document.createElement("div");s.id=e,s.classList.add("fresco-panel"),!0===i?s.classList.add("embedded"):"embedded"===i?s.classList.add("embedded"):"conversation"===i?s.classList.add("conversation"):"homescreen"==i&&s.classList.add("homescreen");var n=ee(e,t);s.appendChild(n),a.appendChild(s),d&&(s.classList.add("readonly"),ae(s)),ie(s)}function W(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:"",a=ce(e).darken(12),i="#fff";ce(e).isLight()&&(i="#656565"),t=t?".".concat(t):".fresco-panel";var d="\n        .fresco-panel:not(.embedded).conversation {\n            box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 15px 0px, rgba(0, 0, 0, 0.1) 0px 1px 2px 0px, ".concat(e," 0px 2px 0px 0px inset;\n        }\n\n        ").concat(t," .component-container .outline-primary {\n            outline-color: ").concat(e,";\n        }\n\n        ").concat(t," .component-container .text-primary {\n            color: ").concat(e,";\n        }\n\n        ").concat(t," .component-container .border-primary {\n            border: 1px solid ").concat(e,";\n        }\n\n        ").concat(t," .component-container .bg-primary {\n            background: ").concat(e,";\n        }\n\n        ").concat(t," .component-container .input-control-container .btn i {\n            border-color: ").concat(i,";\n        }\n\n        ").concat(t," .component-container .input:focus {\n            box-shadow: 0px 0px 5px 1px ").concat(e,";\n        }\n\n        ").concat(t," .component-container .btn.fill:not([disabled]):hover, \n        ").concat(t," .component-container .btn.outline:not([disabled]):hover {\n            background: ").concat(a,";\n            color: ").concat(i,";\n        }\n\n        ").concat(t," .component-container .btn.fill {\n            color: ").concat(i,";\n        }\n\n        ").concat(t," .component-container .ss__option.selected, \n        ").concat(t," .component-container .ss__option.selected:hover {\n            color: ").concat(i,";\n        }\n\n        ").concat(t," .component-container .ss__option.selected:hover {\n            background: ").concat(e,";\n        }\n\n        ").concat(t," .component-container .input-button svg {\n            color: ").concat(i,";\n        }\n    "),s=document.createElement("style");s.type="text/css",s.styleSheet?s.styleSheet.cssText=d:s.appendChild(document.createTextNode(d));var n=document.createElement("span");return n.appendChild(s),n}function Y(e,t){var a=[];return t.forEach(function(t){switch(t.id&&(t.id=e+"__"+t.id),t.type){case"button":a.push(v(t));break;case"file":a.push(_(t));break;case"input":a.push(x(t));break;case"textarea":a.push(N(t));break;case"list":a.push(P(t));break;case"single-select":a.push(j(t));break;case"dropdown":a.push(C(t));break;case"text":a.push(G(t));break;case"table":a.push(J(t));break;case"image":a.push(X(t));break;case"spacer":a.push(Z(t));break;case"divider":a.push(K());break;default:throw"Unrecognised component type";}}),a}function ee(e,t){var a=document.createElement("div");try{var i=JSON.parse(t),d=Y(e,i);d.forEach(function(t){a.appendChild(t)})}catch(e){a.appendChild(te())}return a.classList.add("element-container"),a}function te(){var e=document.createElement("div"),t=document.createElement("div");t.classList.add("text"),t.classList.add("center"),t.innerHTML="Something's gone wrong!";var a=document.createElement("div");a.classList.add("text"),a.classList.add("center");var i=document.createElement("i");return i.innerHTML="<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-alert-triangle\"><path d=\"M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z\"></path><line x1=\"12\" y1=\"9\" x2=\"12\" y2=\"13\"></line><line x1=\"12\" y1=\"17\" x2=\"12\" y2=\"17\"></line></svg>",a.appendChild(i),e.appendChild(a),e.appendChild(t),e}function ae(e){var t,a=f(e.childNodes);try{for(a.s();!(t=a.n()).done;){var i=t.value;i&&i instanceof HTMLElement&&(i.setAttribute("tabindex",-1),ae(i))}}catch(e){a.e(e)}finally{a.f()}}function ie(e){e.addEventListener("click",function(){for(var t,a=Array.from(e.querySelectorAll(".dropdown-container")),i=0,d=a;i<d.length;i++)t=d[i],t.querySelector(".dropdown__options").classList.add("dropdown__options--hidden"),t.querySelector(".dropdown__button").classList.remove("selected","outline-primary","shadow-primary")})}var de={createElement:function(e){return document.createElement(e)},createContainerElement:function(e){var t=document.createElement("div");return t.classList.add(e),t.classList.add("component-container"),t},$:function(e){return document.querySelector(e)},addSaveStateClass:function(e,t){"failed"===t?e.classList.add("failed"):"unsaved"===t?e.classList.add("unsaved"):"saved"===t?e.classList.add("saved"):void 0},getPanel:function(e){for(var t=e;!t.classList.contains("fresco-panel");)t=t.parentNode;return t}},se=de.createElement,ne=de.createContainerElement,le=de.addSaveStateClass,re=de.getPanel;(function(){return"function"!=typeof window.CustomEvent&&void(window.CustomEvent=function(e,t){t=t||{bubbles:!1,cancelable:!1,detail:null};var a=document.createEvent("CustomEvent");return a.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),a})})();var oe={"":["<em>","</em>"],_:["<strong>","</strong>"],"\n":["<br />"]," ":["<br />"],"-":["<hr />"]},ce=function(e,t){return t={exports:{}},e(t,t.exports),t.exports}(function(e){(function(t){var i=(0,eval)("this").Math.max,d=(0,eval)("this").Math.min,s=(0,eval)("this").Math.round;function n(e,t){if(e=e?e:"",t=t||{},e instanceof n)return e;if(!(this instanceof n))return new n(e,t);var a=l(e);this._originalInput=e,this._r=a.r,this._g=a.g,this._b=a.b,this._a=a.a,this._roundA=G(100*this._a)/100,this._format=t.format||a.format,this._gradientType=t.gradientType,1>this._r&&(this._r=G(this._r)),1>this._g&&(this._g=G(this._g)),1>this._b&&(this._b=G(this._b)),this._ok=a.ok,this._tc_id=$++}function l(e){var t={r:0,g:0,b:0},i=1,d=null,n=null,o=null,p=!1,g=!1;return"string"==typeof e&&(e=D(e)),"object"==typeof e&&(z(e.r)&&z(e.g)&&z(e.b)?(t=r(e.r,e.g,e.b),p=!0,g="%"===(e.r+"").substr(-1)?"prgb":"rgb"):z(e.h)&&z(e.s)&&z(e.v)?(d=F(e.s),n=F(e.v),t=h(e.h,d,n),p=!0,g="hsv"):z(e.h)&&z(e.s)&&z(e.l)&&(d=F(e.s),o=F(e.l),t=c(e.h,d,o),p=!0,g="hsl"),e.hasOwnProperty("a")&&(i=e.a)),i=T(i),{ok:p,format:e.format||g,r:X(255,Z(t.r,0)),g:X(255,Z(t.g,0)),b:X(255,Z(t.b,0)),a:i}}function r(e,t,a){return{r:255*H(e,255),g:255*H(t,255),b:255*H(a,255)}}function o(e,t,a){e=H(e,255),t=H(t,255),a=H(a,255);var i,n,o=Z(e,t,a),c=X(e,t,a),p=(o+c)/2;if(o==c)i=n=0;else{var l=o-c;n=.5<p?l/(2-o-c):l/(o+c);o===e?i=(t-a)/l+(t<a?6:0):o===t?i=(a-e)/l+2:o===a?i=(e-t)/l+4:void 0;i/=6}return{h:i,s:n,l:p}}function c(e,t,a){function i(e,a,i){return 0>i&&(i+=1),1<i&&(i-=1),i<1/6?e+6*(a-e)*i:i<1/2?a:i<2/3?e+6*((a-e)*(2/3-i)):e}var d,n,o;if(e=H(e,360),t=H(t,100),a=H(a,100),0===t)d=n=o=a;else{var c=.5>a?a*(1+t):a+t-a*t,f=2*a-c;d=i(f,c,e+1/3),n=i(f,c,e),o=i(f,c,e-1/3)}return{r:255*d,g:255*n,b:255*o}}function p(e,t,a){e=H(e,255),t=H(t,255),a=H(a,255);var i,n,l=Z(e,t,a),o=X(e,t,a),c=l-o;return n=0===l?0:c/l,l==o?i=0:(l===e?i=(t-a)/c+(t<a?6:0):l===t?i=(a-e)/c+2:l===a?i=(e-t)/c+4:void 0,i/=6),{h:i,s:n,v:l}}function h(e,d,n){e=6*H(e,360),d=H(d,100),n=H(n,100);var l=a(e),i=e-l,o=n*(1-d),c=n*(1-i*d),p=n*(1-(1-i)*d),t=l%6,f=[n,c,o,o,p,n][t],r=[p,n,n,c,o,o][t],g=[o,o,p,n,n,c][t];return{r:255*f,g:255*r,b:255*g}}function g(e,t,a,i){var d=[B(G(e).toString(16)),B(G(t).toString(16)),B(G(a).toString(16))];return i&&d[0].charAt(0)==d[0].charAt(1)&&d[1].charAt(0)==d[1].charAt(1)&&d[2].charAt(0)==d[2].charAt(1)?d[0].charAt(0)+d[1].charAt(0)+d[2].charAt(0):d.join("")}function f(e,t,i,d,a){var s=[B(G(e).toString(16)),B(G(t).toString(16)),B(G(i).toString(16)),B(N(d))];return a&&s[0].charAt(0)==s[0].charAt(1)&&s[1].charAt(0)==s[1].charAt(1)&&s[2].charAt(0)==s[2].charAt(1)&&s[3].charAt(0)==s[3].charAt(1)?s[0].charAt(0)+s[1].charAt(0)+s[2].charAt(0)+s[3].charAt(0):s.join("")}function b(e,t,i,d){var a=[B(N(d)),B(G(e).toString(16)),B(G(t).toString(16)),B(G(i).toString(16))];return a.join("")}function u(e,t){t=0===t?0:t||10;var a=n(e).toHsl();return a.s-=t/100,a.s=M(a.s),n(a)}function m(e,t){t=0===t?0:t||10;var a=n(e).toHsl();return a.s+=t/100,a.s=M(a.s),n(a)}function y(e){return n(e).desaturate(100)}function v(e,t){t=0===t?0:t||10;var a=n(e).toHsl();return a.l+=t/100,a.l=M(a.l),n(a)}function _(e,t){t=0===t?0:t||10;var a=n(e).toRgb();return a.r=Z(0,X(255,a.r-G(255*-(t/100)))),a.g=Z(0,X(255,a.g-G(255*-(t/100)))),a.b=Z(0,X(255,a.b-G(255*-(t/100)))),n(a)}function x(e,t){t=0===t?0:t||10;var a=n(e).toHsl();return a.l-=t/100,a.l=M(a.l),n(a)}function L(e,t){var a=n(e).toHsl(),i=(a.h+t)%360;return a.h=0>i?360+i:i,n(a)}function w(e){var t=n(e).toHsl();return t.h=(t.h+180)%360,n(t)}function k(e){var t=n(e).toHsl(),a=t.h;return[n(e),n({h:(a+120)%360,s:t.s,l:t.l}),n({h:(a+240)%360,s:t.s,l:t.l})]}function C(e){var t=n(e).toHsl(),a=t.h;return[n(e),n({h:(a+90)%360,s:t.s,l:t.l}),n({h:(a+180)%360,s:t.s,l:t.l}),n({h:(a+270)%360,s:t.s,l:t.l})]}function S(e){var t=n(e).toHsl(),a=t.h;return[n(e),n({h:(a+72)%360,s:t.s,l:t.l}),n({h:(a+216)%360,s:t.s,l:t.l})]}function A(e,t,a){t=t||6,a=a||30;var i=n(e).toHsl(),d=360/a,s=[n(e)];for(i.h=(i.h-(d*t>>1)+720)%360;--t;)i.h=(i.h+d)%360,s.push(n(i));return s}function E(e,t){t=t||6;for(var a=n(e).toHsv(),i=a.h,d=a.s,s=a.v,l=[],r=1/t;t--;)l.push(n({h:i,s:d,v:s})),s=(s+r)%1;return l}function T(e){return e=parseFloat(e),(isNaN(e)||0>e||1<e)&&(e=1),e}function H(e,t){var a=(0,eval)("this").Math.abs;I(e)&&(e="100%");var i=R(e);return e=X(t,Z(0,parseFloat(e))),i&&(e=parseInt(e*t,10)/100),1e-6>a(e-t)?1:e%t/parseFloat(t)}function M(e){return X(1,Z(0,e))}function j(e){return parseInt(e,16)}function I(e){return"string"==typeof e&&-1!=e.indexOf(".")&&1===parseFloat(e)}function R(e){return"string"==typeof e&&-1!=e.indexOf("%")}function B(e){return 1==e.length?"0"+e:""+e}function F(e){return 1>=e&&(e=100*e+"%"),e}function N(e){return s(255*parseFloat(e)).toString(16)}function P(e){return j(e)/255}function z(e){return!!W.CSS_UNIT.exec(e)}function D(e){e=e.replace(U,"").replace(V,"").toLowerCase();var t=!1;if(K[e])e=K[e],t=!0;else if("transparent"==e)return{r:0,g:0,b:0,a:0,format:"name"};var a;return(a=W.rgb.exec(e))?{r:a[1],g:a[2],b:a[3]}:(a=W.rgba.exec(e))?{r:a[1],g:a[2],b:a[3],a:a[4]}:(a=W.hsl.exec(e))?{h:a[1],s:a[2],l:a[3]}:(a=W.hsla.exec(e))?{h:a[1],s:a[2],l:a[3],a:a[4]}:(a=W.hsv.exec(e))?{h:a[1],s:a[2],v:a[3]}:(a=W.hsva.exec(e))?{h:a[1],s:a[2],v:a[3],a:a[4]}:(a=W.hex8.exec(e))?{r:j(a[1]),g:j(a[2]),b:j(a[3]),a:P(a[4]),format:t?"name":"hex8"}:(a=W.hex6.exec(e))?{r:j(a[1]),g:j(a[2]),b:j(a[3]),format:t?"name":"hex"}:(a=W.hex4.exec(e))?{r:j(a[1]+""+a[1]),g:j(a[2]+""+a[2]),b:j(a[3]+""+a[3]),a:P(a[4]+""+a[4]),format:t?"name":"hex8"}:!!(a=W.hex3.exec(e))&&{r:j(a[1]+""+a[1]),g:j(a[2]+""+a[2]),b:j(a[3]+""+a[3]),format:t?"name":"hex"}}function O(e){var t,a;return e=e||{level:"AA",size:"small"},t=(e.level||"AA").toUpperCase(),a=(e.size||"small").toLowerCase(),"AA"!==t&&"AAA"!==t&&(t="AA"),"small"!==a&&"large"!==a&&(a="small"),{level:t,size:a}}var U=/^\s+/,V=/\s+$/,$=0,G=s,X=d,Z=i,J=t.random;n.prototype={isDark:function(){return 128>this.getBrightness()},isLight:function(){return!this.isDark()},isValid:function(){return this._ok},getOriginalInput:function(){return this._originalInput},getFormat:function(){return this._format},getAlpha:function(){return this._a},getBrightness:function(){var e=this.toRgb();return(299*e.r+587*e.g+114*e.b)/1e3},getLuminance:function(){var t,a,i,d,s,n,e=(0,eval)("this").Math.pow,l=this.toRgb();return t=l.r/255,a=l.g/255,i=l.b/255,d=.03928>=t?t/12.92:e((t+.055)/1.055,2.4),s=.03928>=a?a/12.92:e((a+.055)/1.055,2.4),n=.03928>=i?i/12.92:e((i+.055)/1.055,2.4),.2126*d+.7152*s+.0722*n},setAlpha:function(e){return this._a=T(e),this._roundA=G(100*this._a)/100,this},toHsv:function(){var e=p(this._r,this._g,this._b);return{h:360*e.h,s:e.s,v:e.v,a:this._a}},toHsvString:function(){var e=p(this._r,this._g,this._b),t=G(360*e.h),a=G(100*e.s),i=G(100*e.v);return 1==this._a?"hsv("+t+", "+a+"%, "+i+"%)":"hsva("+t+", "+a+"%, "+i+"%, "+this._roundA+")"},toHsl:function(){var e=o(this._r,this._g,this._b);return{h:360*e.h,s:e.s,l:e.l,a:this._a}},toHslString:function(){var e=o(this._r,this._g,this._b),t=G(360*e.h),a=G(100*e.s),i=G(100*e.l);return 1==this._a?"hsl("+t+", "+a+"%, "+i+"%)":"hsla("+t+", "+a+"%, "+i+"%, "+this._roundA+")"},toHex:function(e){return g(this._r,this._g,this._b,e)},toHexString:function(e){return"#"+this.toHex(e)},toHex8:function(e){return f(this._r,this._g,this._b,this._a,e)},toHex8String:function(e){return"#"+this.toHex8(e)},toRgb:function(){return{r:G(this._r),g:G(this._g),b:G(this._b),a:this._a}},toRgbString:function(){return 1==this._a?"rgb("+G(this._r)+", "+G(this._g)+", "+G(this._b)+")":"rgba("+G(this._r)+", "+G(this._g)+", "+G(this._b)+", "+this._roundA+")"},toPercentageRgb:function(){return{r:G(100*H(this._r,255))+"%",g:G(100*H(this._g,255))+"%",b:G(100*H(this._b,255))+"%",a:this._a}},toPercentageRgbString:function(){return 1==this._a?"rgb("+G(100*H(this._r,255))+"%, "+G(100*H(this._g,255))+"%, "+G(100*H(this._b,255))+"%)":"rgba("+G(100*H(this._r,255))+"%, "+G(100*H(this._g,255))+"%, "+G(100*H(this._b,255))+"%, "+this._roundA+")"},toName:function(){return 0===this._a?"transparent":!(1>this._a)&&(Q[g(this._r,this._g,this._b,!0)]||!1)},toFilter:function(e){var t="#"+b(this._r,this._g,this._b,this._a),a=t,i=this._gradientType?"GradientType = 1, ":"";if(e){var d=n(e);a="#"+b(d._r,d._g,d._b,d._a)}return"progid:DXImageTransform.Microsoft.gradient("+i+"startColorstr="+t+",endColorstr="+a+")"},toString:function(e){var t=!!e;e=e||this._format;var a=!1,i=1>this._a&&0<=this._a,d=!t&&i&&("hex"===e||"hex6"===e||"hex3"===e||"hex4"===e||"hex8"===e||"name"===e);return d?"name"===e&&0===this._a?this.toName():this.toRgbString():("rgb"===e&&(a=this.toRgbString()),"prgb"===e&&(a=this.toPercentageRgbString()),("hex"===e||"hex6"===e)&&(a=this.toHexString()),"hex3"===e&&(a=this.toHexString(!0)),"hex4"===e&&(a=this.toHex8String(!0)),"hex8"===e&&(a=this.toHex8String()),"name"===e&&(a=this.toName()),"hsl"===e&&(a=this.toHslString()),"hsv"===e&&(a=this.toHsvString()),a||this.toHexString())},clone:function(){return n(this.toString())},_applyModification:function(e,t){var a=e.apply(null,[this].concat([].slice.call(t)));return this._r=a._r,this._g=a._g,this._b=a._b,this.setAlpha(a._a),this},lighten:function(){return this._applyModification(v,arguments)},brighten:function(){return this._applyModification(_,arguments)},darken:function(){return this._applyModification(x,arguments)},desaturate:function(){return this._applyModification(u,arguments)},saturate:function(){return this._applyModification(m,arguments)},greyscale:function(){return this._applyModification(y,arguments)},spin:function(){return this._applyModification(L,arguments)},_applyCombination:function(e,t){return e.apply(null,[this].concat([].slice.call(t)))},analogous:function(){return this._applyCombination(A,arguments)},complement:function(){return this._applyCombination(w,arguments)},monochromatic:function(){return this._applyCombination(E,arguments)},splitcomplement:function(){return this._applyCombination(S,arguments)},triad:function(){return this._applyCombination(k,arguments)},tetrad:function(){return this._applyCombination(C,arguments)}},n.fromRatio=function(e,t){if("object"==typeof e){var a={};for(var d in e)e.hasOwnProperty(d)&&(a[d]="a"===d?e[d]:F(e[d]));e=a}return n(e,t)},n.equals=function(e,t){return!!(e&&t)&&n(e).toRgbString()==n(t).toRgbString()},n.random=function(){return n.fromRatio({r:J(),g:J(),b:J()})},n.mix=function(e,t,a){a=0===a?0:a||50;var i=n(e).toRgb(),d=n(t).toRgb(),s=a/100,l={r:(d.r-i.r)*s+i.r,g:(d.g-i.g)*s+i.g,b:(d.b-i.b)*s+i.b,a:(d.a-i.a)*s+i.a};return n(l)},n.readability=function(e,t){var a=n(e),s=n(t);return(i(a.getLuminance(),s.getLuminance())+.05)/(d(a.getLuminance(),s.getLuminance())+.05)},n.isReadable=function(e,t,a){var i,d,s=n.readability(e,t);switch(d=!1,i=O(a),i.level+i.size){case"AAsmall":case"AAAlarge":d=4.5<=s;break;case"AAlarge":d=3<=s;break;case"AAAsmall":d=7<=s;}return d},n.mostReadable=function(e,t,a){var d,s,l,r,o=null,c=0;a=a||{},s=a.includeFallbackColors,l=a.level,r=a.size;for(var p=0;p<t.length;p++)d=n.readability(e,t[p]),d>c&&(c=d,o=n(t[p]));return n.isReadable(e,o,{level:l,size:r})||!s?o:(a.includeFallbackColors=!1,n.mostReadable(e,["#fff","#000"],a))};var K=n.names={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"0ff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000",blanchedalmond:"ffebcd",blue:"00f",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",burntsienna:"ea7e5d",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"0ff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgreen:"006400",darkgrey:"a9a9a9",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkslategrey:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dimgrey:"696969",dodgerblue:"1e90ff",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"f0f",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",grey:"808080",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgray:"d3d3d3",lightgreen:"90ee90",lightgrey:"d3d3d3",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslategray:"789",lightslategrey:"789",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"0f0",limegreen:"32cd32",linen:"faf0e6",magenta:"f0f",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370db",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"db7093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",rebeccapurple:"663399",red:"f00",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",slategrey:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",wheat:"f5deb3",white:"fff",whitesmoke:"f5f5f5",yellow:"ff0",yellowgreen:"9acd32"},Q=n.hexNames=function(e){var t={};for(var a in e)e.hasOwnProperty(a)&&(t[e[a]]=a);return t}(K),W=function(){var e="(?:"+"[-\\+]?\\d*\\.\\d+%?"+")|(?:"+"[-\\+]?\\d+%?"+")",t="[\\s|\\(]+("+e+")[,|\\s]+("+e+")[,|\\s]+("+e+")\\s*\\)?",a="[\\s|\\(]+("+e+")[,|\\s]+("+e+")[,|\\s]+("+e+")[,|\\s]+("+e+")\\s*\\)?";return{CSS_UNIT:new RegExp(e),rgb:new RegExp("rgb"+t),rgba:new RegExp("rgba"+a),hsl:new RegExp("hsl"+t),hsla:new RegExp("hsla"+a),hsv:new RegExp("hsv"+t),hsva:new RegExp("hsva"+a),hex3:/^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,hex6:/^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,hex4:/^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,hex8:/^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/}}();e.exports?e.exports=n:window.tinycolor=n})(Math)});e.addLoading=function(e){var t=document.getElementById(e);t.querySelector(".element-container").classList.add("loading");var a=document.createElement("div");a.classList.add("panel-loading-container");var i=document.createElement("div");i.classList.add("spinner"),i.innerHTML="<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-refresh-cw\"><polyline points=\"23 4 23 10 17 10\"></polyline><polyline points=\"1 20 1 14 7 14\"></polyline><path d=\"M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15\"></path></svg>",a.appendChild(i),t.appendChild(a)},e.default={renderElements:Q,getStyles:W},e.getStyles=W,e.renderElements=Q,e.replacePanel=function(e,t){var a=document.getElementById(e);if(a){a.innerHTML="";var i=ee(e,t);i.classList.remove("loading"),a.appendChild(i)}},Object.defineProperty(e,"__esModule",{value:!0})});


/***/ }),

/***/ "99af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var fails = __webpack_require__("d039");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var toObject = __webpack_require__("7b0b");
var lengthOfArrayLike = __webpack_require__("07fa");
var createProperty = __webpack_require__("8418");
var arraySpeciesCreate = __webpack_require__("65f0");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';
var TypeError = global.TypeError;

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "99d9":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9a1f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var aCallable = __webpack_require__("59ed");
var anObject = __webpack_require__("825a");
var tryToString = __webpack_require__("0d51");
var getIteratorMethod = __webpack_require__("35a1");

var TypeError = global.TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw TypeError(tryToString(argument) + ' is not iterable');
};


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("aed9");
var anObject = __webpack_require__("825a");
var toPropertyKey = __webpack_require__("a04b");

var TypeError = global.TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9c2f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_number_input_vue_vue_type_style_index_0_id_ec509fe4_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7609");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_number_input_vue_vue_type_style_index_0_id_ec509fe4_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_number_input_vue_vue_type_style_index_0_id_ec509fe4_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9e12":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_audio_message_vue_vue_type_style_index_0_id_96837b38_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("dbf0");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_audio_message_vue_vue_type_style_index_0_id_96837b38_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_audio_message_vue_vue_type_style_index_0_id_96837b38_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9ed3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("ae93").IteratorPrototype;
var create = __webpack_require__("7c73");
var createPropertyDescriptor = __webpack_require__("5c6c");
var setToStringTag = __webpack_require__("d44e");
var Iterators = __webpack_require__("3f8c");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "9f26":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));


/***/ }),

/***/ "9f7f":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var global = __webpack_require__("da84");

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global.RegExp;

var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

module.exports = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};


/***/ }),

/***/ "a04b":
/***/ (function(module, exports, __webpack_require__) {

var toPrimitive = __webpack_require__("c04e");
var isSymbol = __webpack_require__("d9b5");

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ "a15b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var uncurryThis = __webpack_require__("e330");
var IndexedObject = __webpack_require__("44ad");
var toIndexedObject = __webpack_require__("fc6a");
var arrayMethodIsStrict = __webpack_require__("a640");

var un$Join = uncurryThis([].join);

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return un$Join(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ "a356":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Amine Roukh: https://github.com/Amine27
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi
//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'جانفي',
            'فيفري',
            'مارس',
            'أفريل',
            'ماي',
            'جوان',
            'جويلية',
            'أوت',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arDz = moment.defineLocale('ar-dz', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arDz;

})));


/***/ }),

/***/ "a4b4":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");

module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),

/***/ "a4d3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var apply = __webpack_require__("2ba4");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var IS_PURE = __webpack_require__("c430");
var DESCRIPTORS = __webpack_require__("83ab");
var NATIVE_SYMBOL = __webpack_require__("4930");
var fails = __webpack_require__("d039");
var hasOwn = __webpack_require__("1a2d");
var isArray = __webpack_require__("e8b5");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");
var isPrototypeOf = __webpack_require__("3a9b");
var isSymbol = __webpack_require__("d9b5");
var anObject = __webpack_require__("825a");
var toObject = __webpack_require__("7b0b");
var toIndexedObject = __webpack_require__("fc6a");
var toPropertyKey = __webpack_require__("a04b");
var $toString = __webpack_require__("577e");
var createPropertyDescriptor = __webpack_require__("5c6c");
var nativeObjectCreate = __webpack_require__("7c73");
var objectKeys = __webpack_require__("df75");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertyNamesExternal = __webpack_require__("057f");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");
var definePropertiesModule = __webpack_require__("37e8");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var arraySlice = __webpack_require__("f36a");
var redefine = __webpack_require__("6eeb");
var shared = __webpack_require__("5692");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");
var uid = __webpack_require__("90e3");
var wellKnownSymbol = __webpack_require__("b622");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineWellKnownSymbol = __webpack_require__("746f");
var setToStringTag = __webpack_require__("d44e");
var InternalStateModule = __webpack_require__("69f3");
var $forEach = __webpack_require__("b727").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);

var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var TypeError = global.TypeError;
var QObject = global.QObject;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwn(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = call(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
      push(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
      if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  redefine(SymbolPrototype, 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.es/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = $toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.es/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (isCallable($replacer)) value = call($replacer, this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return apply($stringify, null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!SymbolPrototype[TO_PRIMITIVE]) {
  var valueOf = SymbolPrototype.valueOf;
  // eslint-disable-next-line no-unused-vars -- required for .length
  redefine(SymbolPrototype, TO_PRIMITIVE, function (hint) {
    // TODO: improve hint logic
    return call(valueOf, this);
  });
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "a503":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_checkbox_group_vue_vue_type_style_index_0_id_0e84e2fa_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ad93");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_checkbox_group_vue_vue_type_style_index_0_id_0e84e2fa_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_checkbox_group_vue_vue_type_style_index_0_id_0e84e2fa_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "a640":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ "a71b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_modal_vue_vue_type_style_index_0_id_01a58372_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6336");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_modal_vue_vue_type_style_index_0_id_01a58372_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_modal_vue_vue_type_style_index_0_id_01a58372_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "a7fa":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bm = moment.defineLocale('bm', {
        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
            '_'
        ),
        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        },
        calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return bm;

})));


/***/ }),

/***/ "a9e3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var isForced = __webpack_require__("94ca");
var redefine = __webpack_require__("6eeb");
var hasOwn = __webpack_require__("1a2d");
var inheritIfRequired = __webpack_require__("7156");
var isPrototypeOf = __webpack_require__("3a9b");
var isSymbol = __webpack_require__("d9b5");
var toPrimitive = __webpack_require__("c04e");
var fails = __webpack_require__("d039");
var getOwnPropertyNames = __webpack_require__("241c").f;
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var defineProperty = __webpack_require__("9bf2").f;
var thisNumberValue = __webpack_require__("408a");
var trim = __webpack_require__("58a8").trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;
var TypeError = global.TypeError;
var arraySlice = uncurryThis(''.slice);
var charCodeAt = uncurryThis(''.charCodeAt);

// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var toNumeric = function (value) {
  var primValue = toPrimitive(value, 'number');
  return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
};

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (isSymbol(it)) throw TypeError('Cannot convert a Symbol value to a number');
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = charCodeAt(it, 0);
    if (first === 43 || first === 45) {
      third = charCodeAt(it, 2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (charCodeAt(it, 1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = arraySlice(it, 2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = charCodeAt(digits, index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
    var dummy = this;
    // check on 1..constructor(foo) case
    return isPrototypeOf(NumberPrototype, dummy) && fails(function () { thisNumberValue(dummy); })
      ? inheritIfRequired(Object(n), dummy, NumberWrapper) : n;
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (hasOwn(NativeNumber, key = keys[j]) && !hasOwn(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),

/***/ "aaf2":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Devanagari script [gom-deva]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
            m: ['एका मिणटान', 'एक मिनूट'],
            mm: [number + ' मिणटांनी', number + ' मिणटां'],
            h: ['एका वरान', 'एक वर'],
            hh: [number + ' वरांनी', number + ' वरां'],
            d: ['एका दिसान', 'एक दीस'],
            dd: [number + ' दिसांनी', number + ' दीस'],
            M: ['एका म्हयन्यान', 'एक म्हयनो'],
            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
            y: ['एका वर्सान', 'एक वर्स'],
            yy: [number + ' वर्सांनी', number + ' वर्सां'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomDeva = moment.defineLocale('gom-deva', {
        months: {
            standalone: 'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
                '_'
            ),
            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort: 'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [वाजतां]',
            LTS: 'A h:mm:ss [वाजतां]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
        },
        calendar: {
            sameDay: '[आयज] LT',
            nextDay: '[फाल्यां] LT',
            nextWeek: '[फुडलो] dddd[,] LT',
            lastDay: '[काल] LT',
            lastWeek: '[फाटलो] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s आदीं',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + 'वेर';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राती') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळीं') {
                return hour;
            } else if (meridiem === 'दनपारां') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'सांजे') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'राती';
            } else if (hour < 12) {
                return 'सकाळीं';
            } else if (hour < 16) {
                return 'दनपारां';
            } else if (hour < 20) {
                return 'सांजे';
            } else {
                return 'राती';
            }
        },
    });

    return gomDeva;

})));


/***/ }),

/***/ "ab36":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports = function (O, options) {
  if (isObject(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};


/***/ }),

/***/ "ac1f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var exec = __webpack_require__("9263");

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ "ad6d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("825a");

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "ad93":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ada2":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            dd: 'день_дні_днів',
            MM: 'місяць_місяці_місяців',
            yy: 'рік_роки_років',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
                nominative: 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
                    '_'
                ),
                accusative: 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
                    '_'
                ),
                genitive: 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
                    '_'
                ),
            },
            nounCase;

        if (m === true) {
            return weekdays['nominative']
                .slice(1, 7)
                .concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
            ? 'accusative'
            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
            ? 'genitive'
            : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months: {
            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
                '_'
            ),
            standalone: 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
                '_'
            ),
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
            '_'
        ),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'годину',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'місяць',
            MM: relativeTimeWithPlural,
            y: 'рік',
            yy: relativeTimeWithPlural,
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uk;

})));


/***/ }),

/***/ "ae93":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");
var create = __webpack_require__("7c73");
var getPrototypeOf = __webpack_require__("e163");
var redefine = __webpack_require__("6eeb");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  redefine(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "aed9":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});


/***/ }),

/***/ "b041":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classof = __webpack_require__("f5df");

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "b044":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "b0b8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_datatable_vue_vue_type_style_index_0_id_2bb6b88c_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b044");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_datatable_vue_vue_type_style_index_0_id_2bb6b88c_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_datatable_vue_vue_type_style_index_0_id_2bb6b88c_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b0c0":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var FUNCTION_NAME_EXISTS = __webpack_require__("5e77").EXISTS;
var uncurryThis = __webpack_require__("e330");
var defineProperty = __webpack_require__("9bf2").f;

var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = uncurryThis(nameRE.exec);
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return regExpExec(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ "b29d":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var lo = moment.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ',
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function (number) {
            return 'ທີ່' + number;
        },
    });

    return lo;

})));


/***/ }),

/***/ "b386":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_video_message_vue_vue_type_style_index_0_id_22d5a220_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("830c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_video_message_vue_vue_type_style_index_0_id_22d5a220_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_video_message_vue_vue_type_style_index_0_id_22d5a220_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b3eb":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
            '_'
        ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deAt;

})));


/***/ }),

/***/ "b469":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
            '_'
        ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));


/***/ }),

/***/ "b53d":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzmLatn = moment.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzmLatn;

})));


/***/ }),

/***/ "b540":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var jv = moment.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return jv;

})));


/***/ }),

/***/ "b575":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var bind = __webpack_require__("0366");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var macrotask = __webpack_require__("2cf4").set;
var IS_IOS = __webpack_require__("1cdc");
var IS_IOS_PEBBLE = __webpack_require__("d4c3");
var IS_WEBOS_WEBKIT = __webpack_require__("a4b4");
var IS_NODE = __webpack_require__("605d");

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = bind(promise.then, promise);
    notify = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    // strange IE + webpack dev server bug - use .bind(global)
    macrotask = bind(macrotask, global);
    notify = function () {
      macrotask(flush);
    };
  }
}

module.exports = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};


/***/ }),

/***/ "b5b7":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Mexico) [es-mx]
//! author : JC Franco : https://github.com/jcfranco

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esMx = moment.defineLocale('es-mx', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return esMx;

})));


/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var hasOwn = __webpack_require__("1a2d");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var symbolFor = Symbol && Symbol['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b727":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("0366");
var uncurryThis = __webpack_require__("e330");
var IndexedObject = __webpack_require__("44ad");
var toObject = __webpack_require__("7b0b");
var lengthOfArrayLike = __webpack_require__("07fa");
var arraySpeciesCreate = __webpack_require__("65f0");

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ "b7e9":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Singapore) [en-sg]
//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enSg = moment.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enSg;

})));


/***/ }),

/***/ "b84c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! authors : https://github.com/mechuwind
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nn = moment.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            w: 'ei veke',
            ww: '%d veker',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nn;

})));


/***/ }),

/***/ "b97c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        h: 'stundas_stundām_stunda_stundas'.split('_'),
        hh: 'stundas_stundām_stunda_stundas'.split('_'),
        d: 'dienas_dienām_diena_dienas'.split('_'),
        dd: 'dienas_dienām_diena_dienas'.split('_'),
        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_'),
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
            '_'
        ),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lv;

})));


/***/ }),

/***/ "b980":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = !fails(function () {
  var error = Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});


/***/ }),

/***/ "bb71":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
            '_'
        ),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deCh;

})));


/***/ }),

/***/ "bbf9":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "bf19":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var call = __webpack_require__("c65b");

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$({ target: 'URL', proto: true, enumerable: true }, {
  toJSON: function toJSON() {
    return call(URL.prototype.toString, this);
  }
});


/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var isObject = __webpack_require__("861d");
var isSymbol = __webpack_require__("d9b5");
var getMethod = __webpack_require__("dc4a");
var ordinaryToPrimitive = __webpack_require__("485a");
var wellKnownSymbol = __webpack_require__("b622");

var TypeError = global.TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ "c109":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzm = moment.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzm;

})));


/***/ }),

/***/ "c1df":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.29.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    undefined
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                __webpack_require__("4678")("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("62e4")(module)))

/***/ }),

/***/ "c2b8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_tooltip_vue_vue_type_style_index_0_id_fc3075cc_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c92e");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_tooltip_vue_vue_type_style_index_0_id_fc3075cc_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_tooltip_vue_vue_type_style_index_0_id_fc3075cc_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c573":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_checkbox_vue_vue_type_style_index_0_id_7c1b07f3_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("67b1");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_checkbox_vue_vue_type_style_index_0_id_7c1b07f3_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_checkbox_vue_vue_type_style_index_0_id_7c1b07f3_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c607":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DESCRIPTORS = __webpack_require__("83ab");
var UNSUPPORTED_DOT_ALL = __webpack_require__("fce3");
var classof = __webpack_require__("c6b6");
var defineProperty = __webpack_require__("9bf2").f;
var getInternalState = __webpack_require__("69f3").get;

var RegExpPrototype = RegExp.prototype;
var TypeError = global.TypeError;

// `RegExp.prototype.dotAll` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.dotall
if (DESCRIPTORS && UNSUPPORTED_DOT_ALL) {
  defineProperty(RegExpPrototype, 'dotAll', {
    configurable: true,
    get: function () {
      if (this === RegExpPrototype) return undefined;
      // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.
      if (classof(this) === 'RegExp') {
        return !!getInternalState(this).dotAll;
      }
      throw TypeError('Incompatible receiver, RegExp required');
    }
  });
}


/***/ }),

/***/ "c65b":
/***/ (function(module, exports) {

var call = Function.prototype.call;

module.exports = call.bind ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ "c6b6":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var setGlobal = __webpack_require__("ce4e");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c770":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

var replace = uncurryThis(''.replace);

var TEST = (function (arg) { return String(Error(arg).stack); })('zxcasd');
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

module.exports = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string') {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};


/***/ }),

/***/ "c7aa":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var he = moment.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
            '_'
        ),
        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split(
            '_'
        ),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            },
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        },
    });

    return he;

})));


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "c8d2":
/***/ (function(module, exports, __webpack_require__) {

var PROPER_FUNCTION_NAME = __webpack_require__("5e77").PROPER;
var fails = __webpack_require__("d039");
var whitespaces = __webpack_require__("5899");

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};


/***/ }),

/***/ "c8f3":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sq = moment.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
            '_'
        ),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
            '_'
        ),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sq;

})));


/***/ }),

/***/ "c92e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "c9aa":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var hasOwn = __webpack_require__("1a2d");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cd54":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "cdf9":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var isObject = __webpack_require__("861d");
var newPromiseCapability = __webpack_require__("f069");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "ce4e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "cf1e":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jedne minute'],
            mm: ['minut', 'minute', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mesec', 'meseca', 'meseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sr;

})));


/***/ }),

/***/ "cf51":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function (input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? "d'o" : "D'O";
            } else {
                return isLower ? "d'a" : "D'A";
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['viensas secunds', "'iensas secunds"],
            ss: [number + ' secunds', '' + number + ' secunds'],
            m: ["'n míut", "'iens míut"],
            mm: [number + ' míuts', '' + number + ' míuts'],
            h: ["'n þora", "'iensa þora"],
            hh: [number + ' þoras', '' + number + ' þoras'],
            d: ["'n ziua", "'iensa ziua"],
            dd: [number + ' ziuas', '' + number + ' ziuas'],
            M: ["'n mes", "'iens mes"],
            MM: [number + ' mesen', '' + number + ' mesen'],
            y: ["'n ar", "'iens ar"],
            yy: [number + ' ars', '' + number + ' ars'],
        };
        return isFuture
            ? format[key][0]
            : withoutSuffix
            ? format[key][0]
            : format[key][1];
    }

    return tzl;

})));


/***/ }),

/***/ "cf75":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'leS'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'waQ'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'nem'
                : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'Hu’'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'wen'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'ben'
                : time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
            ten = Math.floor((number % 100) / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
            '_'
        ),
        monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L',
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate,
            m: 'wa’ tup',
            mm: translate,
            h: 'wa’ rep',
            hh: translate,
            d: 'wa’ jaj',
            dd: translate,
            M: 'wa’ jar',
            MM: translate,
            y: 'wa’ DIS',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlh;

})));


/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d07c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "d26a":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '༡',
            2: '༢',
            3: '༣',
            4: '༤',
            5: '༥',
            6: '༦',
            7: '༧',
            8: '༨',
            9: '༩',
            0: '༠',
        },
        numberMap = {
            '༡': '1',
            '༢': '2',
            '༣': '3',
            '༤': '4',
            '༥': '5',
            '༦': '6',
            '༧': '7',
            '༨': '8',
            '༩': '9',
            '༠': '0',
        };

    var bo = moment.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
            '_'
        ),
        monthsShort: 'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
            '_'
        ),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
            '_'
        ),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
            '_'
        ),
        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ',
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bo;

})));


/***/ }),

/***/ "d28b":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("746f");

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var uncurryThis = __webpack_require__("e330");
var anObject = __webpack_require__("825a");
var aPossiblePrototype = __webpack_require__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d2d4":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ptBr = moment.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
            '_'
        ),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        invalidDate: 'Data inválida',
    });

    return ptBr;

})));


/***/ }),

/***/ "d332":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "d3b7":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var redefine = __webpack_require__("6eeb");
var toString = __webpack_require__("b041");

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "d44e":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("9bf2").f;
var hasOwn = __webpack_require__("1a2d");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "d4c3":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");
var global = __webpack_require__("da84");

module.exports = /ipad|iphone|ipod/i.test(userAgent) && global.Pebble !== undefined;


/***/ }),

/***/ "d69a":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Filipino [fil]
//! author : Dan Hagman : https://github.com/hagmandan
//! author : Matthew Co : https://github.com/matthewdeeco

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fil = moment.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fil;

})));


/***/ }),

/***/ "d6b6":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var hyAm = moment.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
                '_'
            ),
            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
                '_'
            ),
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
            '_'
        ),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի',
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem: function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hyAm;

})));


/***/ }),

/***/ "d716":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ca = moment.defineLocale('ca', {
        months: {
            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
                '_'
            ),
            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function () {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function () {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [passat a ' +
                    (this.hours() !== 1 ? 'les' : 'la') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ca;

})));


/***/ }),

/***/ "d784":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__("ac1f");
var uncurryThis = __webpack_require__("e330");
var redefine = __webpack_require__("6eeb");
var regexpExec = __webpack_require__("9263");
var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var createNonEnumerableProperty = __webpack_require__("9112");

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    redefine(String.prototype, KEY, methods[0]);
    redefine(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ "d81d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $map = __webpack_require__("b727").map;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "d9b5":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var isCallable = __webpack_require__("1626");
var isPrototypeOf = __webpack_require__("3a9b");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var Object = global.Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, Object(it));
};


/***/ }),

/***/ "d9e2":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-unused-vars -- required for functions `.length` */
var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var apply = __webpack_require__("2ba4");
var wrapErrorConstructorWithCause = __webpack_require__("e5cb");

var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = global[WEB_ASSEMBLY];

var FORCED = Error('e', { cause: 7 }).cause !== 7;

var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED);
  $({ global: true, forced: FORCED }, O);
};

var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED);
    $({ target: WEB_ASSEMBLY, stat: true, forced: FORCED }, O);
  }
};

// https://github.com/tc39/proposal-error-cause
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) { return apply(init, this, arguments); };
});


/***/ }),

/***/ "d9f8":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    return frCa;

})));


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "db29":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
            '_'
        ),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
            '_'
        ),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nlBe;

})));


/***/ }),

/***/ "dbf0":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "dc4a":
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__("59ed");

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};


/***/ }),

/***/ "dc4d":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        },
        monthsParse = [
            /^जन/i,
            /^फ़र|फर/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सितं|सित/i,
            /^अक्टू/i,
            /^नव|नवं/i,
            /^दिसं|दिस/i,
        ],
        shortMonthsParse = [
            /^जन/i,
            /^फ़र/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सित/i,
            /^अक्टू/i,
            /^नव/i,
            /^दिस/i,
        ];

    var hi = moment.defineLocale('hi', {
        months: {
            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
                '_'
            ),
            standalone: 'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
                '_'
            ),
        },
        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split(
            '_'
        ),
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
        },

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: shortMonthsParse,

        monthsRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsShortRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsStrictRegex: /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,

        monthsShortStrictRegex: /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,

        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return hi;

})));


/***/ }),

/***/ "ddb0":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var DOMTokenListPrototype = __webpack_require__("785a");
var ArrayIteratorMethods = __webpack_require__("e260");
var createNonEnumerableProperty = __webpack_require__("9112");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),

/***/ "de75":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "df75":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "e01a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var hasOwn = __webpack_require__("1a2d");
var isCallable = __webpack_require__("1626");
var isPrototypeOf = __webpack_require__("3a9b");
var toString = __webpack_require__("577e");
var defineProperty = __webpack_require__("9bf2").f;
var copyConstructorProperties = __webpack_require__("e893");

var NativeSymbol = global.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var symbolToString = uncurryThis(SymbolPrototype.toString);
  var symbolValueOf = uncurryThis(SymbolPrototype.valueOf);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineProperty(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = symbolValueOf(this);
      var string = symbolToString(symbol);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "e0c5":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '૧',
            2: '૨',
            3: '૩',
            4: '૪',
            5: '૫',
            6: '૬',
            7: '૭',
            8: '૮',
            9: '૯',
            0: '૦',
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0',
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
            '_'
        ),
        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
            '_'
        ),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પહેલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ',
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return gu;

})));


/***/ }),

/***/ "e0f3":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e163":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var hasOwn = __webpack_require__("1a2d");
var isCallable = __webpack_require__("1626");
var toObject = __webpack_require__("7b0b");
var sharedKey = __webpack_require__("f772");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var IE_PROTO = sharedKey('IE_PROTO');
var Object = global.Object;
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "e166":
/***/ (function(module, exports, __webpack_require__) {

/*!
 * vue-infinite-loading v2.4.5
 * (c) 2016-2020 PeachScript
 * MIT License
 */
!function(t,e){ true?module.exports=e():undefined}(this,(function(){return function(t){var e={};function n(i){if(e[i])return e[i].exports;var a=e[i]={i:i,l:!1,exports:{}};return t[i].call(a.exports,a,a.exports,n),a.l=!0,a.exports}return n.m=t,n.c=e,n.d=function(t,e,i){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:i})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var i=Object.create(null);if(n.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var a in t)n.d(i,a,function(e){return t[e]}.bind(null,a));return i},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=9)}([function(t,e,n){var i=n(6);"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);(0,n(3).default)("6223ff68",i,!0,{})},function(t,e,n){var i=n(8);"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);(0,n(3).default)("27f0e51f",i,!0,{})},function(t,e){t.exports=function(t){var e=[];return e.toString=function(){return this.map((function(e){var n=function(t,e){var n=t[1]||"",i=t[3];if(!i)return n;if(e&&"function"==typeof btoa){var a=(o=i,"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(o))))+" */"),r=i.sources.map((function(t){return"/*# sourceURL="+i.sourceRoot+t+" */"}));return[n].concat(r).concat([a]).join("\n")}var o;return[n].join("\n")}(e,t);return e[2]?"@media "+e[2]+"{"+n+"}":n})).join("")},e.i=function(t,n){"string"==typeof t&&(t=[[null,t,""]]);for(var i={},a=0;a<this.length;a++){var r=this[a][0];"number"==typeof r&&(i[r]=!0)}for(a=0;a<t.length;a++){var o=t[a];"number"==typeof o[0]&&i[o[0]]||(n&&!o[2]?o[2]=n:n&&(o[2]="("+o[2]+") and ("+n+")"),e.push(o))}},e}},function(t,e,n){"use strict";function i(t,e){for(var n=[],i={},a=0;a<e.length;a++){var r=e[a],o=r[0],s={id:t+":"+a,css:r[1],media:r[2],sourceMap:r[3]};i[o]?i[o].parts.push(s):n.push(i[o]={id:o,parts:[s]})}return n}n.r(e),n.d(e,"default",(function(){return f}));var a="undefined"!=typeof document;if("undefined"!=typeof DEBUG&&DEBUG&&!a)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var r={},o=a&&(document.head||document.getElementsByTagName("head")[0]),s=null,l=0,d=!1,c=function(){},u=null,p="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());function f(t,e,n,a){d=n,u=a||{};var o=i(t,e);return b(o),function(e){for(var n=[],a=0;a<o.length;a++){var s=o[a];(l=r[s.id]).refs--,n.push(l)}e?b(o=i(t,e)):o=[];for(a=0;a<n.length;a++){var l;if(0===(l=n[a]).refs){for(var d=0;d<l.parts.length;d++)l.parts[d]();delete r[l.id]}}}}function b(t){for(var e=0;e<t.length;e++){var n=t[e],i=r[n.id];if(i){i.refs++;for(var a=0;a<i.parts.length;a++)i.parts[a](n.parts[a]);for(;a<n.parts.length;a++)i.parts.push(m(n.parts[a]));i.parts.length>n.parts.length&&(i.parts.length=n.parts.length)}else{var o=[];for(a=0;a<n.parts.length;a++)o.push(m(n.parts[a]));r[n.id]={id:n.id,refs:1,parts:o}}}}function h(){var t=document.createElement("style");return t.type="text/css",o.appendChild(t),t}function m(t){var e,n,i=document.querySelector('style[data-vue-ssr-id~="'+t.id+'"]');if(i){if(d)return c;i.parentNode.removeChild(i)}if(p){var a=l++;i=s||(s=h()),e=w.bind(null,i,a,!1),n=w.bind(null,i,a,!0)}else i=h(),e=y.bind(null,i),n=function(){i.parentNode.removeChild(i)};return e(t),function(i){if(i){if(i.css===t.css&&i.media===t.media&&i.sourceMap===t.sourceMap)return;e(t=i)}else n()}}var g,v=(g=[],function(t,e){return g[t]=e,g.filter(Boolean).join("\n")});function w(t,e,n,i){var a=n?"":i.css;if(t.styleSheet)t.styleSheet.cssText=v(e,a);else{var r=document.createTextNode(a),o=t.childNodes;o[e]&&t.removeChild(o[e]),o.length?t.insertBefore(r,o[e]):t.appendChild(r)}}function y(t,e){var n=e.css,i=e.media,a=e.sourceMap;if(i&&t.setAttribute("media",i),u.ssrId&&t.setAttribute("data-vue-ssr-id",e.id),a&&(n+="\n/*# sourceURL="+a.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(a))))+" */"),t.styleSheet)t.styleSheet.cssText=n;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(n))}}},function(t,e){function n(e){return"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?t.exports=n=function(t){return typeof t}:t.exports=n=function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},n(e)}t.exports=n},function(t,e,n){"use strict";n.r(e);var i=n(0),a=n.n(i);for(var r in i)"default"!==r&&function(t){n.d(e,t,(function(){return i[t]}))}(r);e.default=a.a},function(t,e,n){(t.exports=n(2)(!1)).push([t.i,'.loading-wave-dots[data-v-46b20d22]{position:relative}.loading-wave-dots[data-v-46b20d22] .wave-item{position:absolute;top:50%;left:50%;display:inline-block;margin-top:-4px;width:8px;height:8px;border-radius:50%;-webkit-animation:loading-wave-dots-data-v-46b20d22 linear 2.8s infinite;animation:loading-wave-dots-data-v-46b20d22 linear 2.8s infinite}.loading-wave-dots[data-v-46b20d22] .wave-item:first-child{margin-left:-36px}.loading-wave-dots[data-v-46b20d22] .wave-item:nth-child(2){margin-left:-20px;-webkit-animation-delay:.14s;animation-delay:.14s}.loading-wave-dots[data-v-46b20d22] .wave-item:nth-child(3){margin-left:-4px;-webkit-animation-delay:.28s;animation-delay:.28s}.loading-wave-dots[data-v-46b20d22] .wave-item:nth-child(4){margin-left:12px;-webkit-animation-delay:.42s;animation-delay:.42s}.loading-wave-dots[data-v-46b20d22] .wave-item:last-child{margin-left:28px;-webkit-animation-delay:.56s;animation-delay:.56s}@-webkit-keyframes loading-wave-dots-data-v-46b20d22{0%{-webkit-transform:translateY(0);transform:translateY(0);background:#bbb}10%{-webkit-transform:translateY(-6px);transform:translateY(-6px);background:#999}20%{-webkit-transform:translateY(0);transform:translateY(0);background:#bbb}to{-webkit-transform:translateY(0);transform:translateY(0);background:#bbb}}@keyframes loading-wave-dots-data-v-46b20d22{0%{-webkit-transform:translateY(0);transform:translateY(0);background:#bbb}10%{-webkit-transform:translateY(-6px);transform:translateY(-6px);background:#999}20%{-webkit-transform:translateY(0);transform:translateY(0);background:#bbb}to{-webkit-transform:translateY(0);transform:translateY(0);background:#bbb}}.loading-circles[data-v-46b20d22] .circle-item{width:5px;height:5px;-webkit-animation:loading-circles-data-v-46b20d22 linear .75s infinite;animation:loading-circles-data-v-46b20d22 linear .75s infinite}.loading-circles[data-v-46b20d22] .circle-item:first-child{margin-top:-14.5px;margin-left:-2.5px}.loading-circles[data-v-46b20d22] .circle-item:nth-child(2){margin-top:-11.26px;margin-left:6.26px}.loading-circles[data-v-46b20d22] .circle-item:nth-child(3){margin-top:-2.5px;margin-left:9.5px}.loading-circles[data-v-46b20d22] .circle-item:nth-child(4){margin-top:6.26px;margin-left:6.26px}.loading-circles[data-v-46b20d22] .circle-item:nth-child(5){margin-top:9.5px;margin-left:-2.5px}.loading-circles[data-v-46b20d22] .circle-item:nth-child(6){margin-top:6.26px;margin-left:-11.26px}.loading-circles[data-v-46b20d22] .circle-item:nth-child(7){margin-top:-2.5px;margin-left:-14.5px}.loading-circles[data-v-46b20d22] .circle-item:last-child{margin-top:-11.26px;margin-left:-11.26px}@-webkit-keyframes loading-circles-data-v-46b20d22{0%{background:#dfdfdf}90%{background:#505050}to{background:#dfdfdf}}@keyframes loading-circles-data-v-46b20d22{0%{background:#dfdfdf}90%{background:#505050}to{background:#dfdfdf}}.loading-bubbles[data-v-46b20d22] .bubble-item{background:#666;-webkit-animation:loading-bubbles-data-v-46b20d22 linear .75s infinite;animation:loading-bubbles-data-v-46b20d22 linear .75s infinite}.loading-bubbles[data-v-46b20d22] .bubble-item:first-child{margin-top:-12.5px;margin-left:-.5px}.loading-bubbles[data-v-46b20d22] .bubble-item:nth-child(2){margin-top:-9.26px;margin-left:8.26px}.loading-bubbles[data-v-46b20d22] .bubble-item:nth-child(3){margin-top:-.5px;margin-left:11.5px}.loading-bubbles[data-v-46b20d22] .bubble-item:nth-child(4){margin-top:8.26px;margin-left:8.26px}.loading-bubbles[data-v-46b20d22] .bubble-item:nth-child(5){margin-top:11.5px;margin-left:-.5px}.loading-bubbles[data-v-46b20d22] .bubble-item:nth-child(6){margin-top:8.26px;margin-left:-9.26px}.loading-bubbles[data-v-46b20d22] .bubble-item:nth-child(7){margin-top:-.5px;margin-left:-12.5px}.loading-bubbles[data-v-46b20d22] .bubble-item:last-child{margin-top:-9.26px;margin-left:-9.26px}@-webkit-keyframes loading-bubbles-data-v-46b20d22{0%{width:1px;height:1px;box-shadow:0 0 0 3px #666}90%{width:1px;height:1px;box-shadow:0 0 0 0 #666}to{width:1px;height:1px;box-shadow:0 0 0 3px #666}}@keyframes loading-bubbles-data-v-46b20d22{0%{width:1px;height:1px;box-shadow:0 0 0 3px #666}90%{width:1px;height:1px;box-shadow:0 0 0 0 #666}to{width:1px;height:1px;box-shadow:0 0 0 3px #666}}.loading-default[data-v-46b20d22]{position:relative;border:1px solid #999;-webkit-animation:loading-rotating-data-v-46b20d22 ease 1.5s infinite;animation:loading-rotating-data-v-46b20d22 ease 1.5s infinite}.loading-default[data-v-46b20d22]:before{content:"";position:absolute;display:block;top:0;left:50%;margin-top:-3px;margin-left:-3px;width:6px;height:6px;background-color:#999;border-radius:50%}.loading-spiral[data-v-46b20d22]{border:2px solid #777;border-right-color:transparent;-webkit-animation:loading-rotating-data-v-46b20d22 linear .85s infinite;animation:loading-rotating-data-v-46b20d22 linear .85s infinite}@-webkit-keyframes loading-rotating-data-v-46b20d22{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes loading-rotating-data-v-46b20d22{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.loading-bubbles[data-v-46b20d22],.loading-circles[data-v-46b20d22]{position:relative}.loading-bubbles[data-v-46b20d22] .bubble-item,.loading-circles[data-v-46b20d22] .circle-item{position:absolute;top:50%;left:50%;display:inline-block;border-radius:50%}.loading-bubbles[data-v-46b20d22] .bubble-item:nth-child(2),.loading-circles[data-v-46b20d22] .circle-item:nth-child(2){-webkit-animation-delay:93ms;animation-delay:93ms}.loading-bubbles[data-v-46b20d22] .bubble-item:nth-child(3),.loading-circles[data-v-46b20d22] .circle-item:nth-child(3){-webkit-animation-delay:.186s;animation-delay:.186s}.loading-bubbles[data-v-46b20d22] .bubble-item:nth-child(4),.loading-circles[data-v-46b20d22] .circle-item:nth-child(4){-webkit-animation-delay:.279s;animation-delay:.279s}.loading-bubbles[data-v-46b20d22] .bubble-item:nth-child(5),.loading-circles[data-v-46b20d22] .circle-item:nth-child(5){-webkit-animation-delay:.372s;animation-delay:.372s}.loading-bubbles[data-v-46b20d22] .bubble-item:nth-child(6),.loading-circles[data-v-46b20d22] .circle-item:nth-child(6){-webkit-animation-delay:.465s;animation-delay:.465s}.loading-bubbles[data-v-46b20d22] .bubble-item:nth-child(7),.loading-circles[data-v-46b20d22] .circle-item:nth-child(7){-webkit-animation-delay:.558s;animation-delay:.558s}.loading-bubbles[data-v-46b20d22] .bubble-item:last-child,.loading-circles[data-v-46b20d22] .circle-item:last-child{-webkit-animation-delay:.651s;animation-delay:.651s}',""])},function(t,e,n){"use strict";n.r(e);var i=n(1),a=n.n(i);for(var r in i)"default"!==r&&function(t){n.d(e,t,(function(){return i[t]}))}(r);e.default=a.a},function(t,e,n){(t.exports=n(2)(!1)).push([t.i,".infinite-loading-container[data-v-644ea9c9]{clear:both;text-align:center}.infinite-loading-container[data-v-644ea9c9] [class^=loading-]{display:inline-block;margin:5px 0;width:28px;height:28px;font-size:28px;line-height:28px;border-radius:50%}.btn-try-infinite[data-v-644ea9c9]{margin-top:5px;padding:5px 10px;color:#999;font-size:14px;line-height:1;background:transparent;border:1px solid #ccc;border-radius:3px;outline:none;cursor:pointer}.btn-try-infinite[data-v-644ea9c9]:not(:active):hover{opacity:.8}",""])},function(t,e,n){"use strict";n.r(e);var i={throttleLimit:50,loopCheckTimeout:1e3,loopCheckMaxCalls:10},a=function(){var t=!1;try{var e=Object.defineProperty({},"passive",{get:function(){return t={passive:!0},!0}});window.addEventListener("testpassive",e,e),window.remove("testpassive",e,e)}catch(t){}return t}(),r={STATE_CHANGER:["emit `loaded` and `complete` event through component instance of `$refs` may cause error, so it will be deprecated soon, please use the `$state` argument instead (`$state` just the special `$event` variable):","\ntemplate:",'<infinite-loading @infinite="infiniteHandler"></infinite-loading>',"\nscript:\n...\ninfiniteHandler($state) {\n  ajax('https://www.example.com/api/news')\n    .then((res) => {\n      if (res.data.length) {\n        $state.loaded();\n      } else {\n        $state.complete();\n      }\n    });\n}\n...","","more details: https://github.com/PeachScript/vue-infinite-loading/issues/57#issuecomment-324370549"].join("\n"),INFINITE_EVENT:"`:on-infinite` property will be deprecated soon, please use `@infinite` event instead.",IDENTIFIER:"the `reset` event will be deprecated soon, please reset this component by change the `identifier` property."},o={INFINITE_LOOP:["executed the callback function more than ".concat(i.loopCheckMaxCalls," times for a short time, it looks like searched a wrong scroll wrapper that doest not has fixed height or maximum height, please check it. If you want to force to set a element as scroll wrapper ranther than automatic searching, you can do this:"),'\n\x3c!-- add a special attribute for the real scroll wrapper --\x3e\n<div infinite-wrapper>\n  ...\n  \x3c!-- set force-use-infinite-wrapper --\x3e\n  <infinite-loading force-use-infinite-wrapper></infinite-loading>\n</div>\nor\n<div class="infinite-wrapper">\n  ...\n  \x3c!-- set force-use-infinite-wrapper as css selector of the real scroll wrapper --\x3e\n  <infinite-loading force-use-infinite-wrapper=".infinite-wrapper"></infinite-loading>\n</div>\n    ',"more details: https://github.com/PeachScript/vue-infinite-loading/issues/55#issuecomment-316934169"].join("\n")},s={READY:0,LOADING:1,COMPLETE:2,ERROR:3},l={color:"#666",fontSize:"14px",padding:"10px 0"},d={mode:"development",props:{spinner:"default",distance:100,forceUseInfiniteWrapper:!1},system:i,slots:{noResults:"No results :(",noMore:"No more data :)",error:"Opps, something went wrong :(",errorBtnText:"Retry",spinner:""},WARNINGS:r,ERRORS:o,STATUS:s},c=n(4),u=n.n(c),p={BUBBLES:{render:function(t){return t("span",{attrs:{class:"loading-bubbles"}},Array.apply(Array,Array(8)).map((function(){return t("span",{attrs:{class:"bubble-item"}})})))}},CIRCLES:{render:function(t){return t("span",{attrs:{class:"loading-circles"}},Array.apply(Array,Array(8)).map((function(){return t("span",{attrs:{class:"circle-item"}})})))}},DEFAULT:{render:function(t){return t("i",{attrs:{class:"loading-default"}})}},SPIRAL:{render:function(t){return t("i",{attrs:{class:"loading-spiral"}})}},WAVEDOTS:{render:function(t){return t("span",{attrs:{class:"loading-wave-dots"}},Array.apply(Array,Array(5)).map((function(){return t("span",{attrs:{class:"wave-item"}})})))}}};function f(t,e,n,i,a,r,o,s){var l,d="function"==typeof t?t.options:t;if(e&&(d.render=e,d.staticRenderFns=n,d._compiled=!0),i&&(d.functional=!0),r&&(d._scopeId="data-v-"+r),o?(l=function(t){(t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),a&&a.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(o)},d._ssrRegister=l):a&&(l=s?function(){a.call(this,this.$root.$options.shadowRoot)}:a),l)if(d.functional){d._injectStyles=l;var c=d.render;d.render=function(t,e){return l.call(e),c(t,e)}}else{var u=d.beforeCreate;d.beforeCreate=u?[].concat(u,l):[l]}return{exports:t,options:d}}var b=f({name:"Spinner",computed:{spinnerView:function(){return p[(this.$attrs.spinner||"").toUpperCase()]||this.spinnerInConfig},spinnerInConfig:function(){return d.slots.spinner&&"string"==typeof d.slots.spinner?{render:function(){return this._v(d.slots.spinner)}}:"object"===u()(d.slots.spinner)?d.slots.spinner:p[d.props.spinner.toUpperCase()]||p.DEFAULT}}},(function(){var t=this.$createElement;return(this._self._c||t)(this.spinnerView,{tag:"component"})}),[],!1,(function(t){var e=n(5);e.__inject__&&e.__inject__(t)}),"46b20d22",null).exports;function h(t){"production"!==d.mode&&console.warn("[Vue-infinite-loading warn]: ".concat(t))}function m(t){console.error("[Vue-infinite-loading error]: ".concat(t))}var g={timers:[],caches:[],throttle:function(t){var e=this;-1===this.caches.indexOf(t)&&(this.caches.push(t),this.timers.push(setTimeout((function(){t(),e.caches.splice(e.caches.indexOf(t),1),e.timers.shift()}),d.system.throttleLimit)))},reset:function(){this.timers.forEach((function(t){clearTimeout(t)})),this.timers.length=0,this.caches=[]}},v={isChecked:!1,timer:null,times:0,track:function(){var t=this;this.times+=1,clearTimeout(this.timer),this.timer=setTimeout((function(){t.isChecked=!0}),d.system.loopCheckTimeout),this.times>d.system.loopCheckMaxCalls&&(m(o.INFINITE_LOOP),this.isChecked=!0)}},w={key:"_infiniteScrollHeight",getScrollElm:function(t){return t===window?document.documentElement:t},save:function(t){var e=this.getScrollElm(t);e[this.key]=e.scrollHeight},restore:function(t){var e=this.getScrollElm(t);"number"==typeof e[this.key]&&(e.scrollTop=e.scrollHeight-e[this.key]+e.scrollTop),this.remove(e)},remove:function(t){void 0!==t[this.key]&&delete t[this.key]}};function y(t){return t.replace(/[A-Z]/g,(function(t){return"-".concat(t.toLowerCase())}))}function x(t){return t.offsetWidth+t.offsetHeight>0}var k=f({name:"InfiniteLoading",data:function(){return{scrollParent:null,scrollHandler:null,isFirstLoad:!0,status:s.READY,slots:d.slots}},components:{Spinner:b},computed:{isShowSpinner:function(){return this.status===s.LOADING},isShowError:function(){return this.status===s.ERROR},isShowNoResults:function(){return this.status===s.COMPLETE&&this.isFirstLoad},isShowNoMore:function(){return this.status===s.COMPLETE&&!this.isFirstLoad},slotStyles:function(){var t=this,e={};return Object.keys(d.slots).forEach((function(n){var i=y(n);(!t.$slots[i]&&!d.slots[n].render||t.$slots[i]&&!t.$slots[i][0].tag)&&(e[n]=l)})),e}},props:{distance:{type:Number,default:d.props.distance},spinner:String,direction:{type:String,default:"bottom"},forceUseInfiniteWrapper:{type:[Boolean,String],default:d.props.forceUseInfiniteWrapper},identifier:{default:+new Date},onInfinite:Function},watch:{identifier:function(){this.stateChanger.reset()}},mounted:function(){var t=this;this.$watch("forceUseInfiniteWrapper",(function(){t.scrollParent=t.getScrollParent()}),{immediate:!0}),this.scrollHandler=function(e){t.status===s.READY&&(e&&e.constructor===Event&&x(t.$el)?g.throttle(t.attemptLoad):t.attemptLoad())},setTimeout((function(){t.scrollHandler(),t.scrollParent.addEventListener("scroll",t.scrollHandler,a)}),1),this.$on("$InfiniteLoading:loaded",(function(e){t.isFirstLoad=!1,"top"===t.direction&&t.$nextTick((function(){w.restore(t.scrollParent)})),t.status===s.LOADING&&t.$nextTick(t.attemptLoad.bind(null,!0)),e&&e.target===t||h(r.STATE_CHANGER)})),this.$on("$InfiniteLoading:complete",(function(e){t.status=s.COMPLETE,t.$nextTick((function(){t.$forceUpdate()})),t.scrollParent.removeEventListener("scroll",t.scrollHandler,a),e&&e.target===t||h(r.STATE_CHANGER)})),this.$on("$InfiniteLoading:reset",(function(e){t.status=s.READY,t.isFirstLoad=!0,w.remove(t.scrollParent),t.scrollParent.addEventListener("scroll",t.scrollHandler,a),setTimeout((function(){g.reset(),t.scrollHandler()}),1),e&&e.target===t||h(r.IDENTIFIER)})),this.stateChanger={loaded:function(){t.$emit("$InfiniteLoading:loaded",{target:t})},complete:function(){t.$emit("$InfiniteLoading:complete",{target:t})},reset:function(){t.$emit("$InfiniteLoading:reset",{target:t})},error:function(){t.status=s.ERROR,g.reset()}},this.onInfinite&&h(r.INFINITE_EVENT)},deactivated:function(){this.status===s.LOADING&&(this.status=s.READY),this.scrollParent.removeEventListener("scroll",this.scrollHandler,a)},activated:function(){this.scrollParent.addEventListener("scroll",this.scrollHandler,a)},methods:{attemptLoad:function(t){var e=this;this.status!==s.COMPLETE&&x(this.$el)&&this.getCurrentDistance()<=this.distance?(this.status=s.LOADING,"top"===this.direction&&this.$nextTick((function(){w.save(e.scrollParent)})),"function"==typeof this.onInfinite?this.onInfinite.call(null,this.stateChanger):this.$emit("infinite",this.stateChanger),!t||this.forceUseInfiniteWrapper||v.isChecked||v.track()):this.status===s.LOADING&&(this.status=s.READY)},getCurrentDistance:function(){var t;"top"===this.direction?t="number"==typeof this.scrollParent.scrollTop?this.scrollParent.scrollTop:this.scrollParent.pageYOffset:t=this.$el.getBoundingClientRect().top-(this.scrollParent===window?window.innerHeight:this.scrollParent.getBoundingClientRect().bottom);return t},getScrollParent:function(){var t,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.$el;return"string"==typeof this.forceUseInfiniteWrapper&&(t=document.querySelector(this.forceUseInfiniteWrapper)),t||("BODY"===e.tagName?t=window:!this.forceUseInfiniteWrapper&&["scroll","auto"].indexOf(getComputedStyle(e).overflowY)>-1?t=e:(e.hasAttribute("infinite-wrapper")||e.hasAttribute("data-infinite-wrapper"))&&(t=e)),t||this.getScrollParent(e.parentNode)}},destroyed:function(){!this.status!==s.COMPLETE&&(g.reset(),w.remove(this.scrollParent),this.scrollParent.removeEventListener("scroll",this.scrollHandler,a))}},(function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"infinite-loading-container"},[n("div",{directives:[{name:"show",rawName:"v-show",value:t.isShowSpinner,expression:"isShowSpinner"}],staticClass:"infinite-status-prompt",style:t.slotStyles.spinner},[t._t("spinner",[n("spinner",{attrs:{spinner:t.spinner}})])],2),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:t.isShowNoResults,expression:"isShowNoResults"}],staticClass:"infinite-status-prompt",style:t.slotStyles.noResults},[t._t("no-results",[t.slots.noResults.render?n(t.slots.noResults,{tag:"component"}):[t._v(t._s(t.slots.noResults))]])],2),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:t.isShowNoMore,expression:"isShowNoMore"}],staticClass:"infinite-status-prompt",style:t.slotStyles.noMore},[t._t("no-more",[t.slots.noMore.render?n(t.slots.noMore,{tag:"component"}):[t._v(t._s(t.slots.noMore))]])],2),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:t.isShowError,expression:"isShowError"}],staticClass:"infinite-status-prompt",style:t.slotStyles.error},[t._t("error",[t.slots.error.render?n(t.slots.error,{tag:"component",attrs:{trigger:t.attemptLoad}}):[t._v("\n        "+t._s(t.slots.error)+"\n        "),n("br"),t._v(" "),n("button",{staticClass:"btn-try-infinite",domProps:{textContent:t._s(t.slots.errorBtnText)},on:{click:t.attemptLoad}})]],{trigger:t.attemptLoad})],2)])}),[],!1,(function(t){var e=n(7);e.__inject__&&e.__inject__(t)}),"644ea9c9",null).exports;function E(t){d.mode=t.config.productionTip?"development":"production"}Object.defineProperty(k,"install",{configurable:!1,enumerable:!1,value:function(t,e){Object.assign(d.props,e&&e.props),Object.assign(d.slots,e&&e.slots),Object.assign(d.system,e&&e.system),t.component("infinite-loading",k),E(t)}}),"undefined"!=typeof window&&window.Vue&&(window.Vue.component("infinite-loading",k),E(window.Vue));e.default=k}])}));

/***/ }),

/***/ "e177":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "e19a":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e1d3":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enIe;

})));


/***/ }),

/***/ "e260":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("fc6a");
var addToUnscopables = __webpack_require__("44d2");
var Iterators = __webpack_require__("3f8c");
var InternalStateModule = __webpack_require__("69f3");
var defineProperty = __webpack_require__("9bf2").f;
var defineIterator = __webpack_require__("7dd0");
var IS_PURE = __webpack_require__("c430");
var DESCRIPTORS = __webpack_require__("83ab");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }


/***/ }),

/***/ "e2cc":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("6eeb");

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ "e30c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e330":
/***/ (function(module, exports) {

var FunctionPrototype = Function.prototype;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;
var uncurryThis = bind && bind.bind(call, call);

module.exports = bind ? function (fn) {
  return fn && uncurryThis(fn);
} : function (fn) {
  return fn && function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ "e391":
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__("577e");

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};


/***/ }),

/***/ "e538":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "e5cb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("d066");
var hasOwn = __webpack_require__("1a2d");
var createNonEnumerableProperty = __webpack_require__("9112");
var isPrototypeOf = __webpack_require__("3a9b");
var setPrototypeOf = __webpack_require__("d2bb");
var copyConstructorProperties = __webpack_require__("e893");
var inheritIfRequired = __webpack_require__("7156");
var normalizeStringArgument = __webpack_require__("e391");
var installErrorCause = __webpack_require__("ab36");
var clearErrorStack = __webpack_require__("c770");
var ERROR_STACK_INSTALLABLE = __webpack_require__("b980");
var IS_PURE = __webpack_require__("c430");

module.exports = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn.apply(null, path);

  if (!OriginalError) return;

  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if (!IS_PURE && hasOwn(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;

  if (!FORCED) return OriginalError;

  var BaseError = getBuiltIn('Error');

  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
    if (ERROR_STACK_INSTALLABLE) createNonEnumerableProperty(result, 'stack', clearErrorStack(result.stack, 2));
    if (this && isPrototypeOf(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });

  WrappedError.prototype = OriginalErrorPrototype;

  if (ERROR_NAME !== 'Error') {
    if (setPrototypeOf) setPrototypeOf(WrappedError, BaseError);
    else copyConstructorProperties(WrappedError, BaseError, { name: true });
  }

  copyConstructorProperties(WrappedError, OriginalError);

  if (!IS_PURE) try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) { /* empty */ }

  return WrappedError;
};


/***/ }),

/***/ "e667":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ "e6cf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var IS_PURE = __webpack_require__("c430");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var call = __webpack_require__("c65b");
var NativePromise = __webpack_require__("fea9");
var redefine = __webpack_require__("6eeb");
var redefineAll = __webpack_require__("e2cc");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var setSpecies = __webpack_require__("2626");
var aCallable = __webpack_require__("59ed");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");
var anInstance = __webpack_require__("19aa");
var inspectSource = __webpack_require__("8925");
var iterate = __webpack_require__("2266");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");
var speciesConstructor = __webpack_require__("4840");
var task = __webpack_require__("2cf4").set;
var microtask = __webpack_require__("b575");
var promiseResolve = __webpack_require__("cdf9");
var hostReportErrors = __webpack_require__("44de");
var newPromiseCapabilityModule = __webpack_require__("f069");
var perform = __webpack_require__("e667");
var Queue = __webpack_require__("01b4");
var InternalStateModule = __webpack_require__("69f3");
var isForced = __webpack_require__("94ca");
var wellKnownSymbol = __webpack_require__("b622");
var IS_BROWSER = __webpack_require__("6069");
var IS_NODE = __webpack_require__("605d");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');
var PROMISE = 'Promise';

var getInternalState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var NativePromisePrototype = NativePromise && NativePromise.prototype;
var PromiseConstructor = NativePromise;
var PromisePrototype = NativePromisePrototype;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var NATIVE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var SUBCLASSING = false;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED = isForced(PROMISE, function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#finally in the pure version for preventing prototype pollution
  if (IS_PURE && !PromisePrototype['finally']) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = new PromiseConstructor(function (resolve) { resolve(1); });
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
  if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    call(Internal, this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };
  PromisePrototype = PromiseConstructor.prototype;
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromisePrototype, {
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    // eslint-disable-next-line unicorn/no-thenable -- safe
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      state.parent = true;
      reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
      reaction.fail = isCallable(onRejected) && onRejected;
      reaction.domain = IS_NODE ? process.domain : undefined;
      if (state.state == PENDING) state.reactions.add(reaction);
      else microtask(function () {
        callReaction(reaction, state);
      });
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && isCallable(NativePromise) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      redefine(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });

      // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
      redefine(NativePromisePrototype, 'catch', PromisePrototype['catch'], { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

$({ global: true, wrap: true, forced: FORCED }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
$({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.es/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    call(capability.reject, undefined, r);
    return capability.promise;
  }
});

$({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
  // `Promise.resolve` method
  // https://tc39.es/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
  }
});

$({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.es/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.es/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "e81d":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '១',
            2: '២',
            3: '៣',
            4: '៤',
            5: '៥',
            6: '៦',
            7: '៧',
            8: '៨',
            9: '៩',
            0: '០',
        },
        numberMap = {
            '១': '1',
            '២': '2',
            '៣': '3',
            '៤': '4',
            '៥': '5',
            '៦': '6',
            '៧': '7',
            '៨': '8',
            '៩': '9',
            '០': '0',
        };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ',
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return km;

})));


/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__("1a2d");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ "e8b5":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),

/***/ "e95a":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "e980":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e9c4":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var apply = __webpack_require__("2ba4");
var uncurryThis = __webpack_require__("e330");
var fails = __webpack_require__("d039");

var Array = global.Array;
var $stringify = getBuiltIn('JSON', 'stringify');
var exec = uncurryThis(/./.exec);
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var replace = uncurryThis(''.replace);
var numberToString = uncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var fix = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  } return match;
};

var FORCED = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  // https://github.com/tc39/proposal-well-formed-stringify
  $({ target: 'JSON', stat: true, forced: FORCED }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      for (var i = 0, l = arguments.length, args = Array(l); i < l; i++) args[i] = arguments[i];
      var result = apply($stringify, null, args);
      return typeof result == 'string' ? replace(result, tester, fix) : result;
    }
  });
}


/***/ }),

/***/ "eae0":
/***/ (function(module, exports, __webpack_require__) {

/*! Pickr 1.8.2 MIT | https://github.com/Simonwep/pickr */
!function(t,e){ true?module.exports=e():undefined}(self,(function(){return(()=>{"use strict";var t={d:(e,o)=>{for(var n in o)t.o(o,n)&&!t.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:o[n]})},o:(t,e)=>Object.prototype.hasOwnProperty.call(t,e),r:t=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})}},e={};t.d(e,{default:()=>L});var o={};function n(t,e,o,n,i={}){e instanceof HTMLCollection||e instanceof NodeList?e=Array.from(e):Array.isArray(e)||(e=[e]),Array.isArray(o)||(o=[o]);for(const s of e)for(const e of o)s[t](e,n,{capture:!1,...i});return Array.prototype.slice.call(arguments,1)}t.r(o),t.d(o,{adjustableInputNumbers:()=>p,createElementFromString:()=>r,createFromTemplate:()=>a,eventPath:()=>l,off:()=>s,on:()=>i,resolveElement:()=>c});const i=n.bind(null,"addEventListener"),s=n.bind(null,"removeEventListener");function r(t){const e=document.createElement("div");return e.innerHTML=t.trim(),e.firstElementChild}function a(t){const e=(t,e)=>{const o=t.getAttribute(e);return t.removeAttribute(e),o},o=(t,n={})=>{const i=e(t,":obj"),s=e(t,":ref"),r=i?n[i]={}:n;s&&(n[s]=t);for(const n of Array.from(t.children)){const t=e(n,":arr"),i=o(n,t?{}:r);t&&(r[t]||(r[t]=[])).push(Object.keys(i).length?i:n)}return n};return o(r(t))}function l(t){let e=t.path||t.composedPath&&t.composedPath();if(e)return e;let o=t.target.parentElement;for(e=[t.target,o];o=o.parentElement;)e.push(o);return e.push(document,window),e}function c(t){return t instanceof Element?t:"string"==typeof t?t.split(/>>/g).reduce(((t,e,o,n)=>(t=t.querySelector(e),o<n.length-1?t.shadowRoot:t)),document):null}function p(t,e=(t=>t)){function o(o){const n=[.001,.01,.1][Number(o.shiftKey||2*o.ctrlKey)]*(o.deltaY<0?1:-1);let i=0,s=t.selectionStart;t.value=t.value.replace(/[\d.]+/g,((t,o)=>o<=s&&o+t.length>=s?(s=o,e(Number(t),n,i)):(i++,t))),t.focus(),t.setSelectionRange(s,s),o.preventDefault(),t.dispatchEvent(new Event("input"))}i(t,"focus",(()=>i(window,"wheel",o,{passive:!1}))),i(t,"blur",(()=>s(window,"wheel",o)))}const{min:u,max:h,floor:d,round:m}=Math;function f(t,e,o){e/=100,o/=100;const n=d(t=t/360*6),i=t-n,s=o*(1-e),r=o*(1-i*e),a=o*(1-(1-i)*e),l=n%6;return[255*[o,r,s,s,a,o][l],255*[a,o,o,r,s,s][l],255*[s,s,a,o,o,r][l]]}function v(t,e,o){const n=(2-(e/=100))*(o/=100)/2;return 0!==n&&(e=1===n?0:n<.5?e*o/(2*n):e*o/(2-2*n)),[t,100*e,100*n]}function b(t,e,o){const n=u(t/=255,e/=255,o/=255),i=h(t,e,o),s=i-n;let r,a;if(0===s)r=a=0;else{a=s/i;const n=((i-t)/6+s/2)/s,l=((i-e)/6+s/2)/s,c=((i-o)/6+s/2)/s;t===i?r=c-l:e===i?r=1/3+n-c:o===i&&(r=2/3+l-n),r<0?r+=1:r>1&&(r-=1)}return[360*r,100*a,100*i]}function y(t,e,o,n){e/=100,o/=100;return[...b(255*(1-u(1,(t/=100)*(1-(n/=100))+n)),255*(1-u(1,e*(1-n)+n)),255*(1-u(1,o*(1-n)+n)))]}function g(t,e,o){e/=100;const n=2*(e*=(o/=100)<.5?o:1-o)/(o+e)*100,i=100*(o+e);return[t,isNaN(n)?0:n,i]}function _(t){return b(...t.match(/.{2}/g).map((t=>parseInt(t,16))))}function w(t){t=t.match(/^[a-zA-Z]+$/)?function(t){if("black"===t.toLowerCase())return"#000";const e=document.createElement("canvas").getContext("2d");return e.fillStyle=t,"#000"===e.fillStyle?null:e.fillStyle}(t):t;const e={cmyk:/^cmyk[\D]+([\d.]+)[\D]+([\d.]+)[\D]+([\d.]+)[\D]+([\d.]+)/i,rgba:/^((rgba)|rgb)[\D]+([\d.]+)[\D]+([\d.]+)[\D]+([\d.]+)[\D]*?([\d.]+|$)/i,hsla:/^((hsla)|hsl)[\D]+([\d.]+)[\D]+([\d.]+)[\D]+([\d.]+)[\D]*?([\d.]+|$)/i,hsva:/^((hsva)|hsv)[\D]+([\d.]+)[\D]+([\d.]+)[\D]+([\d.]+)[\D]*?([\d.]+|$)/i,hexa:/^#?(([\dA-Fa-f]{3,4})|([\dA-Fa-f]{6})|([\dA-Fa-f]{8}))$/i},o=t=>t.map((t=>/^(|\d+)\.\d+|\d+$/.test(t)?Number(t):void 0));let n;t:for(const i in e){if(!(n=e[i].exec(t)))continue;const s=t=>!!n[2]==("number"==typeof t);switch(i){case"cmyk":{const[,t,e,s,r]=o(n);if(t>100||e>100||s>100||r>100)break t;return{values:y(t,e,s,r),type:i}}case"rgba":{const[,,,t,e,r,a]=o(n);if(t>255||e>255||r>255||a<0||a>1||!s(a))break t;return{values:[...b(t,e,r),a],a,type:i}}case"hexa":{let[,t]=n;4!==t.length&&3!==t.length||(t=t.split("").map((t=>t+t)).join(""));const e=t.substring(0,6);let o=t.substring(6);return o=o?parseInt(o,16)/255:void 0,{values:[..._(e),o],a:o,type:i}}case"hsla":{const[,,,t,e,r,a]=o(n);if(t>360||e>100||r>100||a<0||a>1||!s(a))break t;return{values:[...g(t,e,r),a],a,type:i}}case"hsva":{const[,,,t,e,r,a]=o(n);if(t>360||e>100||r>100||a<0||a>1||!s(a))break t;return{values:[t,e,r,a],a,type:i}}}}return{values:null,type:null}}function A(t=0,e=0,o=0,n=1){const i=(t,e)=>(o=-1)=>e(~o?t.map((t=>Number(t.toFixed(o)))):t),s={h:t,s:e,v:o,a:n,toHSVA(){const t=[s.h,s.s,s.v,s.a];return t.toString=i(t,(t=>`hsva(${t[0]}, ${t[1]}%, ${t[2]}%, ${s.a})`)),t},toHSLA(){const t=[...v(s.h,s.s,s.v),s.a];return t.toString=i(t,(t=>`hsla(${t[0]}, ${t[1]}%, ${t[2]}%, ${s.a})`)),t},toRGBA(){const t=[...f(s.h,s.s,s.v),s.a];return t.toString=i(t,(t=>`rgba(${t[0]}, ${t[1]}, ${t[2]}, ${s.a})`)),t},toCMYK(){const t=function(t,e,o){const n=f(t,e,o),i=n[0]/255,s=n[1]/255,r=n[2]/255,a=u(1-i,1-s,1-r);return[100*(1===a?0:(1-i-a)/(1-a)),100*(1===a?0:(1-s-a)/(1-a)),100*(1===a?0:(1-r-a)/(1-a)),100*a]}(s.h,s.s,s.v);return t.toString=i(t,(t=>`cmyk(${t[0]}%, ${t[1]}%, ${t[2]}%, ${t[3]}%)`)),t},toHEXA(){const t=function(t,e,o){return f(t,e,o).map((t=>m(t).toString(16).padStart(2,"0")))}(s.h,s.s,s.v),e=s.a>=1?"":Number((255*s.a).toFixed(0)).toString(16).toUpperCase().padStart(2,"0");return e&&t.push(e),t.toString=()=>`#${t.join("").toUpperCase()}`,t},clone:()=>A(s.h,s.s,s.v,s.a)};return s}const C=t=>Math.max(Math.min(t,1),0);function $(t){const e={options:Object.assign({lock:null,onchange:()=>0,onstop:()=>0},t),_keyboard(t){const{options:o}=e,{type:n,key:i}=t;if(document.activeElement===o.wrapper){const{lock:o}=e.options,s="ArrowUp"===i,r="ArrowRight"===i,a="ArrowDown"===i,l="ArrowLeft"===i;if("keydown"===n&&(s||r||a||l)){let n=0,i=0;"v"===o?n=s||r?1:-1:"h"===o?n=s||r?-1:1:(i=s?-1:a?1:0,n=l?-1:r?1:0),e.update(C(e.cache.x+.01*n),C(e.cache.y+.01*i)),t.preventDefault()}else i.startsWith("Arrow")&&(e.options.onstop(),t.preventDefault())}},_tapstart(t){i(document,["mouseup","touchend","touchcancel"],e._tapstop),i(document,["mousemove","touchmove"],e._tapmove),t.cancelable&&t.preventDefault(),e._tapmove(t)},_tapmove(t){const{options:o,cache:n}=e,{lock:i,element:s,wrapper:r}=o,a=r.getBoundingClientRect();let l=0,c=0;if(t){const e=t&&t.touches&&t.touches[0];l=t?(e||t).clientX:0,c=t?(e||t).clientY:0,l<a.left?l=a.left:l>a.left+a.width&&(l=a.left+a.width),c<a.top?c=a.top:c>a.top+a.height&&(c=a.top+a.height),l-=a.left,c-=a.top}else n&&(l=n.x*a.width,c=n.y*a.height);"h"!==i&&(s.style.left=`calc(${l/a.width*100}% - ${s.offsetWidth/2}px)`),"v"!==i&&(s.style.top=`calc(${c/a.height*100}% - ${s.offsetHeight/2}px)`),e.cache={x:l/a.width,y:c/a.height};const p=C(l/a.width),u=C(c/a.height);switch(i){case"v":return o.onchange(p);case"h":return o.onchange(u);default:return o.onchange(p,u)}},_tapstop(){e.options.onstop(),s(document,["mouseup","touchend","touchcancel"],e._tapstop),s(document,["mousemove","touchmove"],e._tapmove)},trigger(){e._tapmove()},update(t=0,o=0){const{left:n,top:i,width:s,height:r}=e.options.wrapper.getBoundingClientRect();"h"===e.options.lock&&(o=t),e._tapmove({clientX:n+s*t,clientY:i+r*o})},destroy(){const{options:t,_tapstart:o,_keyboard:n}=e;s(document,["keydown","keyup"],n),s([t.wrapper,t.element],"mousedown",o),s([t.wrapper,t.element],"touchstart",o,{passive:!1})}},{options:o,_tapstart:n,_keyboard:r}=e;return i([o.wrapper,o.element],"mousedown",n),i([o.wrapper,o.element],"touchstart",n,{passive:!1}),i(document,["keydown","keyup"],r),e}function k(t={}){t=Object.assign({onchange:()=>0,className:"",elements:[]},t);const e=i(t.elements,"click",(e=>{t.elements.forEach((o=>o.classList[e.target===o?"add":"remove"](t.className))),t.onchange(e),e.stopPropagation()}));return{destroy:()=>s(...e)}}const S={variantFlipOrder:{start:"sme",middle:"mse",end:"ems"},positionFlipOrder:{top:"tbrl",right:"rltb",bottom:"btrl",left:"lrbt"},position:"bottom",margin:8},O=(t,e,o)=>{const{container:n,margin:i,position:s,variantFlipOrder:r,positionFlipOrder:a}={container:document.documentElement.getBoundingClientRect(),...S,...o},{left:l,top:c}=e.style;e.style.left="0",e.style.top="0";const p=t.getBoundingClientRect(),u=e.getBoundingClientRect(),h={t:p.top-u.height-i,b:p.bottom+i,r:p.right+i,l:p.left-u.width-i},d={vs:p.left,vm:p.left+p.width/2+-u.width/2,ve:p.left+p.width-u.width,hs:p.top,hm:p.bottom-p.height/2-u.height/2,he:p.bottom-u.height},[m,f="middle"]=s.split("-"),v=a[m],b=r[f],{top:y,left:g,bottom:_,right:w}=n;for(const t of v){const o="t"===t||"b"===t,n=h[t],[i,s]=o?["top","left"]:["left","top"],[r,a]=o?[u.height,u.width]:[u.width,u.height],[l,c]=o?[_,w]:[w,_],[p,m]=o?[y,g]:[g,y];if(!(n<p||n+r>l))for(const r of b){const l=d[(o?"v":"h")+r];if(!(l<m||l+a>c))return e.style[s]=l-u[s]+"px",e.style[i]=n-u[i]+"px",t+r}}return e.style.left=l,e.style.top=c,null};function E(t,e,o){return e in t?Object.defineProperty(t,e,{value:o,enumerable:!0,configurable:!0,writable:!0}):t[e]=o,t}class L{constructor(t){E(this,"_initializingActive",!0),E(this,"_recalc",!0),E(this,"_nanopop",null),E(this,"_root",null),E(this,"_color",A()),E(this,"_lastColor",A()),E(this,"_swatchColors",[]),E(this,"_setupAnimationFrame",null),E(this,"_eventListener",{init:[],save:[],hide:[],show:[],clear:[],change:[],changestop:[],cancel:[],swatchselect:[]}),this.options=t=Object.assign({...L.DEFAULT_OPTIONS},t);const{swatches:e,components:o,theme:n,sliders:i,lockOpacity:s,padding:r}=t;["nano","monolith"].includes(n)&&!i&&(t.sliders="h"),o.interaction||(o.interaction={});const{preview:a,opacity:l,hue:c,palette:p}=o;o.opacity=!s&&l,o.palette=p||a||l||c,this._preBuild(),this._buildComponents(),this._bindEvents(),this._finalBuild(),e&&e.length&&e.forEach((t=>this.addSwatch(t)));const{button:u,app:h}=this._root;this._nanopop=((t,e,o)=>{const n="object"!=typeof t||t instanceof HTMLElement?{reference:t,popper:e,...o}:t;return{update(t=n){const{reference:e,popper:o}=Object.assign(n,t);if(!o||!e)throw new Error("Popper- or reference-element missing.");return O(e,o,n)}}})(u,h,{margin:r}),u.setAttribute("role","button"),u.setAttribute("aria-label",this._t("btn:toggle"));const d=this;this._setupAnimationFrame=requestAnimationFrame((function e(){if(!h.offsetWidth)return requestAnimationFrame(e);d.setColor(t.default),d._rePositioningPicker(),t.defaultRepresentation&&(d._representation=t.defaultRepresentation,d.setColorRepresentation(d._representation)),t.showAlways&&d.show(),d._initializingActive=!1,d._emit("init")}))}_preBuild(){const{options:t}=this;for(const e of["el","container"])t[e]=c(t[e]);this._root=(t=>{const{components:e,useAsButton:o,inline:n,appClass:i,theme:s,lockOpacity:r}=t.options,l=t=>t?"":'style="display:none" hidden',c=e=>t._t(e),p=a(`\n      <div :ref="root" class="pickr">\n\n        ${o?"":'<button type="button" :ref="button" class="pcr-button"></button>'}\n\n        <div :ref="app" class="pcr-app ${i||""}" data-theme="${s}" ${n?'style="position: unset"':""} aria-label="${c("ui:dialog")}" role="window">\n          <div class="pcr-selection" ${l(e.palette)}>\n            <div :obj="preview" class="pcr-color-preview" ${l(e.preview)}>\n              <button type="button" :ref="lastColor" class="pcr-last-color" aria-label="${c("btn:last-color")}"></button>\n              <div :ref="currentColor" class="pcr-current-color"></div>\n            </div>\n\n            <div :obj="palette" class="pcr-color-palette">\n              <div :ref="picker" class="pcr-picker"></div>\n              <div :ref="palette" class="pcr-palette" tabindex="0" aria-label="${c("aria:palette")}" role="listbox"></div>\n            </div>\n\n            <div :obj="hue" class="pcr-color-chooser" ${l(e.hue)}>\n              <div :ref="picker" class="pcr-picker"></div>\n              <div :ref="slider" class="pcr-hue pcr-slider" tabindex="0" aria-label="${c("aria:hue")}" role="slider"></div>\n            </div>\n\n            <div :obj="opacity" class="pcr-color-opacity" ${l(e.opacity)}>\n              <div :ref="picker" class="pcr-picker"></div>\n              <div :ref="slider" class="pcr-opacity pcr-slider" tabindex="0" aria-label="${c("aria:opacity")}" role="slider"></div>\n            </div>\n          </div>\n\n          <div class="pcr-swatches ${e.palette?"":"pcr-last"}" :ref="swatches"></div>\n\n          <div :obj="interaction" class="pcr-interaction" ${l(Object.keys(e.interaction).length)}>\n            <input :ref="result" class="pcr-result" type="text" spellcheck="false" ${l(e.interaction.input)} aria-label="${c("aria:input")}">\n\n            <input :arr="options" class="pcr-type" data-type="HEXA" value="${r?"HEX":"HEXA"}" type="button" ${l(e.interaction.hex)}>\n            <input :arr="options" class="pcr-type" data-type="RGBA" value="${r?"RGB":"RGBA"}" type="button" ${l(e.interaction.rgba)}>\n            <input :arr="options" class="pcr-type" data-type="HSLA" value="${r?"HSL":"HSLA"}" type="button" ${l(e.interaction.hsla)}>\n            <input :arr="options" class="pcr-type" data-type="HSVA" value="${r?"HSV":"HSVA"}" type="button" ${l(e.interaction.hsva)}>\n            <input :arr="options" class="pcr-type" data-type="CMYK" value="CMYK" type="button" ${l(e.interaction.cmyk)}>\n\n            <input :ref="save" class="pcr-save" value="${c("btn:save")}" type="button" ${l(e.interaction.save)} aria-label="${c("aria:btn:save")}">\n            <input :ref="cancel" class="pcr-cancel" value="${c("btn:cancel")}" type="button" ${l(e.interaction.cancel)} aria-label="${c("aria:btn:cancel")}">\n            <input :ref="clear" class="pcr-clear" value="${c("btn:clear")}" type="button" ${l(e.interaction.clear)} aria-label="${c("aria:btn:clear")}">\n          </div>\n        </div>\n      </div>\n    `),u=p.interaction;return u.options.find((t=>!t.hidden&&!t.classList.add("active"))),u.type=()=>u.options.find((t=>t.classList.contains("active"))),p})(this),t.useAsButton&&(this._root.button=t.el),t.container.appendChild(this._root.root)}_finalBuild(){const t=this.options,e=this._root;if(t.container.removeChild(e.root),t.inline){const o=t.el.parentElement;t.el.nextSibling?o.insertBefore(e.app,t.el.nextSibling):o.appendChild(e.app)}else t.container.appendChild(e.app);t.useAsButton?t.inline&&t.el.remove():t.el.parentNode.replaceChild(e.root,t.el),t.disabled&&this.disable(),t.comparison||(e.button.style.transition="none",t.useAsButton||(e.preview.lastColor.style.transition="none")),this.hide()}_buildComponents(){const t=this,e=this.options.components,o=(t.options.sliders||"v").repeat(2),[n,i]=o.match(/^[vh]+$/g)?o:[],s=()=>this._color||(this._color=this._lastColor.clone()),r={palette:$({element:t._root.palette.picker,wrapper:t._root.palette.palette,onstop:()=>t._emit("changestop","slider",t),onchange(o,n){if(!e.palette)return;const i=s(),{_root:r,options:a}=t,{lastColor:l,currentColor:c}=r.preview;t._recalc&&(i.s=100*o,i.v=100-100*n,i.v<0&&(i.v=0),t._updateOutput("slider"));const p=i.toRGBA().toString(0);this.element.style.background=p,this.wrapper.style.background=`\n                        linear-gradient(to top, rgba(0, 0, 0, ${i.a}), transparent),\n                        linear-gradient(to left, hsla(${i.h}, 100%, 50%, ${i.a}), rgba(255, 255, 255, ${i.a}))\n                    `,a.comparison?a.useAsButton||t._lastColor||l.style.setProperty("--pcr-color",p):(r.button.style.setProperty("--pcr-color",p),r.button.classList.remove("clear"));const u=i.toHEXA().toString();for(const{el:e,color:o}of t._swatchColors)e.classList[u===o.toHEXA().toString()?"add":"remove"]("pcr-active");c.style.setProperty("--pcr-color",p)}}),hue:$({lock:"v"===i?"h":"v",element:t._root.hue.picker,wrapper:t._root.hue.slider,onstop:()=>t._emit("changestop","slider",t),onchange(o){if(!e.hue||!e.palette)return;const n=s();t._recalc&&(n.h=360*o),this.element.style.backgroundColor=`hsl(${n.h}, 100%, 50%)`,r.palette.trigger()}}),opacity:$({lock:"v"===n?"h":"v",element:t._root.opacity.picker,wrapper:t._root.opacity.slider,onstop:()=>t._emit("changestop","slider",t),onchange(o){if(!e.opacity||!e.palette)return;const n=s();t._recalc&&(n.a=Math.round(100*o)/100),this.element.style.background=`rgba(0, 0, 0, ${n.a})`,r.palette.trigger()}}),selectable:k({elements:t._root.interaction.options,className:"active",onchange(e){t._representation=e.target.getAttribute("data-type").toUpperCase(),t._recalc&&t._updateOutput("swatch")}})};this._components=r}_bindEvents(){const{_root:t,options:e}=this,o=[i(t.interaction.clear,"click",(()=>this._clearColor())),i([t.interaction.cancel,t.preview.lastColor],"click",(()=>{this.setHSVA(...(this._lastColor||this._color).toHSVA(),!0),this._emit("cancel")})),i(t.interaction.save,"click",(()=>{!this.applyColor()&&!e.showAlways&&this.hide()})),i(t.interaction.result,["keyup","input"],(t=>{this.setColor(t.target.value,!0)&&!this._initializingActive&&(this._emit("change",this._color,"input",this),this._emit("changestop","input",this)),t.stopImmediatePropagation()})),i(t.interaction.result,["focus","blur"],(t=>{this._recalc="blur"===t.type,this._recalc&&this._updateOutput(null)})),i([t.palette.palette,t.palette.picker,t.hue.slider,t.hue.picker,t.opacity.slider,t.opacity.picker],["mousedown","touchstart"],(()=>this._recalc=!0),{passive:!0})];if(!e.showAlways){const n=e.closeWithKey;o.push(i(t.button,"click",(()=>this.isOpen()?this.hide():this.show())),i(document,"keyup",(t=>this.isOpen()&&(t.key===n||t.code===n)&&this.hide())),i(document,["touchstart","mousedown"],(e=>{this.isOpen()&&!l(e).some((e=>e===t.app||e===t.button))&&this.hide()}),{capture:!0}))}if(e.adjustableNumbers){const e={rgba:[255,255,255,1],hsva:[360,100,100,1],hsla:[360,100,100,1],cmyk:[100,100,100,100]};p(t.interaction.result,((t,o,n)=>{const i=e[this.getColorRepresentation().toLowerCase()];if(i){const e=i[n],s=t+(e>=100?1e3*o:o);return s<=0?0:Number((s<e?s:e).toPrecision(3))}return t}))}if(e.autoReposition&&!e.inline){let t=null;const n=this;o.push(i(window,["scroll","resize"],(()=>{n.isOpen()&&(e.closeOnScroll&&n.hide(),null===t?(t=setTimeout((()=>t=null),100),requestAnimationFrame((function e(){n._rePositioningPicker(),null!==t&&requestAnimationFrame(e)}))):(clearTimeout(t),t=setTimeout((()=>t=null),100)))}),{capture:!0}))}this._eventBindings=o}_rePositioningPicker(){const{options:t}=this;if(!t.inline){if(!this._nanopop.update({container:document.body.getBoundingClientRect(),position:t.position})){const t=this._root.app,e=t.getBoundingClientRect();t.style.top=(window.innerHeight-e.height)/2+"px",t.style.left=(window.innerWidth-e.width)/2+"px"}}}_updateOutput(t){const{_root:e,_color:o,options:n}=this;if(e.interaction.type()){const t=`to${e.interaction.type().getAttribute("data-type")}`;e.interaction.result.value="function"==typeof o[t]?o[t]().toString(n.outputPrecision):""}!this._initializingActive&&this._recalc&&this._emit("change",o,t,this)}_clearColor(t=!1){const{_root:e,options:o}=this;o.useAsButton||e.button.style.setProperty("--pcr-color","rgba(0, 0, 0, 0.15)"),e.button.classList.add("clear"),o.showAlways||this.hide(),this._lastColor=null,this._initializingActive||t||(this._emit("save",null),this._emit("clear"))}_parseLocalColor(t){const{values:e,type:o,a:n}=w(t),{lockOpacity:i}=this.options,s=void 0!==n&&1!==n;return e&&3===e.length&&(e[3]=void 0),{values:!e||i&&s?null:e,type:o}}_t(t){return this.options.i18n[t]||L.I18N_DEFAULTS[t]}_emit(t,...e){this._eventListener[t].forEach((t=>t(...e,this)))}on(t,e){return this._eventListener[t].push(e),this}off(t,e){const o=this._eventListener[t]||[],n=o.indexOf(e);return~n&&o.splice(n,1),this}addSwatch(t){const{values:e}=this._parseLocalColor(t);if(e){const{_swatchColors:t,_root:o}=this,n=A(...e),s=r(`<button type="button" style="--pcr-color: ${n.toRGBA().toString(0)}" aria-label="${this._t("btn:swatch")}"/>`);return o.swatches.appendChild(s),t.push({el:s,color:n}),this._eventBindings.push(i(s,"click",(()=>{this.setHSVA(...n.toHSVA(),!0),this._emit("swatchselect",n),this._emit("change",n,"swatch",this)}))),!0}return!1}removeSwatch(t){const e=this._swatchColors[t];if(e){const{el:o}=e;return this._root.swatches.removeChild(o),this._swatchColors.splice(t,1),!0}return!1}applyColor(t=!1){const{preview:e,button:o}=this._root,n=this._color.toRGBA().toString(0);return e.lastColor.style.setProperty("--pcr-color",n),this.options.useAsButton||o.style.setProperty("--pcr-color",n),o.classList.remove("clear"),this._lastColor=this._color.clone(),this._initializingActive||t||this._emit("save",this._color),this}destroy(){cancelAnimationFrame(this._setupAnimationFrame),this._eventBindings.forEach((t=>s(...t))),Object.keys(this._components).forEach((t=>this._components[t].destroy()))}destroyAndRemove(){this.destroy();const{root:t,app:e}=this._root;t.parentElement&&t.parentElement.removeChild(t),e.parentElement.removeChild(e),Object.keys(this).forEach((t=>this[t]=null))}hide(){return!!this.isOpen()&&(this._root.app.classList.remove("visible"),this._emit("hide"),!0)}show(){return!this.options.disabled&&!this.isOpen()&&(this._root.app.classList.add("visible"),this._rePositioningPicker(),this._emit("show",this._color),this)}isOpen(){return this._root.app.classList.contains("visible")}setHSVA(t=360,e=0,o=0,n=1,i=!1){const s=this._recalc;if(this._recalc=!1,t<0||t>360||e<0||e>100||o<0||o>100||n<0||n>1)return!1;this._color=A(t,e,o,n);const{hue:r,opacity:a,palette:l}=this._components;return r.update(t/360),a.update(n),l.update(e/100,1-o/100),i||this.applyColor(),s&&this._updateOutput(),this._recalc=s,!0}setColor(t,e=!1){if(null===t)return this._clearColor(e),!0;const{values:o,type:n}=this._parseLocalColor(t);if(o){const t=n.toUpperCase(),{options:i}=this._root.interaction,s=i.find((e=>e.getAttribute("data-type")===t));if(s&&!s.hidden)for(const t of i)t.classList[t===s?"add":"remove"]("active");return!!this.setHSVA(...o,e)&&this.setColorRepresentation(t)}return!1}setColorRepresentation(t){return t=t.toUpperCase(),!!this._root.interaction.options.find((e=>e.getAttribute("data-type").startsWith(t)&&!e.click()))}getColorRepresentation(){return this._representation}getColor(){return this._color}getSelectedColor(){return this._lastColor}getRoot(){return this._root}disable(){return this.hide(),this.options.disabled=!0,this._root.button.classList.add("disabled"),this}enable(){return this.options.disabled=!1,this._root.button.classList.remove("disabled"),this}}return E(L,"utils",o),E(L,"version","1.8.2"),E(L,"I18N_DEFAULTS",{"ui:dialog":"color picker dialog","btn:toggle":"toggle color picker dialog","btn:swatch":"color swatch","btn:last-color":"use previous color","btn:save":"Save","btn:cancel":"Cancel","btn:clear":"Clear","aria:btn:save":"save and close","aria:btn:cancel":"cancel and close","aria:btn:clear":"clear and close","aria:input":"color input field","aria:palette":"color selection area","aria:hue":"hue selection slider","aria:opacity":"selection slider"}),E(L,"DEFAULT_OPTIONS",{appClass:null,theme:"classic",useAsButton:!1,padding:8,disabled:!1,comparison:!0,closeOnScroll:!1,outputPrecision:0,lockOpacity:!1,autoReposition:!0,container:"body",components:{interaction:{}},i18n:{},swatches:null,inline:!1,sliders:null,default:"#42445a",defaultRepresentation:null,position:"bottom-middle",adjustableNumbers:!0,showAlways:!1,closeWithKey:"Escape"}),E(L,"create",(t=>new L(t))),e=e.default})()}));
//# sourceMappingURL=pickr.min.js.map

/***/ }),

/***/ "ebe4":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ms = moment.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ms;

})));


/***/ }),

/***/ "ec18":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            ss: [number + 'sekundi', number + 'sekundit'],
            m: ['ühe minuti', 'üks minut'],
            mm: [number + ' minuti', number + ' minutit'],
            h: ['ühe tunni', 'tund aega', 'üks tund'],
            hh: [number + ' tunni', number + ' tundi'],
            d: ['ühe päeva', 'üks päev'],
            M: ['kuu aja', 'kuu aega', 'üks kuu'],
            MM: [number + ' kuu', number + ' kuud'],
            y: ['ühe aasta', 'aasta', 'üks aasta'],
            yy: [number + ' aasta', number + ' aastat'],
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
            '_'
        ),
        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split(
            '_'
        ),
        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
            '_'
        ),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: '%d päeva',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return et;

})));


/***/ }),

/***/ "ec2e":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (India) [en-in]
//! author : Jatin Agrawal : https://github.com/jatinag22

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIn = moment.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return enIn;

})));


/***/ }),

/***/ "ed25":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "eda5":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
            '_'
        ),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
            '_'
        ),
        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
            '_'
        ),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function (number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        },
    });

    return si;

})));


/***/ }),

/***/ "eedf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_avatar_vue_vue_type_style_index_0_id_6fd96bec_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8a5c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_avatar_vue_vue_type_style_index_0_id_6fd96bec_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_avatar_vue_vue_type_style_index_0_id_6fd96bec_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "ef98":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "f069":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__("59ed");

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "f0aa":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "f0b2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_tooltip_content_vue_vue_type_style_index_0_id_33e08654_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4ccd");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_tooltip_content_vue_vue_type_style_index_0_id_33e08654_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_tooltip_content_vue_vue_type_style_index_0_id_33e08654_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f1c9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_date_picker_vue_vue_type_style_index_0_id_e2da7c36_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d07c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_date_picker_vue_vue_type_style_index_0_id_e2da7c36_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_date_picker_vue_vue_type_style_index_0_id_e2da7c36_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f260":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pt = moment.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
            '_'
        ),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pt;

})));


/***/ }),

/***/ "f2600":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_badge_vue_vue_type_style_index_0_id_f1de1314_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1081");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_badge_vue_vue_type_style_index_0_id_f1de1314_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_badge_vue_vue_type_style_index_0_id_f1de1314_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f36a":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

module.exports = uncurryThis([].slice);


/***/ }),

/***/ "f3ff":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '੧',
            2: '੨',
            3: '੩',
            4: '੪',
            5: '੫',
            6: '੬',
            7: '੭',
            8: '੮',
            9: '੯',
            0: '੦',
        },
        numberMap = {
            '੧': '1',
            '੨': '2',
            '੩': '3',
            '੪': '4',
            '੫': '5',
            '੬': '6',
            '੭': '7',
            '੮': '8',
            '੯': '9',
            '੦': '0',
        };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
            '_'
        ),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ',
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return paIn;

})));


/***/ }),

/***/ "f5df":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var isCallable = __webpack_require__("1626");
var classofRaw = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var Object = global.Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ "f6b4":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Am Faoilleach',
            'An Gearran',
            'Am Màrt',
            'An Giblean',
            'An Cèitean',
            'An t-Ògmhios',
            'An t-Iuchar',
            'An Lùnastal',
            'An t-Sultain',
            'An Dàmhair',
            'An t-Samhain',
            'An Dùbhlachd',
        ],
        monthsShort = [
            'Faoi',
            'Gear',
            'Màrt',
            'Gibl',
            'Cèit',
            'Ògmh',
            'Iuch',
            'Lùn',
            'Sult',
            'Dàmh',
            'Samh',
            'Dùbh',
        ],
        weekdays = [
            'Didòmhnaich',
            'Diluain',
            'Dimàirt',
            'Diciadain',
            'Diardaoin',
            'Dihaoine',
            'Disathairne',
        ],
        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gd;

})));


/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "f7d5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_app_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ed25");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_app_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_app_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f8c9":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var setToStringTag = __webpack_require__("d44e");

$({ global: true }, { Reflect: {} });

// Reflect[@@toStringTag] property
// https://tc39.es/ecma262/#sec-reflect-@@tostringtag
setToStringTag(global.Reflect, 'Reflect', true);


/***/ }),

/***/ "facd":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
            '_'
        ),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
            '_'
        ),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nl;

})));


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "NButton", function() { return /* reexport */ button_button; });
__webpack_require__.d(__webpack_exports__, "NTextInput", function() { return /* reexport */ text_input; });
__webpack_require__.d(__webpack_exports__, "NSelect", function() { return /* reexport */ select_select; });
__webpack_require__.d(__webpack_exports__, "NToggle", function() { return /* reexport */ toggle; });
__webpack_require__.d(__webpack_exports__, "NBadge", function() { return /* reexport */ badge; });
__webpack_require__.d(__webpack_exports__, "NNumberInput", function() { return /* reexport */ number_input; });
__webpack_require__.d(__webpack_exports__, "NCheckbox", function() { return /* reexport */ checkbox_checkbox; });
__webpack_require__.d(__webpack_exports__, "NCheckboxGroup", function() { return /* reexport */ checkbox_group; });
__webpack_require__.d(__webpack_exports__, "NColourPicker", function() { return /* reexport */ colour_picker; });
__webpack_require__.d(__webpack_exports__, "NRadioButtons", function() { return /* reexport */ radio_button; });
__webpack_require__.d(__webpack_exports__, "NTooltip", function() { return /* reexport */ tooltip; });
__webpack_require__.d(__webpack_exports__, "NButtonGroup", function() { return /* reexport */ button_group; });
__webpack_require__.d(__webpack_exports__, "NReadOnlyInput", function() { return /* reexport */ read_only_input; });
__webpack_require__.d(__webpack_exports__, "NSplitInputButton", function() { return /* reexport */ split_input_button; });
__webpack_require__.d(__webpack_exports__, "NDataTable", function() { return /* reexport */ datatable; });
__webpack_require__.d(__webpack_exports__, "NDatePicker", function() { return /* reexport */ date_picker; });
__webpack_require__.d(__webpack_exports__, "NIcon", function() { return /* reexport */ icon; });
__webpack_require__.d(__webpack_exports__, "NConversation", function() { return /* reexport */ conversation; });
__webpack_require__.d(__webpack_exports__, "NConversationThread", function() { return /* reexport */ conversation_thread; });
__webpack_require__.d(__webpack_exports__, "NEmojiPicker", function() { return /* reexport */ emoji_picker; });
__webpack_require__.d(__webpack_exports__, "NModal", function() { return /* reexport */ modal; });
__webpack_require__.d(__webpack_exports__, "NApp", function() { return /* reexport */ app; });
__webpack_require__.d(__webpack_exports__, "NAvatar", function() { return /* reexport */ avatar; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("159b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("b0c0");

// EXTERNAL MODULE: ./src/styles/_main.scss
var _main = __webpack_require__("32c2");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/control/button/button.vue?vue&type=template&id=2ec05ef6&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.href)?_c('a',{staticClass:"btn",class:_vm.getButtonClass(),attrs:{"href":_vm.href,"id":_vm.id},on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.icon)?_c('n-icon',{staticClass:"btn__icon",class:{ 'btn__icon--no-text': !_vm.$slots['default'] },attrs:{"icon":_vm.icon}}):_vm._e(),_vm._t("default")],2):_c('button',{staticClass:"btn",class:_vm.getButtonClass(),attrs:{"id":_vm.id,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.icon)?_c('n-icon',{staticClass:"btn__icon",class:{ 'btn__icon--no-text': !_vm.$slots['default'] },attrs:{"icon":_vm.icon}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/control/button/button.vue?vue&type=template&id=2ec05ef6&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__("d9e2");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("4ae1");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.to-string-tag.js
var es_reflect_to_string_tag = __webpack_require__("f8c9");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__("3410");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js



function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("e01a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__("d28b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("e260");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("3ca3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("ddb0");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js







function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js






function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}
// CONCATENATED MODULE: ./node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__("8bbf");
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./node_modules/vue-class-component/dist/vue-class-component.esm.js
/**
  * vue-class-component v7.2.6
  * (c) 2015-present Evan You
  * @license MIT
  */


function vue_class_component_esm_typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    vue_class_component_esm_typeof = function (obj) {
      return typeof obj;
    };
  } else {
    vue_class_component_esm_typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return vue_class_component_esm_typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
function reflectionIsSupported() {
  return typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
}
function copyReflectionMetadata(to, from) {
  forwardMetadata(to, from);
  Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
    forwardMetadata(to.prototype, from.prototype, key);
  });
  Object.getOwnPropertyNames(from).forEach(function (key) {
    forwardMetadata(to, from, key);
  });
}

function forwardMetadata(to, from, propertyKey) {
  var metaKeys = propertyKey ? Reflect.getOwnMetadataKeys(from, propertyKey) : Reflect.getOwnMetadataKeys(from);
  metaKeys.forEach(function (metaKey) {
    var metadata = propertyKey ? Reflect.getOwnMetadata(metaKey, from, propertyKey) : Reflect.getOwnMetadata(metaKey, from);

    if (propertyKey) {
      Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
    } else {
      Reflect.defineMetadata(metaKey, metadata, to);
    }
  });
}

var fakeArray = {
  __proto__: []
};
var hasProto = fakeArray instanceof Array;
function createDecorator(factory) {
  return function (target, key, index) {
    var Ctor = typeof target === 'function' ? target : target.constructor;

    if (!Ctor.__decorators__) {
      Ctor.__decorators__ = [];
    }

    if (typeof index !== 'number') {
      index = undefined;
    }

    Ctor.__decorators__.push(function (options) {
      return factory(options, key, index);
    });
  };
}
function mixins() {
  for (var _len = arguments.length, Ctors = new Array(_len), _key = 0; _key < _len; _key++) {
    Ctors[_key] = arguments[_key];
  }

  return external_vue_default.a.extend({
    mixins: Ctors
  });
}
function isPrimitive(value) {
  var type = vue_class_component_esm_typeof(value);

  return value == null || type !== 'object' && type !== 'function';
}
function warn(message) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-class-component] ' + message);
  }
}

function collectDataFromConstructor(vm, Component) {
  // override _init to prevent to init as Vue instance
  var originalInit = Component.prototype._init;

  Component.prototype._init = function () {
    var _this = this;

    // proxy to actual vm
    var keys = Object.getOwnPropertyNames(vm); // 2.2.0 compat (props are no longer exposed as self properties)

    if (vm.$options.props) {
      for (var key in vm.$options.props) {
        if (!vm.hasOwnProperty(key)) {
          keys.push(key);
        }
      }
    }

    keys.forEach(function (key) {
      Object.defineProperty(_this, key, {
        get: function get() {
          return vm[key];
        },
        set: function set(value) {
          vm[key] = value;
        },
        configurable: true
      });
    });
  }; // should be acquired class property values


  var data = new Component(); // restore original _init to avoid memory leak (#209)

  Component.prototype._init = originalInit; // create plain data object

  var plainData = {};
  Object.keys(data).forEach(function (key) {
    if (data[key] !== undefined) {
      plainData[key] = data[key];
    }
  });

  if (false) {}

  return plainData;
}

var $internalHooks = ['data', 'beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeDestroy', 'destroyed', 'beforeUpdate', 'updated', 'activated', 'deactivated', 'render', 'errorCaptured', 'serverPrefetch' // 2.6
];
function componentFactory(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options.name = options.name || Component._componentTag || Component.name; // prototype props.

  var proto = Component.prototype;
  Object.getOwnPropertyNames(proto).forEach(function (key) {
    if (key === 'constructor') {
      return;
    } // hooks


    if ($internalHooks.indexOf(key) > -1) {
      options[key] = proto[key];
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(proto, key);

    if (descriptor.value !== void 0) {
      // methods
      if (typeof descriptor.value === 'function') {
        (options.methods || (options.methods = {}))[key] = descriptor.value;
      } else {
        // typescript decorated data
        (options.mixins || (options.mixins = [])).push({
          data: function data() {
            return _defineProperty({}, key, descriptor.value);
          }
        });
      }
    } else if (descriptor.get || descriptor.set) {
      // computed properties
      (options.computed || (options.computed = {}))[key] = {
        get: descriptor.get,
        set: descriptor.set
      };
    }
  });
  (options.mixins || (options.mixins = [])).push({
    data: function data() {
      return collectDataFromConstructor(this, Component);
    }
  }); // decorate options

  var decorators = Component.__decorators__;

  if (decorators) {
    decorators.forEach(function (fn) {
      return fn(options);
    });
    delete Component.__decorators__;
  } // find super


  var superProto = Object.getPrototypeOf(Component.prototype);
  var Super = superProto instanceof external_vue_default.a ? superProto.constructor : external_vue_default.a;
  var Extended = Super.extend(options);
  forwardStaticMembers(Extended, Component, Super);

  if (reflectionIsSupported()) {
    copyReflectionMetadata(Extended, Component);
  }

  return Extended;
}
var reservedPropertyNames = [// Unique id
'cid', // Super Vue constructor
'super', // Component options that will be used by the component
'options', 'superOptions', 'extendOptions', 'sealedOptions', // Private assets
'component', 'directive', 'filter'];
var shouldIgnore = {
  prototype: true,
  arguments: true,
  callee: true,
  caller: true
};

function forwardStaticMembers(Extended, Original, Super) {
  // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
  Object.getOwnPropertyNames(Original).forEach(function (key) {
    // Skip the properties that should not be overwritten
    if (shouldIgnore[key]) {
      return;
    } // Some browsers does not allow reconfigure built-in properties


    var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);

    if (extendedDescriptor && !extendedDescriptor.configurable) {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(Original, key); // If the user agent does not support `__proto__` or its family (IE <= 10),
    // the sub class properties may be inherited properties from the super class in TypeScript.
    // We need to exclude such properties to prevent to overwrite
    // the component options object which stored on the extended constructor (See #192).
    // If the value is a referenced value (object or function),
    // we can check equality of them and exclude it if they have the same reference.
    // If it is a primitive value, it will be forwarded for safety.

    if (!hasProto) {
      // Only `cid` is explicitly exluded from property forwarding
      // because we cannot detect whether it is a inherited property or not
      // on the no `__proto__` environment even though the property is reserved.
      if (key === 'cid') {
        return;
      }

      var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);

      if (!isPrimitive(descriptor.value) && superDescriptor && superDescriptor.value === descriptor.value) {
        return;
      }
    } // Warn if the users manually declare reserved properties


    if (false) {}

    Object.defineProperty(Extended, key, descriptor);
  });
}

function vue_class_component_esm_Component(options) {
  if (typeof options === 'function') {
    return componentFactory(options);
  }

  return function (Component) {
    return componentFactory(Component, options);
  };
}

vue_class_component_esm_Component.registerHooks = function registerHooks(keys) {
  $internalHooks.push.apply($internalHooks, _toConsumableArray(keys));
};

/* harmony default export */ var vue_class_component_esm = (vue_class_component_esm_Component);


// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Emit.js
var Emit_spreadArrays = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
// Code copied from Vue/src/shared/util.js
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = function (str) { return str.replace(hyphenateRE, '-$1').toLowerCase(); };
/**
 * decorator of an event-emitter function
 * @param  event The name of the event
 * @return MethodDecorator
 */
function Emit(event) {
    return function (_target, propertyKey, descriptor) {
        var key = hyphenate(propertyKey);
        var original = descriptor.value;
        descriptor.value = function emitter() {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var emit = function (returnValue) {
                var emitName = event || key;
                if (returnValue === undefined) {
                    if (args.length === 0) {
                        _this.$emit(emitName);
                    }
                    else if (args.length === 1) {
                        _this.$emit(emitName, args[0]);
                    }
                    else {
                        _this.$emit.apply(_this, Emit_spreadArrays([emitName], args));
                    }
                }
                else {
                    args.unshift(returnValue);
                    _this.$emit.apply(_this, Emit_spreadArrays([emitName], args));
                }
            };
            var returnValue = original.apply(this, args);
            if (isPromise(returnValue)) {
                returnValue.then(emit);
            }
            else {
                emit(returnValue);
            }
            return returnValue;
        };
    };
}
function isPromise(obj) {
    return obj instanceof Promise || (obj && typeof obj.then === 'function');
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Inject.js

/**
 * decorator of an inject
 * @param from key
 * @return PropertyDecorator
 */
function Inject(options) {
    return createDecorator(function (componentOptions, key) {
        if (typeof componentOptions.inject === 'undefined') {
            componentOptions.inject = {};
        }
        if (!Array.isArray(componentOptions.inject)) {
            componentOptions.inject[key] = options || key;
        }
    });
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/helpers/provideInject.js
function needToProduceProvide(original) {
    return (typeof original !== 'function' ||
        (!original.managed && !original.managedReactive));
}
function produceProvide(original) {
    var provide = function () {
        var _this = this;
        var rv = typeof original === 'function' ? original.call(this) : original;
        rv = Object.create(rv || null);
        // set reactive services (propagates previous services if necessary)
        rv[reactiveInjectKey] = Object.create(this[reactiveInjectKey] || {});
        for (var i in provide.managed) {
            rv[provide.managed[i]] = this[i];
        }
        var _loop_1 = function (i) {
            rv[provide.managedReactive[i]] = this_1[i]; // Duplicates the behavior of `@Provide`
            Object.defineProperty(rv[reactiveInjectKey], provide.managedReactive[i], {
                enumerable: true,
                configurable: true,
                get: function () { return _this[i]; },
            });
        };
        var this_1 = this;
        for (var i in provide.managedReactive) {
            _loop_1(i);
        }
        return rv;
    };
    provide.managed = {};
    provide.managedReactive = {};
    return provide;
}
/** Used for keying reactive provide/inject properties */
var reactiveInjectKey = '__reactiveInject__';
function inheritInjected(componentOptions) {
    // inject parent reactive services (if any)
    if (!Array.isArray(componentOptions.inject)) {
        componentOptions.inject = componentOptions.inject || {};
        componentOptions.inject[reactiveInjectKey] = {
            from: reactiveInjectKey,
            default: {},
        };
    }
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/InjectReactive.js


/**
 * decorator of a reactive inject
 * @param from key
 * @return PropertyDecorator
 */
function InjectReactive(options) {
    return createDecorator(function (componentOptions, key) {
        if (typeof componentOptions.inject === 'undefined') {
            componentOptions.inject = {};
        }
        if (!Array.isArray(componentOptions.inject)) {
            var fromKey_1 = !!options ? options.from || options : key;
            var defaultVal_1 = (!!options && options.default) || undefined;
            if (!componentOptions.computed)
                componentOptions.computed = {};
            componentOptions.computed[key] = function () {
                var obj = this[reactiveInjectKey];
                return obj ? obj[fromKey_1] : defaultVal_1;
            };
            componentOptions.inject[reactiveInjectKey] = reactiveInjectKey;
        }
    });
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/helpers/metadata.js
/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
function applyMetadata(options, target, key) {
    if (reflectMetadataIsSupported) {
        if (!Array.isArray(options) &&
            typeof options !== 'function' &&
            !options.hasOwnProperty('type') &&
            typeof options.type === 'undefined') {
            var type = Reflect.getMetadata('design:type', target, key);
            if (type !== Object) {
                options.type = type;
            }
        }
    }
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Model.js


/**
 * decorator of model
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function Model(event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
            componentOptions.model = { prop: k, event: event || k };
        })(target, key);
    };
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/ModelSync.js


/**
 * decorator of synced model and prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function ModelSync(propName, event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            componentOptions.model = { prop: propName, event: event || k };
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    // @ts-ignore
                    this.$emit(event, value);
                },
            };
        })(target, key);
    };
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Prop.js


/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
        })(target, key);
    };
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/PropSync.js


/**
 * decorator of a synced prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param options the options for the synced prop
 * @return PropertyDecorator | void
 */
function PropSync(propName, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    this.$emit("update:" + propName, value);
                },
            };
        })(target, key);
    };
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Provide.js


/**
 * decorator of a provide
 * @param key key
 * @return PropertyDecorator | void
 */
function Provide(key) {
    return createDecorator(function (componentOptions, k) {
        var provide = componentOptions.provide;
        inheritInjected(componentOptions);
        if (needToProduceProvide(provide)) {
            provide = componentOptions.provide = produceProvide(provide);
        }
        provide.managed[k] = key || k;
    });
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/ProvideReactive.js


/**
 * decorator of a reactive provide
 * @param key key
 * @return PropertyDecorator | void
 */
function ProvideReactive(key) {
    return createDecorator(function (componentOptions, k) {
        var provide = componentOptions.provide;
        inheritInjected(componentOptions);
        if (needToProduceProvide(provide)) {
            provide = componentOptions.provide = produceProvide(provide);
        }
        provide.managedReactive[k] = key || k;
    });
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Ref.js

/**
 * decorator of a ref prop
 * @param refKey the ref key defined in template
 */
function Ref(refKey) {
    return createDecorator(function (options, key) {
        options.computed = options.computed || {};
        options.computed[key] = {
            cache: false,
            get: function () {
                return this.$refs[refKey || key];
            },
        };
    });
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/VModel.js

/**
 * decorator for capturings v-model binding to component
 * @param options the options for the prop
 */
function VModel(options) {
    if (options === void 0) { options = {}; }
    var valueKey = 'value';
    return createDecorator(function (componentOptions, key) {
        ;
        (componentOptions.props || (componentOptions.props = {}))[valueKey] = options;
        (componentOptions.computed || (componentOptions.computed = {}))[key] = {
            get: function () {
                return this[valueKey];
            },
            set: function (value) {
                this.$emit('input', value);
            },
        };
    });
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Watch.js

/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return createDecorator(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        var watch = componentOptions.watch;
        if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
            watch[path] = [watch[path]];
        }
        else if (typeof watch[path] === 'undefined') {
            watch[path] = [];
        }
        watch[path].push({ handler: handler, deep: deep, immediate: immediate });
    });
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/index.js
/** vue-property-decorator verson 9.1.2 MIT LICENSE copyright 2020 kaorun343 */
/// <reference types='reflect-metadata'/>
















// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/brand/icon/icon.vue?vue&type=template&id=23af1a56&scoped=true&
var iconvue_type_template_id_23af1a56_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.icon,{tag:"component",attrs:{"fill":_vm.fill}})}
var iconvue_type_template_id_23af1a56_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/brand/icon/icon.vue?vue&type=template&id=23af1a56&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/calendar-icon.vue?vue&type=template&id=5d38688f&
var calendar_iconvue_type_template_id_5d38688f_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"n-icon"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":_vm.fill}},[_c('path',{attrs:{"d":"M0 0h24v24H0V0z","fill":"none"}}),_c('path',{attrs:{"d":"M19 4h-1V3c0-.55-.45-1-1-1s-1 .45-1 1v1H8V3c0-.55-.45-1-1-1s-1 .45-1 1v1H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 15c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V9h14v10zM7 11h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z"}})])])}
var calendar_iconvue_type_template_id_5d38688f_staticRenderFns = []


// CONCATENATED MODULE: ./src/icons/calendar-icon.vue?vue&type=template&id=5d38688f&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/calendar-icon.vue?vue&type=script&lang=ts&







var calendar_iconvue_type_script_lang_ts_NCalendarIcon = /*#__PURE__*/function (_Vue) {
  _inherits(NCalendarIcon, _Vue);

  var _super = _createSuper(NCalendarIcon);

  function NCalendarIcon() {
    _classCallCheck(this, NCalendarIcon);

    return _super.apply(this, arguments);
  }

  return _createClass(NCalendarIcon);
}(external_vue_default.a);

__decorate([Prop({
  default: 'currentColor'
})], calendar_iconvue_type_script_lang_ts_NCalendarIcon.prototype, "fill", void 0);

calendar_iconvue_type_script_lang_ts_NCalendarIcon = __decorate([vue_class_component_esm({
  name: 'n-calendar-icon'
})], calendar_iconvue_type_script_lang_ts_NCalendarIcon);
/* harmony default export */ var calendar_iconvue_type_script_lang_ts_ = (calendar_iconvue_type_script_lang_ts_NCalendarIcon);
// CONCATENATED MODULE: ./src/icons/calendar-icon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_calendar_iconvue_type_script_lang_ts_ = (calendar_iconvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/icons/calendar-icon.vue





/* normalize component */

var component = normalizeComponent(
  icons_calendar_iconvue_type_script_lang_ts_,
  calendar_iconvue_type_template_id_5d38688f_render,
  calendar_iconvue_type_template_id_5d38688f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var calendar_icon = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/custom-attribute-icon.vue?vue&type=template&id=14bd313a&functional=true&
var custom_attribute_iconvue_type_template_id_14bd313a_functional_true_render = function (_h,_vm) {var _c=_vm._c;return _c('span',{staticClass:"material-design-icon sync-icon",attrs:{"aria-hidden":_vm.decorative,"role":"img"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","enable-background":"new 0 0 24 24","viewBox":"0 0 24 24","fill":_vm.fill}},[_c('g',[_c('rect',{attrs:{"fill":"none","height":"24","width":"24"}})]),_c('g',[_c('g'),_c('g',[_c('path',{attrs:{"d":"M22,8l-4-4v3H3v2h15v3L22,8z"}}),_c('path',{attrs:{"d":"M2,16l4,4v-3h15v-2H6v-3L2,16z"}})])])])])}
var custom_attribute_iconvue_type_template_id_14bd313a_functional_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/icons/custom-attribute-icon.vue?vue&type=template&id=14bd313a&functional=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/custom-attribute-icon.vue?vue&type=script&lang=ts&







var custom_attribute_iconvue_type_script_lang_ts_NCustomAttributeIcon = /*#__PURE__*/function (_Vue) {
  _inherits(NCustomAttributeIcon, _Vue);

  var _super = _createSuper(NCustomAttributeIcon);

  function NCustomAttributeIcon() {
    _classCallCheck(this, NCustomAttributeIcon);

    return _super.apply(this, arguments);
  }

  return _createClass(NCustomAttributeIcon);
}(external_vue_default.a);

__decorate([Prop({
  default: 'currentColor'
})], custom_attribute_iconvue_type_script_lang_ts_NCustomAttributeIcon.prototype, "fill", void 0);

custom_attribute_iconvue_type_script_lang_ts_NCustomAttributeIcon = __decorate([vue_class_component_esm({
  name: 'n-custom-attribute-icon'
})], custom_attribute_iconvue_type_script_lang_ts_NCustomAttributeIcon);
/* harmony default export */ var custom_attribute_iconvue_type_script_lang_ts_ = (custom_attribute_iconvue_type_script_lang_ts_NCustomAttributeIcon);
// CONCATENATED MODULE: ./src/icons/custom-attribute-icon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_custom_attribute_iconvue_type_script_lang_ts_ = (custom_attribute_iconvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/icons/custom-attribute-icon.vue





/* normalize component */

var custom_attribute_icon_component = normalizeComponent(
  icons_custom_attribute_iconvue_type_script_lang_ts_,
  custom_attribute_iconvue_type_template_id_14bd313a_functional_true_render,
  custom_attribute_iconvue_type_template_id_14bd313a_functional_true_staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* harmony default export */ var custom_attribute_icon = (custom_attribute_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/decimal-icon.vue?vue&type=template&id=77dd898c&
var decimal_iconvue_type_template_id_77dd898c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"n-icon"},[_c('svg',{attrs:{"viewBox":"0 0 24 24","fill":_vm.fill}},[_c('path',{attrs:{"fill":"currentColor","d":"M6,21V19C10,17 9.5,13 9.5,13H7V11H9.5C8.5,6.5 10,3 14,3C16,3 17,3.5 17,3.5V5.5C11,3.5 11,8 11.5,11H16V13H11.5C11.5,13 12,17 9.5,19H18V21H6Z"}})])])}
var decimal_iconvue_type_template_id_77dd898c_staticRenderFns = []


// CONCATENATED MODULE: ./src/icons/decimal-icon.vue?vue&type=template&id=77dd898c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/decimal-icon.vue?vue&type=script&lang=ts&







var decimal_iconvue_type_script_lang_ts_NDecimalIcon = /*#__PURE__*/function (_Vue) {
  _inherits(NDecimalIcon, _Vue);

  var _super = _createSuper(NDecimalIcon);

  function NDecimalIcon() {
    _classCallCheck(this, NDecimalIcon);

    return _super.apply(this, arguments);
  }

  return _createClass(NDecimalIcon);
}(external_vue_default.a);

__decorate([Prop({
  default: 'currentColor'
})], decimal_iconvue_type_script_lang_ts_NDecimalIcon.prototype, "fill", void 0);

decimal_iconvue_type_script_lang_ts_NDecimalIcon = __decorate([vue_class_component_esm({
  name: 'n-decimal-icon'
})], decimal_iconvue_type_script_lang_ts_NDecimalIcon);
/* harmony default export */ var decimal_iconvue_type_script_lang_ts_ = (decimal_iconvue_type_script_lang_ts_NDecimalIcon);
// CONCATENATED MODULE: ./src/icons/decimal-icon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_decimal_iconvue_type_script_lang_ts_ = (decimal_iconvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/icons/decimal-icon.vue





/* normalize component */

var decimal_icon_component = normalizeComponent(
  icons_decimal_iconvue_type_script_lang_ts_,
  decimal_iconvue_type_template_id_77dd898c_render,
  decimal_iconvue_type_template_id_77dd898c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var decimal_icon = (decimal_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/email-icon.vue?vue&type=template&id=d2ae453e&
var email_iconvue_type_template_id_d2ae453e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"n-icon"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":_vm.fill}},[_c('path',{attrs:{"d":"M0 0h24v24H0V0z","fill":"none"}}),_c('path',{attrs:{"d":"M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-1 14H5c-.55 0-1-.45-1-1V8l6.94 4.34c.65.41 1.47.41 2.12 0L20 8v9c0 .55-.45 1-1 1zm-7-7L4 6h16l-8 5z"}})])])}
var email_iconvue_type_template_id_d2ae453e_staticRenderFns = []


// CONCATENATED MODULE: ./src/icons/email-icon.vue?vue&type=template&id=d2ae453e&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/email-icon.vue?vue&type=script&lang=ts&







var email_iconvue_type_script_lang_ts_NEmailIcon = /*#__PURE__*/function (_Vue) {
  _inherits(NEmailIcon, _Vue);

  var _super = _createSuper(NEmailIcon);

  function NEmailIcon() {
    _classCallCheck(this, NEmailIcon);

    return _super.apply(this, arguments);
  }

  return _createClass(NEmailIcon);
}(external_vue_default.a);

__decorate([Prop({
  default: 'currentColor'
})], email_iconvue_type_script_lang_ts_NEmailIcon.prototype, "fill", void 0);

email_iconvue_type_script_lang_ts_NEmailIcon = __decorate([vue_class_component_esm({
  name: 'n-email-icon'
})], email_iconvue_type_script_lang_ts_NEmailIcon);
/* harmony default export */ var email_iconvue_type_script_lang_ts_ = (email_iconvue_type_script_lang_ts_NEmailIcon);
// CONCATENATED MODULE: ./src/icons/email-icon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_email_iconvue_type_script_lang_ts_ = (email_iconvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/icons/email-icon.vue





/* normalize component */

var email_icon_component = normalizeComponent(
  icons_email_iconvue_type_script_lang_ts_,
  email_iconvue_type_template_id_d2ae453e_render,
  email_iconvue_type_template_id_d2ae453e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var email_icon = (email_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/number-icon.vue?vue&type=template&id=56a2ee34&
var number_iconvue_type_template_id_56a2ee34_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"n-icon"},[_c('svg',{attrs:{"viewBox":"0 0 24 24","fill":_vm.fill}},[_c('path',{attrs:{"fill":"currentColor","d":"M5.41,21L6.12,17H2.12L2.47,15H6.47L7.53,9H3.53L3.88,7H7.88L8.59,3H10.59L9.88,7H15.88L16.59,3H18.59L17.88,7H21.88L21.53,9H17.53L16.47,15H20.47L20.12,17H16.12L15.41,21H13.41L14.12,17H8.12L7.41,21H5.41M9.53,9L8.47,15H14.47L15.53,9H9.53Z"}})])])}
var number_iconvue_type_template_id_56a2ee34_staticRenderFns = []


// CONCATENATED MODULE: ./src/icons/number-icon.vue?vue&type=template&id=56a2ee34&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/number-icon.vue?vue&type=script&lang=ts&







var number_iconvue_type_script_lang_ts_NNumberIcon = /*#__PURE__*/function (_Vue) {
  _inherits(NNumberIcon, _Vue);

  var _super = _createSuper(NNumberIcon);

  function NNumberIcon() {
    _classCallCheck(this, NNumberIcon);

    return _super.apply(this, arguments);
  }

  return _createClass(NNumberIcon);
}(external_vue_default.a);

__decorate([Prop({
  default: 'currentColor'
})], number_iconvue_type_script_lang_ts_NNumberIcon.prototype, "fill", void 0);

number_iconvue_type_script_lang_ts_NNumberIcon = __decorate([vue_class_component_esm({
  name: 'n-number-icon'
})], number_iconvue_type_script_lang_ts_NNumberIcon);
/* harmony default export */ var number_iconvue_type_script_lang_ts_ = (number_iconvue_type_script_lang_ts_NNumberIcon);
// CONCATENATED MODULE: ./src/icons/number-icon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_number_iconvue_type_script_lang_ts_ = (number_iconvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/icons/number-icon.vue





/* normalize component */

var number_icon_component = normalizeComponent(
  icons_number_iconvue_type_script_lang_ts_,
  number_iconvue_type_template_id_56a2ee34_render,
  number_iconvue_type_template_id_56a2ee34_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var number_icon = (number_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/page-icon.vue?vue&type=template&id=7723308a&
var page_iconvue_type_template_id_7723308a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"n-icon"},[_c('svg',{attrs:{"viewBox":"0 0 24 24","fill":_vm.fill}},[_c('path',{attrs:{"fill":"currentColor","d":"M17.9,17.39C17.64,16.59 16.89,16 16,16H15V13A1,1 0 0,0 14,12H8V10H10A1,1 0 0,0 11,9V7H13A2,2 0 0,0 15,5V4.59C17.93,5.77 20,8.64 20,12C20,14.08 19.2,15.97 17.9,17.39M11,19.93C7.05,19.44 4,16.08 4,12C4,11.38 4.08,10.78 4.21,10.21L9,15V16A2,2 0 0,0 11,18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"}})])])}
var page_iconvue_type_template_id_7723308a_staticRenderFns = []


// CONCATENATED MODULE: ./src/icons/page-icon.vue?vue&type=template&id=7723308a&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/page-icon.vue?vue&type=script&lang=ts&







var page_iconvue_type_script_lang_ts_NPageIcon = /*#__PURE__*/function (_Vue) {
  _inherits(NPageIcon, _Vue);

  var _super = _createSuper(NPageIcon);

  function NPageIcon() {
    _classCallCheck(this, NPageIcon);

    return _super.apply(this, arguments);
  }

  return _createClass(NPageIcon);
}(external_vue_default.a);

__decorate([Prop({
  default: 'currentColor'
})], page_iconvue_type_script_lang_ts_NPageIcon.prototype, "fill", void 0);

page_iconvue_type_script_lang_ts_NPageIcon = __decorate([vue_class_component_esm({
  name: 'n-page-icon'
})], page_iconvue_type_script_lang_ts_NPageIcon);
/* harmony default export */ var page_iconvue_type_script_lang_ts_ = (page_iconvue_type_script_lang_ts_NPageIcon);
// CONCATENATED MODULE: ./src/icons/page-icon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_page_iconvue_type_script_lang_ts_ = (page_iconvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/icons/page-icon.vue





/* normalize component */

var page_icon_component = normalizeComponent(
  icons_page_iconvue_type_script_lang_ts_,
  page_iconvue_type_template_id_7723308a_render,
  page_iconvue_type_template_id_7723308a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var page_icon = (page_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/person-icon.vue?vue&type=template&id=5f4d0794&
var person_iconvue_type_template_id_5f4d0794_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"n-icon"},[_c('svg',{attrs:{"viewBox":"0 0 24 24","fill":_vm.fill}},[_c('path',{attrs:{"fill":"currentColor","d":"M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"}})])])}
var person_iconvue_type_template_id_5f4d0794_staticRenderFns = []


// CONCATENATED MODULE: ./src/icons/person-icon.vue?vue&type=template&id=5f4d0794&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/person-icon.vue?vue&type=script&lang=ts&







var person_iconvue_type_script_lang_ts_NPersonIcon = /*#__PURE__*/function (_Vue) {
  _inherits(NPersonIcon, _Vue);

  var _super = _createSuper(NPersonIcon);

  function NPersonIcon() {
    _classCallCheck(this, NPersonIcon);

    return _super.apply(this, arguments);
  }

  return _createClass(NPersonIcon);
}(external_vue_default.a);

__decorate([Prop({
  default: 'currentColor'
})], person_iconvue_type_script_lang_ts_NPersonIcon.prototype, "fill", void 0);

person_iconvue_type_script_lang_ts_NPersonIcon = __decorate([vue_class_component_esm({
  name: 'n-person-icon'
})], person_iconvue_type_script_lang_ts_NPersonIcon);
/* harmony default export */ var person_iconvue_type_script_lang_ts_ = (person_iconvue_type_script_lang_ts_NPersonIcon);
// CONCATENATED MODULE: ./src/icons/person-icon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_person_iconvue_type_script_lang_ts_ = (person_iconvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/icons/person-icon.vue





/* normalize component */

var person_icon_component = normalizeComponent(
  icons_person_iconvue_type_script_lang_ts_,
  person_iconvue_type_template_id_5f4d0794_render,
  person_iconvue_type_template_id_5f4d0794_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var person_icon = (person_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/phone-icon.vue?vue&type=template&id=ed3f5d02&
var phone_iconvue_type_template_id_ed3f5d02_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"n-icon"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":_vm.fill}},[_c('path',{attrs:{"d":"M0 0h24v24H0V0z","fill":"none"}}),_c('path',{attrs:{"d":"M19.23 15.26l-2.54-.29c-.61-.07-1.21.14-1.64.57l-1.84 1.84c-2.83-1.44-5.15-3.75-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52c-.12-1.01-.97-1.77-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98z"}})])])}
var phone_iconvue_type_template_id_ed3f5d02_staticRenderFns = []


// CONCATENATED MODULE: ./src/icons/phone-icon.vue?vue&type=template&id=ed3f5d02&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/phone-icon.vue?vue&type=script&lang=ts&







var phone_iconvue_type_script_lang_ts_NPhoneIcon = /*#__PURE__*/function (_Vue) {
  _inherits(NPhoneIcon, _Vue);

  var _super = _createSuper(NPhoneIcon);

  function NPhoneIcon() {
    _classCallCheck(this, NPhoneIcon);

    return _super.apply(this, arguments);
  }

  return _createClass(NPhoneIcon);
}(external_vue_default.a);

__decorate([Prop({
  default: 'currentColor'
})], phone_iconvue_type_script_lang_ts_NPhoneIcon.prototype, "fill", void 0);

phone_iconvue_type_script_lang_ts_NPhoneIcon = __decorate([vue_class_component_esm({
  name: 'n-phone-icon'
})], phone_iconvue_type_script_lang_ts_NPhoneIcon);
/* harmony default export */ var phone_iconvue_type_script_lang_ts_ = (phone_iconvue_type_script_lang_ts_NPhoneIcon);
// CONCATENATED MODULE: ./src/icons/phone-icon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_phone_iconvue_type_script_lang_ts_ = (phone_iconvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/icons/phone-icon.vue





/* normalize component */

var phone_icon_component = normalizeComponent(
  icons_phone_iconvue_type_script_lang_ts_,
  phone_iconvue_type_template_id_ed3f5d02_render,
  phone_iconvue_type_template_id_ed3f5d02_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var phone_icon = (phone_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/question-icon.vue?vue&type=template&id=267e5981&
var question_iconvue_type_template_id_267e5981_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"n-icon"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":_vm.fill}},[_c('path',{attrs:{"d":"M0 0h24v24H0V0z","fill":"none"}}),_c('path',{attrs:{"d":"M20 6h-1v8c0 .55-.45 1-1 1H6v1c0 1.1.9 2 2 2h10l4 4V8c0-1.1-.9-2-2-2zm-3 5V4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v13l4-4h9c1.1 0 2-.9 2-2z"}})])])}
var question_iconvue_type_template_id_267e5981_staticRenderFns = []


// CONCATENATED MODULE: ./src/icons/question-icon.vue?vue&type=template&id=267e5981&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/question-icon.vue?vue&type=script&lang=ts&







var question_iconvue_type_script_lang_ts_NQuestionIcon = /*#__PURE__*/function (_Vue) {
  _inherits(NQuestionIcon, _Vue);

  var _super = _createSuper(NQuestionIcon);

  function NQuestionIcon() {
    _classCallCheck(this, NQuestionIcon);

    return _super.apply(this, arguments);
  }

  return _createClass(NQuestionIcon);
}(external_vue_default.a);

__decorate([Prop({
  default: 'currentColor'
})], question_iconvue_type_script_lang_ts_NQuestionIcon.prototype, "fill", void 0);

question_iconvue_type_script_lang_ts_NQuestionIcon = __decorate([vue_class_component_esm({
  name: 'n-question-icon'
})], question_iconvue_type_script_lang_ts_NQuestionIcon);
/* harmony default export */ var question_iconvue_type_script_lang_ts_ = (question_iconvue_type_script_lang_ts_NQuestionIcon);
// CONCATENATED MODULE: ./src/icons/question-icon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_question_iconvue_type_script_lang_ts_ = (question_iconvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/icons/question-icon.vue





/* normalize component */

var question_icon_component = normalizeComponent(
  icons_question_iconvue_type_script_lang_ts_,
  question_iconvue_type_template_id_267e5981_render,
  question_iconvue_type_template_id_267e5981_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var question_icon = (question_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/text-icon.vue?vue&type=template&id=7b0c61a2&
var text_iconvue_type_template_id_7b0c61a2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"n-icon"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":_vm.fill}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M5 9h14c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1zm0 4h8c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1z"}})])])}
var text_iconvue_type_template_id_7b0c61a2_staticRenderFns = []


// CONCATENATED MODULE: ./src/icons/text-icon.vue?vue&type=template&id=7b0c61a2&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/text-icon.vue?vue&type=script&lang=ts&







var text_iconvue_type_script_lang_ts_NShortTextIcon = /*#__PURE__*/function (_Vue) {
  _inherits(NShortTextIcon, _Vue);

  var _super = _createSuper(NShortTextIcon);

  function NShortTextIcon() {
    _classCallCheck(this, NShortTextIcon);

    return _super.apply(this, arguments);
  }

  return _createClass(NShortTextIcon);
}(external_vue_default.a);

__decorate([Prop({
  default: 'currentColor'
})], text_iconvue_type_script_lang_ts_NShortTextIcon.prototype, "fill", void 0);

text_iconvue_type_script_lang_ts_NShortTextIcon = __decorate([vue_class_component_esm({
  name: 'n-short-text-icon'
})], text_iconvue_type_script_lang_ts_NShortTextIcon);
/* harmony default export */ var text_iconvue_type_script_lang_ts_ = (text_iconvue_type_script_lang_ts_NShortTextIcon);
// CONCATENATED MODULE: ./src/icons/text-icon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_text_iconvue_type_script_lang_ts_ = (text_iconvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/icons/text-icon.vue





/* normalize component */

var text_icon_component = normalizeComponent(
  icons_text_iconvue_type_script_lang_ts_,
  text_iconvue_type_template_id_7b0c61a2_render,
  text_iconvue_type_template_id_7b0c61a2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var text_icon = (text_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/chevron-right-icon.vue?vue&type=template&id=7ef93141&
var chevron_right_iconvue_type_template_id_7ef93141_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"n-icon"},[_c('svg',{attrs:{"viewBox":"0 0 24 24","fill":_vm.fill}},[_c('path',{attrs:{"fill":"currentColor","d":"M5.59,7.41L7,6L13,12L7,18L5.59,16.59L10.17,12L5.59,7.41M11.59,7.41L13,6L19,12L13,18L11.59,16.59L16.17,12L11.59,7.41Z"}})])])}
var chevron_right_iconvue_type_template_id_7ef93141_staticRenderFns = []


// CONCATENATED MODULE: ./src/icons/chevron-right-icon.vue?vue&type=template&id=7ef93141&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/chevron-right-icon.vue?vue&type=script&lang=ts&







var chevron_right_iconvue_type_script_lang_ts_NChevronRightIcon = /*#__PURE__*/function (_Vue) {
  _inherits(NChevronRightIcon, _Vue);

  var _super = _createSuper(NChevronRightIcon);

  function NChevronRightIcon() {
    _classCallCheck(this, NChevronRightIcon);

    return _super.apply(this, arguments);
  }

  return _createClass(NChevronRightIcon);
}(external_vue_default.a);

__decorate([Prop({
  default: 'currentColor'
})], chevron_right_iconvue_type_script_lang_ts_NChevronRightIcon.prototype, "fill", void 0);

chevron_right_iconvue_type_script_lang_ts_NChevronRightIcon = __decorate([vue_class_component_esm({
  name: 'n-chevron-right-icon'
})], chevron_right_iconvue_type_script_lang_ts_NChevronRightIcon);
/* harmony default export */ var chevron_right_iconvue_type_script_lang_ts_ = (chevron_right_iconvue_type_script_lang_ts_NChevronRightIcon);
// CONCATENATED MODULE: ./src/icons/chevron-right-icon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_chevron_right_iconvue_type_script_lang_ts_ = (chevron_right_iconvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/icons/chevron-right-icon.vue





/* normalize component */

var chevron_right_icon_component = normalizeComponent(
  icons_chevron_right_iconvue_type_script_lang_ts_,
  chevron_right_iconvue_type_template_id_7ef93141_render,
  chevron_right_iconvue_type_template_id_7ef93141_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var chevron_right_icon = (chevron_right_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/chevron-left-icon.vue?vue&type=template&id=a6652d12&
var chevron_left_iconvue_type_template_id_a6652d12_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"n-icon"},[_c('svg',{attrs:{"fill":_vm.fill,"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M18.41,7.41L17,6L11,12L17,18L18.41,16.59L13.83,12L18.41,7.41M12.41,7.41L11,6L5,12L11,18L12.41,16.59L7.83,12L12.41,7.41Z"}})])])}
var chevron_left_iconvue_type_template_id_a6652d12_staticRenderFns = []


// CONCATENATED MODULE: ./src/icons/chevron-left-icon.vue?vue&type=template&id=a6652d12&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/chevron-left-icon.vue?vue&type=script&lang=ts&







var chevron_left_iconvue_type_script_lang_ts_NChevronLeftIcon = /*#__PURE__*/function (_Vue) {
  _inherits(NChevronLeftIcon, _Vue);

  var _super = _createSuper(NChevronLeftIcon);

  function NChevronLeftIcon() {
    _classCallCheck(this, NChevronLeftIcon);

    return _super.apply(this, arguments);
  }

  return _createClass(NChevronLeftIcon);
}(external_vue_default.a);

__decorate([Prop({
  default: 'currentColor'
})], chevron_left_iconvue_type_script_lang_ts_NChevronLeftIcon.prototype, "fill", void 0);

chevron_left_iconvue_type_script_lang_ts_NChevronLeftIcon = __decorate([vue_class_component_esm({
  name: 'n-chevron-left-icon'
})], chevron_left_iconvue_type_script_lang_ts_NChevronLeftIcon);
/* harmony default export */ var chevron_left_iconvue_type_script_lang_ts_ = (chevron_left_iconvue_type_script_lang_ts_NChevronLeftIcon);
// CONCATENATED MODULE: ./src/icons/chevron-left-icon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_chevron_left_iconvue_type_script_lang_ts_ = (chevron_left_iconvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/icons/chevron-left-icon.vue





/* normalize component */

var chevron_left_icon_component = normalizeComponent(
  icons_chevron_left_iconvue_type_script_lang_ts_,
  chevron_left_iconvue_type_template_id_a6652d12_render,
  chevron_left_iconvue_type_template_id_a6652d12_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var chevron_left_icon = (chevron_left_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/skip-next-icon.vue?vue&type=template&id=08e5cd56&
var skip_next_iconvue_type_template_id_08e5cd56_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"n-icon"},[_c('svg',{attrs:{"viewBox":"0 0 24 24","fill":_vm.fill}},[_c('path',{attrs:{"fill":"currentColor","d":"M16,18H18V6H16M6,18L14.5,12L6,6V18Z"}})])])}
var skip_next_iconvue_type_template_id_08e5cd56_staticRenderFns = []


// CONCATENATED MODULE: ./src/icons/skip-next-icon.vue?vue&type=template&id=08e5cd56&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/skip-next-icon.vue?vue&type=script&lang=ts&







var skip_next_iconvue_type_script_lang_ts_NSkipNextIcon = /*#__PURE__*/function (_Vue) {
  _inherits(NSkipNextIcon, _Vue);

  var _super = _createSuper(NSkipNextIcon);

  function NSkipNextIcon() {
    _classCallCheck(this, NSkipNextIcon);

    return _super.apply(this, arguments);
  }

  return _createClass(NSkipNextIcon);
}(external_vue_default.a);

__decorate([Prop({
  default: 'currentColor'
})], skip_next_iconvue_type_script_lang_ts_NSkipNextIcon.prototype, "fill", void 0);

skip_next_iconvue_type_script_lang_ts_NSkipNextIcon = __decorate([vue_class_component_esm({
  name: 'n-skip-next-icon'
})], skip_next_iconvue_type_script_lang_ts_NSkipNextIcon);
/* harmony default export */ var skip_next_iconvue_type_script_lang_ts_ = (skip_next_iconvue_type_script_lang_ts_NSkipNextIcon);
// CONCATENATED MODULE: ./src/icons/skip-next-icon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_skip_next_iconvue_type_script_lang_ts_ = (skip_next_iconvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/icons/skip-next-icon.vue





/* normalize component */

var skip_next_icon_component = normalizeComponent(
  icons_skip_next_iconvue_type_script_lang_ts_,
  skip_next_iconvue_type_template_id_08e5cd56_render,
  skip_next_iconvue_type_template_id_08e5cd56_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var skip_next_icon = (skip_next_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/skip-previous-icon.vue?vue&type=template&id=14e379fe&
var skip_previous_iconvue_type_template_id_14e379fe_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"n-icon"},[_c('svg',{attrs:{"fill":_vm.fill,"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M6,18V6H8V18H6M9.5,12L18,6V18L9.5,12Z"}})])])}
var skip_previous_iconvue_type_template_id_14e379fe_staticRenderFns = []


// CONCATENATED MODULE: ./src/icons/skip-previous-icon.vue?vue&type=template&id=14e379fe&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/skip-previous-icon.vue?vue&type=script&lang=ts&







var skip_previous_iconvue_type_script_lang_ts_NSkipPreviousIcon = /*#__PURE__*/function (_Vue) {
  _inherits(NSkipPreviousIcon, _Vue);

  var _super = _createSuper(NSkipPreviousIcon);

  function NSkipPreviousIcon() {
    _classCallCheck(this, NSkipPreviousIcon);

    return _super.apply(this, arguments);
  }

  return _createClass(NSkipPreviousIcon);
}(external_vue_default.a);

__decorate([Prop({
  default: 'currentColor'
})], skip_previous_iconvue_type_script_lang_ts_NSkipPreviousIcon.prototype, "fill", void 0);

skip_previous_iconvue_type_script_lang_ts_NSkipPreviousIcon = __decorate([vue_class_component_esm({
  name: 'n-skip-previous-icon'
})], skip_previous_iconvue_type_script_lang_ts_NSkipPreviousIcon);
/* harmony default export */ var skip_previous_iconvue_type_script_lang_ts_ = (skip_previous_iconvue_type_script_lang_ts_NSkipPreviousIcon);
// CONCATENATED MODULE: ./src/icons/skip-previous-icon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_skip_previous_iconvue_type_script_lang_ts_ = (skip_previous_iconvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/icons/skip-previous-icon.vue





/* normalize component */

var skip_previous_icon_component = normalizeComponent(
  icons_skip_previous_iconvue_type_script_lang_ts_,
  skip_previous_iconvue_type_template_id_14e379fe_render,
  skip_previous_iconvue_type_template_id_14e379fe_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var skip_previous_icon = (skip_previous_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/add-icon.vue?vue&type=template&id=6a8cea3e&
var add_iconvue_type_template_id_6a8cea3e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"n-icon"},[_c('svg',{attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"}})])])}
var add_iconvue_type_template_id_6a8cea3e_staticRenderFns = []


// CONCATENATED MODULE: ./src/icons/add-icon.vue?vue&type=template&id=6a8cea3e&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/add-icon.vue?vue&type=script&lang=ts&







var add_iconvue_type_script_lang_ts_NAddIcon = /*#__PURE__*/function (_Vue) {
  _inherits(NAddIcon, _Vue);

  var _super = _createSuper(NAddIcon);

  function NAddIcon() {
    _classCallCheck(this, NAddIcon);

    return _super.apply(this, arguments);
  }

  return _createClass(NAddIcon);
}(external_vue_default.a);

__decorate([Prop({
  default: 'currentColor'
})], add_iconvue_type_script_lang_ts_NAddIcon.prototype, "fill", void 0);

add_iconvue_type_script_lang_ts_NAddIcon = __decorate([vue_class_component_esm({
  name: 'n-add-icon'
})], add_iconvue_type_script_lang_ts_NAddIcon);
/* harmony default export */ var add_iconvue_type_script_lang_ts_ = (add_iconvue_type_script_lang_ts_NAddIcon);
// CONCATENATED MODULE: ./src/icons/add-icon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_add_iconvue_type_script_lang_ts_ = (add_iconvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/icons/add-icon.vue





/* normalize component */

var add_icon_component = normalizeComponent(
  icons_add_iconvue_type_script_lang_ts_,
  add_iconvue_type_template_id_6a8cea3e_render,
  add_iconvue_type_template_id_6a8cea3e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var add_icon = (add_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/refresh-icon.vue?vue&type=template&id=9b023faa&
var refresh_iconvue_type_template_id_9b023faa_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"n-icon"},[_c('svg',{attrs:{"viewBox":"0 0 512 512"}},[_c('path',{attrs:{"fill":_vm.fill,"d":"M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z"}})])])}
var refresh_iconvue_type_template_id_9b023faa_staticRenderFns = []


// CONCATENATED MODULE: ./src/icons/refresh-icon.vue?vue&type=template&id=9b023faa&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/refresh-icon.vue?vue&type=script&lang=ts&







var refresh_iconvue_type_script_lang_ts_NRefreshIcon = /*#__PURE__*/function (_Vue) {
  _inherits(NRefreshIcon, _Vue);

  var _super = _createSuper(NRefreshIcon);

  function NRefreshIcon() {
    _classCallCheck(this, NRefreshIcon);

    return _super.apply(this, arguments);
  }

  return _createClass(NRefreshIcon);
}(external_vue_default.a);

__decorate([Prop({
  default: 'currentColor'
})], refresh_iconvue_type_script_lang_ts_NRefreshIcon.prototype, "fill", void 0);

refresh_iconvue_type_script_lang_ts_NRefreshIcon = __decorate([vue_class_component_esm({
  name: 'n-refresh-icon'
})], refresh_iconvue_type_script_lang_ts_NRefreshIcon);
/* harmony default export */ var refresh_iconvue_type_script_lang_ts_ = (refresh_iconvue_type_script_lang_ts_NRefreshIcon);
// CONCATENATED MODULE: ./src/icons/refresh-icon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_refresh_iconvue_type_script_lang_ts_ = (refresh_iconvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/icons/refresh-icon.vue





/* normalize component */

var refresh_icon_component = normalizeComponent(
  icons_refresh_iconvue_type_script_lang_ts_,
  refresh_iconvue_type_template_id_9b023faa_render,
  refresh_iconvue_type_template_id_9b023faa_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var refresh_icon = (refresh_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/conversation-refresh-icon.vue?vue&type=template&id=91333576&
var conversation_refresh_iconvue_type_template_id_91333576_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"n-icon"},[_c('svg',{style:({ fill: _vm.fill }),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 29.211 29.727"}},[_c('path',{attrs:{"d":"M17.368 10.298c.136.242.456.435.732.436l10.348.058c.268.002.512-.138.652-.366.141-.228.145-.517.023-.755L24.404.441c-.126-.248-.409-.429-.685-.438-.278-.012-.606.085-.752.321L21.52 2.671C19.43 1.49 17.032.797 14.464.797 6.489.795 0 7.285 0 15.261c0 7.977 6.489 14.466 14.466 14.466 7.976 0 14.465-6.489 14.465-14.466 0-.873-.09-1.725-.239-2.556-.08.007-.156.029-.237.029h-.021l-4.858-.014c.226.81.355 1.659.355 2.54 0 5.219-4.246 9.466-9.465 9.466C9.246 24.727 5 20.479 5 15.261c0-5.22 4.246-9.466 9.466-9.466 1.605 0 3.11.415 4.435 1.125l-1.58 2.563c-.146.236-.087.572.047.815z"}})])])}
var conversation_refresh_iconvue_type_template_id_91333576_staticRenderFns = []


// CONCATENATED MODULE: ./src/icons/conversation-refresh-icon.vue?vue&type=template&id=91333576&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/conversation-refresh-icon.vue?vue&type=script&lang=ts&







var conversation_refresh_iconvue_type_script_lang_ts_NConversationRefreshIcon = /*#__PURE__*/function (_Vue) {
  _inherits(NConversationRefreshIcon, _Vue);

  var _super = _createSuper(NConversationRefreshIcon);

  function NConversationRefreshIcon() {
    _classCallCheck(this, NConversationRefreshIcon);

    return _super.apply(this, arguments);
  }

  return _createClass(NConversationRefreshIcon);
}(external_vue_default.a);

__decorate([Prop({
  default: 'currentColor'
})], conversation_refresh_iconvue_type_script_lang_ts_NConversationRefreshIcon.prototype, "fill", void 0);

conversation_refresh_iconvue_type_script_lang_ts_NConversationRefreshIcon = __decorate([vue_class_component_esm({
  name: 'n-conversation-refresh-icon'
})], conversation_refresh_iconvue_type_script_lang_ts_NConversationRefreshIcon);
/* harmony default export */ var conversation_refresh_iconvue_type_script_lang_ts_ = (conversation_refresh_iconvue_type_script_lang_ts_NConversationRefreshIcon);
// CONCATENATED MODULE: ./src/icons/conversation-refresh-icon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_conversation_refresh_iconvue_type_script_lang_ts_ = (conversation_refresh_iconvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/icons/conversation-refresh-icon.vue





/* normalize component */

var conversation_refresh_icon_component = normalizeComponent(
  icons_conversation_refresh_iconvue_type_script_lang_ts_,
  conversation_refresh_iconvue_type_template_id_91333576_render,
  conversation_refresh_iconvue_type_template_id_91333576_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var conversation_refresh_icon = (conversation_refresh_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/tick-icon.vue?vue&type=template&id=fbd26afa&
var tick_iconvue_type_template_id_fbd26afa_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"n-icon"},[_c('svg',{style:({ fill: _vm.fill }),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 27.002 19.146"}},[_c('path',{attrs:{"d":"M9.85 19.146c-1.13 0-2.229-.46-3.02-1.26L.724 11.697c-.974-.989-.964-2.581.024-3.555.989-.975 2.582-.965 3.555.023l5.541 5.617L22.697.749c.976-.989 2.567-1 3.557-.024.987.975.998 2.567.024 3.556L12.861 17.885c-.787.799-1.885 1.26-3.011 1.261z"}})])])}
var tick_iconvue_type_template_id_fbd26afa_staticRenderFns = []


// CONCATENATED MODULE: ./src/icons/tick-icon.vue?vue&type=template&id=fbd26afa&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/tick-icon.vue?vue&type=script&lang=ts&







var tick_iconvue_type_script_lang_ts_NTickIcon = /*#__PURE__*/function (_Vue) {
  _inherits(NTickIcon, _Vue);

  var _super = _createSuper(NTickIcon);

  function NTickIcon() {
    _classCallCheck(this, NTickIcon);

    return _super.apply(this, arguments);
  }

  return _createClass(NTickIcon);
}(external_vue_default.a);

__decorate([Prop({
  default: 'currentColor'
})], tick_iconvue_type_script_lang_ts_NTickIcon.prototype, "fill", void 0);

tick_iconvue_type_script_lang_ts_NTickIcon = __decorate([vue_class_component_esm({
  name: 'n-tick-icon'
})], tick_iconvue_type_script_lang_ts_NTickIcon);
/* harmony default export */ var tick_iconvue_type_script_lang_ts_ = (tick_iconvue_type_script_lang_ts_NTickIcon);
// CONCATENATED MODULE: ./src/icons/tick-icon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_tick_iconvue_type_script_lang_ts_ = (tick_iconvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/icons/tick-icon.vue





/* normalize component */

var tick_icon_component = normalizeComponent(
  icons_tick_iconvue_type_script_lang_ts_,
  tick_iconvue_type_template_id_fbd26afa_render,
  tick_iconvue_type_template_id_fbd26afa_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var tick_icon = (tick_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/alert-icon.vue?vue&type=template&id=2077f17c&
var alert_iconvue_type_template_id_2077f17c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"n-icon"},[_c('svg',{style:({ fill: _vm.fill }),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30.184 24.959"}},[_c('path',{attrs:{"d":"M29.796 22.442L16.679 1.059c-.873-1.425-2.301-1.405-3.174.02L.388 22.433c-.873 1.426-.221 2.527 1.449 2.527h26.509c1.671 0 2.323-1.094 1.45-2.518zM15.081 5.792c.84 0 1.49.928 1.447 2.062l-.266 6.834c-.043 1.133-.576 2.061-1.184 2.061s-1.142-.928-1.185-2.061l-.263-6.834c-.043-1.134.609-2.062 1.451-2.062zm0 16.105c-1.06 0-1.787-.775-1.765-1.834 0-1.082.729-1.834 1.765-1.834 1.08 0 1.763.752 1.786 1.834 0 1.059-.706 1.834-1.786 1.834z"}})])])}
var alert_iconvue_type_template_id_2077f17c_staticRenderFns = []


// CONCATENATED MODULE: ./src/icons/alert-icon.vue?vue&type=template&id=2077f17c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/alert-icon.vue?vue&type=script&lang=ts&







var alert_iconvue_type_script_lang_ts_NAlertIcon = /*#__PURE__*/function (_Vue) {
  _inherits(NAlertIcon, _Vue);

  var _super = _createSuper(NAlertIcon);

  function NAlertIcon() {
    _classCallCheck(this, NAlertIcon);

    return _super.apply(this, arguments);
  }

  return _createClass(NAlertIcon);
}(external_vue_default.a);

__decorate([Prop({
  default: 'currentColor'
})], alert_iconvue_type_script_lang_ts_NAlertIcon.prototype, "fill", void 0);

alert_iconvue_type_script_lang_ts_NAlertIcon = __decorate([vue_class_component_esm({
  name: 'n-alert-icon'
})], alert_iconvue_type_script_lang_ts_NAlertIcon);
/* harmony default export */ var alert_iconvue_type_script_lang_ts_ = (alert_iconvue_type_script_lang_ts_NAlertIcon);
// CONCATENATED MODULE: ./src/icons/alert-icon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_alert_iconvue_type_script_lang_ts_ = (alert_iconvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/icons/alert-icon.vue





/* normalize component */

var alert_icon_component = normalizeComponent(
  icons_alert_iconvue_type_script_lang_ts_,
  alert_iconvue_type_template_id_2077f17c_render,
  alert_iconvue_type_template_id_2077f17c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var alert_icon = (alert_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/send-icon.vue?vue&type=template&id=534de347&
var send_iconvue_type_template_id_534de347_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"n-icon"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M0 0h24v24H0V0z","fill":"none"}}),_c('path',{attrs:{"d":"M2.01 21L23 12 2.01 3 2 10l15 2-15 2 .01 7z","fill":_vm.fill}})])])}
var send_iconvue_type_template_id_534de347_staticRenderFns = []


// CONCATENATED MODULE: ./src/icons/send-icon.vue?vue&type=template&id=534de347&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/send-icon.vue?vue&type=script&lang=ts&







var send_iconvue_type_script_lang_ts_NSendIcon = /*#__PURE__*/function (_Vue) {
  _inherits(NSendIcon, _Vue);

  var _super = _createSuper(NSendIcon);

  function NSendIcon() {
    _classCallCheck(this, NSendIcon);

    return _super.apply(this, arguments);
  }

  return _createClass(NSendIcon);
}(external_vue_default.a);

__decorate([Prop({
  default: 'currentColor'
})], send_iconvue_type_script_lang_ts_NSendIcon.prototype, "fill", void 0);

send_iconvue_type_script_lang_ts_NSendIcon = __decorate([vue_class_component_esm({
  name: 'n-send-icon'
})], send_iconvue_type_script_lang_ts_NSendIcon);
/* harmony default export */ var send_iconvue_type_script_lang_ts_ = (send_iconvue_type_script_lang_ts_NSendIcon);
// CONCATENATED MODULE: ./src/icons/send-icon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_send_iconvue_type_script_lang_ts_ = (send_iconvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/icons/send-icon.vue





/* normalize component */

var send_icon_component = normalizeComponent(
  icons_send_iconvue_type_script_lang_ts_,
  send_iconvue_type_template_id_534de347_render,
  send_iconvue_type_template_id_534de347_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var send_icon = (send_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/emoji-icon.vue?vue&type=template&id=61461fc2&
var emoji_iconvue_type_template_id_61461fc2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"n-icon"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"24","viewBox":"0 0 24 24","width":"24"}},[_c('path',{attrs:{"d":"M0 0h24v24H0V0z","fill":"none"}}),_c('circle',{attrs:{"cx":"15.5","cy":"9.5","r":"1.5","fill":_vm.fill}}),_c('circle',{attrs:{"cx":"8.5","cy":"9.5","r":"1.5","fill":_vm.fill}}),_c('path',{attrs:{"d":"M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-4c-1.48 0-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5s4.32-1.45 5.12-3.5h-1.67c-.7 1.19-1.97 2-3.45 2z","fill":_vm.fill}})])])}
var emoji_iconvue_type_template_id_61461fc2_staticRenderFns = []


// CONCATENATED MODULE: ./src/icons/emoji-icon.vue?vue&type=template&id=61461fc2&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/emoji-icon.vue?vue&type=script&lang=ts&







var emoji_iconvue_type_script_lang_ts_NEmojiIcon = /*#__PURE__*/function (_Vue) {
  _inherits(NEmojiIcon, _Vue);

  var _super = _createSuper(NEmojiIcon);

  function NEmojiIcon() {
    _classCallCheck(this, NEmojiIcon);

    return _super.apply(this, arguments);
  }

  return _createClass(NEmojiIcon);
}(external_vue_default.a);

__decorate([Prop({
  default: 'currentColor'
})], emoji_iconvue_type_script_lang_ts_NEmojiIcon.prototype, "fill", void 0);

emoji_iconvue_type_script_lang_ts_NEmojiIcon = __decorate([vue_class_component_esm({
  name: 'n-emoji-icon'
})], emoji_iconvue_type_script_lang_ts_NEmojiIcon);
/* harmony default export */ var emoji_iconvue_type_script_lang_ts_ = (emoji_iconvue_type_script_lang_ts_NEmojiIcon);
// CONCATENATED MODULE: ./src/icons/emoji-icon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_emoji_iconvue_type_script_lang_ts_ = (emoji_iconvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/icons/emoji-icon.vue





/* normalize component */

var emoji_icon_component = normalizeComponent(
  icons_emoji_iconvue_type_script_lang_ts_,
  emoji_iconvue_type_template_id_61461fc2_render,
  emoji_iconvue_type_template_id_61461fc2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var emoji_icon = (emoji_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/copy-icon.vue?vue&type=template&id=d822994c&
var copy_iconvue_type_template_id_d822994c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"n-icon"},[_c('svg',{attrs:{"role":"img","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512"}},[_c('path',{attrs:{"fill":_vm.fill,"d":"M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"}})])])}
var copy_iconvue_type_template_id_d822994c_staticRenderFns = []


// CONCATENATED MODULE: ./src/icons/copy-icon.vue?vue&type=template&id=d822994c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/copy-icon.vue?vue&type=script&lang=ts&







var copy_iconvue_type_script_lang_ts_NCopyIcon = /*#__PURE__*/function (_Vue) {
  _inherits(NCopyIcon, _Vue);

  var _super = _createSuper(NCopyIcon);

  function NCopyIcon() {
    _classCallCheck(this, NCopyIcon);

    return _super.apply(this, arguments);
  }

  return _createClass(NCopyIcon);
}(external_vue_default.a);

__decorate([Prop({
  default: 'currentColor'
})], copy_iconvue_type_script_lang_ts_NCopyIcon.prototype, "fill", void 0);

copy_iconvue_type_script_lang_ts_NCopyIcon = __decorate([vue_class_component_esm({
  name: 'n-copy-icon'
})], copy_iconvue_type_script_lang_ts_NCopyIcon);
/* harmony default export */ var copy_iconvue_type_script_lang_ts_ = (copy_iconvue_type_script_lang_ts_NCopyIcon);
// CONCATENATED MODULE: ./src/icons/copy-icon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_copy_iconvue_type_script_lang_ts_ = (copy_iconvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/icons/copy-icon.vue





/* normalize component */

var copy_icon_component = normalizeComponent(
  icons_copy_iconvue_type_script_lang_ts_,
  copy_iconvue_type_template_id_d822994c_render,
  copy_iconvue_type_template_id_d822994c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var copy_icon = (copy_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/delete-icon.vue?vue&type=template&id=18310ff5&
var delete_iconvue_type_template_id_18310ff5_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"n-icon"},[_c('svg',{attrs:{"viewBox":"0 0 512 512","fill":_vm.fill}},[_c('path',{attrs:{"d":"M413.7 133.4c-2.4-9-4-14-4-14-2.6-9.3-9.2-9.3-19-10.9l-53.1-6.7c-6.6-1.1-6.6-1.1-9.2-6.8-8.7-19.6-11.4-31-20.9-31h-103c-9.5 0-12.1 11.4-20.8 31.1-2.6 5.6-2.6 5.6-9.2 6.8l-53.2 6.7c-9.7 1.6-16.7 2.5-19.3 11.8 0 0-1.2 4.1-3.7 13-3.2 11.9-4.5 10.6 6.5 10.6h302.4c11 .1 9.8 1.3 6.5-10.6zM379.4 176H132.6c-16.6 0-17.4 2.2-16.4 14.7l18.7 242.6c1.6 12.3 2.8 14.8 17.5 14.8h207.2c14.7 0 15.9-2.5 17.5-14.8l18.7-242.6c1-12.6.2-14.7-16.4-14.7z"}})])])}
var delete_iconvue_type_template_id_18310ff5_staticRenderFns = []


// CONCATENATED MODULE: ./src/icons/delete-icon.vue?vue&type=template&id=18310ff5&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/delete-icon.vue?vue&type=script&lang=ts&







var delete_iconvue_type_script_lang_ts_NDeleteIcon = /*#__PURE__*/function (_Vue) {
  _inherits(NDeleteIcon, _Vue);

  var _super = _createSuper(NDeleteIcon);

  function NDeleteIcon() {
    _classCallCheck(this, NDeleteIcon);

    return _super.apply(this, arguments);
  }

  return _createClass(NDeleteIcon);
}(external_vue_default.a);

__decorate([Prop({
  default: 'currentColor'
})], delete_iconvue_type_script_lang_ts_NDeleteIcon.prototype, "fill", void 0);

delete_iconvue_type_script_lang_ts_NDeleteIcon = __decorate([vue_class_component_esm({
  name: 'n-delete-icon'
})], delete_iconvue_type_script_lang_ts_NDeleteIcon);
/* harmony default export */ var delete_iconvue_type_script_lang_ts_ = (delete_iconvue_type_script_lang_ts_NDeleteIcon);
// CONCATENATED MODULE: ./src/icons/delete-icon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_delete_iconvue_type_script_lang_ts_ = (delete_iconvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/icons/delete-icon.vue





/* normalize component */

var delete_icon_component = normalizeComponent(
  icons_delete_iconvue_type_script_lang_ts_,
  delete_iconvue_type_template_id_18310ff5_render,
  delete_iconvue_type_template_id_18310ff5_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var delete_icon = (delete_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/file-icon.vue?vue&type=template&id=8aefe508&
var file_iconvue_type_template_id_8aefe508_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"n-icon"},[_c('svg',{attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":_vm.fill,"d":"M13,9V3.5L18.5,9M6,2C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2H6Z"}})])])}
var file_iconvue_type_template_id_8aefe508_staticRenderFns = []


// CONCATENATED MODULE: ./src/icons/file-icon.vue?vue&type=template&id=8aefe508&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/icons/file-icon.vue?vue&type=script&lang=ts&







var file_iconvue_type_script_lang_ts_NFileIcon = /*#__PURE__*/function (_Vue) {
  _inherits(NFileIcon, _Vue);

  var _super = _createSuper(NFileIcon);

  function NFileIcon() {
    _classCallCheck(this, NFileIcon);

    return _super.apply(this, arguments);
  }

  return _createClass(NFileIcon);
}(external_vue_default.a);

__decorate([Prop({
  default: 'currentColor'
})], file_iconvue_type_script_lang_ts_NFileIcon.prototype, "fill", void 0);

file_iconvue_type_script_lang_ts_NFileIcon = __decorate([vue_class_component_esm({
  name: 'n-file-icon'
})], file_iconvue_type_script_lang_ts_NFileIcon);
/* harmony default export */ var file_iconvue_type_script_lang_ts_ = (file_iconvue_type_script_lang_ts_NFileIcon);
// CONCATENATED MODULE: ./src/icons/file-icon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_file_iconvue_type_script_lang_ts_ = (file_iconvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/icons/file-icon.vue





/* normalize component */

var file_icon_component = normalizeComponent(
  icons_file_iconvue_type_script_lang_ts_,
  file_iconvue_type_template_id_8aefe508_render,
  file_iconvue_type_template_id_8aefe508_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var file_icon = (file_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/brand/icon/icon.vue?vue&type=script&lang=ts&































var iconvue_type_script_lang_ts_NIcon = /*#__PURE__*/function (_Vue) {
  _inherits(NIcon, _Vue);

  var _super = _createSuper(NIcon);

  function NIcon() {
    _classCallCheck(this, NIcon);

    return _super.apply(this, arguments);
  }

  return _createClass(NIcon);
}(external_vue_default.a);

__decorate([Prop()], iconvue_type_script_lang_ts_NIcon.prototype, "icon", void 0);

__decorate([Prop({
  default: 'currentColor'
})], iconvue_type_script_lang_ts_NIcon.prototype, "fill", void 0);

iconvue_type_script_lang_ts_NIcon = __decorate([vue_class_component_esm({
  name: 'n-icon',
  components: {
    'add': add_icon,
    'calendar': calendar_icon,
    'copy': copy_icon,
    'customAttribute': custom_attribute_icon,
    'decimal': decimal_icon,
    'email': email_icon,
    'number': number_icon,
    'page': page_icon,
    'person': person_icon,
    'phone': phone_icon,
    'question': question_icon,
    'short-text': text_icon,
    'chevron-right': chevron_right_icon,
    'chevron-left': chevron_left_icon,
    'skip-next': skip_next_icon,
    'skip-previous': skip_previous_icon,
    'refresh': refresh_icon,
    'conversation-refresh': conversation_refresh_icon,
    'tick': tick_icon,
    'alert': alert_icon,
    'send': send_icon,
    'emoji': emoji_icon,
    'delete': delete_icon,
    'file': file_icon
  }
})], iconvue_type_script_lang_ts_NIcon);
/* harmony default export */ var iconvue_type_script_lang_ts_ = (iconvue_type_script_lang_ts_NIcon);
// CONCATENATED MODULE: ./src/components/brand/icon/icon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icon_iconvue_type_script_lang_ts_ = (iconvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/brand/icon/icon.vue?vue&type=style&index=0&id=23af1a56&lang=scss&scoped=true&
var iconvue_type_style_index_0_id_23af1a56_lang_scss_scoped_true_ = __webpack_require__("32c4");

// CONCATENATED MODULE: ./src/components/brand/icon/icon.vue






/* normalize component */

var icon_component = normalizeComponent(
  icon_iconvue_type_script_lang_ts_,
  iconvue_type_template_id_23af1a56_scoped_true_render,
  iconvue_type_template_id_23af1a56_scoped_true_staticRenderFns,
  false,
  null,
  "23af1a56",
  null
  
)

/* harmony default export */ var icon = (icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/control/button/button.vue?vue&type=script&lang=ts&








var buttonvue_type_script_lang_ts_NButton = /*#__PURE__*/function (_Vue) {
  _inherits(NButton, _Vue);

  var _super = _createSuper(NButton);

  function NButton() {
    _classCallCheck(this, NButton);

    return _super.apply(this, arguments);
  }

  _createClass(NButton, [{
    key: "getButtonClass",
    value: function getButtonClass() {
      return {
        'btn--primary': this.variant === 'primary' || this.variant === 'primary--outline',
        'btn--secondary': this.variant === 'secondary' || this.variant === 'secondary--outline',
        'btn--success': this.variant === 'success',
        'btn--danger': this.variant === 'danger',
        'btn--action': this.variant === 'action',
        'btn--outline': this.variant === 'primary--outline' || this.variant === 'secondary--outline',
        'btn--ghost': this.variant === 'ghost',
        'btn--loading': this.loading,
        'btn--icon': this.icon,
        'btn--no-text': this.slotIsEmpty()
      };
    }
  }, {
    key: "slotIsEmpty",
    value: function slotIsEmpty() {
      if (!this.$slots.default) {
        return true;
      }

      if (!this.$slots.default[0].text) {
        return true;
      }

      return false;
    }
  }]);

  return NButton;
}(external_vue_default.a);

__decorate([Prop()], buttonvue_type_script_lang_ts_NButton.prototype, "variant", void 0);

__decorate([Prop()], buttonvue_type_script_lang_ts_NButton.prototype, "href", void 0);

__decorate([Prop()], buttonvue_type_script_lang_ts_NButton.prototype, "disabled", void 0);

__decorate([Prop()], buttonvue_type_script_lang_ts_NButton.prototype, "id", void 0);

__decorate([Prop()], buttonvue_type_script_lang_ts_NButton.prototype, "icon", void 0);

__decorate([Prop({
  default: false
})], buttonvue_type_script_lang_ts_NButton.prototype, "loading", void 0);

buttonvue_type_script_lang_ts_NButton = __decorate([vue_class_component_esm({
  name: 'n-button',
  components: {
    NIcon: icon
  }
})], buttonvue_type_script_lang_ts_NButton);
/* harmony default export */ var buttonvue_type_script_lang_ts_ = (buttonvue_type_script_lang_ts_NButton);
// CONCATENATED MODULE: ./src/components/control/button/button.vue?vue&type=script&lang=ts&
 /* harmony default export */ var button_buttonvue_type_script_lang_ts_ = (buttonvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/control/button/button.vue?vue&type=style&index=0&id=2ec05ef6&lang=scss&scoped=true&
var buttonvue_type_style_index_0_id_2ec05ef6_lang_scss_scoped_true_ = __webpack_require__("1788");

// CONCATENATED MODULE: ./src/components/control/button/button.vue






/* normalize component */

var button_component = normalizeComponent(
  button_buttonvue_type_script_lang_ts_,
  render,
  staticRenderFns,
  false,
  null,
  "2ec05ef6",
  null
  
)

/* harmony default export */ var button_button = (button_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/toggle/toggle.vue?vue&type=template&id=2476a5ac&scoped=true&
var togglevue_type_template_id_2476a5ac_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-input",class:{ 'has-error': _vm.errorMessage }},[_c('div',{staticClass:"toggle__container"},[_c('div',{staticClass:"toggle__input-container"},[_c('input',{attrs:{"type":"checkbox","name":_vm.name,"id":_vm.inputId,"disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.checked)},"change":function($event){return _vm.$emit('change', $event.target.checked)}}}),_c('div',{staticClass:"toggle",on:{"click":_vm.handleToggleClick}},[_c('div',{staticClass:"toggle-inner"})])]),_c('label',{class:{ 'sr-only': _vm.hideLabel },attrs:{"for":_vm.inputId}},[_vm._v(_vm._s(_vm.label)+" ")])]),(_vm.errorMessage)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()])}
var togglevue_type_template_id_2476a5ac_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/toggle/toggle.vue?vue&type=template&id=2476a5ac&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// CONCATENATED MODULE: ./node_modules/nanoid/url-alphabet/index.js
let urlAlphabet =
  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict'


// CONCATENATED MODULE: ./node_modules/nanoid/index.browser.js

if (false) {}
let random = bytes => crypto.getRandomValues(new Uint8Array(bytes))
let customRandom = (alphabet, size, getRandom) => {
  let mask = (2 << (Math.log(alphabet.length - 1) / Math.LN2)) - 1
  let step = -~((1.6 * mask * size) / alphabet.length)
  return () => {
    let id = ''
    while (true) {
      let bytes = getRandom(step)
      let j = step
      while (j--) {
        id += alphabet[bytes[j] & mask] || ''
        if (id.length === size) return id
      }
    }
  }
}
let customAlphabet = (alphabet, size) => customRandom(alphabet, size, random)
let nanoid = (size = 21) => {
  let id = ''
  let bytes = crypto.getRandomValues(new Uint8Array(size))
  while (size--) {
    let byte = bytes[size] & 63
    if (byte < 36) {
      id += byte.toString(36)
    } else if (byte < 62) {
      id += (byte - 26).toString(36).toUpperCase()
    } else if (byte < 63) {
      id += '_'
    } else {
      id += '-'
    }
  }
  return id
}


// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/mixins/id-generator/id-generator.vue?vue&type=script&lang=ts&








/**
 * A mixin component to automatically generate a unique ID if an ID is not provided
 * as a prop.
 */

var id_generatorvue_type_script_lang_ts_IdGenerator = /*#__PURE__*/function (_Vue) {
  _inherits(IdGenerator, _Vue);

  var _super = _createSuper(IdGenerator);

  function IdGenerator() {
    var _this;

    _classCallCheck(this, IdGenerator);

    _this = _super.apply(this, arguments);
    _this.inputId = '';
    _this.idPrefix = 'n-input_';
    return _this;
  }

  _createClass(IdGenerator, [{
    key: "handleIdChange",
    value: function handleIdChange() {
      if (!this.id) {
        this.generateId();
      } else {
        this.inputId = this.id;
      }
    }
  }, {
    key: "created",
    value: function created() {
      this.handleIdChange();
    }
  }, {
    key: "generateId",
    value: function generateId() {
      this.inputId = "".concat(this.idPrefix).concat(nanoid());
    }
  }]);

  return IdGenerator;
}(external_vue_default.a);

__decorate([Prop()], id_generatorvue_type_script_lang_ts_IdGenerator.prototype, "id", void 0);

__decorate([Watch('id')], id_generatorvue_type_script_lang_ts_IdGenerator.prototype, "handleIdChange", null);

id_generatorvue_type_script_lang_ts_IdGenerator = __decorate([vue_class_component_esm], id_generatorvue_type_script_lang_ts_IdGenerator);
/* harmony default export */ var id_generatorvue_type_script_lang_ts_ = (id_generatorvue_type_script_lang_ts_IdGenerator);
// CONCATENATED MODULE: ./src/mixins/id-generator/id-generator.vue?vue&type=script&lang=ts&
 /* harmony default export */ var id_generator_id_generatorvue_type_script_lang_ts_ = (id_generatorvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/mixins/id-generator/id-generator.vue
var id_generator_render, id_generator_staticRenderFns




/* normalize component */

var id_generator_component = normalizeComponent(
  id_generator_id_generatorvue_type_script_lang_ts_,
  id_generator_render,
  id_generator_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var id_generator = (id_generator_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/toggle/toggle.vue?vue&type=script&lang=ts&








var togglevue_type_script_lang_ts_NToggle = /*#__PURE__*/function (_Mixins) {
  _inherits(NToggle, _Mixins);

  var _super = _createSuper(NToggle);

  function NToggle() {
    _classCallCheck(this, NToggle);

    return _super.apply(this, arguments);
  }

  _createClass(NToggle, [{
    key: "handleToggleClick",
    value: function handleToggleClick() {
      if (!this.disabled) {
        this.$emit('input', !this.value);
        this.$emit('change', !this.value);
      }
    }
  }]);

  return NToggle;
}(mixins(id_generator));

__decorate([Prop()], togglevue_type_script_lang_ts_NToggle.prototype, "label", void 0);

__decorate([Prop()], togglevue_type_script_lang_ts_NToggle.prototype, "id", void 0);

__decorate([Prop()], togglevue_type_script_lang_ts_NToggle.prototype, "errorMessage", void 0);

__decorate([Prop()], togglevue_type_script_lang_ts_NToggle.prototype, "value", void 0);

__decorate([Prop()], togglevue_type_script_lang_ts_NToggle.prototype, "name", void 0);

__decorate([Prop({
  default: false
})], togglevue_type_script_lang_ts_NToggle.prototype, "disabled", void 0);

__decorate([Prop()], togglevue_type_script_lang_ts_NToggle.prototype, "hideLabel", void 0);

togglevue_type_script_lang_ts_NToggle = __decorate([vue_class_component_esm({
  name: 'n-toggle'
})], togglevue_type_script_lang_ts_NToggle);
/* harmony default export */ var togglevue_type_script_lang_ts_ = (togglevue_type_script_lang_ts_NToggle);
// CONCATENATED MODULE: ./src/components/input/toggle/toggle.vue?vue&type=script&lang=ts&
 /* harmony default export */ var toggle_togglevue_type_script_lang_ts_ = (togglevue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/input/toggle/toggle.vue?vue&type=style&index=0&id=2476a5ac&lang=scss&scoped=true&
var togglevue_type_style_index_0_id_2476a5ac_lang_scss_scoped_true_ = __webpack_require__("961c");

// CONCATENATED MODULE: ./src/components/input/toggle/toggle.vue






/* normalize component */

var toggle_component = normalizeComponent(
  toggle_togglevue_type_script_lang_ts_,
  togglevue_type_template_id_2476a5ac_scoped_true_render,
  togglevue_type_template_id_2476a5ac_scoped_true_staticRenderFns,
  false,
  null,
  "2476a5ac",
  null
  
)

/* harmony default export */ var toggle = (toggle_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/number-input/number-input.vue?vue&type=template&id=ec509fe4&scoped=true&
var number_inputvue_type_template_id_ec509fe4_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-input",class:{ 'has-error': _vm.errorMessage }},[_c('label',{class:{ 'sr-only': _vm.hideLabel },attrs:{"for":_vm.inputId}},[_vm._v(_vm._s(_vm.label))]),_c('input',{staticClass:"control",attrs:{"type":"number","id":_vm.inputId,"name":_vm.name,"disabled":_vm.disabled,"placeholder":_vm.placeholder,"min":_vm.min,"max":_vm.max,"step":_vm.step},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.emitValue('input', $event.target.value)},"change":function($event){return _vm.emitValue('change', $event.target.value)}}}),(_vm.errorMessage)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()])}
var number_inputvue_type_template_id_ec509fe4_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/number-input/number-input.vue?vue&type=template&id=ec509fe4&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/number-input/number-input.vue?vue&type=script&lang=ts&








var number_inputvue_type_script_lang_ts_NNumberInput = /*#__PURE__*/function (_Mixins) {
  _inherits(NNumberInput, _Mixins);

  var _super = _createSuper(NNumberInput);

  function NNumberInput() {
    _classCallCheck(this, NNumberInput);

    return _super.apply(this, arguments);
  }

  _createClass(NNumberInput, [{
    key: "emitValue",
    value: function emitValue(eventType, eventValue) {
      this.$emit(eventType, parseInt(eventValue, 10));
    }
  }]);

  return NNumberInput;
}(mixins(id_generator));

__decorate([Prop()], number_inputvue_type_script_lang_ts_NNumberInput.prototype, "id", void 0);

__decorate([Prop()], number_inputvue_type_script_lang_ts_NNumberInput.prototype, "label", void 0);

__decorate([Prop()], number_inputvue_type_script_lang_ts_NNumberInput.prototype, "errorMessage", void 0);

__decorate([Prop()], number_inputvue_type_script_lang_ts_NNumberInput.prototype, "value", void 0);

__decorate([Prop()], number_inputvue_type_script_lang_ts_NNumberInput.prototype, "name", void 0);

__decorate([Prop()], number_inputvue_type_script_lang_ts_NNumberInput.prototype, "placeholder", void 0);

__decorate([Prop()], number_inputvue_type_script_lang_ts_NNumberInput.prototype, "min", void 0);

__decorate([Prop()], number_inputvue_type_script_lang_ts_NNumberInput.prototype, "max", void 0);

__decorate([Prop()], number_inputvue_type_script_lang_ts_NNumberInput.prototype, "step", void 0);

__decorate([Prop({
  default: false
})], number_inputvue_type_script_lang_ts_NNumberInput.prototype, "disabled", void 0);

__decorate([Prop()], number_inputvue_type_script_lang_ts_NNumberInput.prototype, "hideLabel", void 0);

number_inputvue_type_script_lang_ts_NNumberInput = __decorate([vue_class_component_esm({
  name: 'n-number-input'
})], number_inputvue_type_script_lang_ts_NNumberInput);
/* harmony default export */ var number_inputvue_type_script_lang_ts_ = (number_inputvue_type_script_lang_ts_NNumberInput);
// CONCATENATED MODULE: ./src/components/input/number-input/number-input.vue?vue&type=script&lang=ts&
 /* harmony default export */ var number_input_number_inputvue_type_script_lang_ts_ = (number_inputvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/input/number-input/number-input.vue?vue&type=style&index=0&id=ec509fe4&lang=scss&scoped=true&
var number_inputvue_type_style_index_0_id_ec509fe4_lang_scss_scoped_true_ = __webpack_require__("9c2f");

// CONCATENATED MODULE: ./src/components/input/number-input/number-input.vue






/* normalize component */

var number_input_component = normalizeComponent(
  number_input_number_inputvue_type_script_lang_ts_,
  number_inputvue_type_template_id_ec509fe4_scoped_true_render,
  number_inputvue_type_template_id_ec509fe4_scoped_true_staticRenderFns,
  false,
  null,
  "ec509fe4",
  null
  
)

/* harmony default export */ var number_input = (number_input_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/control/badge/badge.vue?vue&type=template&id=f1de1314&scoped=true&
var badgevue_type_template_id_f1de1314_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge",class:_vm.getBadgeClass()},[_vm._t("default")],2)}
var badgevue_type_template_id_f1de1314_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/control/badge/badge.vue?vue&type=template&id=f1de1314&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/control/badge/badge.vue?vue&type=script&lang=ts&







var badgevue_type_script_lang_ts_NBadge = /*#__PURE__*/function (_Vue) {
  _inherits(NBadge, _Vue);

  var _super = _createSuper(NBadge);

  function NBadge() {
    _classCallCheck(this, NBadge);

    return _super.apply(this, arguments);
  }

  _createClass(NBadge, [{
    key: "getBadgeClass",
    value: function getBadgeClass() {
      return {
        'badge--primary': this.variant === 'primary',
        'badge--secondary': this.variant === 'secondary',
        'badge--tertiary': this.variant === 'tertiary',
        'badge--success': this.variant === 'success',
        'badge--danger': this.variant === 'danger'
      };
    }
  }]);

  return NBadge;
}(external_vue_default.a);

__decorate([Prop()], badgevue_type_script_lang_ts_NBadge.prototype, "variant", void 0);

badgevue_type_script_lang_ts_NBadge = __decorate([vue_class_component_esm({
  name: 'n-badge'
})], badgevue_type_script_lang_ts_NBadge);
/* harmony default export */ var badgevue_type_script_lang_ts_ = (badgevue_type_script_lang_ts_NBadge);
// CONCATENATED MODULE: ./src/components/control/badge/badge.vue?vue&type=script&lang=ts&
 /* harmony default export */ var badge_badgevue_type_script_lang_ts_ = (badgevue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/control/badge/badge.vue?vue&type=style&index=0&id=f1de1314&lang=scss&scoped=true&
var badgevue_type_style_index_0_id_f1de1314_lang_scss_scoped_true_ = __webpack_require__("f2600");

// CONCATENATED MODULE: ./src/components/control/badge/badge.vue






/* normalize component */

var badge_component = normalizeComponent(
  badge_badgevue_type_script_lang_ts_,
  badgevue_type_template_id_f1de1314_scoped_true_render,
  badgevue_type_template_id_f1de1314_scoped_true_staticRenderFns,
  false,
  null,
  "f1de1314",
  null
  
)

/* harmony default export */ var badge = (badge_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/text-input/text-input.vue?vue&type=template&id=2840dc56&scoped=true&
var text_inputvue_type_template_id_2840dc56_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-input",class:{ 'has-error': _vm.errorMessage }},[_c('label',{class:{ 'sr-only': _vm.hideLabel },attrs:{"for":_vm.inputId}},[_vm._v(_vm._s(_vm.label))]),(_vm.multiline)?_c('textarea',{staticClass:"control",attrs:{"id":_vm.inputId,"name":_vm.name,"disabled":_vm.disabled,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)},"change":function($event){return _vm.$emit('change', $event.target.value)}}}):_c('input',{staticClass:"control",attrs:{"id":_vm.inputId,"name":_vm.name,"type":_vm.type,"disabled":_vm.disabled,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)},"change":function($event){return _vm.$emit('change', $event.target.value)}}}),(_vm.errorMessage)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()])}
var text_inputvue_type_template_id_2840dc56_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/text-input/text-input.vue?vue&type=template&id=2840dc56&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/text-input/text-input.vue?vue&type=script&lang=ts&








var text_inputvue_type_script_lang_ts_NTextInput = /*#__PURE__*/function (_Mixins) {
  _inherits(NTextInput, _Mixins);

  var _super = _createSuper(NTextInput);

  function NTextInput() {
    _classCallCheck(this, NTextInput);

    return _super.apply(this, arguments);
  }

  return _createClass(NTextInput);
}(mixins(id_generator));

__decorate([Prop()], text_inputvue_type_script_lang_ts_NTextInput.prototype, "id", void 0);

__decorate([Prop({
  default: 'text'
})], text_inputvue_type_script_lang_ts_NTextInput.prototype, "type", void 0);

__decorate([Prop()], text_inputvue_type_script_lang_ts_NTextInput.prototype, "label", void 0);

__decorate([Prop()], text_inputvue_type_script_lang_ts_NTextInput.prototype, "errorMessage", void 0);

__decorate([Prop()], text_inputvue_type_script_lang_ts_NTextInput.prototype, "value", void 0);

__decorate([Prop()], text_inputvue_type_script_lang_ts_NTextInput.prototype, "name", void 0);

__decorate([Prop()], text_inputvue_type_script_lang_ts_NTextInput.prototype, "placeholder", void 0);

__decorate([Prop({
  default: false
})], text_inputvue_type_script_lang_ts_NTextInput.prototype, "multiline", void 0);

__decorate([Prop({
  default: false
})], text_inputvue_type_script_lang_ts_NTextInput.prototype, "disabled", void 0);

__decorate([Prop()], text_inputvue_type_script_lang_ts_NTextInput.prototype, "hideLabel", void 0);

text_inputvue_type_script_lang_ts_NTextInput = __decorate([vue_class_component_esm({
  name: 'n-text-input'
})], text_inputvue_type_script_lang_ts_NTextInput);
/* harmony default export */ var text_inputvue_type_script_lang_ts_ = (text_inputvue_type_script_lang_ts_NTextInput);
// CONCATENATED MODULE: ./src/components/input/text-input/text-input.vue?vue&type=script&lang=ts&
 /* harmony default export */ var text_input_text_inputvue_type_script_lang_ts_ = (text_inputvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/input/text-input/text-input.vue?vue&type=style&index=0&id=2840dc56&lang=scss&scoped=true&
var text_inputvue_type_style_index_0_id_2840dc56_lang_scss_scoped_true_ = __webpack_require__("19cd");

// CONCATENATED MODULE: ./src/components/input/text-input/text-input.vue






/* normalize component */

var text_input_component = normalizeComponent(
  text_input_text_inputvue_type_script_lang_ts_,
  text_inputvue_type_template_id_2840dc56_scoped_true_render,
  text_inputvue_type_template_id_2840dc56_scoped_true_staticRenderFns,
  false,
  null,
  "2840dc56",
  null
  
)

/* harmony default export */ var text_input = (text_input_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/select/select.vue?vue&type=template&id=b645ef98&scoped=true&
var selectvue_type_template_id_b645ef98_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-input",class:{ 'has-error': _vm.errorMessage }},[_c('label',{class:{ 'sr-only': _vm.hideLabel },attrs:{"for":_vm.inputId}},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedItem),expression:"selectedItem"}],staticClass:"control",attrs:{"id":_vm.inputId,"name":_vm.name,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedItem=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.handleSelectChange()}]}},[_vm._t("default"),_vm._l((_vm.options),function(option){return _c('option',{key:_vm.getOptionKey(option),attrs:{"disabled":option.disabled},domProps:{"value":option.value}},[_vm._v(" "+_vm._s(option.label)+" ")])})],2)]),(_vm.errorMessage)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()])}
var selectvue_type_template_id_b645ef98_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/select/select.vue?vue&type=template&id=b645ef98&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.json.stringify.js
var es_json_stringify = __webpack_require__("e9c4");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/select/select.vue?vue&type=script&lang=ts&









var selectvue_type_script_lang_ts_NSelect = /*#__PURE__*/function (_Mixins) {
  _inherits(NSelect, _Mixins);

  var _super = _createSuper(NSelect);

  function NSelect() {
    var _this;

    _classCallCheck(this, NSelect);

    _this = _super.apply(this, arguments);
    _this.selectedItem = null;
    return _this;
  }

  _createClass(NSelect, [{
    key: "handleValueChange",
    value: function handleValueChange() {
      this.selectedItem = this.value;
    }
    /**
     * A helper method to generate a key to be used in v-for.
     * Uses id if defined else value.
     */

  }, {
    key: "getOptionKey",
    value: function getOptionKey(option) {
      if (option.id) {
        return option.id;
      }

      return JSON.stringify(option.value);
    }
  }, {
    key: "handleSelectChange",
    value: function handleSelectChange() {
      this.$emit('input', this.selectedItem);
    }
  }]);

  return NSelect;
}(mixins(id_generator));

__decorate([Prop()], selectvue_type_script_lang_ts_NSelect.prototype, "id", void 0);

__decorate([Prop()], selectvue_type_script_lang_ts_NSelect.prototype, "label", void 0);

__decorate([Prop()], selectvue_type_script_lang_ts_NSelect.prototype, "name", void 0);

__decorate([Prop()], selectvue_type_script_lang_ts_NSelect.prototype, "options", void 0);

__decorate([Prop()], selectvue_type_script_lang_ts_NSelect.prototype, "value", void 0);

__decorate([Prop({
  default: false
})], selectvue_type_script_lang_ts_NSelect.prototype, "disabled", void 0);

__decorate([Prop()], selectvue_type_script_lang_ts_NSelect.prototype, "errorMessage", void 0);

__decorate([Prop()], selectvue_type_script_lang_ts_NSelect.prototype, "hideLabel", void 0);

__decorate([Watch('value', {
  immediate: true
})], selectvue_type_script_lang_ts_NSelect.prototype, "handleValueChange", null);

selectvue_type_script_lang_ts_NSelect = __decorate([vue_class_component_esm({
  name: 'n-select'
})], selectvue_type_script_lang_ts_NSelect);
/* harmony default export */ var selectvue_type_script_lang_ts_ = (selectvue_type_script_lang_ts_NSelect);
// CONCATENATED MODULE: ./src/components/input/select/select.vue?vue&type=script&lang=ts&
 /* harmony default export */ var select_selectvue_type_script_lang_ts_ = (selectvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/input/select/select.vue?vue&type=style&index=0&id=b645ef98&lang=scss&scoped=true&
var selectvue_type_style_index_0_id_b645ef98_lang_scss_scoped_true_ = __webpack_require__("84d2");

// CONCATENATED MODULE: ./src/components/input/select/select.vue






/* normalize component */

var select_component = normalizeComponent(
  select_selectvue_type_script_lang_ts_,
  selectvue_type_template_id_b645ef98_scoped_true_render,
  selectvue_type_template_id_b645ef98_scoped_true_staticRenderFns,
  false,
  null,
  "b645ef98",
  null
  
)

/* harmony default export */ var select_select = (select_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/control/tooltip/tooltip.vue?vue&type=template&id=fc3075cc&scoped=true&
var tooltipvue_type_template_id_fc3075cc_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-tooltip"},[_c('div',{ref:"host",staticClass:"n-tooltip__trigger",on:{"mouseenter":_vm.handleMouseEnter,"mouseleave":_vm.handleMouseLeave}},[(!_vm.hasCustomContent)?_c('span',{staticClass:"n-tooltip__icon"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"24","viewBox":"0 0 24 24","width":"24"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48\n\t\t\t\t10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41\n\t\t\t\t0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8\n\t\t\t\t8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2\n\t\t\t\t2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"}})])]):_vm._e(),_vm._t("host")],2)])}
var tooltipvue_type_template_id_fc3075cc_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/control/tooltip/tooltip.vue?vue&type=template&id=fc3075cc&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/control/tooltip/tooltip-content.vue?vue&type=template&id=33e08654&scoped=true&
var tooltip_contentvue_type_template_id_33e08654_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"messageEl",staticClass:"n-tooltip__content",class:_vm.getTooltipClasses(),attrs:{"aria-hidden":_vm.hidden}},[_c('VNodeRenderer',{attrs:{"nodes":_vm.content}})],1)}
var tooltip_contentvue_type_template_id_33e08654_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/control/tooltip/tooltip-content.vue?vue&type=template&id=33e08654&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/control/tooltip/vnode-renderer.vue?vue&type=script&lang=ts&
/* harmony default export */ var vnode_renderervue_type_script_lang_ts_ = ({
  functional: true,
  render: function render(h, ctx) {
    var nodes = ctx.props.nodes;

    if (typeof nodes === 'string') {
      return h('span', nodes);
    }

    return ctx.props.nodes || h(ctx.props.nodes);
  }
});
// CONCATENATED MODULE: ./src/components/control/tooltip/vnode-renderer.vue?vue&type=script&lang=ts&
 /* harmony default export */ var tooltip_vnode_renderervue_type_script_lang_ts_ = (vnode_renderervue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/control/tooltip/vnode-renderer.vue
var vnode_renderer_render, vnode_renderer_staticRenderFns




/* normalize component */

var vnode_renderer_component = normalizeComponent(
  tooltip_vnode_renderervue_type_script_lang_ts_,
  vnode_renderer_render,
  vnode_renderer_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vnode_renderer = (vnode_renderer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/control/tooltip/tooltip-content.vue?vue&type=script&lang=ts&








var tooltip_contentvue_type_script_lang_ts_NTooltipContent = /*#__PURE__*/function (_Vue) {
  _inherits(NTooltipContent, _Vue);

  var _super = _createSuper(NTooltipContent);

  function NTooltipContent() {
    var _this;

    _classCallCheck(this, NTooltipContent);

    _this = _super.apply(this, arguments);
    _this.position = 'top';
    _this.offset = 5;
    _this.content = '';
    _this.hidden = true;
    return _this;
  }

  _createClass(NTooltipContent, [{
    key: "calculatePosition",
    value: function calculatePosition(hostPosition) {
      var messageEl = this.$refs.messageEl;
      var tooltipPosition = messageEl.getBoundingClientRect();
      var top = 0;
      var left = 0;
      var scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

      if (this.position === 'top') {
        top = hostPosition.top - tooltipPosition.height - this.offset;
        left = hostPosition.left + hostPosition.width / 2 - tooltipPosition.width / 2;
      }

      if (this.position === 'bottom') {
        top = hostPosition.bottom + this.offset;
        left = hostPosition.left + (hostPosition.width / 2 - tooltipPosition.width / 2);
      }

      if (this.position === 'left') {
        top = hostPosition.top + (hostPosition.height - tooltipPosition.height) / 2;
        left = Math.max(hostPosition.left - tooltipPosition.width - this.offset, 0);
      }

      if (this.position === 'right') {
        top = hostPosition.top + (hostPosition.height - tooltipPosition.height) / 2;
        left = hostPosition.right + this.offset;
      }

      messageEl.style.left = "".concat(left, "px");
      messageEl.style.top = "".concat(top + scrollPosition, "px");
    }
  }, {
    key: "getTooltipClasses",
    value: function getTooltipClasses() {
      return {
        'n-tooltip__content--top': this.position === 'top',
        'n-tooltip__content--hidden': this.hidden,
        'n-tooltip__content--bottom': this.position === 'bottom',
        'n-tooltip__content--left': this.position === 'left',
        'n-tooltip__content--right': this.position === 'right'
      };
    }
  }, {
    key: "remove",
    value: function remove() {
      var parent = this.$el.parentNode;
      this.$destroy();

      if (parent) {
        parent.removeChild(this.$el);
      }
    }
  }]);

  return NTooltipContent;
}(external_vue_default.a);

tooltip_contentvue_type_script_lang_ts_NTooltipContent = __decorate([vue_class_component_esm({
  name: 'n-tooltip-content',
  components: {
    VNodeRenderer: vnode_renderer
  }
})], tooltip_contentvue_type_script_lang_ts_NTooltipContent);
/* harmony default export */ var tooltip_contentvue_type_script_lang_ts_ = (tooltip_contentvue_type_script_lang_ts_NTooltipContent);
// CONCATENATED MODULE: ./src/components/control/tooltip/tooltip-content.vue?vue&type=script&lang=ts&
 /* harmony default export */ var tooltip_tooltip_contentvue_type_script_lang_ts_ = (tooltip_contentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/control/tooltip/tooltip-content.vue?vue&type=style&index=0&id=33e08654&lang=scss&scoped=true&
var tooltip_contentvue_type_style_index_0_id_33e08654_lang_scss_scoped_true_ = __webpack_require__("f0b2");

// CONCATENATED MODULE: ./src/components/control/tooltip/tooltip-content.vue






/* normalize component */

var tooltip_content_component = normalizeComponent(
  tooltip_tooltip_contentvue_type_script_lang_ts_,
  tooltip_contentvue_type_template_id_33e08654_scoped_true_render,
  tooltip_contentvue_type_template_id_33e08654_scoped_true_staticRenderFns,
  false,
  null,
  "33e08654",
  null
  
)

/* harmony default export */ var tooltip_content = (tooltip_content_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/control/tooltip/tooltip.vue?vue&type=script&lang=ts&





/* eslint-disable operator-linebreak */




var tooltipvue_type_script_lang_ts_NTooltip = /*#__PURE__*/function (_Vue) {
  _inherits(NTooltip, _Vue);

  var _super = _createSuper(NTooltip);

  function NTooltip() {
    var _this;

    _classCallCheck(this, NTooltip);

    _this = _super.apply(this, arguments);
    _this.displayMessage = false;
    return _this;
  }

  _createClass(NTooltip, [{
    key: "onContentChange",
    value: function onContentChange() {
      if (this.tooltipElement) {
        this.tooltipElement.remove();
      }

      this.generateTooltipContentElement();
    }
  }, {
    key: "onPositionChange",
    value: function onPositionChange() {
      if (this.tooltipElement) {
        this.tooltipElement.position = this.position;
      }
    }
    /* Lifecycle hooks */

  }, {
    key: "mounted",
    value: function mounted() {
      if (this.tooltipElement) {
        this.tooltipElement.remove();
      }

      this.generateTooltipContentElement();
      this.tooltipHost = this.$refs.host;
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      if (this.tooltipElement) {
        this.tooltipElement.remove();
      }
    }
    /* Public methods */

  }, {
    key: "handleMouseEnter",
    value: function handleMouseEnter() {
      this.calculateTooltipPosition();
      this.tooltipElement.hidden = false;
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      this.tooltipElement.hidden = true;
    }
  }, {
    key: "hasCustomContent",
    get: function get() {
      return !!this.$slots.host && !!this.$slots.host[0];
    }
  }, {
    key: "calculateTooltipPosition",
    value: function calculateTooltipPosition() {
      var hostPosition = this.tooltipHost.getBoundingClientRect();
      this.tooltipElement.calculatePosition(hostPosition);
    }
    /* Private methods */

  }, {
    key: "generateTooltipContentElement",
    value: function generateTooltipContentElement() {
      this.tooltipContentHost = document.createElement('div');
      document.body.appendChild(this.tooltipContentHost);
      this.tooltipElement = new tooltip_content();
      this.tooltipElement.content = this.generateTooltipContent();
      this.tooltipElement.position = this.position;
      this.tooltipElement.$mount(this.tooltipContentHost);
    }
  }, {
    key: "generateTooltipContent",
    value: function generateTooltipContent() {
      if (this.$slots.messageSlot && this.$slots.messageSlot.length) {
        return this.$slots.messageSlot[0];
      }

      return this.text;
    }
  }]);

  return NTooltip;
}(external_vue_default.a);

__decorate([Prop({
  default: ''
})], tooltipvue_type_script_lang_ts_NTooltip.prototype, "text", void 0);

__decorate([Prop({
  default: 'top'
})], tooltipvue_type_script_lang_ts_NTooltip.prototype, "position", void 0);

__decorate([Watch('text')], tooltipvue_type_script_lang_ts_NTooltip.prototype, "onContentChange", null);

__decorate([Watch('position')], tooltipvue_type_script_lang_ts_NTooltip.prototype, "onPositionChange", null);

tooltipvue_type_script_lang_ts_NTooltip = __decorate([vue_class_component_esm({
  name: 'n-tooltip'
})], tooltipvue_type_script_lang_ts_NTooltip);
/* harmony default export */ var tooltipvue_type_script_lang_ts_ = (tooltipvue_type_script_lang_ts_NTooltip);
// CONCATENATED MODULE: ./src/components/control/tooltip/tooltip.vue?vue&type=script&lang=ts&
 /* harmony default export */ var tooltip_tooltipvue_type_script_lang_ts_ = (tooltipvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/control/tooltip/tooltip.vue?vue&type=style&index=0&id=fc3075cc&lang=scss&scoped=true&
var tooltipvue_type_style_index_0_id_fc3075cc_lang_scss_scoped_true_ = __webpack_require__("c2b8");

// CONCATENATED MODULE: ./src/components/control/tooltip/tooltip.vue






/* normalize component */

var tooltip_component = normalizeComponent(
  tooltip_tooltipvue_type_script_lang_ts_,
  tooltipvue_type_template_id_fc3075cc_scoped_true_render,
  tooltipvue_type_template_id_fc3075cc_scoped_true_staticRenderFns,
  false,
  null,
  "fc3075cc",
  null
  
)

/* harmony default export */ var tooltip = (tooltip_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/layout/checkbox-group/checkbox-group.vue?vue&type=template&id=0e84e2fa&scoped=true&
var checkbox_groupvue_type_template_id_0e84e2fa_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-input",class:{ 'has-error': _vm.errorMessage }},[_c('fieldset',{staticClass:"checkbox-group",attrs:{"id":_vm.id,"name":_vm.name}},[_c('legend',{class:{ 'sr-only': _vm.hideLabel }},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"checkbox-group__checkboxes"},[_vm._t("default")],2)]),(_vm.errorMessage)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()])}
var checkbox_groupvue_type_template_id_0e84e2fa_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/layout/checkbox-group/checkbox-group.vue?vue&type=template&id=0e84e2fa&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/checkbox/checkbox.vue?vue&type=template&id=7c1b07f3&scoped=true&
var checkboxvue_type_template_id_7c1b07f3_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-input checkbox",class:{ 'has-error': _vm.errorMessage }},[_c('div',{staticClass:"checkbox__input-container"},[_c('input',{attrs:{"type":"checkbox","name":_vm.name,"id":_vm.inputId,"disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":_vm.handleCheckboxChange}}),_c('label',{staticClass:"checkbox__label",class:{
				'checkbox__label--disabled': _vm.disabled
			},attrs:{"for":_vm.inputId}},[_vm._v(" "+_vm._s(_vm.label)+" ")])]),(_vm.errorMessage)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()])}
var checkboxvue_type_template_id_7c1b07f3_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/checkbox/checkbox.vue?vue&type=template&id=7c1b07f3&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/checkbox/checkbox.vue?vue&type=script&lang=ts&








var checkboxvue_type_script_lang_ts_NCheckbox = /*#__PURE__*/function (_Mixins) {
  _inherits(NCheckbox, _Mixins);

  var _super = _createSuper(NCheckbox);

  function NCheckbox() {
    _classCallCheck(this, NCheckbox);

    return _super.apply(this, arguments);
  }

  _createClass(NCheckbox, [{
    key: "handleCheckboxChange",
    value: function handleCheckboxChange($event) {
      var target = $event.currentTarget;
      this.$emit('input', target.checked);
      this.$emit('change', target.checked);
    }
  }]);

  return NCheckbox;
}(mixins(id_generator));

__decorate([Prop()], checkboxvue_type_script_lang_ts_NCheckbox.prototype, "id", void 0);

__decorate([Prop()], checkboxvue_type_script_lang_ts_NCheckbox.prototype, "label", void 0);

__decorate([Prop()], checkboxvue_type_script_lang_ts_NCheckbox.prototype, "name", void 0);

__decorate([Prop()], checkboxvue_type_script_lang_ts_NCheckbox.prototype, "errorMessage", void 0);

__decorate([Prop()], checkboxvue_type_script_lang_ts_NCheckbox.prototype, "checked", void 0);

__decorate([Prop()], checkboxvue_type_script_lang_ts_NCheckbox.prototype, "disabled", void 0);

checkboxvue_type_script_lang_ts_NCheckbox = __decorate([vue_class_component_esm({
  name: 'n-checkbox'
})], checkboxvue_type_script_lang_ts_NCheckbox);
/* harmony default export */ var checkboxvue_type_script_lang_ts_ = (checkboxvue_type_script_lang_ts_NCheckbox);
// CONCATENATED MODULE: ./src/components/input/checkbox/checkbox.vue?vue&type=script&lang=ts&
 /* harmony default export */ var checkbox_checkboxvue_type_script_lang_ts_ = (checkboxvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/input/checkbox/checkbox.vue?vue&type=style&index=0&id=7c1b07f3&lang=scss&scoped=true&
var checkboxvue_type_style_index_0_id_7c1b07f3_lang_scss_scoped_true_ = __webpack_require__("c573");

// CONCATENATED MODULE: ./src/components/input/checkbox/checkbox.vue






/* normalize component */

var checkbox_component = normalizeComponent(
  checkbox_checkboxvue_type_script_lang_ts_,
  checkboxvue_type_template_id_7c1b07f3_scoped_true_render,
  checkboxvue_type_template_id_7c1b07f3_scoped_true_staticRenderFns,
  false,
  null,
  "7c1b07f3",
  null
  
)

/* harmony default export */ var checkbox_checkbox = (checkbox_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/layout/checkbox-group/checkbox-group.vue?vue&type=script&lang=ts&








var checkbox_groupvue_type_script_lang_ts_NCheckboxGroup = /*#__PURE__*/function (_Vue) {
  _inherits(NCheckboxGroup, _Vue);

  var _super = _createSuper(NCheckboxGroup);

  function NCheckboxGroup() {
    _classCallCheck(this, NCheckboxGroup);

    return _super.apply(this, arguments);
  }

  return _createClass(NCheckboxGroup);
}(external_vue_default.a);

__decorate([Prop()], checkbox_groupvue_type_script_lang_ts_NCheckboxGroup.prototype, "id", void 0);

__decorate([Prop()], checkbox_groupvue_type_script_lang_ts_NCheckboxGroup.prototype, "label", void 0);

__decorate([Prop()], checkbox_groupvue_type_script_lang_ts_NCheckboxGroup.prototype, "name", void 0);

__decorate([Prop()], checkbox_groupvue_type_script_lang_ts_NCheckboxGroup.prototype, "errorMessage", void 0);

__decorate([Prop()], checkbox_groupvue_type_script_lang_ts_NCheckboxGroup.prototype, "hideLabel", void 0);

checkbox_groupvue_type_script_lang_ts_NCheckboxGroup = __decorate([vue_class_component_esm({
  name: 'n-checkbox-group',
  components: {
    NCheckbox: checkbox_checkbox
  }
})], checkbox_groupvue_type_script_lang_ts_NCheckboxGroup);
/* harmony default export */ var checkbox_groupvue_type_script_lang_ts_ = (checkbox_groupvue_type_script_lang_ts_NCheckboxGroup);
// CONCATENATED MODULE: ./src/components/layout/checkbox-group/checkbox-group.vue?vue&type=script&lang=ts&
 /* harmony default export */ var checkbox_group_checkbox_groupvue_type_script_lang_ts_ = (checkbox_groupvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/layout/checkbox-group/checkbox-group.vue?vue&type=style&index=0&id=0e84e2fa&lang=scss&scoped=true&
var checkbox_groupvue_type_style_index_0_id_0e84e2fa_lang_scss_scoped_true_ = __webpack_require__("a503");

// CONCATENATED MODULE: ./src/components/layout/checkbox-group/checkbox-group.vue






/* normalize component */

var checkbox_group_component = normalizeComponent(
  checkbox_group_checkbox_groupvue_type_script_lang_ts_,
  checkbox_groupvue_type_template_id_0e84e2fa_scoped_true_render,
  checkbox_groupvue_type_template_id_0e84e2fa_scoped_true_staticRenderFns,
  false,
  null,
  "0e84e2fa",
  null
  
)

/* harmony default export */ var checkbox_group = (checkbox_group_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/colour-picker/colour-picker.vue?vue&type=template&id=fcc30a16&scoped=true&
var colour_pickervue_type_template_id_fcc30a16_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colour-picker n-input"},[_c('div',{staticClass:"colour-picker__wrapper"},[_c('label',{staticClass:"colour-picker__label",class:{ 'sr-only': _vm.hideLabel },attrs:{"for":_vm.inputId}},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"colour-picker__input-wrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentColour),expression:"currentColour"}],staticClass:"colour-picker__input",attrs:{"type":"text","id":_vm.inputId,"maxlength":"7"},domProps:{"value":(_vm.currentColour)},on:{"blur":function($event){return _vm.setColour($event.target.value)},"input":function($event){if($event.target.composing){ return; }_vm.currentColour=$event.target.value}}}),_c('div',{staticClass:"colour-picker__trigger"},[_c('div',{ref:"pickerHost",attrs:{"id":_vm.id + '__trigger'}})])]),(_vm.errorMessage)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()])])}
var colour_pickervue_type_template_id_fcc30a16_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/colour-picker/colour-picker.vue?vue&type=template&id=fcc30a16&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("25f0");

// EXTERNAL MODULE: ./node_modules/@simonwep/pickr/dist/pickr.min.js
var pickr_min = __webpack_require__("eae0");
var pickr_min_default = /*#__PURE__*/__webpack_require__.n(pickr_min);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/colour-picker/colour-picker.vue?vue&type=script&lang=ts&











var colour_pickervue_type_script_lang_ts_NColourPicker = /*#__PURE__*/function (_Mixins) {
  _inherits(NColourPicker, _Mixins);

  var _super = _createSuper(NColourPicker);

  function NColourPicker() {
    var _this;

    _classCallCheck(this, NColourPicker);

    _this = _super.apply(this, arguments);
    _this.currentColour = _this.value;
    return _this;
  }

  _createClass(NColourPicker, [{
    key: "onValueChanged",
    value: function onValueChanged(value) {
      // fires 'change' event
      this.pickr.setColor(value);
    }
  }, {
    key: "setColour",
    value: function setColour(colour) {
      // fires 'change' event
      if (!this.pickr.setColor(colour)) {
        this.currentColour = this.value;
      }
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      var pickerHost = this.$refs.pickerHost;

      if (!pickerHost) {
        // If the host element isn't defined, just return.
        return;
      }

      this.pickr = pickr_min_default.a.create({
        el: pickerHost,
        theme: 'monolith',
        lockOpacity: true,
        default: this.value,
        position: 'bottom-start',
        components: {
          preview: false,
          opacity: false,
          hue: true,
          interaction: {
            clear: false,
            input: false,
            save: false
          }
        }
      });
      this.pickr.on('change', function (colour, instance) {
        // fires 'save' event
        _this2.pickr.applyColor();
      });
      this.pickr.on('save', function (colour, instance) {
        _this2.currentColour = colour.toHEXA().toString();

        _this2.$emit('input', _this2.currentColour);
      });
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      if (this.pickr) {
        this.pickr.destroyAndRemove();
      }
    }
  }]);

  return NColourPicker;
}(mixins(id_generator));

__decorate([Prop()], colour_pickervue_type_script_lang_ts_NColourPicker.prototype, "id", void 0);

__decorate([Prop({
  default: '#062B80'
})], colour_pickervue_type_script_lang_ts_NColourPicker.prototype, "value", void 0);

__decorate([Prop({
  default: ''
})], colour_pickervue_type_script_lang_ts_NColourPicker.prototype, "label", void 0);

__decorate([Prop()], colour_pickervue_type_script_lang_ts_NColourPicker.prototype, "errorMessage", void 0);

__decorate([Prop()], colour_pickervue_type_script_lang_ts_NColourPicker.prototype, "hideLabel", void 0);

__decorate([Watch('value')], colour_pickervue_type_script_lang_ts_NColourPicker.prototype, "onValueChanged", null);

colour_pickervue_type_script_lang_ts_NColourPicker = __decorate([vue_class_component_esm({
  name: 'n-colour-picker'
})], colour_pickervue_type_script_lang_ts_NColourPicker);
/* harmony default export */ var colour_pickervue_type_script_lang_ts_ = (colour_pickervue_type_script_lang_ts_NColourPicker);
// CONCATENATED MODULE: ./src/components/input/colour-picker/colour-picker.vue?vue&type=script&lang=ts&
 /* harmony default export */ var colour_picker_colour_pickervue_type_script_lang_ts_ = (colour_pickervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./node_modules/@simonwep/pickr/dist/themes/monolith.min.css?vue&type=style&index=0&lang=css&
var monolith_minvue_type_style_index_0_lang_css_ = __webpack_require__("8fb9");

// EXTERNAL MODULE: ./node_modules/@simonwep/pickr/dist/themes/classic.min.css?vue&type=style&index=1&lang=css&
var classic_minvue_type_style_index_1_lang_css_ = __webpack_require__("5756");

// EXTERNAL MODULE: ./src/components/input/colour-picker/colour-picker.vue?vue&type=style&index=2&id=fcc30a16&scoped=true&lang=scss&
var colour_pickervue_type_style_index_2_id_fcc30a16_scoped_true_lang_scss_ = __webpack_require__("7e6e");

// CONCATENATED MODULE: ./src/components/input/colour-picker/colour-picker.vue








/* normalize component */

var colour_picker_component = normalizeComponent(
  colour_picker_colour_pickervue_type_script_lang_ts_,
  colour_pickervue_type_template_id_fcc30a16_scoped_true_render,
  colour_pickervue_type_template_id_fcc30a16_scoped_true_staticRenderFns,
  false,
  null,
  "fcc30a16",
  null
  
)

/* harmony default export */ var colour_picker = (colour_picker_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/radio-button/radio-button.vue?vue&type=template&id=12681963&scoped=true&
var radio_buttonvue_type_template_id_12681963_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-input",class:{ 'has-error': _vm.errorMessage }},[_c('fieldset',{staticClass:"radio-button-group",attrs:{"disabled":_vm.disabled,"id":_vm.inputId,"name":_vm.name}},[_c('legend',{class:{ 'sr-only': _vm.hideLabel }},[_vm._v(_vm._s(_vm.label))]),_vm._l((_vm.options),function(option,index){return _c('div',{key:option.label,staticClass:"radio-button"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],attrs:{"type":"radio","disabled":option.disabled,"id":(_vm.inputId + "__" + index)},domProps:{"value":option,"checked":_vm._q(_vm.selected,option)},on:{"change":[function($event){_vm.selected=option},function($event){return _vm.handleRadioChange()}]}}),_c('label',{staticClass:"radio-button__label",class:{
					'radio-button__label--checked': _vm.selected === option,
					'radio-button__label--disabled': option.disabled || _vm.disabled
				},attrs:{"for":(_vm.inputId + "__" + index)}},[_vm._v(" "+_vm._s(option.label)+" ")])])})],2),(_vm.errorMessage)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()])}
var radio_buttonvue_type_template_id_12681963_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/radio-button/radio-button.vue?vue&type=template&id=12681963&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("7db0");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/radio-button/radio-button.vue?vue&type=script&lang=ts&










var radio_buttonvue_type_script_lang_ts_NRadioButtons = /*#__PURE__*/function (_Mixins) {
  _inherits(NRadioButtons, _Mixins);

  var _super = _createSuper(NRadioButtons);

  function NRadioButtons() {
    var _this;

    _classCallCheck(this, NRadioButtons);

    _this = _super.apply(this, arguments);
    _this.selected = _this.options[0];
    return _this;
  }

  _createClass(NRadioButtons, [{
    key: "handleValueChange",
    value: function handleValueChange(value) {
      this.selected = this.options.find(function (option) {
        return option.value === value;
      });
    }
  }, {
    key: "created",
    value: function created() {
      // Call the handleIdChange method to set up the Id
      this.handleIdChange(); // Call the handleValueChange method to correctly set the selected property

      this.handleValueChange(this.value);
    }
  }, {
    key: "handleRadioChange",
    value: function handleRadioChange() {
      this.$emit('input', this.selected.value);
      this.$emit('change', this.selected.value);
    }
  }]);

  return NRadioButtons;
}(mixins(id_generator));

__decorate([Prop()], radio_buttonvue_type_script_lang_ts_NRadioButtons.prototype, "id", void 0);

__decorate([Prop()], radio_buttonvue_type_script_lang_ts_NRadioButtons.prototype, "label", void 0);

__decorate([Prop()], radio_buttonvue_type_script_lang_ts_NRadioButtons.prototype, "name", void 0);

__decorate([Prop()], radio_buttonvue_type_script_lang_ts_NRadioButtons.prototype, "options", void 0);

__decorate([Prop()], radio_buttonvue_type_script_lang_ts_NRadioButtons.prototype, "value", void 0);

__decorate([Prop()], radio_buttonvue_type_script_lang_ts_NRadioButtons.prototype, "errorMessage", void 0);

__decorate([Prop()], radio_buttonvue_type_script_lang_ts_NRadioButtons.prototype, "disabled", void 0);

__decorate([Prop()], radio_buttonvue_type_script_lang_ts_NRadioButtons.prototype, "hideLabel", void 0);

__decorate([Watch('value')], radio_buttonvue_type_script_lang_ts_NRadioButtons.prototype, "handleValueChange", null);

radio_buttonvue_type_script_lang_ts_NRadioButtons = __decorate([vue_class_component_esm({
  name: 'n-radio-buttons'
})], radio_buttonvue_type_script_lang_ts_NRadioButtons);
/* harmony default export */ var radio_buttonvue_type_script_lang_ts_ = (radio_buttonvue_type_script_lang_ts_NRadioButtons);
// CONCATENATED MODULE: ./src/components/input/radio-button/radio-button.vue?vue&type=script&lang=ts&
 /* harmony default export */ var radio_button_radio_buttonvue_type_script_lang_ts_ = (radio_buttonvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/input/radio-button/radio-button.vue?vue&type=style&index=0&id=12681963&lang=scss&scoped=true&
var radio_buttonvue_type_style_index_0_id_12681963_lang_scss_scoped_true_ = __webpack_require__("1ea6");

// CONCATENATED MODULE: ./src/components/input/radio-button/radio-button.vue






/* normalize component */

var radio_button_component = normalizeComponent(
  radio_button_radio_buttonvue_type_script_lang_ts_,
  radio_buttonvue_type_template_id_12681963_scoped_true_render,
  radio_buttonvue_type_template_id_12681963_scoped_true_staticRenderFns,
  false,
  null,
  "12681963",
  null
  
)

/* harmony default export */ var radio_button = (radio_button_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/layout/button-group/button-group.vue?vue&type=template&id=52123fc9&scoped=true&
var button_groupvue_type_template_id_52123fc9_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-group"},[_vm._t("default")],2)}
var button_groupvue_type_template_id_52123fc9_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/layout/button-group/button-group.vue?vue&type=template&id=52123fc9&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/layout/button-group/button-group.vue?vue&type=script&lang=ts&







var button_groupvue_type_script_lang_ts_NButtonGroup = /*#__PURE__*/function (_Vue) {
  _inherits(NButtonGroup, _Vue);

  var _super = _createSuper(NButtonGroup);

  function NButtonGroup() {
    _classCallCheck(this, NButtonGroup);

    return _super.apply(this, arguments);
  }

  return _createClass(NButtonGroup);
}(external_vue_default.a);

button_groupvue_type_script_lang_ts_NButtonGroup = __decorate([vue_class_component_esm({
  name: 'n-button-group'
})], button_groupvue_type_script_lang_ts_NButtonGroup);
/* harmony default export */ var button_groupvue_type_script_lang_ts_ = (button_groupvue_type_script_lang_ts_NButtonGroup);
// CONCATENATED MODULE: ./src/components/layout/button-group/button-group.vue?vue&type=script&lang=ts&
 /* harmony default export */ var button_group_button_groupvue_type_script_lang_ts_ = (button_groupvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/layout/button-group/button-group.vue?vue&type=style&index=0&id=52123fc9&lang=scss&scoped=true&
var button_groupvue_type_style_index_0_id_52123fc9_lang_scss_scoped_true_ = __webpack_require__("9004");

// CONCATENATED MODULE: ./src/components/layout/button-group/button-group.vue






/* normalize component */

var button_group_component = normalizeComponent(
  button_group_button_groupvue_type_script_lang_ts_,
  button_groupvue_type_template_id_52123fc9_scoped_true_render,
  button_groupvue_type_template_id_52123fc9_scoped_true_staticRenderFns,
  false,
  null,
  "52123fc9",
  null
  
)

/* harmony default export */ var button_group = (button_group_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/read-only-input/read-only-input.vue?vue&type=template&id=7c28b1ce&
var read_only_inputvue_type_template_id_7c28b1ce_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-input n-readonly-input"},[_c('n-split-input-button',{attrs:{"label":_vm.label,"hideLabel":_vm.hideLabel,"helpText":_vm.helpText,"id":_vm.inputId,"value":_vm.readonlyValue},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('n-text-input',{staticClass:"n-readonly-input__input",attrs:{"disabled":true,"id":_vm.inputId},model:{value:(_vm.readonlyValue),callback:function ($$v) {_vm.readonlyValue=$$v},expression:"readonlyValue"}})]},proxy:true},{key:"button",fn:function(){return [_c('n-button',{staticClass:"n-readonly-input__button",attrs:{"icon":"copy"},on:{"click":_vm.copyValue}})]},proxy:true}])})],1)}
var read_only_inputvue_type_template_id_7c28b1ce_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/read-only-input/read-only-input.vue?vue&type=template&id=7c28b1ce&

// EXTERNAL MODULE: ./node_modules/v-clipboard/dist/index.min.js
var index_min = __webpack_require__("4ae6");
var index_min_default = /*#__PURE__*/__webpack_require__.n(index_min);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/split-input-button/split-input-button.vue?vue&type=template&id=44831aca&scoped=true&
var split_input_buttonvue_type_template_id_44831aca_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-split-input-button n-input",class:{ 'has-error': _vm.errorMessage }},[_c('label',{staticClass:"n-split-input-button__label",class:{ 'sr-only': _vm.hideLabel },attrs:{"for":_vm.inputId}},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"n-split-input-button__wrapper"},[_vm._t("input"),_c('div',{staticClass:"n-split-input-button__btn-wrapper"},[_vm._t("button"),(!_vm.$slots.button)?[_c('n-button',{staticClass:"n-split-input-button__button",attrs:{"icon":_vm.icon},on:{"click":function($event){return _vm.$emit('buttonClick')}}})]:_vm._e()],2)],2),_c('span',{staticClass:"help-text",domProps:{"innerHTML":_vm._s(_vm.helpText)}}),_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errorMessage))])])}
var split_input_buttonvue_type_template_id_44831aca_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/split-input-button/split-input-button.vue?vue&type=template&id=44831aca&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/split-input-button/split-input-button.vue?vue&type=script&lang=ts&










var split_input_buttonvue_type_script_lang_ts_NSplitInputButton = /*#__PURE__*/function (_Mixins) {
  _inherits(NSplitInputButton, _Mixins);

  var _super = _createSuper(NSplitInputButton);

  function NSplitInputButton() {
    var _this;

    _classCallCheck(this, NSplitInputButton);

    _this = _super.apply(this, arguments);
    _this.idPrefix = 'n-split-input-button_';
    return _this;
  }

  return _createClass(NSplitInputButton);
}(mixins(id_generator));

__decorate([Prop()], split_input_buttonvue_type_script_lang_ts_NSplitInputButton.prototype, "id", void 0);

__decorate([Prop()], split_input_buttonvue_type_script_lang_ts_NSplitInputButton.prototype, "icon", void 0);

__decorate([Prop()], split_input_buttonvue_type_script_lang_ts_NSplitInputButton.prototype, "label", void 0);

__decorate([Prop()], split_input_buttonvue_type_script_lang_ts_NSplitInputButton.prototype, "hideLabel", void 0);

__decorate([Prop()], split_input_buttonvue_type_script_lang_ts_NSplitInputButton.prototype, "helpText", void 0);

__decorate([Prop()], split_input_buttonvue_type_script_lang_ts_NSplitInputButton.prototype, "value", void 0);

__decorate([Prop()], split_input_buttonvue_type_script_lang_ts_NSplitInputButton.prototype, "errorMessage", void 0);

split_input_buttonvue_type_script_lang_ts_NSplitInputButton = __decorate([vue_class_component_esm({
  name: 'n-split-input-button',
  components: {
    NButton: button_button,
    NTextInput: text_input
  }
})], split_input_buttonvue_type_script_lang_ts_NSplitInputButton);
/* harmony default export */ var split_input_buttonvue_type_script_lang_ts_ = (split_input_buttonvue_type_script_lang_ts_NSplitInputButton);
// CONCATENATED MODULE: ./src/components/input/split-input-button/split-input-button.vue?vue&type=script&lang=ts&
 /* harmony default export */ var split_input_button_split_input_buttonvue_type_script_lang_ts_ = (split_input_buttonvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/input/split-input-button/split-input-button.vue?vue&type=style&index=0&id=44831aca&lang=scss&scoped=true&
var split_input_buttonvue_type_style_index_0_id_44831aca_lang_scss_scoped_true_ = __webpack_require__("815f");

// CONCATENATED MODULE: ./src/components/input/split-input-button/split-input-button.vue






/* normalize component */

var split_input_button_component = normalizeComponent(
  split_input_button_split_input_buttonvue_type_script_lang_ts_,
  split_input_buttonvue_type_template_id_44831aca_scoped_true_render,
  split_input_buttonvue_type_template_id_44831aca_scoped_true_staticRenderFns,
  false,
  null,
  "44831aca",
  null
  
)

/* harmony default export */ var split_input_button = (split_input_button_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/read-only-input/read-only-input.vue?vue&type=script&lang=ts&




 // eslint-disable-next-line object-curly-newline







external_vue_default.a.use(index_min_default.a);

var read_only_inputvue_type_script_lang_ts_NReadOnlyInput = /*#__PURE__*/function (_Mixins) {
  _inherits(NReadOnlyInput, _Mixins);

  var _super = _createSuper(NReadOnlyInput);

  function NReadOnlyInput() {
    var _this;

    _classCallCheck(this, NReadOnlyInput);

    _this = _super.apply(this, arguments);
    _this.readonlyValue = '';
    return _this;
  }

  _createClass(NReadOnlyInput, [{
    key: "handleValueChange",
    value: function handleValueChange() {
      this.readonlyValue = this.value;
    }
  }, {
    key: "onCopy",
    value: function onCopy() {
      this.$emit('copy');
    }
  }, {
    key: "copyValue",
    value: function copyValue() {
      this.$clipboard(this.readonlyValue);
      this.onCopy();
    }
  }]);

  return NReadOnlyInput;
}(mixins(id_generator));

__decorate([Prop()], read_only_inputvue_type_script_lang_ts_NReadOnlyInput.prototype, "label", void 0);

__decorate([Prop()], read_only_inputvue_type_script_lang_ts_NReadOnlyInput.prototype, "helpText", void 0);

__decorate([Prop()], read_only_inputvue_type_script_lang_ts_NReadOnlyInput.prototype, "value", void 0);

__decorate([Prop()], read_only_inputvue_type_script_lang_ts_NReadOnlyInput.prototype, "id", void 0);

__decorate([Prop()], read_only_inputvue_type_script_lang_ts_NReadOnlyInput.prototype, "hideLabel", void 0);

__decorate([Watch('value', {
  immediate: true
})], read_only_inputvue_type_script_lang_ts_NReadOnlyInput.prototype, "handleValueChange", null);

read_only_inputvue_type_script_lang_ts_NReadOnlyInput = __decorate([vue_class_component_esm({
  name: 'n-readonly-input',
  components: {
    NButton: button_button,
    NSplitInputButton: split_input_button,
    NTextInput: text_input
  }
})], read_only_inputvue_type_script_lang_ts_NReadOnlyInput);
/* harmony default export */ var read_only_inputvue_type_script_lang_ts_ = (read_only_inputvue_type_script_lang_ts_NReadOnlyInput);
// CONCATENATED MODULE: ./src/components/input/read-only-input/read-only-input.vue?vue&type=script&lang=ts&
 /* harmony default export */ var read_only_input_read_only_inputvue_type_script_lang_ts_ = (read_only_inputvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/input/read-only-input/read-only-input.vue





/* normalize component */

var read_only_input_component = normalizeComponent(
  read_only_input_read_only_inputvue_type_script_lang_ts_,
  read_only_inputvue_type_template_id_7c28b1ce_render,
  read_only_inputvue_type_template_id_7c28b1ce_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var read_only_input = (read_only_input_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/datatable/datatable.vue?vue&type=template&id=2bb6b88c&scoped=true&
var datatablevue_type_template_id_2bb6b88c_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-data-table"},[(_vm.hasResults() || _vm.isLoading)?_c('div',{staticClass:"data-table__container"},[(_vm.hasResults() && !_vm.isLoading)?_c('table',{staticClass:"n-table"},[_c('thead',[_c('tr',[_vm._l((_vm.columns),function(column){return _c('th',{key:column.name,class:{ 'th--with-icon': column.icon }},[_c('div',{staticClass:"column-heading"},[(column.sortable)?_c('div',{staticClass:"data-table__column",class:{ sortable: column.sortable }},[(column.sortable)?_c('div',{staticClass:"column__sort-trigger",attrs:{"role":"button","tabindex":"0"},on:{"click":function($event){return _vm.handleColumnClick(column.name)},"keypress":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleColumnClick(column.name)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.handleColumnClick(column.name)}]}},[(column.icon)?_c('n-icon',{attrs:{"icon":column.icon}}):_vm._e(),_vm._v(" "+_vm._s(column.display)+" "),_c('div',{class:_vm.getSortClass(column.name)})],1):_vm._e()]):_vm._e(),(!column.sortable)?_c('div',{staticClass:"data-table__column"},[(column.icon)?_c('n-icon',{attrs:{"icon":column.icon}}):_vm._e(),_vm._v(" "+_vm._s(column.display)+" ")],1):_vm._e()])])}),(!!_vm.$scopedSlots['actions'])?_c('th'):_vm._e()],2)]),_c('tbody',_vm._l((_vm.items),function(row){return _c('tr',{key:row.id,staticClass:"data-item"},[_vm._l((_vm.columns),function(column){return _c('td',{key:column.name,staticClass:"data-cell",class:{ 'cell-wrap': column.wrappable }},[(!_vm.$scopedSlots[column.name] && !column.formatter)?_c('div',{staticClass:"default-cell-display"},[(_vm.isCellClickable(row, column.clickable))?_c('a',{staticClass:"clickable-cell",on:{"click":function($event){return _vm.cellClicked(row)}}},[_vm._v(" "+_vm._s(row[column.name])+" ")]):_vm._e(),(!_vm.isCellClickable(row, column.clickable))?_c('span',[_vm._v(" "+_vm._s(row[column.name])+" ")]):_vm._e()]):_vm._e(),(!_vm.$scopedSlots[column.name] && column.formatter)?_c('div',[(_vm.isCellClickable(row, column.clickable))?_c('a',{staticClass:"clickable-cell",on:{"click":function($event){return _vm.cellClicked(row)}}},[_vm._v(" "+_vm._s(column.formatter(row[column.name]))+" ")]):_vm._e(),(!_vm.isCellClickable(row, column.clickable))?_c('span',[_vm._v(" "+_vm._s(column.formatter(row[column.name]))+" ")]):_vm._e()]):_vm._e(),(!!_vm.$scopedSlots[column.name])?_vm._t(column.name,null,{"row":row}):_vm._e()],2)}),(!!_vm.$scopedSlots['actions'])?_c('td',{staticClass:"actions-column"},[_vm._t("actions",null,{"row":row})],2):_vm._e()],2)}),0)]):_vm._e(),(_vm.isLoading)?_c('div',{staticClass:"loading-spinner-container"},[_c('div',{staticClass:"loading-spinner"},[_c('n-loading-spinner')],1)]):_vm._e()]):_vm._e(),(_vm.pagination && _vm.hasResults())?_c('n-pagination',{attrs:{"itemsTotal":_vm.itemsTotal,"itemsPerPage":_vm.itemsPerPage},on:{"page-changed":_vm.onPageChanged}}):_vm._e(),(!_vm.hasResults() && !_vm.isLoading)?_vm._t("nodata"):_vm._e()],2)}
var datatablevue_type_template_id_2bb6b88c_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/visualisations/datatable/datatable.vue?vue&type=template&id=2bb6b88c&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("e6cf");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js



function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}
// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/datatable/pagination.vue?vue&type=template&id=ac112ad6&scoped=true&
var paginationvue_type_template_id_ac112ad6_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination__container"},[_c('div',{staticClass:"pagination__total-records"},[_vm._v(_vm._s(_vm.totalRows)+" records")]),_c('div',{staticClass:"pagination__paging-controls"},[_c('div',{staticClass:"action",attrs:{"disabled":!_vm.hasPrevious() || _vm.disableControls},on:{"click":function($event){return _vm.first()}}},[_c('n-icon',{attrs:{"icon":"skip-previous"}})],1),_vm._v("   "),_c('div',{staticClass:"action",attrs:{"disabled":!_vm.hasPrevious() || _vm.disableControls},on:{"click":function($event){return _vm.previous()}}},[_c('n-icon',{attrs:{"icon":"chevron-left"}})],1),_c('div',{staticClass:"pagination__paging-controls--current"},[_vm._v(" Page "+_vm._s(_vm.currentPage)+" of "+_vm._s(_vm.numberOfPages())+" ")]),_c('div',{staticClass:"action",attrs:{"disabled":!_vm.hasNext() || _vm.disableControls},on:{"click":function($event){return _vm.next()}}},[_c('n-icon',{attrs:{"icon":"chevron-right"}})],1),_vm._v("   "),_c('div',{staticClass:"action",attrs:{"disabled":!_vm.hasNext() || _vm.disableControls},on:{"click":function($event){return _vm.last()}}},[_c('n-icon',{attrs:{"icon":"skip-next"}})],1)])])}
var paginationvue_type_template_id_ac112ad6_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/visualisations/datatable/pagination.vue?vue&type=template&id=ac112ad6&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/datatable/pagination.vue?vue&type=script&lang=ts&








var paginationvue_type_script_lang_ts_NPagination = /*#__PURE__*/function (_Vue) {
  _inherits(NPagination, _Vue);

  var _super = _createSuper(NPagination);

  function NPagination() {
    var _this;

    _classCallCheck(this, NPagination);

    _this = _super.apply(this, arguments);
    _this.currentPage = 1;
    _this.totalRows = 0;
    return _this;
  }

  _createClass(NPagination, [{
    key: "mounted",
    value: function mounted() {
      this.totalRows = this.itemsTotal || 0;
      this.currentPage = this.page || 1;
    }
  }, {
    key: "onTotalChanged",
    value: function onTotalChanged(current, previous) {
      this.totalRows = current;

      if (this.totalRows < 0) {
        this.totalRows = 0;
      } // if new total means that our current page is invalid, then reset back to the first page


      if (this.currentPage > 1 && this.isPageOutOfBounds(this.currentPage)) {
        this.currentPage = 1;
        this.pageChanged();
      }
    }
  }, {
    key: "numberOfPages",
    value: function numberOfPages() {
      if (this.totalRows <= 0) {
        return 1;
      }

      return Math.max(Math.ceil(this.totalRows / this.itemsPerPage), 1);
    }
  }, {
    key: "last",
    value: function last() {
      if (this.disableControls) {
        return;
      }

      if (this.hasNext()) {
        this.currentPage = this.numberOfPages();
        this.pageChanged();
      }
    }
  }, {
    key: "first",
    value: function first() {
      if (this.disableControls) {
        return;
      }

      if (this.hasPrevious()) {
        this.currentPage = 1;
        this.pageChanged();
      }
    }
  }, {
    key: "next",
    value: function next() {
      if (this.disableControls) {
        return;
      }

      if (this.hasNext()) {
        this.currentPage += 1;
        this.pageChanged();
      }
    }
  }, {
    key: "previous",
    value: function previous() {
      if (this.disableControls) {
        return;
      }

      if (this.hasPrevious()) {
        this.currentPage -= 1;
        this.pageChanged();
      }
    }
  }, {
    key: "hasNext",
    value: function hasNext() {
      var next = this.currentPage + 1;
      return !this.isPageOutOfBounds(next);
    }
  }, {
    key: "hasPrevious",
    value: function hasPrevious() {
      return this.currentPage > 1;
    }
  }, {
    key: "startOfPage",
    value: function startOfPage(pageNumber) {
      // default to current page if page number not supplied
      var pageNum = typeof pageNumber !== 'undefined' ? pageNumber : this.currentPage;
      return (pageNum - 1) * this.itemsPerPage + 1;
    }
  }, {
    key: "endOfPage",
    value: function endOfPage(pageNumber) {
      // default to current page if page number not supplied
      var pageNum = typeof pageNumber !== 'undefined' ? pageNumber : this.currentPage;
      return Math.min(pageNum * this.itemsPerPage, this.totalRows);
    }
  }, {
    key: "pageChanged",
    value: function pageChanged() {
      // our rows are 1-based, but consumers of this will likely have their records stored in 0-based arrays
      this.$emit('page-changed', {
        start: this.startOfPage() - 1,
        end: this.endOfPage()
      });
    }
  }, {
    key: "isPageOutOfBounds",
    value: function isPageOutOfBounds(pageNumber) {
      return this.startOfPage(pageNumber) > this.totalRows;
    }
  }]);

  return NPagination;
}(external_vue_default.a);

__decorate([Prop({
  default: 0
})], paginationvue_type_script_lang_ts_NPagination.prototype, "itemsTotal", void 0);

__decorate([Prop({
  default: 50
})], paginationvue_type_script_lang_ts_NPagination.prototype, "itemsPerPage", void 0);

__decorate([Prop({
  default: 1
})], paginationvue_type_script_lang_ts_NPagination.prototype, "page", void 0);

__decorate([Prop({
  default: false
})], paginationvue_type_script_lang_ts_NPagination.prototype, "disableControls", void 0);

__decorate([Watch('itemsTotal')], paginationvue_type_script_lang_ts_NPagination.prototype, "onTotalChanged", null);

paginationvue_type_script_lang_ts_NPagination = __decorate([vue_class_component_esm({
  name: 'n-pagination',
  components: {
    NIcon: icon
  }
})], paginationvue_type_script_lang_ts_NPagination);
/* harmony default export */ var paginationvue_type_script_lang_ts_ = (paginationvue_type_script_lang_ts_NPagination);
// CONCATENATED MODULE: ./src/components/visualisations/datatable/pagination.vue?vue&type=script&lang=ts&
 /* harmony default export */ var datatable_paginationvue_type_script_lang_ts_ = (paginationvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/visualisations/datatable/pagination.vue?vue&type=style&index=0&id=ac112ad6&scoped=true&lang=scss&
var paginationvue_type_style_index_0_id_ac112ad6_scoped_true_lang_scss_ = __webpack_require__("45b1");

// CONCATENATED MODULE: ./src/components/visualisations/datatable/pagination.vue






/* normalize component */

var pagination_component = normalizeComponent(
  datatable_paginationvue_type_script_lang_ts_,
  paginationvue_type_template_id_ac112ad6_scoped_true_render,
  paginationvue_type_template_id_ac112ad6_scoped_true_staticRenderFns,
  false,
  null,
  "ac112ad6",
  null
  
)

/* harmony default export */ var pagination = (pagination_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/loading-spinner/loading-spinner.vue?vue&type=template&id=2c824f0f&scoped=true&
var loading_spinnervue_type_template_id_2c824f0f_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var loading_spinnervue_type_template_id_2c824f0f_scoped_true_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sk-folding-cube"},[_c('div',{staticClass:"sk-cube1 sk-cube"}),_c('div',{staticClass:"sk-cube2 sk-cube"}),_c('div',{staticClass:"sk-cube4 sk-cube"}),_c('div',{staticClass:"sk-cube3 sk-cube"})])}]


// CONCATENATED MODULE: ./src/components/visualisations/loading-spinner/loading-spinner.vue?vue&type=template&id=2c824f0f&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/loading-spinner/loading-spinner.vue?vue&type=script&lang=ts&







var loading_spinnervue_type_script_lang_ts_NLoadingSpinner = /*#__PURE__*/function (_Vue) {
  _inherits(NLoadingSpinner, _Vue);

  var _super = _createSuper(NLoadingSpinner);

  function NLoadingSpinner() {
    _classCallCheck(this, NLoadingSpinner);

    return _super.apply(this, arguments);
  }

  return _createClass(NLoadingSpinner);
}(external_vue_default.a);

loading_spinnervue_type_script_lang_ts_NLoadingSpinner = __decorate([vue_class_component_esm({
  name: 'n-loading-spinner'
})], loading_spinnervue_type_script_lang_ts_NLoadingSpinner);
/* harmony default export */ var loading_spinnervue_type_script_lang_ts_ = (loading_spinnervue_type_script_lang_ts_NLoadingSpinner);
// CONCATENATED MODULE: ./src/components/visualisations/loading-spinner/loading-spinner.vue?vue&type=script&lang=ts&
 /* harmony default export */ var loading_spinner_loading_spinnervue_type_script_lang_ts_ = (loading_spinnervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/visualisations/loading-spinner/loading-spinner.vue?vue&type=style&index=0&id=2c824f0f&scoped=true&lang=scss&
var loading_spinnervue_type_style_index_0_id_2c824f0f_scoped_true_lang_scss_ = __webpack_require__("63a2");

// CONCATENATED MODULE: ./src/components/visualisations/loading-spinner/loading-spinner.vue






/* normalize component */

var loading_spinner_component = normalizeComponent(
  loading_spinner_loading_spinnervue_type_script_lang_ts_,
  loading_spinnervue_type_template_id_2c824f0f_scoped_true_render,
  loading_spinnervue_type_template_id_2c824f0f_scoped_true_staticRenderFns,
  false,
  null,
  "2c824f0f",
  null
  
)

/* harmony default export */ var loading_spinner = (loading_spinner_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/datatable/datatable.vue?vue&type=script&lang=ts&












var datatablevue_type_script_lang_ts_NDataTable = /*#__PURE__*/function (_Vue) {
  _inherits(NDataTable, _Vue);

  var _super = _createSuper(NDataTable);

  function NDataTable() {
    var _this;

    _classCallCheck(this, NDataTable);

    _this = _super.apply(this, arguments);
    _this.isLoading = false;
    _this.offset = 0;
    return _this;
  }

  _createClass(NDataTable, [{
    key: "loadingChangedFromParent",
    value: function loadingChangedFromParent(loading) {
      this.isLoading = loading;
    }
  }, {
    key: "itemsUpdated",
    value: function itemsUpdated(items) {
      this.isLoading = false;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.sortColumn = this.sortBy;
      this.sortDirection = this.sortDesc ? 'desc' : 'asc';
    }
  }, {
    key: "onPageChanged",
    value: function () {
      var _onPageChanged = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(page) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.offset = page.start;
                _context.next = 3;
                return this.loadData();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onPageChanged(_x) {
        return _onPageChanged.apply(this, arguments);
      }

      return onPageChanged;
    }()
  }, {
    key: "loadData",
    value: function loadData() {
      this.isLoading = true;
      this.$emit('load', {
        offset: this.offset,
        sortColumn: this.sortColumn,
        sortDirection: this.sortDirection
      });
    }
  }, {
    key: "getSortClass",
    value: function getSortClass(column) {
      if (column !== this.sortColumn) {
        return '';
      }

      return this.sortDirection;
    }
  }, {
    key: "handleColumnClick",
    value: function handleColumnClick(column) {
      if (column === this.sortColumn) {
        if (this.sortDirection === 'desc') {
          this.sortDirection = 'asc';
        } else if (this.sortDirection === 'asc') {
          this.sortDirection = 'desc';
        }
      } else {
        this.sortDirection = 'desc';
        this.sortColumn = column;
      }

      this.loadData();
    }
  }, {
    key: "isCellClickable",
    value: function isCellClickable(row, clickableConfig) {
      if (typeof clickableConfig === 'function') {
        return clickableConfig(row);
      }

      return !!clickableConfig;
    }
  }, {
    key: "cellClicked",
    value: function cellClicked(row) {
      this.$emit('cellClicked', row);
    }
  }, {
    key: "hasResults",
    value: function hasResults() {
      if (this.pagination) {
        return this.itemsTotal > 0 && this.items && this.items.length > 0;
      }

      return this.items && this.items.length > 0;
    }
  }]);

  return NDataTable;
}(external_vue_default.a);

__decorate([Prop()], datatablevue_type_script_lang_ts_NDataTable.prototype, "columns", void 0);

__decorate([Prop()], datatablevue_type_script_lang_ts_NDataTable.prototype, "items", void 0);

__decorate([Prop()], datatablevue_type_script_lang_ts_NDataTable.prototype, "itemsTotal", void 0);

__decorate([Prop()], datatablevue_type_script_lang_ts_NDataTable.prototype, "loading", void 0);

__decorate([Prop()], datatablevue_type_script_lang_ts_NDataTable.prototype, "pagination", void 0);

__decorate([Prop()], datatablevue_type_script_lang_ts_NDataTable.prototype, "itemsPerPage", void 0);

__decorate([Prop()], datatablevue_type_script_lang_ts_NDataTable.prototype, "sortBy", void 0);

__decorate([Prop()], datatablevue_type_script_lang_ts_NDataTable.prototype, "sortDesc", void 0);

__decorate([Watch('loading', {
  immediate: true
})], datatablevue_type_script_lang_ts_NDataTable.prototype, "loadingChangedFromParent", null);

__decorate([Watch('items', {
  immediate: true
})], datatablevue_type_script_lang_ts_NDataTable.prototype, "itemsUpdated", null);

datatablevue_type_script_lang_ts_NDataTable = __decorate([vue_class_component_esm({
  components: {
    NPagination: pagination,
    NLoadingSpinner: loading_spinner,
    NIcon: icon
  },
  name: 'n-data-table'
})], datatablevue_type_script_lang_ts_NDataTable);
/* harmony default export */ var datatablevue_type_script_lang_ts_ = (datatablevue_type_script_lang_ts_NDataTable);
// CONCATENATED MODULE: ./src/components/visualisations/datatable/datatable.vue?vue&type=script&lang=ts&
 /* harmony default export */ var datatable_datatablevue_type_script_lang_ts_ = (datatablevue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/visualisations/datatable/datatable.vue?vue&type=style&index=0&id=2bb6b88c&scoped=true&lang=scss&
var datatablevue_type_style_index_0_id_2bb6b88c_scoped_true_lang_scss_ = __webpack_require__("b0b8");

// CONCATENATED MODULE: ./src/components/visualisations/datatable/datatable.vue






/* normalize component */

var datatable_component = normalizeComponent(
  datatable_datatablevue_type_script_lang_ts_,
  datatablevue_type_template_id_2bb6b88c_scoped_true_render,
  datatablevue_type_template_id_2bb6b88c_scoped_true_staticRenderFns,
  false,
  null,
  "2bb6b88c",
  null
  
)

/* harmony default export */ var datatable = (datatable_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/date-picker/date-picker.vue?vue&type=template&id=e2da7c36&scoped=true&
var date_pickervue_type_template_id_e2da7c36_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-input",class:{ 'has-error': _vm.dateError }},[(_vm.label)?_c('label',{class:{ 'sr-only': _vm.hideLabel },attrs:{"for":_vm.inputId}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('input',{staticClass:"control",attrs:{"type":"date","id":_vm.inputId,"name":_vm.name,"disabled":_vm.disabled,"min":_vm.formatDate(_vm.minDate),"max":_vm.formatDate(_vm.maxDate)},domProps:{"value":_vm.dateValueStr},on:{"input":function ($event) { return _vm.handleInput($event.target.value); }}}),(_vm.dateError)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.dateError))]):_vm._e()])}
var date_pickervue_type_template_id_e2da7c36_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/date-picker/date-picker.vue?vue&type=template&id=e2da7c36&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.is-nan.js
var es_number_is_nan = __webpack_require__("9129");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("fb6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url.to-json.js
var web_url_to_json = __webpack_require__("bf19");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/date-picker/date-picker.vue?vue&type=script&lang=ts&












var date_pickervue_type_script_lang_ts_NDatePicker = /*#__PURE__*/function (_Mixins) {
  _inherits(NDatePicker, _Mixins);

  var _super = _createSuper(NDatePicker);

  function NDatePicker() {
    var _this;

    _classCallCheck(this, NDatePicker);

    _this = _super.apply(this, arguments);
    _this.dateValueStr = '';
    _this.dateError = '';
    return _this;
  }

  _createClass(NDatePicker, [{
    key: "created",
    value: function created() {
      this.handleValueChange();
      this.handleMinChange();
      this.handleMaxChange();
      this.handleErrorMessageChange();
    }
  }, {
    key: "handleErrorMessageChange",
    value: function handleErrorMessageChange() {
      this.dateError = this.errorMessage;
    }
  }, {
    key: "handleValueChange",
    value: function handleValueChange() {
      if (this.value === null) {
        return;
      }

      if (!(this.value instanceof Date)) {
        // This is needed to make the storybook work because the storybook control passes a unix timestamp
        this.dateValueStr = this.formatDate(new Date(this.value));
      } else if (!Number.isNaN(this.value.getTime())) {
        this.dateValueStr = this.formatDate(this.value);
      }
    }
  }, {
    key: "handleMinChange",
    value: function handleMinChange() {
      if (!(this.min instanceof Date) && this.min !== undefined) {
        this.minDate = new Date(this.min);
      } else {
        this.minDate = this.min;
      }
    }
  }, {
    key: "handleMaxChange",
    value: function handleMaxChange() {
      if (!(this.max instanceof Date) && this.max !== undefined) {
        this.maxDate = new Date(this.max);
      } else {
        this.maxDate = this.max;
      }
    }
  }, {
    key: "handleInput",
    value: function handleInput(value) {
      var dateVal = new Date(value);
      this.$emit('input', dateVal);
    }
  }, {
    key: "formatDate",
    value: function formatDate(date) {
      if (date && date instanceof Date && !Number.isNaN(date.getTime())) {
        return date.toJSON().slice(0, 10);
      }

      return '';
    }
  }]);

  return NDatePicker;
}(mixins(id_generator));

__decorate([Prop()], date_pickervue_type_script_lang_ts_NDatePicker.prototype, "id", void 0);

__decorate([Prop()], date_pickervue_type_script_lang_ts_NDatePicker.prototype, "label", void 0);

__decorate([Prop()], date_pickervue_type_script_lang_ts_NDatePicker.prototype, "errorMessage", void 0);

__decorate([Prop()], date_pickervue_type_script_lang_ts_NDatePicker.prototype, "value", void 0);

__decorate([Prop()], date_pickervue_type_script_lang_ts_NDatePicker.prototype, "name", void 0);

__decorate([Prop({
  default: false
})], date_pickervue_type_script_lang_ts_NDatePicker.prototype, "disabled", void 0);

__decorate([Prop()], date_pickervue_type_script_lang_ts_NDatePicker.prototype, "min", void 0);

__decorate([Prop()], date_pickervue_type_script_lang_ts_NDatePicker.prototype, "max", void 0);

__decorate([Prop()], date_pickervue_type_script_lang_ts_NDatePicker.prototype, "hideLabel", void 0);

__decorate([Watch('errorMessage')], date_pickervue_type_script_lang_ts_NDatePicker.prototype, "handleErrorMessageChange", null);

__decorate([Watch('value')], date_pickervue_type_script_lang_ts_NDatePicker.prototype, "handleValueChange", null);

__decorate([Watch('min')], date_pickervue_type_script_lang_ts_NDatePicker.prototype, "handleMinChange", null);

__decorate([Watch('max')], date_pickervue_type_script_lang_ts_NDatePicker.prototype, "handleMaxChange", null);

date_pickervue_type_script_lang_ts_NDatePicker = __decorate([vue_class_component_esm({
  name: 'n-date-picker'
})], date_pickervue_type_script_lang_ts_NDatePicker);
/* harmony default export */ var date_pickervue_type_script_lang_ts_ = (date_pickervue_type_script_lang_ts_NDatePicker);
// CONCATENATED MODULE: ./src/components/input/date-picker/date-picker.vue?vue&type=script&lang=ts&
 /* harmony default export */ var date_picker_date_pickervue_type_script_lang_ts_ = (date_pickervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/input/date-picker/date-picker.vue?vue&type=style&index=0&id=e2da7c36&lang=scss&scoped=true&
var date_pickervue_type_style_index_0_id_e2da7c36_lang_scss_scoped_true_ = __webpack_require__("f1c9");

// CONCATENATED MODULE: ./src/components/input/date-picker/date-picker.vue






/* normalize component */

var date_picker_component = normalizeComponent(
  date_picker_date_pickervue_type_script_lang_ts_,
  date_pickervue_type_template_id_e2da7c36_scoped_true_render,
  date_pickervue_type_template_id_e2da7c36_scoped_true_staticRenderFns,
  false,
  null,
  "e2da7c36",
  null
  
)

/* harmony default export */ var date_picker = (date_picker_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/conversation/conversation-thread.vue?vue&type=template&id=86e34550&scoped=true&
var conversation_threadvue_type_template_id_86e34550_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-conversation-thread",attrs:{"infinite-wrapper":""}},[_c('div',{ref:"conversationContainer",staticClass:"n-conversation-thread__container"},[_c('infinite-loading',{attrs:{"throttleLimit":200,"direction":"top","distance":0,"force-use-infinite-wrapper":"true","spinner":"spiral"},on:{"infinite":_vm.loadMoreMessages},scopedSlots:_vm._u([{key:"error",fn:function(ref){
var trigger = ref.trigger;
return _c('div',{staticClass:"infinite-loading-error"},[_c('n-icon',{attrs:{"fill":'#686868',"icon":"conversation-refresh"}}),_c('a',{staticClass:"reload-message-link",on:{"click":trigger}},[_vm._v("Reload previous messages")])],1)}}])},[_c('div',{attrs:{"slot":"no-results"},slot:"no-results"}),_c('div',{attrs:{"slot":"no-more"},slot:"no-more"},[(_vm.messages.length)?_c('div',{staticClass:"n-conversation-thread__message-divider no-more"},[_vm._v(" "+_vm._s(_vm.formatTimestampDivider(_vm.messages[0].timestampUtc))+" ")]):_vm._e()])]),_c('div',{staticClass:"n-conversation-thread__message-list"},[_c('transition-group',{attrs:{"name":"transitions"}},[_vm._l((_vm.messages),function(m,index){return _c('div',{key:index,staticClass:"n-conversation-thread__message-row transition-item",class:[("n-conversation-thread__message-row--" + (_vm.getMessagePosition(m)))]},[(_vm.shouldShowTimestampDivider(m, _vm.messages[index - 1]))?_c('div',{staticClass:"n-conversation-thread__message-divider"},[_vm._v(" "+_vm._s(_vm.formatTimestampDivider(m.timestampUtc))+" ")]):_vm._e(),(m.type === 'whisper')?_c('div',{staticClass:"n-conversation-thread__message-divider--whisper"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.getFormattedMessage(m.text))}})]):_vm._e(),(m.type === 'text')?_c('NTextMessage',{attrs:{"message":m,"outboundMessageColour":_vm.outboundMessageColour,"tooltipPosition":_vm.getMessagePosition(m) === 'right' ? 'left' : 'right',"displayAvatar":_vm.displayAvatar,"enableAvatarTooltip":_vm.enableAvatarTooltip}}):_vm._e(),(m.type === 'app')?_c('NAppMessage',{attrs:{"message":m,"readonly":_vm.readonlyApps,"brandColour":_vm.outboundMessageColour,"displayAvatar":_vm.displayAvatar,"enableAvatarTooltip":_vm.enableAvatarTooltip,"position":_vm.getMessagePosition(m)}}):_vm._e(),(m.type === 'image')?_c('NImageMessage',{attrs:{"message":m,"displayAvatar":_vm.displayAvatar,"enableAvatarTooltip":_vm.enableAvatarTooltip,"tooltipPosition":_vm.getMessagePosition(m) === 'right' ? 'left' : 'right'}}):_vm._e(),(m.type === 'video')?_c('NVideoMessage',{attrs:{"message":m,"displayAvatar":_vm.displayAvatar,"enableAvatarTooltip":_vm.enableAvatarTooltip,"tooltipPosition":_vm.getMessagePosition(m) === 'right' ? 'left' : 'right'}}):_vm._e(),(m.type === 'audio')?_c('NAudioMessage',{attrs:{"message":m,"displayAvatar":_vm.displayAvatar,"enableAvatarTooltip":_vm.enableAvatarTooltip,"tooltipPosition":_vm.getMessagePosition(m) === 'right' ? 'left' : 'right'}}):_vm._e(),(m.type === 'file')?_c('NFileMessage',{attrs:{"message":m,"outboundMessageColour":_vm.outboundMessageColour,"displayAvatar":_vm.displayAvatar,"enableAvatarTooltip":_vm.enableAvatarTooltip,"tooltipPosition":_vm.getMessagePosition(m) === 'right' ? 'left' : 'right'}}):_vm._e()],1)}),(_vm.shouldShowQuickReplies())?_c('div',{key:'quick-replies',staticClass:"n-conversation-thread__quick-replies transition-item",class:[
						("n-conversation-thread__quick-replies--" + (_vm.getMessagePosition(_vm.messages[_vm.messages.length - 1]) === 'right'
								? 'left'
								: 'right'))
					]},[_c('QuickReplies',{attrs:{"actions":_vm.messages[_vm.messages.length - 1].actions,"messageColour":_vm.outboundMessageColour},on:{"sendQuickReply":_vm.sendQuickReply}})],1):_vm._e()],2)],1)],1)])}
var conversation_threadvue_type_template_id_86e34550_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/visualisations/conversation/conversation-thread.vue?vue&type=template&id=86e34550&scoped=true&

// EXTERNAL MODULE: ./node_modules/vue-infinite-loading/dist/vue-infinite-loading.js
var vue_infinite_loading = __webpack_require__("e166");
var vue_infinite_loading_default = /*#__PURE__*/__webpack_require__.n(vue_infinite_loading);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("c1df");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/conversation/text-message.vue?vue&type=template&id=c1c0df06&scoped=true&
var text_messagevue_type_template_id_c1c0df06_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-text-message",class:{
		'n-text-message--right': _vm.tooltipPosition === 'left',
		'n-text-message--left': _vm.tooltipPosition === 'right'
	}},[(_vm.displayAvatar)?_c('n-avatar',{staticClass:"n-text-message__avatar",class:{
			'n-text-message__avatar--left': _vm.tooltipPosition === 'right',
			'n-text-message__avatar--right': _vm.tooltipPosition === 'left'
		},attrs:{"name":_vm.message.name,"imageUrl":_vm.message.avatarUrl,"enableTooltip":_vm.enableAvatarTooltip,"size":"s"}}):_vm._e(),_c('n-tooltip',{attrs:{"position":_vm.tooltipPosition},scopedSlots:_vm._u([{key:"host",fn:function(){return [_c('span',{staticClass:"msg-text",style:(_vm.getMessageStyle()),domProps:{"innerHTML":_vm._s(_vm.formattedMessage)}})]},proxy:true},{key:"messageSlot",fn:function(){return [_c('span',[_vm._v(" "+_vm._s(_vm.getMessageTimestamp(_vm.message.timestampUtc))+" "),(_vm.shouldShowAlertIcon(_vm.message))?_c('n-icon',{attrs:{"icon":"alert","fill":"#ff6348"}}):_vm._e(),(_vm.shouldShowTickIcon(_vm.message))?_c('n-icon',{attrs:{"icon":"tick","fill":_vm.isRead(_vm.message) ? '#57d272' : '#bdbdbd'}}):_vm._e()],1)]},proxy:true}])})],1)}
var text_messagevue_type_template_id_c1c0df06_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/visualisations/conversation/text-message.vue?vue&type=template&id=c1c0df06&scoped=true&

// EXTERNAL MODULE: ./node_modules/tinycolor2/tinycolor.js
var tinycolor = __webpack_require__("66cb");
var tinycolor_default = /*#__PURE__*/__webpack_require__.n(tinycolor);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("5319");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__("4d63");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.dot-all.js
var es_regexp_dot_all = __webpack_require__("c607");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.sticky.js
var es_regexp_sticky = __webpack_require__("2c3e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__("466d");

// CONCATENATED MODULE: ./src/components/visualisations/conversation/messageContent.ts













/* eslint-disable no-useless-escape, no-control-regex, no-param-reassign */
var messageContent_MessageContent = /*#__PURE__*/function () {
  function MessageContent(text) {
    _classCallCheck(this, MessageContent);

    this.URL_REGEX = /((http(s)?|ftp):\/\/(?:(www\.)(www\.)+\S+|\S+[\.]+\S+)|(www\.)+\S+[\.]+\S+)([a-zA-Z\d])/gi;
    this.ESCAPE_CHARS = {
      '<': '&lt;',
      '>': '&gt;'
    };
    this.text = text;
  }

  _createClass(MessageContent, [{
    key: "EscapeHtml",
    value: function EscapeHtml() {
      var _this = this;

      this.text = this.text.replace(/[<>]/g, function (tag) {
        return _this.ESCAPE_CHARS[tag] || tag;
      });
      return this;
    }
  }, {
    key: "NewLinesToBreaks",
    value: function NewLinesToBreaks() {
      this.text = this.text.replace(new RegExp('\n', 'g'), '<br>');
      return this;
    }
  }, {
    key: "ProcessUrls",
    value: function ProcessUrls() {
      this.text = this.processUrls(this.text);
      return this;
    }
  }, {
    key: "Value",
    get: function get() {
      return this.text;
    }
  }, {
    key: "processUrls",
    value: function processUrls(rawMessage) {
      var _this2 = this;

      var html = rawMessage;
      var urls = rawMessage.match(this.URL_REGEX);

      if (urls) {
        urls.forEach(function (url) {
          var cleanUrl = _this2.cleanupUrl(url);

          var urlAsLink = "<a href=\"".concat(cleanUrl, "\" target=\"_blank\" style=\"color: inherit\">").concat(cleanUrl, "</a>");
          html = html.replace(new RegExp(_this2.escapeRegExp(url), 'gi'), urlAsLink);
        });
      }

      return html;
    }
  }, {
    key: "cleanupUrl",
    value: function cleanupUrl(url) {
      if (url.substr(0, 3) === 'www') {
        url = "http://".concat(url);
      }

      return url;
    }
  }, {
    key: "escapeRegExp",
    value: function escapeRegExp(input) {
      return input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
  }]);

  return MessageContent;
}();
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/avatar/avatar.vue?vue&type=template&id=6fd96bec&scoped=true&
var avatarvue_type_template_id_6fd96bec_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-avatar"},[(_vm.enableTooltip)?_c('n-tooltip',{attrs:{"position":"top","text":_vm.name},scopedSlots:_vm._u([{key:"host",fn:function(){return [_c('div',{staticClass:"n-avatar__circle",class:{
					'n-avatar__circle--small': _vm.size === 's',
					'n-avatar__circle--large': _vm.size === 'l'
				},style:({
					'background-color':
						_vm.imageUrl && !_vm.imageLoadError ? 'transparent' : _vm.stringToHSLColour(_vm.name)
				}),on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.imageUrl && !_vm.imageLoadError)?_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.imageLoaded),expression:"imageLoaded"}],attrs:{"src":_vm.imageUrl,"alt":("Avatar image for " + _vm.name)},on:{"load":_vm.handleImageLoad,"error":_vm.handleImageErr}}):_c('span',[_vm._v(_vm._s(_vm.initials))])])]},proxy:true}],null,false,1796780038)}):_c('div',[_c('div',{staticClass:"n-avatar__circle",class:{
				'n-avatar__circle--small': _vm.size === 's',
				'n-avatar__circle--large': _vm.size === 'l'
			},style:({
				'background-color':
					_vm.imageUrl && !_vm.imageLoadError ? 'transparent' : _vm.stringToHSLColour(_vm.name)
			}),on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.imageUrl && !_vm.imageLoadError)?_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.imageLoaded),expression:"imageLoaded"}],attrs:{"src":_vm.imageUrl,"alt":("Avatar image for " + _vm.name)},on:{"load":_vm.handleImageLoad,"error":_vm.handleImageErr}}):_c('span',[_vm._v(_vm._s(_vm.initials))])])])],1)}
var avatarvue_type_template_id_6fd96bec_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/visualisations/avatar/avatar.vue?vue&type=template&id=6fd96bec&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("a15b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("1276");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/avatar/avatar.vue?vue&type=script&lang=ts&














var avatarvue_type_script_lang_ts_NAvatar = /*#__PURE__*/function (_Vue) {
  _inherits(NAvatar, _Vue);

  var _super = _createSuper(NAvatar);

  function NAvatar() {
    var _this;

    _classCallCheck(this, NAvatar);

    _this = _super.apply(this, arguments);
    _this.imageLoaded = false;
    _this.imageLoadError = false;
    return _this;
  }

  _createClass(NAvatar, [{
    key: "handleImageUrlChange",
    value: function handleImageUrlChange() {
      this.imageLoaded = false;
      this.imageLoadError = false;
    }
  }, {
    key: "initials",
    get: function get() {
      if (!this.name) {
        return 'U';
      }

      return this.name.split(' ').map(function (n) {
        return n[0];
      }).slice(0, 2).join('').toUpperCase();
    }
  }, {
    key: "stringToHSLColour",
    value: function stringToHSLColour(str) {
      var hash = 0;

      for (var i = 0; i < str.length; i += 1) {
        // eslint-disable-next-line no-bitwise
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }

      var h = Math.abs(hash % 360);
      return "hsl(".concat(Math.abs(h), ", 40%, 80%)");
    }
  }, {
    key: "handleImageLoad",
    value: function handleImageLoad() {
      this.imageLoaded = true;
    }
  }, {
    key: "handleImageErr",
    value: function handleImageErr() {
      this.imageLoadError = true;
    }
  }]);

  return NAvatar;
}(external_vue_default.a);

__decorate([Prop()], avatarvue_type_script_lang_ts_NAvatar.prototype, "imageUrl", void 0);

__decorate([Prop({
  default: 'm'
})], avatarvue_type_script_lang_ts_NAvatar.prototype, "size", void 0);

__decorate([Prop({
  default: 'unknown'
})], avatarvue_type_script_lang_ts_NAvatar.prototype, "name", void 0);

__decorate([Prop({
  default: false
})], avatarvue_type_script_lang_ts_NAvatar.prototype, "enableTooltip", void 0);

__decorate([Watch('imageUrl', {
  immediate: true
})], avatarvue_type_script_lang_ts_NAvatar.prototype, "handleImageUrlChange", null);

avatarvue_type_script_lang_ts_NAvatar = __decorate([vue_class_component_esm({
  name: 'n-avatar',
  components: {
    NTooltip: tooltip
  }
})], avatarvue_type_script_lang_ts_NAvatar);
/* harmony default export */ var avatarvue_type_script_lang_ts_ = (avatarvue_type_script_lang_ts_NAvatar);
// CONCATENATED MODULE: ./src/components/visualisations/avatar/avatar.vue?vue&type=script&lang=ts&
 /* harmony default export */ var avatar_avatarvue_type_script_lang_ts_ = (avatarvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/visualisations/avatar/avatar.vue?vue&type=style&index=0&id=6fd96bec&lang=scss&scoped=true&
var avatarvue_type_style_index_0_id_6fd96bec_lang_scss_scoped_true_ = __webpack_require__("eedf");

// CONCATENATED MODULE: ./src/components/visualisations/avatar/avatar.vue






/* normalize component */

var avatar_component = normalizeComponent(
  avatar_avatarvue_type_script_lang_ts_,
  avatarvue_type_template_id_6fd96bec_scoped_true_render,
  avatarvue_type_template_id_6fd96bec_scoped_true_staticRenderFns,
  false,
  null,
  "6fd96bec",
  null
  
)

/* harmony default export */ var avatar = (avatar_component.exports);
// CONCATENATED MODULE: ./src/components/visualisations/conversation/messageStatus.ts
var MessageStatus;

(function (MessageStatus) {
  MessageStatus["Received"] = "received";
  MessageStatus["Sent"] = "sent";
  MessageStatus["DeliverySucceeded"] = "delivery:succeeded";
  MessageStatus["DeliveryFailed"] = "delivery:failed";
  MessageStatus["Read"] = "read";
})(MessageStatus || (MessageStatus = {}));
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/conversation/text-message.vue?vue&type=script&lang=ts&














var text_messagevue_type_script_lang_ts_NTextMessage = /*#__PURE__*/function (_Vue) {
  _inherits(NTextMessage, _Vue);

  var _super = _createSuper(NTextMessage);

  function NTextMessage() {
    _classCallCheck(this, NTextMessage);

    return _super.apply(this, arguments);
  }

  _createClass(NTextMessage, [{
    key: "formattedMessage",
    get: function get() {
      return new messageContent_MessageContent(this.message.text).EscapeHtml().ProcessUrls().NewLinesToBreaks().Value;
    }
  }, {
    key: "getMessageTimestamp",
    value: function getMessageTimestamp(timestamp) {
      return moment_default()(timestamp).format('HH:mm');
    }
  }, {
    key: "isRead",
    value: function isRead(m) {
      return m.status === MessageStatus.Read;
    }
  }, {
    key: "shouldShowTickIcon",
    value: function shouldShowTickIcon(m) {
      switch (m.status) {
        case MessageStatus.DeliverySucceeded:
        case MessageStatus.Read:
        case MessageStatus.Received:
        case MessageStatus.Sent:
          return true;

        default:
          return false;
      }
    }
  }, {
    key: "shouldShowAlertIcon",
    value: function shouldShowAlertIcon(m) {
      return m.status === MessageStatus.DeliveryFailed;
    }
  }, {
    key: "getMessageStyle",
    value: function getMessageStyle() {
      var backgroundColour = '#f5f5f5';
      var textColour = '#212121';

      if (this.message.direction === 'outbound') {
        backgroundColour = this.outboundMessageColour;
        textColour = tinycolor_default()(backgroundColour).isDark() ? '#fff' : '#212121';
      }

      if (this.message.status === MessageStatus.DeliveryFailed) {
        backgroundColour = '#ffdada';
        textColour = '#212121';
      }

      return {
        background: backgroundColour,
        color: textColour
      };
    }
  }]);

  return NTextMessage;
}(external_vue_default.a);

__decorate([Prop({
  default: '#062b80'
})], text_messagevue_type_script_lang_ts_NTextMessage.prototype, "outboundMessageColour", void 0);

__decorate([Prop()], text_messagevue_type_script_lang_ts_NTextMessage.prototype, "message", void 0);

__decorate([Prop()], text_messagevue_type_script_lang_ts_NTextMessage.prototype, "tooltipPosition", void 0);

__decorate([Prop({
  default: false
})], text_messagevue_type_script_lang_ts_NTextMessage.prototype, "displayAvatar", void 0);

__decorate([Prop({
  default: false
})], text_messagevue_type_script_lang_ts_NTextMessage.prototype, "enableAvatarTooltip", void 0);

text_messagevue_type_script_lang_ts_NTextMessage = __decorate([vue_class_component_esm({
  components: {
    NIcon: icon,
    NTooltip: tooltip,
    NAvatar: avatar
  }
})], text_messagevue_type_script_lang_ts_NTextMessage);
/* harmony default export */ var text_messagevue_type_script_lang_ts_ = (text_messagevue_type_script_lang_ts_NTextMessage);
// CONCATENATED MODULE: ./src/components/visualisations/conversation/text-message.vue?vue&type=script&lang=ts&
 /* harmony default export */ var conversation_text_messagevue_type_script_lang_ts_ = (text_messagevue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/visualisations/conversation/text-message.vue?vue&type=style&index=0&id=c1c0df06&lang=scss&scoped=true&
var text_messagevue_type_style_index_0_id_c1c0df06_lang_scss_scoped_true_ = __webpack_require__("9379");

// CONCATENATED MODULE: ./src/components/visualisations/conversation/text-message.vue






/* normalize component */

var text_message_component = normalizeComponent(
  conversation_text_messagevue_type_script_lang_ts_,
  text_messagevue_type_template_id_c1c0df06_scoped_true_render,
  text_messagevue_type_template_id_c1c0df06_scoped_true_staticRenderFns,
  false,
  null,
  "c1c0df06",
  null
  
)

/* harmony default export */ var text_message = (text_message_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/conversation/image-message.vue?vue&type=template&id=f8cd417a&scoped=true&
var image_messagevue_type_template_id_f8cd417a_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-image-message",class:{
		'n-image-message--left': _vm.tooltipPosition === 'right',
		'n-image-message--right': _vm.tooltipPosition === 'left'
	}},[(_vm.displayAvatar)?_c('n-avatar',{staticClass:"n-image-message__avatar",class:{
			'n-image-message__avatar--left': _vm.tooltipPosition === 'right',
			'n-image-message__avatar--right': _vm.tooltipPosition === 'left'
		},attrs:{"size":"s","name":_vm.message.name,"imageUrl":_vm.message.avatarUrl,"enableTooltip":_vm.enableAvatarTooltip}}):_vm._e(),_c('n-tooltip',{attrs:{"position":_vm.tooltipPosition},scopedSlots:_vm._u([{key:"host",fn:function(){return [_c('img',{staticClass:"n-image-message__image",attrs:{"src":_vm.message.mediaSrc,"alt":_vm.message.altText}})]},proxy:true},{key:"messageSlot",fn:function(){return [_c('span',[_vm._v(" "+_vm._s(_vm.getMessageTimestamp(_vm.message.timestampUtc))+" "),(_vm.shouldShowAlertIcon(_vm.message))?_c('n-icon',{attrs:{"icon":"alert","fill":"#ff6348"}}):_vm._e(),(_vm.shouldShowTickIcon(_vm.message))?_c('n-icon',{attrs:{"icon":"tick","fill":_vm.isRead(_vm.message) ? '#57d272' : '#bdbdbd'}}):_vm._e()],1)]},proxy:true}])})],1)}
var image_messagevue_type_template_id_f8cd417a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/visualisations/conversation/image-message.vue?vue&type=template&id=f8cd417a&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/conversation/image-message.vue?vue&type=script&lang=ts&












var image_messagevue_type_script_lang_ts_NImageMessage = /*#__PURE__*/function (_Vue) {
  _inherits(NImageMessage, _Vue);

  var _super = _createSuper(NImageMessage);

  function NImageMessage() {
    _classCallCheck(this, NImageMessage);

    return _super.apply(this, arguments);
  }

  _createClass(NImageMessage, [{
    key: "getMessageTimestamp",
    value: function getMessageTimestamp(timestamp) {
      return moment_default()(timestamp).format('HH:mm');
    }
  }, {
    key: "shouldShowAlertIcon",
    value: function shouldShowAlertIcon(m) {
      return m.status === MessageStatus.DeliveryFailed;
    }
  }, {
    key: "isRead",
    value: function isRead(m) {
      return m.status === MessageStatus.Read;
    }
  }, {
    key: "shouldShowTickIcon",
    value: function shouldShowTickIcon(m) {
      switch (m.status) {
        case MessageStatus.DeliverySucceeded:
        case MessageStatus.Read:
        case MessageStatus.Received:
        case MessageStatus.Sent:
          return true;

        default:
          return false;
      }
    }
  }]);

  return NImageMessage;
}(external_vue_default.a);

__decorate([Prop()], image_messagevue_type_script_lang_ts_NImageMessage.prototype, "message", void 0);

__decorate([Prop({
  default: false
})], image_messagevue_type_script_lang_ts_NImageMessage.prototype, "displayAvatar", void 0);

__decorate([Prop({
  default: false
})], image_messagevue_type_script_lang_ts_NImageMessage.prototype, "enableAvatarTooltip", void 0);

__decorate([Prop()], image_messagevue_type_script_lang_ts_NImageMessage.prototype, "tooltipPosition", void 0);

image_messagevue_type_script_lang_ts_NImageMessage = __decorate([vue_class_component_esm({
  components: {
    NIcon: icon,
    NTooltip: tooltip,
    NAvatar: avatar
  }
})], image_messagevue_type_script_lang_ts_NImageMessage);
/* harmony default export */ var image_messagevue_type_script_lang_ts_ = (image_messagevue_type_script_lang_ts_NImageMessage);
// CONCATENATED MODULE: ./src/components/visualisations/conversation/image-message.vue?vue&type=script&lang=ts&
 /* harmony default export */ var conversation_image_messagevue_type_script_lang_ts_ = (image_messagevue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/visualisations/conversation/image-message.vue?vue&type=style&index=0&id=f8cd417a&lang=scss&scoped=true&
var image_messagevue_type_style_index_0_id_f8cd417a_lang_scss_scoped_true_ = __webpack_require__("958e");

// CONCATENATED MODULE: ./src/components/visualisations/conversation/image-message.vue






/* normalize component */

var image_message_component = normalizeComponent(
  conversation_image_messagevue_type_script_lang_ts_,
  image_messagevue_type_template_id_f8cd417a_scoped_true_render,
  image_messagevue_type_template_id_f8cd417a_scoped_true_staticRenderFns,
  false,
  null,
  "f8cd417a",
  null
  
)

/* harmony default export */ var image_message = (image_message_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/conversation/video-message.vue?vue&type=template&id=22d5a220&scoped=true&
var video_messagevue_type_template_id_22d5a220_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-video-message",class:{
		'n-video-message--left': _vm.tooltipPosition === 'right',
		'n-video-message--right': _vm.tooltipPosition === 'left'
	}},[(_vm.displayAvatar)?_c('n-avatar',{staticClass:"n-app-message__avatar",class:{
			'n-video-message__avatar--left': _vm.tooltipPosition === 'right',
			'n-video-message__avatar--right': _vm.tooltipPosition === 'left'
		},attrs:{"size":"s","name":_vm.message.name,"imageUrl":_vm.message.avatarUrl,"enableTooltip":_vm.enableAvatarTooltip}}):_vm._e(),_c('n-tooltip',{attrs:{"position":_vm.tooltipPosition},scopedSlots:_vm._u([{key:"host",fn:function(){return [_c('video',{staticClass:"n-video-message__video",attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.message.mediaSrc}})])]},proxy:true},{key:"messageSlot",fn:function(){return [_c('span',[_vm._v(" "+_vm._s(_vm.getMessageTimestamp(_vm.message.timestampUtc))+" "),(_vm.shouldShowAlertIcon(_vm.message))?_c('n-icon',{attrs:{"icon":"alert","fill":"#ff6348"}}):_vm._e(),(_vm.shouldShowTickIcon(_vm.message))?_c('n-icon',{attrs:{"icon":"tick","fill":_vm.isRead(_vm.message) ? '#57d272' : '#bdbdbd'}}):_vm._e()],1)]},proxy:true}])})],1)}
var video_messagevue_type_template_id_22d5a220_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/visualisations/conversation/video-message.vue?vue&type=template&id=22d5a220&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/conversation/video-message.vue?vue&type=script&lang=ts&












var video_messagevue_type_script_lang_ts_NVideoMessage = /*#__PURE__*/function (_Vue) {
  _inherits(NVideoMessage, _Vue);

  var _super = _createSuper(NVideoMessage);

  function NVideoMessage() {
    _classCallCheck(this, NVideoMessage);

    return _super.apply(this, arguments);
  }

  _createClass(NVideoMessage, [{
    key: "getMessageTimestamp",
    value: function getMessageTimestamp(timestamp) {
      return moment_default()(timestamp).format('HH:mm');
    }
  }, {
    key: "shouldShowAlertIcon",
    value: function shouldShowAlertIcon(m) {
      return m.status === MessageStatus.DeliveryFailed;
    }
  }, {
    key: "isRead",
    value: function isRead(m) {
      return m.status === MessageStatus.Read;
    }
  }, {
    key: "shouldShowTickIcon",
    value: function shouldShowTickIcon(m) {
      switch (m.status) {
        case MessageStatus.DeliverySucceeded:
        case MessageStatus.Read:
        case MessageStatus.Received:
        case MessageStatus.Sent:
          return true;

        default:
          return false;
      }
    }
  }]);

  return NVideoMessage;
}(external_vue_default.a);

__decorate([Prop()], video_messagevue_type_script_lang_ts_NVideoMessage.prototype, "message", void 0);

__decorate([Prop({
  default: false
})], video_messagevue_type_script_lang_ts_NVideoMessage.prototype, "displayAvatar", void 0);

__decorate([Prop({
  default: false
})], video_messagevue_type_script_lang_ts_NVideoMessage.prototype, "enableAvatarTooltip", void 0);

__decorate([Prop({
  default: 'right'
})], video_messagevue_type_script_lang_ts_NVideoMessage.prototype, "tooltipPosition", void 0);

video_messagevue_type_script_lang_ts_NVideoMessage = __decorate([vue_class_component_esm({
  components: {
    NIcon: icon,
    NTooltip: tooltip,
    NAvatar: avatar
  }
})], video_messagevue_type_script_lang_ts_NVideoMessage);
/* harmony default export */ var video_messagevue_type_script_lang_ts_ = (video_messagevue_type_script_lang_ts_NVideoMessage);
// CONCATENATED MODULE: ./src/components/visualisations/conversation/video-message.vue?vue&type=script&lang=ts&
 /* harmony default export */ var conversation_video_messagevue_type_script_lang_ts_ = (video_messagevue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/visualisations/conversation/video-message.vue?vue&type=style&index=0&id=22d5a220&lang=scss&scoped=true&
var video_messagevue_type_style_index_0_id_22d5a220_lang_scss_scoped_true_ = __webpack_require__("b386");

// CONCATENATED MODULE: ./src/components/visualisations/conversation/video-message.vue






/* normalize component */

var video_message_component = normalizeComponent(
  conversation_video_messagevue_type_script_lang_ts_,
  video_messagevue_type_template_id_22d5a220_scoped_true_render,
  video_messagevue_type_template_id_22d5a220_scoped_true_staticRenderFns,
  false,
  null,
  "22d5a220",
  null
  
)

/* harmony default export */ var video_message = (video_message_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/conversation/audio-message.vue?vue&type=template&id=96837b38&scoped=true&
var audio_messagevue_type_template_id_96837b38_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-audio-message",class:{
		'n-audio-message--left': _vm.tooltipPosition === 'right',
		'n-audio-message--right': _vm.tooltipPosition === 'left'
	}},[(_vm.displayAvatar)?_c('n-avatar',{staticClass:"n-audio-message__avatar",class:{
			'n-audio-message__avatar--left': _vm.tooltipPosition === 'right',
			'n-audio-message__avatar--right': _vm.tooltipPosition === 'left'
		},attrs:{"size":"s","name":_vm.message.name,"imageUrl":_vm.message.avatarUrl,"enableTooltip":_vm.enableAvatarTooltip}}):_vm._e(),_c('n-tooltip',{attrs:{"position":_vm.tooltipPosition},scopedSlots:_vm._u([{key:"host",fn:function(){return [_c('audio',{staticClass:"n-audio-message__audio",attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.message.mediaSrc}}),_vm._v(" Your browser does not support the audio element. ")])]},proxy:true},{key:"messageSlot",fn:function(){return [_c('span',[_vm._v(" "+_vm._s(_vm.getMessageTimestamp(_vm.message.timestampUtc))+" "),(_vm.shouldShowAlertIcon(_vm.message))?_c('n-icon',{attrs:{"icon":"alert","fill":"#ff6348"}}):_vm._e(),(_vm.shouldShowTickIcon(_vm.message))?_c('n-icon',{attrs:{"icon":"tick","fill":_vm.isRead(_vm.message) ? '#57d272' : '#bdbdbd'}}):_vm._e()],1)]},proxy:true}])})],1)}
var audio_messagevue_type_template_id_96837b38_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/visualisations/conversation/audio-message.vue?vue&type=template&id=96837b38&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/conversation/audio-message.vue?vue&type=script&lang=ts&












var audio_messagevue_type_script_lang_ts_NAudioMessage = /*#__PURE__*/function (_Vue) {
  _inherits(NAudioMessage, _Vue);

  var _super = _createSuper(NAudioMessage);

  function NAudioMessage() {
    _classCallCheck(this, NAudioMessage);

    return _super.apply(this, arguments);
  }

  _createClass(NAudioMessage, [{
    key: "getMessageTimestamp",
    value: function getMessageTimestamp(timestamp) {
      return moment_default()(timestamp).format('HH:mm');
    }
  }, {
    key: "shouldShowAlertIcon",
    value: function shouldShowAlertIcon(m) {
      return m.status === MessageStatus.DeliveryFailed;
    }
  }, {
    key: "isRead",
    value: function isRead(m) {
      return m.status === MessageStatus.Read;
    }
  }, {
    key: "shouldShowTickIcon",
    value: function shouldShowTickIcon(m) {
      switch (m.status) {
        case MessageStatus.DeliverySucceeded:
        case MessageStatus.Read:
        case MessageStatus.Received:
        case MessageStatus.Sent:
          return true;

        default:
          return false;
      }
    }
  }]);

  return NAudioMessage;
}(external_vue_default.a);

__decorate([Prop()], audio_messagevue_type_script_lang_ts_NAudioMessage.prototype, "message", void 0);

__decorate([Prop({
  default: false
})], audio_messagevue_type_script_lang_ts_NAudioMessage.prototype, "displayAvatar", void 0);

__decorate([Prop({
  default: false
})], audio_messagevue_type_script_lang_ts_NAudioMessage.prototype, "enableAvatarTooltip", void 0);

__decorate([Prop({
  default: 'right'
})], audio_messagevue_type_script_lang_ts_NAudioMessage.prototype, "tooltipPosition", void 0);

audio_messagevue_type_script_lang_ts_NAudioMessage = __decorate([vue_class_component_esm({
  components: {
    NIcon: icon,
    NTooltip: tooltip,
    NAvatar: avatar
  }
})], audio_messagevue_type_script_lang_ts_NAudioMessage);
/* harmony default export */ var audio_messagevue_type_script_lang_ts_ = (audio_messagevue_type_script_lang_ts_NAudioMessage);
// CONCATENATED MODULE: ./src/components/visualisations/conversation/audio-message.vue?vue&type=script&lang=ts&
 /* harmony default export */ var conversation_audio_messagevue_type_script_lang_ts_ = (audio_messagevue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/visualisations/conversation/audio-message.vue?vue&type=style&index=0&id=96837b38&lang=scss&scoped=true&
var audio_messagevue_type_style_index_0_id_96837b38_lang_scss_scoped_true_ = __webpack_require__("9e12");

// CONCATENATED MODULE: ./src/components/visualisations/conversation/audio-message.vue






/* normalize component */

var audio_message_component = normalizeComponent(
  conversation_audio_messagevue_type_script_lang_ts_,
  audio_messagevue_type_template_id_96837b38_scoped_true_render,
  audio_messagevue_type_template_id_96837b38_scoped_true_staticRenderFns,
  false,
  null,
  "96837b38",
  null
  
)

/* harmony default export */ var audio_message = (audio_message_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/conversation/file-message.vue?vue&type=template&id=2716a584&scoped=true&
var file_messagevue_type_template_id_2716a584_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-file-message",class:{
		'n-file-message--left': _vm.tooltipPosition === 'right',
		'n-file-message--right': _vm.tooltipPosition === 'left'
	}},[(_vm.displayAvatar)?_c('n-avatar',{staticClass:"n-file-message__avatar",class:{
			'n-file-message__avatar--left': _vm.tooltipPosition === 'right',
			'n-file-message__avatar--right': _vm.tooltipPosition === 'left'
		},attrs:{"size":"s","name":_vm.message.name,"imageUrl":_vm.message.avatarUrl,"enableTooltip":_vm.enableAvatarTooltip}}):_vm._e(),_c('n-tooltip',{attrs:{"position":_vm.tooltipPosition},scopedSlots:_vm._u([{key:"host",fn:function(){return [_c('div',{staticClass:"n-file-message__message-container",style:(_vm.getMessageStyle())},[_c('n-icon',{attrs:{"icon":"file"}}),_c('a',{style:({ color: _vm.getMessageStyle().color }),attrs:{"href":_vm.message.mediaSrc,"download":""}},[_vm._v(_vm._s(_vm.message.fileName)+" "),_c('span',{staticClass:"n-file-message__file-size"},[_vm._v("("+_vm._s(_vm.fileSize)+")")])])],1)]},proxy:true},{key:"messageSlot",fn:function(){return [_c('span',[_vm._v(" "+_vm._s(_vm.getMessageTimestamp(_vm.message.timestampUtc))+" "),(_vm.shouldShowAlertIcon(_vm.message))?_c('n-icon',{attrs:{"icon":"alert","fill":"#ff6348"}}):_vm._e(),(_vm.shouldShowTickIcon(_vm.message))?_c('n-icon',{attrs:{"icon":"tick","fill":_vm.isRead(_vm.message) ? '#57d272' : '#bdbdbd'}}):_vm._e()],1)]},proxy:true}])})],1)}
var file_messagevue_type_template_id_2716a584_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/visualisations/conversation/file-message.vue?vue&type=template&id=2716a584&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/conversation/file-message.vue?vue&type=script&lang=ts&














var file_messagevue_type_script_lang_ts_NFileMessage = /*#__PURE__*/function (_Vue) {
  _inherits(NFileMessage, _Vue);

  var _super = _createSuper(NFileMessage);

  function NFileMessage() {
    _classCallCheck(this, NFileMessage);

    return _super.apply(this, arguments);
  }

  _createClass(NFileMessage, [{
    key: "getMessageTimestamp",
    value: function getMessageTimestamp(timestamp) {
      return moment_default()(timestamp).format('HH:mm');
    }
  }, {
    key: "shouldShowAlertIcon",
    value: function shouldShowAlertIcon(m) {
      return m.status === MessageStatus.DeliveryFailed;
    }
  }, {
    key: "isRead",
    value: function isRead(m) {
      return m.status === MessageStatus.Read;
    }
  }, {
    key: "shouldShowTickIcon",
    value: function shouldShowTickIcon(m) {
      switch (m.status) {
        case MessageStatus.DeliverySucceeded:
        case MessageStatus.Read:
        case MessageStatus.Received:
        case MessageStatus.Sent:
          return true;

        default:
          return false;
      }
    }
  }, {
    key: "fileSize",
    get: function get() {
      var i = Math.floor(Math.log(this.message.fileSize) / Math.log(1024));
      return "".concat(Math.round(this.message.fileSize / Math.pow(1024, i)), " ").concat(['B', 'kB', 'MB', 'GB', 'TB'][i]);
    }
  }, {
    key: "getMessageStyle",
    value: function getMessageStyle() {
      var backgroundColour = '#f5f5f5';
      var textColour = '#212121';

      if (this.message.direction === 'outbound') {
        backgroundColour = this.outboundMessageColour;
        textColour = tinycolor_default()(backgroundColour).isDark() ? '#fff' : '#212121';
      }

      if (this.message.status === MessageStatus.DeliveryFailed) {
        backgroundColour = '#ffdada';
        textColour = '#212121';
      }

      return {
        background: backgroundColour,
        color: textColour
      };
    }
  }]);

  return NFileMessage;
}(external_vue_default.a);

__decorate([Prop({
  default: '#062b80'
})], file_messagevue_type_script_lang_ts_NFileMessage.prototype, "outboundMessageColour", void 0);

__decorate([Prop()], file_messagevue_type_script_lang_ts_NFileMessage.prototype, "message", void 0);

__decorate([Prop({
  default: false
})], file_messagevue_type_script_lang_ts_NFileMessage.prototype, "displayAvatar", void 0);

__decorate([Prop()], file_messagevue_type_script_lang_ts_NFileMessage.prototype, "tooltipPosition", void 0);

__decorate([Prop({
  default: false
})], file_messagevue_type_script_lang_ts_NFileMessage.prototype, "enableAvatarTooltip", void 0);

file_messagevue_type_script_lang_ts_NFileMessage = __decorate([vue_class_component_esm({
  components: {
    NIcon: icon,
    NTooltip: tooltip,
    NAvatar: avatar
  }
})], file_messagevue_type_script_lang_ts_NFileMessage);
/* harmony default export */ var file_messagevue_type_script_lang_ts_ = (file_messagevue_type_script_lang_ts_NFileMessage);
// CONCATENATED MODULE: ./src/components/visualisations/conversation/file-message.vue?vue&type=script&lang=ts&
 /* harmony default export */ var conversation_file_messagevue_type_script_lang_ts_ = (file_messagevue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/visualisations/conversation/file-message.vue?vue&type=style&index=0&id=2716a584&lang=scss&scoped=true&
var file_messagevue_type_style_index_0_id_2716a584_lang_scss_scoped_true_ = __webpack_require__("36a2");

// CONCATENATED MODULE: ./src/components/visualisations/conversation/file-message.vue






/* normalize component */

var file_message_component = normalizeComponent(
  conversation_file_messagevue_type_script_lang_ts_,
  file_messagevue_type_template_id_2716a584_scoped_true_render,
  file_messagevue_type_template_id_2716a584_scoped_true_staticRenderFns,
  false,
  null,
  "2716a584",
  null
  
)

/* harmony default export */ var file_message = (file_message_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/conversation/app-message.vue?vue&type=template&id=18db408b&scoped=true&
var app_messagevue_type_template_id_18db408b_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-app-message",class:{
		'n-app-message--left': _vm.position === 'left',
		'n-app-message--right': _vm.position === 'right'
	}},[(_vm.displayAvatar)?_c('n-avatar',{staticClass:"n-app-message__avatar",class:{
			'n-app-message__avatar--left': _vm.position === 'left',
			'n-app-message__avatar--right': _vm.position === 'right'
		},attrs:{"size":"s","name":_vm.message.name,"imageUrl":_vm.message.avatarUrl,"enableTooltip":_vm.enableAvatarTooltip}}):_vm._e(),(_vm.card)?_c('n-app',{staticClass:"n-app-message__card",attrs:{"colour":_vm.brandColour,"card":_vm.card,"location":"conversation","readonly":_vm.readonly}}):_vm._e()],1)}
var app_messagevue_type_template_id_18db408b_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/visualisations/conversation/app-message.vue?vue&type=template&id=18db408b&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/app/app.vue?vue&type=template&id=fc0cfaa6&
var appvue_type_template_id_fc0cfaa6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-reset",class:_vm.id},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.getStyles())}}),_c('div',{ref:"cardContainer",staticClass:"card-container"})])}
var appvue_type_template_id_fc0cfaa6_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/visualisations/app/app.vue?vue&type=template&id=fc0cfaa6&

// EXTERNAL MODULE: ./node_modules/@netcall/card-renderer/dist/sdk.js
var sdk = __webpack_require__("98a1");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/app/app.vue?vue&type=script&lang=ts&










var appvue_type_script_lang_ts_NApp = /*#__PURE__*/function (_Vue) {
  _inherits(NApp, _Vue);

  var _super = _createSuper(NApp);

  function NApp() {
    var _this;

    _classCallCheck(this, NApp);

    _this = _super.apply(this, arguments);
    _this.id = "nc_".concat(nanoid());
    return _this;
  }

  _createClass(NApp, [{
    key: "onCardChange",
    value: function onCardChange(card) {
      this.renderCard(card);
    }
  }, {
    key: "onReadonlyChange",
    value: function onReadonlyChange(value) {
      this.readonly = value;
      this.renderCard(this.card);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.renderCard(this.card);
      document.addEventListener('fresco-panel-submit', this.cardSubmitHandler);
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      document.removeEventListener('fresco-panel-submit', this.cardSubmitHandler);
    }
  }, {
    key: "getStyles",
    value: function getStyles() {
      return Object(sdk["getStyles"])(this.colour, this.id).innerHTML;
    }
  }, {
    key: "renderCard",
    value: function renderCard(card) {
      if (!this.$refs.cardContainer) {
        return;
      }

      this.clearSubmitTimeout();
      this.$refs.cardContainer.innerHTML = '';

      if (this.isCardComponentsValid(card)) {
        var cardJson = JSON.stringify(card.content.components);
        Object(sdk["renderElements"])(card.id || '', cardJson, this.$refs.cardContainer, this.location, this.readonly);
      } else {
        this.renderError(card);
      }
    }
  }, {
    key: "renderError",
    value: function renderError(card) {
      Object(sdk["renderElements"])(card.id || '', '{}', this.$refs.cardContainer, this.location, this.readonly);
    }
  }, {
    key: "isCardComponentsValid",
    value: function isCardComponentsValid(card) {
      return card.content && card.content.components && card.content.components.length > 0;
    }
  }, {
    key: "cardSubmitHandler",
    value: function cardSubmitHandler(e) {
      if (this.isEventForCard(e)) {
        var customEvent = e;
        var panelId = customEvent.detail.panelId;
        this.addLoadingSpinner(panelId);
        this.onSubmit(customEvent.detail);
      }
    }
  }, {
    key: "isEventForCard",
    value: function isEventForCard(evt) {
      return evt.detail.panelId === this.card.id;
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(e) {
      this.$emit('submit', e);
    }
  }, {
    key: "addLoadingSpinner",
    value: function addLoadingSpinner(panelId) {
      Object(sdk["addLoading"])(panelId);
      this.setSubmitTimeout(panelId);
    }
  }, {
    key: "setSubmitTimeout",
    value: function setSubmitTimeout(panelId) {
      var _this2 = this;

      this.submitTimeout = setTimeout(function () {
        _this2.replaceWithError(panelId);
      }, 30000);
    }
  }, {
    key: "clearSubmitTimeout",
    value: function clearSubmitTimeout() {
      if (this.submitTimeout) {
        clearTimeout(this.submitTimeout);
      }
    }
  }, {
    key: "replaceWithError",
    value: function replaceWithError(panelId) {
      // No method in render engine to display error state, but passing invalid json will result in that
      Object(sdk["replacePanel"])(panelId, '!!!');
    }
  }]);

  return NApp;
}(external_vue_default.a);

__decorate([Prop()], appvue_type_script_lang_ts_NApp.prototype, "readonly", void 0);

__decorate([Prop()], appvue_type_script_lang_ts_NApp.prototype, "card", void 0);

__decorate([Prop()], appvue_type_script_lang_ts_NApp.prototype, "colour", void 0);

__decorate([Prop()], appvue_type_script_lang_ts_NApp.prototype, "location", void 0);

__decorate([Watch('card')], appvue_type_script_lang_ts_NApp.prototype, "onCardChange", null);

__decorate([Watch('readonly')], appvue_type_script_lang_ts_NApp.prototype, "onReadonlyChange", null);

appvue_type_script_lang_ts_NApp = __decorate([vue_class_component_esm({
  name: 'n-app'
})], appvue_type_script_lang_ts_NApp);
/* harmony default export */ var appvue_type_script_lang_ts_ = (appvue_type_script_lang_ts_NApp);
// CONCATENATED MODULE: ./src/components/visualisations/app/app.vue?vue&type=script&lang=ts&
 /* harmony default export */ var app_appvue_type_script_lang_ts_ = (appvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/visualisations/app/app.vue?vue&type=style&index=0&lang=scss&
var appvue_type_style_index_0_lang_scss_ = __webpack_require__("f7d5");

// CONCATENATED MODULE: ./src/components/visualisations/app/app.vue






/* normalize component */

var app_component = normalizeComponent(
  app_appvue_type_script_lang_ts_,
  appvue_type_template_id_fc0cfaa6_render,
  appvue_type_template_id_fc0cfaa6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var app = (app_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/conversation/app-message.vue?vue&type=script&lang=ts&










var app_messagevue_type_script_lang_ts_NAppMessage = /*#__PURE__*/function (_Vue) {
  _inherits(NAppMessage, _Vue);

  var _super = _createSuper(NAppMessage);

  function NAppMessage() {
    _classCallCheck(this, NAppMessage);

    return _super.apply(this, arguments);
  }

  _createClass(NAppMessage, [{
    key: "card",
    get: function get() {
      if (this.message.card) {
        var content = this.message.card.content;
        return {
          id: this.message.id ? this.message.id : nanoid(),
          content: content
        };
      }

      return undefined;
    }
  }]);

  return NAppMessage;
}(external_vue_default.a);

__decorate([Prop()], app_messagevue_type_script_lang_ts_NAppMessage.prototype, "message", void 0);

__decorate([Prop({
  default: '#062b80'
})], app_messagevue_type_script_lang_ts_NAppMessage.prototype, "brandColour", void 0);

__decorate([Prop({
  default: false
})], app_messagevue_type_script_lang_ts_NAppMessage.prototype, "displayAvatar", void 0);

__decorate([Prop({
  default: false
})], app_messagevue_type_script_lang_ts_NAppMessage.prototype, "enableAvatarTooltip", void 0);

__decorate([Prop({
  default: 'right'
})], app_messagevue_type_script_lang_ts_NAppMessage.prototype, "position", void 0);

__decorate([Prop({
  default: true
})], app_messagevue_type_script_lang_ts_NAppMessage.prototype, "readonly", void 0);

app_messagevue_type_script_lang_ts_NAppMessage = __decorate([vue_class_component_esm({
  components: {
    NApp: app,
    NAvatar: avatar
  }
})], app_messagevue_type_script_lang_ts_NAppMessage);
/* harmony default export */ var app_messagevue_type_script_lang_ts_ = (app_messagevue_type_script_lang_ts_NAppMessage);
// CONCATENATED MODULE: ./src/components/visualisations/conversation/app-message.vue?vue&type=script&lang=ts&
 /* harmony default export */ var conversation_app_messagevue_type_script_lang_ts_ = (app_messagevue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/visualisations/conversation/app-message.vue?vue&type=style&index=0&id=18db408b&lang=scss&scoped=true&
var app_messagevue_type_style_index_0_id_18db408b_lang_scss_scoped_true_ = __webpack_require__("6546");

// CONCATENATED MODULE: ./src/components/visualisations/conversation/app-message.vue






/* normalize component */

var app_message_component = normalizeComponent(
  conversation_app_messagevue_type_script_lang_ts_,
  app_messagevue_type_template_id_18db408b_scoped_true_render,
  app_messagevue_type_template_id_18db408b_scoped_true_staticRenderFns,
  false,
  null,
  "18db408b",
  null
  
)

/* harmony default export */ var app_message = (app_message_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/conversation/quick-replies.vue?vue&type=template&id=dfab3daa&scoped=true&
var quick_repliesvue_type_template_id_dfab3daa_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quick-replies"},_vm._l((_vm.actions),function(action,index){return _c('div',{key:index,staticClass:"reply",style:(_vm.getStyle()),on:{"click":function($event){return _vm.sendQuickReply(action)}}},[_c('div',{staticClass:"reply-title"},[_vm._v(_vm._s(action))])])}),0)}
var quick_repliesvue_type_template_id_dfab3daa_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/visualisations/conversation/quick-replies.vue?vue&type=template&id=dfab3daa&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/conversation/quick-replies.vue?vue&type=script&lang=ts&







var quick_repliesvue_type_script_lang_ts_QuickReplies = /*#__PURE__*/function (_Vue) {
  _inherits(QuickReplies, _Vue);

  var _super = _createSuper(QuickReplies);

  function QuickReplies() {
    _classCallCheck(this, QuickReplies);

    return _super.apply(this, arguments);
  }

  _createClass(QuickReplies, [{
    key: "getStyle",
    value: function getStyle() {
      return {
        border: "1px solid ".concat(this.messageColour),
        color: this.messageColour
      };
    }
  }, {
    key: "sendQuickReply",
    value: function sendQuickReply(reply) {
      this.$emit('sendQuickReply', {
        text: reply,
        isQuickReplyResponse: true
      });
    }
  }]);

  return QuickReplies;
}(external_vue_default.a);

__decorate([Prop()], quick_repliesvue_type_script_lang_ts_QuickReplies.prototype, "messageColour", void 0);

__decorate([Prop()], quick_repliesvue_type_script_lang_ts_QuickReplies.prototype, "actions", void 0);

quick_repliesvue_type_script_lang_ts_QuickReplies = __decorate([vue_class_component_esm], quick_repliesvue_type_script_lang_ts_QuickReplies);
/* harmony default export */ var quick_repliesvue_type_script_lang_ts_ = (quick_repliesvue_type_script_lang_ts_QuickReplies);
// CONCATENATED MODULE: ./src/components/visualisations/conversation/quick-replies.vue?vue&type=script&lang=ts&
 /* harmony default export */ var conversation_quick_repliesvue_type_script_lang_ts_ = (quick_repliesvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/visualisations/conversation/quick-replies.vue?vue&type=style&index=0&id=dfab3daa&scoped=true&lang=scss&
var quick_repliesvue_type_style_index_0_id_dfab3daa_scoped_true_lang_scss_ = __webpack_require__("036e");

// CONCATENATED MODULE: ./src/components/visualisations/conversation/quick-replies.vue






/* normalize component */

var quick_replies_component = normalizeComponent(
  conversation_quick_repliesvue_type_script_lang_ts_,
  quick_repliesvue_type_template_id_dfab3daa_scoped_true_render,
  quick_repliesvue_type_template_id_dfab3daa_scoped_true_staticRenderFns,
  false,
  null,
  "dfab3daa",
  null
  
)

/* harmony default export */ var quick_replies = (quick_replies_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/conversation/conversation-thread.vue?vue&type=script&lang=ts&





















var conversation_threadvue_type_script_lang_ts_NConversationThread = /*#__PURE__*/function (_Vue) {
  _inherits(NConversationThread, _Vue);

  var _super = _createSuper(NConversationThread);

  function NConversationThread() {
    var _this;

    _classCallCheck(this, NConversationThread);

    _this = _super.apply(this, arguments);
    _this.isScrolledToBottom = false;
    return _this;
  }

  _createClass(NConversationThread, [{
    key: "mounted",
    value: function mounted() {
      this.scrollToBottom();
    }
  }, {
    key: "loadMoreMessages",
    value: function () {
      var _loadMoreMessages = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee($state) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$emit('load', $state);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadMoreMessages(_x) {
        return _loadMoreMessages.apply(this, arguments);
      }

      return loadMoreMessages;
    }()
  }, {
    key: "shouldShowTimestampDivider",
    value: function shouldShowTimestampDivider(current, previous) {
      if (!current || !previous) {
        return false;
      }

      var currentDate = moment_default()(current.timestampUtc);
      var previousDate = moment_default()(previous.timestampUtc);
      return currentDate.diff(previousDate, 'hours', false) !== 0;
    }
  }, {
    key: "formatTimestampDivider",
    value: function formatTimestampDivider(timestamp) {
      return moment_default()(timestamp).format('MMM D, YYYY, h:mm A');
    }
  }, {
    key: "shouldShowQuickReplies",
    value: function shouldShowQuickReplies() {
      var lastMessage = this.messages[this.messages.length - 1];
      return lastMessage && lastMessage.actions && lastMessage.actions.length;
    }
  }, {
    key: "sendQuickReply",
    value: function sendQuickReply(quickReply) {
      this.$emit('sendQuickReply', quickReply);
    }
  }, {
    key: "getMessagePosition",
    value: function getMessagePosition(m) {
      return m.direction === 'outbound' ? 'right' : 'left';
    }
  }, {
    key: "getFormattedMessage",
    value: function getFormattedMessage(message) {
      return new messageContent_MessageContent(message).EscapeHtml().ProcessUrls().NewLinesToBreaks().Value;
    }
  }, {
    key: "scrollToBottom",
    value: function scrollToBottom() {
      if (!this.$refs.conversationContainer) return;
      this.$refs.conversationContainer.scrollTop = this.$refs.conversationContainer.scrollHeight;
      this.isScrolledToBottom = true;
    }
  }]);

  return NConversationThread;
}(external_vue_default.a);

__decorate([Prop({
  default: '#062b80'
})], conversation_threadvue_type_script_lang_ts_NConversationThread.prototype, "outboundMessageColour", void 0);

__decorate([Prop({
  default: function _default() {
    return [];
  }
})], conversation_threadvue_type_script_lang_ts_NConversationThread.prototype, "messages", void 0);

__decorate([Prop({
  default: false
})], conversation_threadvue_type_script_lang_ts_NConversationThread.prototype, "displayAvatar", void 0);

__decorate([Prop({
  default: false
})], conversation_threadvue_type_script_lang_ts_NConversationThread.prototype, "enableAvatarTooltip", void 0);

__decorate([Prop({
  default: true
})], conversation_threadvue_type_script_lang_ts_NConversationThread.prototype, "readonlyApps", void 0);

conversation_threadvue_type_script_lang_ts_NConversationThread = __decorate([vue_class_component_esm({
  components: {
    InfiniteLoading: vue_infinite_loading_default.a,
    NTextMessage: text_message,
    NAppMessage: app_message,
    NImageMessage: image_message,
    NVideoMessage: video_message,
    NAudioMessage: audio_message,
    NFileMessage: file_message,
    QuickReplies: quick_replies,
    NTooltip: tooltip,
    NIcon: icon
  },
  name: 'n-conversation-thread'
})], conversation_threadvue_type_script_lang_ts_NConversationThread);
/* harmony default export */ var conversation_threadvue_type_script_lang_ts_ = (conversation_threadvue_type_script_lang_ts_NConversationThread);
// CONCATENATED MODULE: ./src/components/visualisations/conversation/conversation-thread.vue?vue&type=script&lang=ts&
 /* harmony default export */ var conversation_conversation_threadvue_type_script_lang_ts_ = (conversation_threadvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/visualisations/conversation/conversation-thread.vue?vue&type=style&index=0&id=86e34550&scoped=true&lang=scss&
var conversation_threadvue_type_style_index_0_id_86e34550_scoped_true_lang_scss_ = __webpack_require__("fd48");

// CONCATENATED MODULE: ./src/components/visualisations/conversation/conversation-thread.vue






/* normalize component */

var conversation_thread_component = normalizeComponent(
  conversation_conversation_threadvue_type_script_lang_ts_,
  conversation_threadvue_type_template_id_86e34550_scoped_true_render,
  conversation_threadvue_type_template_id_86e34550_scoped_true_staticRenderFns,
  false,
  null,
  "86e34550",
  null
  
)

/* harmony default export */ var conversation_thread = (conversation_thread_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/conversation/conversation.vue?vue&type=template&id=2a7074df&
var conversationvue_type_template_id_2a7074df_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-conversation"},[_c('n-conversation-thread',{attrs:{"messages":_vm.messages,"outboundMessageColour":_vm.outboundMessageColour,"displayAvatar":_vm.displayAvatar,"enableAvatarTooltip":_vm.enableAvatarTooltip,"readonlyApps":_vm.readonlyApps},on:{"load":function ($state) { return _vm.$emit('load', $state); },"sendQuickReply":function (quickReply) { return _vm.$emit('sendQuickReply', quickReply); }}}),_c('n-message-composer',{attrs:{"accentColour":_vm.outboundMessageColour},on:{"messageSend":function (messageText) { return _vm.$emit('messageSend', messageText); },"conversationRead":function($event){return _vm.$emit('conversationRead')},"typingStart":function($event){return _vm.$emit('typingStart')},"typingStop":function($event){return _vm.$emit('typingStop')}}})],1)}
var conversationvue_type_template_id_2a7074df_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/visualisations/conversation/conversation.vue?vue&type=template&id=2a7074df&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/conversation/message-composer.vue?vue&type=template&id=3e2f946a&scoped=true&
var message_composervue_type_template_id_3e2f946a_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-message-composer"},[_c('div',{staticClass:"n-message-composer__input-container",class:{
			'n-message-composer__input-container--focused': _vm.isInputFocused,
			'n-message-composer__input-container--disabled': _vm.disabled
		}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.messageText),expression:"messageText"}],ref:"input",staticClass:"n-message-composer__input",attrs:{"rows":"1","placeholder":"Enter your message...","disabled":_vm.disabled},domProps:{"value":(_vm.messageText)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.messageText=$event.target.value},function($event){return _vm.onInput()}],"focus":function($event){return _vm.onFocus()},"blur":_vm.onBlur,"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onSend.apply(null, arguments)}}}),_c('div',{staticClass:"n-message-composer__actions"},[_c('n-emoji-picker',{attrs:{"accentColour":_vm.accentColour},on:{"emojiSelect":_vm.insertEmoji}}),_c('n-button',{attrs:{"icon":"send","variant":"action","disabled":_vm.messageText && _vm.messageText.length === 0},on:{"click":_vm.onSend}})],1)])])}
var message_composervue_type_template_id_3e2f946a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/visualisations/conversation/message-composer.vue?vue&type=template&id=3e2f946a&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("498a");

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("2ef0");

// CONCATENATED MODULE: ./node_modules/autosize/dist/autosize.esm.js
var autosize_esm_e,t,n="function"==typeof Map?new Map:(autosize_esm_e=[],t=[],{has:function(t){return autosize_esm_e.indexOf(t)>-1},get:function(n){return t[autosize_esm_e.indexOf(n)]},set:function(n,o){-1===autosize_esm_e.indexOf(n)&&(autosize_esm_e.push(n),t.push(o))},delete:function(n){var o=autosize_esm_e.indexOf(n);o>-1&&(autosize_esm_e.splice(o,1),t.splice(o,1))}}),o=function(e){return new Event(e,{bubbles:!0})};try{new Event("test")}catch(e){o=function(e){var t=document.createEvent("Event");return t.initEvent(e,!0,!1),t}}function r(e){var t=n.get(e);t&&t.destroy()}function i(e){var t=n.get(e);t&&t.update()}var l=null;"undefined"==typeof window||"function"!=typeof window.getComputedStyle?((l=function(e){return e}).destroy=function(e){return e},l.update=function(e){return e}):((l=function(e,t){return e&&Array.prototype.forEach.call(e.length?e:[e],function(e){return function(e){if(e&&e.nodeName&&"TEXTAREA"===e.nodeName&&!n.has(e)){var t,r=null,i=null,l=null,d=function(){e.clientWidth!==i&&c()},a=function(t){window.removeEventListener("resize",d,!1),e.removeEventListener("input",c,!1),e.removeEventListener("keyup",c,!1),e.removeEventListener("autosize:destroy",a,!1),e.removeEventListener("autosize:update",c,!1),Object.keys(t).forEach(function(n){e.style[n]=t[n]}),n.delete(e)}.bind(e,{height:e.style.height,resize:e.style.resize,overflowY:e.style.overflowY,overflowX:e.style.overflowX,wordWrap:e.style.wordWrap});e.addEventListener("autosize:destroy",a,!1),"onpropertychange"in e&&"oninput"in e&&e.addEventListener("keyup",c,!1),window.addEventListener("resize",d,!1),e.addEventListener("input",c,!1),e.addEventListener("autosize:update",c,!1),e.style.overflowX="hidden",e.style.wordWrap="break-word",n.set(e,{destroy:a,update:c}),"vertical"===(t=window.getComputedStyle(e,null)).resize?e.style.resize="none":"both"===t.resize&&(e.style.resize="horizontal"),r="content-box"===t.boxSizing?-(parseFloat(t.paddingTop)+parseFloat(t.paddingBottom)):parseFloat(t.borderTopWidth)+parseFloat(t.borderBottomWidth),isNaN(r)&&(r=0),c()}function u(t){var n=e.style.width;e.style.width="0px",e.style.width=n,e.style.overflowY=t}function s(){if(0!==e.scrollHeight){var t=function(e){for(var t=[];e&&e.parentNode&&e.parentNode instanceof Element;)e.parentNode.scrollTop&&t.push({node:e.parentNode,scrollTop:e.parentNode.scrollTop}),e=e.parentNode;return t}(e),n=document.documentElement&&document.documentElement.scrollTop;e.style.height="",e.style.height=e.scrollHeight+r+"px",i=e.clientWidth,t.forEach(function(e){e.node.scrollTop=e.scrollTop}),n&&(document.documentElement.scrollTop=n)}}function c(){s();var t=Math.round(parseFloat(e.style.height)),n=window.getComputedStyle(e,null),r="content-box"===n.boxSizing?Math.round(parseFloat(n.height)):e.offsetHeight;if(r<t?"hidden"===n.overflowY&&(u("scroll"),s(),r="content-box"===n.boxSizing?Math.round(parseFloat(window.getComputedStyle(e,null).height)):e.offsetHeight):"hidden"!==n.overflowY&&(u("hidden"),s(),r="content-box"===n.boxSizing?Math.round(parseFloat(window.getComputedStyle(e,null).height)):e.offsetHeight),l!==r){l=r;var i=o("autosize:resized");try{e.dispatchEvent(i)}catch(e){}}}}(e)}),e}).destroy=function(e){return e&&Array.prototype.forEach.call(e.length?e:[e],r),e},l.update=function(e){return e&&Array.prototype.forEach.call(e.length?e:[e],i),e});var d=l;/* harmony default export */ var autosize_esm = (d);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/emoji-picker/emoji-picker.vue?vue&type=template&id=5e1d87b0&scoped=true&
var emoji_pickervue_type_template_id_5e1d87b0_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-emoji-picker"},[_c('div',{staticClass:"n-emoji-picker__button-container",class:{ 'n-emoji-picker__button-container--open': _vm.emojiPickerOpen },style:({ color: _vm.accentColour })},[_c('n-button',{staticClass:"n-message-composer__emoji-button",attrs:{"icon":"emoji","variant":"action"},on:{"click":_vm.toggleOpen}})],1),(_vm.emojiPickerOpen)?_c('div',{staticClass:"n-emoji-picker__overlay",on:{"click":_vm.toggleOpen}}):_vm._e(),(_vm.emojiPickerOpen)?_c('Picker',{staticClass:"emoji-picker",attrs:{"emoji-size":21,"perLine":10,"native":true,"showPreview":false,"data":_vm.ei},on:{"select":_vm.insertEmoji}}):_vm._e(),(_vm.emojiPickerOpen)?_c('div',{staticClass:"arrow-down"},[_c('div',{staticClass:"inner-arrow"})]):_vm._e()],1)}
var emoji_pickervue_type_template_id_5e1d87b0_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/visualisations/emoji-picker/emoji-picker.vue?vue&type=template&id=5e1d87b0&scoped=true&

// EXTERNAL MODULE: ./node_modules/emoji-mart-vue-fast/dist/emoji-mart.js
var emoji_mart = __webpack_require__("41fb");

// CONCATENATED MODULE: ./src/data/emoji-list.ts
// @ts-nocheck
/* eslint-disable */var emojiList={compressed:true,categories:[{id:'smileys',name:'Smileys & Emotion',emojis:['grinning','smiley','smile','grin','laughing','sweat_smile','rolling_on_the_floor_laughing','joy','slightly_smiling_face','upside_down_face','wink','blush','innocent','smiling_face_with_3_hearts','heart_eyes','star-struck','kissing_heart','kissing','relaxed','kissing_closed_eyes','kissing_smiling_eyes','yum','stuck_out_tongue','stuck_out_tongue_winking_eye','zany_face','stuck_out_tongue_closed_eyes','money_mouth_face','hugging_face','face_with_hand_over_mouth','shushing_face','thinking_face','zipper_mouth_face','face_with_raised_eyebrow','neutral_face','expressionless','no_mouth','smirk','unamused','face_with_rolling_eyes','grimacing','lying_face','relieved','pensive','sleepy','drooling_face','sleeping','mask','face_with_thermometer','face_with_head_bandage','nauseated_face','face_vomiting','sneezing_face','hot_face','cold_face','woozy_face','dizzy_face','exploding_head','face_with_cowboy_hat','partying_face','sunglasses','nerd_face','face_with_monocle','confused','worried','slightly_frowning_face','white_frowning_face','open_mouth','hushed','astonished','flushed','pleading_face','frowning','anguished','fearful','cold_sweat','disappointed_relieved','cry','sob','scream','confounded','persevere','disappointed','sweat','weary','tired_face','yawning_face','triumph','rage','angry','face_with_symbols_on_mouth','smiling_imp','imp','skull','skull_and_crossbones','hankey','clown_face','japanese_ogre','japanese_goblin','ghost','alien','space_invader','robot_face','smiley_cat','smile_cat','joy_cat','heart_eyes_cat','smirk_cat','kissing_cat','scream_cat','crying_cat_face','pouting_cat','see_no_evil','hear_no_evil','speak_no_evil','kiss','love_letter','cupid','gift_heart','sparkling_heart','heartpulse','heartbeat','revolving_hearts','two_hearts','heart_decoration','heavy_heart_exclamation_mark_ornament','broken_heart','heart','orange_heart','yellow_heart','green_heart','blue_heart','purple_heart','brown_heart','black_heart','white_heart','100','anger','boom','dizzy','sweat_drops','dash','hole','bomb','speech_balloon','eye-in-speech-bubble','left_speech_bubble','right_anger_bubble','thought_balloon','zzz']},{id:'people',name:'People & Body',emojis:['wave','raised_back_of_hand','raised_hand_with_fingers_splayed','hand','spock-hand','ok_hand','pinching_hand','v','crossed_fingers','i_love_you_hand_sign','the_horns','call_me_hand','point_left','point_right','point_up_2','middle_finger','point_down','point_up','+1','-1','fist','facepunch','left-facing_fist','right-facing_fist','clap','raised_hands','open_hands','palms_up_together','handshake','pray','writing_hand','nail_care','selfie','muscle','mechanical_arm','mechanical_leg','leg','foot','ear','ear_with_hearing_aid','nose','brain','tooth','bone','eyes','eye','tongue','lips','baby','child','boy','girl','adult','person_with_blond_hair','man','bearded_person','red_haired_man','curly_haired_man','white_haired_man','bald_man','woman','red_haired_woman','red_haired_person','curly_haired_woman','curly_haired_person','white_haired_woman','white_haired_person','bald_woman','bald_person','blond-haired-woman','blond-haired-man','older_adult','older_man','older_woman','person_frowning','man-frowning','woman-frowning','person_with_pouting_face','man-pouting','woman-pouting','no_good','man-gesturing-no','woman-gesturing-no','ok_woman','man-gesturing-ok','woman-gesturing-ok','information_desk_person','man-tipping-hand','woman-tipping-hand','raising_hand','man-raising-hand','woman-raising-hand','deaf_person','deaf_man','deaf_woman','bow','man-bowing','woman-bowing','face_palm','man-facepalming','woman-facepalming','shrug','man-shrugging','woman-shrugging','health_worker','male-doctor','female-doctor','student','male-student','female-student','teacher','male-teacher','female-teacher','judge','male-judge','female-judge','farmer','male-farmer','female-farmer','cook','male-cook','female-cook','mechanic','male-mechanic','female-mechanic','factory_worker','male-factory-worker','female-factory-worker','office_worker','male-office-worker','female-office-worker','scientist','male-scientist','female-scientist','technologist','male-technologist','female-technologist','singer','male-singer','female-singer','artist','male-artist','female-artist','pilot','male-pilot','female-pilot','astronaut','male-astronaut','female-astronaut','firefighter','male-firefighter','female-firefighter','cop','male-police-officer','female-police-officer','sleuth_or_spy','male-detective','female-detective','guardsman','male-guard','female-guard','construction_worker','male-construction-worker','female-construction-worker','prince','princess','man_with_turban','man-wearing-turban','woman-wearing-turban','man_with_gua_pi_mao','person_with_headscarf','man_in_tuxedo','bride_with_veil','pregnant_woman','breast-feeding','angel','santa','mrs_claus','superhero','male_superhero','female_superhero','supervillain','male_supervillain','female_supervillain','mage','male_mage','female_mage','fairy','male_fairy','female_fairy','vampire','male_vampire','female_vampire','merperson','merman','mermaid','elf','male_elf','female_elf','genie','male_genie','female_genie','zombie','male_zombie','female_zombie','massage','man-getting-massage','woman-getting-massage','haircut','man-getting-haircut','woman-getting-haircut','walking','man-walking','woman-walking','standing_person','man_standing','woman_standing','kneeling_person','man_kneeling','woman_kneeling','person_with_probing_cane','man_with_probing_cane','woman_with_probing_cane','person_in_motorized_wheelchair','man_in_motorized_wheelchair','woman_in_motorized_wheelchair','person_in_manual_wheelchair','man_in_manual_wheelchair','woman_in_manual_wheelchair','runner','man-running','woman-running','dancer','man_dancing','man_in_business_suit_levitating','dancers','man-with-bunny-ears-partying','woman-with-bunny-ears-partying','person_in_steamy_room','man_in_steamy_room','woman_in_steamy_room','person_climbing','man_climbing','woman_climbing','fencer','horse_racing','skier','snowboarder','golfer','man-golfing','woman-golfing','surfer','man-surfing','woman-surfing','rowboat','man-rowing-boat','woman-rowing-boat','swimmer','man-swimming','woman-swimming','person_with_ball','man-bouncing-ball','woman-bouncing-ball','weight_lifter','man-lifting-weights','woman-lifting-weights','bicyclist','man-biking','woman-biking','mountain_bicyclist','man-mountain-biking','woman-mountain-biking','person_doing_cartwheel','man-cartwheeling','woman-cartwheeling','wrestlers','man-wrestling','woman-wrestling','water_polo','man-playing-water-polo','woman-playing-water-polo','handball','man-playing-handball','woman-playing-handball','juggling','man-juggling','woman-juggling','person_in_lotus_position','man_in_lotus_position','woman_in_lotus_position','bath','sleeping_accommodation','people_holding_hands','two_women_holding_hands','couple','two_men_holding_hands','couplekiss','woman-kiss-man','man-kiss-man','woman-kiss-woman','couple_with_heart','woman-heart-man','man-heart-man','woman-heart-woman','family','man-woman-boy','man-woman-girl','man-woman-girl-boy','man-woman-boy-boy','man-woman-girl-girl','man-man-boy','man-man-girl','man-man-girl-boy','man-man-boy-boy','man-man-girl-girl','woman-woman-boy','woman-woman-girl','woman-woman-girl-boy','woman-woman-boy-boy','woman-woman-girl-girl','man-boy','man-boy-boy','man-girl','man-girl-boy','man-girl-girl','woman-boy','woman-boy-boy','woman-girl','woman-girl-boy','woman-girl-girl','speaking_head_in_silhouette','bust_in_silhouette','busts_in_silhouette','footprints']},{id:'nature',name:'Animals & Nature',emojis:['monkey_face','monkey','gorilla','orangutan','dog','dog2','guide_dog','service_dog','poodle','wolf','fox_face','raccoon','cat','cat2','lion_face','tiger','tiger2','leopard','horse','racehorse','unicorn_face','zebra_face','deer','cow','ox','water_buffalo','cow2','pig','pig2','boar','pig_nose','ram','sheep','goat','dromedary_camel','camel','llama','giraffe_face','elephant','rhinoceros','hippopotamus','mouse','mouse2','rat','hamster','rabbit','rabbit2','chipmunk','hedgehog','bat','bear','koala','panda_face','sloth','otter','skunk','kangaroo','badger','feet','turkey','chicken','rooster','hatching_chick','baby_chick','hatched_chick','bird','penguin','dove_of_peace','eagle','duck','swan','owl','flamingo','peacock','parrot','frog','crocodile','turtle','lizard','snake','dragon_face','dragon','sauropod','t-rex','whale','whale2','dolphin','fish','tropical_fish','blowfish','shark','octopus','shell','snail','butterfly','bug','ant','bee','beetle','cricket','spider','spider_web','scorpion','mosquito','microbe','bouquet','cherry_blossom','white_flower','rosette','rose','wilted_flower','hibiscus','sunflower','blossom','tulip','seedling','evergreen_tree','deciduous_tree','palm_tree','cactus','ear_of_rice','herb','shamrock','four_leaf_clover','maple_leaf','fallen_leaf','leaves']},{id:'foods',name:'Food & Drink',emojis:['grapes','melon','watermelon','tangerine','lemon','banana','pineapple','mango','apple','green_apple','pear','peach','cherries','strawberry','kiwifruit','tomato','coconut','avocado','eggplant','potato','carrot','corn','hot_pepper','cucumber','leafy_green','broccoli','garlic','onion','mushroom','peanuts','chestnut','bread','croissant','baguette_bread','pretzel','bagel','pancakes','waffle','cheese_wedge','meat_on_bone','poultry_leg','cut_of_meat','bacon','hamburger','fries','pizza','hotdog','sandwich','taco','burrito','stuffed_flatbread','falafel','egg','fried_egg','shallow_pan_of_food','stew','bowl_with_spoon','green_salad','popcorn','butter','salt','canned_food','bento','rice_cracker','rice_ball','rice','curry','ramen','spaghetti','sweet_potato','oden','sushi','fried_shrimp','fish_cake','moon_cake','dango','dumpling','fortune_cookie','takeout_box','crab','lobster','shrimp','squid','oyster','icecream','shaved_ice','ice_cream','doughnut','cookie','birthday','cake','cupcake','pie','chocolate_bar','candy','lollipop','custard','honey_pot','baby_bottle','glass_of_milk','coffee','tea','sake','champagne','wine_glass','cocktail','tropical_drink','beer','beers','clinking_glasses','tumbler_glass','cup_with_straw','beverage_box','mate_drink','ice_cube','chopsticks','knife_fork_plate','fork_and_knife','spoon','hocho','amphora']},{id:'activity',name:'Activities',emojis:['jack_o_lantern','christmas_tree','fireworks','sparkler','firecracker','sparkles','balloon','tada','confetti_ball','tanabata_tree','bamboo','dolls','flags','wind_chime','rice_scene','red_envelope','ribbon','gift','reminder_ribbon','admission_tickets','ticket','medal','trophy','sports_medal','first_place_medal','second_place_medal','third_place_medal','soccer','baseball','softball','basketball','volleyball','football','rugby_football','tennis','flying_disc','bowling','cricket_bat_and_ball','field_hockey_stick_and_ball','ice_hockey_stick_and_puck','lacrosse','table_tennis_paddle_and_ball','badminton_racquet_and_shuttlecock','boxing_glove','martial_arts_uniform','goal_net','golf','ice_skate','fishing_pole_and_fish','diving_mask','running_shirt_with_sash','ski','sled','curling_stone','dart','yo-yo','kite','8ball','crystal_ball','nazar_amulet','video_game','joystick','slot_machine','game_die','jigsaw','teddy_bear','spades','hearts','diamonds','clubs','chess_pawn','black_joker','mahjong','flower_playing_cards','performing_arts','frame_with_picture','art','thread','yarn']},{id:'places',name:'Travel & Places',emojis:['earth_africa','earth_americas','earth_asia','globe_with_meridians','world_map','japan','compass','snow_capped_mountain','mountain','volcano','mount_fuji','camping','beach_with_umbrella','desert','desert_island','national_park','stadium','classical_building','building_construction','bricks','house_buildings','derelict_house_building','house','house_with_garden','office','post_office','european_post_office','hospital','bank','hotel','love_hotel','convenience_store','school','department_store','factory','japanese_castle','european_castle','wedding','tokyo_tower','statue_of_liberty','church','mosque','hindu_temple','synagogue','shinto_shrine','kaaba','fountain','tent','foggy','night_with_stars','cityscape','sunrise_over_mountains','sunrise','city_sunset','city_sunrise','bridge_at_night','hotsprings','carousel_horse','ferris_wheel','roller_coaster','barber','circus_tent','steam_locomotive','railway_car','bullettrain_side','bullettrain_front','train2','metro','light_rail','station','tram','monorail','mountain_railway','train','bus','oncoming_bus','trolleybus','minibus','ambulance','fire_engine','police_car','oncoming_police_car','taxi','oncoming_taxi','car','oncoming_automobile','blue_car','truck','articulated_lorry','tractor','racing_car','racing_motorcycle','motor_scooter','manual_wheelchair','motorized_wheelchair','auto_rickshaw','bike','scooter','skateboard','busstop','motorway','railway_track','oil_drum','fuelpump','rotating_light','traffic_light','vertical_traffic_light','octagonal_sign','construction','anchor','boat','canoe','speedboat','passenger_ship','ferry','motor_boat','ship','airplane','small_airplane','airplane_departure','airplane_arriving','parachute','seat','helicopter','suspension_railway','mountain_cableway','aerial_tramway','satellite','rocket','flying_saucer','bellhop_bell','luggage','hourglass','hourglass_flowing_sand','watch','alarm_clock','stopwatch','timer_clock','mantelpiece_clock','clock12','clock1230','clock1','clock130','clock2','clock230','clock3','clock330','clock4','clock430','clock5','clock530','clock6','clock630','clock7','clock730','clock8','clock830','clock9','clock930','clock10','clock1030','clock11','clock1130','new_moon','waxing_crescent_moon','first_quarter_moon','moon','full_moon','waning_gibbous_moon','last_quarter_moon','waning_crescent_moon','crescent_moon','new_moon_with_face','first_quarter_moon_with_face','last_quarter_moon_with_face','thermometer','sunny','full_moon_with_face','sun_with_face','ringed_planet','star','star2','stars','milky_way','cloud','partly_sunny','thunder_cloud_and_rain','mostly_sunny','barely_sunny','partly_sunny_rain','rain_cloud','snow_cloud','lightning','tornado','fog','wind_blowing_face','cyclone','rainbow','closed_umbrella','umbrella','umbrella_with_rain_drops','umbrella_on_ground','zap','snowflake','snowman','snowman_without_snow','comet','fire','droplet','ocean']},{id:'objects',name:'Objects',emojis:['eyeglasses','dark_sunglasses','goggles','lab_coat','safety_vest','necktie','shirt','jeans','scarf','gloves','coat','socks','dress','kimono','sari','one-piece_swimsuit','briefs','shorts','bikini','womans_clothes','purse','handbag','pouch','shopping_bags','school_satchel','mans_shoe','athletic_shoe','hiking_boot','womans_flat_shoe','high_heel','sandal','ballet_shoes','boot','crown','womans_hat','tophat','mortar_board','billed_cap','helmet_with_white_cross','prayer_beads','lipstick','ring','gem','mute','speaker','sound','loud_sound','loudspeaker','mega','postal_horn','bell','no_bell','musical_score','musical_note','notes','studio_microphone','level_slider','control_knobs','microphone','headphones','radio','saxophone','guitar','musical_keyboard','trumpet','violin','banjo','drum_with_drumsticks','iphone','calling','phone','telephone_receiver','pager','fax','battery','electric_plug','computer','desktop_computer','printer','keyboard','three_button_mouse','trackball','minidisc','floppy_disk','cd','dvd','abacus','movie_camera','film_frames','film_projector','clapper','tv','camera','camera_with_flash','video_camera','vhs','mag','mag_right','candle','bulb','flashlight','izakaya_lantern','diya_lamp','notebook_with_decorative_cover','closed_book','book','green_book','blue_book','orange_book','books','notebook','ledger','page_with_curl','scroll','page_facing_up','newspaper','rolled_up_newspaper','bookmark_tabs','bookmark','label','moneybag','yen','dollar','euro','pound','money_with_wings','credit_card','receipt','chart','currency_exchange','heavy_dollar_sign','email','e-mail','incoming_envelope','envelope_with_arrow','outbox_tray','inbox_tray','package','mailbox','mailbox_closed','mailbox_with_mail','mailbox_with_no_mail','postbox','ballot_box_with_ballot','pencil2','black_nib','lower_left_fountain_pen','lower_left_ballpoint_pen','lower_left_paintbrush','lower_left_crayon','memo','briefcase','file_folder','open_file_folder','card_index_dividers','date','calendar','spiral_note_pad','spiral_calendar_pad','card_index','chart_with_upwards_trend','chart_with_downwards_trend','bar_chart','clipboard','pushpin','round_pushpin','paperclip','linked_paperclips','straight_ruler','triangular_ruler','scissors','card_file_box','file_cabinet','wastebasket','lock','unlock','lock_with_ink_pen','closed_lock_with_key','key','old_key','hammer','axe','pick','hammer_and_pick','hammer_and_wrench','dagger_knife','crossed_swords','gun','bow_and_arrow','shield','wrench','nut_and_bolt','gear','compression','scales','probing_cane','link','chains','toolbox','magnet','alembic','test_tube','petri_dish','dna','microscope','telescope','satellite_antenna','syringe','drop_of_blood','pill','adhesive_bandage','stethoscope','door','bed','couch_and_lamp','chair','toilet','shower','bathtub','razor','lotion_bottle','safety_pin','broom','basket','roll_of_paper','soap','sponge','fire_extinguisher','shopping_trolley','smoking','coffin','funeral_urn','moyai']},{id:'symbols',name:'Symbols',emojis:['atm','put_litter_in_its_place','potable_water','wheelchair','mens','womens','restroom','baby_symbol','wc','passport_control','customs','baggage_claim','left_luggage','warning','children_crossing','no_entry','no_entry_sign','no_bicycles','no_smoking','do_not_litter','non-potable_water','no_pedestrians','no_mobile_phones','underage','radioactive_sign','biohazard_sign','arrow_up','arrow_upper_right','arrow_right','arrow_lower_right','arrow_down','arrow_lower_left','arrow_left','arrow_upper_left','arrow_up_down','left_right_arrow','leftwards_arrow_with_hook','arrow_right_hook','arrow_heading_up','arrow_heading_down','arrows_clockwise','arrows_counterclockwise','back','end','on','soon','top','place_of_worship','atom_symbol','om_symbol','star_of_david','wheel_of_dharma','yin_yang','latin_cross','orthodox_cross','star_and_crescent','peace_symbol','menorah_with_nine_branches','six_pointed_star','aries','taurus','gemini','cancer','leo','virgo','libra','scorpius','sagittarius','capricorn','aquarius','pisces','ophiuchus','twisted_rightwards_arrows','repeat','repeat_one','arrow_forward','fast_forward','black_right_pointing_double_triangle_with_vertical_bar','black_right_pointing_triangle_with_double_vertical_bar','arrow_backward','rewind','black_left_pointing_double_triangle_with_vertical_bar','arrow_up_small','arrow_double_up','arrow_down_small','arrow_double_down','double_vertical_bar','black_square_for_stop','black_circle_for_record','eject','cinema','low_brightness','high_brightness','signal_strength','vibration_mode','mobile_phone_off','infinity','recycle','fleur_de_lis','trident','name_badge','beginner','o','white_check_mark','ballot_box_with_check','heavy_check_mark','heavy_multiplication_x','x','negative_squared_cross_mark','heavy_plus_sign','heavy_minus_sign','heavy_division_sign','curly_loop','loop','part_alternation_mark','eight_spoked_asterisk','eight_pointed_black_star','sparkle','bangbang','interrobang','question','grey_question','grey_exclamation','exclamation','wavy_dash','copyright','registered','tm','hash','keycap_star','zero','one','two','three','four','five','six','seven','eight','nine','keycap_ten','capital_abcd','abcd','1234','symbols','abc','a','ab','b','cl','cool','free','information_source','id','m','new','ng','o2','ok','parking','sos','up','vs','koko','sa','u6708','u6709','u6307','ideograph_advantage','u5272','u7121','u7981','accept','u7533','u5408','u7a7a','congratulations','secret','u55b6','u6e80','red_circle','large_orange_circle','large_yellow_circle','large_green_circle','large_blue_circle','large_purple_circle','large_brown_circle','black_circle','white_circle','large_red_square','large_orange_square','large_yellow_square','large_green_square','large_blue_square','large_purple_square','large_brown_square','black_large_square','white_large_square','black_medium_square','white_medium_square','black_medium_small_square','white_medium_small_square','black_small_square','white_small_square','large_orange_diamond','large_blue_diamond','small_orange_diamond','small_blue_diamond','small_red_triangle','small_red_triangle_down','diamond_shape_with_a_dot_inside','radio_button','white_square_button','black_square_button']},{id:'flags',name:'Flags',emojis:['checkered_flag','cn','crossed_flags','de','es','flag-ac','flag-ad','flag-ae','flag-af','flag-ag','flag-ai','flag-al','flag-am','flag-ao','flag-aq','flag-ar','flag-as','flag-at','flag-au','flag-aw','flag-ax','flag-az','flag-ba','flag-bb','flag-bd','flag-be','flag-bf','flag-bg','flag-bh','flag-bi','flag-bj','flag-bl','flag-bm','flag-bn','flag-bo','flag-bq','flag-br','flag-bs','flag-bt','flag-bv','flag-bw','flag-by','flag-bz','flag-ca','flag-cc','flag-cd','flag-cf','flag-cg','flag-ch','flag-ci','flag-ck','flag-cl','flag-cm','flag-co','flag-cp','flag-cr','flag-cu','flag-cv','flag-cw','flag-cx','flag-cy','flag-cz','flag-dg','flag-dj','flag-dk','flag-dm','flag-do','flag-dz','flag-ea','flag-ec','flag-ee','flag-eg','flag-eh','flag-england','flag-er','flag-et','flag-eu','flag-fi','flag-fj','flag-fk','flag-fm','flag-fo','flag-ga','flag-gd','flag-ge','flag-gf','flag-gg','flag-gh','flag-gi','flag-gl','flag-gm','flag-gn','flag-gp','flag-gq','flag-gr','flag-gs','flag-gt','flag-gu','flag-gw','flag-gy','flag-hk','flag-hm','flag-hn','flag-hr','flag-ht','flag-hu','flag-ic','flag-id','flag-ie','flag-il','flag-im','flag-in','flag-io','flag-iq','flag-ir','flag-is','flag-je','flag-jm','flag-jo','flag-ke','flag-kg','flag-kh','flag-ki','flag-km','flag-kn','flag-kp','flag-kw','flag-ky','flag-kz','flag-la','flag-lb','flag-lc','flag-li','flag-lk','flag-lr','flag-ls','flag-lt','flag-lu','flag-lv','flag-ly','flag-ma','flag-mc','flag-md','flag-me','flag-mf','flag-mg','flag-mh','flag-mk','flag-ml','flag-mm','flag-mn','flag-mo','flag-mp','flag-mq','flag-mr','flag-ms','flag-mt','flag-mu','flag-mv','flag-mw','flag-mx','flag-my','flag-mz','flag-na','flag-nc','flag-ne','flag-nf','flag-ng','flag-ni','flag-nl','flag-no','flag-np','flag-nr','flag-nu','flag-nz','flag-om','flag-pa','flag-pe','flag-pf','flag-pg','flag-ph','flag-pk','flag-pl','flag-pm','flag-pn','flag-pr','flag-ps','flag-pt','flag-pw','flag-py','flag-qa','flag-re','flag-ro','flag-rs','flag-rw','flag-sa','flag-sb','flag-sc','flag-scotland','flag-sd','flag-se','flag-sg','flag-sh','flag-si','flag-sj','flag-sk','flag-sl','flag-sm','flag-sn','flag-so','flag-sr','flag-ss','flag-st','flag-sv','flag-sx','flag-sy','flag-sz','flag-ta','flag-tc','flag-td','flag-tf','flag-tg','flag-th','flag-tj','flag-tk','flag-tl','flag-tm','flag-tn','flag-to','flag-tr','flag-tt','flag-tv','flag-tw','flag-tz','flag-ua','flag-ug','flag-um','flag-uy','flag-uz','flag-va','flag-vc','flag-ve','flag-vg','flag-vi','flag-vn','flag-vu','flag-wales','flag-wf','flag-ws','flag-xk','flag-ye','flag-yt','flag-za','flag-zm','flag-zw','fr','gb','it','jp','kr','pirate_flag','rainbow-flag','ru','triangular_flag_on_post','us','waving_black_flag','waving_white_flag']}],emojis:{'100':{a:'Hundred Points Symbol',b:'1F4AF',j:['score','perfect','numbers','century','exam','quiz','test','pass','hundred'],k:[26,5],o:2},'1234':{a:'Input Symbol for Numbers',b:'1F522',j:['numbers','blue-square'],k:[28,5],o:2},grinning:{a:'Grinning Face',b:'1F600',j:['face','smile','happy','joy',':D','grin'],k:[30,35],m:':D',o:2},monkey_face:{a:'Monkey Face',b:'1F435',j:['animal','nature','circus'],k:[12,25],l:[':o)'],o:2},grapes:{a:'Grapes',b:'1F347',j:['fruit','food','wine'],k:[6,31],o:2},eyeglasses:{a:'Eyeglasses',b:'1F453',j:['fashion','accessories','eyesight','nerdy','dork','geek'],k:[14,7],o:2},checkered_flag:{a:'Chequered Flag',b:'1F3C1',j:['contest','finishline','race','gokart'],k:[8,39],o:2},jack_o_lantern:{a:'Jack-O-Lantern',b:'1F383',j:['halloween','light','pumpkin','creepy','fall'],k:[7,34],o:2},wave:{skin_variations:{'1F3FB':{unified:'1F44B-1F3FB',non_qualified:null,image:'1f44b-1f3fb.png',sheet_x:13,sheet_y:27,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F44B-1F3FC',non_qualified:null,image:'1f44b-1f3fc.png',sheet_x:13,sheet_y:28,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F44B-1F3FD',non_qualified:null,image:'1f44b-1f3fd.png',sheet_x:13,sheet_y:29,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F44B-1F3FE',non_qualified:null,image:'1f44b-1f3fe.png',sheet_x:13,sheet_y:30,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F44B-1F3FF',non_qualified:null,image:'1f44b-1f3ff.png',sheet_x:13,sheet_y:31,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Waving Hand Sign',b:'1F44B',j:['hands','gesture','goodbye','solong','farewell','hello','hi','palm'],k:[13,26],o:2},earth_africa:{a:'Earth Globe Europe-Africa',b:'1F30D',j:['globe','world','international'],k:[5,32],o:2},atm:{a:'Automated Teller Machine',b:'1F3E7',j:['money','sales','cash','blue-square','payment','bank'],k:[11,1],o:2},melon:{a:'Melon',b:'1F348',j:['fruit','nature','food'],k:[6,32],o:2},triangular_flag_on_post:{a:'Triangular Flag on Post',b:'1F6A9',j:['mark','milestone','place'],k:[35,0],o:2},put_litter_in_its_place:{a:'Put Litter in Its Place Symbol',b:'1F6AE',j:['blue-square','sign','human','info'],k:[35,5],o:2},christmas_tree:{a:'Christmas Tree',b:'1F384',j:['festival','vacation','december','xmas','celebration'],k:[7,35],o:2},monkey:{a:'Monkey',b:'1F412',j:['animal','nature','banana','circus'],k:[11,46],o:2},earth_americas:{a:'Earth Globe Americas',b:'1F30E',j:['globe','world','USA','international'],k:[5,33],o:2},dark_sunglasses:{a:'Dark Sunglasses',b:'1F576-FE0F',c:'1F576',j:['face','cool','accessories'],k:[29,33],o:2},raised_back_of_hand:{skin_variations:{'1F3FB':{unified:'1F91A-1F3FB',non_qualified:null,image:'1f91a-1f3fb.png',sheet_x:37,sheet_y:44,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F91A-1F3FC',non_qualified:null,image:'1f91a-1f3fc.png',sheet_x:37,sheet_y:45,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F91A-1F3FD',non_qualified:null,image:'1f91a-1f3fd.png',sheet_x:37,sheet_y:46,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F91A-1F3FE',non_qualified:null,image:'1f91a-1f3fe.png',sheet_x:37,sheet_y:47,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F91A-1F3FF',non_qualified:null,image:'1f91a-1f3ff.png',sheet_x:37,sheet_y:48,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Raised Back of Hand',b:'1F91A',j:['fingers','raised','backhand'],k:[37,43],o:4},smiley:{a:'Smiling Face with Open Mouth',b:'1F603',j:['face','happy','joy','haha',':D',':)','smile','funny'],k:[30,38],l:['=)','=-)'],m:':)',o:2},earth_asia:{a:'Earth Globe Asia-Australia',b:'1F30F',j:['globe','world','east','international'],k:[5,34],o:2},crossed_flags:{a:'Crossed Flags',b:'1F38C',j:['japanese','nation','country','border'],k:[7,48],o:2},watermelon:{a:'Watermelon',b:'1F349',j:['fruit','food','picnic','summer'],k:[6,33],o:2},goggles:{a:'Goggles',b:'1F97D',k:[42,15],o:11},raised_hand_with_fingers_splayed:{skin_variations:{'1F3FB':{unified:'1F590-1F3FB',non_qualified:null,image:'1f590-1f3fb.png',sheet_x:29,sheet_y:49,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F590-1F3FC',non_qualified:null,image:'1f590-1f3fc.png',sheet_x:29,sheet_y:50,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F590-1F3FD',non_qualified:null,image:'1f590-1f3fd.png',sheet_x:29,sheet_y:51,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F590-1F3FE',non_qualified:null,image:'1f590-1f3fe.png',sheet_x:29,sheet_y:52,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F590-1F3FF',non_qualified:null,image:'1f590-1f3ff.png',sheet_x:29,sheet_y:53,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Raised Hand with Fingers Splayed',b:'1F590-FE0F',c:'1F590',j:['hand','fingers','palm'],k:[29,48],o:2},smile:{a:'Smiling Face with Open Mouth and Smiling Eyes',b:'1F604',j:['face','happy','joy','funny','haha','laugh','like',':D',':)'],k:[30,39],l:['C:','c:',':D',':-D'],m:':)',o:2},potable_water:{a:'Potable Water Symbol',b:'1F6B0',j:['blue-square','liquid','restroom','cleaning','faucet'],k:[35,7],o:2},fireworks:{a:'Fireworks',b:'1F386',j:['photo','festival','carnival','congratulations'],k:[7,42],o:2},gorilla:{a:'Gorilla',b:'1F98D',j:['animal','nature','circus'],k:[42,31],o:4},lab_coat:{a:'Lab Coat',b:'1F97C',k:[42,14],o:11},tangerine:{a:'Tangerine',b:'1F34A',j:['food','fruit','nature','orange'],k:[6,34],o:2},wheelchair:{a:'Wheelchair Symbol',b:'267F',j:['blue-square','disabled','a11y','accessibility'],k:[53,40],o:2},waving_black_flag:{a:'Waving Black Flag',b:'1F3F4',k:[11,17],o:2},orangutan:{a:'Orangutan',b:'1F9A7',k:[42,55],o:12},sparkler:{a:'Firework Sparkler',b:'1F387',j:['stars','night','shine'],k:[7,43],o:2},globe_with_meridians:{a:'Globe with Meridians',b:'1F310',j:['earth','international','world','internet','interweb','i18n'],k:[5,35],o:2},grin:{a:'Grinning Face with Smiling Eyes',b:'1F601',j:['face','happy','smile','joy','kawaii'],k:[30,36],o:2},hand:{skin_variations:{'1F3FB':{unified:'270B-1F3FB',non_qualified:null,image:'270b-1f3fb.png',sheet_x:54,sheet_y:50,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'270B-1F3FC',non_qualified:null,image:'270b-1f3fc.png',sheet_x:54,sheet_y:51,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'270B-1F3FD',non_qualified:null,image:'270b-1f3fd.png',sheet_x:54,sheet_y:52,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'270B-1F3FE',non_qualified:null,image:'270b-1f3fe.png',sheet_x:54,sheet_y:53,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'270B-1F3FF',non_qualified:null,image:'270b-1f3ff.png',sheet_x:54,sheet_y:54,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Raised Hand',b:'270B',k:[54,49],n:['raised_hand'],o:2},firecracker:{a:'Firecracker',b:'1F9E8',k:[51,27],o:11},lemon:{a:'Lemon',b:'1F34B',j:['fruit','nature'],k:[6,35],o:2},dog:{a:'Dog Face',b:'1F436',j:['animal','friend','nature','woof','puppy','pet','faithful'],k:[12,26],o:2},mens:{a:'Mens Symbol',b:'1F6B9',j:['toilet','restroom','wc','blue-square','gender','male'],k:[36,10],o:2},'spock-hand':{skin_variations:{'1F3FB':{unified:'1F596-1F3FB',non_qualified:null,image:'1f596-1f3fb.png',sheet_x:30,sheet_y:4,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F596-1F3FC',non_qualified:null,image:'1f596-1f3fc.png',sheet_x:30,sheet_y:5,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F596-1F3FD',non_qualified:null,image:'1f596-1f3fd.png',sheet_x:30,sheet_y:6,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F596-1F3FE',non_qualified:null,image:'1f596-1f3fe.png',sheet_x:30,sheet_y:7,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F596-1F3FF',non_qualified:null,image:'1f596-1f3ff.png',sheet_x:30,sheet_y:8,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Raised Hand with Part Between Middle and Ring Fingers',b:'1F596',k:[30,3],o:2},world_map:{a:'World Map',b:'1F5FA-FE0F',c:'1F5FA',j:['location','direction'],k:[30,29],o:2},laughing:{a:'Smiling Face with Open Mouth and Tightly-Closed Eyes',b:'1F606',j:['happy','joy','lol','satisfied','haha','face','glad','XD','laugh'],k:[30,41],l:[':>',':->'],n:['satisfied'],o:2},waving_white_flag:{a:'Waving White Flag',b:'1F3F3-FE0F',c:'1F3F3',k:[11,12],o:2},safety_vest:{a:'Safety Vest',b:'1F9BA',k:[43,54],o:12},sweat_smile:{a:'Smiling Face with Open Mouth and Cold Sweat',b:'1F605',j:['face','hot','happy','laugh','sweat','smile','relief'],k:[30,40],o:2},sparkles:{a:'Sparkles',b:'2728',j:['stars','shine','shiny','cool','awesome','good','magic'],k:[55,16],o:2},banana:{a:'Banana',b:'1F34C',j:['fruit','food','monkey'],k:[6,36],o:2},'rainbow-flag':{a:'Rainbow Flag',b:'1F3F3-FE0F-200D-1F308',c:'1F3F3-200D-1F308',k:[11,11],o:4},ok_hand:{skin_variations:{'1F3FB':{unified:'1F44C-1F3FB',non_qualified:null,image:'1f44c-1f3fb.png',sheet_x:13,sheet_y:33,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F44C-1F3FC',non_qualified:null,image:'1f44c-1f3fc.png',sheet_x:13,sheet_y:34,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F44C-1F3FD',non_qualified:null,image:'1f44c-1f3fd.png',sheet_x:13,sheet_y:35,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F44C-1F3FE',non_qualified:null,image:'1f44c-1f3fe.png',sheet_x:13,sheet_y:36,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F44C-1F3FF',non_qualified:null,image:'1f44c-1f3ff.png',sheet_x:13,sheet_y:37,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Ok Hand Sign',b:'1F44C',j:['fingers','limbs','perfect','ok','okay'],k:[13,32],o:2},japan:{a:'Silhouette of Japan',b:'1F5FE',j:['nation','country','japanese','asia'],k:[30,33],o:2},dog2:{a:'Dog',b:'1F415',j:['animal','nature','friend','doge','pet','faithful'],k:[11,50],o:2},womens:{a:'Womens Symbol',b:'1F6BA',j:['purple-square','woman','female','toilet','loo','restroom','gender'],k:[36,11],o:2},necktie:{a:'Necktie',b:'1F454',j:['shirt','suitup','formal','fashion','cloth','business'],k:[14,8],o:2},pirate_flag:{a:'Pirate Flag',b:'1F3F4-200D-2620-FE0F',c:'1F3F4-200D-2620',k:[11,13],o:11},guide_dog:{a:'Guide Dog',b:'1F9AE',k:[43,2],o:12},restroom:{a:'Restroom',b:'1F6BB',j:['blue-square','toilet','refresh','wc','gender'],k:[36,12],o:2},compass:{a:'Compass',b:'1F9ED',k:[51,32],o:11},rolling_on_the_floor_laughing:{a:'Rolling on the Floor Laughing',b:'1F923',k:[38,20],o:4},balloon:{a:'Balloon',b:'1F388',j:['party','celebration','birthday','circus'],k:[7,44],o:2},pinching_hand:{skin_variations:{'1F3FB':{unified:'1F90F-1F3FB',non_qualified:null,image:'1f90f-1f3fb.png',sheet_x:37,sheet_y:18,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F90F-1F3FC',non_qualified:null,image:'1f90f-1f3fc.png',sheet_x:37,sheet_y:19,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F90F-1F3FD',non_qualified:null,image:'1f90f-1f3fd.png',sheet_x:37,sheet_y:20,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F90F-1F3FE',non_qualified:null,image:'1f90f-1f3fe.png',sheet_x:37,sheet_y:21,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F90F-1F3FF',non_qualified:null,image:'1f90f-1f3ff.png',sheet_x:37,sheet_y:22,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Pinching Hand',b:'1F90F',k:[37,17],o:12},pineapple:{a:'Pineapple',b:'1F34D',j:['fruit','nature','food'],k:[6,37],o:2},shirt:{a:'T-Shirt',b:'1F455',k:[14,9],n:['tshirt'],o:2},service_dog:{a:'Service Dog',b:'1F415-200D-1F9BA',k:[11,49],o:12},baby_symbol:{a:'Baby Symbol',b:'1F6BC',j:['orange-square','child'],k:[36,13],o:2},joy:{a:'Face with Tears of Joy',b:'1F602',j:['face','cry','tears','weep','happy','happytears','haha'],k:[30,37],o:2},tada:{a:'Party Popper',b:'1F389',j:['party','congratulations','birthday','magic','circus','celebration'],k:[7,45],o:2},mango:{a:'Mango',b:'1F96D',k:[42,3],o:11},v:{skin_variations:{'1F3FB':{unified:'270C-1F3FB',non_qualified:null,image:'270c-1f3fb.png',sheet_x:54,sheet_y:56,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'270C-1F3FC',non_qualified:null,image:'270c-1f3fc.png',sheet_x:55,sheet_y:0,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'270C-1F3FD',non_qualified:null,image:'270c-1f3fd.png',sheet_x:55,sheet_y:1,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'270C-1F3FE',non_qualified:null,image:'270c-1f3fe.png',sheet_x:55,sheet_y:2,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'270C-1F3FF',non_qualified:null,image:'270c-1f3ff.png',sheet_x:55,sheet_y:3,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Victory Hand',b:'270C-FE0F',c:'270C',j:['fingers','ohyeah','hand','peace','victory','two'],k:[54,55],o:2},snow_capped_mountain:{a:'Snow Capped Mountain',b:'1F3D4-FE0F',c:'1F3D4',k:[10,39],o:2},'flag-ac':{a:'Ascension Island Flag',b:'1F1E6-1F1E8',k:[0,31],o:2},jeans:{a:'Jeans',b:'1F456',j:['fashion','shopping'],k:[14,10],o:2},poodle:{a:'Poodle',b:'1F429',j:['dog','animal','101','nature','pet'],k:[12,13],o:2},crossed_fingers:{skin_variations:{'1F3FB':{unified:'1F91E-1F3FB',non_qualified:null,image:'1f91e-1f3fb.png',sheet_x:38,sheet_y:6,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F91E-1F3FC',non_qualified:null,image:'1f91e-1f3fc.png',sheet_x:38,sheet_y:7,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F91E-1F3FD',non_qualified:null,image:'1f91e-1f3fd.png',sheet_x:38,sheet_y:8,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F91E-1F3FE',non_qualified:null,image:'1f91e-1f3fe.png',sheet_x:38,sheet_y:9,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F91E-1F3FF',non_qualified:null,image:'1f91e-1f3ff.png',sheet_x:38,sheet_y:10,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Hand with Index and Middle Fingers Crossed',b:'1F91E',j:['good','lucky'],k:[38,5],n:['hand_with_index_and_middle_fingers_crossed'],o:4},'flag-ad':{a:'Andorra Flag',b:'1F1E6-1F1E9',k:[0,32],o:2},slightly_smiling_face:{a:'Slightly Smiling Face',b:'1F642',j:['face','smile'],k:[31,44],l:[':)','(:',':-)'],o:2},apple:{a:'Red Apple',b:'1F34E',j:['fruit','mac','school'],k:[6,38],o:2},wc:{a:'Water Closet',b:'1F6BE',j:['toilet','restroom','blue-square'],k:[36,15],o:2},scarf:{a:'Scarf',b:'1F9E3',j:['neck','winter','clothes'],k:[51,22],o:5},mountain:{a:'Mountain',b:'26F0-FE0F',c:'26F0',j:['photo','nature','environment'],k:[54,11],o:2},confetti_ball:{a:'Confetti Ball',b:'1F38A',j:['festival','party','birthday','circus'],k:[7,46],o:2},i_love_you_hand_sign:{skin_variations:{'1F3FB':{unified:'1F91F-1F3FB',non_qualified:null,image:'1f91f-1f3fb.png',sheet_x:38,sheet_y:12,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F91F-1F3FC',non_qualified:null,image:'1f91f-1f3fc.png',sheet_x:38,sheet_y:13,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F91F-1F3FD',non_qualified:null,image:'1f91f-1f3fd.png',sheet_x:38,sheet_y:14,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F91F-1F3FE',non_qualified:null,image:'1f91f-1f3fe.png',sheet_x:38,sheet_y:15,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F91F-1F3FF',non_qualified:null,image:'1f91f-1f3ff.png',sheet_x:38,sheet_y:16,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'I Love You Hand Sign',b:'1F91F',k:[38,11],o:5},wolf:{a:'Wolf Face',b:'1F43A',j:['animal','nature','wild'],k:[12,30],o:2},gloves:{a:'Gloves',b:'1F9E4',j:['hands','winter','clothes'],k:[51,23],o:5},'flag-ae':{a:'United Arab Emirates Flag',b:'1F1E6-1F1EA',k:[0,33],o:2},upside_down_face:{a:'Upside-Down Face',b:'1F643',j:['face','flipped','silly','smile'],k:[31,45],o:2},green_apple:{a:'Green Apple',b:'1F34F',j:['fruit','nature'],k:[6,39],o:2},passport_control:{a:'Passport Control',b:'1F6C2',j:['custom','blue-square'],k:[36,24],o:2},volcano:{a:'Volcano',b:'1F30B',j:['photo','nature','disaster'],k:[5,30],o:2},tanabata_tree:{a:'Tanabata Tree',b:'1F38B',j:['plant','nature','branch','summer'],k:[7,47],o:2},customs:{a:'Customs',b:'1F6C3',j:['passport','border','blue-square'],k:[36,25],o:2},coat:{a:'Coat',b:'1F9E5',j:['jacket'],k:[51,24],o:5},wink:{a:'Winking Face',b:'1F609',j:['face','happy','mischievous','secret',';)','smile','eye'],k:[30,44],l:[';)',';-)'],m:';)',o:2},bamboo:{a:'Pine Decoration',b:'1F38D',j:['plant','nature','vegetable','panda','pine_decoration'],k:[7,49],o:2},'flag-af':{a:'Afghanistan Flag',b:'1F1E6-1F1EB',k:[0,34],o:2},fox_face:{a:'Fox Face',b:'1F98A',j:['animal','nature','face'],k:[42,28],o:4},pear:{a:'Pear',b:'1F350',j:['fruit','nature','food'],k:[6,40],o:2},mount_fuji:{a:'Mount Fuji',b:'1F5FB',j:['photo','mountain','nature','japanese'],k:[30,30],o:2},the_horns:{skin_variations:{'1F3FB':{unified:'1F918-1F3FB',non_qualified:null,image:'1f918-1f3fb.png',sheet_x:37,sheet_y:32,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F918-1F3FC',non_qualified:null,image:'1f918-1f3fc.png',sheet_x:37,sheet_y:33,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F918-1F3FD',non_qualified:null,image:'1f918-1f3fd.png',sheet_x:37,sheet_y:34,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F918-1F3FE',non_qualified:null,image:'1f918-1f3fe.png',sheet_x:37,sheet_y:35,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F918-1F3FF',non_qualified:null,image:'1f918-1f3ff.png',sheet_x:37,sheet_y:36,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Sign of the Horns',b:'1F918',k:[37,31],n:['sign_of_the_horns'],o:2},call_me_hand:{skin_variations:{'1F3FB':{unified:'1F919-1F3FB',non_qualified:null,image:'1f919-1f3fb.png',sheet_x:37,sheet_y:38,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F919-1F3FC',non_qualified:null,image:'1f919-1f3fc.png',sheet_x:37,sheet_y:39,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F919-1F3FD',non_qualified:null,image:'1f919-1f3fd.png',sheet_x:37,sheet_y:40,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F919-1F3FE',non_qualified:null,image:'1f919-1f3fe.png',sheet_x:37,sheet_y:41,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F919-1F3FF',non_qualified:null,image:'1f919-1f3ff.png',sheet_x:37,sheet_y:42,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Call Me Hand',b:'1F919',j:['hands','gesture'],k:[37,37],o:4},'flag-ag':{a:'Antigua & Barbuda Flag',b:'1F1E6-1F1EC',k:[0,35],o:2},raccoon:{a:'Raccoon',b:'1F99D',k:[42,47],o:11},dolls:{a:'Japanese Dolls',b:'1F38E',j:['japanese','toy','kimono'],k:[7,50],o:2},blush:{a:'Smiling Face with Smiling Eyes',b:'1F60A',j:['face','smile','happy','flushed','crush','embarrassed','shy','joy'],k:[30,45],m:':)',o:2},peach:{a:'Peach',b:'1F351',j:['fruit','nature','food'],k:[6,41],o:2},baggage_claim:{a:'Baggage Claim',b:'1F6C4',j:['blue-square','airport','transport'],k:[36,26],o:2},socks:{a:'Socks',b:'1F9E6',j:['stockings','clothes'],k:[51,25],o:5},camping:{a:'Camping',b:'1F3D5-FE0F',c:'1F3D5',j:['photo','outdoors','tent'],k:[10,40],o:2},dress:{a:'Dress',b:'1F457',j:['clothes','fashion','shopping'],k:[14,11],o:2},beach_with_umbrella:{a:'Beach with Umbrella',b:'1F3D6-FE0F',c:'1F3D6',k:[10,41],o:2},cherries:{a:'Cherries',b:'1F352',j:['food','fruit'],k:[6,42],o:2},cat:{a:'Cat Face',b:'1F431',j:['animal','meow','nature','pet','kitten'],k:[12,21],o:2},point_left:{skin_variations:{'1F3FB':{unified:'1F448-1F3FB',non_qualified:null,image:'1f448-1f3fb.png',sheet_x:13,sheet_y:9,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F448-1F3FC',non_qualified:null,image:'1f448-1f3fc.png',sheet_x:13,sheet_y:10,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F448-1F3FD',non_qualified:null,image:'1f448-1f3fd.png',sheet_x:13,sheet_y:11,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F448-1F3FE',non_qualified:null,image:'1f448-1f3fe.png',sheet_x:13,sheet_y:12,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F448-1F3FF',non_qualified:null,image:'1f448-1f3ff.png',sheet_x:13,sheet_y:13,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'White Left Pointing Backhand Index',b:'1F448',j:['direction','fingers','hand','left'],k:[13,8],o:2},left_luggage:{a:'Left Luggage',b:'1F6C5',j:['blue-square','travel'],k:[36,27],o:2},'flag-ai':{a:'Anguilla Flag',b:'1F1E6-1F1EE',k:[0,36],o:2},innocent:{a:'Smiling Face with Halo',b:'1F607',j:['face','angel','heaven','halo'],k:[30,42],o:2},flags:{a:'Carp Streamer',b:'1F38F',j:['fish','japanese','koinobori','carp','banner'],k:[7,51],o:2},warning:{a:'Warning Sign',b:'26A0-FE0F',c:'26A0',j:['exclamation','wip','alert','error','problem','issue'],k:[53,50],o:2},strawberry:{a:'Strawberry',b:'1F353',j:['fruit','food','nature'],k:[6,43],o:2},point_right:{skin_variations:{'1F3FB':{unified:'1F449-1F3FB',non_qualified:null,image:'1f449-1f3fb.png',sheet_x:13,sheet_y:15,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F449-1F3FC',non_qualified:null,image:'1f449-1f3fc.png',sheet_x:13,sheet_y:16,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F449-1F3FD',non_qualified:null,image:'1f449-1f3fd.png',sheet_x:13,sheet_y:17,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F449-1F3FE',non_qualified:null,image:'1f449-1f3fe.png',sheet_x:13,sheet_y:18,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F449-1F3FF',non_qualified:null,image:'1f449-1f3ff.png',sheet_x:13,sheet_y:19,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'White Right Pointing Backhand Index',b:'1F449',j:['fingers','hand','direction','right'],k:[13,14],o:2},desert:{a:'Desert',b:'1F3DC-FE0F',c:'1F3DC',j:['photo','warm','saharah'],k:[10,47],o:2},kimono:{a:'Kimono',b:'1F458',j:['dress','fashion','women','female','japanese'],k:[14,12],o:2},'flag-al':{a:'Albania Flag',b:'1F1E6-1F1F1',k:[0,37],o:2},wind_chime:{a:'Wind Chime',b:'1F390',j:['nature','ding','spring','bell'],k:[7,52],o:2},smiling_face_with_3_hearts:{a:'Smiling Face with Smiling Eyes and Three Hearts',b:'1F970',k:[42,6],o:11},cat2:{a:'Cat',b:'1F408',j:['animal','meow','pet','cats'],k:[11,36],o:2},rice_scene:{a:'Moon Viewing Ceremony',b:'1F391',j:['photo','japan','asia','tsukimi'],k:[7,53],o:2},heart_eyes:{a:'Smiling Face with Heart-Shaped Eyes',b:'1F60D',j:['face','love','like','affection','valentines','infatuation','crush','heart'],k:[30,48],o:2},sari:{a:'Sari',b:'1F97B',k:[42,13],o:12},'flag-am':{a:'Armenia Flag',b:'1F1E6-1F1F2',k:[0,38],o:2},lion_face:{a:'Lion Face',b:'1F981',k:[42,19],o:2},desert_island:{a:'Desert Island',b:'1F3DD-FE0F',c:'1F3DD',j:['photo','tropical','mojito'],k:[10,48],o:2},point_up_2:{skin_variations:{'1F3FB':{unified:'1F446-1F3FB',non_qualified:null,image:'1f446-1f3fb.png',sheet_x:12,sheet_y:54,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F446-1F3FC',non_qualified:null,image:'1f446-1f3fc.png',sheet_x:12,sheet_y:55,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F446-1F3FD',non_qualified:null,image:'1f446-1f3fd.png',sheet_x:12,sheet_y:56,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F446-1F3FE',non_qualified:null,image:'1f446-1f3fe.png',sheet_x:13,sheet_y:0,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F446-1F3FF',non_qualified:null,image:'1f446-1f3ff.png',sheet_x:13,sheet_y:1,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'White Up Pointing Backhand Index',b:'1F446',j:['fingers','hand','direction','up'],k:[12,53],o:2},kiwifruit:{a:'Kiwifruit',b:'1F95D',k:[41,44],o:4},children_crossing:{a:'Children Crossing',b:'1F6B8',j:['school','warning','danger','sign','driving','yellow-diamond'],k:[36,9],o:2},national_park:{a:'National Park',b:'1F3DE-FE0F',c:'1F3DE',j:['photo','environment','nature'],k:[10,49],o:2},no_entry:{a:'No Entry',b:'26D4',j:['limit','security','privacy','bad','denied','stop','circle'],k:[54,8],o:2},'one-piece_swimsuit':{a:'One-Piece Swimsuit',b:'1FA71',k:[51,52],o:12},tiger:{a:'Tiger Face',b:'1F42F',j:['animal','cat','danger','wild','nature','roar'],k:[12,19],o:2},red_envelope:{a:'Red Gift Envelope',b:'1F9E7',k:[51,26],o:11},'star-struck':{a:'Grinning Face with Star Eyes',b:'1F929',k:[38,43],n:['grinning_face_with_star_eyes'],o:5},middle_finger:{skin_variations:{'1F3FB':{unified:'1F595-1F3FB',non_qualified:null,image:'1f595-1f3fb.png',sheet_x:29,sheet_y:55,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F595-1F3FC',non_qualified:null,image:'1f595-1f3fc.png',sheet_x:29,sheet_y:56,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F595-1F3FD',non_qualified:null,image:'1f595-1f3fd.png',sheet_x:30,sheet_y:0,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F595-1F3FE',non_qualified:null,image:'1f595-1f3fe.png',sheet_x:30,sheet_y:1,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F595-1F3FF',non_qualified:null,image:'1f595-1f3ff.png',sheet_x:30,sheet_y:2,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Reversed Hand with Middle Finger Extended',b:'1F595',k:[29,54],n:['reversed_hand_with_middle_finger_extended'],o:2},'flag-ao':{a:'Angola Flag',b:'1F1E6-1F1F4',k:[0,39],o:2},tomato:{a:'Tomato',b:'1F345',j:['fruit','vegetable','nature','food'],k:[6,29],o:2},coconut:{a:'Coconut',b:'1F965',j:['fruit','nature','food','palm'],k:[41,52],o:5},ribbon:{a:'Ribbon',b:'1F380',j:['decoration','pink','girl','bowtie'],k:[7,31],o:2},no_entry_sign:{a:'No Entry Sign',b:'1F6AB',j:['forbid','stop','limit','denied','disallow','circle'],k:[35,2],o:2},point_down:{skin_variations:{'1F3FB':{unified:'1F447-1F3FB',non_qualified:null,image:'1f447-1f3fb.png',sheet_x:13,sheet_y:3,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F447-1F3FC',non_qualified:null,image:'1f447-1f3fc.png',sheet_x:13,sheet_y:4,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F447-1F3FD',non_qualified:null,image:'1f447-1f3fd.png',sheet_x:13,sheet_y:5,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F447-1F3FE',non_qualified:null,image:'1f447-1f3fe.png',sheet_x:13,sheet_y:6,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F447-1F3FF',non_qualified:null,image:'1f447-1f3ff.png',sheet_x:13,sheet_y:7,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'White Down Pointing Backhand Index',b:'1F447',j:['fingers','hand','direction','down'],k:[13,2],o:2},'flag-aq':{a:'Antarctica Flag',b:'1F1E6-1F1F6',k:[0,40],o:2},briefs:{a:'Briefs',b:'1FA72',k:[51,53],o:12},kissing_heart:{a:'Face Throwing a Kiss',b:'1F618',j:['face','love','like','affection','valentines','infatuation','kiss'],k:[31,2],l:[':*',':-*'],o:2},tiger2:{a:'Tiger',b:'1F405',j:['animal','nature','roar'],k:[11,33],o:2},stadium:{a:'Stadium',b:'1F3DF-FE0F',c:'1F3DF',j:['photo','place','sports','concert','venue'],k:[10,50],o:2},leopard:{a:'Leopard',b:'1F406',j:['animal','nature'],k:[11,34],o:2},no_bicycles:{a:'No Bicycles',b:'1F6B3',j:['cyclist','prohibited','circle'],k:[35,10],o:2},kissing:{a:'Kissing Face',b:'1F617',j:['love','like','face','3','valentines','infatuation','kiss'],k:[31,1],o:2},'flag-ar':{a:'Argentina Flag',b:'1F1E6-1F1F7',k:[0,41],o:2},avocado:{a:'Avocado',b:'1F951',j:['fruit','food'],k:[41,32],o:4},point_up:{skin_variations:{'1F3FB':{unified:'261D-1F3FB',non_qualified:null,image:'261d-1f3fb.png',sheet_x:53,sheet_y:3,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'261D-1F3FC',non_qualified:null,image:'261d-1f3fc.png',sheet_x:53,sheet_y:4,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'261D-1F3FD',non_qualified:null,image:'261d-1f3fd.png',sheet_x:53,sheet_y:5,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'261D-1F3FE',non_qualified:null,image:'261d-1f3fe.png',sheet_x:53,sheet_y:6,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'261D-1F3FF',non_qualified:null,image:'261d-1f3ff.png',sheet_x:53,sheet_y:7,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'White Up Pointing Index',b:'261D-FE0F',c:'261D',j:['hand','fingers','direction','up'],k:[53,2],o:2},gift:{a:'Wrapped Present',b:'1F381',j:['present','birthday','christmas','xmas'],k:[7,32],o:2},classical_building:{a:'Classical Building',b:'1F3DB-FE0F',c:'1F3DB',j:['art','culture','history'],k:[10,46],o:2},shorts:{a:'Shorts',b:'1FA73',k:[51,54],o:12},'+1':{skin_variations:{'1F3FB':{unified:'1F44D-1F3FB',non_qualified:null,image:'1f44d-1f3fb.png',sheet_x:13,sheet_y:39,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F44D-1F3FC',non_qualified:null,image:'1f44d-1f3fc.png',sheet_x:13,sheet_y:40,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F44D-1F3FD',non_qualified:null,image:'1f44d-1f3fd.png',sheet_x:13,sheet_y:41,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F44D-1F3FE',non_qualified:null,image:'1f44d-1f3fe.png',sheet_x:13,sheet_y:42,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F44D-1F3FF',non_qualified:null,image:'1f44d-1f3ff.png',sheet_x:13,sheet_y:43,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Thumbs Up Sign',b:'1F44D',j:['thumbsup','yes','awesome','good','agree','accept','cool','hand','like'],k:[13,38],n:['thumbsup'],o:2},horse:{a:'Horse Face',b:'1F434',j:['animal','brown','nature'],k:[12,24],o:2},bikini:{a:'Bikini',b:'1F459',j:['swimming','female','woman','girl','fashion','beach','summer'],k:[14,13],o:2},no_smoking:{a:'No Smoking Symbol',b:'1F6AD',j:['cigarette','blue-square','smell','smoke'],k:[35,4],o:2},eggplant:{a:'Aubergine',b:'1F346',j:['vegetable','nature','food','aubergine'],k:[6,30],o:2},'flag-as':{a:'American Samoa Flag',b:'1F1E6-1F1F8',k:[0,42],o:2},reminder_ribbon:{a:'Reminder Ribbon',b:'1F397-FE0F',c:'1F397',j:['sports','cause','support','awareness'],k:[8,0],o:2},building_construction:{a:'Building Construction',b:'1F3D7-FE0F',c:'1F3D7',j:['wip','working','progress'],k:[10,42],o:2},relaxed:{a:'White Smiling Face',b:'263A-FE0F',c:'263A',j:['face','blush','massage','happiness'],k:[53,17],o:2},kissing_closed_eyes:{a:'Kissing Face with Closed Eyes',b:'1F61A',j:['face','love','like','affection','valentines','infatuation','kiss'],k:[31,4],o:2},'-1':{skin_variations:{'1F3FB':{unified:'1F44E-1F3FB',non_qualified:null,image:'1f44e-1f3fb.png',sheet_x:13,sheet_y:45,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F44E-1F3FC',non_qualified:null,image:'1f44e-1f3fc.png',sheet_x:13,sheet_y:46,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F44E-1F3FD',non_qualified:null,image:'1f44e-1f3fd.png',sheet_x:13,sheet_y:47,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F44E-1F3FE',non_qualified:null,image:'1f44e-1f3fe.png',sheet_x:13,sheet_y:48,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F44E-1F3FF',non_qualified:null,image:'1f44e-1f3ff.png',sheet_x:13,sheet_y:49,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Thumbs Down Sign',b:'1F44E',j:['thumbsdown','no','dislike','hand'],k:[13,44],n:['thumbsdown'],o:2},admission_tickets:{a:'Admission Tickets',b:'1F39F-FE0F',c:'1F39F',k:[8,5],o:2},'flag-at':{a:'Austria Flag',b:'1F1E6-1F1F9',k:[0,43],o:2},womans_clothes:{a:'Womans Clothes',b:'1F45A',j:['fashion','shopping_bags','female'],k:[14,14],o:2},do_not_litter:{a:'Do Not Litter Symbol',b:'1F6AF',j:['trash','bin','garbage','circle'],k:[35,6],o:2},potato:{a:'Potato',b:'1F954',j:['food','tuber','vegatable','starch'],k:[41,35],o:4},racehorse:{a:'Horse',b:'1F40E',j:['animal','gamble','luck'],k:[11,42],o:2},bricks:{a:'Brick',b:'1F9F1',k:[51,36],o:11},fist:{skin_variations:{'1F3FB':{unified:'270A-1F3FB',non_qualified:null,image:'270a-1f3fb.png',sheet_x:54,sheet_y:44,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'270A-1F3FC',non_qualified:null,image:'270a-1f3fc.png',sheet_x:54,sheet_y:45,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'270A-1F3FD',non_qualified:null,image:'270a-1f3fd.png',sheet_x:54,sheet_y:46,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'270A-1F3FE',non_qualified:null,image:'270a-1f3fe.png',sheet_x:54,sheet_y:47,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'270A-1F3FF',non_qualified:null,image:'270a-1f3ff.png',sheet_x:54,sheet_y:48,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Raised Fist',b:'270A',j:['fingers','hand','grasp'],k:[54,43],o:2},house_buildings:{a:'House Buildings',b:'1F3D8-FE0F',c:'1F3D8',k:[10,43],o:2},carrot:{a:'Carrot',b:'1F955',j:['vegetable','food','orange'],k:[41,36],o:4},ticket:{a:'Ticket',b:'1F3AB',j:['event','concert','pass'],k:[8,17],o:2},'flag-au':{a:'Australia Flag',b:'1F1E6-1F1FA',k:[0,44],o:2},'non-potable_water':{a:'Non-Potable Water Symbol',b:'1F6B1',j:['drink','faucet','tap','circle'],k:[35,8],o:2},purse:{a:'Purse',b:'1F45B',j:['fashion','accessories','money','sales','shopping'],k:[14,15],o:2},unicorn_face:{a:'Unicorn Face',b:'1F984',k:[42,22],o:2},kissing_smiling_eyes:{a:'Kissing Face with Smiling Eyes',b:'1F619',j:['face','affection','valentines','infatuation','kiss'],k:[31,3],o:2},facepunch:{skin_variations:{'1F3FB':{unified:'1F44A-1F3FB',non_qualified:null,image:'1f44a-1f3fb.png',sheet_x:13,sheet_y:21,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F44A-1F3FC',non_qualified:null,image:'1f44a-1f3fc.png',sheet_x:13,sheet_y:22,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F44A-1F3FD',non_qualified:null,image:'1f44a-1f3fd.png',sheet_x:13,sheet_y:23,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F44A-1F3FE',non_qualified:null,image:'1f44a-1f3fe.png',sheet_x:13,sheet_y:24,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F44A-1F3FF',non_qualified:null,image:'1f44a-1f3ff.png',sheet_x:13,sheet_y:25,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Fisted Hand Sign',b:'1F44A',j:['angry','violence','fist','hit','attack','hand'],k:[13,20],n:['punch'],o:2},medal:{a:'Medal',b:'1F396-FE0F',c:'1F396',k:[7,56],o:2},zebra_face:{a:'Zebra Face',b:'1F993',k:[42,37],o:5},handbag:{a:'Handbag',b:'1F45C',j:['fashion','accessory','accessories','shopping'],k:[14,16],o:2},derelict_house_building:{a:'Derelict House Building',b:'1F3DA-FE0F',c:'1F3DA',k:[10,45],o:2},yum:{a:'Face Savouring Delicious Food',b:'1F60B',j:['happy','joy','tongue','smile','face','silly','yummy','nom','delicious','savouring'],k:[30,46],o:2},corn:{a:'Ear of Maize',b:'1F33D',j:['food','vegetable','plant'],k:[6,21],o:2},'flag-aw':{a:'Aruba Flag',b:'1F1E6-1F1FC',k:[0,45],o:2},no_pedestrians:{a:'No Pedestrians',b:'1F6B7',j:['rules','crossing','walking','circle'],k:[36,8],o:2},house:{a:'House Building',b:'1F3E0',j:['building','home'],k:[10,51],o:2},hot_pepper:{a:'Hot Pepper',b:'1F336-FE0F',c:'1F336',j:['food','spicy','chilli','chili'],k:[6,14],o:2},'flag-ax':{a:'Åland Islands Flag',b:'1F1E6-1F1FD',k:[0,46],o:2},trophy:{a:'Trophy',b:'1F3C6',j:['win','award','contest','place','ftw','ceremony'],k:[9,26],o:2},deer:{a:'Deer',b:'1F98C',j:['animal','nature','horns','venison'],k:[42,30],o:4},'left-facing_fist':{skin_variations:{'1F3FB':{unified:'1F91B-1F3FB',non_qualified:null,image:'1f91b-1f3fb.png',sheet_x:37,sheet_y:50,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F91B-1F3FC',non_qualified:null,image:'1f91b-1f3fc.png',sheet_x:37,sheet_y:51,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F91B-1F3FD',non_qualified:null,image:'1f91b-1f3fd.png',sheet_x:37,sheet_y:52,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F91B-1F3FE',non_qualified:null,image:'1f91b-1f3fe.png',sheet_x:37,sheet_y:53,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F91B-1F3FF',non_qualified:null,image:'1f91b-1f3ff.png',sheet_x:37,sheet_y:54,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Left-Facing Fist',b:'1F91B',k:[37,49],o:4},stuck_out_tongue:{a:'Face with Stuck-out Tongue',b:'1F61B',j:['face','prank','childish','playful','mischievous','smile','tongue'],k:[31,5],l:[':p',':-p',':P',':-P',':b',':-b'],m:':p',o:2},pouch:{a:'Pouch',b:'1F45D',j:['bag','accessories','shopping'],k:[14,17],o:2},no_mobile_phones:{a:'No Mobile Phones',b:'1F4F5',j:['iphone','mute','circle'],k:[27,18],o:2},stuck_out_tongue_winking_eye:{a:'Face with Stuck-out Tongue and Winking Eye',b:'1F61C',j:['face','prank','childish','playful','mischievous','smile','wink','tongue'],k:[31,6],l:[';p',';-p',';b',';-b',';P',';-P'],m:';p',o:2},sports_medal:{a:'Sports Medal',b:'1F3C5',k:[9,25],o:2},cucumber:{a:'Cucumber',b:'1F952',j:['fruit','food','pickle'],k:[41,33],o:4},cow:{a:'Cow Face',b:'1F42E',j:['beef','ox','animal','nature','moo','milk'],k:[12,18],o:2},underage:{a:'No One Under Eighteen Symbol',b:'1F51E',j:['18','drink','pub','night','minor','circle'],k:[28,1],o:2},'flag-az':{a:'Azerbaijan Flag',b:'1F1E6-1F1FF',k:[0,47],o:2},shopping_bags:{a:'Shopping Bags',b:'1F6CD-FE0F',c:'1F6CD',k:[36,35],o:2},'right-facing_fist':{skin_variations:{'1F3FB':{unified:'1F91C-1F3FB',non_qualified:null,image:'1f91c-1f3fb.png',sheet_x:37,sheet_y:56,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F91C-1F3FC',non_qualified:null,image:'1f91c-1f3fc.png',sheet_x:38,sheet_y:0,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F91C-1F3FD',non_qualified:null,image:'1f91c-1f3fd.png',sheet_x:38,sheet_y:1,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F91C-1F3FE',non_qualified:null,image:'1f91c-1f3fe.png',sheet_x:38,sheet_y:2,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F91C-1F3FF',non_qualified:null,image:'1f91c-1f3ff.png',sheet_x:38,sheet_y:3,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Right-Facing Fist',b:'1F91C',k:[37,55],o:4},house_with_garden:{a:'House with Garden',b:'1F3E1',j:['home','plant','nature'],k:[10,52],o:2},clap:{skin_variations:{'1F3FB':{unified:'1F44F-1F3FB',non_qualified:null,image:'1f44f-1f3fb.png',sheet_x:13,sheet_y:51,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F44F-1F3FC',non_qualified:null,image:'1f44f-1f3fc.png',sheet_x:13,sheet_y:52,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F44F-1F3FD',non_qualified:null,image:'1f44f-1f3fd.png',sheet_x:13,sheet_y:53,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F44F-1F3FE',non_qualified:null,image:'1f44f-1f3fe.png',sheet_x:13,sheet_y:54,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F44F-1F3FF',non_qualified:null,image:'1f44f-1f3ff.png',sheet_x:13,sheet_y:55,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Clapping Hands Sign',b:'1F44F',j:['hands','praise','applause','congrats','yay'],k:[13,50],o:2},leafy_green:{a:'Leafy Green',b:'1F96C',k:[42,2],o:11},office:{a:'Office Building',b:'1F3E2',j:['building','bureau','work'],k:[10,53],o:2},'flag-ba':{a:'Bosnia & Herzegovina Flag',b:'1F1E7-1F1E6',k:[0,48],o:2},zany_face:{a:'Grinning Face with One Large and One Small Eye',b:'1F92A',k:[38,44],n:['grinning_face_with_one_large_and_one_small_eye'],o:5},first_place_medal:{a:'First Place Medal',b:'1F947',k:[41,22],o:4},ox:{a:'Ox',b:'1F402',j:['animal','cow','beef'],k:[11,30],o:2},school_satchel:{a:'School Satchel',b:'1F392',j:['student','education','bag','backpack'],k:[7,54],o:2},radioactive_sign:{a:'Radioactive Sign',b:'2622-FE0F',c:'2622',k:[53,9],o:2},second_place_medal:{a:'Second Place Medal',b:'1F948',k:[41,23],o:4},stuck_out_tongue_closed_eyes:{a:'Face with Stuck-out Tongue and Tightly-Closed Eyes',b:'1F61D',j:['face','prank','playful','mischievous','smile','tongue'],k:[31,7],o:2},broccoli:{a:'Broccoli',b:'1F966',j:['fruit','food','vegetable'],k:[41,53],o:5},biohazard_sign:{a:'Biohazard Sign',b:'2623-FE0F',c:'2623',k:[53,10],o:2},mans_shoe:{a:'Mans Shoe',b:'1F45E',j:['fashion','male'],k:[14,18],n:['shoe'],o:2},raised_hands:{skin_variations:{'1F3FB':{unified:'1F64C-1F3FB',non_qualified:null,image:'1f64c-1f3fb.png',sheet_x:33,sheet_y:9,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F64C-1F3FC',non_qualified:null,image:'1f64c-1f3fc.png',sheet_x:33,sheet_y:10,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F64C-1F3FD',non_qualified:null,image:'1f64c-1f3fd.png',sheet_x:33,sheet_y:11,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F64C-1F3FE',non_qualified:null,image:'1f64c-1f3fe.png',sheet_x:33,sheet_y:12,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F64C-1F3FF',non_qualified:null,image:'1f64c-1f3ff.png',sheet_x:33,sheet_y:13,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Person Raising Both Hands in Celebration',b:'1F64C',j:['gesture','hooray','yea','celebration','hands'],k:[33,8],o:2},post_office:{a:'Japanese Post Office',b:'1F3E3',j:['building','envelope','communication'],k:[10,54],o:2},'flag-bb':{a:'Barbados Flag',b:'1F1E7-1F1E7',k:[0,49],o:2},water_buffalo:{a:'Water Buffalo',b:'1F403',j:['animal','nature','ox','cow'],k:[11,31],o:2},third_place_medal:{a:'Third Place Medal',b:'1F949',k:[41,24],o:4},european_post_office:{a:'European Post Office',b:'1F3E4',j:['building','email'],k:[10,55],o:2},athletic_shoe:{a:'Athletic Shoe',b:'1F45F',j:['shoes','sports','sneakers'],k:[14,19],o:2},arrow_up:{a:'Upwards Black Arrow',b:'2B06-FE0F',c:'2B06',j:['blue-square','continue','top','direction'],k:[55,38],o:2},cow2:{a:'Cow',b:'1F404',j:['beef','ox','animal','nature','moo','milk'],k:[11,32],o:2},open_hands:{skin_variations:{'1F3FB':{unified:'1F450-1F3FB',non_qualified:null,image:'1f450-1f3fb.png',sheet_x:14,sheet_y:0,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F450-1F3FC',non_qualified:null,image:'1f450-1f3fc.png',sheet_x:14,sheet_y:1,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F450-1F3FD',non_qualified:null,image:'1f450-1f3fd.png',sheet_x:14,sheet_y:2,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F450-1F3FE',non_qualified:null,image:'1f450-1f3fe.png',sheet_x:14,sheet_y:3,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F450-1F3FF',non_qualified:null,image:'1f450-1f3ff.png',sheet_x:14,sheet_y:4,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Open Hands Sign',b:'1F450',j:['fingers','butterfly','hands','open'],k:[13,56],o:2},garlic:{a:'Garlic',b:'1F9C4',k:[44,12],o:12},money_mouth_face:{a:'Money-Mouth Face',b:'1F911',j:['face','rich','dollar','money'],k:[37,24],o:2},'flag-bd':{a:'Bangladesh Flag',b:'1F1E7-1F1E9',k:[0,50],o:2},soccer:{a:'Soccer Ball',b:'26BD',j:['sports','football'],k:[53,56],o:2},hugging_face:{a:'Hugging Face',b:'1F917',k:[37,30],o:2},onion:{a:'Onion',b:'1F9C5',k:[44,13],o:12},arrow_upper_right:{a:'North East Arrow',b:'2197-FE0F',c:'2197',j:['blue-square','point','direction','diagonal','northeast'],k:[52,17],o:2},palms_up_together:{skin_variations:{'1F3FB':{unified:'1F932-1F3FB',non_qualified:null,image:'1f932-1f3fb.png',sheet_x:39,sheet_y:6,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F932-1F3FC',non_qualified:null,image:'1f932-1f3fc.png',sheet_x:39,sheet_y:7,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F932-1F3FD',non_qualified:null,image:'1f932-1f3fd.png',sheet_x:39,sheet_y:8,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F932-1F3FE',non_qualified:null,image:'1f932-1f3fe.png',sheet_x:39,sheet_y:9,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F932-1F3FF',non_qualified:null,image:'1f932-1f3ff.png',sheet_x:39,sheet_y:10,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Palms Up Together',b:'1F932',k:[39,5],o:5},pig:{a:'Pig Face',b:'1F437',j:['animal','oink','nature'],k:[12,27],o:2},hospital:{a:'Hospital',b:'1F3E5',j:['building','health','surgery','doctor'],k:[10,56],o:2},hiking_boot:{a:'Hiking Boot',b:'1F97E',k:[42,16],o:11},'flag-be':{a:'Belgium Flag',b:'1F1E7-1F1EA',k:[0,51],o:2},'flag-bf':{a:'Burkina Faso Flag',b:'1F1E7-1F1EB',k:[0,52],o:2},mushroom:{a:'Mushroom',b:'1F344',j:['plant','vegetable'],k:[6,28],o:2},pig2:{a:'Pig',b:'1F416',j:['animal','nature'],k:[11,51],o:2},baseball:{a:'Baseball',b:'26BE',j:['sports','balls'],k:[54,0],o:2},face_with_hand_over_mouth:{a:'Smiling Face with Smiling Eyes and Hand Covering Mouth',b:'1F92D',k:[38,47],n:['smiling_face_with_smiling_eyes_and_hand_covering_mouth'],o:5},handshake:{a:'Handshake',b:'1F91D',j:['agreement','shake'],k:[38,4],o:4},womans_flat_shoe:{a:'Flat Shoe',b:'1F97F',k:[42,17],o:11},bank:{a:'Bank',b:'1F3E6',j:['building','money','sales','cash','business','enterprise'],k:[11,0],o:2},arrow_right:{a:'Black Rightwards Arrow',b:'27A1-FE0F',c:'27A1',j:['blue-square','next'],k:[55,32],o:2},peanuts:{a:'Peanuts',b:'1F95C',j:['food','nut'],k:[41,43],o:4},shushing_face:{a:'Face with Finger Covering Closed Lips',b:'1F92B',k:[38,45],n:['face_with_finger_covering_closed_lips'],o:5},pray:{skin_variations:{'1F3FB':{unified:'1F64F-1F3FB',non_qualified:null,image:'1f64f-1f3fb.png',sheet_x:33,sheet_y:51,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F64F-1F3FC',non_qualified:null,image:'1f64f-1f3fc.png',sheet_x:33,sheet_y:52,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F64F-1F3FD',non_qualified:null,image:'1f64f-1f3fd.png',sheet_x:33,sheet_y:53,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F64F-1F3FE',non_qualified:null,image:'1f64f-1f3fe.png',sheet_x:33,sheet_y:54,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F64F-1F3FF',non_qualified:null,image:'1f64f-1f3ff.png',sheet_x:33,sheet_y:55,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Person with Folded Hands',b:'1F64F',j:['please','hope','wish','namaste','highfive'],k:[33,50],o:2},softball:{a:'Softball',b:'1F94E',k:[41,29],o:11},high_heel:{a:'High-Heeled Shoe',b:'1F460',j:['fashion','shoes','female','pumps','stiletto'],k:[14,20],o:2},'flag-bg':{a:'Bulgaria Flag',b:'1F1E7-1F1EC',k:[0,53],o:2},arrow_lower_right:{a:'South East Arrow',b:'2198-FE0F',c:'2198',j:['blue-square','direction','diagonal','southeast'],k:[52,18],o:2},hotel:{a:'Hotel',b:'1F3E8',j:['building','accomodation','checkin'],k:[11,2],o:2},boar:{a:'Boar',b:'1F417',j:['animal','nature'],k:[11,52],o:2},sandal:{a:'Womans Sandal',b:'1F461',j:['shoes','fashion','flip flops'],k:[14,21],o:2},'flag-bh':{a:'Bahrain Flag',b:'1F1E7-1F1ED',k:[0,54],o:2},arrow_down:{a:'Downwards Black Arrow',b:'2B07-FE0F',c:'2B07',j:['blue-square','direction','bottom'],k:[55,39],o:2},thinking_face:{a:'Thinking Face',b:'1F914',k:[37,27],o:2},writing_hand:{skin_variations:{'1F3FB':{unified:'270D-1F3FB',non_qualified:null,image:'270d-1f3fb.png',sheet_x:55,sheet_y:5,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'270D-1F3FC',non_qualified:null,image:'270d-1f3fc.png',sheet_x:55,sheet_y:6,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'270D-1F3FD',non_qualified:null,image:'270d-1f3fd.png',sheet_x:55,sheet_y:7,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'270D-1F3FE',non_qualified:null,image:'270d-1f3fe.png',sheet_x:55,sheet_y:8,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'270D-1F3FF',non_qualified:null,image:'270d-1f3ff.png',sheet_x:55,sheet_y:9,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Writing Hand',b:'270D-FE0F',c:'270D',j:['lower_left_ballpoint_pen','stationery','write','compose'],k:[55,4],o:2},chestnut:{a:'Chestnut',b:'1F330',j:['food','squirrel'],k:[6,8],o:2},basketball:{a:'Basketball and Hoop',b:'1F3C0',j:['sports','balls','NBA'],k:[8,38],o:2},pig_nose:{a:'Pig Nose',b:'1F43D',j:['animal','oink'],k:[12,33],o:2},love_hotel:{a:'Love Hotel',b:'1F3E9',j:['like','affection','dating'],k:[11,3],o:2},nail_care:{skin_variations:{'1F3FB':{unified:'1F485-1F3FB',non_qualified:null,image:'1f485-1f3fb.png',sheet_x:24,sheet_y:34,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F485-1F3FC',non_qualified:null,image:'1f485-1f3fc.png',sheet_x:24,sheet_y:35,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F485-1F3FD',non_qualified:null,image:'1f485-1f3fd.png',sheet_x:24,sheet_y:36,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F485-1F3FE',non_qualified:null,image:'1f485-1f3fe.png',sheet_x:24,sheet_y:37,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F485-1F3FF',non_qualified:null,image:'1f485-1f3ff.png',sheet_x:24,sheet_y:38,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Nail Polish',b:'1F485',j:['beauty','manicure','finger','fashion','nail'],k:[24,33],o:2},volleyball:{a:'Volleyball',b:'1F3D0',j:['sports','balls'],k:[10,35],o:2},'flag-bi':{a:'Burundi Flag',b:'1F1E7-1F1EE',k:[0,55],o:2},arrow_lower_left:{a:'South West Arrow',b:'2199-FE0F',c:'2199',j:['blue-square','direction','diagonal','southwest'],k:[52,19],o:2},ram:{a:'Ram',b:'1F40F',j:['animal','sheep','nature'],k:[11,43],o:2},ballet_shoes:{a:'Ballet Shoes',b:'1FA70',k:[51,51],o:12},zipper_mouth_face:{a:'Zipper-Mouth Face',b:'1F910',j:['face','sealed','zipper','secret'],k:[37,23],o:2},bread:{a:'Bread',b:'1F35E',j:['food','wheat','breakfast','toast'],k:[6,54],o:2},convenience_store:{a:'Convenience Store',b:'1F3EA',j:['building','shopping','groceries'],k:[11,4],o:2},boot:{a:'Womans Boots',b:'1F462',j:['shoes','fashion'],k:[14,22],o:2},sheep:{a:'Sheep',b:'1F411',j:['animal','nature','wool','shipit'],k:[11,45],o:2},face_with_raised_eyebrow:{a:'Face with One Eyebrow Raised',b:'1F928',k:[38,42],n:['face_with_one_eyebrow_raised'],o:5},'flag-bj':{a:'Benin Flag',b:'1F1E7-1F1EF',k:[0,56],o:2},arrow_left:{a:'Leftwards Black Arrow',b:'2B05-FE0F',c:'2B05',j:['blue-square','previous','back'],k:[55,37],o:2},selfie:{skin_variations:{'1F3FB':{unified:'1F933-1F3FB',non_qualified:null,image:'1f933-1f3fb.png',sheet_x:39,sheet_y:12,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F933-1F3FC',non_qualified:null,image:'1f933-1f3fc.png',sheet_x:39,sheet_y:13,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F933-1F3FD',non_qualified:null,image:'1f933-1f3fd.png',sheet_x:39,sheet_y:14,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F933-1F3FE',non_qualified:null,image:'1f933-1f3fe.png',sheet_x:39,sheet_y:15,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F933-1F3FF',non_qualified:null,image:'1f933-1f3ff.png',sheet_x:39,sheet_y:16,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Selfie',b:'1F933',j:['camera','phone'],k:[39,11],o:4},croissant:{a:'Croissant',b:'1F950',j:['food','bread','french'],k:[41,31],o:4},school:{a:'School',b:'1F3EB',j:['building','student','education','learn','teach'],k:[11,5],o:2},football:{a:'American Football',b:'1F3C8',j:['sports','balls','NFL'],k:[9,33],o:2},goat:{a:'Goat',b:'1F410',j:['animal','nature'],k:[11,44],o:2},department_store:{a:'Department Store',b:'1F3EC',j:['building','shopping','mall'],k:[11,6],o:2},'flag-bl':{a:'St. Barthélemy Flag',b:'1F1E7-1F1F1',k:[1,0],o:2},crown:{a:'Crown',b:'1F451',j:['king','kod','leader','royalty','lord'],k:[14,5],o:2},arrow_upper_left:{a:'North West Arrow',b:'2196-FE0F',c:'2196',j:['blue-square','point','direction','diagonal','northwest'],k:[52,16],o:2},neutral_face:{a:'Neutral Face',b:'1F610',j:['indifference','meh',':|','neutral'],k:[30,51],l:[':|',':-|'],o:2},rugby_football:{a:'Rugby Football',b:'1F3C9',j:['sports','team'],k:[9,34],o:2},muscle:{skin_variations:{'1F3FB':{unified:'1F4AA-1F3FB',non_qualified:null,image:'1f4aa-1f3fb.png',sheet_x:25,sheet_y:53,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F4AA-1F3FC',non_qualified:null,image:'1f4aa-1f3fc.png',sheet_x:25,sheet_y:54,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F4AA-1F3FD',non_qualified:null,image:'1f4aa-1f3fd.png',sheet_x:25,sheet_y:55,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F4AA-1F3FE',non_qualified:null,image:'1f4aa-1f3fe.png',sheet_x:25,sheet_y:56,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F4AA-1F3FF',non_qualified:null,image:'1f4aa-1f3ff.png',sheet_x:26,sheet_y:0,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Flexed Biceps',b:'1F4AA',j:['arm','flex','hand','summer','strong','biceps'],k:[25,52],o:2},baguette_bread:{a:'Baguette Bread',b:'1F956',j:['food','bread','french'],k:[41,37],o:4},expressionless:{a:'Expressionless Face',b:'1F611',j:['face','indifferent','-_-','meh','deadpan'],k:[30,52],o:2},womans_hat:{a:'Womans Hat',b:'1F452',j:['fashion','accessories','female','lady','spring'],k:[14,6],o:2},pretzel:{a:'Pretzel',b:'1F968',j:['food','bread','twisted'],k:[41,55],o:5},mechanical_arm:{a:'Mechanical Arm',b:'1F9BE',k:[44,6],o:12},arrow_up_down:{a:'Up Down Arrow',b:'2195-FE0F',c:'2195',j:['blue-square','direction','way','vertical'],k:[52,15],o:2},dromedary_camel:{a:'Dromedary Camel',b:'1F42A',j:['animal','hot','desert','hump'],k:[12,14],o:2},tennis:{a:'Tennis Racquet and Ball',b:'1F3BE',j:['sports','balls','green'],k:[8,36],o:2},'flag-bm':{a:'Bermuda Flag',b:'1F1E7-1F1F2',k:[1,1],o:2},factory:{a:'Factory',b:'1F3ED',j:['building','industry','pollution','smoke'],k:[11,7],o:2},japanese_castle:{a:'Japanese Castle',b:'1F3EF',j:['photo','building'],k:[11,9],o:2},no_mouth:{a:'Face Without Mouth',b:'1F636',j:['face','hellokitty'],k:[31,32],o:2},mechanical_leg:{a:'Mechanical Leg',b:'1F9BF',k:[44,7],o:12},bagel:{a:'Bagel',b:'1F96F',k:[42,5],o:11},camel:{a:'Bactrian Camel',b:'1F42B',j:['animal','nature','hot','desert','hump'],k:[12,15],o:2},tophat:{a:'Top Hat',b:'1F3A9',j:['magic','gentleman','classy','circus'],k:[8,15],o:2},left_right_arrow:{a:'Left Right Arrow',b:'2194-FE0F',c:'2194',j:['shape','direction','horizontal','sideways'],k:[52,14],o:2},'flag-bn':{a:'Brunei Flag',b:'1F1E7-1F1F3',k:[1,2],o:2},flying_disc:{a:'Flying Disc',b:'1F94F',k:[41,30],o:11},smirk:{a:'Smirking Face',b:'1F60F',j:['face','smile','mean','prank','smug','sarcasm'],k:[30,50],o:2},mortar_board:{a:'Graduation Cap',b:'1F393',j:['school','college','degree','university','graduation','cap','hat','legal','learn','education'],k:[7,55],o:2},european_castle:{a:'European Castle',b:'1F3F0',j:['building','royalty','history'],k:[11,10],o:2},leg:{skin_variations:{'1F3FB':{unified:'1F9B5-1F3FB',non_qualified:null,image:'1f9b5-1f3fb.png',sheet_x:43,sheet_y:6,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9B5-1F3FC',non_qualified:null,image:'1f9b5-1f3fc.png',sheet_x:43,sheet_y:7,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9B5-1F3FD',non_qualified:null,image:'1f9b5-1f3fd.png',sheet_x:43,sheet_y:8,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9B5-1F3FE',non_qualified:null,image:'1f9b5-1f3fe.png',sheet_x:43,sheet_y:9,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9B5-1F3FF',non_qualified:null,image:'1f9b5-1f3ff.png',sheet_x:43,sheet_y:10,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Leg',b:'1F9B5',k:[43,5],o:11},pancakes:{a:'Pancakes',b:'1F95E',j:['food','breakfast','flapjacks','hotcakes'],k:[41,45],o:4},leftwards_arrow_with_hook:{a:'Leftwards Arrow with Hook',b:'21A9-FE0F',c:'21A9',j:['back','return','blue-square','undo','enter'],k:[52,20],o:2},'flag-bo':{a:'Bolivia Flag',b:'1F1E7-1F1F4',k:[1,3],o:2},bowling:{a:'Bowling',b:'1F3B3',j:['sports','fun','play'],k:[8,25],o:2},llama:{a:'Llama',b:'1F999',k:[42,43],o:11},arrow_right_hook:{a:'Rightwards Arrow with Hook',b:'21AA-FE0F',c:'21AA',j:['blue-square','return','rotate','direction'],k:[52,21],o:2},wedding:{a:'Wedding',b:'1F492',j:['love','like','affection','couple','marriage','bride','groom'],k:[25,28],o:2},'flag-bq':{a:'Caribbean Netherlands Flag',b:'1F1E7-1F1F6',k:[1,4],o:2},foot:{skin_variations:{'1F3FB':{unified:'1F9B6-1F3FB',non_qualified:null,image:'1f9b6-1f3fb.png',sheet_x:43,sheet_y:12,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9B6-1F3FC',non_qualified:null,image:'1f9b6-1f3fc.png',sheet_x:43,sheet_y:13,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9B6-1F3FD',non_qualified:null,image:'1f9b6-1f3fd.png',sheet_x:43,sheet_y:14,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9B6-1F3FE',non_qualified:null,image:'1f9b6-1f3fe.png',sheet_x:43,sheet_y:15,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9B6-1F3FF',non_qualified:null,image:'1f9b6-1f3ff.png',sheet_x:43,sheet_y:16,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Foot',b:'1F9B6',k:[43,11],o:11},giraffe_face:{a:'Giraffe Face',b:'1F992',k:[42,36],o:5},unamused:{a:'Unamused Face',b:'1F612',j:['indifference','bored','straight face','serious','sarcasm'],k:[30,53],m:':(',o:2},billed_cap:{a:'Billed Cap',b:'1F9E2',k:[51,21],o:5},waffle:{a:'Waffle',b:'1F9C7',k:[44,15],o:12},cricket_bat_and_ball:{a:'Cricket Bat and Ball',b:'1F3CF',k:[10,34],o:2},helmet_with_white_cross:{a:'Helmet with White Cross',b:'26D1-FE0F',c:'26D1',k:[54,6],o:2},ear:{skin_variations:{'1F3FB':{unified:'1F442-1F3FB',non_qualified:null,image:'1f442-1f3fb.png',sheet_x:12,sheet_y:40,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F442-1F3FC',non_qualified:null,image:'1f442-1f3fc.png',sheet_x:12,sheet_y:41,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F442-1F3FD',non_qualified:null,image:'1f442-1f3fd.png',sheet_x:12,sheet_y:42,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F442-1F3FE',non_qualified:null,image:'1f442-1f3fe.png',sheet_x:12,sheet_y:43,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F442-1F3FF',non_qualified:null,image:'1f442-1f3ff.png',sheet_x:12,sheet_y:44,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Ear',b:'1F442',j:['face','hear','sound','listen'],k:[12,39],o:2},elephant:{a:'Elephant',b:'1F418',j:['animal','nature','nose','th','circus'],k:[11,53],o:2},cheese_wedge:{a:'Cheese Wedge',b:'1F9C0',k:[44,8],o:2},tokyo_tower:{a:'Tokyo Tower',b:'1F5FC',j:['photo','japanese'],k:[30,31],o:2},arrow_heading_up:{a:'Arrow Pointing Rightwards Then Curving Upwards',b:'2934-FE0F',c:'2934',j:['blue-square','direction','top'],k:[55,35],o:2},field_hockey_stick_and_ball:{a:'Field Hockey Stick and Ball',b:'1F3D1',k:[10,36],o:2},'flag-br':{a:'Brazil Flag',b:'1F1E7-1F1F7',k:[1,5],o:2},face_with_rolling_eyes:{a:'Face with Rolling Eyes',b:'1F644',k:[31,46],o:2},ear_with_hearing_aid:{skin_variations:{'1F3FB':{unified:'1F9BB-1F3FB',non_qualified:null,image:'1f9bb-1f3fb.png',sheet_x:43,sheet_y:56,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9BB-1F3FC',non_qualified:null,image:'1f9bb-1f3fc.png',sheet_x:44,sheet_y:0,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9BB-1F3FD',non_qualified:null,image:'1f9bb-1f3fd.png',sheet_x:44,sheet_y:1,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9BB-1F3FE',non_qualified:null,image:'1f9bb-1f3fe.png',sheet_x:44,sheet_y:2,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9BB-1F3FF',non_qualified:null,image:'1f9bb-1f3ff.png',sheet_x:44,sheet_y:3,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Ear with Hearing Aid',b:'1F9BB',k:[43,55],o:12},arrow_heading_down:{a:'Arrow Pointing Rightwards Then Curving Downwards',b:'2935-FE0F',c:'2935',j:['blue-square','direction','bottom'],k:[55,36],o:2},ice_hockey_stick_and_puck:{a:'Ice Hockey Stick and Puck',b:'1F3D2',k:[10,37],o:2},meat_on_bone:{a:'Meat on Bone',b:'1F356',j:['good','food','drumstick'],k:[6,46],o:2},prayer_beads:{a:'Prayer Beads',b:'1F4FF',j:['dhikr','religious'],k:[27,27],o:2},statue_of_liberty:{a:'Statue of Liberty',b:'1F5FD',j:['american','newyork'],k:[30,32],o:2},grimacing:{a:'Grimacing Face',b:'1F62C',j:['face','grimace','teeth'],k:[31,22],o:2},'flag-bs':{a:'Bahamas Flag',b:'1F1E7-1F1F8',k:[1,6],o:2},rhinoceros:{a:'Rhinoceros',b:'1F98F',j:['animal','nature','horn'],k:[42,33],o:4},lacrosse:{a:'Lacrosse Stick and Ball',b:'1F94D',k:[41,28],o:11},poultry_leg:{a:'Poultry Leg',b:'1F357',j:['food','meat','drumstick','bird','chicken','turkey'],k:[6,47],o:2},hippopotamus:{a:'Hippopotamus',b:'1F99B',k:[42,45],o:11},nose:{skin_variations:{'1F3FB':{unified:'1F443-1F3FB',non_qualified:null,image:'1f443-1f3fb.png',sheet_x:12,sheet_y:46,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F443-1F3FC',non_qualified:null,image:'1f443-1f3fc.png',sheet_x:12,sheet_y:47,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F443-1F3FD',non_qualified:null,image:'1f443-1f3fd.png',sheet_x:12,sheet_y:48,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F443-1F3FE',non_qualified:null,image:'1f443-1f3fe.png',sheet_x:12,sheet_y:49,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F443-1F3FF',non_qualified:null,image:'1f443-1f3ff.png',sheet_x:12,sheet_y:50,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Nose',b:'1F443',j:['smell','sniff'],k:[12,45],o:2},arrows_clockwise:{a:'Clockwise Downwards and Upwards Open Circle Arrows',b:'1F503',j:['sync','cycle','round','repeat'],k:[27,31],o:2},'flag-bt':{a:'Bhutan Flag',b:'1F1E7-1F1F9',k:[1,7],o:2},church:{a:'Church',b:'26EA',j:['building','religion','christ'],k:[54,10],o:2},lipstick:{a:'Lipstick',b:'1F484',j:['female','girl','fashion','woman'],k:[24,32],o:2},lying_face:{a:'Lying Face',b:'1F925',j:['face','lie','pinocchio'],k:[38,22],o:4},arrows_counterclockwise:{a:'Anticlockwise Downwards and Upwards Open Circle Arrows',b:'1F504',j:['blue-square','sync','cycle'],k:[27,32],o:2},'flag-bv':{a:'Bouvet Island Flag',b:'1F1E7-1F1FB',k:[1,8],o:2},cut_of_meat:{a:'Cut of Meat',b:'1F969',k:[41,56],o:5},mosque:{a:'Mosque',b:'1F54C',j:['islam','worship','minaret'],k:[28,36],o:2},ring:{a:'Ring',b:'1F48D',j:['wedding','propose','marriage','valentines','diamond','fashion','jewelry','gem','engagement'],k:[25,23],o:2},brain:{a:'Brain',b:'1F9E0',j:['smart','intelligent'],k:[51,19],o:5},table_tennis_paddle_and_ball:{a:'Table Tennis Paddle and Ball',b:'1F3D3',k:[10,38],o:2},relieved:{a:'Relieved Face',b:'1F60C',j:['face','relaxed','phew','massage','happiness'],k:[30,47],o:2},mouse:{a:'Mouse Face',b:'1F42D',j:['animal','nature','cheese_wedge','rodent'],k:[12,17],o:2},hindu_temple:{a:'Hindu Temple',b:'1F6D5',k:[36,41],o:12},back:{a:'Back with Leftwards Arrow Above',b:'1F519',j:['arrow','words','return'],k:[27,53],o:2},gem:{a:'Gem Stone',b:'1F48E',j:['blue','ruby','diamond','jewelry'],k:[25,24],o:2},pensive:{a:'Pensive Face',b:'1F614',j:['face','sad','depressed','upset'],k:[30,55],o:2},'flag-bw':{a:'Botswana Flag',b:'1F1E7-1F1FC',k:[1,9],o:2},mouse2:{a:'Mouse',b:'1F401',j:['animal','nature','rodent'],k:[11,29],o:2},bacon:{a:'Bacon',b:'1F953',j:['food','breakfast','pork','pig','meat'],k:[41,34],o:4},tooth:{a:'Tooth',b:'1F9B7',k:[43,17],o:11},badminton_racquet_and_shuttlecock:{a:'Badminton Racquet and Shuttlecock',b:'1F3F8',k:[11,20],o:2},rat:{a:'Rat',b:'1F400',j:['animal','mouse','rodent'],k:[11,28],o:2},synagogue:{a:'Synagogue',b:'1F54D',j:['judaism','worship','temple','jewish'],k:[28,37],o:2},end:{a:'End with Leftwards Arrow Above',b:'1F51A',j:['words','arrow'],k:[27,54],o:2},bone:{a:'Bone',b:'1F9B4',k:[43,4],o:11},boxing_glove:{a:'Boxing Glove',b:'1F94A',j:['sports','fighting'],k:[41,25],o:4},mute:{a:'Speaker with Cancellation Stroke',b:'1F507',j:['sound','volume','silence','quiet'],k:[27,35],o:2},hamburger:{a:'Hamburger',b:'1F354',j:['meat','fast food','beef','cheeseburger','mcdonalds','burger king'],k:[6,44],o:2},'flag-by':{a:'Belarus Flag',b:'1F1E7-1F1FE',k:[1,10],o:2},sleepy:{a:'Sleepy Face',b:'1F62A',j:['face','tired','rest','nap'],k:[31,20],o:2},on:{a:'On with Exclamation Mark with Left Right Arrow Above',b:'1F51B',j:['arrow','words'],k:[27,55],o:2},martial_arts_uniform:{a:'Martial Arts Uniform',b:'1F94B',j:['judo','karate','taekwondo'],k:[41,26],o:4},speaker:{a:'Speaker',b:'1F508',j:['sound','volume','silence','broadcast'],k:[27,36],o:2},drooling_face:{a:'Drooling Face',b:'1F924',j:['face'],k:[38,21],o:4},eyes:{a:'Eyes',b:'1F440',j:['look','watch','stalk','peek','see'],k:[12,36],o:2},'flag-bz':{a:'Belize Flag',b:'1F1E7-1F1FF',k:[1,11],o:2},hamster:{a:'Hamster Face',b:'1F439',j:['animal','nature'],k:[12,29],o:2},shinto_shrine:{a:'Shinto Shrine',b:'26E9-FE0F',c:'26E9',j:['temple','japan','kyoto'],k:[54,9],o:2},fries:{a:'French Fries',b:'1F35F',j:['chips','snack','fast food'],k:[6,55],o:2},goal_net:{a:'Goal Net',b:'1F945',j:['sports'],k:[41,21],o:4},kaaba:{a:'Kaaba',b:'1F54B',j:['mecca','mosque','islam'],k:[28,35],o:2},soon:{a:'Soon with Rightwards Arrow Above',b:'1F51C',j:['arrow','words'],k:[27,56],o:2},'flag-ca':{a:'Canada Flag',b:'1F1E8-1F1E6',k:[1,12],o:2},rabbit:{a:'Rabbit Face',b:'1F430',j:['animal','nature','pet','spring','magic','bunny'],k:[12,20],o:2},eye:{a:'Eye',b:'1F441-FE0F',c:'1F441',j:['face','look','see','watch','stare'],k:[12,38],o:2},sleeping:{a:'Sleeping Face',b:'1F634',j:['face','tired','sleepy','night','zzz'],k:[31,30],o:2},pizza:{a:'Slice of Pizza',b:'1F355',j:['food','party'],k:[6,45],o:2},sound:{a:'Speaker with One Sound Wave',b:'1F509',j:['volume','speaker','broadcast'],k:[27,37],o:2},rabbit2:{a:'Rabbit',b:'1F407',j:['animal','nature','pet','magic','spring'],k:[11,35],o:2},fountain:{a:'Fountain',b:'26F2',j:['photo','summer','water','fresh'],k:[54,13],o:2},golf:{a:'Flag in Hole',b:'26F3',j:['sports','business','flag','hole','summer'],k:[54,14],o:2},top:{a:'Top with Upwards Arrow Above',b:'1F51D',j:['words','blue-square'],k:[28,0],o:2},mask:{a:'Face with Medical Mask',b:'1F637',j:['face','sick','ill','disease'],k:[31,33],o:2},'flag-cc':{a:'Cocos (keeling) Islands Flag',b:'1F1E8-1F1E8',k:[1,13],o:2},hotdog:{a:'Hot Dog',b:'1F32D',j:['food','frankfurter'],k:[6,5],o:2},loud_sound:{a:'Speaker with Three Sound Waves',b:'1F50A',j:['volume','noise','noisy','speaker','broadcast'],k:[27,38],o:2},tongue:{a:'Tongue',b:'1F445',j:['mouth','playful'],k:[12,52],o:2},place_of_worship:{a:'Place of Worship',b:'1F6D0',j:['religion','church','temple','prayer'],k:[36,38],o:2},ice_skate:{a:'Ice Skate',b:'26F8-FE0F',c:'26F8',j:['sports'],k:[54,18],o:2},sandwich:{a:'Sandwich',b:'1F96A',j:['food','lunch','bread'],k:[42,0],o:5},chipmunk:{a:'Chipmunk',b:'1F43F-FE0F',c:'1F43F',j:['animal','nature','rodent','squirrel'],k:[12,35],o:2},loudspeaker:{a:'Public Address Loudspeaker',b:'1F4E2',j:['volume','sound'],k:[26,56],o:2},lips:{a:'Mouth',b:'1F444',j:['mouth','kiss'],k:[12,51],o:2},'flag-cd':{a:'Congo - Kinshasa Flag',b:'1F1E8-1F1E9',k:[1,14],o:2},tent:{a:'Tent',b:'26FA',j:['photo','camping','outdoors'],k:[54,37],o:2},face_with_thermometer:{a:'Face with Thermometer',b:'1F912',j:['sick','temperature','thermometer','cold','fever'],k:[37,25],o:2},taco:{a:'Taco',b:'1F32E',j:['food','mexican'],k:[6,6],o:2},foggy:{a:'Foggy',b:'1F301',j:['photo','mountain'],k:[5,20],o:2},'flag-cf':{a:'Central African Republic Flag',b:'1F1E8-1F1EB',k:[1,15],o:2},baby:{skin_variations:{'1F3FB':{unified:'1F476-1F3FB',non_qualified:null,image:'1f476-1f3fb.png',sheet_x:23,sheet_y:5,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F476-1F3FC',non_qualified:null,image:'1f476-1f3fc.png',sheet_x:23,sheet_y:6,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F476-1F3FD',non_qualified:null,image:'1f476-1f3fd.png',sheet_x:23,sheet_y:7,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F476-1F3FE',non_qualified:null,image:'1f476-1f3fe.png',sheet_x:23,sheet_y:8,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F476-1F3FF',non_qualified:null,image:'1f476-1f3ff.png',sheet_x:23,sheet_y:9,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Baby',b:'1F476',j:['child','boy','girl','toddler'],k:[23,4],o:2},atom_symbol:{a:'Atom Symbol',b:'269B-FE0F',c:'269B',j:['science','physics','chemistry'],k:[53,48],o:2},fishing_pole_and_fish:{a:'Fishing Pole and Fish',b:'1F3A3',j:['food','hobby','summer'],k:[8,9],o:2},hedgehog:{a:'Hedgehog',b:'1F994',j:['animal','nature','spiny'],k:[42,38],o:5},face_with_head_bandage:{a:'Face with Head-Bandage',b:'1F915',j:['injured','clumsy','bandage','hurt'],k:[37,28],o:2},mega:{a:'Cheering Megaphone',b:'1F4E3',j:['sound','speaker','volume'],k:[27,0],o:2},nauseated_face:{a:'Nauseated Face',b:'1F922',j:['face','vomit','gross','green','sick','throw up','ill'],k:[38,19],o:4},child:{skin_variations:{'1F3FB':{unified:'1F9D2-1F3FB',non_qualified:null,image:'1f9d2-1f3fb.png',sheet_x:48,sheet_y:17,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9D2-1F3FC',non_qualified:null,image:'1f9d2-1f3fc.png',sheet_x:48,sheet_y:18,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9D2-1F3FD',non_qualified:null,image:'1f9d2-1f3fd.png',sheet_x:48,sheet_y:19,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9D2-1F3FE',non_qualified:null,image:'1f9d2-1f3fe.png',sheet_x:48,sheet_y:20,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9D2-1F3FF',non_qualified:null,image:'1f9d2-1f3ff.png',sheet_x:48,sheet_y:21,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Child',b:'1F9D2',j:['gender-neutral','young'],k:[48,16],o:5},'flag-cg':{a:'Congo - Brazzaville Flag',b:'1F1E8-1F1EC',k:[1,16],o:2},bat:{a:'Bat',b:'1F987',j:['animal','nature','blind','vampire'],k:[42,25],o:4},diving_mask:{a:'Diving Mask',b:'1F93F',k:[41,15],o:12},burrito:{a:'Burrito',b:'1F32F',j:['food','mexican'],k:[6,7],o:2},postal_horn:{a:'Postal Horn',b:'1F4EF',j:['instrument','music'],k:[27,12],o:2},night_with_stars:{a:'Night with Stars',b:'1F303',j:['evening','city','downtown'],k:[5,22],o:2},om_symbol:{a:'Om Symbol',b:'1F549-FE0F',c:'1F549',k:[28,33],o:2},star_of_david:{a:'Star of David',b:'2721-FE0F',c:'2721',j:['judaism'],k:[55,15],o:2},boy:{skin_variations:{'1F3FB':{unified:'1F466-1F3FB',non_qualified:null,image:'1f466-1f3fb.png',sheet_x:14,sheet_y:27,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F466-1F3FC',non_qualified:null,image:'1f466-1f3fc.png',sheet_x:14,sheet_y:28,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F466-1F3FD',non_qualified:null,image:'1f466-1f3fd.png',sheet_x:14,sheet_y:29,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F466-1F3FE',non_qualified:null,image:'1f466-1f3fe.png',sheet_x:14,sheet_y:30,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F466-1F3FF',non_qualified:null,image:'1f466-1f3ff.png',sheet_x:14,sheet_y:31,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Boy',b:'1F466',j:['man','male','guy','teenager'],k:[14,26],o:2},bell:{a:'Bell',b:'1F514',j:['sound','notification','christmas','xmas','chime'],k:[27,48],o:2},'flag-ch':{a:'Switzerland Flag',b:'1F1E8-1F1ED',k:[1,17],o:2},running_shirt_with_sash:{a:'Running Shirt with Sash',b:'1F3BD',j:['play','pageant'],k:[8,35],o:2},stuffed_flatbread:{a:'Stuffed Flatbread',b:'1F959',j:['food','flatbread','stuffed','gyro'],k:[41,40],o:4},bear:{a:'Bear Face',b:'1F43B',j:['animal','nature','wild'],k:[12,31],o:2},cityscape:{a:'Cityscape',b:'1F3D9-FE0F',c:'1F3D9',j:['photo','night life','urban'],k:[10,44],o:2},face_vomiting:{a:'Face with Open Mouth Vomiting',b:'1F92E',k:[38,48],n:['face_with_open_mouth_vomiting'],o:5},wheel_of_dharma:{a:'Wheel of Dharma',b:'2638-FE0F',c:'2638',j:['hinduism','buddhism','sikhism','jainism'],k:[53,15],o:2},ski:{a:'Ski and Ski Boot',b:'1F3BF',j:['sports','winter','cold','snow'],k:[8,37],o:2},girl:{skin_variations:{'1F3FB':{unified:'1F467-1F3FB',non_qualified:null,image:'1f467-1f3fb.png',sheet_x:14,sheet_y:33,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F467-1F3FC',non_qualified:null,image:'1f467-1f3fc.png',sheet_x:14,sheet_y:34,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F467-1F3FD',non_qualified:null,image:'1f467-1f3fd.png',sheet_x:14,sheet_y:35,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F467-1F3FE',non_qualified:null,image:'1f467-1f3fe.png',sheet_x:14,sheet_y:36,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F467-1F3FF',non_qualified:null,image:'1f467-1f3ff.png',sheet_x:14,sheet_y:37,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Girl',b:'1F467',j:['female','woman','teenager'],k:[14,32],o:2},falafel:{a:'Falafel',b:'1F9C6',k:[44,14],o:12},sneezing_face:{a:'Sneezing Face',b:'1F927',j:['face','gesundheit','sneeze','sick','allergy'],k:[38,41],o:4},no_bell:{a:'Bell with Cancellation Stroke',b:'1F515',j:['sound','volume','mute','quiet','silent'],k:[27,49],o:2},koala:{a:'Koala',b:'1F428',j:['animal','nature'],k:[12,12],o:2},sunrise_over_mountains:{a:'Sunrise over Mountains',b:'1F304',j:['view','vacation','photo'],k:[5,23],o:2},'flag-ci':{a:'Côte D’ivoire Flag',b:'1F1E8-1F1EE',k:[1,18],o:2},sunrise:{a:'Sunrise',b:'1F305',j:['morning','view','vacation','photo'],k:[5,24],o:2},yin_yang:{a:'Yin Yang',b:'262F-FE0F',c:'262F',j:['balance'],k:[53,14],o:2},adult:{skin_variations:{'1F3FB':{unified:'1F9D1-1F3FB',non_qualified:null,image:'1f9d1-1f3fb.png',sheet_x:48,sheet_y:11,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9D1-1F3FC',non_qualified:null,image:'1f9d1-1f3fc.png',sheet_x:48,sheet_y:12,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9D1-1F3FD',non_qualified:null,image:'1f9d1-1f3fd.png',sheet_x:48,sheet_y:13,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9D1-1F3FE',non_qualified:null,image:'1f9d1-1f3fe.png',sheet_x:48,sheet_y:14,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9D1-1F3FF',non_qualified:null,image:'1f9d1-1f3ff.png',sheet_x:48,sheet_y:15,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Adult',b:'1F9D1',j:['gender-neutral','person'],k:[48,10],o:5},hot_face:{a:'Overheated Face',b:'1F975',k:[42,10],o:11},musical_score:{a:'Musical Score',b:'1F3BC',j:['treble','clef','compose'],k:[8,34],o:2},sled:{a:'Sled',b:'1F6F7',j:['sleigh','luge','toboggan'],k:[36,56],o:5},egg:{a:'Egg',b:'1F95A',j:['food','chicken','breakfast'],k:[41,41],o:4},panda_face:{a:'Panda Face',b:'1F43C',j:['animal','nature','panda'],k:[12,32],o:2},'flag-ck':{a:'Cook Islands Flag',b:'1F1E8-1F1F0',k:[1,19],o:2},'flag-cl':{a:'Chile Flag',b:'1F1E8-1F1F1',k:[1,20],o:2},person_with_blond_hair:{skin_variations:{'1F3FB':{unified:'1F471-1F3FB',non_qualified:null,image:'1f471-1f3fb.png',sheet_x:22,sheet_y:20,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F471-1F3FC',non_qualified:null,image:'1f471-1f3fc.png',sheet_x:22,sheet_y:21,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F471-1F3FD',non_qualified:null,image:'1f471-1f3fd.png',sheet_x:22,sheet_y:22,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F471-1F3FE',non_qualified:null,image:'1f471-1f3fe.png',sheet_x:22,sheet_y:23,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F471-1F3FF',non_qualified:null,image:'1f471-1f3ff.png',sheet_x:22,sheet_y:24,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},obsoleted_by:'1F471-200D-2642-FE0F',a:'Person with Blond Hair',b:'1F471',k:[22,19],o:2},sloth:{a:'Sloth',b:'1F9A5',k:[42,53],o:12},latin_cross:{a:'Latin Cross',b:'271D-FE0F',c:'271D',j:['christianity'],k:[55,14],o:2},curling_stone:{a:'Curling Stone',b:'1F94C',j:['sports'],k:[41,27],o:5},cold_face:{a:'Freezing Face',b:'1F976',k:[42,11],o:11},fried_egg:{a:'Cooking',b:'1F373',j:['food','breakfast','kitchen','egg'],k:[7,18],n:['cooking'],o:2},city_sunset:{a:'Cityscape at Dusk',b:'1F306',j:['photo','evening','sky','buildings'],k:[5,25],o:2},musical_note:{a:'Musical Note',b:'1F3B5',j:['score','tone','sound'],k:[8,27],o:2},'flag-cm':{a:'Cameroon Flag',b:'1F1E8-1F1F2',k:[1,21],o:2},notes:{a:'Multiple Musical Notes',b:'1F3B6',j:['music','score'],k:[8,28],o:2},woozy_face:{a:'Face with Uneven Eyes and Wavy Mouth',b:'1F974',k:[42,9],o:11},dart:{a:'Direct Hit',b:'1F3AF',j:['game','play','bar','target','bullseye'],k:[8,21],o:2},orthodox_cross:{a:'Orthodox Cross',b:'2626-FE0F',c:'2626',j:['suppedaneum','religion'],k:[53,11],o:2},shallow_pan_of_food:{a:'Shallow Pan of Food',b:'1F958',j:['food','cooking','casserole','paella'],k:[41,39],o:4},otter:{a:'Otter',b:'1F9A6',k:[42,54],o:12},man:{skin_variations:{'1F3FB':{unified:'1F468-1F3FB',non_qualified:null,image:'1f468-1f3fb.png',sheet_x:17,sheet_y:23,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F468-1F3FC',non_qualified:null,image:'1f468-1f3fc.png',sheet_x:17,sheet_y:24,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F468-1F3FD',non_qualified:null,image:'1f468-1f3fd.png',sheet_x:17,sheet_y:25,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F468-1F3FE',non_qualified:null,image:'1f468-1f3fe.png',sheet_x:17,sheet_y:26,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F468-1F3FF',non_qualified:null,image:'1f468-1f3ff.png',sheet_x:17,sheet_y:27,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man',b:'1F468',j:['mustache','father','dad','guy','classy','sir','moustache'],k:[17,22],o:2},city_sunrise:{a:'Sunset over Buildings',b:'1F307',j:['photo','good morning','dawn'],k:[5,26],o:2},bearded_person:{skin_variations:{'1F3FB':{unified:'1F9D4-1F3FB',non_qualified:null,image:'1f9d4-1f3fb.png',sheet_x:48,sheet_y:29,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9D4-1F3FC',non_qualified:null,image:'1f9d4-1f3fc.png',sheet_x:48,sheet_y:30,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9D4-1F3FD',non_qualified:null,image:'1f9d4-1f3fd.png',sheet_x:48,sheet_y:31,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9D4-1F3FE',non_qualified:null,image:'1f9d4-1f3fe.png',sheet_x:48,sheet_y:32,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9D4-1F3FF',non_qualified:null,image:'1f9d4-1f3ff.png',sheet_x:48,sheet_y:33,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Bearded Person',b:'1F9D4',j:['person','bewhiskered'],k:[48,28],o:5},skunk:{a:'Skunk',b:'1F9A8',k:[42,56],o:12},stew:{a:'Pot of Food',b:'1F372',j:['food','meat','soup'],k:[7,17],o:2},cn:{a:'China Flag',b:'1F1E8-1F1F3',j:['china','chinese','prc','flag','country','nation','banner'],k:[1,22],n:['flag-cn'],o:2},studio_microphone:{a:'Studio Microphone',b:'1F399-FE0F',c:'1F399',j:['sing','recording','artist','talkshow'],k:[8,1],o:2},star_and_crescent:{a:'Star and Crescent',b:'262A-FE0F',c:'262A',j:['islam'],k:[53,12],o:2},'yo-yo':{a:'Yo-Yo',b:'1FA80',k:[52,1],o:12},bridge_at_night:{a:'Bridge at Night',b:'1F309',j:['photo','sanfrancisco'],k:[5,28],o:2},dizzy_face:{a:'Dizzy Face',b:'1F635',j:['spent','unconscious','xox','dizzy'],k:[31,31],o:2},red_haired_man:{skin_variations:{'1F3FB':{unified:'1F468-1F3FB-200D-1F9B0',non_qualified:null,image:'1f468-1f3fb-200d-1f9b0.png',sheet_x:16,sheet_y:24,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F468-1F3FC-200D-1F9B0',non_qualified:null,image:'1f468-1f3fc-200d-1f9b0.png',sheet_x:16,sheet_y:25,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F468-1F3FD-200D-1F9B0',non_qualified:null,image:'1f468-1f3fd-200d-1f9b0.png',sheet_x:16,sheet_y:26,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F468-1F3FE-200D-1F9B0',non_qualified:null,image:'1f468-1f3fe-200d-1f9b0.png',sheet_x:16,sheet_y:27,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F468-1F3FF-200D-1F9B0',non_qualified:null,image:'1f468-1f3ff-200d-1f9b0.png',sheet_x:16,sheet_y:28,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Red Haired Man',b:'1F468-200D-1F9B0',k:[16,23],o:11},kite:{a:'Kite',b:'1FA81',k:[52,2],o:12},bowl_with_spoon:{a:'Bowl with Spoon',b:'1F963',j:['food','breakfast','cereal','oatmeal','porridge'],k:[41,50],o:5},'flag-co':{a:'Colombia Flag',b:'1F1E8-1F1F4',k:[1,23],o:2},peace_symbol:{a:'Peace Symbol',b:'262E-FE0F',c:'262E',j:['hippie'],k:[53,13],o:2},kangaroo:{a:'Kangaroo',b:'1F998',k:[42,42],o:11},hotsprings:{a:'Hot Springs',b:'2668-FE0F',c:'2668',j:['bath','warm','relax'],k:[53,37],o:2},exploding_head:{a:'Shocked Face with Exploding Head',b:'1F92F',j:['face','shocked','mind','blown'],k:[38,49],n:['shocked_face_with_exploding_head'],o:5},level_slider:{a:'Level Slider',b:'1F39A-FE0F',c:'1F39A',j:['scale'],k:[8,2],o:2},badger:{a:'Badger',b:'1F9A1',k:[42,51],o:11},'8ball':{a:'Billiards',b:'1F3B1',j:['pool','hobby','game','luck','magic'],k:[8,23],o:2},curly_haired_man:{skin_variations:{'1F3FB':{unified:'1F468-1F3FB-200D-1F9B1',non_qualified:null,image:'1f468-1f3fb-200d-1f9b1.png',sheet_x:16,sheet_y:30,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F468-1F3FC-200D-1F9B1',non_qualified:null,image:'1f468-1f3fc-200d-1f9b1.png',sheet_x:16,sheet_y:31,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F468-1F3FD-200D-1F9B1',non_qualified:null,image:'1f468-1f3fd-200d-1f9b1.png',sheet_x:16,sheet_y:32,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F468-1F3FE-200D-1F9B1',non_qualified:null,image:'1f468-1f3fe-200d-1f9b1.png',sheet_x:16,sheet_y:33,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F468-1F3FF-200D-1F9B1',non_qualified:null,image:'1f468-1f3ff-200d-1f9b1.png',sheet_x:16,sheet_y:34,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Curly Haired Man',b:'1F468-200D-1F9B1',k:[16,29],o:11},'flag-cp':{a:'Clipperton Island Flag',b:'1F1E8-1F1F5',k:[1,24],o:2},carousel_horse:{a:'Carousel Horse',b:'1F3A0',j:['photo','carnival'],k:[8,6],o:2},face_with_cowboy_hat:{a:'Face with Cowboy Hat',b:'1F920',k:[38,17],o:4},menorah_with_nine_branches:{a:'Menorah with Nine Branches',b:'1F54E',k:[28,38],o:2},green_salad:{a:'Green Salad',b:'1F957',j:['food','healthy','lettuce'],k:[41,38],o:4},control_knobs:{a:'Control Knobs',b:'1F39B-FE0F',c:'1F39B',j:['dial'],k:[8,3],o:2},popcorn:{a:'Popcorn',b:'1F37F',j:['food','movie theater','films','snack'],k:[7,30],o:2},six_pointed_star:{a:'Six Pointed Star with Middle Dot',b:'1F52F',j:['purple-square','religion','jewish','hexagram'],k:[28,18],o:2},feet:{a:'Paw Prints',b:'1F43E',k:[12,34],n:['paw_prints'],o:2},ferris_wheel:{a:'Ferris Wheel',b:'1F3A1',j:['photo','carnival','londoneye'],k:[8,7],o:2},microphone:{a:'Microphone',b:'1F3A4',j:['sound','music','PA','sing','talkshow'],k:[8,10],o:2},crystal_ball:{a:'Crystal Ball',b:'1F52E',j:['disco','party','magic','circus','fortune_teller'],k:[28,17],o:2},partying_face:{a:'Face with Party Horn and Party Hat',b:'1F973',k:[42,8],o:11},'flag-cr':{a:'Costa Rica Flag',b:'1F1E8-1F1F7',k:[1,25],o:2},white_haired_man:{skin_variations:{'1F3FB':{unified:'1F468-1F3FB-200D-1F9B3',non_qualified:null,image:'1f468-1f3fb-200d-1f9b3.png',sheet_x:16,sheet_y:42,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F468-1F3FC-200D-1F9B3',non_qualified:null,image:'1f468-1f3fc-200d-1f9b3.png',sheet_x:16,sheet_y:43,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F468-1F3FD-200D-1F9B3',non_qualified:null,image:'1f468-1f3fd-200d-1f9b3.png',sheet_x:16,sheet_y:44,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F468-1F3FE-200D-1F9B3',non_qualified:null,image:'1f468-1f3fe-200d-1f9b3.png',sheet_x:16,sheet_y:45,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F468-1F3FF-200D-1F9B3',non_qualified:null,image:'1f468-1f3ff-200d-1f9b3.png',sheet_x:16,sheet_y:46,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'White Haired Man',b:'1F468-200D-1F9B3',k:[16,41],o:11},headphones:{a:'Headphone',b:'1F3A7',j:['music','score','gadgets'],k:[8,13],o:2},bald_man:{skin_variations:{'1F3FB':{unified:'1F468-1F3FB-200D-1F9B2',non_qualified:null,image:'1f468-1f3fb-200d-1f9b2.png',sheet_x:16,sheet_y:36,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F468-1F3FC-200D-1F9B2',non_qualified:null,image:'1f468-1f3fc-200d-1f9b2.png',sheet_x:16,sheet_y:37,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F468-1F3FD-200D-1F9B2',non_qualified:null,image:'1f468-1f3fd-200d-1f9b2.png',sheet_x:16,sheet_y:38,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F468-1F3FE-200D-1F9B2',non_qualified:null,image:'1f468-1f3fe-200d-1f9b2.png',sheet_x:16,sheet_y:39,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F468-1F3FF-200D-1F9B2',non_qualified:null,image:'1f468-1f3ff-200d-1f9b2.png',sheet_x:16,sheet_y:40,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Bald Man',b:'1F468-200D-1F9B2',k:[16,35],o:11},sunglasses:{a:'Smiling Face with Sunglasses',b:'1F60E',j:['face','cool','smile','summer','beach','sunglass'],k:[30,49],l:['8)'],o:2},butter:{a:'Butter',b:'1F9C8',k:[44,16],o:12},roller_coaster:{a:'Roller Coaster',b:'1F3A2',j:['carnival','playground','photo','fun'],k:[8,8],o:2},turkey:{a:'Turkey',b:'1F983',j:['animal','bird'],k:[42,21],o:2},nazar_amulet:{a:'Nazar Amulet',b:'1F9FF',k:[51,50],o:11},'flag-cu':{a:'Cuba Flag',b:'1F1E8-1F1FA',k:[1,26],o:2},aries:{a:'Aries',b:'2648',j:['sign','purple-square','zodiac','astrology'],k:[53,20],o:2},'flag-cv':{a:'Cape Verde Flag',b:'1F1E8-1F1FB',k:[1,27],o:2},barber:{a:'Barber Pole',b:'1F488',j:['hair','salon','style'],k:[25,18],o:2},taurus:{a:'Taurus',b:'2649',j:['purple-square','sign','zodiac','astrology'],k:[53,21],o:2},salt:{a:'Salt Shaker',b:'1F9C2',k:[44,10],o:11},woman:{skin_variations:{'1F3FB':{unified:'1F469-1F3FB',non_qualified:null,image:'1f469-1f3fb.png',sheet_x:20,sheet_y:10,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F469-1F3FC',non_qualified:null,image:'1f469-1f3fc.png',sheet_x:20,sheet_y:11,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F469-1F3FD',non_qualified:null,image:'1f469-1f3fd.png',sheet_x:20,sheet_y:12,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F469-1F3FE',non_qualified:null,image:'1f469-1f3fe.png',sheet_x:20,sheet_y:13,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F469-1F3FF',non_qualified:null,image:'1f469-1f3ff.png',sheet_x:20,sheet_y:14,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Woman',b:'1F469',j:['female','girls','lady'],k:[20,9],o:2},video_game:{a:'Video Game',b:'1F3AE',j:['play','console','PS4','controller'],k:[8,20],o:2},chicken:{a:'Chicken',b:'1F414',j:['animal','cluck','nature','bird'],k:[11,48],o:2},radio:{a:'Radio',b:'1F4FB',j:['communication','music','podcast','program'],k:[27,24],o:2},nerd_face:{a:'Nerd Face',b:'1F913',j:['face','nerdy','geek','dork'],k:[37,26],o:2},red_haired_woman:{skin_variations:{'1F3FB':{unified:'1F469-1F3FB-200D-1F9B0',non_qualified:null,image:'1f469-1f3fb-200d-1f9b0.png',sheet_x:19,sheet_y:9,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F469-1F3FC-200D-1F9B0',non_qualified:null,image:'1f469-1f3fc-200d-1f9b0.png',sheet_x:19,sheet_y:10,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F469-1F3FD-200D-1F9B0',non_qualified:null,image:'1f469-1f3fd-200d-1f9b0.png',sheet_x:19,sheet_y:11,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F469-1F3FE-200D-1F9B0',non_qualified:null,image:'1f469-1f3fe-200d-1f9b0.png',sheet_x:19,sheet_y:12,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F469-1F3FF-200D-1F9B0',non_qualified:null,image:'1f469-1f3ff-200d-1f9b0.png',sheet_x:19,sheet_y:13,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Red Haired Woman',b:'1F469-200D-1F9B0',k:[19,8],o:11},circus_tent:{a:'Circus Tent',b:'1F3AA',j:['festival','carnival','party'],k:[8,16],o:2},face_with_monocle:{a:'Face with Monocle',b:'1F9D0',k:[45,16],o:5},canned_food:{a:'Canned Food',b:'1F96B',j:['food','soup'],k:[42,1],o:5},'flag-cw':{a:'Curaçao Flag',b:'1F1E8-1F1FC',k:[1,28],o:2},gemini:{a:'Gemini',b:'264A',j:['sign','zodiac','purple-square','astrology'],k:[53,22],o:2},saxophone:{a:'Saxophone',b:'1F3B7',j:['music','instrument','jazz','blues'],k:[8,29],o:2},rooster:{a:'Rooster',b:'1F413',j:['animal','nature','chicken'],k:[11,47],o:2},joystick:{a:'Joystick',b:'1F579-FE0F',c:'1F579',j:['game','play'],k:[29,36],o:2},guitar:{a:'Guitar',b:'1F3B8',j:['music','instrument'],k:[8,30],o:2},slot_machine:{a:'Slot Machine',b:'1F3B0',j:['bet','gamble','vegas','fruit machine','luck','casino'],k:[8,22],o:2},bento:{a:'Bento Box',b:'1F371',j:['food','japanese','box'],k:[7,16],o:2},steam_locomotive:{a:'Steam Locomotive',b:'1F682',j:['transportation','vehicle','train'],k:[34,1],o:2},confused:{a:'Confused Face',b:'1F615',j:['face','indifference','huh','weird','hmmm',':/'],k:[30,56],l:[':\\',':-\\',':/',':-/'],o:2},'flag-cx':{a:'Christmas Island Flag',b:'1F1E8-1F1FD',k:[1,29],o:2},hatching_chick:{a:'Hatching Chick',b:'1F423',j:['animal','chicken','egg','born','baby','bird'],k:[12,7],o:2},cancer:{a:'Cancer',b:'264B',j:['sign','zodiac','purple-square','astrology'],k:[53,23],o:2},red_haired_person:{skin_variations:{'1F3FB':{unified:'1F9D1-1F3FB-200D-1F9B0',non_qualified:null,image:'1f9d1-1f3fb-200d-1f9b0.png',sheet_x:47,sheet_y:14,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FC':{unified:'1F9D1-1F3FC-200D-1F9B0',non_qualified:null,image:'1f9d1-1f3fc-200d-1f9b0.png',sheet_x:47,sheet_y:15,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FD':{unified:'1F9D1-1F3FD-200D-1F9B0',non_qualified:null,image:'1f9d1-1f3fd-200d-1f9b0.png',sheet_x:47,sheet_y:16,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FE':{unified:'1F9D1-1F3FE-200D-1F9B0',non_qualified:null,image:'1f9d1-1f3fe-200d-1f9b0.png',sheet_x:47,sheet_y:17,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FF':{unified:'1F9D1-1F3FF-200D-1F9B0',non_qualified:null,image:'1f9d1-1f3ff-200d-1f9b0.png',sheet_x:47,sheet_y:18,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false}},a:'Red Haired Person',b:'1F9D1-200D-1F9B0',k:[47,13],o:12},'flag-cy':{a:'Cyprus Flag',b:'1F1E8-1F1FE',k:[1,30],o:2},worried:{a:'Worried Face',b:'1F61F',j:['face','concern','nervous',':('],k:[31,9],o:2},railway_car:{a:'Railway Car',b:'1F683',j:['transportation','vehicle'],k:[34,2],o:2},leo:{a:'Leo',b:'264C',j:['sign','purple-square','zodiac','astrology'],k:[53,24],o:2},curly_haired_woman:{skin_variations:{'1F3FB':{unified:'1F469-1F3FB-200D-1F9B1',non_qualified:null,image:'1f469-1f3fb-200d-1f9b1.png',sheet_x:19,sheet_y:15,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F469-1F3FC-200D-1F9B1',non_qualified:null,image:'1f469-1f3fc-200d-1f9b1.png',sheet_x:19,sheet_y:16,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F469-1F3FD-200D-1F9B1',non_qualified:null,image:'1f469-1f3fd-200d-1f9b1.png',sheet_x:19,sheet_y:17,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F469-1F3FE-200D-1F9B1',non_qualified:null,image:'1f469-1f3fe-200d-1f9b1.png',sheet_x:19,sheet_y:18,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F469-1F3FF-200D-1F9B1',non_qualified:null,image:'1f469-1f3ff-200d-1f9b1.png',sheet_x:19,sheet_y:19,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Curly Haired Woman',b:'1F469-200D-1F9B1',k:[19,14],o:11},baby_chick:{a:'Baby Chick',b:'1F424',j:['animal','chicken','bird'],k:[12,8],o:2},musical_keyboard:{a:'Musical Keyboard',b:'1F3B9',j:['piano','instrument','compose'],k:[8,31],o:2},game_die:{a:'Game Die',b:'1F3B2',j:['dice','random','tabletop','play','luck'],k:[8,24],o:2},rice_cracker:{a:'Rice Cracker',b:'1F358',j:['food','japanese'],k:[6,48],o:2},virgo:{a:'Virgo',b:'264D',j:['sign','zodiac','purple-square','astrology'],k:[53,25],o:2},'flag-cz':{a:'Czechia Flag',b:'1F1E8-1F1FF',k:[1,31],o:2},curly_haired_person:{skin_variations:{'1F3FB':{unified:'1F9D1-1F3FB-200D-1F9B1',non_qualified:null,image:'1f9d1-1f3fb-200d-1f9b1.png',sheet_x:47,sheet_y:20,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FC':{unified:'1F9D1-1F3FC-200D-1F9B1',non_qualified:null,image:'1f9d1-1f3fc-200d-1f9b1.png',sheet_x:47,sheet_y:21,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FD':{unified:'1F9D1-1F3FD-200D-1F9B1',non_qualified:null,image:'1f9d1-1f3fd-200d-1f9b1.png',sheet_x:47,sheet_y:22,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FE':{unified:'1F9D1-1F3FE-200D-1F9B1',non_qualified:null,image:'1f9d1-1f3fe-200d-1f9b1.png',sheet_x:47,sheet_y:23,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FF':{unified:'1F9D1-1F3FF-200D-1F9B1',non_qualified:null,image:'1f9d1-1f3ff-200d-1f9b1.png',sheet_x:47,sheet_y:24,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false}},a:'Curly Haired Person',b:'1F9D1-200D-1F9B1',k:[47,19],o:12},rice_ball:{a:'Rice Ball',b:'1F359',j:['food','japanese'],k:[6,49],o:2},hatched_chick:{a:'Front-Facing Baby Chick',b:'1F425',j:['animal','chicken','baby','bird'],k:[12,9],o:2},jigsaw:{a:'Jigsaw Puzzle Piece',b:'1F9E9',k:[51,28],o:11},trumpet:{a:'Trumpet',b:'1F3BA',j:['music','brass'],k:[8,32],o:2},slightly_frowning_face:{a:'Slightly Frowning Face',b:'1F641',j:['face','frowning','disappointed','sad','upset'],k:[31,43],o:2},bullettrain_side:{a:'High-Speed Train',b:'1F684',j:['transportation','vehicle'],k:[34,3],o:2},libra:{a:'Libra',b:'264E',j:['sign','purple-square','zodiac','astrology'],k:[53,26],o:2},de:{a:'Germany Flag',b:'1F1E9-1F1EA',j:['german','nation','flag','country','banner'],k:[1,32],n:['flag-de'],o:2},rice:{a:'Cooked Rice',b:'1F35A',j:['food','china','asian'],k:[6,50],o:2},violin:{a:'Violin',b:'1F3BB',j:['music','instrument','orchestra','symphony'],k:[8,33],o:2},white_haired_woman:{skin_variations:{'1F3FB':{unified:'1F469-1F3FB-200D-1F9B3',non_qualified:null,image:'1f469-1f3fb-200d-1f9b3.png',sheet_x:19,sheet_y:27,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F469-1F3FC-200D-1F9B3',non_qualified:null,image:'1f469-1f3fc-200d-1f9b3.png',sheet_x:19,sheet_y:28,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F469-1F3FD-200D-1F9B3',non_qualified:null,image:'1f469-1f3fd-200d-1f9b3.png',sheet_x:19,sheet_y:29,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F469-1F3FE-200D-1F9B3',non_qualified:null,image:'1f469-1f3fe-200d-1f9b3.png',sheet_x:19,sheet_y:30,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F469-1F3FF-200D-1F9B3',non_qualified:null,image:'1f469-1f3ff-200d-1f9b3.png',sheet_x:19,sheet_y:31,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'White Haired Woman',b:'1F469-200D-1F9B3',k:[19,26],o:11},bird:{a:'Bird',b:'1F426',j:['animal','nature','fly','tweet','spring'],k:[12,10],o:2},white_frowning_face:{a:'White Frowning Face',b:'2639-FE0F',c:'2639',k:[53,16],o:2},bullettrain_front:{a:'High-Speed Train with Bullet Nose',b:'1F685',j:['transportation','vehicle','speed','fast','public','travel'],k:[34,4],o:2},teddy_bear:{a:'Teddy Bear',b:'1F9F8',k:[51,43],o:11},white_haired_person:{skin_variations:{'1F3FB':{unified:'1F9D1-1F3FB-200D-1F9B3',non_qualified:null,image:'1f9d1-1f3fb-200d-1f9b3.png',sheet_x:47,sheet_y:32,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FC':{unified:'1F9D1-1F3FC-200D-1F9B3',non_qualified:null,image:'1f9d1-1f3fc-200d-1f9b3.png',sheet_x:47,sheet_y:33,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FD':{unified:'1F9D1-1F3FD-200D-1F9B3',non_qualified:null,image:'1f9d1-1f3fd-200d-1f9b3.png',sheet_x:47,sheet_y:34,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FE':{unified:'1F9D1-1F3FE-200D-1F9B3',non_qualified:null,image:'1f9d1-1f3fe-200d-1f9b3.png',sheet_x:47,sheet_y:35,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FF':{unified:'1F9D1-1F3FF-200D-1F9B3',non_qualified:null,image:'1f9d1-1f3ff-200d-1f9b3.png',sheet_x:47,sheet_y:36,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false}},a:'White Haired Person',b:'1F9D1-200D-1F9B3',k:[47,31],o:12},spades:{a:'Black Spade Suit',b:'2660-FE0F',c:'2660',j:['poker','cards','suits','magic'],k:[53,33],o:2},banjo:{a:'Banjo',b:'1FA95',k:[52,9],o:12},train2:{a:'Train',b:'1F686',j:['transportation','vehicle'],k:[34,5],o:2},scorpius:{a:'Scorpius',b:'264F',j:['sign','zodiac','purple-square','astrology','scorpio'],k:[53,27],o:2},curry:{a:'Curry and Rice',b:'1F35B',j:['food','spicy','hot','indian'],k:[6,51],o:2},open_mouth:{a:'Face with Open Mouth',b:'1F62E',j:['face','surprise','impressed','wow','whoa',':O'],k:[31,24],l:[':o',':-o',':O',':-O'],o:2},'flag-dg':{a:'Diego Garcia Flag',b:'1F1E9-1F1EC',k:[1,33],o:2},penguin:{a:'Penguin',b:'1F427',j:['animal','nature'],k:[12,11],o:2},hearts:{a:'Black Heart Suit',b:'2665-FE0F',c:'2665',j:['poker','cards','magic','suits'],k:[53,35],o:2},ramen:{a:'Steaming Bowl',b:'1F35C',j:['food','japanese','noodle','chopsticks'],k:[6,52],o:2},sagittarius:{a:'Sagittarius',b:'2650',j:['sign','zodiac','purple-square','astrology'],k:[53,28],o:2},bald_woman:{skin_variations:{'1F3FB':{unified:'1F469-1F3FB-200D-1F9B2',non_qualified:null,image:'1f469-1f3fb-200d-1f9b2.png',sheet_x:19,sheet_y:21,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F469-1F3FC-200D-1F9B2',non_qualified:null,image:'1f469-1f3fc-200d-1f9b2.png',sheet_x:19,sheet_y:22,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F469-1F3FD-200D-1F9B2',non_qualified:null,image:'1f469-1f3fd-200d-1f9b2.png',sheet_x:19,sheet_y:23,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F469-1F3FE-200D-1F9B2',non_qualified:null,image:'1f469-1f3fe-200d-1f9b2.png',sheet_x:19,sheet_y:24,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F469-1F3FF-200D-1F9B2',non_qualified:null,image:'1f469-1f3ff-200d-1f9b2.png',sheet_x:19,sheet_y:25,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Bald Woman',b:'1F469-200D-1F9B2',k:[19,20],o:11},dove_of_peace:{a:'Dove of Peace',b:'1F54A-FE0F',c:'1F54A',k:[28,34],o:2},hushed:{a:'Hushed Face',b:'1F62F',j:['face','woo','shh'],k:[31,25],o:2},metro:{a:'Metro',b:'1F687',j:['transportation','blue-square','mrt','underground','tube'],k:[34,6],o:2},'flag-dj':{a:'Djibouti Flag',b:'1F1E9-1F1EF',k:[1,34],o:2},drum_with_drumsticks:{a:'Drum with Drumsticks',b:'1F941',k:[41,17],o:4},spaghetti:{a:'Spaghetti',b:'1F35D',j:['food','italian','noodle'],k:[6,53],o:2},eagle:{a:'Eagle',b:'1F985',j:['animal','nature','bird'],k:[42,23],o:4},astonished:{a:'Astonished Face',b:'1F632',j:['face','xox','surprised','poisoned'],k:[31,28],o:2},capricorn:{a:'Capricorn',b:'2651',j:['sign','zodiac','purple-square','astrology'],k:[53,29],o:2},light_rail:{a:'Light Rail',b:'1F688',j:['transportation','vehicle'],k:[34,7],o:2},'flag-dk':{a:'Denmark Flag',b:'1F1E9-1F1F0',k:[1,35],o:2},iphone:{a:'Mobile Phone',b:'1F4F1',j:['technology','apple','gadgets','dial'],k:[27,14],o:2},bald_person:{skin_variations:{'1F3FB':{unified:'1F9D1-1F3FB-200D-1F9B2',non_qualified:null,image:'1f9d1-1f3fb-200d-1f9b2.png',sheet_x:47,sheet_y:26,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FC':{unified:'1F9D1-1F3FC-200D-1F9B2',non_qualified:null,image:'1f9d1-1f3fc-200d-1f9b2.png',sheet_x:47,sheet_y:27,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FD':{unified:'1F9D1-1F3FD-200D-1F9B2',non_qualified:null,image:'1f9d1-1f3fd-200d-1f9b2.png',sheet_x:47,sheet_y:28,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FE':{unified:'1F9D1-1F3FE-200D-1F9B2',non_qualified:null,image:'1f9d1-1f3fe-200d-1f9b2.png',sheet_x:47,sheet_y:29,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FF':{unified:'1F9D1-1F3FF-200D-1F9B2',non_qualified:null,image:'1f9d1-1f3ff-200d-1f9b2.png',sheet_x:47,sheet_y:30,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false}},a:'Bald Person',b:'1F9D1-200D-1F9B2',k:[47,25],o:12},diamonds:{a:'Black Diamond Suit',b:'2666-FE0F',c:'2666',j:['poker','cards','magic','suits'],k:[53,36],o:2},clubs:{a:'Black Club Suit',b:'2663-FE0F',c:'2663',j:['poker','cards','magic','suits'],k:[53,34],o:2},aquarius:{a:'Aquarius',b:'2652',j:['sign','purple-square','zodiac','astrology'],k:[53,30],o:2},sweet_potato:{a:'Roasted Sweet Potato',b:'1F360',j:['food','nature'],k:[6,56],o:2},'flag-dm':{a:'Dominica Flag',b:'1F1E9-1F1F2',k:[1,36],o:2},duck:{a:'Duck',b:'1F986',j:['animal','nature','bird','mallard'],k:[42,24],o:4},calling:{a:'Mobile Phone with Rightwards Arrow at Left',b:'1F4F2',j:['iphone','incoming'],k:[27,15],o:2},station:{a:'Station',b:'1F689',j:['transportation','vehicle','public'],k:[34,8],o:2},'blond-haired-woman':{skin_variations:{'1F3FB':{unified:'1F471-1F3FB-200D-2640-FE0F',non_qualified:'1F471-1F3FB-200D-2640',image:'1f471-1f3fb-200d-2640-fe0f.png',sheet_x:22,sheet_y:8,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F471-1F3FC-200D-2640-FE0F',non_qualified:'1F471-1F3FC-200D-2640',image:'1f471-1f3fc-200d-2640-fe0f.png',sheet_x:22,sheet_y:9,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F471-1F3FD-200D-2640-FE0F',non_qualified:'1F471-1F3FD-200D-2640',image:'1f471-1f3fd-200d-2640-fe0f.png',sheet_x:22,sheet_y:10,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F471-1F3FE-200D-2640-FE0F',non_qualified:'1F471-1F3FE-200D-2640',image:'1f471-1f3fe-200d-2640-fe0f.png',sheet_x:22,sheet_y:11,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F471-1F3FF-200D-2640-FE0F',non_qualified:'1F471-1F3FF-200D-2640',image:'1f471-1f3ff-200d-2640-fe0f.png',sheet_x:22,sheet_y:12,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Blond Haired Woman',b:'1F471-200D-2640-FE0F',c:'1F471-200D-2640',k:[22,7],o:4},flushed:{a:'Flushed Face',b:'1F633',j:['face','blush','shy','flattered'],k:[31,29],o:2},pisces:{a:'Pisces',b:'2653',j:['purple-square','sign','zodiac','astrology'],k:[53,31],o:2},chess_pawn:{a:'Chess Pawn',b:'265F-FE0F',c:'265F',k:[53,32],o:11},'blond-haired-man':{skin_variations:{'1F3FB':{unified:'1F471-1F3FB-200D-2642-FE0F',non_qualified:'1F471-1F3FB-200D-2642',image:'1f471-1f3fb-200d-2642-fe0f.png',sheet_x:22,sheet_y:14,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F471-1F3FC-200D-2642-FE0F',non_qualified:'1F471-1F3FC-200D-2642',image:'1f471-1f3fc-200d-2642-fe0f.png',sheet_x:22,sheet_y:15,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F471-1F3FD-200D-2642-FE0F',non_qualified:'1F471-1F3FD-200D-2642',image:'1f471-1f3fd-200d-2642-fe0f.png',sheet_x:22,sheet_y:16,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F471-1F3FE-200D-2642-FE0F',non_qualified:'1F471-1F3FE-200D-2642',image:'1f471-1f3fe-200d-2642-fe0f.png',sheet_x:22,sheet_y:17,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F471-1F3FF-200D-2642-FE0F',non_qualified:'1F471-1F3FF-200D-2642',image:'1f471-1f3ff-200d-2642-fe0f.png',sheet_x:22,sheet_y:18,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},obsoletes:'1F471',a:'Blond Haired Man',b:'1F471-200D-2642-FE0F',c:'1F471-200D-2642',k:[22,13],o:4},phone:{a:'Black Telephone',b:'260E-FE0F',c:'260E',j:['technology','communication','dial','telephone'],k:[52,54],n:['telephone'],o:2},oden:{a:'Oden',b:'1F362',j:['food','japanese'],k:[7,1],o:2},'flag-do':{a:'Dominican Republic Flag',b:'1F1E9-1F1F4',k:[1,37],o:2},tram:{a:'Tram',b:'1F68A',j:['transportation','vehicle'],k:[34,9],o:2},swan:{a:'Swan',b:'1F9A2',k:[42,52],o:11},pleading_face:{a:'Face with Pleading Eyes',b:'1F97A',k:[42,12],o:11},'flag-dz':{a:'Algeria Flag',b:'1F1E9-1F1FF',k:[1,38],o:2},monorail:{a:'Monorail',b:'1F69D',j:['transportation','vehicle'],k:[34,28],o:2},owl:{a:'Owl',b:'1F989',j:['animal','nature','bird','hoot'],k:[42,27],o:4},sushi:{a:'Sushi',b:'1F363',j:['food','fish','japanese','rice'],k:[7,2],o:2},telephone_receiver:{a:'Telephone Receiver',b:'1F4DE',j:['technology','communication','dial'],k:[26,52],o:2},black_joker:{a:'Playing Card Black Joker',b:'1F0CF',j:['poker','cards','game','play','magic'],k:[0,15],o:2},ophiuchus:{a:'Ophiuchus',b:'26CE',j:['sign','purple-square','constellation','astrology'],k:[54,4],o:2},frowning:{a:'Frowning Face with Open Mouth',b:'1F626',j:['face','aw','what'],k:[31,16],o:2},older_adult:{skin_variations:{'1F3FB':{unified:'1F9D3-1F3FB',non_qualified:null,image:'1f9d3-1f3fb.png',sheet_x:48,sheet_y:23,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9D3-1F3FC',non_qualified:null,image:'1f9d3-1f3fc.png',sheet_x:48,sheet_y:24,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9D3-1F3FD',non_qualified:null,image:'1f9d3-1f3fd.png',sheet_x:48,sheet_y:25,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9D3-1F3FE',non_qualified:null,image:'1f9d3-1f3fe.png',sheet_x:48,sheet_y:26,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9D3-1F3FF',non_qualified:null,image:'1f9d3-1f3ff.png',sheet_x:48,sheet_y:27,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Older Adult',b:'1F9D3',j:['human','elder','senior','gender-neutral'],k:[48,22],o:5},'flag-ea':{a:'Ceuta & Melilla Flag',b:'1F1EA-1F1E6',k:[1,39],o:2},flamingo:{a:'Flamingo',b:'1F9A9',k:[43,0],o:12},pager:{a:'Pager',b:'1F4DF',j:['bbcall','oldschool','90s'],k:[26,53],o:2},mountain_railway:{a:'Mountain Railway',b:'1F69E',j:['transportation','vehicle'],k:[34,29],o:2},mahjong:{a:'Mahjong Tile Red Dragon',b:'1F004',j:['game','play','chinese','kanji'],k:[0,14],o:2},older_man:{skin_variations:{'1F3FB':{unified:'1F474-1F3FB',non_qualified:null,image:'1f474-1f3fb.png',sheet_x:22,sheet_y:50,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F474-1F3FC',non_qualified:null,image:'1f474-1f3fc.png',sheet_x:22,sheet_y:51,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F474-1F3FD',non_qualified:null,image:'1f474-1f3fd.png',sheet_x:22,sheet_y:52,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F474-1F3FE',non_qualified:null,image:'1f474-1f3fe.png',sheet_x:22,sheet_y:53,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F474-1F3FF',non_qualified:null,image:'1f474-1f3ff.png',sheet_x:22,sheet_y:54,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Older Man',b:'1F474',j:['human','male','men','old','elder','senior'],k:[22,49],o:2},twisted_rightwards_arrows:{a:'Twisted Rightwards Arrows',b:'1F500',j:['blue-square','shuffle','music','random'],k:[27,28],o:2},fried_shrimp:{a:'Fried Shrimp',b:'1F364',j:['food','animal','appetizer','summer'],k:[7,3],o:2},anguished:{a:'Anguished Face',b:'1F627',j:['face','stunned','nervous'],k:[31,17],l:['D:'],o:2},repeat:{a:'Clockwise Rightwards and Leftwards Open Circle Arrows',b:'1F501',j:['loop','record'],k:[27,29],o:2},fish_cake:{a:'Fish Cake with Swirl Design',b:'1F365',j:['food','japan','sea','beach','narutomaki','pink','swirl','kamaboko','surimi','ramen'],k:[7,4],o:2},fax:{a:'Fax Machine',b:'1F4E0',j:['communication','technology'],k:[26,54],o:2},older_woman:{skin_variations:{'1F3FB':{unified:'1F475-1F3FB',non_qualified:null,image:'1f475-1f3fb.png',sheet_x:22,sheet_y:56,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F475-1F3FC',non_qualified:null,image:'1f475-1f3fc.png',sheet_x:23,sheet_y:0,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F475-1F3FD',non_qualified:null,image:'1f475-1f3fd.png',sheet_x:23,sheet_y:1,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F475-1F3FE',non_qualified:null,image:'1f475-1f3fe.png',sheet_x:23,sheet_y:2,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F475-1F3FF',non_qualified:null,image:'1f475-1f3ff.png',sheet_x:23,sheet_y:3,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Older Woman',b:'1F475',j:['human','female','women','lady','old','elder','senior'],k:[22,55],o:2},'flag-ec':{a:'Ecuador Flag',b:'1F1EA-1F1E8',k:[1,40],o:2},peacock:{a:'Peacock',b:'1F99A',k:[42,44],o:11},fearful:{a:'Fearful Face',b:'1F628',j:['face','scared','terrified','nervous','oops','huh'],k:[31,18],o:2},train:{a:'Tram Car',b:'1F68B',j:['transportation','vehicle','carriage','public','travel'],k:[34,10],o:2},flower_playing_cards:{a:'Flower Playing Cards',b:'1F3B4',j:['game','sunset','red'],k:[8,26],o:2},repeat_one:{a:'Clockwise Rightwards and Leftwards Open Circle Arrows with Circled One Overlay',b:'1F502',j:['blue-square','loop'],k:[27,30],o:2},moon_cake:{a:'Moon Cake',b:'1F96E',k:[42,4],o:11},performing_arts:{a:'Performing Arts',b:'1F3AD',j:['acting','theater','drama'],k:[8,19],o:2},cold_sweat:{a:'Face with Open Mouth and Cold Sweat',b:'1F630',j:['face','nervous','sweat'],k:[31,26],o:2},person_frowning:{skin_variations:{'1F3FB':{unified:'1F64D-1F3FB',non_qualified:null,image:'1f64d-1f3fb.png',sheet_x:33,sheet_y:27,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F64D-1F3FC',non_qualified:null,image:'1f64d-1f3fc.png',sheet_x:33,sheet_y:28,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F64D-1F3FD',non_qualified:null,image:'1f64d-1f3fd.png',sheet_x:33,sheet_y:29,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F64D-1F3FE',non_qualified:null,image:'1f64d-1f3fe.png',sheet_x:33,sheet_y:30,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F64D-1F3FF',non_qualified:null,image:'1f64d-1f3ff.png',sheet_x:33,sheet_y:31,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},obsoleted_by:'1F64D-200D-2640-FE0F',a:'Person Frowning',b:'1F64D',k:[33,26],o:2},'flag-ee':{a:'Estonia Flag',b:'1F1EA-1F1EA',k:[1,41],o:2},battery:{a:'Battery',b:'1F50B',j:['power','energy','sustain'],k:[27,39],o:2},parrot:{a:'Parrot',b:'1F99C',k:[42,46],o:11},bus:{a:'Bus',b:'1F68C',j:['car','vehicle','transportation'],k:[34,11],o:2},'flag-eg':{a:'Egypt Flag',b:'1F1EA-1F1EC',k:[1,42],o:2},arrow_forward:{a:'Black Right-Pointing Triangle',b:'25B6-FE0F',c:'25B6',j:['blue-square','right','direction','play'],k:[52,43],o:2},'man-frowning':{skin_variations:{'1F3FB':{unified:'1F64D-1F3FB-200D-2642-FE0F',non_qualified:'1F64D-1F3FB-200D-2642',image:'1f64d-1f3fb-200d-2642-fe0f.png',sheet_x:33,sheet_y:21,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F64D-1F3FC-200D-2642-FE0F',non_qualified:'1F64D-1F3FC-200D-2642',image:'1f64d-1f3fc-200d-2642-fe0f.png',sheet_x:33,sheet_y:22,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F64D-1F3FD-200D-2642-FE0F',non_qualified:'1F64D-1F3FD-200D-2642',image:'1f64d-1f3fd-200d-2642-fe0f.png',sheet_x:33,sheet_y:23,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F64D-1F3FE-200D-2642-FE0F',non_qualified:'1F64D-1F3FE-200D-2642',image:'1f64d-1f3fe-200d-2642-fe0f.png',sheet_x:33,sheet_y:24,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F64D-1F3FF-200D-2642-FE0F',non_qualified:'1F64D-1F3FF-200D-2642',image:'1f64d-1f3ff-200d-2642-fe0f.png',sheet_x:33,sheet_y:25,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man Frowning',b:'1F64D-200D-2642-FE0F',c:'1F64D-200D-2642',k:[33,20],o:4},disappointed_relieved:{a:'Disappointed but Relieved Face',b:'1F625',j:['face','phew','sweat','nervous'],k:[31,15],o:2},electric_plug:{a:'Electric Plug',b:'1F50C',j:['charger','power'],k:[27,40],o:2},frame_with_picture:{a:'Frame with Picture',b:'1F5BC-FE0F',c:'1F5BC',k:[30,14],o:2},oncoming_bus:{a:'Oncoming Bus',b:'1F68D',j:['vehicle','transportation'],k:[34,12],o:2},dango:{a:'Dango',b:'1F361',j:['food','dessert','sweet','japanese','barbecue','meat'],k:[7,0],o:2},frog:{a:'Frog Face',b:'1F438',j:['animal','nature','croak','toad'],k:[12,28],o:2},computer:{a:'Personal Computer',b:'1F4BB',j:['technology','laptop','screen','display','monitor'],k:[26,17],o:2},art:{a:'Artist Palette',b:'1F3A8',j:['design','paint','draw','colors'],k:[8,14],o:2},'flag-eh':{a:'Western Sahara Flag',b:'1F1EA-1F1ED',k:[1,43],o:2},fast_forward:{a:'Black Right-Pointing Double Triangle',b:'23E9',j:['blue-square','play','speed','continue'],k:[52,26],o:2},cry:{a:'Crying Face',b:'1F622',j:['face','tears','sad','depressed','upset',":'("],k:[31,12],l:[":'("],m:":'(",o:2},'woman-frowning':{skin_variations:{'1F3FB':{unified:'1F64D-1F3FB-200D-2640-FE0F',non_qualified:'1F64D-1F3FB-200D-2640',image:'1f64d-1f3fb-200d-2640-fe0f.png',sheet_x:33,sheet_y:15,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F64D-1F3FC-200D-2640-FE0F',non_qualified:'1F64D-1F3FC-200D-2640',image:'1f64d-1f3fc-200d-2640-fe0f.png',sheet_x:33,sheet_y:16,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F64D-1F3FD-200D-2640-FE0F',non_qualified:'1F64D-1F3FD-200D-2640',image:'1f64d-1f3fd-200d-2640-fe0f.png',sheet_x:33,sheet_y:17,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F64D-1F3FE-200D-2640-FE0F',non_qualified:'1F64D-1F3FE-200D-2640',image:'1f64d-1f3fe-200d-2640-fe0f.png',sheet_x:33,sheet_y:18,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F64D-1F3FF-200D-2640-FE0F',non_qualified:'1F64D-1F3FF-200D-2640',image:'1f64d-1f3ff-200d-2640-fe0f.png',sheet_x:33,sheet_y:19,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},obsoletes:'1F64D',a:'Woman Frowning',b:'1F64D-200D-2640-FE0F',c:'1F64D-200D-2640',k:[33,14],o:4},trolleybus:{a:'Trolleybus',b:'1F68E',j:['bart','transportation','vehicle'],k:[34,13],o:2},crocodile:{a:'Crocodile',b:'1F40A',j:['animal','nature','reptile','lizard','alligator'],k:[11,38],o:2},dumpling:{a:'Dumpling',b:'1F95F',j:['food','empanada','pierogi','potsticker'],k:[41,46],o:5},black_right_pointing_double_triangle_with_vertical_bar:{a:'Black Right Pointing Double Triangle with Vertical Bar',b:'23ED-FE0F',c:'23ED',k:[52,30],o:2},desktop_computer:{a:'Desktop Computer',b:'1F5A5-FE0F',c:'1F5A5',j:['technology','computing','screen'],k:[30,10],o:2},person_with_pouting_face:{skin_variations:{'1F3FB':{unified:'1F64E-1F3FB',non_qualified:null,image:'1f64e-1f3fb.png',sheet_x:33,sheet_y:45,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F64E-1F3FC',non_qualified:null,image:'1f64e-1f3fc.png',sheet_x:33,sheet_y:46,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F64E-1F3FD',non_qualified:null,image:'1f64e-1f3fd.png',sheet_x:33,sheet_y:47,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F64E-1F3FE',non_qualified:null,image:'1f64e-1f3fe.png',sheet_x:33,sheet_y:48,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F64E-1F3FF',non_qualified:null,image:'1f64e-1f3ff.png',sheet_x:33,sheet_y:49,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},obsoleted_by:'1F64E-200D-2640-FE0F',a:'Person with Pouting Face',b:'1F64E',k:[33,44],o:2},turtle:{a:'Turtle',b:'1F422',j:['animal','slow','nature','tortoise'],k:[12,6],o:2},sob:{a:'Loudly Crying Face',b:'1F62D',j:['face','cry','tears','sad','upset','depressed'],k:[31,23],m:":'(",o:2},'flag-er':{a:'Eritrea Flag',b:'1F1EA-1F1F7',k:[1,44],o:2},thread:{a:'Spool of Thread',b:'1F9F5',k:[51,40],o:11},minibus:{a:'Minibus',b:'1F690',j:['vehicle','car','transportation'],k:[34,15],o:2},fortune_cookie:{a:'Fortune Cookie',b:'1F960',j:['food','prophecy'],k:[41,47],o:5},yarn:{a:'Ball of Yarn',b:'1F9F6',k:[51,41],o:11},takeout_box:{a:'Takeout Box',b:'1F961',j:['food','leftovers'],k:[41,48],o:5},'man-pouting':{skin_variations:{'1F3FB':{unified:'1F64E-1F3FB-200D-2642-FE0F',non_qualified:'1F64E-1F3FB-200D-2642',image:'1f64e-1f3fb-200d-2642-fe0f.png',sheet_x:33,sheet_y:39,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F64E-1F3FC-200D-2642-FE0F',non_qualified:'1F64E-1F3FC-200D-2642',image:'1f64e-1f3fc-200d-2642-fe0f.png',sheet_x:33,sheet_y:40,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F64E-1F3FD-200D-2642-FE0F',non_qualified:'1F64E-1F3FD-200D-2642',image:'1f64e-1f3fd-200d-2642-fe0f.png',sheet_x:33,sheet_y:41,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F64E-1F3FE-200D-2642-FE0F',non_qualified:'1F64E-1F3FE-200D-2642',image:'1f64e-1f3fe-200d-2642-fe0f.png',sheet_x:33,sheet_y:42,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F64E-1F3FF-200D-2642-FE0F',non_qualified:'1F64E-1F3FF-200D-2642',image:'1f64e-1f3ff-200d-2642-fe0f.png',sheet_x:33,sheet_y:43,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man Pouting',b:'1F64E-200D-2642-FE0F',c:'1F64E-200D-2642',k:[33,38],o:4},printer:{a:'Printer',b:'1F5A8-FE0F',c:'1F5A8',j:['paper','ink'],k:[30,11],o:2},scream:{a:'Face Screaming in Fear',b:'1F631',j:['face','munch','scared','omg'],k:[31,27],o:2},es:{a:'Spain Flag',b:'1F1EA-1F1F8',j:['spain','flag','nation','country','banner'],k:[1,45],n:['flag-es'],o:2},ambulance:{a:'Ambulance',b:'1F691',j:['health','911','hospital'],k:[34,16],o:2},black_right_pointing_triangle_with_double_vertical_bar:{a:'Black Right Pointing Triangle with Double Vertical Bar',b:'23EF-FE0F',c:'23EF',k:[52,32],o:2},lizard:{a:'Lizard',b:'1F98E',j:['animal','nature','reptile'],k:[42,32],o:4},'flag-et':{a:'Ethiopia Flag',b:'1F1EA-1F1F9',k:[1,46],o:2},keyboard:{a:'Keyboard',b:'2328-FE0F',c:'2328',j:['technology','computer','type','input','text'],k:[52,24],o:2},crab:{a:'Crab',b:'1F980',j:['animal','crustacean'],k:[42,18],o:2},confounded:{a:'Confounded Face',b:'1F616',j:['face','confused','sick','unwell','oops',':S'],k:[31,0],o:2},snake:{a:'Snake',b:'1F40D',j:['animal','evil','nature','hiss','python'],k:[11,41],o:2},'woman-pouting':{skin_variations:{'1F3FB':{unified:'1F64E-1F3FB-200D-2640-FE0F',non_qualified:'1F64E-1F3FB-200D-2640',image:'1f64e-1f3fb-200d-2640-fe0f.png',sheet_x:33,sheet_y:33,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F64E-1F3FC-200D-2640-FE0F',non_qualified:'1F64E-1F3FC-200D-2640',image:'1f64e-1f3fc-200d-2640-fe0f.png',sheet_x:33,sheet_y:34,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F64E-1F3FD-200D-2640-FE0F',non_qualified:'1F64E-1F3FD-200D-2640',image:'1f64e-1f3fd-200d-2640-fe0f.png',sheet_x:33,sheet_y:35,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F64E-1F3FE-200D-2640-FE0F',non_qualified:'1F64E-1F3FE-200D-2640',image:'1f64e-1f3fe-200d-2640-fe0f.png',sheet_x:33,sheet_y:36,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F64E-1F3FF-200D-2640-FE0F',non_qualified:'1F64E-1F3FF-200D-2640',image:'1f64e-1f3ff-200d-2640-fe0f.png',sheet_x:33,sheet_y:37,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},obsoletes:'1F64E',a:'Woman Pouting',b:'1F64E-200D-2640-FE0F',c:'1F64E-200D-2640',k:[33,32],o:4},arrow_backward:{a:'Black Left-Pointing Triangle',b:'25C0-FE0F',c:'25C0',j:['blue-square','left','direction'],k:[52,44],o:2},fire_engine:{a:'Fire Engine',b:'1F692',j:['transportation','cars','vehicle'],k:[34,17],o:2},rewind:{a:'Black Left-Pointing Double Triangle',b:'23EA',j:['play','blue-square'],k:[52,27],o:2},three_button_mouse:{a:'Three Button Mouse',b:'1F5B1-FE0F',c:'1F5B1',k:[30,12],o:2},no_good:{skin_variations:{'1F3FB':{unified:'1F645-1F3FB',non_qualified:null,image:'1f645-1f3fb.png',sheet_x:32,sheet_y:3,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F645-1F3FC',non_qualified:null,image:'1f645-1f3fc.png',sheet_x:32,sheet_y:4,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F645-1F3FD',non_qualified:null,image:'1f645-1f3fd.png',sheet_x:32,sheet_y:5,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F645-1F3FE',non_qualified:null,image:'1f645-1f3fe.png',sheet_x:32,sheet_y:6,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F645-1F3FF',non_qualified:null,image:'1f645-1f3ff.png',sheet_x:32,sheet_y:7,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},obsoleted_by:'1F645-200D-2640-FE0F',a:'Face with No Good Gesture',b:'1F645',k:[32,2],o:2},police_car:{a:'Police Car',b:'1F693',j:['vehicle','cars','transportation','law','legal','enforcement'],k:[34,18],o:2},dragon_face:{a:'Dragon Face',b:'1F432',j:['animal','myth','nature','chinese','green'],k:[12,22],o:2},persevere:{a:'Persevering Face',b:'1F623',j:['face','sick','no','upset','oops'],k:[31,13],o:2},lobster:{a:'Lobster',b:'1F99E',k:[42,48],o:11},'flag-eu':{a:'European Union Flag',b:'1F1EA-1F1FA',k:[1,47],o:2},disappointed:{a:'Disappointed Face',b:'1F61E',j:['face','sad','upset','depressed',':('],k:[31,8],l:['):',':(',':-('],m:':(',o:2},shrimp:{a:'Shrimp',b:'1F990',j:['animal','ocean','nature','seafood'],k:[42,34],o:4},dragon:{a:'Dragon',b:'1F409',j:['animal','myth','nature','chinese','green'],k:[11,37],o:2},'man-gesturing-no':{skin_variations:{'1F3FB':{unified:'1F645-1F3FB-200D-2642-FE0F',non_qualified:'1F645-1F3FB-200D-2642',image:'1f645-1f3fb-200d-2642-fe0f.png',sheet_x:31,sheet_y:54,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F645-1F3FC-200D-2642-FE0F',non_qualified:'1F645-1F3FC-200D-2642',image:'1f645-1f3fc-200d-2642-fe0f.png',sheet_x:31,sheet_y:55,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F645-1F3FD-200D-2642-FE0F',non_qualified:'1F645-1F3FD-200D-2642',image:'1f645-1f3fd-200d-2642-fe0f.png',sheet_x:31,sheet_y:56,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F645-1F3FE-200D-2642-FE0F',non_qualified:'1F645-1F3FE-200D-2642',image:'1f645-1f3fe-200d-2642-fe0f.png',sheet_x:32,sheet_y:0,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F645-1F3FF-200D-2642-FE0F',non_qualified:'1F645-1F3FF-200D-2642',image:'1f645-1f3ff-200d-2642-fe0f.png',sheet_x:32,sheet_y:1,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man Gesturing No',b:'1F645-200D-2642-FE0F',c:'1F645-200D-2642',k:[31,53],o:4},'flag-fi':{a:'Finland Flag',b:'1F1EB-1F1EE',k:[1,48],o:2},trackball:{a:'Trackball',b:'1F5B2-FE0F',c:'1F5B2',j:['technology','trackpad'],k:[30,13],o:2},black_left_pointing_double_triangle_with_vertical_bar:{a:'Black Left Pointing Double Triangle with Vertical Bar',b:'23EE-FE0F',c:'23EE',k:[52,31],o:2},oncoming_police_car:{a:'Oncoming Police Car',b:'1F694',j:['vehicle','law','legal','enforcement','911'],k:[34,19],o:2},minidisc:{a:'Minidisc',b:'1F4BD',j:['technology','record','data','disk','90s'],k:[26,19],o:2},sweat:{a:'Face with Cold Sweat',b:'1F613',j:['face','hot','sad','tired','exercise'],k:[30,54],o:2},squid:{a:'Squid',b:'1F991',j:['animal','nature','ocean','sea'],k:[42,35],o:4},sauropod:{a:'Sauropod',b:'1F995',j:['animal','nature','dinosaur','brachiosaurus','brontosaurus','diplodocus','extinct'],k:[42,39],o:5},arrow_up_small:{a:'Up-Pointing Small Red Triangle',b:'1F53C',j:['blue-square','triangle','direction','point','forward','top'],k:[28,31],o:2},'flag-fj':{a:'Fiji Flag',b:'1F1EB-1F1EF',k:[1,49],o:2},'woman-gesturing-no':{skin_variations:{'1F3FB':{unified:'1F645-1F3FB-200D-2640-FE0F',non_qualified:'1F645-1F3FB-200D-2640',image:'1f645-1f3fb-200d-2640-fe0f.png',sheet_x:31,sheet_y:48,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F645-1F3FC-200D-2640-FE0F',non_qualified:'1F645-1F3FC-200D-2640',image:'1f645-1f3fc-200d-2640-fe0f.png',sheet_x:31,sheet_y:49,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F645-1F3FD-200D-2640-FE0F',non_qualified:'1F645-1F3FD-200D-2640',image:'1f645-1f3fd-200d-2640-fe0f.png',sheet_x:31,sheet_y:50,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F645-1F3FE-200D-2640-FE0F',non_qualified:'1F645-1F3FE-200D-2640',image:'1f645-1f3fe-200d-2640-fe0f.png',sheet_x:31,sheet_y:51,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F645-1F3FF-200D-2640-FE0F',non_qualified:'1F645-1F3FF-200D-2640',image:'1f645-1f3ff-200d-2640-fe0f.png',sheet_x:31,sheet_y:52,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},obsoletes:'1F645',a:'Woman Gesturing No',b:'1F645-200D-2640-FE0F',c:'1F645-200D-2640',k:[31,47],o:4},taxi:{a:'Taxi',b:'1F695',j:['uber','vehicle','cars','transportation'],k:[34,20],o:2},'flag-fk':{a:'Falkland Islands Flag',b:'1F1EB-1F1F0',k:[1,50],o:2},floppy_disk:{a:'Floppy Disk',b:'1F4BE',j:['oldschool','technology','save','90s','80s'],k:[26,20],o:2},'t-rex':{a:'T-Rex',b:'1F996',j:['animal','nature','dinosaur','tyrannosaurus','extinct'],k:[42,40],o:5},oyster:{a:'Oyster',b:'1F9AA',k:[43,1],o:12},arrow_double_up:{a:'Black Up-Pointing Double Triangle',b:'23EB',j:['blue-square','direction','top'],k:[52,28],o:2},oncoming_taxi:{a:'Oncoming Taxi',b:'1F696',j:['vehicle','cars','uber'],k:[34,21],o:2},ok_woman:{skin_variations:{'1F3FB':{unified:'1F646-1F3FB',non_qualified:null,image:'1f646-1f3fb.png',sheet_x:32,sheet_y:21,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F646-1F3FC',non_qualified:null,image:'1f646-1f3fc.png',sheet_x:32,sheet_y:22,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F646-1F3FD',non_qualified:null,image:'1f646-1f3fd.png',sheet_x:32,sheet_y:23,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F646-1F3FE',non_qualified:null,image:'1f646-1f3fe.png',sheet_x:32,sheet_y:24,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F646-1F3FF',non_qualified:null,image:'1f646-1f3ff.png',sheet_x:32,sheet_y:25,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},obsoleted_by:'1F646-200D-2640-FE0F',a:'Face with Ok Gesture',b:'1F646',j:['women','girl','female','pink','human','woman'],k:[32,20],o:2},weary:{a:'Weary Face',b:'1F629',j:['face','tired','sleepy','sad','frustrated','upset'],k:[31,19],o:2},'man-gesturing-ok':{skin_variations:{'1F3FB':{unified:'1F646-1F3FB-200D-2642-FE0F',non_qualified:'1F646-1F3FB-200D-2642',image:'1f646-1f3fb-200d-2642-fe0f.png',sheet_x:32,sheet_y:15,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F646-1F3FC-200D-2642-FE0F',non_qualified:'1F646-1F3FC-200D-2642',image:'1f646-1f3fc-200d-2642-fe0f.png',sheet_x:32,sheet_y:16,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F646-1F3FD-200D-2642-FE0F',non_qualified:'1F646-1F3FD-200D-2642',image:'1f646-1f3fd-200d-2642-fe0f.png',sheet_x:32,sheet_y:17,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F646-1F3FE-200D-2642-FE0F',non_qualified:'1F646-1F3FE-200D-2642',image:'1f646-1f3fe-200d-2642-fe0f.png',sheet_x:32,sheet_y:18,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F646-1F3FF-200D-2642-FE0F',non_qualified:'1F646-1F3FF-200D-2642',image:'1f646-1f3ff-200d-2642-fe0f.png',sheet_x:32,sheet_y:19,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man Gesturing Ok',b:'1F646-200D-2642-FE0F',c:'1F646-200D-2642',k:[32,14],o:4},arrow_down_small:{a:'Down-Pointing Small Red Triangle',b:'1F53D',j:['blue-square','direction','bottom'],k:[28,32],o:2},tired_face:{a:'Tired Face',b:'1F62B',j:['sick','whine','upset','frustrated'],k:[31,21],o:2},car:{a:'Automobile',b:'1F697',k:[34,22],n:['red_car'],o:2},icecream:{a:'Soft Ice Cream',b:'1F366',j:['food','hot','dessert','summer'],k:[7,5],o:2},cd:{a:'Optical Disc',b:'1F4BF',j:['technology','dvd','disk','disc','90s'],k:[26,21],o:2},whale:{a:'Spouting Whale',b:'1F433',j:['animal','nature','sea','ocean'],k:[12,23],o:2},'flag-fm':{a:'Micronesia Flag',b:'1F1EB-1F1F2',k:[1,51],o:2},oncoming_automobile:{a:'Oncoming Automobile',b:'1F698',j:['car','vehicle','transportation'],k:[34,23],o:2},arrow_double_down:{a:'Black Down-Pointing Double Triangle',b:'23EC',j:['blue-square','direction','bottom'],k:[52,29],o:2},'woman-gesturing-ok':{skin_variations:{'1F3FB':{unified:'1F646-1F3FB-200D-2640-FE0F',non_qualified:'1F646-1F3FB-200D-2640',image:'1f646-1f3fb-200d-2640-fe0f.png',sheet_x:32,sheet_y:9,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F646-1F3FC-200D-2640-FE0F',non_qualified:'1F646-1F3FC-200D-2640',image:'1f646-1f3fc-200d-2640-fe0f.png',sheet_x:32,sheet_y:10,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F646-1F3FD-200D-2640-FE0F',non_qualified:'1F646-1F3FD-200D-2640',image:'1f646-1f3fd-200d-2640-fe0f.png',sheet_x:32,sheet_y:11,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F646-1F3FE-200D-2640-FE0F',non_qualified:'1F646-1F3FE-200D-2640',image:'1f646-1f3fe-200d-2640-fe0f.png',sheet_x:32,sheet_y:12,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F646-1F3FF-200D-2640-FE0F',non_qualified:'1F646-1F3FF-200D-2640',image:'1f646-1f3ff-200d-2640-fe0f.png',sheet_x:32,sheet_y:13,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},obsoletes:'1F646',a:'Woman Gesturing Ok',b:'1F646-200D-2640-FE0F',c:'1F646-200D-2640',k:[32,8],o:4},yawning_face:{a:'Yawning Face',b:'1F971',k:[42,7],o:12},dvd:{a:'Dvd',b:'1F4C0',j:['cd','disk','disc'],k:[26,22],o:2},whale2:{a:'Whale',b:'1F40B',j:['animal','nature','sea','ocean'],k:[11,39],o:2},'flag-fo':{a:'Faroe Islands Flag',b:'1F1EB-1F1F4',k:[1,52],o:2},shaved_ice:{a:'Shaved Ice',b:'1F367',j:['hot','dessert','summer'],k:[7,6],o:2},double_vertical_bar:{a:'Double Vertical Bar',b:'23F8-FE0F',c:'23F8',k:[52,37],o:2},information_desk_person:{skin_variations:{'1F3FB':{unified:'1F481-1F3FB',non_qualified:null,image:'1f481-1f3fb.png',sheet_x:24,sheet_y:3,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F481-1F3FC',non_qualified:null,image:'1f481-1f3fc.png',sheet_x:24,sheet_y:4,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F481-1F3FD',non_qualified:null,image:'1f481-1f3fd.png',sheet_x:24,sheet_y:5,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F481-1F3FE',non_qualified:null,image:'1f481-1f3fe.png',sheet_x:24,sheet_y:6,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F481-1F3FF',non_qualified:null,image:'1f481-1f3ff.png',sheet_x:24,sheet_y:7,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},obsoleted_by:'1F481-200D-2640-FE0F',a:'Information Desk Person',b:'1F481',k:[24,2],o:2},dolphin:{a:'Dolphin',b:'1F42C',j:['animal','nature','fish','sea','ocean','flipper','fins','beach'],k:[12,16],n:['flipper'],o:2},blue_car:{a:'Recreational Vehicle',b:'1F699',j:['transportation','vehicle'],k:[34,24],o:2},ice_cream:{a:'Ice Cream',b:'1F368',j:['food','hot','dessert'],k:[7,7],o:2},fr:{a:'France Flag',b:'1F1EB-1F1F7',j:['banner','flag','nation','france','french','country'],k:[1,53],n:['flag-fr'],o:2},triumph:{a:'Face with Look of Triumph',b:'1F624',j:['face','gas','phew','proud','pride'],k:[31,14],o:2},abacus:{a:'Abacus',b:'1F9EE',k:[51,33],o:11},'man-tipping-hand':{skin_variations:{'1F3FB':{unified:'1F481-1F3FB-200D-2642-FE0F',non_qualified:'1F481-1F3FB-200D-2642',image:'1f481-1f3fb-200d-2642-fe0f.png',sheet_x:23,sheet_y:54,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F481-1F3FC-200D-2642-FE0F',non_qualified:'1F481-1F3FC-200D-2642',image:'1f481-1f3fc-200d-2642-fe0f.png',sheet_x:23,sheet_y:55,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F481-1F3FD-200D-2642-FE0F',non_qualified:'1F481-1F3FD-200D-2642',image:'1f481-1f3fd-200d-2642-fe0f.png',sheet_x:23,sheet_y:56,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F481-1F3FE-200D-2642-FE0F',non_qualified:'1F481-1F3FE-200D-2642',image:'1f481-1f3fe-200d-2642-fe0f.png',sheet_x:24,sheet_y:0,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F481-1F3FF-200D-2642-FE0F',non_qualified:'1F481-1F3FF-200D-2642',image:'1f481-1f3ff-200d-2642-fe0f.png',sheet_x:24,sheet_y:1,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man Tipping Hand',b:'1F481-200D-2642-FE0F',c:'1F481-200D-2642',k:[23,53],o:4},doughnut:{a:'Doughnut',b:'1F369',j:['food','dessert','snack','sweet','donut'],k:[7,8],o:2},fish:{a:'Fish',b:'1F41F',j:['animal','food','nature'],k:[12,3],o:2},truck:{a:'Delivery Truck',b:'1F69A',j:['cars','transportation'],k:[34,25],o:2},movie_camera:{a:'Movie Camera',b:'1F3A5',j:['film','record'],k:[8,11],o:2},'flag-ga':{a:'Gabon Flag',b:'1F1EC-1F1E6',k:[1,54],o:2},rage:{a:'Pouting Face',b:'1F621',j:['angry','mad','hate','despise'],k:[31,11],o:2},black_square_for_stop:{a:'Black Square for Stop',b:'23F9-FE0F',c:'23F9',k:[52,38],o:2},articulated_lorry:{a:'Articulated Lorry',b:'1F69B',j:['vehicle','cars','transportation','express'],k:[34,26],o:2},angry:{a:'Angry Face',b:'1F620',j:['mad','face','annoyed','frustrated'],k:[31,10],l:['>:(','>:-('],o:2},cookie:{a:'Cookie',b:'1F36A',j:['food','snack','oreo','chocolate','sweet','dessert'],k:[7,9],o:2},gb:{a:'United Kingdom Flag',b:'1F1EC-1F1E7',k:[1,55],n:['uk','flag-gb'],o:2},tropical_fish:{a:'Tropical Fish',b:'1F420',j:['animal','swim','ocean','beach','nemo'],k:[12,4],o:2},'woman-tipping-hand':{skin_variations:{'1F3FB':{unified:'1F481-1F3FB-200D-2640-FE0F',non_qualified:'1F481-1F3FB-200D-2640',image:'1f481-1f3fb-200d-2640-fe0f.png',sheet_x:23,sheet_y:48,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F481-1F3FC-200D-2640-FE0F',non_qualified:'1F481-1F3FC-200D-2640',image:'1f481-1f3fc-200d-2640-fe0f.png',sheet_x:23,sheet_y:49,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F481-1F3FD-200D-2640-FE0F',non_qualified:'1F481-1F3FD-200D-2640',image:'1f481-1f3fd-200d-2640-fe0f.png',sheet_x:23,sheet_y:50,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F481-1F3FE-200D-2640-FE0F',non_qualified:'1F481-1F3FE-200D-2640',image:'1f481-1f3fe-200d-2640-fe0f.png',sheet_x:23,sheet_y:51,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F481-1F3FF-200D-2640-FE0F',non_qualified:'1F481-1F3FF-200D-2640',image:'1f481-1f3ff-200d-2640-fe0f.png',sheet_x:23,sheet_y:52,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},obsoletes:'1F481',a:'Woman Tipping Hand',b:'1F481-200D-2640-FE0F',c:'1F481-200D-2640',k:[23,47],o:4},black_circle_for_record:{a:'Black Circle for Record',b:'23FA-FE0F',c:'23FA',k:[52,39],o:2},film_frames:{a:'Film Frames',b:'1F39E-FE0F',c:'1F39E',k:[8,4],o:2},film_projector:{a:'Film Projector',b:'1F4FD-FE0F',c:'1F4FD',j:['video','tape','record','movie'],k:[27,26],o:2},'flag-gd':{a:'Grenada Flag',b:'1F1EC-1F1E9',k:[1,56],o:2},blowfish:{a:'Blowfish',b:'1F421',j:['animal','nature','food','sea','ocean'],k:[12,5],o:2},face_with_symbols_on_mouth:{a:'Serious Face with Symbols Covering Mouth',b:'1F92C',k:[38,46],n:['serious_face_with_symbols_covering_mouth'],o:5},birthday:{a:'Birthday Cake',b:'1F382',j:['food','dessert','cake'],k:[7,33],o:2},eject:{a:'Eject',b:'23CF-FE0F',c:'23CF',k:[52,25],o:2},raising_hand:{skin_variations:{'1F3FB':{unified:'1F64B-1F3FB',non_qualified:null,image:'1f64b-1f3fb.png',sheet_x:33,sheet_y:3,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F64B-1F3FC',non_qualified:null,image:'1f64b-1f3fc.png',sheet_x:33,sheet_y:4,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F64B-1F3FD',non_qualified:null,image:'1f64b-1f3fd.png',sheet_x:33,sheet_y:5,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F64B-1F3FE',non_qualified:null,image:'1f64b-1f3fe.png',sheet_x:33,sheet_y:6,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F64B-1F3FF',non_qualified:null,image:'1f64b-1f3ff.png',sheet_x:33,sheet_y:7,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},obsoleted_by:'1F64B-200D-2640-FE0F',a:'Happy Person Raising One Hand',b:'1F64B',k:[33,2],o:2},tractor:{a:'Tractor',b:'1F69C',j:['vehicle','car','farming','agriculture'],k:[34,27],o:2},'flag-ge':{a:'Georgia Flag',b:'1F1EC-1F1EA',k:[2,0],o:2},smiling_imp:{a:'Smiling Face with Horns',b:'1F608',j:['devil','horns'],k:[30,43],o:2},racing_car:{a:'Racing Car',b:'1F3CE-FE0F',c:'1F3CE',j:['sports','race','fast','formula','f1'],k:[10,33],o:2},cinema:{a:'Cinema',b:'1F3A6',j:['blue-square','record','film','movie','curtain','stage','theater'],k:[8,12],o:2},clapper:{a:'Clapper Board',b:'1F3AC',j:['movie','film','record'],k:[8,18],o:2},shark:{a:'Shark',b:'1F988',j:['animal','nature','fish','sea','ocean','jaws','fins','beach'],k:[42,26],o:4},cake:{a:'Shortcake',b:'1F370',j:['food','dessert'],k:[7,15],o:2},'man-raising-hand':{skin_variations:{'1F3FB':{unified:'1F64B-1F3FB-200D-2642-FE0F',non_qualified:'1F64B-1F3FB-200D-2642',image:'1f64b-1f3fb-200d-2642-fe0f.png',sheet_x:32,sheet_y:54,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F64B-1F3FC-200D-2642-FE0F',non_qualified:'1F64B-1F3FC-200D-2642',image:'1f64b-1f3fc-200d-2642-fe0f.png',sheet_x:32,sheet_y:55,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F64B-1F3FD-200D-2642-FE0F',non_qualified:'1F64B-1F3FD-200D-2642',image:'1f64b-1f3fd-200d-2642-fe0f.png',sheet_x:32,sheet_y:56,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F64B-1F3FE-200D-2642-FE0F',non_qualified:'1F64B-1F3FE-200D-2642',image:'1f64b-1f3fe-200d-2642-fe0f.png',sheet_x:33,sheet_y:0,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F64B-1F3FF-200D-2642-FE0F',non_qualified:'1F64B-1F3FF-200D-2642',image:'1f64b-1f3ff-200d-2642-fe0f.png',sheet_x:33,sheet_y:1,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man Raising Hand',b:'1F64B-200D-2642-FE0F',c:'1F64B-200D-2642',k:[32,53],o:4},octopus:{a:'Octopus',b:'1F419',j:['animal','creature','ocean','sea','nature','beach'],k:[11,54],o:2},'woman-raising-hand':{skin_variations:{'1F3FB':{unified:'1F64B-1F3FB-200D-2640-FE0F',non_qualified:'1F64B-1F3FB-200D-2640',image:'1f64b-1f3fb-200d-2640-fe0f.png',sheet_x:32,sheet_y:48,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F64B-1F3FC-200D-2640-FE0F',non_qualified:'1F64B-1F3FC-200D-2640',image:'1f64b-1f3fc-200d-2640-fe0f.png',sheet_x:32,sheet_y:49,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F64B-1F3FD-200D-2640-FE0F',non_qualified:'1F64B-1F3FD-200D-2640',image:'1f64b-1f3fd-200d-2640-fe0f.png',sheet_x:32,sheet_y:50,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F64B-1F3FE-200D-2640-FE0F',non_qualified:'1F64B-1F3FE-200D-2640',image:'1f64b-1f3fe-200d-2640-fe0f.png',sheet_x:32,sheet_y:51,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F64B-1F3FF-200D-2640-FE0F',non_qualified:'1F64B-1F3FF-200D-2640',image:'1f64b-1f3ff-200d-2640-fe0f.png',sheet_x:32,sheet_y:52,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},obsoletes:'1F64B',a:'Woman Raising Hand',b:'1F64B-200D-2640-FE0F',c:'1F64B-200D-2640',k:[32,47],o:4},'flag-gf':{a:'French Guiana Flag',b:'1F1EC-1F1EB',k:[2,1],o:2},tv:{a:'Television',b:'1F4FA',j:['technology','program','oldschool','show','television'],k:[27,23],o:2},imp:{a:'Imp',b:'1F47F',j:['devil','angry','horns'],k:[23,45],o:2},cupcake:{a:'Cupcake',b:'1F9C1',k:[44,9],o:11},racing_motorcycle:{a:'Racing Motorcycle',b:'1F3CD-FE0F',c:'1F3CD',k:[10,32],o:2},low_brightness:{a:'Low Brightness Symbol',b:'1F505',j:['sun','afternoon','warm','summer'],k:[27,33],o:2},shell:{a:'Spiral Shell',b:'1F41A',j:['nature','sea','beach'],k:[11,55],o:2},'flag-gg':{a:'Guernsey Flag',b:'1F1EC-1F1EC',k:[2,2],o:2},high_brightness:{a:'High Brightness Symbol',b:'1F506',j:['sun','light'],k:[27,34],o:2},deaf_person:{skin_variations:{'1F3FB':{unified:'1F9CF-1F3FB',non_qualified:null,image:'1f9cf-1f3fb.png',sheet_x:45,sheet_y:11,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9CF-1F3FC',non_qualified:null,image:'1f9cf-1f3fc.png',sheet_x:45,sheet_y:12,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9CF-1F3FD',non_qualified:null,image:'1f9cf-1f3fd.png',sheet_x:45,sheet_y:13,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9CF-1F3FE',non_qualified:null,image:'1f9cf-1f3fe.png',sheet_x:45,sheet_y:14,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9CF-1F3FF',non_qualified:null,image:'1f9cf-1f3ff.png',sheet_x:45,sheet_y:15,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Deaf Person',b:'1F9CF',k:[45,10],o:12},skull:{a:'Skull',b:'1F480',j:['dead','skeleton','creepy','death'],k:[23,46],o:2},motor_scooter:{a:'Motor Scooter',b:'1F6F5',j:['vehicle','vespa','sasha'],k:[36,54],o:4},camera:{a:'Camera',b:'1F4F7',j:['gadgets','photography'],k:[27,20],o:2},pie:{a:'Pie',b:'1F967',j:['food','dessert','pastry'],k:[41,54],o:5},'flag-gh':{a:'Ghana Flag',b:'1F1EC-1F1ED',k:[2,3],o:2},deaf_man:{skin_variations:{'1F3FB':{unified:'1F9CF-1F3FB-200D-2642-FE0F',non_qualified:'1F9CF-1F3FB-200D-2642',image:'1f9cf-1f3fb-200d-2642-fe0f.png',sheet_x:45,sheet_y:5,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9CF-1F3FC-200D-2642-FE0F',non_qualified:'1F9CF-1F3FC-200D-2642',image:'1f9cf-1f3fc-200d-2642-fe0f.png',sheet_x:45,sheet_y:6,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9CF-1F3FD-200D-2642-FE0F',non_qualified:'1F9CF-1F3FD-200D-2642',image:'1f9cf-1f3fd-200d-2642-fe0f.png',sheet_x:45,sheet_y:7,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9CF-1F3FE-200D-2642-FE0F',non_qualified:'1F9CF-1F3FE-200D-2642',image:'1f9cf-1f3fe-200d-2642-fe0f.png',sheet_x:45,sheet_y:8,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9CF-1F3FF-200D-2642-FE0F',non_qualified:'1F9CF-1F3FF-200D-2642',image:'1f9cf-1f3ff-200d-2642-fe0f.png',sheet_x:45,sheet_y:9,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Deaf Man',b:'1F9CF-200D-2642-FE0F',c:'1F9CF-200D-2642',k:[45,4],o:12},skull_and_crossbones:{a:'Skull and Crossbones',b:'2620-FE0F',c:'2620',j:['poison','danger','deadly','scary','death','pirate','evil'],k:[53,8],o:2},camera_with_flash:{a:'Camera with Flash',b:'1F4F8',k:[27,21],o:2},signal_strength:{a:'Antenna with Bars',b:'1F4F6',j:['blue-square','reception','phone','internet','connection','wifi','bluetooth','bars'],k:[27,19],o:2},chocolate_bar:{a:'Chocolate Bar',b:'1F36B',j:['food','snack','dessert','sweet'],k:[7,10],o:2},manual_wheelchair:{a:'Manual Wheelchair',b:'1F9BD',k:[44,5],o:12},snail:{a:'Snail',b:'1F40C',j:['slow','animal','shell'],k:[11,40],o:2},motorized_wheelchair:{a:'Motorized Wheelchair',b:'1F9BC',k:[44,4],o:12},'flag-gi':{a:'Gibraltar Flag',b:'1F1EC-1F1EE',k:[2,4],o:2},hankey:{a:'Pile of Poo',b:'1F4A9',k:[25,51],n:['poop','shit'],o:2},vibration_mode:{a:'Vibration Mode',b:'1F4F3',j:['orange-square','phone'],k:[27,16],o:2},deaf_woman:{skin_variations:{'1F3FB':{unified:'1F9CF-1F3FB-200D-2640-FE0F',non_qualified:'1F9CF-1F3FB-200D-2640',image:'1f9cf-1f3fb-200d-2640-fe0f.png',sheet_x:44,sheet_y:56,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9CF-1F3FC-200D-2640-FE0F',non_qualified:'1F9CF-1F3FC-200D-2640',image:'1f9cf-1f3fc-200d-2640-fe0f.png',sheet_x:45,sheet_y:0,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9CF-1F3FD-200D-2640-FE0F',non_qualified:'1F9CF-1F3FD-200D-2640',image:'1f9cf-1f3fd-200d-2640-fe0f.png',sheet_x:45,sheet_y:1,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9CF-1F3FE-200D-2640-FE0F',non_qualified:'1F9CF-1F3FE-200D-2640',image:'1f9cf-1f3fe-200d-2640-fe0f.png',sheet_x:45,sheet_y:2,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9CF-1F3FF-200D-2640-FE0F',non_qualified:'1F9CF-1F3FF-200D-2640',image:'1f9cf-1f3ff-200d-2640-fe0f.png',sheet_x:45,sheet_y:3,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Deaf Woman',b:'1F9CF-200D-2640-FE0F',c:'1F9CF-200D-2640',k:[44,55],o:12},butterfly:{a:'Butterfly',b:'1F98B',j:['animal','insect','nature','caterpillar'],k:[42,29],o:4},video_camera:{a:'Video Camera',b:'1F4F9',j:['film','record'],k:[27,22],o:2},candy:{a:'Candy',b:'1F36C',j:['snack','dessert','sweet','lolly'],k:[7,11],o:2},auto_rickshaw:{a:'Auto Rickshaw',b:'1F6FA',k:[37,2],o:12},bow:{skin_variations:{'1F3FB':{unified:'1F647-1F3FB',non_qualified:null,image:'1f647-1f3fb.png',sheet_x:32,sheet_y:39,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F647-1F3FC',non_qualified:null,image:'1f647-1f3fc.png',sheet_x:32,sheet_y:40,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F647-1F3FD',non_qualified:null,image:'1f647-1f3fd.png',sheet_x:32,sheet_y:41,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F647-1F3FE',non_qualified:null,image:'1f647-1f3fe.png',sheet_x:32,sheet_y:42,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F647-1F3FF',non_qualified:null,image:'1f647-1f3ff.png',sheet_x:32,sheet_y:43,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},obsoleted_by:'1F647-200D-2642-FE0F',a:'Person Bowing Deeply',b:'1F647',k:[32,38],o:2},mobile_phone_off:{a:'Mobile Phone off',b:'1F4F4',j:['mute','orange-square','silence','quiet'],k:[27,17],o:2},clown_face:{a:'Clown Face',b:'1F921',j:['face'],k:[38,18],o:4},lollipop:{a:'Lollipop',b:'1F36D',j:['food','snack','candy','sweet'],k:[7,12],o:2},'flag-gl':{a:'Greenland Flag',b:'1F1EC-1F1F1',k:[2,5],o:2},vhs:{a:'Videocassette',b:'1F4FC',j:['record','video','oldschool','90s','80s'],k:[27,25],o:2},bug:{a:'Bug',b:'1F41B',j:['animal','insect','nature','worm'],k:[11,56],o:2},bike:{a:'Bicycle',b:'1F6B2',j:['sports','bicycle','exercise','hipster'],k:[35,9],o:2},'man-bowing':{skin_variations:{'1F3FB':{unified:'1F647-1F3FB-200D-2642-FE0F',non_qualified:'1F647-1F3FB-200D-2642',image:'1f647-1f3fb-200d-2642-fe0f.png',sheet_x:32,sheet_y:33,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F647-1F3FC-200D-2642-FE0F',non_qualified:'1F647-1F3FC-200D-2642',image:'1f647-1f3fc-200d-2642-fe0f.png',sheet_x:32,sheet_y:34,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F647-1F3FD-200D-2642-FE0F',non_qualified:'1F647-1F3FD-200D-2642',image:'1f647-1f3fd-200d-2642-fe0f.png',sheet_x:32,sheet_y:35,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F647-1F3FE-200D-2642-FE0F',non_qualified:'1F647-1F3FE-200D-2642',image:'1f647-1f3fe-200d-2642-fe0f.png',sheet_x:32,sheet_y:36,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F647-1F3FF-200D-2642-FE0F',non_qualified:'1F647-1F3FF-200D-2642',image:'1f647-1f3ff-200d-2642-fe0f.png',sheet_x:32,sheet_y:37,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},obsoletes:'1F647',a:'Man Bowing',b:'1F647-200D-2642-FE0F',c:'1F647-200D-2642',k:[32,32],o:4},japanese_ogre:{a:'Japanese Ogre',b:'1F479',j:['monster','red','mask','halloween','scary','creepy','devil','demon','japanese','ogre'],k:[23,34],o:2},custard:{a:'Custard',b:'1F36E',j:['dessert','food'],k:[7,13],o:2},ant:{a:'Ant',b:'1F41C',j:['animal','insect','nature','bug'],k:[12,0],o:2},mag:{a:'Left-Pointing Magnifying Glass',b:'1F50D',j:['search','zoom','find','detective'],k:[27,41],o:2},'flag-gm':{a:'Gambia Flag',b:'1F1EC-1F1F2',k:[2,6],o:2},honey_pot:{a:'Honey Pot',b:'1F36F',j:['bees','sweet','kitchen'],k:[7,14],o:2},'woman-bowing':{skin_variations:{'1F3FB':{unified:'1F647-1F3FB-200D-2640-FE0F',non_qualified:'1F647-1F3FB-200D-2640',image:'1f647-1f3fb-200d-2640-fe0f.png',sheet_x:32,sheet_y:27,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F647-1F3FC-200D-2640-FE0F',non_qualified:'1F647-1F3FC-200D-2640',image:'1f647-1f3fc-200d-2640-fe0f.png',sheet_x:32,sheet_y:28,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F647-1F3FD-200D-2640-FE0F',non_qualified:'1F647-1F3FD-200D-2640',image:'1f647-1f3fd-200d-2640-fe0f.png',sheet_x:32,sheet_y:29,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F647-1F3FE-200D-2640-FE0F',non_qualified:'1F647-1F3FE-200D-2640',image:'1f647-1f3fe-200d-2640-fe0f.png',sheet_x:32,sheet_y:30,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F647-1F3FF-200D-2640-FE0F',non_qualified:'1F647-1F3FF-200D-2640',image:'1f647-1f3ff-200d-2640-fe0f.png',sheet_x:32,sheet_y:31,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Woman Bowing',b:'1F647-200D-2640-FE0F',c:'1F647-200D-2640',k:[32,26],o:4},mag_right:{a:'Right-Pointing Magnifying Glass',b:'1F50E',j:['search','zoom','find','detective'],k:[27,42],o:2},japanese_goblin:{a:'Japanese Goblin',b:'1F47A',j:['red','evil','mask','monster','scary','creepy','japanese','goblin'],k:[23,35],o:2},scooter:{a:'Scooter',b:'1F6F4',k:[36,53],o:4},bee:{a:'Honeybee',b:'1F41D',k:[12,1],n:['honeybee'],o:2},'flag-gn':{a:'Guinea Flag',b:'1F1EC-1F1F3',k:[2,7],o:2},candle:{a:'Candle',b:'1F56F-FE0F',c:'1F56F',j:['fire','wax'],k:[29,6],o:2},skateboard:{a:'Skateboard',b:'1F6F9',k:[37,1],o:11},ghost:{a:'Ghost',b:'1F47B',j:['halloween','spooky','scary'],k:[23,36],o:2},beetle:{a:'Lady Beetle',b:'1F41E',j:['animal','insect','nature','ladybug'],k:[12,2],o:2},face_palm:{skin_variations:{'1F3FB':{unified:'1F926-1F3FB',non_qualified:null,image:'1f926-1f3fb.png',sheet_x:38,sheet_y:36,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F926-1F3FC',non_qualified:null,image:'1f926-1f3fc.png',sheet_x:38,sheet_y:37,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F926-1F3FD',non_qualified:null,image:'1f926-1f3fd.png',sheet_x:38,sheet_y:38,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F926-1F3FE',non_qualified:null,image:'1f926-1f3fe.png',sheet_x:38,sheet_y:39,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F926-1F3FF',non_qualified:null,image:'1f926-1f3ff.png',sheet_x:38,sheet_y:40,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},a:'Face Palm',b:'1F926',k:[38,35],o:4},'flag-gp':{a:'Guadeloupe Flag',b:'1F1EC-1F1F5',k:[2,8],o:2},baby_bottle:{a:'Baby Bottle',b:'1F37C',j:['food','container','milk'],k:[7,27],o:2},infinity:{a:'Infinity',b:'267E-FE0F',c:'267E',k:[53,39],o:11},glass_of_milk:{a:'Glass of Milk',b:'1F95B',k:[41,42],o:4},'man-facepalming':{skin_variations:{'1F3FB':{unified:'1F926-1F3FB-200D-2642-FE0F',non_qualified:'1F926-1F3FB-200D-2642',image:'1f926-1f3fb-200d-2642-fe0f.png',sheet_x:38,sheet_y:30,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F926-1F3FC-200D-2642-FE0F',non_qualified:'1F926-1F3FC-200D-2642',image:'1f926-1f3fc-200d-2642-fe0f.png',sheet_x:38,sheet_y:31,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F926-1F3FD-200D-2642-FE0F',non_qualified:'1F926-1F3FD-200D-2642',image:'1f926-1f3fd-200d-2642-fe0f.png',sheet_x:38,sheet_y:32,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F926-1F3FE-200D-2642-FE0F',non_qualified:'1F926-1F3FE-200D-2642',image:'1f926-1f3fe-200d-2642-fe0f.png',sheet_x:38,sheet_y:33,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F926-1F3FF-200D-2642-FE0F',non_qualified:'1F926-1F3FF-200D-2642',image:'1f926-1f3ff-200d-2642-fe0f.png',sheet_x:38,sheet_y:34,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man Facepalming',b:'1F926-200D-2642-FE0F',c:'1F926-200D-2642',k:[38,29],o:4},cricket:{a:'Cricket',b:'1F997',j:['sports'],k:[42,41],o:5},busstop:{a:'Bus Stop',b:'1F68F',j:['transportation','wait'],k:[34,14],o:2},'flag-gq':{a:'Equatorial Guinea Flag',b:'1F1EC-1F1F6',k:[2,9],o:2},alien:{a:'Extraterrestrial Alien',b:'1F47D',j:['UFO','paul','weird','outer_space'],k:[23,43],o:2},bulb:{a:'Electric Light Bulb',b:'1F4A1',j:['light','electricity','idea'],k:[25,43],o:2},'woman-facepalming':{skin_variations:{'1F3FB':{unified:'1F926-1F3FB-200D-2640-FE0F',non_qualified:'1F926-1F3FB-200D-2640',image:'1f926-1f3fb-200d-2640-fe0f.png',sheet_x:38,sheet_y:24,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F926-1F3FC-200D-2640-FE0F',non_qualified:'1F926-1F3FC-200D-2640',image:'1f926-1f3fc-200d-2640-fe0f.png',sheet_x:38,sheet_y:25,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F926-1F3FD-200D-2640-FE0F',non_qualified:'1F926-1F3FD-200D-2640',image:'1f926-1f3fd-200d-2640-fe0f.png',sheet_x:38,sheet_y:26,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F926-1F3FE-200D-2640-FE0F',non_qualified:'1F926-1F3FE-200D-2640',image:'1f926-1f3fe-200d-2640-fe0f.png',sheet_x:38,sheet_y:27,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F926-1F3FF-200D-2640-FE0F',non_qualified:'1F926-1F3FF-200D-2640',image:'1f926-1f3ff-200d-2640-fe0f.png',sheet_x:38,sheet_y:28,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Woman Facepalming',b:'1F926-200D-2640-FE0F',c:'1F926-200D-2640',k:[38,23],o:4},spider:{a:'Spider',b:'1F577-FE0F',c:'1F577',j:['animal','arachnid'],k:[29,34],o:2},space_invader:{a:'Alien Monster',b:'1F47E',j:['game','arcade','play'],k:[23,44],o:2},motorway:{a:'Motorway',b:'1F6E3-FE0F',c:'1F6E3',j:['road','cupertino','interstate','highway'],k:[36,45],o:2},'flag-gr':{a:'Greece Flag',b:'1F1EC-1F1F7',k:[2,10],o:2},recycle:{a:'Black Universal Recycling Symbol',b:'267B-FE0F',c:'267B',j:['arrow','environment','garbage','trash'],k:[53,38],o:2},coffee:{a:'Hot Beverage',b:'2615',j:['beverage','caffeine','latte','espresso'],k:[53,0],o:2},flashlight:{a:'Electric Torch',b:'1F526',j:['dark','camping','sight','night'],k:[28,9],o:2},spider_web:{a:'Spider Web',b:'1F578-FE0F',c:'1F578',j:['animal','insect','arachnid','silk'],k:[29,35],o:2},izakaya_lantern:{a:'Izakaya Lantern',b:'1F3EE',j:['light','paper','halloween','spooky'],k:[11,8],n:['lantern'],o:2},'flag-gs':{a:'South Georgia & South Sandwich Islands Flag',b:'1F1EC-1F1F8',k:[2,11],o:2},shrug:{skin_variations:{'1F3FB':{unified:'1F937-1F3FB',non_qualified:null,image:'1f937-1f3fb.png',sheet_x:39,sheet_y:48,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F937-1F3FC',non_qualified:null,image:'1f937-1f3fc.png',sheet_x:39,sheet_y:49,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F937-1F3FD',non_qualified:null,image:'1f937-1f3fd.png',sheet_x:39,sheet_y:50,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F937-1F3FE',non_qualified:null,image:'1f937-1f3fe.png',sheet_x:39,sheet_y:51,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F937-1F3FF',non_qualified:null,image:'1f937-1f3ff.png',sheet_x:39,sheet_y:52,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},a:'Shrug',b:'1F937',k:[39,47],o:4},fleur_de_lis:{a:'Fleur De Lis',b:'269C-FE0F',c:'269C',j:['decorative','scout'],k:[53,49],o:2},robot_face:{a:'Robot Face',b:'1F916',k:[37,29],o:2},railway_track:{a:'Railway Track',b:'1F6E4-FE0F',c:'1F6E4',j:['train','transportation'],k:[36,46],o:2},tea:{a:'Teacup Without Handle',b:'1F375',j:['drink','bowl','breakfast','green','british'],k:[7,20],o:2},'flag-gt':{a:'Guatemala Flag',b:'1F1EC-1F1F9',k:[2,12],o:2},oil_drum:{a:'Oil Drum',b:'1F6E2-FE0F',c:'1F6E2',j:['barrell'],k:[36,44],o:2},diya_lamp:{a:'Diya Lamp',b:'1FA94',k:[52,8],o:12},sake:{a:'Sake Bottle and Cup',b:'1F376',j:['wine','drink','drunk','beverage','japanese','alcohol','booze'],k:[7,21],o:2},trident:{a:'Trident Emblem',b:'1F531',j:['weapon','spear'],k:[28,20],o:2},'man-shrugging':{skin_variations:{'1F3FB':{unified:'1F937-1F3FB-200D-2642-FE0F',non_qualified:'1F937-1F3FB-200D-2642',image:'1f937-1f3fb-200d-2642-fe0f.png',sheet_x:39,sheet_y:42,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F937-1F3FC-200D-2642-FE0F',non_qualified:'1F937-1F3FC-200D-2642',image:'1f937-1f3fc-200d-2642-fe0f.png',sheet_x:39,sheet_y:43,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F937-1F3FD-200D-2642-FE0F',non_qualified:'1F937-1F3FD-200D-2642',image:'1f937-1f3fd-200d-2642-fe0f.png',sheet_x:39,sheet_y:44,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F937-1F3FE-200D-2642-FE0F',non_qualified:'1F937-1F3FE-200D-2642',image:'1f937-1f3fe-200d-2642-fe0f.png',sheet_x:39,sheet_y:45,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F937-1F3FF-200D-2642-FE0F',non_qualified:'1F937-1F3FF-200D-2642',image:'1f937-1f3ff-200d-2642-fe0f.png',sheet_x:39,sheet_y:46,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man Shrugging',b:'1F937-200D-2642-FE0F',c:'1F937-200D-2642',k:[39,41],o:4},smiley_cat:{a:'Smiling Cat Face with Open Mouth',b:'1F63A',j:['animal','cats','happy','smile'],k:[31,36],o:2},scorpion:{a:'Scorpion',b:'1F982',j:['animal','arachnid'],k:[42,20],o:2},'woman-shrugging':{skin_variations:{'1F3FB':{unified:'1F937-1F3FB-200D-2640-FE0F',non_qualified:'1F937-1F3FB-200D-2640',image:'1f937-1f3fb-200d-2640-fe0f.png',sheet_x:39,sheet_y:36,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F937-1F3FC-200D-2640-FE0F',non_qualified:'1F937-1F3FC-200D-2640',image:'1f937-1f3fc-200d-2640-fe0f.png',sheet_x:39,sheet_y:37,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F937-1F3FD-200D-2640-FE0F',non_qualified:'1F937-1F3FD-200D-2640',image:'1f937-1f3fd-200d-2640-fe0f.png',sheet_x:39,sheet_y:38,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F937-1F3FE-200D-2640-FE0F',non_qualified:'1F937-1F3FE-200D-2640',image:'1f937-1f3fe-200d-2640-fe0f.png',sheet_x:39,sheet_y:39,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F937-1F3FF-200D-2640-FE0F',non_qualified:'1F937-1F3FF-200D-2640',image:'1f937-1f3ff-200d-2640-fe0f.png',sheet_x:39,sheet_y:40,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Woman Shrugging',b:'1F937-200D-2640-FE0F',c:'1F937-200D-2640',k:[39,35],o:4},notebook_with_decorative_cover:{a:'Notebook with Decorative Cover',b:'1F4D4',j:['classroom','notes','record','paper','study'],k:[26,42],o:2},fuelpump:{a:'Fuel Pump',b:'26FD',j:['gas station','petroleum'],k:[54,38],o:2},name_badge:{a:'Name Badge',b:'1F4DB',j:['fire','forbid'],k:[26,49],o:2},mosquito:{a:'Mosquito',b:'1F99F',k:[42,49],o:11},'flag-gu':{a:'Guam Flag',b:'1F1EC-1F1FA',k:[2,13],o:2},smile_cat:{a:'Grinning Cat Face with Smiling Eyes',b:'1F638',j:['animal','cats','smile'],k:[31,34],o:2},champagne:{a:'Bottle with Popping Cork',b:'1F37E',j:['drink','wine','bottle','celebration'],k:[7,29],o:2},joy_cat:{a:'Cat Face with Tears of Joy',b:'1F639',j:['animal','cats','haha','happy','tears'],k:[31,35],o:2},closed_book:{a:'Closed Book',b:'1F4D5',j:['read','library','knowledge','textbook','learn'],k:[26,43],o:2},health_worker:{skin_variations:{'1F3FB':{unified:'1F9D1-1F3FB-200D-2695-FE0F',non_qualified:'1F9D1-1F3FB-200D-2695',image:'1f9d1-1f3fb-200d-2695-fe0f.png',sheet_x:47,sheet_y:50,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FC':{unified:'1F9D1-1F3FC-200D-2695-FE0F',non_qualified:'1F9D1-1F3FC-200D-2695',image:'1f9d1-1f3fc-200d-2695-fe0f.png',sheet_x:47,sheet_y:51,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FD':{unified:'1F9D1-1F3FD-200D-2695-FE0F',non_qualified:'1F9D1-1F3FD-200D-2695',image:'1f9d1-1f3fd-200d-2695-fe0f.png',sheet_x:47,sheet_y:52,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FE':{unified:'1F9D1-1F3FE-200D-2695-FE0F',non_qualified:'1F9D1-1F3FE-200D-2695',image:'1f9d1-1f3fe-200d-2695-fe0f.png',sheet_x:47,sheet_y:53,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FF':{unified:'1F9D1-1F3FF-200D-2695-FE0F',non_qualified:'1F9D1-1F3FF-200D-2695',image:'1f9d1-1f3ff-200d-2695-fe0f.png',sheet_x:47,sheet_y:54,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false}},a:'Health Worker',b:'1F9D1-200D-2695-FE0F',c:'1F9D1-200D-2695',k:[47,49],o:12},rotating_light:{a:'Police Cars Revolving Light',b:'1F6A8',j:['police','ambulance','911','emergency','alert','error','pinged','law','legal'],k:[34,56],o:2},microbe:{a:'Microbe',b:'1F9A0',k:[42,50],o:11},'flag-gw':{a:'Guinea-Bissau Flag',b:'1F1EC-1F1FC',k:[2,14],o:2},wine_glass:{a:'Wine Glass',b:'1F377',j:['drink','beverage','drunk','alcohol','booze'],k:[7,22],o:2},beginner:{a:'Japanese Symbol for Beginner',b:'1F530',j:['badge','shield'],k:[28,19],o:2},bouquet:{a:'Bouquet',b:'1F490',j:['flowers','nature','spring'],k:[25,26],o:2},heart_eyes_cat:{a:'Smiling Cat Face with Heart-Shaped Eyes',b:'1F63B',j:['animal','love','like','affection','cats','valentines','heart'],k:[31,37],o:2},'male-doctor':{skin_variations:{'1F3FB':{unified:'1F468-1F3FB-200D-2695-FE0F',non_qualified:'1F468-1F3FB-200D-2695',image:'1f468-1f3fb-200d-2695-fe0f.png',sheet_x:17,sheet_y:3,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F468-1F3FC-200D-2695-FE0F',non_qualified:'1F468-1F3FC-200D-2695',image:'1f468-1f3fc-200d-2695-fe0f.png',sheet_x:17,sheet_y:4,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F468-1F3FD-200D-2695-FE0F',non_qualified:'1F468-1F3FD-200D-2695',image:'1f468-1f3fd-200d-2695-fe0f.png',sheet_x:17,sheet_y:5,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F468-1F3FE-200D-2695-FE0F',non_qualified:'1F468-1F3FE-200D-2695',image:'1f468-1f3fe-200d-2695-fe0f.png',sheet_x:17,sheet_y:6,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F468-1F3FF-200D-2695-FE0F',non_qualified:'1F468-1F3FF-200D-2695',image:'1f468-1f3ff-200d-2695-fe0f.png',sheet_x:17,sheet_y:7,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Male Doctor',b:'1F468-200D-2695-FE0F',c:'1F468-200D-2695',k:[17,2],o:4},book:{a:'Open Book',b:'1F4D6',k:[26,44],n:['open_book'],o:2},traffic_light:{a:'Horizontal Traffic Light',b:'1F6A5',j:['transportation','signal'],k:[34,53],o:2},cocktail:{a:'Cocktail Glass',b:'1F378',j:['drink','drunk','alcohol','beverage','booze','mojito'],k:[7,23],o:2},o:{a:'Heavy Large Circle',b:'2B55',j:['circle','round'],k:[55,43],o:2},'flag-gy':{a:'Guyana Flag',b:'1F1EC-1F1FE',k:[2,15],o:2},'female-doctor':{skin_variations:{'1F3FB':{unified:'1F469-1F3FB-200D-2695-FE0F',non_qualified:'1F469-1F3FB-200D-2695',image:'1f469-1f3fb-200d-2695-fe0f.png',sheet_x:19,sheet_y:45,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F469-1F3FC-200D-2695-FE0F',non_qualified:'1F469-1F3FC-200D-2695',image:'1f469-1f3fc-200d-2695-fe0f.png',sheet_x:19,sheet_y:46,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F469-1F3FD-200D-2695-FE0F',non_qualified:'1F469-1F3FD-200D-2695',image:'1f469-1f3fd-200d-2695-fe0f.png',sheet_x:19,sheet_y:47,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F469-1F3FE-200D-2695-FE0F',non_qualified:'1F469-1F3FE-200D-2695',image:'1f469-1f3fe-200d-2695-fe0f.png',sheet_x:19,sheet_y:48,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F469-1F3FF-200D-2695-FE0F',non_qualified:'1F469-1F3FF-200D-2695',image:'1f469-1f3ff-200d-2695-fe0f.png',sheet_x:19,sheet_y:49,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Female Doctor',b:'1F469-200D-2695-FE0F',c:'1F469-200D-2695',k:[19,44],o:4},smirk_cat:{a:'Cat Face with Wry Smile',b:'1F63C',j:['animal','cats','smirk'],k:[31,38],o:2},green_book:{a:'Green Book',b:'1F4D7',j:['read','library','knowledge','study'],k:[26,45],o:2},cherry_blossom:{a:'Cherry Blossom',b:'1F338',j:['nature','plant','spring','flower'],k:[6,16],o:2},'flag-hk':{a:'Hong Kong Sar China Flag',b:'1F1ED-1F1F0',k:[2,16],o:2},vertical_traffic_light:{a:'Vertical Traffic Light',b:'1F6A6',j:['transportation','driving'],k:[34,54],o:2},white_check_mark:{a:'White Heavy Check Mark',b:'2705',j:['green-square','ok','agree','vote','election','answer','tick'],k:[54,40],o:2},tropical_drink:{a:'Tropical Drink',b:'1F379',j:['beverage','cocktail','summer','beach','alcohol','booze','mojito'],k:[7,24],o:2},kissing_cat:{a:'Kissing Cat Face with Closed Eyes',b:'1F63D',j:['animal','cats','kiss'],k:[31,39],o:2},'flag-hm':{a:'Heard & Mcdonald Islands Flag',b:'1F1ED-1F1F2',k:[2,17],o:2},octagonal_sign:{a:'Octagonal Sign',b:'1F6D1',k:[36,39],o:4},white_flower:{a:'White Flower',b:'1F4AE',j:['japanese','spring'],k:[26,4],o:2},ballot_box_with_check:{a:'Ballot Box with Check',b:'2611-FE0F',c:'2611',j:['ok','agree','confirm','black-square','vote','election','yes','tick'],k:[52,55],o:2},student:{skin_variations:{'1F3FB':{unified:'1F9D1-1F3FB-200D-1F393',non_qualified:null,image:'1f9d1-1f3fb-200d-1f393.png',sheet_x:45,sheet_y:30,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FC':{unified:'1F9D1-1F3FC-200D-1F393',non_qualified:null,image:'1f9d1-1f3fc-200d-1f393.png',sheet_x:45,sheet_y:31,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FD':{unified:'1F9D1-1F3FD-200D-1F393',non_qualified:null,image:'1f9d1-1f3fd-200d-1f393.png',sheet_x:45,sheet_y:32,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FE':{unified:'1F9D1-1F3FE-200D-1F393',non_qualified:null,image:'1f9d1-1f3fe-200d-1f393.png',sheet_x:45,sheet_y:33,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FF':{unified:'1F9D1-1F3FF-200D-1F393',non_qualified:null,image:'1f9d1-1f3ff-200d-1f393.png',sheet_x:45,sheet_y:34,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false}},a:'Student',b:'1F9D1-200D-1F393',k:[45,29],o:12},blue_book:{a:'Blue Book',b:'1F4D8',j:['read','library','knowledge','learn','study'],k:[26,46],o:2},beer:{a:'Beer Mug',b:'1F37A',j:['relax','beverage','drink','drunk','party','pub','summer','alcohol','booze'],k:[7,25],o:2},construction:{a:'Construction Sign',b:'1F6A7',j:['wip','progress','caution','warning'],k:[34,55],o:2},rosette:{a:'Rosette',b:'1F3F5-FE0F',c:'1F3F5',j:['flower','decoration','military'],k:[11,18],o:2},heavy_check_mark:{a:'Heavy Check Mark',b:'2714-FE0F',c:'2714',j:['ok','nike','answer','yes','tick'],k:[55,12],o:2},scream_cat:{a:'Weary Cat Face',b:'1F640',j:['animal','cats','munch','scared','scream'],k:[31,42],o:2},orange_book:{a:'Orange Book',b:'1F4D9',j:['read','library','knowledge','textbook','study'],k:[26,47],o:2},beers:{a:'Clinking Beer Mugs',b:'1F37B',j:['relax','beverage','drink','drunk','party','pub','summer','alcohol','booze'],k:[7,26],o:2},'male-student':{skin_variations:{'1F3FB':{unified:'1F468-1F3FB-200D-1F393',non_qualified:null,image:'1f468-1f3fb-200d-1f393.png',sheet_x:14,sheet_y:51,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F468-1F3FC-200D-1F393',non_qualified:null,image:'1f468-1f3fc-200d-1f393.png',sheet_x:14,sheet_y:52,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F468-1F3FD-200D-1F393',non_qualified:null,image:'1f468-1f3fd-200d-1f393.png',sheet_x:14,sheet_y:53,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F468-1F3FE-200D-1F393',non_qualified:null,image:'1f468-1f3fe-200d-1f393.png',sheet_x:14,sheet_y:54,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F468-1F3FF-200D-1F393',non_qualified:null,image:'1f468-1f3ff-200d-1f393.png',sheet_x:14,sheet_y:55,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Male Student',b:'1F468-200D-1F393',k:[14,50],o:4},'flag-hn':{a:'Honduras Flag',b:'1F1ED-1F1F3',k:[2,18],o:2},crying_cat_face:{a:'Crying Cat Face',b:'1F63F',j:['animal','tears','weep','sad','cats','upset','cry'],k:[31,41],o:2},anchor:{a:'Anchor',b:'2693',j:['ship','ferry','sea','boat'],k:[53,42],o:2},'flag-hr':{a:'Croatia Flag',b:'1F1ED-1F1F7',k:[2,19],o:2},heavy_multiplication_x:{a:'Heavy Multiplication X',b:'2716-FE0F',c:'2716',j:['math','calculation'],k:[55,13],o:2},'female-student':{skin_variations:{'1F3FB':{unified:'1F469-1F3FB-200D-1F393',non_qualified:null,image:'1f469-1f3fb-200d-1f393.png',sheet_x:17,sheet_y:41,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F469-1F3FC-200D-1F393',non_qualified:null,image:'1f469-1f3fc-200d-1f393.png',sheet_x:17,sheet_y:42,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F469-1F3FD-200D-1F393',non_qualified:null,image:'1f469-1f3fd-200d-1f393.png',sheet_x:17,sheet_y:43,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F469-1F3FE-200D-1F393',non_qualified:null,image:'1f469-1f3fe-200d-1f393.png',sheet_x:17,sheet_y:44,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F469-1F3FF-200D-1F393',non_qualified:null,image:'1f469-1f3ff-200d-1f393.png',sheet_x:17,sheet_y:45,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Female Student',b:'1F469-200D-1F393',k:[17,40],o:4},rose:{a:'Rose',b:'1F339',j:['flowers','valentines','love','spring'],k:[6,17],o:2},books:{a:'Books',b:'1F4DA',j:['literature','library','study'],k:[26,48],o:2},clinking_glasses:{a:'Clinking Glasses',b:'1F942',j:['beverage','drink','party','alcohol','celebrate','cheers'],k:[41,18],o:4},teacher:{skin_variations:{'1F3FB':{unified:'1F9D1-1F3FB-200D-1F3EB',non_qualified:null,image:'1f9d1-1f3fb-200d-1f3eb.png',sheet_x:45,sheet_y:48,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FC':{unified:'1F9D1-1F3FC-200D-1F3EB',non_qualified:null,image:'1f9d1-1f3fc-200d-1f3eb.png',sheet_x:45,sheet_y:49,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FD':{unified:'1F9D1-1F3FD-200D-1F3EB',non_qualified:null,image:'1f9d1-1f3fd-200d-1f3eb.png',sheet_x:45,sheet_y:50,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FE':{unified:'1F9D1-1F3FE-200D-1F3EB',non_qualified:null,image:'1f9d1-1f3fe-200d-1f3eb.png',sheet_x:45,sheet_y:51,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FF':{unified:'1F9D1-1F3FF-200D-1F3EB',non_qualified:null,image:'1f9d1-1f3ff-200d-1f3eb.png',sheet_x:45,sheet_y:52,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false}},a:'Teacher',b:'1F9D1-200D-1F3EB',k:[45,47],o:12},x:{a:'Cross Mark',b:'274C',j:['no','delete','remove','cancel'],k:[55,21],o:2},pouting_cat:{a:'Pouting Cat Face',b:'1F63E',j:['animal','cats'],k:[31,40],o:2},wilted_flower:{a:'Wilted Flower',b:'1F940',j:['plant','nature','flower'],k:[41,16],o:4},boat:{a:'Sailboat',b:'26F5',k:[54,16],n:['sailboat'],o:2},'flag-ht':{a:'Haiti Flag',b:'1F1ED-1F1F9',k:[2,20],o:2},tumbler_glass:{a:'Tumbler Glass',b:'1F943',j:['drink','beverage','drunk','alcohol','liquor','booze','bourbon','scotch','whisky','glass','shot'],k:[41,19],o:4},notebook:{a:'Notebook',b:'1F4D3',j:['stationery','record','notes','paper','study'],k:[26,41],o:2},'male-teacher':{skin_variations:{'1F3FB':{unified:'1F468-1F3FB-200D-1F3EB',non_qualified:null,image:'1f468-1f3fb-200d-1f3eb.png',sheet_x:15,sheet_y:12,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F468-1F3FC-200D-1F3EB',non_qualified:null,image:'1f468-1f3fc-200d-1f3eb.png',sheet_x:15,sheet_y:13,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F468-1F3FD-200D-1F3EB',non_qualified:null,image:'1f468-1f3fd-200d-1f3eb.png',sheet_x:15,sheet_y:14,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F468-1F3FE-200D-1F3EB',non_qualified:null,image:'1f468-1f3fe-200d-1f3eb.png',sheet_x:15,sheet_y:15,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F468-1F3FF-200D-1F3EB',non_qualified:null,image:'1f468-1f3ff-200d-1f3eb.png',sheet_x:15,sheet_y:16,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Male Teacher',b:'1F468-200D-1F3EB',k:[15,11],o:4},ledger:{a:'Ledger',b:'1F4D2',j:['notes','paper'],k:[26,40],o:2},'flag-hu':{a:'Hungary Flag',b:'1F1ED-1F1FA',k:[2,21],o:2},cup_with_straw:{a:'Cup with Straw',b:'1F964',j:['drink','soda'],k:[41,51],o:5},hibiscus:{a:'Hibiscus',b:'1F33A',j:['plant','vegetable','flowers','beach'],k:[6,18],o:2},see_no_evil:{a:'See-No-Evil Monkey',b:'1F648',j:['monkey','animal','nature','haha'],k:[32,44],o:2},canoe:{a:'Canoe',b:'1F6F6',j:['boat','paddle','water','ship'],k:[36,55],o:4},negative_squared_cross_mark:{a:'Negative Squared Cross Mark',b:'274E',j:['x','green-square','no','deny'],k:[55,22],o:2},'flag-ic':{a:'Canary Islands Flag',b:'1F1EE-1F1E8',k:[2,22],o:2},beverage_box:{a:'Beverage Box',b:'1F9C3',k:[44,11],o:12},speedboat:{a:'Speedboat',b:'1F6A4',j:['ship','transportation','vehicle','summer'],k:[34,52],o:2},heavy_plus_sign:{a:'Heavy Plus Sign',b:'2795',j:['math','calculation','addition','more','increase'],k:[55,29],o:2},sunflower:{a:'Sunflower',b:'1F33B',j:['nature','plant','fall'],k:[6,19],o:2},page_with_curl:{a:'Page with Curl',b:'1F4C3',j:['documents','office','paper'],k:[26,25],o:2},'female-teacher':{skin_variations:{'1F3FB':{unified:'1F469-1F3FB-200D-1F3EB',non_qualified:null,image:'1f469-1f3fb-200d-1f3eb.png',sheet_x:18,sheet_y:2,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F469-1F3FC-200D-1F3EB',non_qualified:null,image:'1f469-1f3fc-200d-1f3eb.png',sheet_x:18,sheet_y:3,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F469-1F3FD-200D-1F3EB',non_qualified:null,image:'1f469-1f3fd-200d-1f3eb.png',sheet_x:18,sheet_y:4,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F469-1F3FE-200D-1F3EB',non_qualified:null,image:'1f469-1f3fe-200d-1f3eb.png',sheet_x:18,sheet_y:5,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F469-1F3FF-200D-1F3EB',non_qualified:null,image:'1f469-1f3ff-200d-1f3eb.png',sheet_x:18,sheet_y:6,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Female Teacher',b:'1F469-200D-1F3EB',k:[18,1],o:4},hear_no_evil:{a:'Hear-No-Evil Monkey',b:'1F649',j:['animal','monkey','nature'],k:[32,45],o:2},mate_drink:{a:'Mate Drink',b:'1F9C9',k:[44,17],o:12},passenger_ship:{a:'Passenger Ship',b:'1F6F3-FE0F',c:'1F6F3',j:['yacht','cruise','ferry'],k:[36,52],o:2},judge:{skin_variations:{'1F3FB':{unified:'1F9D1-1F3FB-200D-2696-FE0F',non_qualified:'1F9D1-1F3FB-200D-2696',image:'1f9d1-1f3fb-200d-2696-fe0f.png',sheet_x:47,sheet_y:56,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FC':{unified:'1F9D1-1F3FC-200D-2696-FE0F',non_qualified:'1F9D1-1F3FC-200D-2696',image:'1f9d1-1f3fc-200d-2696-fe0f.png',sheet_x:48,sheet_y:0,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FD':{unified:'1F9D1-1F3FD-200D-2696-FE0F',non_qualified:'1F9D1-1F3FD-200D-2696',image:'1f9d1-1f3fd-200d-2696-fe0f.png',sheet_x:48,sheet_y:1,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FE':{unified:'1F9D1-1F3FE-200D-2696-FE0F',non_qualified:'1F9D1-1F3FE-200D-2696',image:'1f9d1-1f3fe-200d-2696-fe0f.png',sheet_x:48,sheet_y:2,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FF':{unified:'1F9D1-1F3FF-200D-2696-FE0F',non_qualified:'1F9D1-1F3FF-200D-2696',image:'1f9d1-1f3ff-200d-2696-fe0f.png',sheet_x:48,sheet_y:3,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false}},a:'Judge',b:'1F9D1-200D-2696-FE0F',c:'1F9D1-200D-2696',k:[47,55],o:12},scroll:{a:'Scroll',b:'1F4DC',j:['documents','ancient','history','paper'],k:[26,50],o:2},blossom:{a:'Blossom',b:'1F33C',j:['nature','flowers','yellow'],k:[6,20],o:2},'flag-id':{a:'Indonesia Flag',b:'1F1EE-1F1E9',k:[2,23],o:2},speak_no_evil:{a:'Speak-No-Evil Monkey',b:'1F64A',j:['monkey','animal','nature','omg'],k:[32,46],o:2},heavy_minus_sign:{a:'Heavy Minus Sign',b:'2796',j:['math','calculation','subtract','less'],k:[55,30],o:2},'flag-ie':{a:'Ireland Flag',b:'1F1EE-1F1EA',k:[2,24],o:2},ice_cube:{a:'Ice Cube',b:'1F9CA',k:[44,18],o:12},page_facing_up:{a:'Page Facing Up',b:'1F4C4',j:['documents','office','paper','information'],k:[26,26],o:2},'male-judge':{skin_variations:{'1F3FB':{unified:'1F468-1F3FB-200D-2696-FE0F',non_qualified:'1F468-1F3FB-200D-2696',image:'1f468-1f3fb-200d-2696-fe0f.png',sheet_x:17,sheet_y:9,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F468-1F3FC-200D-2696-FE0F',non_qualified:'1F468-1F3FC-200D-2696',image:'1f468-1f3fc-200d-2696-fe0f.png',sheet_x:17,sheet_y:10,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F468-1F3FD-200D-2696-FE0F',non_qualified:'1F468-1F3FD-200D-2696',image:'1f468-1f3fd-200d-2696-fe0f.png',sheet_x:17,sheet_y:11,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F468-1F3FE-200D-2696-FE0F',non_qualified:'1F468-1F3FE-200D-2696',image:'1f468-1f3fe-200d-2696-fe0f.png',sheet_x:17,sheet_y:12,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F468-1F3FF-200D-2696-FE0F',non_qualified:'1F468-1F3FF-200D-2696',image:'1f468-1f3ff-200d-2696-fe0f.png',sheet_x:17,sheet_y:13,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Male Judge',b:'1F468-200D-2696-FE0F',c:'1F468-200D-2696',k:[17,8],o:4},tulip:{a:'Tulip',b:'1F337',j:['flowers','plant','nature','summer','spring'],k:[6,15],o:2},ferry:{a:'Ferry',b:'26F4-FE0F',c:'26F4',j:['boat','ship','yacht'],k:[54,15],o:2},kiss:{a:'Kiss Mark',b:'1F48B',j:['face','lips','love','like','affection','valentines'],k:[25,21],o:2},heavy_division_sign:{a:'Heavy Division Sign',b:'2797',j:['divide','math','calculation'],k:[55,31],o:2},newspaper:{a:'Newspaper',b:'1F4F0',j:['press','headline'],k:[27,13],o:2},'female-judge':{skin_variations:{'1F3FB':{unified:'1F469-1F3FB-200D-2696-FE0F',non_qualified:'1F469-1F3FB-200D-2696',image:'1f469-1f3fb-200d-2696-fe0f.png',sheet_x:19,sheet_y:51,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F469-1F3FC-200D-2696-FE0F',non_qualified:'1F469-1F3FC-200D-2696',image:'1f469-1f3fc-200d-2696-fe0f.png',sheet_x:19,sheet_y:52,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F469-1F3FD-200D-2696-FE0F',non_qualified:'1F469-1F3FD-200D-2696',image:'1f469-1f3fd-200d-2696-fe0f.png',sheet_x:19,sheet_y:53,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F469-1F3FE-200D-2696-FE0F',non_qualified:'1F469-1F3FE-200D-2696',image:'1f469-1f3fe-200d-2696-fe0f.png',sheet_x:19,sheet_y:54,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F469-1F3FF-200D-2696-FE0F',non_qualified:'1F469-1F3FF-200D-2696',image:'1f469-1f3ff-200d-2696-fe0f.png',sheet_x:19,sheet_y:55,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Female Judge',b:'1F469-200D-2696-FE0F',c:'1F469-200D-2696',k:[19,50],o:4},seedling:{a:'Seedling',b:'1F331',j:['plant','nature','grass','lawn','spring'],k:[6,9],o:2},love_letter:{a:'Love Letter',b:'1F48C',j:['email','like','affection','envelope','valentines'],k:[25,22],o:2},chopsticks:{a:'Chopsticks',b:'1F962',j:['food'],k:[41,49],o:5},motor_boat:{a:'Motor Boat',b:'1F6E5-FE0F',c:'1F6E5',j:['ship'],k:[36,47],o:2},'flag-il':{a:'Israel Flag',b:'1F1EE-1F1F1',k:[2,25],o:2},curly_loop:{a:'Curly Loop',b:'27B0',j:['scribble','draw','shape','squiggle'],k:[55,33],o:2},'flag-im':{a:'Isle of Man Flag',b:'1F1EE-1F1F2',k:[2,26],o:2},evergreen_tree:{a:'Evergreen Tree',b:'1F332',j:['plant','nature'],k:[6,10],o:2},cupid:{a:'Heart with Arrow',b:'1F498',j:['love','like','heart','affection','valentines'],k:[25,34],o:2},loop:{a:'Double Curly Loop',b:'27BF',j:['tape','cassette'],k:[55,34],o:2},ship:{a:'Ship',b:'1F6A2',j:['transportation','titanic','deploy'],k:[34,33],o:2},farmer:{skin_variations:{'1F3FB':{unified:'1F9D1-1F3FB-200D-1F33E',non_qualified:null,image:'1f9d1-1f3fb-200d-1f33e.png',sheet_x:45,sheet_y:18,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FC':{unified:'1F9D1-1F3FC-200D-1F33E',non_qualified:null,image:'1f9d1-1f3fc-200d-1f33e.png',sheet_x:45,sheet_y:19,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FD':{unified:'1F9D1-1F3FD-200D-1F33E',non_qualified:null,image:'1f9d1-1f3fd-200d-1f33e.png',sheet_x:45,sheet_y:20,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FE':{unified:'1F9D1-1F3FE-200D-1F33E',non_qualified:null,image:'1f9d1-1f3fe-200d-1f33e.png',sheet_x:45,sheet_y:21,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FF':{unified:'1F9D1-1F3FF-200D-1F33E',non_qualified:null,image:'1f9d1-1f3ff-200d-1f33e.png',sheet_x:45,sheet_y:22,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false}},a:'Farmer',b:'1F9D1-200D-1F33E',k:[45,17],o:12},rolled_up_newspaper:{a:'Rolled Up Newspaper',b:'1F5DE-FE0F',c:'1F5DE',k:[30,23],o:2},knife_fork_plate:{a:'Knife Fork Plate',b:'1F37D-FE0F',c:'1F37D',k:[7,28],o:2},fork_and_knife:{a:'Fork and Knife',b:'1F374',j:['cutlery','kitchen'],k:[7,19],o:2},'male-farmer':{skin_variations:{'1F3FB':{unified:'1F468-1F3FB-200D-1F33E',non_qualified:null,image:'1f468-1f3fb-200d-1f33e.png',sheet_x:14,sheet_y:39,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F468-1F3FC-200D-1F33E',non_qualified:null,image:'1f468-1f3fc-200d-1f33e.png',sheet_x:14,sheet_y:40,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F468-1F3FD-200D-1F33E',non_qualified:null,image:'1f468-1f3fd-200d-1f33e.png',sheet_x:14,sheet_y:41,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F468-1F3FE-200D-1F33E',non_qualified:null,image:'1f468-1f3fe-200d-1f33e.png',sheet_x:14,sheet_y:42,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F468-1F3FF-200D-1F33E',non_qualified:null,image:'1f468-1f3ff-200d-1f33e.png',sheet_x:14,sheet_y:43,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Male Farmer',b:'1F468-200D-1F33E',k:[14,38],o:4},bookmark_tabs:{a:'Bookmark Tabs',b:'1F4D1',j:['favorite','save','order','tidy'],k:[26,39],o:2},part_alternation_mark:{a:'Part Alternation Mark',b:'303D-FE0F',c:'303D',j:['graph','presentation','stats','business','economics','bad'],k:[55,45],o:2},'flag-in':{a:'India Flag',b:'1F1EE-1F1F3',k:[2,27],o:2},gift_heart:{a:'Heart with Ribbon',b:'1F49D',j:['love','valentines'],k:[25,39],o:2},airplane:{a:'Airplane',b:'2708-FE0F',c:'2708',j:['vehicle','transportation','flight','fly'],k:[54,41],o:2},deciduous_tree:{a:'Deciduous Tree',b:'1F333',j:['plant','nature'],k:[6,11],o:2},spoon:{a:'Spoon',b:'1F944',j:['cutlery','kitchen','tableware'],k:[41,20],o:4},'flag-io':{a:'British Indian Ocean Territory Flag',b:'1F1EE-1F1F4',k:[2,28],o:2},palm_tree:{a:'Palm Tree',b:'1F334',j:['plant','vegetable','nature','summer','beach','mojito','tropical'],k:[6,12],o:2},sparkling_heart:{a:'Sparkling Heart',b:'1F496',j:['love','like','affection','valentines'],k:[25,32],o:2},'female-farmer':{skin_variations:{'1F3FB':{unified:'1F469-1F3FB-200D-1F33E',non_qualified:null,image:'1f469-1f3fb-200d-1f33e.png',sheet_x:17,sheet_y:29,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F469-1F3FC-200D-1F33E',non_qualified:null,image:'1f469-1f3fc-200d-1f33e.png',sheet_x:17,sheet_y:30,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F469-1F3FD-200D-1F33E',non_qualified:null,image:'1f469-1f3fd-200d-1f33e.png',sheet_x:17,sheet_y:31,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F469-1F3FE-200D-1F33E',non_qualified:null,image:'1f469-1f3fe-200d-1f33e.png',sheet_x:17,sheet_y:32,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F469-1F3FF-200D-1F33E',non_qualified:null,image:'1f469-1f3ff-200d-1f33e.png',sheet_x:17,sheet_y:33,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Female Farmer',b:'1F469-200D-1F33E',k:[17,28],o:4},eight_spoked_asterisk:{a:'Eight Spoked Asterisk',b:'2733-FE0F',c:'2733',j:['star','sparkle','green-square'],k:[55,17],o:2},small_airplane:{a:'Small Airplane',b:'1F6E9-FE0F',c:'1F6E9',j:['flight','transportation','fly','vehicle'],k:[36,48],o:2},bookmark:{a:'Bookmark',b:'1F516',j:['favorite','label','save'],k:[27,50],o:2},cook:{skin_variations:{'1F3FB':{unified:'1F9D1-1F3FB-200D-1F373',non_qualified:null,image:'1f9d1-1f3fb-200d-1f373.png',sheet_x:45,sheet_y:24,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FC':{unified:'1F9D1-1F3FC-200D-1F373',non_qualified:null,image:'1f9d1-1f3fc-200d-1f373.png',sheet_x:45,sheet_y:25,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FD':{unified:'1F9D1-1F3FD-200D-1F373',non_qualified:null,image:'1f9d1-1f3fd-200d-1f373.png',sheet_x:45,sheet_y:26,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FE':{unified:'1F9D1-1F3FE-200D-1F373',non_qualified:null,image:'1f9d1-1f3fe-200d-1f373.png',sheet_x:45,sheet_y:27,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FF':{unified:'1F9D1-1F3FF-200D-1F373',non_qualified:null,image:'1f9d1-1f3ff-200d-1f373.png',sheet_x:45,sheet_y:28,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false}},a:'Cook',b:'1F9D1-200D-1F373',k:[45,23],o:12},eight_pointed_black_star:{a:'Eight Pointed Black Star',b:'2734-FE0F',c:'2734',j:['orange-square','shape','polygon'],k:[55,18],o:2},heartpulse:{a:'Growing Heart',b:'1F497',j:['like','love','affection','valentines','pink'],k:[25,33],o:2},label:{a:'Label',b:'1F3F7-FE0F',c:'1F3F7',j:['sale','tag'],k:[11,19],o:2},'flag-iq':{a:'Iraq Flag',b:'1F1EE-1F1F6',k:[2,29],o:2},hocho:{a:'Hocho',b:'1F52A',j:['knife','blade','cutlery','kitchen','weapon'],k:[28,13],n:['knife'],o:2},cactus:{a:'Cactus',b:'1F335',j:['vegetable','plant','nature'],k:[6,13],o:2},airplane_departure:{a:'Airplane Departure',b:'1F6EB',k:[36,49],o:2},airplane_arriving:{a:'Airplane Arriving',b:'1F6EC',k:[36,50],o:2},ear_of_rice:{a:'Ear of Rice',b:'1F33E',j:['nature','plant'],k:[6,22],o:2},'flag-ir':{a:'Iran Flag',b:'1F1EE-1F1F7',k:[2,30],o:2},moneybag:{a:'Money Bag',b:'1F4B0',j:['dollar','payment','coins','sale'],k:[26,6],o:2},'male-cook':{skin_variations:{'1F3FB':{unified:'1F468-1F3FB-200D-1F373',non_qualified:null,image:'1f468-1f3fb-200d-1f373.png',sheet_x:14,sheet_y:45,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F468-1F3FC-200D-1F373',non_qualified:null,image:'1f468-1f3fc-200d-1f373.png',sheet_x:14,sheet_y:46,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F468-1F3FD-200D-1F373',non_qualified:null,image:'1f468-1f3fd-200d-1f373.png',sheet_x:14,sheet_y:47,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F468-1F3FE-200D-1F373',non_qualified:null,image:'1f468-1f3fe-200d-1f373.png',sheet_x:14,sheet_y:48,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F468-1F3FF-200D-1F373',non_qualified:null,image:'1f468-1f3ff-200d-1f373.png',sheet_x:14,sheet_y:49,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Male Cook',b:'1F468-200D-1F373',k:[14,44],o:4},heartbeat:{a:'Beating Heart',b:'1F493',j:['love','like','affection','valentines','pink','heart'],k:[25,29],o:2},sparkle:{a:'Sparkle',b:'2747-FE0F',c:'2747',j:['stars','green-square','awesome','good','fireworks'],k:[55,20],o:2},amphora:{a:'Amphora',b:'1F3FA',j:['vase','jar'],k:[11,22],o:2},yen:{a:'Banknote with Yen Sign',b:'1F4B4',j:['money','sales','japanese','dollar','currency'],k:[26,10],o:2},revolving_hearts:{a:'Revolving Hearts',b:'1F49E',j:['love','like','affection','valentines'],k:[25,40],o:2},bangbang:{a:'Double Exclamation Mark',b:'203C-FE0F',c:'203C',j:['exclamation','surprise'],k:[52,10],o:2},parachute:{a:'Parachute',b:'1FA82',k:[52,3],o:12},herb:{a:'Herb',b:'1F33F',j:['vegetable','plant','medicine','weed','grass','lawn'],k:[6,23],o:2},'flag-is':{a:'Iceland Flag',b:'1F1EE-1F1F8',k:[2,31],o:2},'female-cook':{skin_variations:{'1F3FB':{unified:'1F469-1F3FB-200D-1F373',non_qualified:null,image:'1f469-1f3fb-200d-1f373.png',sheet_x:17,sheet_y:35,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F469-1F3FC-200D-1F373',non_qualified:null,image:'1f469-1f3fc-200d-1f373.png',sheet_x:17,sheet_y:36,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F469-1F3FD-200D-1F373',non_qualified:null,image:'1f469-1f3fd-200d-1f373.png',sheet_x:17,sheet_y:37,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F469-1F3FE-200D-1F373',non_qualified:null,image:'1f469-1f3fe-200d-1f373.png',sheet_x:17,sheet_y:38,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F469-1F3FF-200D-1F373',non_qualified:null,image:'1f469-1f3ff-200d-1f373.png',sheet_x:17,sheet_y:39,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Female Cook',b:'1F469-200D-1F373',k:[17,34],o:4},mechanic:{skin_variations:{'1F3FB':{unified:'1F9D1-1F3FB-200D-1F527',non_qualified:null,image:'1f9d1-1f3fb-200d-1f527.png',sheet_x:46,sheet_y:15,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FC':{unified:'1F9D1-1F3FC-200D-1F527',non_qualified:null,image:'1f9d1-1f3fc-200d-1f527.png',sheet_x:46,sheet_y:16,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FD':{unified:'1F9D1-1F3FD-200D-1F527',non_qualified:null,image:'1f9d1-1f3fd-200d-1f527.png',sheet_x:46,sheet_y:17,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FE':{unified:'1F9D1-1F3FE-200D-1F527',non_qualified:null,image:'1f9d1-1f3fe-200d-1f527.png',sheet_x:46,sheet_y:18,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FF':{unified:'1F9D1-1F3FF-200D-1F527',non_qualified:null,image:'1f9d1-1f3ff-200d-1f527.png',sheet_x:46,sheet_y:19,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false}},a:'Mechanic',b:'1F9D1-200D-1F527',k:[46,14],o:12},interrobang:{a:'Exclamation Question Mark',b:'2049-FE0F',c:'2049',j:['wat','punctuation','surprise'],k:[52,11],o:2},seat:{a:'Seat',b:'1F4BA',j:['sit','airplane','transport','bus','flight','fly'],k:[26,16],o:2},dollar:{a:'Banknote with Dollar Sign',b:'1F4B5',j:['money','sales','bill','currency'],k:[26,11],o:2},two_hearts:{a:'Two Hearts',b:'1F495',j:['love','like','affection','valentines','heart'],k:[25,31],o:2},it:{a:'Italy Flag',b:'1F1EE-1F1F9',j:['italy','flag','nation','country','banner'],k:[2,32],n:['flag-it'],o:2},shamrock:{a:'Shamrock',b:'2618-FE0F',c:'2618',j:['vegetable','plant','nature','irish','clover'],k:[53,1],o:2},four_leaf_clover:{a:'Four Leaf Clover',b:'1F340',j:['vegetable','plant','nature','lucky','irish'],k:[6,24],o:2},euro:{a:'Banknote with Euro Sign',b:'1F4B6',j:['money','sales','dollar','currency'],k:[26,12],o:2},question:{a:'Black Question Mark Ornament',b:'2753',j:['doubt','confused'],k:[55,23],o:2},helicopter:{a:'Helicopter',b:'1F681',j:['transportation','vehicle','fly'],k:[34,0],o:2},heart_decoration:{a:'Heart Decoration',b:'1F49F',j:['purple-square','love','like'],k:[25,41],o:2},'flag-je':{a:'Jersey Flag',b:'1F1EF-1F1EA',k:[2,33],o:2},'male-mechanic':{skin_variations:{'1F3FB':{unified:'1F468-1F3FB-200D-1F527',non_qualified:null,image:'1f468-1f3fb-200d-1f527.png',sheet_x:15,sheet_y:51,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F468-1F3FC-200D-1F527',non_qualified:null,image:'1f468-1f3fc-200d-1f527.png',sheet_x:15,sheet_y:52,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F468-1F3FD-200D-1F527',non_qualified:null,image:'1f468-1f3fd-200d-1f527.png',sheet_x:15,sheet_y:53,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F468-1F3FE-200D-1F527',non_qualified:null,image:'1f468-1f3fe-200d-1f527.png',sheet_x:15,sheet_y:54,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F468-1F3FF-200D-1F527',non_qualified:null,image:'1f468-1f3ff-200d-1f527.png',sheet_x:15,sheet_y:55,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Male Mechanic',b:'1F468-200D-1F527',k:[15,50],o:4},suspension_railway:{a:'Suspension Railway',b:'1F69F',j:['vehicle','transportation'],k:[34,30],o:2},heavy_heart_exclamation_mark_ornament:{a:'Heavy Heart Exclamation Mark Ornament',b:'2763-FE0F',c:'2763',k:[55,27],o:2},'female-mechanic':{skin_variations:{'1F3FB':{unified:'1F469-1F3FB-200D-1F527',non_qualified:null,image:'1f469-1f3fb-200d-1f527.png',sheet_x:18,sheet_y:36,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F469-1F3FC-200D-1F527',non_qualified:null,image:'1f469-1f3fc-200d-1f527.png',sheet_x:18,sheet_y:37,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F469-1F3FD-200D-1F527',non_qualified:null,image:'1f469-1f3fd-200d-1f527.png',sheet_x:18,sheet_y:38,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F469-1F3FE-200D-1F527',non_qualified:null,image:'1f469-1f3fe-200d-1f527.png',sheet_x:18,sheet_y:39,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F469-1F3FF-200D-1F527',non_qualified:null,image:'1f469-1f3ff-200d-1f527.png',sheet_x:18,sheet_y:40,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Female Mechanic',b:'1F469-200D-1F527',k:[18,35],o:4},'flag-jm':{a:'Jamaica Flag',b:'1F1EF-1F1F2',k:[2,34],o:2},grey_question:{a:'White Question Mark Ornament',b:'2754',j:['doubts','gray','huh','confused'],k:[55,24],o:2},maple_leaf:{a:'Maple Leaf',b:'1F341',j:['nature','plant','vegetable','ca','fall'],k:[6,25],o:2},pound:{a:'Banknote with Pound Sign',b:'1F4B7',j:['british','sterling','money','sales','bills','uk','england','currency'],k:[26,13],o:2},money_with_wings:{a:'Money with Wings',b:'1F4B8',j:['dollar','bills','payment','sale'],k:[26,14],o:2},'flag-jo':{a:'Jordan Flag',b:'1F1EF-1F1F4',k:[2,35],o:2},fallen_leaf:{a:'Fallen Leaf',b:'1F342',j:['nature','plant','vegetable','leaves'],k:[6,26],o:2},factory_worker:{skin_variations:{'1F3FB':{unified:'1F9D1-1F3FB-200D-1F3ED',non_qualified:null,image:'1f9d1-1f3fb-200d-1f3ed.png',sheet_x:45,sheet_y:54,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FC':{unified:'1F9D1-1F3FC-200D-1F3ED',non_qualified:null,image:'1f9d1-1f3fc-200d-1f3ed.png',sheet_x:45,sheet_y:55,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FD':{unified:'1F9D1-1F3FD-200D-1F3ED',non_qualified:null,image:'1f9d1-1f3fd-200d-1f3ed.png',sheet_x:45,sheet_y:56,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FE':{unified:'1F9D1-1F3FE-200D-1F3ED',non_qualified:null,image:'1f9d1-1f3fe-200d-1f3ed.png',sheet_x:46,sheet_y:0,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FF':{unified:'1F9D1-1F3FF-200D-1F3ED',non_qualified:null,image:'1f9d1-1f3ff-200d-1f3ed.png',sheet_x:46,sheet_y:1,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false}},a:'Factory Worker',b:'1F9D1-200D-1F3ED',k:[45,53],o:12},broken_heart:{a:'Broken Heart',b:'1F494',j:['sad','sorry','break','heart','heartbreak'],k:[25,30],l:['</3'],m:'</3',o:2},grey_exclamation:{a:'White Exclamation Mark Ornament',b:'2755',j:['surprise','punctuation','gray','wow','warning'],k:[55,25],o:2},mountain_cableway:{a:'Mountain Cableway',b:'1F6A0',j:['transportation','vehicle','ski'],k:[34,31],o:2},exclamation:{a:'Heavy Exclamation Mark Symbol',b:'2757',j:['heavy_exclamation_mark','danger','surprise','punctuation','wow','warning'],k:[55,26],n:['heavy_exclamation_mark'],o:2},leaves:{a:'Leaf Fluttering in Wind',b:'1F343',j:['nature','plant','tree','vegetable','grass','lawn','spring'],k:[6,27],o:2},heart:{a:'Heavy Black Heart',b:'2764-FE0F',c:'2764',j:['love','like','valentines'],k:[55,28],l:['<3'],m:'<3',o:2},jp:{a:'Japan Flag',b:'1F1EF-1F1F5',j:['japanese','nation','flag','country','banner'],k:[2,36],n:['flag-jp'],o:2},'male-factory-worker':{skin_variations:{'1F3FB':{unified:'1F468-1F3FB-200D-1F3ED',non_qualified:null,image:'1f468-1f3fb-200d-1f3ed.png',sheet_x:15,sheet_y:18,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F468-1F3FC-200D-1F3ED',non_qualified:null,image:'1f468-1f3fc-200d-1f3ed.png',sheet_x:15,sheet_y:19,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F468-1F3FD-200D-1F3ED',non_qualified:null,image:'1f468-1f3fd-200d-1f3ed.png',sheet_x:15,sheet_y:20,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F468-1F3FE-200D-1F3ED',non_qualified:null,image:'1f468-1f3fe-200d-1f3ed.png',sheet_x:15,sheet_y:21,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F468-1F3FF-200D-1F3ED',non_qualified:null,image:'1f468-1f3ff-200d-1f3ed.png',sheet_x:15,sheet_y:22,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Male Factory Worker',b:'1F468-200D-1F3ED',k:[15,17],o:4},credit_card:{a:'Credit Card',b:'1F4B3',j:['money','sales','dollar','bill','payment','shopping'],k:[26,9],o:2},aerial_tramway:{a:'Aerial Tramway',b:'1F6A1',j:['transportation','vehicle','ski'],k:[34,32],o:2},'female-factory-worker':{skin_variations:{'1F3FB':{unified:'1F469-1F3FB-200D-1F3ED',non_qualified:null,image:'1f469-1f3fb-200d-1f3ed.png',sheet_x:18,sheet_y:8,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F469-1F3FC-200D-1F3ED',non_qualified:null,image:'1f469-1f3fc-200d-1f3ed.png',sheet_x:18,sheet_y:9,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F469-1F3FD-200D-1F3ED',non_qualified:null,image:'1f469-1f3fd-200d-1f3ed.png',sheet_x:18,sheet_y:10,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F469-1F3FE-200D-1F3ED',non_qualified:null,image:'1f469-1f3fe-200d-1f3ed.png',sheet_x:18,sheet_y:11,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F469-1F3FF-200D-1F3ED',non_qualified:null,image:'1f469-1f3ff-200d-1f3ed.png',sheet_x:18,sheet_y:12,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Female Factory Worker',b:'1F469-200D-1F3ED',k:[18,7],o:4},receipt:{a:'Receipt',b:'1F9FE',k:[51,49],o:11},wavy_dash:{a:'Wavy Dash',b:'3030-FE0F',c:'3030',j:['draw','line','moustache','mustache','squiggle','scribble'],k:[55,44],o:2},'flag-ke':{a:'Kenya Flag',b:'1F1F0-1F1EA',k:[2,37],o:2},satellite:{a:'Satellite',b:'1F6F0-FE0F',c:'1F6F0',j:['communication','future','radio','space'],k:[36,51],o:2},orange_heart:{a:'Orange Heart',b:'1F9E1',j:['love','like','affection','valentines'],k:[51,20],o:5},yellow_heart:{a:'Yellow Heart',b:'1F49B',j:['love','like','affection','valentines'],k:[25,37],m:'<3',o:2},copyright:{a:'Copyright Sign',b:'00A9-FE0F',c:'00A9',j:['ip','license','circle','law','legal'],k:[0,12],o:2},rocket:{a:'Rocket',b:'1F680',j:['launch','ship','staffmode','NASA','outer space','outer_space','fly'],k:[33,56],o:2},chart:{a:'Chart with Upwards Trend and Yen Sign',b:'1F4B9',j:['green-square','graph','presentation','stats'],k:[26,15],o:2},'flag-kg':{a:'Kyrgyzstan Flag',b:'1F1F0-1F1EC',k:[2,38],o:2},office_worker:{skin_variations:{'1F3FB':{unified:'1F9D1-1F3FB-200D-1F4BC',non_qualified:null,image:'1f9d1-1f3fb-200d-1f4bc.png',sheet_x:46,sheet_y:9,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FC':{unified:'1F9D1-1F3FC-200D-1F4BC',non_qualified:null,image:'1f9d1-1f3fc-200d-1f4bc.png',sheet_x:46,sheet_y:10,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FD':{unified:'1F9D1-1F3FD-200D-1F4BC',non_qualified:null,image:'1f9d1-1f3fd-200d-1f4bc.png',sheet_x:46,sheet_y:11,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FE':{unified:'1F9D1-1F3FE-200D-1F4BC',non_qualified:null,image:'1f9d1-1f3fe-200d-1f4bc.png',sheet_x:46,sheet_y:12,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FF':{unified:'1F9D1-1F3FF-200D-1F4BC',non_qualified:null,image:'1f9d1-1f3ff-200d-1f4bc.png',sheet_x:46,sheet_y:13,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false}},a:'Office Worker',b:'1F9D1-200D-1F4BC',k:[46,8],o:12},currency_exchange:{a:'Currency Exchange',b:'1F4B1',j:['money','sales','dollar','travel'],k:[26,7],o:2},registered:{a:'Registered Sign',b:'00AE-FE0F',c:'00AE',j:['alphabet','circle'],k:[0,13],o:2},green_heart:{a:'Green Heart',b:'1F49A',j:['love','like','affection','valentines'],k:[25,36],m:'<3',o:2},flying_saucer:{a:'Flying Saucer',b:'1F6F8',j:['transportation','vehicle','ufo'],k:[37,0],o:5},'flag-kh':{a:'Cambodia Flag',b:'1F1F0-1F1ED',k:[2,39],o:2},'male-office-worker':{skin_variations:{'1F3FB':{unified:'1F468-1F3FB-200D-1F4BC',non_qualified:null,image:'1f468-1f3fb-200d-1f4bc.png',sheet_x:15,sheet_y:45,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F468-1F3FC-200D-1F4BC',non_qualified:null,image:'1f468-1f3fc-200d-1f4bc.png',sheet_x:15,sheet_y:46,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F468-1F3FD-200D-1F4BC',non_qualified:null,image:'1f468-1f3fd-200d-1f4bc.png',sheet_x:15,sheet_y:47,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F468-1F3FE-200D-1F4BC',non_qualified:null,image:'1f468-1f3fe-200d-1f4bc.png',sheet_x:15,sheet_y:48,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F468-1F3FF-200D-1F4BC',non_qualified:null,image:'1f468-1f3ff-200d-1f4bc.png',sheet_x:15,sheet_y:49,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Male Office Worker',b:'1F468-200D-1F4BC',k:[15,44],o:4},tm:{a:'Trade Mark Sign',b:'2122-FE0F',c:'2122',j:['trademark','brand','law','legal'],k:[52,12],o:2},bellhop_bell:{a:'Bellhop Bell',b:'1F6CE-FE0F',c:'1F6CE',j:['service'],k:[36,36],o:2},blue_heart:{a:'Blue Heart',b:'1F499',j:['love','like','affection','valentines'],k:[25,35],m:'<3',o:2},'flag-ki':{a:'Kiribati Flag',b:'1F1F0-1F1EE',k:[2,40],o:2},heavy_dollar_sign:{a:'Heavy Dollar Sign',b:'1F4B2',j:['money','sales','payment','currency','buck'],k:[26,8],o:2},'female-office-worker':{skin_variations:{'1F3FB':{unified:'1F469-1F3FB-200D-1F4BC',non_qualified:null,image:'1f469-1f3fb-200d-1f4bc.png',sheet_x:18,sheet_y:30,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F469-1F3FC-200D-1F4BC',non_qualified:null,image:'1f469-1f3fc-200d-1f4bc.png',sheet_x:18,sheet_y:31,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F469-1F3FD-200D-1F4BC',non_qualified:null,image:'1f469-1f3fd-200d-1f4bc.png',sheet_x:18,sheet_y:32,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F469-1F3FE-200D-1F4BC',non_qualified:null,image:'1f469-1f3fe-200d-1f4bc.png',sheet_x:18,sheet_y:33,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F469-1F3FF-200D-1F4BC',non_qualified:null,image:'1f469-1f3ff-200d-1f4bc.png',sheet_x:18,sheet_y:34,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Female Office Worker',b:'1F469-200D-1F4BC',k:[18,29],o:4},purple_heart:{a:'Purple Heart',b:'1F49C',j:['love','like','affection','valentines'],k:[25,38],m:'<3',o:2},scientist:{skin_variations:{'1F3FB':{unified:'1F9D1-1F3FB-200D-1F52C',non_qualified:null,image:'1f9d1-1f3fb-200d-1f52c.png',sheet_x:46,sheet_y:21,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FC':{unified:'1F9D1-1F3FC-200D-1F52C',non_qualified:null,image:'1f9d1-1f3fc-200d-1f52c.png',sheet_x:46,sheet_y:22,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FD':{unified:'1F9D1-1F3FD-200D-1F52C',non_qualified:null,image:'1f9d1-1f3fd-200d-1f52c.png',sheet_x:46,sheet_y:23,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FE':{unified:'1F9D1-1F3FE-200D-1F52C',non_qualified:null,image:'1f9d1-1f3fe-200d-1f52c.png',sheet_x:46,sheet_y:24,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FF':{unified:'1F9D1-1F3FF-200D-1F52C',non_qualified:null,image:'1f9d1-1f3ff-200d-1f52c.png',sheet_x:46,sheet_y:25,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false}},a:'Scientist',b:'1F9D1-200D-1F52C',k:[46,20],o:12},luggage:{a:'Luggage',b:'1F9F3',k:[51,38],o:11},hash:{a:'Hash Key',b:'0023-FE0F-20E3',c:'0023-20E3',j:['symbol','blue-square','twitter'],k:[0,0],o:0},'flag-km':{a:'Comoros Flag',b:'1F1F0-1F1F2',k:[2,41],o:2},email:{a:'Envelope',b:'2709-FE0F',c:'2709',j:['letter','postal','inbox','communication'],k:[54,42],n:['envelope'],o:2},'e-mail':{a:'E-Mail Symbol',b:'1F4E7',j:['communication','inbox'],k:[27,4],o:2},keycap_star:{a:'Keycap Star',b:'002A-FE0F-20E3',c:'002A-20E3',k:[0,1],o:0},'flag-kn':{a:'St. Kitts & Nevis Flag',b:'1F1F0-1F1F3',k:[2,42],o:2},hourglass:{a:'Hourglass',b:'231B',j:['time','clock','oldschool','limit','exam','quiz','test'],k:[52,23],o:2},brown_heart:{a:'Brown Heart',b:'1F90E',k:[37,16],o:12},'male-scientist':{skin_variations:{'1F3FB':{unified:'1F468-1F3FB-200D-1F52C',non_qualified:null,image:'1f468-1f3fb-200d-1f52c.png',sheet_x:16,sheet_y:0,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F468-1F3FC-200D-1F52C',non_qualified:null,image:'1f468-1f3fc-200d-1f52c.png',sheet_x:16,sheet_y:1,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F468-1F3FD-200D-1F52C',non_qualified:null,image:'1f468-1f3fd-200d-1f52c.png',sheet_x:16,sheet_y:2,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F468-1F3FE-200D-1F52C',non_qualified:null,image:'1f468-1f3fe-200d-1f52c.png',sheet_x:16,sheet_y:3,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F468-1F3FF-200D-1F52C',non_qualified:null,image:'1f468-1f3ff-200d-1f52c.png',sheet_x:16,sheet_y:4,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Male Scientist',b:'1F468-200D-1F52C',k:[15,56],o:4},hourglass_flowing_sand:{a:'Hourglass with Flowing Sand',b:'23F3',j:['oldschool','time','countdown'],k:[52,36],o:2},black_heart:{a:'Black Heart',b:'1F5A4',j:['evil'],k:[30,9],o:4},zero:{a:'Keycap 0',b:'0030-FE0F-20E3',c:'0030-20E3',j:['0','numbers','blue-square','null'],k:[0,2],o:0},incoming_envelope:{a:'Incoming Envelope',b:'1F4E8',j:['email','inbox'],k:[27,5],o:2},'flag-kp':{a:'North Korea Flag',b:'1F1F0-1F1F5',k:[2,43],o:2},'female-scientist':{skin_variations:{'1F3FB':{unified:'1F469-1F3FB-200D-1F52C',non_qualified:null,image:'1f469-1f3fb-200d-1f52c.png',sheet_x:18,sheet_y:42,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F469-1F3FC-200D-1F52C',non_qualified:null,image:'1f469-1f3fc-200d-1f52c.png',sheet_x:18,sheet_y:43,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F469-1F3FD-200D-1F52C',non_qualified:null,image:'1f469-1f3fd-200d-1f52c.png',sheet_x:18,sheet_y:44,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F469-1F3FE-200D-1F52C',non_qualified:null,image:'1f469-1f3fe-200d-1f52c.png',sheet_x:18,sheet_y:45,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F469-1F3FF-200D-1F52C',non_qualified:null,image:'1f469-1f3ff-200d-1f52c.png',sheet_x:18,sheet_y:46,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Female Scientist',b:'1F469-200D-1F52C',k:[18,41],o:4},watch:{a:'Watch',b:'231A',j:['time','accessories'],k:[52,22],o:2},white_heart:{a:'White Heart',b:'1F90D',k:[37,15],o:12},one:{a:'Keycap 1',b:'0031-FE0F-20E3',c:'0031-20E3',j:['blue-square','numbers','1'],k:[0,3],o:0},kr:{a:'South Korea Flag',b:'1F1F0-1F1F7',j:['south','korea','nation','flag','country','banner'],k:[2,44],n:['flag-kr'],o:2},envelope_with_arrow:{a:'Envelope with Downwards Arrow Above',b:'1F4E9',j:['email','communication'],k:[27,6],o:2},technologist:{skin_variations:{'1F3FB':{unified:'1F9D1-1F3FB-200D-1F4BB',non_qualified:null,image:'1f9d1-1f3fb-200d-1f4bb.png',sheet_x:46,sheet_y:3,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FC':{unified:'1F9D1-1F3FC-200D-1F4BB',non_qualified:null,image:'1f9d1-1f3fc-200d-1f4bb.png',sheet_x:46,sheet_y:4,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FD':{unified:'1F9D1-1F3FD-200D-1F4BB',non_qualified:null,image:'1f9d1-1f3fd-200d-1f4bb.png',sheet_x:46,sheet_y:5,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FE':{unified:'1F9D1-1F3FE-200D-1F4BB',non_qualified:null,image:'1f9d1-1f3fe-200d-1f4bb.png',sheet_x:46,sheet_y:6,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FF':{unified:'1F9D1-1F3FF-200D-1F4BB',non_qualified:null,image:'1f9d1-1f3ff-200d-1f4bb.png',sheet_x:46,sheet_y:7,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false}},a:'Technologist',b:'1F9D1-200D-1F4BB',k:[46,2],o:12},outbox_tray:{a:'Outbox Tray',b:'1F4E4',j:['inbox','email'],k:[27,1],o:2},'male-technologist':{skin_variations:{'1F3FB':{unified:'1F468-1F3FB-200D-1F4BB',non_qualified:null,image:'1f468-1f3fb-200d-1f4bb.png',sheet_x:15,sheet_y:39,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F468-1F3FC-200D-1F4BB',non_qualified:null,image:'1f468-1f3fc-200d-1f4bb.png',sheet_x:15,sheet_y:40,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F468-1F3FD-200D-1F4BB',non_qualified:null,image:'1f468-1f3fd-200d-1f4bb.png',sheet_x:15,sheet_y:41,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F468-1F3FE-200D-1F4BB',non_qualified:null,image:'1f468-1f3fe-200d-1f4bb.png',sheet_x:15,sheet_y:42,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F468-1F3FF-200D-1F4BB',non_qualified:null,image:'1f468-1f3ff-200d-1f4bb.png',sheet_x:15,sheet_y:43,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Male Technologist',b:'1F468-200D-1F4BB',k:[15,38],o:4},alarm_clock:{a:'Alarm Clock',b:'23F0',j:['time','wake'],k:[52,33],o:2},'flag-kw':{a:'Kuwait Flag',b:'1F1F0-1F1FC',k:[2,45],o:2},two:{a:'Keycap 2',b:'0032-FE0F-20E3',c:'0032-20E3',j:['numbers','2','prime','blue-square'],k:[0,4],o:0},anger:{a:'Anger Symbol',b:'1F4A2',j:['angry','mad'],k:[25,44],o:2},inbox_tray:{a:'Inbox Tray',b:'1F4E5',j:['email','documents'],k:[27,2],o:2},three:{a:'Keycap 3',b:'0033-FE0F-20E3',c:'0033-20E3',j:['3','numbers','prime','blue-square'],k:[0,5],o:0},'flag-ky':{a:'Cayman Islands Flag',b:'1F1F0-1F1FE',k:[2,46],o:2},stopwatch:{a:'Stopwatch',b:'23F1-FE0F',c:'23F1',j:['time','deadline'],k:[52,34],o:2},'female-technologist':{skin_variations:{'1F3FB':{unified:'1F469-1F3FB-200D-1F4BB',non_qualified:null,image:'1f469-1f3fb-200d-1f4bb.png',sheet_x:18,sheet_y:24,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F469-1F3FC-200D-1F4BB',non_qualified:null,image:'1f469-1f3fc-200d-1f4bb.png',sheet_x:18,sheet_y:25,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F469-1F3FD-200D-1F4BB',non_qualified:null,image:'1f469-1f3fd-200d-1f4bb.png',sheet_x:18,sheet_y:26,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F469-1F3FE-200D-1F4BB',non_qualified:null,image:'1f469-1f3fe-200d-1f4bb.png',sheet_x:18,sheet_y:27,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F469-1F3FF-200D-1F4BB',non_qualified:null,image:'1f469-1f3ff-200d-1f4bb.png',sheet_x:18,sheet_y:28,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Female Technologist',b:'1F469-200D-1F4BB',k:[18,23],o:4},boom:{a:'Collision Symbol',b:'1F4A5',j:['bomb','explode','explosion','collision','blown'],k:[25,47],n:['collision'],o:2},'flag-kz':{a:'Kazakhstan Flag',b:'1F1F0-1F1FF',k:[2,47],o:2},four:{a:'Keycap 4',b:'0034-FE0F-20E3',c:'0034-20E3',j:['4','numbers','blue-square'],k:[0,6],o:0},timer_clock:{a:'Timer Clock',b:'23F2-FE0F',c:'23F2',j:['alarm'],k:[52,35],o:2},singer:{skin_variations:{'1F3FB':{unified:'1F9D1-1F3FB-200D-1F3A4',non_qualified:null,image:'1f9d1-1f3fb-200d-1f3a4.png',sheet_x:45,sheet_y:36,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FC':{unified:'1F9D1-1F3FC-200D-1F3A4',non_qualified:null,image:'1f9d1-1f3fc-200d-1f3a4.png',sheet_x:45,sheet_y:37,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FD':{unified:'1F9D1-1F3FD-200D-1F3A4',non_qualified:null,image:'1f9d1-1f3fd-200d-1f3a4.png',sheet_x:45,sheet_y:38,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FE':{unified:'1F9D1-1F3FE-200D-1F3A4',non_qualified:null,image:'1f9d1-1f3fe-200d-1f3a4.png',sheet_x:45,sheet_y:39,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FF':{unified:'1F9D1-1F3FF-200D-1F3A4',non_qualified:null,image:'1f9d1-1f3ff-200d-1f3a4.png',sheet_x:45,sheet_y:40,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false}},a:'Singer',b:'1F9D1-200D-1F3A4',k:[45,35],o:12},package:{a:'Package',b:'1F4E6',j:['mail','gift','cardboard','box','moving'],k:[27,3],o:2},mailbox:{a:'Closed Mailbox with Raised Flag',b:'1F4EB',j:['email','inbox','communication'],k:[27,8],o:2},'flag-la':{a:'Laos Flag',b:'1F1F1-1F1E6',k:[2,48],o:2},dizzy:{a:'Dizzy Symbol',b:'1F4AB',j:['star','sparkle','shoot','magic'],k:[26,1],o:2},five:{a:'Keycap 5',b:'0035-FE0F-20E3',c:'0035-20E3',j:['5','numbers','blue-square','prime'],k:[0,7],o:0},'male-singer':{skin_variations:{'1F3FB':{unified:'1F468-1F3FB-200D-1F3A4',non_qualified:null,image:'1f468-1f3fb-200d-1f3a4.png',sheet_x:15,sheet_y:0,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F468-1F3FC-200D-1F3A4',non_qualified:null,image:'1f468-1f3fc-200d-1f3a4.png',sheet_x:15,sheet_y:1,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F468-1F3FD-200D-1F3A4',non_qualified:null,image:'1f468-1f3fd-200d-1f3a4.png',sheet_x:15,sheet_y:2,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F468-1F3FE-200D-1F3A4',non_qualified:null,image:'1f468-1f3fe-200d-1f3a4.png',sheet_x:15,sheet_y:3,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F468-1F3FF-200D-1F3A4',non_qualified:null,image:'1f468-1f3ff-200d-1f3a4.png',sheet_x:15,sheet_y:4,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Male Singer',b:'1F468-200D-1F3A4',k:[14,56],o:4},mantelpiece_clock:{a:'Mantelpiece Clock',b:'1F570-FE0F',c:'1F570',j:['time'],k:[29,7],o:2},'female-singer':{skin_variations:{'1F3FB':{unified:'1F469-1F3FB-200D-1F3A4',non_qualified:null,image:'1f469-1f3fb-200d-1f3a4.png',sheet_x:17,sheet_y:47,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F469-1F3FC-200D-1F3A4',non_qualified:null,image:'1f469-1f3fc-200d-1f3a4.png',sheet_x:17,sheet_y:48,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F469-1F3FD-200D-1F3A4',non_qualified:null,image:'1f469-1f3fd-200d-1f3a4.png',sheet_x:17,sheet_y:49,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F469-1F3FE-200D-1F3A4',non_qualified:null,image:'1f469-1f3fe-200d-1f3a4.png',sheet_x:17,sheet_y:50,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F469-1F3FF-200D-1F3A4',non_qualified:null,image:'1f469-1f3ff-200d-1f3a4.png',sheet_x:17,sheet_y:51,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Female Singer',b:'1F469-200D-1F3A4',k:[17,46],o:4},'flag-lb':{a:'Lebanon Flag',b:'1F1F1-1F1E7',k:[2,49],o:2},six:{a:'Keycap 6',b:'0036-FE0F-20E3',c:'0036-20E3',j:['6','numbers','blue-square'],k:[0,8],o:0},mailbox_closed:{a:'Closed Mailbox with Lowered Flag',b:'1F4EA',j:['email','communication','inbox'],k:[27,7],o:2},sweat_drops:{a:'Splashing Sweat Symbol',b:'1F4A6',j:['water','drip','oops'],k:[25,48],o:2},clock12:{a:'Clock Face Twelve Oclock',b:'1F55B',j:['time','noon','midnight','midday','late','early','schedule'],k:[28,50],o:2},seven:{a:'Keycap 7',b:'0037-FE0F-20E3',c:'0037-20E3',j:['7','numbers','blue-square','prime'],k:[0,9],o:0},mailbox_with_mail:{a:'Open Mailbox with Raised Flag',b:'1F4EC',j:['email','inbox','communication'],k:[27,9],o:2},clock1230:{a:'Clock Face Twelve-Thirty',b:'1F567',j:['time','late','early','schedule'],k:[29,5],o:2},dash:{a:'Dash Symbol',b:'1F4A8',j:['wind','air','fast','shoo','fart','smoke','puff'],k:[25,50],o:2},artist:{skin_variations:{'1F3FB':{unified:'1F9D1-1F3FB-200D-1F3A8',non_qualified:null,image:'1f9d1-1f3fb-200d-1f3a8.png',sheet_x:45,sheet_y:42,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FC':{unified:'1F9D1-1F3FC-200D-1F3A8',non_qualified:null,image:'1f9d1-1f3fc-200d-1f3a8.png',sheet_x:45,sheet_y:43,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FD':{unified:'1F9D1-1F3FD-200D-1F3A8',non_qualified:null,image:'1f9d1-1f3fd-200d-1f3a8.png',sheet_x:45,sheet_y:44,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FE':{unified:'1F9D1-1F3FE-200D-1F3A8',non_qualified:null,image:'1f9d1-1f3fe-200d-1f3a8.png',sheet_x:45,sheet_y:45,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FF':{unified:'1F9D1-1F3FF-200D-1F3A8',non_qualified:null,image:'1f9d1-1f3ff-200d-1f3a8.png',sheet_x:45,sheet_y:46,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false}},a:'Artist',b:'1F9D1-200D-1F3A8',k:[45,41],o:12},'flag-lc':{a:'St. Lucia Flag',b:'1F1F1-1F1E8',k:[2,50],o:2},hole:{a:'Hole',b:'1F573-FE0F',c:'1F573',j:['embarrassing'],k:[29,8],o:2},'male-artist':{skin_variations:{'1F3FB':{unified:'1F468-1F3FB-200D-1F3A8',non_qualified:null,image:'1f468-1f3fb-200d-1f3a8.png',sheet_x:15,sheet_y:6,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F468-1F3FC-200D-1F3A8',non_qualified:null,image:'1f468-1f3fc-200d-1f3a8.png',sheet_x:15,sheet_y:7,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F468-1F3FD-200D-1F3A8',non_qualified:null,image:'1f468-1f3fd-200d-1f3a8.png',sheet_x:15,sheet_y:8,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F468-1F3FE-200D-1F3A8',non_qualified:null,image:'1f468-1f3fe-200d-1f3a8.png',sheet_x:15,sheet_y:9,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F468-1F3FF-200D-1F3A8',non_qualified:null,image:'1f468-1f3ff-200d-1f3a8.png',sheet_x:15,sheet_y:10,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Male Artist',b:'1F468-200D-1F3A8',k:[15,5],o:4},clock1:{a:'Clock Face One Oclock',b:'1F550',j:['time','late','early','schedule'],k:[28,39],o:2},eight:{a:'Keycap 8',b:'0038-FE0F-20E3',c:'0038-20E3',j:['8','blue-square','numbers'],k:[0,10],o:0},mailbox_with_no_mail:{a:'Open Mailbox with Lowered Flag',b:'1F4ED',j:['email','inbox'],k:[27,10],o:2},'flag-li':{a:'Liechtenstein Flag',b:'1F1F1-1F1EE',k:[2,51],o:2},bomb:{a:'Bomb',b:'1F4A3',j:['boom','explode','explosion','terrorism'],k:[25,45],o:2},nine:{a:'Keycap 9',b:'0039-FE0F-20E3',c:'0039-20E3',j:['blue-square','numbers','9'],k:[0,11],o:0},postbox:{a:'Postbox',b:'1F4EE',j:['email','letter','envelope'],k:[27,11],o:2},'female-artist':{skin_variations:{'1F3FB':{unified:'1F469-1F3FB-200D-1F3A8',non_qualified:null,image:'1f469-1f3fb-200d-1f3a8.png',sheet_x:17,sheet_y:53,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F469-1F3FC-200D-1F3A8',non_qualified:null,image:'1f469-1f3fc-200d-1f3a8.png',sheet_x:17,sheet_y:54,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F469-1F3FD-200D-1F3A8',non_qualified:null,image:'1f469-1f3fd-200d-1f3a8.png',sheet_x:17,sheet_y:55,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F469-1F3FE-200D-1F3A8',non_qualified:null,image:'1f469-1f3fe-200d-1f3a8.png',sheet_x:17,sheet_y:56,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F469-1F3FF-200D-1F3A8',non_qualified:null,image:'1f469-1f3ff-200d-1f3a8.png',sheet_x:18,sheet_y:0,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Female Artist',b:'1F469-200D-1F3A8',k:[17,52],o:4},clock130:{a:'Clock Face One-Thirty',b:'1F55C',j:['time','late','early','schedule'],k:[28,51],o:2},'flag-lk':{a:'Sri Lanka Flag',b:'1F1F1-1F1F0',k:[2,52],o:2},ballot_box_with_ballot:{a:'Ballot Box with Ballot',b:'1F5F3-FE0F',c:'1F5F3',k:[30,28],o:2},pilot:{skin_variations:{'1F3FB':{unified:'1F9D1-1F3FB-200D-2708-FE0F',non_qualified:'1F9D1-1F3FB-200D-2708',image:'1f9d1-1f3fb-200d-2708-fe0f.png',sheet_x:48,sheet_y:5,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FC':{unified:'1F9D1-1F3FC-200D-2708-FE0F',non_qualified:'1F9D1-1F3FC-200D-2708',image:'1f9d1-1f3fc-200d-2708-fe0f.png',sheet_x:48,sheet_y:6,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FD':{unified:'1F9D1-1F3FD-200D-2708-FE0F',non_qualified:'1F9D1-1F3FD-200D-2708',image:'1f9d1-1f3fd-200d-2708-fe0f.png',sheet_x:48,sheet_y:7,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FE':{unified:'1F9D1-1F3FE-200D-2708-FE0F',non_qualified:'1F9D1-1F3FE-200D-2708',image:'1f9d1-1f3fe-200d-2708-fe0f.png',sheet_x:48,sheet_y:8,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FF':{unified:'1F9D1-1F3FF-200D-2708-FE0F',non_qualified:'1F9D1-1F3FF-200D-2708',image:'1f9d1-1f3ff-200d-2708-fe0f.png',sheet_x:48,sheet_y:9,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false}},a:'Pilot',b:'1F9D1-200D-2708-FE0F',c:'1F9D1-200D-2708',k:[48,4],o:12},keycap_ten:{a:'Keycap Ten',b:'1F51F',j:['numbers','10','blue-square'],k:[28,2],o:2},clock2:{a:'Clock Face Two Oclock',b:'1F551',j:['time','late','early','schedule'],k:[28,40],o:2},'flag-lr':{a:'Liberia Flag',b:'1F1F1-1F1F7',k:[2,53],o:2},speech_balloon:{a:'Speech Balloon',b:'1F4AC',j:['bubble','words','message','talk','chatting'],k:[26,2],o:2},'eye-in-speech-bubble':{a:'Eye in Speech Bubble',b:'1F441-FE0F-200D-1F5E8-FE0F',k:[12,37],o:2},'flag-ls':{a:'Lesotho Flag',b:'1F1F1-1F1F8',k:[2,54],o:2},clock230:{a:'Clock Face Two-Thirty',b:'1F55D',j:['time','late','early','schedule'],k:[28,52],o:2},'male-pilot':{skin_variations:{'1F3FB':{unified:'1F468-1F3FB-200D-2708-FE0F',non_qualified:'1F468-1F3FB-200D-2708',image:'1f468-1f3fb-200d-2708-fe0f.png',sheet_x:17,sheet_y:15,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F468-1F3FC-200D-2708-FE0F',non_qualified:'1F468-1F3FC-200D-2708',image:'1f468-1f3fc-200d-2708-fe0f.png',sheet_x:17,sheet_y:16,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F468-1F3FD-200D-2708-FE0F',non_qualified:'1F468-1F3FD-200D-2708',image:'1f468-1f3fd-200d-2708-fe0f.png',sheet_x:17,sheet_y:17,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F468-1F3FE-200D-2708-FE0F',non_qualified:'1F468-1F3FE-200D-2708',image:'1f468-1f3fe-200d-2708-fe0f.png',sheet_x:17,sheet_y:18,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F468-1F3FF-200D-2708-FE0F',non_qualified:'1F468-1F3FF-200D-2708',image:'1f468-1f3ff-200d-2708-fe0f.png',sheet_x:17,sheet_y:19,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Male Pilot',b:'1F468-200D-2708-FE0F',c:'1F468-200D-2708',k:[17,14],o:4},capital_abcd:{a:'Input Symbol for Latin Capital Letters',b:'1F520',j:['alphabet','words','blue-square'],k:[28,3],o:2},pencil2:{a:'Pencil',b:'270F-FE0F',c:'270F',j:['stationery','write','paper','writing','school','study'],k:[55,10],o:2},'female-pilot':{skin_variations:{'1F3FB':{unified:'1F469-1F3FB-200D-2708-FE0F',non_qualified:'1F469-1F3FB-200D-2708',image:'1f469-1f3fb-200d-2708-fe0f.png',sheet_x:20,sheet_y:0,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F469-1F3FC-200D-2708-FE0F',non_qualified:'1F469-1F3FC-200D-2708',image:'1f469-1f3fc-200d-2708-fe0f.png',sheet_x:20,sheet_y:1,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F469-1F3FD-200D-2708-FE0F',non_qualified:'1F469-1F3FD-200D-2708',image:'1f469-1f3fd-200d-2708-fe0f.png',sheet_x:20,sheet_y:2,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F469-1F3FE-200D-2708-FE0F',non_qualified:'1F469-1F3FE-200D-2708',image:'1f469-1f3fe-200d-2708-fe0f.png',sheet_x:20,sheet_y:3,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F469-1F3FF-200D-2708-FE0F',non_qualified:'1F469-1F3FF-200D-2708',image:'1f469-1f3ff-200d-2708-fe0f.png',sheet_x:20,sheet_y:4,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Female Pilot',b:'1F469-200D-2708-FE0F',c:'1F469-200D-2708',k:[19,56],o:4},black_nib:{a:'Black Nib',b:'2712-FE0F',c:'2712',j:['pen','stationery','writing','write'],k:[55,11],o:2},left_speech_bubble:{a:'Left Speech Bubble',b:'1F5E8-FE0F',c:'1F5E8',j:['words','message','talk','chatting'],k:[30,26],o:2},clock3:{a:'Clock Face Three Oclock',b:'1F552',j:['time','late','early','schedule'],k:[28,41],o:2},abcd:{a:'Input Symbol for Latin Small Letters',b:'1F521',j:['blue-square','alphabet'],k:[28,4],o:2},'flag-lt':{a:'Lithuania Flag',b:'1F1F1-1F1F9',k:[2,55],o:2},clock330:{a:'Clock Face Three-Thirty',b:'1F55E',j:['time','late','early','schedule'],k:[28,53],o:2},astronaut:{skin_variations:{'1F3FB':{unified:'1F9D1-1F3FB-200D-1F680',non_qualified:null,image:'1f9d1-1f3fb-200d-1f680.png',sheet_x:46,sheet_y:27,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FC':{unified:'1F9D1-1F3FC-200D-1F680',non_qualified:null,image:'1f9d1-1f3fc-200d-1f680.png',sheet_x:46,sheet_y:28,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FD':{unified:'1F9D1-1F3FD-200D-1F680',non_qualified:null,image:'1f9d1-1f3fd-200d-1f680.png',sheet_x:46,sheet_y:29,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FE':{unified:'1F9D1-1F3FE-200D-1F680',non_qualified:null,image:'1f9d1-1f3fe-200d-1f680.png',sheet_x:46,sheet_y:30,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FF':{unified:'1F9D1-1F3FF-200D-1F680',non_qualified:null,image:'1f9d1-1f3ff-200d-1f680.png',sheet_x:46,sheet_y:31,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false}},a:'Astronaut',b:'1F9D1-200D-1F680',k:[46,26],o:12},'flag-lu':{a:'Luxembourg Flag',b:'1F1F1-1F1FA',k:[2,56],o:2},right_anger_bubble:{a:'Right Anger Bubble',b:'1F5EF-FE0F',c:'1F5EF',j:['caption','speech','thinking','mad'],k:[30,27],o:2},lower_left_fountain_pen:{a:'Lower Left Fountain Pen',b:'1F58B-FE0F',c:'1F58B',k:[29,45],o:2},'male-astronaut':{skin_variations:{'1F3FB':{unified:'1F468-1F3FB-200D-1F680',non_qualified:null,image:'1f468-1f3fb-200d-1f680.png',sheet_x:16,sheet_y:6,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F468-1F3FC-200D-1F680',non_qualified:null,image:'1f468-1f3fc-200d-1f680.png',sheet_x:16,sheet_y:7,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F468-1F3FD-200D-1F680',non_qualified:null,image:'1f468-1f3fd-200d-1f680.png',sheet_x:16,sheet_y:8,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F468-1F3FE-200D-1F680',non_qualified:null,image:'1f468-1f3fe-200d-1f680.png',sheet_x:16,sheet_y:9,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F468-1F3FF-200D-1F680',non_qualified:null,image:'1f468-1f3ff-200d-1f680.png',sheet_x:16,sheet_y:10,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Male Astronaut',b:'1F468-200D-1F680',k:[16,5],o:4},thought_balloon:{a:'Thought Balloon',b:'1F4AD',j:['bubble','cloud','speech','thinking','dream'],k:[26,3],o:2},symbols:{a:'Input Symbol for Symbols',b:'1F523',j:['blue-square','music','note','ampersand','percent','glyphs','characters'],k:[28,6],o:2},clock4:{a:'Clock Face Four Oclock',b:'1F553',j:['time','late','early','schedule'],k:[28,42],o:2},'flag-lv':{a:'Latvia Flag',b:'1F1F1-1F1FB',k:[3,0],o:2},lower_left_ballpoint_pen:{a:'Lower Left Ballpoint Pen',b:'1F58A-FE0F',c:'1F58A',k:[29,44],o:2},abc:{a:'Input Symbol for Latin Letters',b:'1F524',j:['blue-square','alphabet'],k:[28,7],o:2},zzz:{a:'Sleeping Symbol',b:'1F4A4',j:['sleepy','tired','dream'],k:[25,46],o:2},lower_left_paintbrush:{a:'Lower Left Paintbrush',b:'1F58C-FE0F',c:'1F58C',k:[29,46],o:2},'female-astronaut':{skin_variations:{'1F3FB':{unified:'1F469-1F3FB-200D-1F680',non_qualified:null,image:'1f469-1f3fb-200d-1f680.png',sheet_x:18,sheet_y:48,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F469-1F3FC-200D-1F680',non_qualified:null,image:'1f469-1f3fc-200d-1f680.png',sheet_x:18,sheet_y:49,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F469-1F3FD-200D-1F680',non_qualified:null,image:'1f469-1f3fd-200d-1f680.png',sheet_x:18,sheet_y:50,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F469-1F3FE-200D-1F680',non_qualified:null,image:'1f469-1f3fe-200d-1f680.png',sheet_x:18,sheet_y:51,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F469-1F3FF-200D-1F680',non_qualified:null,image:'1f469-1f3ff-200d-1f680.png',sheet_x:18,sheet_y:52,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Female Astronaut',b:'1F469-200D-1F680',k:[18,47],o:4},'flag-ly':{a:'Libya Flag',b:'1F1F1-1F1FE',k:[3,1],o:2},clock430:{a:'Clock Face Four-Thirty',b:'1F55F',j:['time','late','early','schedule'],k:[28,54],o:2},'flag-ma':{a:'Morocco Flag',b:'1F1F2-1F1E6',k:[3,2],o:2},a:{a:'Negative Squared Latin Capital Letter a',b:'1F170-FE0F',c:'1F170',j:['red-square','alphabet','letter'],k:[0,16],o:2},clock5:{a:'Clock Face Five Oclock',b:'1F554',j:['time','late','early','schedule'],k:[28,43],o:2},lower_left_crayon:{a:'Lower Left Crayon',b:'1F58D-FE0F',c:'1F58D',k:[29,47],o:2},firefighter:{skin_variations:{'1F3FB':{unified:'1F9D1-1F3FB-200D-1F692',non_qualified:null,image:'1f9d1-1f3fb-200d-1f692.png',sheet_x:46,sheet_y:33,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FC':{unified:'1F9D1-1F3FC-200D-1F692',non_qualified:null,image:'1f9d1-1f3fc-200d-1f692.png',sheet_x:46,sheet_y:34,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FD':{unified:'1F9D1-1F3FD-200D-1F692',non_qualified:null,image:'1f9d1-1f3fd-200d-1f692.png',sheet_x:46,sheet_y:35,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FE':{unified:'1F9D1-1F3FE-200D-1F692',non_qualified:null,image:'1f9d1-1f3fe-200d-1f692.png',sheet_x:46,sheet_y:36,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FF':{unified:'1F9D1-1F3FF-200D-1F692',non_qualified:null,image:'1f9d1-1f3ff-200d-1f692.png',sheet_x:46,sheet_y:37,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false}},a:'Firefighter',b:'1F9D1-200D-1F692',k:[46,32],o:12},'male-firefighter':{skin_variations:{'1F3FB':{unified:'1F468-1F3FB-200D-1F692',non_qualified:null,image:'1f468-1f3fb-200d-1f692.png',sheet_x:16,sheet_y:12,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F468-1F3FC-200D-1F692',non_qualified:null,image:'1f468-1f3fc-200d-1f692.png',sheet_x:16,sheet_y:13,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F468-1F3FD-200D-1F692',non_qualified:null,image:'1f468-1f3fd-200d-1f692.png',sheet_x:16,sheet_y:14,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F468-1F3FE-200D-1F692',non_qualified:null,image:'1f468-1f3fe-200d-1f692.png',sheet_x:16,sheet_y:15,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F468-1F3FF-200D-1F692',non_qualified:null,image:'1f468-1f3ff-200d-1f692.png',sheet_x:16,sheet_y:16,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Male Firefighter',b:'1F468-200D-1F692',k:[16,11],o:4},memo:{a:'Memo',b:'1F4DD',j:['write','documents','stationery','pencil','paper','writing','legal','exam','quiz','test','study','compose'],k:[26,51],n:['pencil'],o:2},ab:{a:'Negative Squared Ab',b:'1F18E',j:['red-square','alphabet'],k:[0,20],o:2},'flag-mc':{a:'Monaco Flag',b:'1F1F2-1F1E8',k:[3,3],o:2},clock530:{a:'Clock Face Five-Thirty',b:'1F560',j:['time','late','early','schedule'],k:[28,55],o:2},briefcase:{a:'Briefcase',b:'1F4BC',j:['business','documents','work','law','legal','job','career'],k:[26,18],o:2},'female-firefighter':{skin_variations:{'1F3FB':{unified:'1F469-1F3FB-200D-1F692',non_qualified:null,image:'1f469-1f3fb-200d-1f692.png',sheet_x:18,sheet_y:54,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F469-1F3FC-200D-1F692',non_qualified:null,image:'1f469-1f3fc-200d-1f692.png',sheet_x:18,sheet_y:55,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F469-1F3FD-200D-1F692',non_qualified:null,image:'1f469-1f3fd-200d-1f692.png',sheet_x:18,sheet_y:56,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F469-1F3FE-200D-1F692',non_qualified:null,image:'1f469-1f3fe-200d-1f692.png',sheet_x:19,sheet_y:0,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F469-1F3FF-200D-1F692',non_qualified:null,image:'1f469-1f3ff-200d-1f692.png',sheet_x:19,sheet_y:1,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Female Firefighter',b:'1F469-200D-1F692',k:[18,53],o:4},clock6:{a:'Clock Face Six Oclock',b:'1F555',j:['time','late','early','schedule','dawn','dusk'],k:[28,44],o:2},b:{a:'Negative Squared Latin Capital Letter B',b:'1F171-FE0F',c:'1F171',j:['red-square','alphabet','letter'],k:[0,17],o:2},'flag-md':{a:'Moldova Flag',b:'1F1F2-1F1E9',k:[3,4],o:2},clock630:{a:'Clock Face Six-Thirty',b:'1F561',j:['time','late','early','schedule'],k:[28,56],o:2},cl:{a:'Squared Cl',b:'1F191',j:['alphabet','words','red-square'],k:[0,21],o:2},'flag-me':{a:'Montenegro Flag',b:'1F1F2-1F1EA',k:[3,5],o:2},file_folder:{a:'File Folder',b:'1F4C1',j:['documents','business','office'],k:[26,23],o:2},cop:{skin_variations:{'1F3FB':{unified:'1F46E-1F3FB',non_qualified:null,image:'1f46e-1f3fb.png',sheet_x:21,sheet_y:50,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F46E-1F3FC',non_qualified:null,image:'1f46e-1f3fc.png',sheet_x:21,sheet_y:51,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F46E-1F3FD',non_qualified:null,image:'1f46e-1f3fd.png',sheet_x:21,sheet_y:52,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F46E-1F3FE',non_qualified:null,image:'1f46e-1f3fe.png',sheet_x:21,sheet_y:53,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F46E-1F3FF',non_qualified:null,image:'1f46e-1f3ff.png',sheet_x:21,sheet_y:54,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},obsoleted_by:'1F46E-200D-2642-FE0F',a:'Police Officer',b:'1F46E',k:[21,49],o:2},'male-police-officer':{skin_variations:{'1F3FB':{unified:'1F46E-1F3FB-200D-2642-FE0F',non_qualified:'1F46E-1F3FB-200D-2642',image:'1f46e-1f3fb-200d-2642-fe0f.png',sheet_x:21,sheet_y:44,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F46E-1F3FC-200D-2642-FE0F',non_qualified:'1F46E-1F3FC-200D-2642',image:'1f46e-1f3fc-200d-2642-fe0f.png',sheet_x:21,sheet_y:45,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F46E-1F3FD-200D-2642-FE0F',non_qualified:'1F46E-1F3FD-200D-2642',image:'1f46e-1f3fd-200d-2642-fe0f.png',sheet_x:21,sheet_y:46,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F46E-1F3FE-200D-2642-FE0F',non_qualified:'1F46E-1F3FE-200D-2642',image:'1f46e-1f3fe-200d-2642-fe0f.png',sheet_x:21,sheet_y:47,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F46E-1F3FF-200D-2642-FE0F',non_qualified:'1F46E-1F3FF-200D-2642',image:'1f46e-1f3ff-200d-2642-fe0f.png',sheet_x:21,sheet_y:48,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},obsoletes:'1F46E',a:'Male Police Officer',b:'1F46E-200D-2642-FE0F',c:'1F46E-200D-2642',k:[21,43],o:4},cool:{a:'Squared Cool',b:'1F192',j:['words','blue-square'],k:[0,22],o:2},clock7:{a:'Clock Face Seven Oclock',b:'1F556',j:['time','late','early','schedule'],k:[28,45],o:2},'flag-mf':{a:'St. Martin Flag',b:'1F1F2-1F1EB',k:[3,6],o:2},open_file_folder:{a:'Open File Folder',b:'1F4C2',j:['documents','load'],k:[26,24],o:2},card_index_dividers:{a:'Card Index Dividers',b:'1F5C2-FE0F',c:'1F5C2',j:['organizing','business','stationery'],k:[30,15],o:2},'flag-mg':{a:'Madagascar Flag',b:'1F1F2-1F1EC',k:[3,7],o:2},free:{a:'Squared Free',b:'1F193',j:['blue-square','words'],k:[0,23],o:2},'female-police-officer':{skin_variations:{'1F3FB':{unified:'1F46E-1F3FB-200D-2640-FE0F',non_qualified:'1F46E-1F3FB-200D-2640',image:'1f46e-1f3fb-200d-2640-fe0f.png',sheet_x:21,sheet_y:38,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F46E-1F3FC-200D-2640-FE0F',non_qualified:'1F46E-1F3FC-200D-2640',image:'1f46e-1f3fc-200d-2640-fe0f.png',sheet_x:21,sheet_y:39,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F46E-1F3FD-200D-2640-FE0F',non_qualified:'1F46E-1F3FD-200D-2640',image:'1f46e-1f3fd-200d-2640-fe0f.png',sheet_x:21,sheet_y:40,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F46E-1F3FE-200D-2640-FE0F',non_qualified:'1F46E-1F3FE-200D-2640',image:'1f46e-1f3fe-200d-2640-fe0f.png',sheet_x:21,sheet_y:41,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F46E-1F3FF-200D-2640-FE0F',non_qualified:'1F46E-1F3FF-200D-2640',image:'1f46e-1f3ff-200d-2640-fe0f.png',sheet_x:21,sheet_y:42,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Female Police Officer',b:'1F46E-200D-2640-FE0F',c:'1F46E-200D-2640',k:[21,37],o:4},clock730:{a:'Clock Face Seven-Thirty',b:'1F562',j:['time','late','early','schedule'],k:[29,0],o:2},date:{a:'Calendar',b:'1F4C5',j:['calendar','schedule'],k:[26,27],o:2},clock8:{a:'Clock Face Eight Oclock',b:'1F557',j:['time','late','early','schedule'],k:[28,46],o:2},information_source:{a:'Information Source',b:'2139-FE0F',c:'2139',j:['blue-square','alphabet','letter'],k:[52,13],o:2},sleuth_or_spy:{skin_variations:{'1F3FB':{unified:'1F575-1F3FB',non_qualified:null,image:'1f575-1f3fb.png',sheet_x:29,sheet_y:28,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F575-1F3FC',non_qualified:null,image:'1f575-1f3fc.png',sheet_x:29,sheet_y:29,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F575-1F3FD',non_qualified:null,image:'1f575-1f3fd.png',sheet_x:29,sheet_y:30,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F575-1F3FE',non_qualified:null,image:'1f575-1f3fe.png',sheet_x:29,sheet_y:31,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F575-1F3FF',non_qualified:null,image:'1f575-1f3ff.png',sheet_x:29,sheet_y:32,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},obsoleted_by:'1F575-FE0F-200D-2642-FE0F',a:'Sleuth or Spy',b:'1F575-FE0F',c:'1F575',k:[29,27],o:2},'flag-mh':{a:'Marshall Islands Flag',b:'1F1F2-1F1ED',k:[3,8],o:2},clock830:{a:'Clock Face Eight-Thirty',b:'1F563',j:['time','late','early','schedule'],k:[29,1],o:2},calendar:{a:'Tear-off Calendar',b:'1F4C6',j:['schedule','date','planning'],k:[26,28],o:2},'male-detective':{skin_variations:{'1F3FB':{unified:'1F575-1F3FB-200D-2642-FE0F',non_qualified:'1F575-1F3FB-200D-2642',image:'1f575-1f3fb-200d-2642-fe0f.png',sheet_x:29,sheet_y:22,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F575-1F3FC-200D-2642-FE0F',non_qualified:'1F575-1F3FC-200D-2642',image:'1f575-1f3fc-200d-2642-fe0f.png',sheet_x:29,sheet_y:23,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F575-1F3FD-200D-2642-FE0F',non_qualified:'1F575-1F3FD-200D-2642',image:'1f575-1f3fd-200d-2642-fe0f.png',sheet_x:29,sheet_y:24,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F575-1F3FE-200D-2642-FE0F',non_qualified:'1F575-1F3FE-200D-2642',image:'1f575-1f3fe-200d-2642-fe0f.png',sheet_x:29,sheet_y:25,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F575-1F3FF-200D-2642-FE0F',non_qualified:'1F575-1F3FF-200D-2642',image:'1f575-1f3ff-200d-2642-fe0f.png',sheet_x:29,sheet_y:26,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},obsoletes:'1F575-FE0F',a:'Male Detective',b:'1F575-FE0F-200D-2642-FE0F',k:[29,21],o:4},'flag-mk':{a:'North Macedonia Flag',b:'1F1F2-1F1F0',k:[3,9],o:2},id:{a:'Squared Id',b:'1F194',j:['purple-square','words'],k:[0,24],o:2},spiral_note_pad:{a:'Spiral Note Pad',b:'1F5D2-FE0F',c:'1F5D2',k:[30,19],o:2},'female-detective':{skin_variations:{'1F3FB':{unified:'1F575-1F3FB-200D-2640-FE0F',non_qualified:'1F575-1F3FB-200D-2640',image:'1f575-1f3fb-200d-2640-fe0f.png',sheet_x:29,sheet_y:16,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F575-1F3FC-200D-2640-FE0F',non_qualified:'1F575-1F3FC-200D-2640',image:'1f575-1f3fc-200d-2640-fe0f.png',sheet_x:29,sheet_y:17,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F575-1F3FD-200D-2640-FE0F',non_qualified:'1F575-1F3FD-200D-2640',image:'1f575-1f3fd-200d-2640-fe0f.png',sheet_x:29,sheet_y:18,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F575-1F3FE-200D-2640-FE0F',non_qualified:'1F575-1F3FE-200D-2640',image:'1f575-1f3fe-200d-2640-fe0f.png',sheet_x:29,sheet_y:19,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F575-1F3FF-200D-2640-FE0F',non_qualified:'1F575-1F3FF-200D-2640',image:'1f575-1f3ff-200d-2640-fe0f.png',sheet_x:29,sheet_y:20,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Female Detective',b:'1F575-FE0F-200D-2640-FE0F',k:[29,15],o:4},clock9:{a:'Clock Face Nine Oclock',b:'1F558',j:['time','late','early','schedule'],k:[28,47],o:2},'flag-ml':{a:'Mali Flag',b:'1F1F2-1F1F1',k:[3,10],o:2},m:{a:'Circled Latin Capital Letter M',b:'24C2-FE0F',c:'24C2',j:['alphabet','blue-circle','letter'],k:[52,40],o:2},'flag-mm':{a:'Myanmar (burma) Flag',b:'1F1F2-1F1F2',k:[3,11],o:2},clock930:{a:'Clock Face Nine-Thirty',b:'1F564',j:['time','late','early','schedule'],k:[29,2],o:2},guardsman:{skin_variations:{'1F3FB':{unified:'1F482-1F3FB',non_qualified:null,image:'1f482-1f3fb.png',sheet_x:24,sheet_y:21,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F482-1F3FC',non_qualified:null,image:'1f482-1f3fc.png',sheet_x:24,sheet_y:22,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F482-1F3FD',non_qualified:null,image:'1f482-1f3fd.png',sheet_x:24,sheet_y:23,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F482-1F3FE',non_qualified:null,image:'1f482-1f3fe.png',sheet_x:24,sheet_y:24,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F482-1F3FF',non_qualified:null,image:'1f482-1f3ff.png',sheet_x:24,sheet_y:25,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},obsoleted_by:'1F482-200D-2642-FE0F',a:'Guardsman',b:'1F482',j:['uk','gb','british','male','guy','royal'],k:[24,20],o:2},new:{a:'Squared New',b:'1F195',j:['blue-square','words','start'],k:[0,25],o:2},spiral_calendar_pad:{a:'Spiral Calendar Pad',b:'1F5D3-FE0F',c:'1F5D3',k:[30,20],o:2},ng:{a:'Squared Ng',b:'1F196',j:['blue-square','words','shape','icon'],k:[0,26],o:2},card_index:{a:'Card Index',b:'1F4C7',j:['business','stationery'],k:[26,29],o:2},clock10:{a:'Clock Face Ten Oclock',b:'1F559',j:['time','late','early','schedule'],k:[28,48],o:2},'flag-mn':{a:'Mongolia Flag',b:'1F1F2-1F1F3',k:[3,12],o:2},'male-guard':{skin_variations:{'1F3FB':{unified:'1F482-1F3FB-200D-2642-FE0F',non_qualified:'1F482-1F3FB-200D-2642',image:'1f482-1f3fb-200d-2642-fe0f.png',sheet_x:24,sheet_y:15,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F482-1F3FC-200D-2642-FE0F',non_qualified:'1F482-1F3FC-200D-2642',image:'1f482-1f3fc-200d-2642-fe0f.png',sheet_x:24,sheet_y:16,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F482-1F3FD-200D-2642-FE0F',non_qualified:'1F482-1F3FD-200D-2642',image:'1f482-1f3fd-200d-2642-fe0f.png',sheet_x:24,sheet_y:17,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F482-1F3FE-200D-2642-FE0F',non_qualified:'1F482-1F3FE-200D-2642',image:'1f482-1f3fe-200d-2642-fe0f.png',sheet_x:24,sheet_y:18,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F482-1F3FF-200D-2642-FE0F',non_qualified:'1F482-1F3FF-200D-2642',image:'1f482-1f3ff-200d-2642-fe0f.png',sheet_x:24,sheet_y:19,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},obsoletes:'1F482',a:'Male Guard',b:'1F482-200D-2642-FE0F',c:'1F482-200D-2642',k:[24,14],o:4},'flag-mo':{a:'Macao Sar China Flag',b:'1F1F2-1F1F4',k:[3,13],o:2},clock1030:{a:'Clock Face Ten-Thirty',b:'1F565',j:['time','late','early','schedule'],k:[29,3],o:2},chart_with_upwards_trend:{a:'Chart with Upwards Trend',b:'1F4C8',j:['graph','presentation','stats','recovery','business','economics','money','sales','good','success'],k:[26,30],o:2},o2:{a:'Negative Squared Latin Capital Letter O',b:'1F17E-FE0F',c:'1F17E',j:['alphabet','red-square','letter'],k:[0,18],o:2},'female-guard':{skin_variations:{'1F3FB':{unified:'1F482-1F3FB-200D-2640-FE0F',non_qualified:'1F482-1F3FB-200D-2640',image:'1f482-1f3fb-200d-2640-fe0f.png',sheet_x:24,sheet_y:9,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F482-1F3FC-200D-2640-FE0F',non_qualified:'1F482-1F3FC-200D-2640',image:'1f482-1f3fc-200d-2640-fe0f.png',sheet_x:24,sheet_y:10,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F482-1F3FD-200D-2640-FE0F',non_qualified:'1F482-1F3FD-200D-2640',image:'1f482-1f3fd-200d-2640-fe0f.png',sheet_x:24,sheet_y:11,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F482-1F3FE-200D-2640-FE0F',non_qualified:'1F482-1F3FE-200D-2640',image:'1f482-1f3fe-200d-2640-fe0f.png',sheet_x:24,sheet_y:12,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F482-1F3FF-200D-2640-FE0F',non_qualified:'1F482-1F3FF-200D-2640',image:'1f482-1f3ff-200d-2640-fe0f.png',sheet_x:24,sheet_y:13,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Female Guard',b:'1F482-200D-2640-FE0F',c:'1F482-200D-2640',k:[24,8],o:4},chart_with_downwards_trend:{a:'Chart with Downwards Trend',b:'1F4C9',j:['graph','presentation','stats','recession','business','economics','money','sales','bad','failure'],k:[26,31],o:2},'flag-mp':{a:'Northern Mariana Islands Flag',b:'1F1F2-1F1F5',k:[3,14],o:2},ok:{a:'Squared Ok',b:'1F197',j:['good','agree','yes','blue-square'],k:[0,27],o:2},clock11:{a:'Clock Face Eleven Oclock',b:'1F55A',j:['time','late','early','schedule'],k:[28,49],o:2},construction_worker:{skin_variations:{'1F3FB':{unified:'1F477-1F3FB',non_qualified:null,image:'1f477-1f3fb.png',sheet_x:23,sheet_y:23,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F477-1F3FC',non_qualified:null,image:'1f477-1f3fc.png',sheet_x:23,sheet_y:24,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F477-1F3FD',non_qualified:null,image:'1f477-1f3fd.png',sheet_x:23,sheet_y:25,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F477-1F3FE',non_qualified:null,image:'1f477-1f3fe.png',sheet_x:23,sheet_y:26,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F477-1F3FF',non_qualified:null,image:'1f477-1f3ff.png',sheet_x:23,sheet_y:27,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},obsoleted_by:'1F477-200D-2642-FE0F',a:'Construction Worker',b:'1F477',k:[23,22],o:2},'male-construction-worker':{skin_variations:{'1F3FB':{unified:'1F477-1F3FB-200D-2642-FE0F',non_qualified:'1F477-1F3FB-200D-2642',image:'1f477-1f3fb-200d-2642-fe0f.png',sheet_x:23,sheet_y:17,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F477-1F3FC-200D-2642-FE0F',non_qualified:'1F477-1F3FC-200D-2642',image:'1f477-1f3fc-200d-2642-fe0f.png',sheet_x:23,sheet_y:18,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F477-1F3FD-200D-2642-FE0F',non_qualified:'1F477-1F3FD-200D-2642',image:'1f477-1f3fd-200d-2642-fe0f.png',sheet_x:23,sheet_y:19,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F477-1F3FE-200D-2642-FE0F',non_qualified:'1F477-1F3FE-200D-2642',image:'1f477-1f3fe-200d-2642-fe0f.png',sheet_x:23,sheet_y:20,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F477-1F3FF-200D-2642-FE0F',non_qualified:'1F477-1F3FF-200D-2642',image:'1f477-1f3ff-200d-2642-fe0f.png',sheet_x:23,sheet_y:21,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},obsoletes:'1F477',a:'Male Construction Worker',b:'1F477-200D-2642-FE0F',c:'1F477-200D-2642',k:[23,16],o:4},clock1130:{a:'Clock Face Eleven-Thirty',b:'1F566',j:['time','late','early','schedule'],k:[29,4],o:2},'flag-mq':{a:'Martinique Flag',b:'1F1F2-1F1F6',k:[3,15],o:2},bar_chart:{a:'Bar Chart',b:'1F4CA',j:['graph','presentation','stats'],k:[26,32],o:2},parking:{a:'Negative Squared Latin Capital Letter P',b:'1F17F-FE0F',c:'1F17F',j:['cars','blue-square','alphabet','letter'],k:[0,19],o:2},new_moon:{a:'New Moon Symbol',b:'1F311',j:['nature','twilight','planet','space','night','evening','sleep'],k:[5,36],o:2},'female-construction-worker':{skin_variations:{'1F3FB':{unified:'1F477-1F3FB-200D-2640-FE0F',non_qualified:'1F477-1F3FB-200D-2640',image:'1f477-1f3fb-200d-2640-fe0f.png',sheet_x:23,sheet_y:11,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F477-1F3FC-200D-2640-FE0F',non_qualified:'1F477-1F3FC-200D-2640',image:'1f477-1f3fc-200d-2640-fe0f.png',sheet_x:23,sheet_y:12,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F477-1F3FD-200D-2640-FE0F',non_qualified:'1F477-1F3FD-200D-2640',image:'1f477-1f3fd-200d-2640-fe0f.png',sheet_x:23,sheet_y:13,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F477-1F3FE-200D-2640-FE0F',non_qualified:'1F477-1F3FE-200D-2640',image:'1f477-1f3fe-200d-2640-fe0f.png',sheet_x:23,sheet_y:14,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F477-1F3FF-200D-2640-FE0F',non_qualified:'1F477-1F3FF-200D-2640',image:'1f477-1f3ff-200d-2640-fe0f.png',sheet_x:23,sheet_y:15,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Female Construction Worker',b:'1F477-200D-2640-FE0F',c:'1F477-200D-2640',k:[23,10],o:4},sos:{a:'Squared Sos',b:'1F198',j:['help','red-square','words','emergency','911'],k:[0,28],o:2},clipboard:{a:'Clipboard',b:'1F4CB',j:['stationery','documents'],k:[26,33],o:2},'flag-mr':{a:'Mauritania Flag',b:'1F1F2-1F1F7',k:[3,16],o:2},prince:{skin_variations:{'1F3FB':{unified:'1F934-1F3FB',non_qualified:null,image:'1f934-1f3fb.png',sheet_x:39,sheet_y:18,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F934-1F3FC',non_qualified:null,image:'1f934-1f3fc.png',sheet_x:39,sheet_y:19,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F934-1F3FD',non_qualified:null,image:'1f934-1f3fd.png',sheet_x:39,sheet_y:20,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F934-1F3FE',non_qualified:null,image:'1f934-1f3fe.png',sheet_x:39,sheet_y:21,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F934-1F3FF',non_qualified:null,image:'1f934-1f3ff.png',sheet_x:39,sheet_y:22,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Prince',b:'1F934',j:['boy','man','male','crown','royal','king'],k:[39,17],o:4},waxing_crescent_moon:{a:'Waxing Crescent Moon Symbol',b:'1F312',j:['nature','twilight','planet','space','night','evening','sleep'],k:[5,37],o:2},'flag-ms':{a:'Montserrat Flag',b:'1F1F2-1F1F8',k:[3,17],o:2},pushpin:{a:'Pushpin',b:'1F4CC',j:['stationery','mark','here'],k:[26,34],o:2},up:{a:'Squared Up with Exclamation Mark',b:'1F199',j:['blue-square','above','high'],k:[0,29],o:2},'flag-mt':{a:'Malta Flag',b:'1F1F2-1F1F9',k:[3,18],o:2},princess:{skin_variations:{'1F3FB':{unified:'1F478-1F3FB',non_qualified:null,image:'1f478-1f3fb.png',sheet_x:23,sheet_y:29,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F478-1F3FC',non_qualified:null,image:'1f478-1f3fc.png',sheet_x:23,sheet_y:30,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F478-1F3FD',non_qualified:null,image:'1f478-1f3fd.png',sheet_x:23,sheet_y:31,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F478-1F3FE',non_qualified:null,image:'1f478-1f3fe.png',sheet_x:23,sheet_y:32,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F478-1F3FF',non_qualified:null,image:'1f478-1f3ff.png',sheet_x:23,sheet_y:33,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Princess',b:'1F478',j:['girl','woman','female','blond','crown','royal','queen'],k:[23,28],o:2},round_pushpin:{a:'Round Pushpin',b:'1F4CD',j:['stationery','location','map','here'],k:[26,35],o:2},first_quarter_moon:{a:'First Quarter Moon Symbol',b:'1F313',j:['nature','twilight','planet','space','night','evening','sleep'],k:[5,38],o:2},vs:{a:'Squared Vs',b:'1F19A',j:['words','orange-square'],k:[0,30],o:2},'flag-mu':{a:'Mauritius Flag',b:'1F1F2-1F1FA',k:[3,19],o:2},koko:{a:'Squared Katakana Koko',b:'1F201',j:['blue-square','here','katakana','japanese','destination'],k:[5,4],o:2},man_with_turban:{skin_variations:{'1F3FB':{unified:'1F473-1F3FB',non_qualified:null,image:'1f473-1f3fb.png',sheet_x:22,sheet_y:44,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F473-1F3FC',non_qualified:null,image:'1f473-1f3fc.png',sheet_x:22,sheet_y:45,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F473-1F3FD',non_qualified:null,image:'1f473-1f3fd.png',sheet_x:22,sheet_y:46,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F473-1F3FE',non_qualified:null,image:'1f473-1f3fe.png',sheet_x:22,sheet_y:47,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F473-1F3FF',non_qualified:null,image:'1f473-1f3ff.png',sheet_x:22,sheet_y:48,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},obsoleted_by:'1F473-200D-2642-FE0F',a:'Man with Turban',b:'1F473',j:['male','indian','hinduism','arabs'],k:[22,43],o:2},moon:{a:'Waxing Gibbous Moon Symbol',b:'1F314',k:[5,39],n:['waxing_gibbous_moon'],o:2},paperclip:{a:'Paperclip',b:'1F4CE',j:['documents','stationery'],k:[26,36],o:2},linked_paperclips:{a:'Linked Paperclips',b:'1F587-FE0F',c:'1F587',k:[29,43],o:2},'man-wearing-turban':{skin_variations:{'1F3FB':{unified:'1F473-1F3FB-200D-2642-FE0F',non_qualified:'1F473-1F3FB-200D-2642',image:'1f473-1f3fb-200d-2642-fe0f.png',sheet_x:22,sheet_y:38,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F473-1F3FC-200D-2642-FE0F',non_qualified:'1F473-1F3FC-200D-2642',image:'1f473-1f3fc-200d-2642-fe0f.png',sheet_x:22,sheet_y:39,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F473-1F3FD-200D-2642-FE0F',non_qualified:'1F473-1F3FD-200D-2642',image:'1f473-1f3fd-200d-2642-fe0f.png',sheet_x:22,sheet_y:40,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F473-1F3FE-200D-2642-FE0F',non_qualified:'1F473-1F3FE-200D-2642',image:'1f473-1f3fe-200d-2642-fe0f.png',sheet_x:22,sheet_y:41,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F473-1F3FF-200D-2642-FE0F',non_qualified:'1F473-1F3FF-200D-2642',image:'1f473-1f3ff-200d-2642-fe0f.png',sheet_x:22,sheet_y:42,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},obsoletes:'1F473',a:'Man Wearing Turban',b:'1F473-200D-2642-FE0F',c:'1F473-200D-2642',k:[22,37],o:4},sa:{a:'Squared Katakana Sa',b:'1F202-FE0F',c:'1F202',j:['japanese','blue-square','katakana'],k:[5,5],o:2},full_moon:{a:'Full Moon Symbol',b:'1F315',j:['nature','yellow','twilight','planet','space','night','evening','sleep'],k:[5,40],o:2},'flag-mv':{a:'Maldives Flag',b:'1F1F2-1F1FB',k:[3,20],o:2},'flag-mw':{a:'Malawi Flag',b:'1F1F2-1F1FC',k:[3,21],o:2},waning_gibbous_moon:{a:'Waning Gibbous Moon Symbol',b:'1F316',j:['nature','twilight','planet','space','night','evening','sleep','waxing_gibbous_moon'],k:[5,41],o:2},'woman-wearing-turban':{skin_variations:{'1F3FB':{unified:'1F473-1F3FB-200D-2640-FE0F',non_qualified:'1F473-1F3FB-200D-2640',image:'1f473-1f3fb-200d-2640-fe0f.png',sheet_x:22,sheet_y:32,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F473-1F3FC-200D-2640-FE0F',non_qualified:'1F473-1F3FC-200D-2640',image:'1f473-1f3fc-200d-2640-fe0f.png',sheet_x:22,sheet_y:33,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F473-1F3FD-200D-2640-FE0F',non_qualified:'1F473-1F3FD-200D-2640',image:'1f473-1f3fd-200d-2640-fe0f.png',sheet_x:22,sheet_y:34,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F473-1F3FE-200D-2640-FE0F',non_qualified:'1F473-1F3FE-200D-2640',image:'1f473-1f3fe-200d-2640-fe0f.png',sheet_x:22,sheet_y:35,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F473-1F3FF-200D-2640-FE0F',non_qualified:'1F473-1F3FF-200D-2640',image:'1f473-1f3ff-200d-2640-fe0f.png',sheet_x:22,sheet_y:36,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Woman Wearing Turban',b:'1F473-200D-2640-FE0F',c:'1F473-200D-2640',k:[22,31],o:4},u6708:{a:'Squared Cjk Unified Ideograph-6708',b:'1F237-FE0F',c:'1F237',j:['chinese','month','moon','japanese','orange-square','kanji'],k:[5,13],o:2},straight_ruler:{a:'Straight Ruler',b:'1F4CF',j:['stationery','calculate','length','math','school','drawing','architect','sketch'],k:[26,37],o:2},u6709:{a:'Squared Cjk Unified Ideograph-6709',b:'1F236',j:['orange-square','chinese','have','kanji'],k:[5,12],o:2},triangular_ruler:{a:'Triangular Ruler',b:'1F4D0',j:['stationery','math','architect','sketch'],k:[26,38],o:2},man_with_gua_pi_mao:{skin_variations:{'1F3FB':{unified:'1F472-1F3FB',non_qualified:null,image:'1f472-1f3fb.png',sheet_x:22,sheet_y:26,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F472-1F3FC',non_qualified:null,image:'1f472-1f3fc.png',sheet_x:22,sheet_y:27,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F472-1F3FD',non_qualified:null,image:'1f472-1f3fd.png',sheet_x:22,sheet_y:28,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F472-1F3FE',non_qualified:null,image:'1f472-1f3fe.png',sheet_x:22,sheet_y:29,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F472-1F3FF',non_qualified:null,image:'1f472-1f3ff.png',sheet_x:22,sheet_y:30,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man with Gua Pi Mao',b:'1F472',j:['male','boy','chinese'],k:[22,25],o:2},'flag-mx':{a:'Mexico Flag',b:'1F1F2-1F1FD',k:[3,22],o:2},last_quarter_moon:{a:'Last Quarter Moon Symbol',b:'1F317',j:['nature','twilight','planet','space','night','evening','sleep'],k:[5,42],o:2},person_with_headscarf:{skin_variations:{'1F3FB':{unified:'1F9D5-1F3FB',non_qualified:null,image:'1f9d5-1f3fb.png',sheet_x:48,sheet_y:35,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9D5-1F3FC',non_qualified:null,image:'1f9d5-1f3fc.png',sheet_x:48,sheet_y:36,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9D5-1F3FD',non_qualified:null,image:'1f9d5-1f3fd.png',sheet_x:48,sheet_y:37,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9D5-1F3FE',non_qualified:null,image:'1f9d5-1f3fe.png',sheet_x:48,sheet_y:38,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9D5-1F3FF',non_qualified:null,image:'1f9d5-1f3ff.png',sheet_x:48,sheet_y:39,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Person with Headscarf',b:'1F9D5',k:[48,34],o:5},waning_crescent_moon:{a:'Waning Crescent Moon Symbol',b:'1F318',j:['nature','twilight','planet','space','night','evening','sleep'],k:[5,43],o:2},u6307:{a:'Squared Cjk Unified Ideograph-6307',b:'1F22F',j:['chinese','point','green-square','kanji'],k:[5,7],o:2},scissors:{a:'Black Scissors',b:'2702-FE0F',c:'2702',j:['stationery','cut'],k:[54,39],o:2},'flag-my':{a:'Malaysia Flag',b:'1F1F2-1F1FE',k:[3,23],o:2},ideograph_advantage:{a:'Circled Ideograph Advantage',b:'1F250',j:['chinese','kanji','obtain','get','circle'],k:[5,17],o:2},man_in_tuxedo:{skin_variations:{'1F3FB':{unified:'1F935-1F3FB',non_qualified:null,image:'1f935-1f3fb.png',sheet_x:39,sheet_y:24,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F935-1F3FC',non_qualified:null,image:'1f935-1f3fc.png',sheet_x:39,sheet_y:25,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F935-1F3FD',non_qualified:null,image:'1f935-1f3fd.png',sheet_x:39,sheet_y:26,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F935-1F3FE',non_qualified:null,image:'1f935-1f3fe.png',sheet_x:39,sheet_y:27,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F935-1F3FF',non_qualified:null,image:'1f935-1f3ff.png',sheet_x:39,sheet_y:28,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man in Tuxedo',b:'1F935',j:['couple','marriage','wedding','groom'],k:[39,23],o:4},'flag-mz':{a:'Mozambique Flag',b:'1F1F2-1F1FF',k:[3,24],o:2},card_file_box:{a:'Card File Box',b:'1F5C3-FE0F',c:'1F5C3',j:['business','stationery'],k:[30,16],o:2},crescent_moon:{a:'Crescent Moon',b:'1F319',j:['night','sleep','sky','evening','magic'],k:[5,44],o:2},'flag-na':{a:'Namibia Flag',b:'1F1F3-1F1E6',k:[3,25],o:2},bride_with_veil:{skin_variations:{'1F3FB':{unified:'1F470-1F3FB',non_qualified:null,image:'1f470-1f3fb.png',sheet_x:22,sheet_y:2,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F470-1F3FC',non_qualified:null,image:'1f470-1f3fc.png',sheet_x:22,sheet_y:3,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F470-1F3FD',non_qualified:null,image:'1f470-1f3fd.png',sheet_x:22,sheet_y:4,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F470-1F3FE',non_qualified:null,image:'1f470-1f3fe.png',sheet_x:22,sheet_y:5,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F470-1F3FF',non_qualified:null,image:'1f470-1f3ff.png',sheet_x:22,sheet_y:6,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Bride with Veil',b:'1F470',j:['couple','marriage','wedding','woman','bride'],k:[22,1],o:2},new_moon_with_face:{a:'New Moon with Face',b:'1F31A',j:['nature','twilight','planet','space','night','evening','sleep'],k:[5,45],o:2},file_cabinet:{a:'File Cabinet',b:'1F5C4-FE0F',c:'1F5C4',j:['filing','organizing'],k:[30,17],o:2},u5272:{a:'Squared Cjk Unified Ideograph-5272',b:'1F239',j:['cut','divide','chinese','kanji','pink-square'],k:[5,15],o:2},wastebasket:{a:'Wastebasket',b:'1F5D1-FE0F',c:'1F5D1',j:['bin','trash','rubbish','garbage','toss'],k:[30,18],o:2},pregnant_woman:{skin_variations:{'1F3FB':{unified:'1F930-1F3FB',non_qualified:null,image:'1f930-1f3fb.png',sheet_x:38,sheet_y:51,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F930-1F3FC',non_qualified:null,image:'1f930-1f3fc.png',sheet_x:38,sheet_y:52,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F930-1F3FD',non_qualified:null,image:'1f930-1f3fd.png',sheet_x:38,sheet_y:53,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F930-1F3FE',non_qualified:null,image:'1f930-1f3fe.png',sheet_x:38,sheet_y:54,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F930-1F3FF',non_qualified:null,image:'1f930-1f3ff.png',sheet_x:38,sheet_y:55,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Pregnant Woman',b:'1F930',j:['baby'],k:[38,50],o:4},first_quarter_moon_with_face:{a:'First Quarter Moon with Face',b:'1F31B',j:['nature','twilight','planet','space','night','evening','sleep'],k:[5,46],o:2},'flag-nc':{a:'New Caledonia Flag',b:'1F1F3-1F1E8',k:[3,26],o:2},u7121:{a:'Squared Cjk Unified Ideograph-7121',b:'1F21A',j:['nothing','chinese','kanji','japanese','orange-square'],k:[5,6],o:2},lock:{a:'Lock',b:'1F512',j:['security','password','padlock'],k:[27,46],o:2},'flag-ne':{a:'Niger Flag',b:'1F1F3-1F1EA',k:[3,27],o:2},last_quarter_moon_with_face:{a:'Last Quarter Moon with Face',b:'1F31C',j:['nature','twilight','planet','space','night','evening','sleep'],k:[5,47],o:2},'breast-feeding':{skin_variations:{'1F3FB':{unified:'1F931-1F3FB',non_qualified:null,image:'1f931-1f3fb.png',sheet_x:39,sheet_y:0,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F931-1F3FC',non_qualified:null,image:'1f931-1f3fc.png',sheet_x:39,sheet_y:1,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F931-1F3FD',non_qualified:null,image:'1f931-1f3fd.png',sheet_x:39,sheet_y:2,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F931-1F3FE',non_qualified:null,image:'1f931-1f3fe.png',sheet_x:39,sheet_y:3,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F931-1F3FF',non_qualified:null,image:'1f931-1f3ff.png',sheet_x:39,sheet_y:4,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Breast-Feeding',b:'1F931',k:[38,56],o:5},u7981:{a:'Squared Cjk Unified Ideograph-7981',b:'1F232',j:['kanji','japanese','chinese','forbidden','limit','restricted','red-square'],k:[5,8],o:2},accept:{a:'Circled Ideograph Accept',b:'1F251',j:['ok','good','chinese','kanji','agree','yes','orange-circle'],k:[5,18],o:2},angel:{skin_variations:{'1F3FB':{unified:'1F47C-1F3FB',non_qualified:null,image:'1f47c-1f3fb.png',sheet_x:23,sheet_y:38,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F47C-1F3FC',non_qualified:null,image:'1f47c-1f3fc.png',sheet_x:23,sheet_y:39,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F47C-1F3FD',non_qualified:null,image:'1f47c-1f3fd.png',sheet_x:23,sheet_y:40,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F47C-1F3FE',non_qualified:null,image:'1f47c-1f3fe.png',sheet_x:23,sheet_y:41,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F47C-1F3FF',non_qualified:null,image:'1f47c-1f3ff.png',sheet_x:23,sheet_y:42,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Baby Angel',b:'1F47C',j:['heaven','wings','halo'],k:[23,37],o:2},unlock:{a:'Open Lock',b:'1F513',j:['privacy','security'],k:[27,47],o:2},'flag-nf':{a:'Norfolk Island Flag',b:'1F1F3-1F1EB',k:[3,28],o:2},thermometer:{a:'Thermometer',b:'1F321-FE0F',c:'1F321',j:['weather','temperature','hot','cold'],k:[5,52],o:2},'flag-ng':{a:'Nigeria Flag',b:'1F1F3-1F1EC',k:[3,29],o:2},u7533:{a:'Squared Cjk Unified Ideograph-7533',b:'1F238',j:['chinese','japanese','kanji','orange-square'],k:[5,14],o:2},sunny:{a:'Black Sun with Rays',b:'2600-FE0F',c:'2600',j:['weather','nature','brightness','summer','beach','spring'],k:[52,49],o:2},lock_with_ink_pen:{a:'Lock with Ink Pen',b:'1F50F',j:['security','secret'],k:[27,43],o:2},santa:{skin_variations:{'1F3FB':{unified:'1F385-1F3FB',non_qualified:null,image:'1f385-1f3fb.png',sheet_x:7,sheet_y:37,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F385-1F3FC',non_qualified:null,image:'1f385-1f3fc.png',sheet_x:7,sheet_y:38,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F385-1F3FD',non_qualified:null,image:'1f385-1f3fd.png',sheet_x:7,sheet_y:39,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F385-1F3FE',non_qualified:null,image:'1f385-1f3fe.png',sheet_x:7,sheet_y:40,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F385-1F3FF',non_qualified:null,image:'1f385-1f3ff.png',sheet_x:7,sheet_y:41,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Father Christmas',b:'1F385',j:['festival','man','male','xmas','father christmas'],k:[7,36],o:2},closed_lock_with_key:{a:'Closed Lock with Key',b:'1F510',j:['security','privacy'],k:[27,44],o:2},u5408:{a:'Squared Cjk Unified Ideograph-5408',b:'1F234',j:['japanese','chinese','join','kanji','red-square'],k:[5,10],o:2},'flag-ni':{a:'Nicaragua Flag',b:'1F1F3-1F1EE',k:[3,30],o:2},mrs_claus:{skin_variations:{'1F3FB':{unified:'1F936-1F3FB',non_qualified:null,image:'1f936-1f3fb.png',sheet_x:39,sheet_y:30,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F936-1F3FC',non_qualified:null,image:'1f936-1f3fc.png',sheet_x:39,sheet_y:31,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F936-1F3FD',non_qualified:null,image:'1f936-1f3fd.png',sheet_x:39,sheet_y:32,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F936-1F3FE',non_qualified:null,image:'1f936-1f3fe.png',sheet_x:39,sheet_y:33,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F936-1F3FF',non_qualified:null,image:'1f936-1f3ff.png',sheet_x:39,sheet_y:34,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Mother Christmas',b:'1F936',j:['woman','female','xmas','mother christmas'],k:[39,29],n:['mother_christmas'],o:4},full_moon_with_face:{a:'Full Moon with Face',b:'1F31D',j:['nature','twilight','planet','space','night','evening','sleep'],k:[5,48],o:2},key:{a:'Key',b:'1F511',j:['lock','door','password'],k:[27,45],o:2},superhero:{skin_variations:{'1F3FB':{unified:'1F9B8-1F3FB',non_qualified:null,image:'1f9b8-1f3fb.png',sheet_x:43,sheet_y:31,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9B8-1F3FC',non_qualified:null,image:'1f9b8-1f3fc.png',sheet_x:43,sheet_y:32,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9B8-1F3FD',non_qualified:null,image:'1f9b8-1f3fd.png',sheet_x:43,sheet_y:33,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9B8-1F3FE',non_qualified:null,image:'1f9b8-1f3fe.png',sheet_x:43,sheet_y:34,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9B8-1F3FF',non_qualified:null,image:'1f9b8-1f3ff.png',sheet_x:43,sheet_y:35,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Superhero',b:'1F9B8',k:[43,30],o:11},'flag-nl':{a:'Netherlands Flag',b:'1F1F3-1F1F1',k:[3,31],o:2},u7a7a:{a:'Squared Cjk Unified Ideograph-7a7a',b:'1F233',j:['kanji','japanese','chinese','empty','sky','blue-square'],k:[5,9],o:2},sun_with_face:{a:'Sun with Face',b:'1F31E',j:['nature','morning','sky'],k:[5,49],o:2},male_superhero:{skin_variations:{'1F3FB':{unified:'1F9B8-1F3FB-200D-2642-FE0F',non_qualified:'1F9B8-1F3FB-200D-2642',image:'1f9b8-1f3fb-200d-2642-fe0f.png',sheet_x:43,sheet_y:25,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9B8-1F3FC-200D-2642-FE0F',non_qualified:'1F9B8-1F3FC-200D-2642',image:'1f9b8-1f3fc-200d-2642-fe0f.png',sheet_x:43,sheet_y:26,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9B8-1F3FD-200D-2642-FE0F',non_qualified:'1F9B8-1F3FD-200D-2642',image:'1f9b8-1f3fd-200d-2642-fe0f.png',sheet_x:43,sheet_y:27,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9B8-1F3FE-200D-2642-FE0F',non_qualified:'1F9B8-1F3FE-200D-2642',image:'1f9b8-1f3fe-200d-2642-fe0f.png',sheet_x:43,sheet_y:28,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9B8-1F3FF-200D-2642-FE0F',non_qualified:'1F9B8-1F3FF-200D-2642',image:'1f9b8-1f3ff-200d-2642-fe0f.png',sheet_x:43,sheet_y:29,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Male Superhero',b:'1F9B8-200D-2642-FE0F',c:'1F9B8-200D-2642',k:[43,24],o:11},ringed_planet:{a:'Ringed Planet',b:'1FA90',k:[52,4],o:12},old_key:{a:'Old Key',b:'1F5DD-FE0F',c:'1F5DD',j:['lock','door','password'],k:[30,22],o:2},congratulations:{a:'Circled Ideograph Congratulation',b:'3297-FE0F',c:'3297',j:['chinese','kanji','japanese','red-circle'],k:[55,46],o:2},'flag-no':{a:'Norway Flag',b:'1F1F3-1F1F4',k:[3,32],o:2},star:{a:'White Medium Star',b:'2B50',j:['night','yellow'],k:[55,42],o:2},secret:{a:'Circled Ideograph Secret',b:'3299-FE0F',c:'3299',j:['privacy','chinese','sshh','kanji','red-circle'],k:[55,47],o:2},'flag-np':{a:'Nepal Flag',b:'1F1F3-1F1F5',k:[3,33],o:2},female_superhero:{skin_variations:{'1F3FB':{unified:'1F9B8-1F3FB-200D-2640-FE0F',non_qualified:'1F9B8-1F3FB-200D-2640',image:'1f9b8-1f3fb-200d-2640-fe0f.png',sheet_x:43,sheet_y:19,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9B8-1F3FC-200D-2640-FE0F',non_qualified:'1F9B8-1F3FC-200D-2640',image:'1f9b8-1f3fc-200d-2640-fe0f.png',sheet_x:43,sheet_y:20,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9B8-1F3FD-200D-2640-FE0F',non_qualified:'1F9B8-1F3FD-200D-2640',image:'1f9b8-1f3fd-200d-2640-fe0f.png',sheet_x:43,sheet_y:21,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9B8-1F3FE-200D-2640-FE0F',non_qualified:'1F9B8-1F3FE-200D-2640',image:'1f9b8-1f3fe-200d-2640-fe0f.png',sheet_x:43,sheet_y:22,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9B8-1F3FF-200D-2640-FE0F',non_qualified:'1F9B8-1F3FF-200D-2640',image:'1f9b8-1f3ff-200d-2640-fe0f.png',sheet_x:43,sheet_y:23,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Female Superhero',b:'1F9B8-200D-2640-FE0F',c:'1F9B8-200D-2640',k:[43,18],o:11},hammer:{a:'Hammer',b:'1F528',j:['tools','build','create'],k:[28,11],o:2},star2:{a:'Glowing Star',b:'1F31F',j:['night','sparkle','awesome','good','magic'],k:[5,50],o:2},'flag-nr':{a:'Nauru Flag',b:'1F1F3-1F1F7',k:[3,34],o:2},axe:{a:'Axe',b:'1FA93',k:[52,7],o:12},u55b6:{a:'Squared Cjk Unified Ideograph-55b6',b:'1F23A',j:['japanese','opening hours','orange-square'],k:[5,16],o:2},supervillain:{skin_variations:{'1F3FB':{unified:'1F9B9-1F3FB',non_qualified:null,image:'1f9b9-1f3fb.png',sheet_x:43,sheet_y:49,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9B9-1F3FC',non_qualified:null,image:'1f9b9-1f3fc.png',sheet_x:43,sheet_y:50,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9B9-1F3FD',non_qualified:null,image:'1f9b9-1f3fd.png',sheet_x:43,sheet_y:51,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9B9-1F3FE',non_qualified:null,image:'1f9b9-1f3fe.png',sheet_x:43,sheet_y:52,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9B9-1F3FF',non_qualified:null,image:'1f9b9-1f3ff.png',sheet_x:43,sheet_y:53,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Supervillain',b:'1F9B9',k:[43,48],o:11},stars:{a:'Shooting Star',b:'1F320',j:['night','photo'],k:[5,51],o:2},u6e80:{a:'Squared Cjk Unified Ideograph-6e80',b:'1F235',j:['full','chinese','japanese','red-square','kanji'],k:[5,11],o:2},'flag-nu':{a:'Niue Flag',b:'1F1F3-1F1FA',k:[3,35],o:2},pick:{a:'Pick',b:'26CF-FE0F',c:'26CF',j:['tools','dig'],k:[54,5],o:2},male_supervillain:{skin_variations:{'1F3FB':{unified:'1F9B9-1F3FB-200D-2642-FE0F',non_qualified:'1F9B9-1F3FB-200D-2642',image:'1f9b9-1f3fb-200d-2642-fe0f.png',sheet_x:43,sheet_y:43,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9B9-1F3FC-200D-2642-FE0F',non_qualified:'1F9B9-1F3FC-200D-2642',image:'1f9b9-1f3fc-200d-2642-fe0f.png',sheet_x:43,sheet_y:44,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9B9-1F3FD-200D-2642-FE0F',non_qualified:'1F9B9-1F3FD-200D-2642',image:'1f9b9-1f3fd-200d-2642-fe0f.png',sheet_x:43,sheet_y:45,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9B9-1F3FE-200D-2642-FE0F',non_qualified:'1F9B9-1F3FE-200D-2642',image:'1f9b9-1f3fe-200d-2642-fe0f.png',sheet_x:43,sheet_y:46,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9B9-1F3FF-200D-2642-FE0F',non_qualified:'1F9B9-1F3FF-200D-2642',image:'1f9b9-1f3ff-200d-2642-fe0f.png',sheet_x:43,sheet_y:47,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Male Supervillain',b:'1F9B9-200D-2642-FE0F',c:'1F9B9-200D-2642',k:[43,42],o:11},female_supervillain:{skin_variations:{'1F3FB':{unified:'1F9B9-1F3FB-200D-2640-FE0F',non_qualified:'1F9B9-1F3FB-200D-2640',image:'1f9b9-1f3fb-200d-2640-fe0f.png',sheet_x:43,sheet_y:37,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9B9-1F3FC-200D-2640-FE0F',non_qualified:'1F9B9-1F3FC-200D-2640',image:'1f9b9-1f3fc-200d-2640-fe0f.png',sheet_x:43,sheet_y:38,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9B9-1F3FD-200D-2640-FE0F',non_qualified:'1F9B9-1F3FD-200D-2640',image:'1f9b9-1f3fd-200d-2640-fe0f.png',sheet_x:43,sheet_y:39,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9B9-1F3FE-200D-2640-FE0F',non_qualified:'1F9B9-1F3FE-200D-2640',image:'1f9b9-1f3fe-200d-2640-fe0f.png',sheet_x:43,sheet_y:40,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9B9-1F3FF-200D-2640-FE0F',non_qualified:'1F9B9-1F3FF-200D-2640',image:'1f9b9-1f3ff-200d-2640-fe0f.png',sheet_x:43,sheet_y:41,added_in:'11.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Female Supervillain',b:'1F9B9-200D-2640-FE0F',c:'1F9B9-200D-2640',k:[43,36],o:11},hammer_and_pick:{a:'Hammer and Pick',b:'2692-FE0F',c:'2692',j:['tools','build','create'],k:[53,41],o:2},milky_way:{a:'Milky Way',b:'1F30C',j:['photo','space','stars'],k:[5,31],o:2},red_circle:{a:'Large Red Circle',b:'1F534',j:['shape','error','danger'],k:[28,23],o:2},'flag-nz':{a:'New Zealand Flag',b:'1F1F3-1F1FF',k:[3,36],o:2},large_orange_circle:{a:'Large Orange Circle',b:'1F7E0',k:[37,3],o:12},hammer_and_wrench:{a:'Hammer and Wrench',b:'1F6E0-FE0F',c:'1F6E0',j:['tools','build','create'],k:[36,42],o:2},'flag-om':{a:'Oman Flag',b:'1F1F4-1F1F2',k:[3,37],o:2},cloud:{a:'Cloud',b:'2601-FE0F',c:'2601',j:['weather','sky'],k:[52,50],o:2},mage:{skin_variations:{'1F3FB':{unified:'1F9D9-1F3FB',non_qualified:null,image:'1f9d9-1f3fb.png',sheet_x:49,sheet_y:50,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9D9-1F3FB-200D-2640-FE0F'},'1F3FC':{unified:'1F9D9-1F3FC',non_qualified:null,image:'1f9d9-1f3fc.png',sheet_x:49,sheet_y:51,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9D9-1F3FC-200D-2640-FE0F'},'1F3FD':{unified:'1F9D9-1F3FD',non_qualified:null,image:'1f9d9-1f3fd.png',sheet_x:49,sheet_y:52,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9D9-1F3FD-200D-2640-FE0F'},'1F3FE':{unified:'1F9D9-1F3FE',non_qualified:null,image:'1f9d9-1f3fe.png',sheet_x:49,sheet_y:53,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9D9-1F3FE-200D-2640-FE0F'},'1F3FF':{unified:'1F9D9-1F3FF',non_qualified:null,image:'1f9d9-1f3ff.png',sheet_x:49,sheet_y:54,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9D9-1F3FF-200D-2640-FE0F'}},obsoleted_by:'1F9D9-200D-2640-FE0F',a:'Mage',b:'1F9D9',k:[49,49],o:5},dagger_knife:{a:'Dagger Knife',b:'1F5E1-FE0F',c:'1F5E1',k:[30,24],o:2},partly_sunny:{a:'Sun Behind Cloud',b:'26C5',j:['weather','nature','cloudy','morning','fall','spring'],k:[54,2],o:2},large_yellow_circle:{a:'Large Yellow Circle',b:'1F7E1',k:[37,4],o:12},male_mage:{skin_variations:{'1F3FB':{unified:'1F9D9-1F3FB-200D-2642-FE0F',non_qualified:'1F9D9-1F3FB-200D-2642',image:'1f9d9-1f3fb-200d-2642-fe0f.png',sheet_x:49,sheet_y:44,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9D9-1F3FC-200D-2642-FE0F',non_qualified:'1F9D9-1F3FC-200D-2642',image:'1f9d9-1f3fc-200d-2642-fe0f.png',sheet_x:49,sheet_y:45,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9D9-1F3FD-200D-2642-FE0F',non_qualified:'1F9D9-1F3FD-200D-2642',image:'1f9d9-1f3fd-200d-2642-fe0f.png',sheet_x:49,sheet_y:46,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9D9-1F3FE-200D-2642-FE0F',non_qualified:'1F9D9-1F3FE-200D-2642',image:'1f9d9-1f3fe-200d-2642-fe0f.png',sheet_x:49,sheet_y:47,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9D9-1F3FF-200D-2642-FE0F',non_qualified:'1F9D9-1F3FF-200D-2642',image:'1f9d9-1f3ff-200d-2642-fe0f.png',sheet_x:49,sheet_y:48,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Male Mage',b:'1F9D9-200D-2642-FE0F',c:'1F9D9-200D-2642',k:[49,43],o:5},'flag-pa':{a:'Panama Flag',b:'1F1F5-1F1E6',k:[3,38],o:2},thunder_cloud_and_rain:{a:'Thunder Cloud and Rain',b:'26C8-FE0F',c:'26C8',k:[54,3],o:2},large_green_circle:{a:'Large Green Circle',b:'1F7E2',k:[37,5],o:12},female_mage:{skin_variations:{'1F3FB':{unified:'1F9D9-1F3FB-200D-2640-FE0F',non_qualified:'1F9D9-1F3FB-200D-2640',image:'1f9d9-1f3fb-200d-2640-fe0f.png',sheet_x:49,sheet_y:38,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9D9-1F3FB'},'1F3FC':{unified:'1F9D9-1F3FC-200D-2640-FE0F',non_qualified:'1F9D9-1F3FC-200D-2640',image:'1f9d9-1f3fc-200d-2640-fe0f.png',sheet_x:49,sheet_y:39,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9D9-1F3FC'},'1F3FD':{unified:'1F9D9-1F3FD-200D-2640-FE0F',non_qualified:'1F9D9-1F3FD-200D-2640',image:'1f9d9-1f3fd-200d-2640-fe0f.png',sheet_x:49,sheet_y:40,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9D9-1F3FD'},'1F3FE':{unified:'1F9D9-1F3FE-200D-2640-FE0F',non_qualified:'1F9D9-1F3FE-200D-2640',image:'1f9d9-1f3fe-200d-2640-fe0f.png',sheet_x:49,sheet_y:41,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9D9-1F3FE'},'1F3FF':{unified:'1F9D9-1F3FF-200D-2640-FE0F',non_qualified:'1F9D9-1F3FF-200D-2640',image:'1f9d9-1f3ff-200d-2640-fe0f.png',sheet_x:49,sheet_y:42,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9D9-1F3FF'}},obsoletes:'1F9D9',a:'Female Mage',b:'1F9D9-200D-2640-FE0F',c:'1F9D9-200D-2640',k:[49,37],o:5},crossed_swords:{a:'Crossed Swords',b:'2694-FE0F',c:'2694',j:['weapon'],k:[53,43],o:2},'flag-pe':{a:'Peru Flag',b:'1F1F5-1F1EA',k:[3,39],o:2},gun:{a:'Pistol',b:'1F52B',j:['violence','weapon','pistol','revolver'],k:[28,14],o:2},mostly_sunny:{a:'Mostly Sunny',b:'1F324-FE0F',c:'1F324',k:[5,53],n:['sun_small_cloud'],o:2},fairy:{skin_variations:{'1F3FB':{unified:'1F9DA-1F3FB',non_qualified:null,image:'1f9da-1f3fb.png',sheet_x:50,sheet_y:11,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false,obsoleted_by:'1F9DA-1F3FB-200D-2640-FE0F'},'1F3FC':{unified:'1F9DA-1F3FC',non_qualified:null,image:'1f9da-1f3fc.png',sheet_x:50,sheet_y:12,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false,obsoleted_by:'1F9DA-1F3FC-200D-2640-FE0F'},'1F3FD':{unified:'1F9DA-1F3FD',non_qualified:null,image:'1f9da-1f3fd.png',sheet_x:50,sheet_y:13,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false,obsoleted_by:'1F9DA-1F3FD-200D-2640-FE0F'},'1F3FE':{unified:'1F9DA-1F3FE',non_qualified:null,image:'1f9da-1f3fe.png',sheet_x:50,sheet_y:14,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false,obsoleted_by:'1F9DA-1F3FE-200D-2640-FE0F'},'1F3FF':{unified:'1F9DA-1F3FF',non_qualified:null,image:'1f9da-1f3ff.png',sheet_x:50,sheet_y:15,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false,obsoleted_by:'1F9DA-1F3FF-200D-2640-FE0F'}},obsoleted_by:'1F9DA-200D-2640-FE0F',a:'Fairy',b:'1F9DA',k:[50,10],o:5},'flag-pf':{a:'French Polynesia Flag',b:'1F1F5-1F1EB',k:[3,40],o:2},large_blue_circle:{a:'Large Blue Circle',b:'1F535',j:['shape','icon','button'],k:[28,24],o:2},large_purple_circle:{a:'Large Purple Circle',b:'1F7E3',k:[37,6],o:12},bow_and_arrow:{a:'Bow and Arrow',b:'1F3F9',j:['sports'],k:[11,21],o:2},male_fairy:{skin_variations:{'1F3FB':{unified:'1F9DA-1F3FB-200D-2642-FE0F',non_qualified:'1F9DA-1F3FB-200D-2642',image:'1f9da-1f3fb-200d-2642-fe0f.png',sheet_x:50,sheet_y:5,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F9DA-1F3FC-200D-2642-FE0F',non_qualified:'1F9DA-1F3FC-200D-2642',image:'1f9da-1f3fc-200d-2642-fe0f.png',sheet_x:50,sheet_y:6,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F9DA-1F3FD-200D-2642-FE0F',non_qualified:'1F9DA-1F3FD-200D-2642',image:'1f9da-1f3fd-200d-2642-fe0f.png',sheet_x:50,sheet_y:7,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F9DA-1F3FE-200D-2642-FE0F',non_qualified:'1F9DA-1F3FE-200D-2642',image:'1f9da-1f3fe-200d-2642-fe0f.png',sheet_x:50,sheet_y:8,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F9DA-1F3FF-200D-2642-FE0F',non_qualified:'1F9DA-1F3FF-200D-2642',image:'1f9da-1f3ff-200d-2642-fe0f.png',sheet_x:50,sheet_y:9,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},a:'Male Fairy',b:'1F9DA-200D-2642-FE0F',c:'1F9DA-200D-2642',k:[50,4],o:5},barely_sunny:{a:'Barely Sunny',b:'1F325-FE0F',c:'1F325',k:[5,54],n:['sun_behind_cloud'],o:2},'flag-pg':{a:'Papua New Guinea Flag',b:'1F1F5-1F1EC',k:[3,41],o:2},shield:{a:'Shield',b:'1F6E1-FE0F',c:'1F6E1',j:['protection','security'],k:[36,43],o:2},partly_sunny_rain:{a:'Partly Sunny Rain',b:'1F326-FE0F',c:'1F326',k:[5,55],n:['sun_behind_rain_cloud'],o:2},large_brown_circle:{a:'Large Brown Circle',b:'1F7E4',k:[37,7],o:12},female_fairy:{skin_variations:{'1F3FB':{unified:'1F9DA-1F3FB-200D-2640-FE0F',non_qualified:'1F9DA-1F3FB-200D-2640',image:'1f9da-1f3fb-200d-2640-fe0f.png',sheet_x:49,sheet_y:56,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false,obsoletes:'1F9DA-1F3FB'},'1F3FC':{unified:'1F9DA-1F3FC-200D-2640-FE0F',non_qualified:'1F9DA-1F3FC-200D-2640',image:'1f9da-1f3fc-200d-2640-fe0f.png',sheet_x:50,sheet_y:0,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false,obsoletes:'1F9DA-1F3FC'},'1F3FD':{unified:'1F9DA-1F3FD-200D-2640-FE0F',non_qualified:'1F9DA-1F3FD-200D-2640',image:'1f9da-1f3fd-200d-2640-fe0f.png',sheet_x:50,sheet_y:1,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false,obsoletes:'1F9DA-1F3FD'},'1F3FE':{unified:'1F9DA-1F3FE-200D-2640-FE0F',non_qualified:'1F9DA-1F3FE-200D-2640',image:'1f9da-1f3fe-200d-2640-fe0f.png',sheet_x:50,sheet_y:2,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false,obsoletes:'1F9DA-1F3FE'},'1F3FF':{unified:'1F9DA-1F3FF-200D-2640-FE0F',non_qualified:'1F9DA-1F3FF-200D-2640',image:'1f9da-1f3ff-200d-2640-fe0f.png',sheet_x:50,sheet_y:3,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false,obsoletes:'1F9DA-1F3FF'}},obsoletes:'1F9DA',a:'Female Fairy',b:'1F9DA-200D-2640-FE0F',c:'1F9DA-200D-2640',k:[49,55],o:5},'flag-ph':{a:'Philippines Flag',b:'1F1F5-1F1ED',k:[3,42],o:2},'flag-pk':{a:'Pakistan Flag',b:'1F1F5-1F1F0',k:[3,43],o:2},black_circle:{a:'Medium Black Circle',b:'26AB',j:['shape','button','round'],k:[53,53],o:2},wrench:{a:'Wrench',b:'1F527',j:['tools','diy','ikea','fix','maintainer'],k:[28,10],o:2},vampire:{skin_variations:{'1F3FB':{unified:'1F9DB-1F3FB',non_qualified:null,image:'1f9db-1f3fb.png',sheet_x:50,sheet_y:29,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9DB-1F3FB-200D-2640-FE0F'},'1F3FC':{unified:'1F9DB-1F3FC',non_qualified:null,image:'1f9db-1f3fc.png',sheet_x:50,sheet_y:30,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9DB-1F3FC-200D-2640-FE0F'},'1F3FD':{unified:'1F9DB-1F3FD',non_qualified:null,image:'1f9db-1f3fd.png',sheet_x:50,sheet_y:31,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9DB-1F3FD-200D-2640-FE0F'},'1F3FE':{unified:'1F9DB-1F3FE',non_qualified:null,image:'1f9db-1f3fe.png',sheet_x:50,sheet_y:32,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9DB-1F3FE-200D-2640-FE0F'},'1F3FF':{unified:'1F9DB-1F3FF',non_qualified:null,image:'1f9db-1f3ff.png',sheet_x:50,sheet_y:33,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9DB-1F3FF-200D-2640-FE0F'}},obsoleted_by:'1F9DB-200D-2640-FE0F',a:'Vampire',b:'1F9DB',k:[50,28],o:5},rain_cloud:{a:'Rain Cloud',b:'1F327-FE0F',c:'1F327',k:[5,56],o:2},snow_cloud:{a:'Snow Cloud',b:'1F328-FE0F',c:'1F328',k:[6,0],o:2},'flag-pl':{a:'Poland Flag',b:'1F1F5-1F1F1',k:[3,44],o:2},male_vampire:{skin_variations:{'1F3FB':{unified:'1F9DB-1F3FB-200D-2642-FE0F',non_qualified:'1F9DB-1F3FB-200D-2642',image:'1f9db-1f3fb-200d-2642-fe0f.png',sheet_x:50,sheet_y:23,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9DB-1F3FC-200D-2642-FE0F',non_qualified:'1F9DB-1F3FC-200D-2642',image:'1f9db-1f3fc-200d-2642-fe0f.png',sheet_x:50,sheet_y:24,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9DB-1F3FD-200D-2642-FE0F',non_qualified:'1F9DB-1F3FD-200D-2642',image:'1f9db-1f3fd-200d-2642-fe0f.png',sheet_x:50,sheet_y:25,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9DB-1F3FE-200D-2642-FE0F',non_qualified:'1F9DB-1F3FE-200D-2642',image:'1f9db-1f3fe-200d-2642-fe0f.png',sheet_x:50,sheet_y:26,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9DB-1F3FF-200D-2642-FE0F',non_qualified:'1F9DB-1F3FF-200D-2642',image:'1f9db-1f3ff-200d-2642-fe0f.png',sheet_x:50,sheet_y:27,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Male Vampire',b:'1F9DB-200D-2642-FE0F',c:'1F9DB-200D-2642',k:[50,22],o:5},nut_and_bolt:{a:'Nut and Bolt',b:'1F529',j:['handy','tools','fix'],k:[28,12],o:2},white_circle:{a:'Medium White Circle',b:'26AA',j:['shape','round'],k:[53,52],o:2},female_vampire:{skin_variations:{'1F3FB':{unified:'1F9DB-1F3FB-200D-2640-FE0F',non_qualified:'1F9DB-1F3FB-200D-2640',image:'1f9db-1f3fb-200d-2640-fe0f.png',sheet_x:50,sheet_y:17,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9DB-1F3FB'},'1F3FC':{unified:'1F9DB-1F3FC-200D-2640-FE0F',non_qualified:'1F9DB-1F3FC-200D-2640',image:'1f9db-1f3fc-200d-2640-fe0f.png',sheet_x:50,sheet_y:18,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9DB-1F3FC'},'1F3FD':{unified:'1F9DB-1F3FD-200D-2640-FE0F',non_qualified:'1F9DB-1F3FD-200D-2640',image:'1f9db-1f3fd-200d-2640-fe0f.png',sheet_x:50,sheet_y:19,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9DB-1F3FD'},'1F3FE':{unified:'1F9DB-1F3FE-200D-2640-FE0F',non_qualified:'1F9DB-1F3FE-200D-2640',image:'1f9db-1f3fe-200d-2640-fe0f.png',sheet_x:50,sheet_y:20,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9DB-1F3FE'},'1F3FF':{unified:'1F9DB-1F3FF-200D-2640-FE0F',non_qualified:'1F9DB-1F3FF-200D-2640',image:'1f9db-1f3ff-200d-2640-fe0f.png',sheet_x:50,sheet_y:21,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9DB-1F3FF'}},obsoletes:'1F9DB',a:'Female Vampire',b:'1F9DB-200D-2640-FE0F',c:'1F9DB-200D-2640',k:[50,16],o:5},'flag-pm':{a:'St. Pierre & Miquelon Flag',b:'1F1F5-1F1F2',k:[3,45],o:2},large_red_square:{a:'Large Red Square',b:'1F7E5',k:[37,8],o:12},lightning:{a:'Lightning',b:'1F329-FE0F',c:'1F329',k:[6,1],n:['lightning_cloud'],o:2},gear:{a:'Gear',b:'2699-FE0F',c:'2699',j:['cog'],k:[53,47],o:2},merperson:{skin_variations:{'1F3FB':{unified:'1F9DC-1F3FB',non_qualified:null,image:'1f9dc-1f3fb.png',sheet_x:50,sheet_y:47,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9DC-1F3FB-200D-2642-FE0F'},'1F3FC':{unified:'1F9DC-1F3FC',non_qualified:null,image:'1f9dc-1f3fc.png',sheet_x:50,sheet_y:48,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9DC-1F3FC-200D-2642-FE0F'},'1F3FD':{unified:'1F9DC-1F3FD',non_qualified:null,image:'1f9dc-1f3fd.png',sheet_x:50,sheet_y:49,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9DC-1F3FD-200D-2642-FE0F'},'1F3FE':{unified:'1F9DC-1F3FE',non_qualified:null,image:'1f9dc-1f3fe.png',sheet_x:50,sheet_y:50,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9DC-1F3FE-200D-2642-FE0F'},'1F3FF':{unified:'1F9DC-1F3FF',non_qualified:null,image:'1f9dc-1f3ff.png',sheet_x:50,sheet_y:51,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9DC-1F3FF-200D-2642-FE0F'}},obsoleted_by:'1F9DC-200D-2642-FE0F',a:'Merperson',b:'1F9DC',k:[50,46],o:5},tornado:{a:'Tornado',b:'1F32A-FE0F',c:'1F32A',j:['weather','cyclone','twister'],k:[6,2],n:['tornado_cloud'],o:2},large_orange_square:{a:'Large Orange Square',b:'1F7E7',k:[37,10],o:12},'flag-pn':{a:'Pitcairn Islands Flag',b:'1F1F5-1F1F3',k:[3,46],o:2},compression:{a:'Compression',b:'1F5DC-FE0F',c:'1F5DC',k:[30,21],o:2},merman:{skin_variations:{'1F3FB':{unified:'1F9DC-1F3FB-200D-2642-FE0F',non_qualified:'1F9DC-1F3FB-200D-2642',image:'1f9dc-1f3fb-200d-2642-fe0f.png',sheet_x:50,sheet_y:41,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9DC-1F3FB'},'1F3FC':{unified:'1F9DC-1F3FC-200D-2642-FE0F',non_qualified:'1F9DC-1F3FC-200D-2642',image:'1f9dc-1f3fc-200d-2642-fe0f.png',sheet_x:50,sheet_y:42,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9DC-1F3FC'},'1F3FD':{unified:'1F9DC-1F3FD-200D-2642-FE0F',non_qualified:'1F9DC-1F3FD-200D-2642',image:'1f9dc-1f3fd-200d-2642-fe0f.png',sheet_x:50,sheet_y:43,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9DC-1F3FD'},'1F3FE':{unified:'1F9DC-1F3FE-200D-2642-FE0F',non_qualified:'1F9DC-1F3FE-200D-2642',image:'1f9dc-1f3fe-200d-2642-fe0f.png',sheet_x:50,sheet_y:44,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9DC-1F3FE'},'1F3FF':{unified:'1F9DC-1F3FF-200D-2642-FE0F',non_qualified:'1F9DC-1F3FF-200D-2642',image:'1f9dc-1f3ff-200d-2642-fe0f.png',sheet_x:50,sheet_y:45,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9DC-1F3FF'}},obsoletes:'1F9DC',a:'Merman',b:'1F9DC-200D-2642-FE0F',c:'1F9DC-200D-2642',j:['man','male','triton'],k:[50,40],o:5},large_yellow_square:{a:'Large Yellow Square',b:'1F7E8',k:[37,11],o:12},fog:{a:'Fog',b:'1F32B-FE0F',c:'1F32B',j:['weather'],k:[6,3],o:2},scales:{a:'Scales',b:'2696-FE0F',c:'2696',k:[53,45],o:2},'flag-pr':{a:'Puerto Rico Flag',b:'1F1F5-1F1F7',k:[3,47],o:2},wind_blowing_face:{a:'Wind Blowing Face',b:'1F32C-FE0F',c:'1F32C',k:[6,4],o:2},'flag-ps':{a:'Palestinian Territories Flag',b:'1F1F5-1F1F8',k:[3,48],o:2},mermaid:{skin_variations:{'1F3FB':{unified:'1F9DC-1F3FB-200D-2640-FE0F',non_qualified:'1F9DC-1F3FB-200D-2640',image:'1f9dc-1f3fb-200d-2640-fe0f.png',sheet_x:50,sheet_y:35,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9DC-1F3FC-200D-2640-FE0F',non_qualified:'1F9DC-1F3FC-200D-2640',image:'1f9dc-1f3fc-200d-2640-fe0f.png',sheet_x:50,sheet_y:36,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9DC-1F3FD-200D-2640-FE0F',non_qualified:'1F9DC-1F3FD-200D-2640',image:'1f9dc-1f3fd-200d-2640-fe0f.png',sheet_x:50,sheet_y:37,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9DC-1F3FE-200D-2640-FE0F',non_qualified:'1F9DC-1F3FE-200D-2640',image:'1f9dc-1f3fe-200d-2640-fe0f.png',sheet_x:50,sheet_y:38,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9DC-1F3FF-200D-2640-FE0F',non_qualified:'1F9DC-1F3FF-200D-2640',image:'1f9dc-1f3ff-200d-2640-fe0f.png',sheet_x:50,sheet_y:39,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Mermaid',b:'1F9DC-200D-2640-FE0F',c:'1F9DC-200D-2640',j:['woman','female','merwoman','ariel'],k:[50,34],o:5},probing_cane:{a:'Probing Cane',b:'1F9AF',k:[43,3],o:12},large_green_square:{a:'Large Green Square',b:'1F7E9',k:[37,12],o:12},'flag-pt':{a:'Portugal Flag',b:'1F1F5-1F1F9',k:[3,49],o:2},link:{a:'Link Symbol',b:'1F517',j:['rings','url'],k:[27,51],o:2},large_blue_square:{a:'Large Blue Square',b:'1F7E6',k:[37,9],o:12},elf:{skin_variations:{'1F3FB':{unified:'1F9DD-1F3FB',non_qualified:null,image:'1f9dd-1f3fb.png',sheet_x:51,sheet_y:8,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9DD-1F3FB-200D-2642-FE0F'},'1F3FC':{unified:'1F9DD-1F3FC',non_qualified:null,image:'1f9dd-1f3fc.png',sheet_x:51,sheet_y:9,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9DD-1F3FC-200D-2642-FE0F'},'1F3FD':{unified:'1F9DD-1F3FD',non_qualified:null,image:'1f9dd-1f3fd.png',sheet_x:51,sheet_y:10,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9DD-1F3FD-200D-2642-FE0F'},'1F3FE':{unified:'1F9DD-1F3FE',non_qualified:null,image:'1f9dd-1f3fe.png',sheet_x:51,sheet_y:11,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9DD-1F3FE-200D-2642-FE0F'},'1F3FF':{unified:'1F9DD-1F3FF',non_qualified:null,image:'1f9dd-1f3ff.png',sheet_x:51,sheet_y:12,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9DD-1F3FF-200D-2642-FE0F'}},obsoleted_by:'1F9DD-200D-2642-FE0F',a:'Elf',b:'1F9DD',k:[51,7],o:5},cyclone:{a:'Cyclone',b:'1F300',j:['weather','swirl','blue','cloud','vortex','spiral','whirlpool','spin','tornado','hurricane','typhoon'],k:[5,19],o:2},rainbow:{a:'Rainbow',b:'1F308',j:['nature','happy','unicorn_face','photo','sky','spring'],k:[5,27],o:2},male_elf:{skin_variations:{'1F3FB':{unified:'1F9DD-1F3FB-200D-2642-FE0F',non_qualified:'1F9DD-1F3FB-200D-2642',image:'1f9dd-1f3fb-200d-2642-fe0f.png',sheet_x:51,sheet_y:2,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9DD-1F3FB'},'1F3FC':{unified:'1F9DD-1F3FC-200D-2642-FE0F',non_qualified:'1F9DD-1F3FC-200D-2642',image:'1f9dd-1f3fc-200d-2642-fe0f.png',sheet_x:51,sheet_y:3,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9DD-1F3FC'},'1F3FD':{unified:'1F9DD-1F3FD-200D-2642-FE0F',non_qualified:'1F9DD-1F3FD-200D-2642',image:'1f9dd-1f3fd-200d-2642-fe0f.png',sheet_x:51,sheet_y:4,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9DD-1F3FD'},'1F3FE':{unified:'1F9DD-1F3FE-200D-2642-FE0F',non_qualified:'1F9DD-1F3FE-200D-2642',image:'1f9dd-1f3fe-200d-2642-fe0f.png',sheet_x:51,sheet_y:5,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9DD-1F3FE'},'1F3FF':{unified:'1F9DD-1F3FF-200D-2642-FE0F',non_qualified:'1F9DD-1F3FF-200D-2642',image:'1f9dd-1f3ff-200d-2642-fe0f.png',sheet_x:51,sheet_y:6,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9DD-1F3FF'}},obsoletes:'1F9DD',a:'Male Elf',b:'1F9DD-200D-2642-FE0F',c:'1F9DD-200D-2642',k:[51,1],o:5},'flag-pw':{a:'Palau Flag',b:'1F1F5-1F1FC',k:[3,50],o:2},chains:{a:'Chains',b:'26D3-FE0F',c:'26D3',j:['lock','arrest'],k:[54,7],o:2},large_purple_square:{a:'Large Purple Square',b:'1F7EA',k:[37,13],o:12},female_elf:{skin_variations:{'1F3FB':{unified:'1F9DD-1F3FB-200D-2640-FE0F',non_qualified:'1F9DD-1F3FB-200D-2640',image:'1f9dd-1f3fb-200d-2640-fe0f.png',sheet_x:50,sheet_y:53,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9DD-1F3FC-200D-2640-FE0F',non_qualified:'1F9DD-1F3FC-200D-2640',image:'1f9dd-1f3fc-200d-2640-fe0f.png',sheet_x:50,sheet_y:54,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9DD-1F3FD-200D-2640-FE0F',non_qualified:'1F9DD-1F3FD-200D-2640',image:'1f9dd-1f3fd-200d-2640-fe0f.png',sheet_x:50,sheet_y:55,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9DD-1F3FE-200D-2640-FE0F',non_qualified:'1F9DD-1F3FE-200D-2640',image:'1f9dd-1f3fe-200d-2640-fe0f.png',sheet_x:50,sheet_y:56,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9DD-1F3FF-200D-2640-FE0F',non_qualified:'1F9DD-1F3FF-200D-2640',image:'1f9dd-1f3ff-200d-2640-fe0f.png',sheet_x:51,sheet_y:0,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Female Elf',b:'1F9DD-200D-2640-FE0F',c:'1F9DD-200D-2640',k:[50,52],o:5},'flag-py':{a:'Paraguay Flag',b:'1F1F5-1F1FE',k:[3,51],o:2},closed_umbrella:{a:'Closed Umbrella',b:'1F302',j:['weather','rain','drizzle'],k:[5,21],o:2},toolbox:{a:'Toolbox',b:'1F9F0',k:[51,35],o:11},large_brown_square:{a:'Large Brown Square',b:'1F7EB',k:[37,14],o:12},magnet:{a:'Magnet',b:'1F9F2',k:[51,37],o:11},genie:{obsoleted_by:'1F9DE-200D-2642-FE0F',a:'Genie',b:'1F9DE',k:[51,15],o:5},'flag-qa':{a:'Qatar Flag',b:'1F1F6-1F1E6',k:[3,52],o:2},umbrella:{a:'Umbrella',b:'2602-FE0F',c:'2602',j:['rainy','weather','spring'],k:[52,51],o:2},black_large_square:{a:'Black Large Square',b:'2B1B',j:['shape','icon','button'],k:[55,40],o:2},male_genie:{obsoletes:'1F9DE',a:'Male Genie',b:'1F9DE-200D-2642-FE0F',c:'1F9DE-200D-2642',k:[51,14],o:5},umbrella_with_rain_drops:{a:'Umbrella with Rain Drops',b:'2614',k:[52,56],o:2},'flag-re':{a:'Réunion Flag',b:'1F1F7-1F1EA',k:[3,53],o:2},white_large_square:{a:'White Large Square',b:'2B1C',j:['shape','icon','stone','button'],k:[55,41],o:2},alembic:{a:'Alembic',b:'2697-FE0F',c:'2697',j:['distilling','science','experiment','chemistry'],k:[53,46],o:2},black_medium_square:{a:'Black Medium Square',b:'25FC-FE0F',c:'25FC',j:['shape','button','icon'],k:[52,46],o:2},test_tube:{a:'Test Tube',b:'1F9EA',k:[51,29],o:11},'flag-ro':{a:'Romania Flag',b:'1F1F7-1F1F4',k:[3,54],o:2},female_genie:{a:'Female Genie',b:'1F9DE-200D-2640-FE0F',c:'1F9DE-200D-2640',k:[51,13],o:5},umbrella_on_ground:{a:'Umbrella on Ground',b:'26F1-FE0F',c:'26F1',k:[54,12],o:2},zombie:{obsoleted_by:'1F9DF-200D-2642-FE0F',a:'Zombie',b:'1F9DF',k:[51,18],o:5},zap:{a:'High Voltage Sign',b:'26A1',j:['thunder','weather','lightning bolt','fast'],k:[53,51],o:2},white_medium_square:{a:'White Medium Square',b:'25FB-FE0F',c:'25FB',j:['shape','stone','icon'],k:[52,45],o:2},'flag-rs':{a:'Serbia Flag',b:'1F1F7-1F1F8',k:[3,55],o:2},petri_dish:{a:'Petri Dish',b:'1F9EB',k:[51,30],o:11},snowflake:{a:'Snowflake',b:'2744-FE0F',c:'2744',j:['winter','season','cold','weather','christmas','xmas'],k:[55,19],o:2},dna:{a:'Dna Double Helix',b:'1F9EC',k:[51,31],o:11},male_zombie:{obsoletes:'1F9DF',a:'Male Zombie',b:'1F9DF-200D-2642-FE0F',c:'1F9DF-200D-2642',k:[51,17],o:5},black_medium_small_square:{a:'Black Medium Small Square',b:'25FE',j:['icon','shape','button'],k:[52,48],o:2},ru:{a:'Russia Flag',b:'1F1F7-1F1FA',j:['russian','federation','flag','nation','country','banner'],k:[3,56],n:['flag-ru'],o:2},female_zombie:{a:'Female Zombie',b:'1F9DF-200D-2640-FE0F',c:'1F9DF-200D-2640',k:[51,16],o:5},'flag-rw':{a:'Rwanda Flag',b:'1F1F7-1F1FC',k:[4,0],o:2},snowman:{a:'Snowman',b:'2603-FE0F',c:'2603',j:['winter','season','cold','weather','christmas','xmas','frozen','without_snow'],k:[52,52],o:2},white_medium_small_square:{a:'White Medium Small Square',b:'25FD',j:['shape','stone','icon','button'],k:[52,47],o:2},microscope:{a:'Microscope',b:'1F52C',j:['laboratory','experiment','zoomin','science','study'],k:[28,15],o:2},snowman_without_snow:{a:'Snowman Without Snow',b:'26C4',k:[54,1],o:2},telescope:{a:'Telescope',b:'1F52D',j:['stars','space','zoom','science','astronomy'],k:[28,16],o:2},massage:{skin_variations:{'1F3FB':{unified:'1F486-1F3FB',non_qualified:null,image:'1f486-1f3fb.png',sheet_x:24,sheet_y:52,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F486-1F3FC',non_qualified:null,image:'1f486-1f3fc.png',sheet_x:24,sheet_y:53,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F486-1F3FD',non_qualified:null,image:'1f486-1f3fd.png',sheet_x:24,sheet_y:54,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F486-1F3FE',non_qualified:null,image:'1f486-1f3fe.png',sheet_x:24,sheet_y:55,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F486-1F3FF',non_qualified:null,image:'1f486-1f3ff.png',sheet_x:24,sheet_y:56,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},obsoleted_by:'1F486-200D-2640-FE0F',a:'Face Massage',b:'1F486',k:[24,51],o:2},black_small_square:{a:'Black Small Square',b:'25AA-FE0F',c:'25AA',j:['shape','icon'],k:[52,41],o:2},'flag-sa':{a:'Saudi Arabia Flag',b:'1F1F8-1F1E6',k:[4,1],o:2},'man-getting-massage':{skin_variations:{'1F3FB':{unified:'1F486-1F3FB-200D-2642-FE0F',non_qualified:'1F486-1F3FB-200D-2642',image:'1f486-1f3fb-200d-2642-fe0f.png',sheet_x:24,sheet_y:46,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F486-1F3FC-200D-2642-FE0F',non_qualified:'1F486-1F3FC-200D-2642',image:'1f486-1f3fc-200d-2642-fe0f.png',sheet_x:24,sheet_y:47,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F486-1F3FD-200D-2642-FE0F',non_qualified:'1F486-1F3FD-200D-2642',image:'1f486-1f3fd-200d-2642-fe0f.png',sheet_x:24,sheet_y:48,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F486-1F3FE-200D-2642-FE0F',non_qualified:'1F486-1F3FE-200D-2642',image:'1f486-1f3fe-200d-2642-fe0f.png',sheet_x:24,sheet_y:49,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F486-1F3FF-200D-2642-FE0F',non_qualified:'1F486-1F3FF-200D-2642',image:'1f486-1f3ff-200d-2642-fe0f.png',sheet_x:24,sheet_y:50,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man Getting Massage',b:'1F486-200D-2642-FE0F',c:'1F486-200D-2642',k:[24,45],o:4},comet:{a:'Comet',b:'2604-FE0F',c:'2604',j:['space'],k:[52,53],o:2},white_small_square:{a:'White Small Square',b:'25AB-FE0F',c:'25AB',j:['shape','icon'],k:[52,42],o:2},'flag-sb':{a:'Solomon Islands Flag',b:'1F1F8-1F1E7',k:[4,2],o:2},satellite_antenna:{a:'Satellite Antenna',b:'1F4E1',k:[26,55],o:2},large_orange_diamond:{a:'Large Orange Diamond',b:'1F536',j:['shape','jewel','gem'],k:[28,25],o:2},'woman-getting-massage':{skin_variations:{'1F3FB':{unified:'1F486-1F3FB-200D-2640-FE0F',non_qualified:'1F486-1F3FB-200D-2640',image:'1f486-1f3fb-200d-2640-fe0f.png',sheet_x:24,sheet_y:40,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F486-1F3FC-200D-2640-FE0F',non_qualified:'1F486-1F3FC-200D-2640',image:'1f486-1f3fc-200d-2640-fe0f.png',sheet_x:24,sheet_y:41,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F486-1F3FD-200D-2640-FE0F',non_qualified:'1F486-1F3FD-200D-2640',image:'1f486-1f3fd-200d-2640-fe0f.png',sheet_x:24,sheet_y:42,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F486-1F3FE-200D-2640-FE0F',non_qualified:'1F486-1F3FE-200D-2640',image:'1f486-1f3fe-200d-2640-fe0f.png',sheet_x:24,sheet_y:43,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F486-1F3FF-200D-2640-FE0F',non_qualified:'1F486-1F3FF-200D-2640',image:'1f486-1f3ff-200d-2640-fe0f.png',sheet_x:24,sheet_y:44,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},obsoletes:'1F486',a:'Woman Getting Massage',b:'1F486-200D-2640-FE0F',c:'1F486-200D-2640',k:[24,39],o:4},fire:{a:'Fire',b:'1F525',j:['hot','cook','flame'],k:[28,8],o:2},syringe:{a:'Syringe',b:'1F489',j:['health','hospital','drugs','blood','medicine','needle','doctor','nurse'],k:[25,19],o:2},'flag-sc':{a:'Seychelles Flag',b:'1F1F8-1F1E8',k:[4,3],o:2},large_blue_diamond:{a:'Large Blue Diamond',b:'1F537',j:['shape','jewel','gem'],k:[28,26],o:2},'flag-sd':{a:'Sudan Flag',b:'1F1F8-1F1E9',k:[4,4],o:2},droplet:{a:'Droplet',b:'1F4A7',j:['water','drip','faucet','spring'],k:[25,49],o:2},drop_of_blood:{a:'Drop of Blood',b:'1FA78',k:[51,55],o:12},haircut:{skin_variations:{'1F3FB':{unified:'1F487-1F3FB',non_qualified:null,image:'1f487-1f3fb.png',sheet_x:25,sheet_y:13,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F487-1F3FC',non_qualified:null,image:'1f487-1f3fc.png',sheet_x:25,sheet_y:14,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F487-1F3FD',non_qualified:null,image:'1f487-1f3fd.png',sheet_x:25,sheet_y:15,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F487-1F3FE',non_qualified:null,image:'1f487-1f3fe.png',sheet_x:25,sheet_y:16,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F487-1F3FF',non_qualified:null,image:'1f487-1f3ff.png',sheet_x:25,sheet_y:17,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},obsoleted_by:'1F487-200D-2640-FE0F',a:'Haircut',b:'1F487',k:[25,12],o:2},ocean:{a:'Water Wave',b:'1F30A',j:['sea','water','wave','nature','tsunami','disaster'],k:[5,29],o:2},'flag-se':{a:'Sweden Flag',b:'1F1F8-1F1EA',k:[4,5],o:2},'man-getting-haircut':{skin_variations:{'1F3FB':{unified:'1F487-1F3FB-200D-2642-FE0F',non_qualified:'1F487-1F3FB-200D-2642',image:'1f487-1f3fb-200d-2642-fe0f.png',sheet_x:25,sheet_y:7,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F487-1F3FC-200D-2642-FE0F',non_qualified:'1F487-1F3FC-200D-2642',image:'1f487-1f3fc-200d-2642-fe0f.png',sheet_x:25,sheet_y:8,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F487-1F3FD-200D-2642-FE0F',non_qualified:'1F487-1F3FD-200D-2642',image:'1f487-1f3fd-200d-2642-fe0f.png',sheet_x:25,sheet_y:9,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F487-1F3FE-200D-2642-FE0F',non_qualified:'1F487-1F3FE-200D-2642',image:'1f487-1f3fe-200d-2642-fe0f.png',sheet_x:25,sheet_y:10,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F487-1F3FF-200D-2642-FE0F',non_qualified:'1F487-1F3FF-200D-2642',image:'1f487-1f3ff-200d-2642-fe0f.png',sheet_x:25,sheet_y:11,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man Getting Haircut',b:'1F487-200D-2642-FE0F',c:'1F487-200D-2642',k:[25,6],o:4},small_orange_diamond:{a:'Small Orange Diamond',b:'1F538',j:['shape','jewel','gem'],k:[28,27],o:2},pill:{a:'Pill',b:'1F48A',j:['health','medicine','doctor','pharmacy','drug'],k:[25,20],o:2},'woman-getting-haircut':{skin_variations:{'1F3FB':{unified:'1F487-1F3FB-200D-2640-FE0F',non_qualified:'1F487-1F3FB-200D-2640',image:'1f487-1f3fb-200d-2640-fe0f.png',sheet_x:25,sheet_y:1,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F487-1F3FC-200D-2640-FE0F',non_qualified:'1F487-1F3FC-200D-2640',image:'1f487-1f3fc-200d-2640-fe0f.png',sheet_x:25,sheet_y:2,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F487-1F3FD-200D-2640-FE0F',non_qualified:'1F487-1F3FD-200D-2640',image:'1f487-1f3fd-200d-2640-fe0f.png',sheet_x:25,sheet_y:3,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F487-1F3FE-200D-2640-FE0F',non_qualified:'1F487-1F3FE-200D-2640',image:'1f487-1f3fe-200d-2640-fe0f.png',sheet_x:25,sheet_y:4,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F487-1F3FF-200D-2640-FE0F',non_qualified:'1F487-1F3FF-200D-2640',image:'1f487-1f3ff-200d-2640-fe0f.png',sheet_x:25,sheet_y:5,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},obsoletes:'1F487',a:'Woman Getting Haircut',b:'1F487-200D-2640-FE0F',c:'1F487-200D-2640',k:[25,0],o:4},small_blue_diamond:{a:'Small Blue Diamond',b:'1F539',j:['shape','jewel','gem'],k:[28,28],o:2},'flag-sg':{a:'Singapore Flag',b:'1F1F8-1F1EC',k:[4,6],o:2},adhesive_bandage:{a:'Adhesive Bandage',b:'1FA79',k:[51,56],o:12},walking:{skin_variations:{'1F3FB':{unified:'1F6B6-1F3FB',non_qualified:null,image:'1f6b6-1f3fb.png',sheet_x:36,sheet_y:3,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F6B6-1F3FC',non_qualified:null,image:'1f6b6-1f3fc.png',sheet_x:36,sheet_y:4,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F6B6-1F3FD',non_qualified:null,image:'1f6b6-1f3fd.png',sheet_x:36,sheet_y:5,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F6B6-1F3FE',non_qualified:null,image:'1f6b6-1f3fe.png',sheet_x:36,sheet_y:6,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F6B6-1F3FF',non_qualified:null,image:'1f6b6-1f3ff.png',sheet_x:36,sheet_y:7,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},obsoleted_by:'1F6B6-200D-2642-FE0F',a:'Pedestrian',b:'1F6B6',k:[36,2],o:2},small_red_triangle:{a:'Up-Pointing Red Triangle',b:'1F53A',j:['shape','direction','up','top'],k:[28,29],o:2},'flag-sh':{a:'St. Helena Flag',b:'1F1F8-1F1ED',k:[4,7],o:2},stethoscope:{a:'Stethoscope',b:'1FA7A',k:[52,0],o:12},'man-walking':{skin_variations:{'1F3FB':{unified:'1F6B6-1F3FB-200D-2642-FE0F',non_qualified:'1F6B6-1F3FB-200D-2642',image:'1f6b6-1f3fb-200d-2642-fe0f.png',sheet_x:35,sheet_y:54,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F6B6-1F3FC-200D-2642-FE0F',non_qualified:'1F6B6-1F3FC-200D-2642',image:'1f6b6-1f3fc-200d-2642-fe0f.png',sheet_x:35,sheet_y:55,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F6B6-1F3FD-200D-2642-FE0F',non_qualified:'1F6B6-1F3FD-200D-2642',image:'1f6b6-1f3fd-200d-2642-fe0f.png',sheet_x:35,sheet_y:56,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F6B6-1F3FE-200D-2642-FE0F',non_qualified:'1F6B6-1F3FE-200D-2642',image:'1f6b6-1f3fe-200d-2642-fe0f.png',sheet_x:36,sheet_y:0,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F6B6-1F3FF-200D-2642-FE0F',non_qualified:'1F6B6-1F3FF-200D-2642',image:'1f6b6-1f3ff-200d-2642-fe0f.png',sheet_x:36,sheet_y:1,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},obsoletes:'1F6B6',a:'Man Walking',b:'1F6B6-200D-2642-FE0F',c:'1F6B6-200D-2642',k:[35,53],o:4},'flag-si':{a:'Slovenia Flag',b:'1F1F8-1F1EE',k:[4,8],o:2},door:{a:'Door',b:'1F6AA',j:['house','entry','exit'],k:[35,1],o:2},small_red_triangle_down:{a:'Down-Pointing Red Triangle',b:'1F53B',j:['shape','direction','bottom'],k:[28,30],o:2},'flag-sj':{a:'Svalbard & Jan Mayen Flag',b:'1F1F8-1F1EF',k:[4,9],o:2},diamond_shape_with_a_dot_inside:{a:'Diamond Shape with a Dot Inside',b:'1F4A0',j:['jewel','blue','gem','crystal','fancy'],k:[25,42],o:2},'woman-walking':{skin_variations:{'1F3FB':{unified:'1F6B6-1F3FB-200D-2640-FE0F',non_qualified:'1F6B6-1F3FB-200D-2640',image:'1f6b6-1f3fb-200d-2640-fe0f.png',sheet_x:35,sheet_y:48,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F6B6-1F3FC-200D-2640-FE0F',non_qualified:'1F6B6-1F3FC-200D-2640',image:'1f6b6-1f3fc-200d-2640-fe0f.png',sheet_x:35,sheet_y:49,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F6B6-1F3FD-200D-2640-FE0F',non_qualified:'1F6B6-1F3FD-200D-2640',image:'1f6b6-1f3fd-200d-2640-fe0f.png',sheet_x:35,sheet_y:50,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F6B6-1F3FE-200D-2640-FE0F',non_qualified:'1F6B6-1F3FE-200D-2640',image:'1f6b6-1f3fe-200d-2640-fe0f.png',sheet_x:35,sheet_y:51,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F6B6-1F3FF-200D-2640-FE0F',non_qualified:'1F6B6-1F3FF-200D-2640',image:'1f6b6-1f3ff-200d-2640-fe0f.png',sheet_x:35,sheet_y:52,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Woman Walking',b:'1F6B6-200D-2640-FE0F',c:'1F6B6-200D-2640',k:[35,47],o:4},bed:{a:'Bed',b:'1F6CF-FE0F',c:'1F6CF',j:['sleep','rest'],k:[36,37],o:2},radio_button:{a:'Radio Button',b:'1F518',j:['input','old','music','circle'],k:[27,52],o:2},'flag-sk':{a:'Slovakia Flag',b:'1F1F8-1F1F0',k:[4,10],o:2},standing_person:{skin_variations:{'1F3FB':{unified:'1F9CD-1F3FB',non_qualified:null,image:'1f9cd-1f3fb.png',sheet_x:44,sheet_y:32,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9CD-1F3FC',non_qualified:null,image:'1f9cd-1f3fc.png',sheet_x:44,sheet_y:33,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9CD-1F3FD',non_qualified:null,image:'1f9cd-1f3fd.png',sheet_x:44,sheet_y:34,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9CD-1F3FE',non_qualified:null,image:'1f9cd-1f3fe.png',sheet_x:44,sheet_y:35,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9CD-1F3FF',non_qualified:null,image:'1f9cd-1f3ff.png',sheet_x:44,sheet_y:36,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Standing Person',b:'1F9CD',k:[44,31],o:12},couch_and_lamp:{a:'Couch and Lamp',b:'1F6CB-FE0F',c:'1F6CB',j:['read','chill'],k:[36,28],o:2},man_standing:{skin_variations:{'1F3FB':{unified:'1F9CD-1F3FB-200D-2642-FE0F',non_qualified:'1F9CD-1F3FB-200D-2642',image:'1f9cd-1f3fb-200d-2642-fe0f.png',sheet_x:44,sheet_y:26,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9CD-1F3FC-200D-2642-FE0F',non_qualified:'1F9CD-1F3FC-200D-2642',image:'1f9cd-1f3fc-200d-2642-fe0f.png',sheet_x:44,sheet_y:27,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9CD-1F3FD-200D-2642-FE0F',non_qualified:'1F9CD-1F3FD-200D-2642',image:'1f9cd-1f3fd-200d-2642-fe0f.png',sheet_x:44,sheet_y:28,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9CD-1F3FE-200D-2642-FE0F',non_qualified:'1F9CD-1F3FE-200D-2642',image:'1f9cd-1f3fe-200d-2642-fe0f.png',sheet_x:44,sheet_y:29,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9CD-1F3FF-200D-2642-FE0F',non_qualified:'1F9CD-1F3FF-200D-2642',image:'1f9cd-1f3ff-200d-2642-fe0f.png',sheet_x:44,sheet_y:30,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man Standing',b:'1F9CD-200D-2642-FE0F',c:'1F9CD-200D-2642',k:[44,25],o:12},white_square_button:{a:'White Square Button',b:'1F533',j:['shape','input'],k:[28,22],o:2},'flag-sl':{a:'Sierra Leone Flag',b:'1F1F8-1F1F1',k:[4,11],o:2},chair:{a:'Chair',b:'1FA91',k:[52,5],o:12},toilet:{a:'Toilet',b:'1F6BD',j:['restroom','wc','washroom','bathroom','potty'],k:[36,14],o:2},black_square_button:{a:'Black Square Button',b:'1F532',j:['shape','input','frame'],k:[28,21],o:2},'flag-sm':{a:'San Marino Flag',b:'1F1F8-1F1F2',k:[4,12],o:2},woman_standing:{skin_variations:{'1F3FB':{unified:'1F9CD-1F3FB-200D-2640-FE0F',non_qualified:'1F9CD-1F3FB-200D-2640',image:'1f9cd-1f3fb-200d-2640-fe0f.png',sheet_x:44,sheet_y:20,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9CD-1F3FC-200D-2640-FE0F',non_qualified:'1F9CD-1F3FC-200D-2640',image:'1f9cd-1f3fc-200d-2640-fe0f.png',sheet_x:44,sheet_y:21,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9CD-1F3FD-200D-2640-FE0F',non_qualified:'1F9CD-1F3FD-200D-2640',image:'1f9cd-1f3fd-200d-2640-fe0f.png',sheet_x:44,sheet_y:22,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9CD-1F3FE-200D-2640-FE0F',non_qualified:'1F9CD-1F3FE-200D-2640',image:'1f9cd-1f3fe-200d-2640-fe0f.png',sheet_x:44,sheet_y:23,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9CD-1F3FF-200D-2640-FE0F',non_qualified:'1F9CD-1F3FF-200D-2640',image:'1f9cd-1f3ff-200d-2640-fe0f.png',sheet_x:44,sheet_y:24,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Woman Standing',b:'1F9CD-200D-2640-FE0F',c:'1F9CD-200D-2640',k:[44,19],o:12},kneeling_person:{skin_variations:{'1F3FB':{unified:'1F9CE-1F3FB',non_qualified:null,image:'1f9ce-1f3fb.png',sheet_x:44,sheet_y:50,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9CE-1F3FC',non_qualified:null,image:'1f9ce-1f3fc.png',sheet_x:44,sheet_y:51,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9CE-1F3FD',non_qualified:null,image:'1f9ce-1f3fd.png',sheet_x:44,sheet_y:52,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9CE-1F3FE',non_qualified:null,image:'1f9ce-1f3fe.png',sheet_x:44,sheet_y:53,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9CE-1F3FF',non_qualified:null,image:'1f9ce-1f3ff.png',sheet_x:44,sheet_y:54,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Kneeling Person',b:'1F9CE',k:[44,49],o:12},shower:{a:'Shower',b:'1F6BF',j:['clean','water','bathroom'],k:[36,16],o:2},'flag-sn':{a:'Senegal Flag',b:'1F1F8-1F1F3',k:[4,13],o:2},bathtub:{a:'Bathtub',b:'1F6C1',j:['clean','shower','bathroom'],k:[36,23],o:2},'flag-so':{a:'Somalia Flag',b:'1F1F8-1F1F4',k:[4,14],o:2},man_kneeling:{skin_variations:{'1F3FB':{unified:'1F9CE-1F3FB-200D-2642-FE0F',non_qualified:'1F9CE-1F3FB-200D-2642',image:'1f9ce-1f3fb-200d-2642-fe0f.png',sheet_x:44,sheet_y:44,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9CE-1F3FC-200D-2642-FE0F',non_qualified:'1F9CE-1F3FC-200D-2642',image:'1f9ce-1f3fc-200d-2642-fe0f.png',sheet_x:44,sheet_y:45,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9CE-1F3FD-200D-2642-FE0F',non_qualified:'1F9CE-1F3FD-200D-2642',image:'1f9ce-1f3fd-200d-2642-fe0f.png',sheet_x:44,sheet_y:46,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9CE-1F3FE-200D-2642-FE0F',non_qualified:'1F9CE-1F3FE-200D-2642',image:'1f9ce-1f3fe-200d-2642-fe0f.png',sheet_x:44,sheet_y:47,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9CE-1F3FF-200D-2642-FE0F',non_qualified:'1F9CE-1F3FF-200D-2642',image:'1f9ce-1f3ff-200d-2642-fe0f.png',sheet_x:44,sheet_y:48,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man Kneeling',b:'1F9CE-200D-2642-FE0F',c:'1F9CE-200D-2642',k:[44,43],o:12},'flag-sr':{a:'Suriname Flag',b:'1F1F8-1F1F7',k:[4,15],o:2},woman_kneeling:{skin_variations:{'1F3FB':{unified:'1F9CE-1F3FB-200D-2640-FE0F',non_qualified:'1F9CE-1F3FB-200D-2640',image:'1f9ce-1f3fb-200d-2640-fe0f.png',sheet_x:44,sheet_y:38,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9CE-1F3FC-200D-2640-FE0F',non_qualified:'1F9CE-1F3FC-200D-2640',image:'1f9ce-1f3fc-200d-2640-fe0f.png',sheet_x:44,sheet_y:39,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9CE-1F3FD-200D-2640-FE0F',non_qualified:'1F9CE-1F3FD-200D-2640',image:'1f9ce-1f3fd-200d-2640-fe0f.png',sheet_x:44,sheet_y:40,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9CE-1F3FE-200D-2640-FE0F',non_qualified:'1F9CE-1F3FE-200D-2640',image:'1f9ce-1f3fe-200d-2640-fe0f.png',sheet_x:44,sheet_y:41,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9CE-1F3FF-200D-2640-FE0F',non_qualified:'1F9CE-1F3FF-200D-2640',image:'1f9ce-1f3ff-200d-2640-fe0f.png',sheet_x:44,sheet_y:42,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Woman Kneeling',b:'1F9CE-200D-2640-FE0F',c:'1F9CE-200D-2640',k:[44,37],o:12},razor:{a:'Razor',b:'1FA92',k:[52,6],o:12},person_with_probing_cane:{skin_variations:{'1F3FB':{unified:'1F9D1-1F3FB-200D-1F9AF',non_qualified:null,image:'1f9d1-1f3fb-200d-1f9af.png',sheet_x:47,sheet_y:8,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FC':{unified:'1F9D1-1F3FC-200D-1F9AF',non_qualified:null,image:'1f9d1-1f3fc-200d-1f9af.png',sheet_x:47,sheet_y:9,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FD':{unified:'1F9D1-1F3FD-200D-1F9AF',non_qualified:null,image:'1f9d1-1f3fd-200d-1f9af.png',sheet_x:47,sheet_y:10,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FE':{unified:'1F9D1-1F3FE-200D-1F9AF',non_qualified:null,image:'1f9d1-1f3fe-200d-1f9af.png',sheet_x:47,sheet_y:11,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FF':{unified:'1F9D1-1F3FF-200D-1F9AF',non_qualified:null,image:'1f9d1-1f3ff-200d-1f9af.png',sheet_x:47,sheet_y:12,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false}},a:'Person with Probing Cane',b:'1F9D1-200D-1F9AF',k:[47,7],o:12},'flag-ss':{a:'South Sudan Flag',b:'1F1F8-1F1F8',k:[4,16],o:2},lotion_bottle:{a:'Lotion Bottle',b:'1F9F4',k:[51,39],o:11},'flag-st':{a:'São Tomé & Príncipe Flag',b:'1F1F8-1F1F9',k:[4,17],o:2},safety_pin:{a:'Safety Pin',b:'1F9F7',k:[51,42],o:11},man_with_probing_cane:{skin_variations:{'1F3FB':{unified:'1F468-1F3FB-200D-1F9AF',non_qualified:null,image:'1f468-1f3fb-200d-1f9af.png',sheet_x:16,sheet_y:18,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F468-1F3FC-200D-1F9AF',non_qualified:null,image:'1f468-1f3fc-200d-1f9af.png',sheet_x:16,sheet_y:19,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F468-1F3FD-200D-1F9AF',non_qualified:null,image:'1f468-1f3fd-200d-1f9af.png',sheet_x:16,sheet_y:20,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F468-1F3FE-200D-1F9AF',non_qualified:null,image:'1f468-1f3fe-200d-1f9af.png',sheet_x:16,sheet_y:21,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F468-1F3FF-200D-1F9AF',non_qualified:null,image:'1f468-1f3ff-200d-1f9af.png',sheet_x:16,sheet_y:22,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man with Probing Cane',b:'1F468-200D-1F9AF',k:[16,17],o:12},broom:{a:'Broom',b:'1F9F9',k:[51,44],o:11},woman_with_probing_cane:{skin_variations:{'1F3FB':{unified:'1F469-1F3FB-200D-1F9AF',non_qualified:null,image:'1f469-1f3fb-200d-1f9af.png',sheet_x:19,sheet_y:3,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F469-1F3FC-200D-1F9AF',non_qualified:null,image:'1f469-1f3fc-200d-1f9af.png',sheet_x:19,sheet_y:4,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F469-1F3FD-200D-1F9AF',non_qualified:null,image:'1f469-1f3fd-200d-1f9af.png',sheet_x:19,sheet_y:5,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F469-1F3FE-200D-1F9AF',non_qualified:null,image:'1f469-1f3fe-200d-1f9af.png',sheet_x:19,sheet_y:6,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F469-1F3FF-200D-1F9AF',non_qualified:null,image:'1f469-1f3ff-200d-1f9af.png',sheet_x:19,sheet_y:7,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Woman with Probing Cane',b:'1F469-200D-1F9AF',k:[19,2],o:12},'flag-sv':{a:'El Salvador Flag',b:'1F1F8-1F1FB',k:[4,18],o:2},'flag-sx':{a:'Sint Maarten Flag',b:'1F1F8-1F1FD',k:[4,19],o:2},basket:{a:'Basket',b:'1F9FA',k:[51,45],o:11},person_in_motorized_wheelchair:{skin_variations:{'1F3FB':{unified:'1F9D1-1F3FB-200D-1F9BC',non_qualified:null,image:'1f9d1-1f3fb-200d-1f9bc.png',sheet_x:47,sheet_y:38,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FC':{unified:'1F9D1-1F3FC-200D-1F9BC',non_qualified:null,image:'1f9d1-1f3fc-200d-1f9bc.png',sheet_x:47,sheet_y:39,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FD':{unified:'1F9D1-1F3FD-200D-1F9BC',non_qualified:null,image:'1f9d1-1f3fd-200d-1f9bc.png',sheet_x:47,sheet_y:40,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FE':{unified:'1F9D1-1F3FE-200D-1F9BC',non_qualified:null,image:'1f9d1-1f3fe-200d-1f9bc.png',sheet_x:47,sheet_y:41,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FF':{unified:'1F9D1-1F3FF-200D-1F9BC',non_qualified:null,image:'1f9d1-1f3ff-200d-1f9bc.png',sheet_x:47,sheet_y:42,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false}},a:'Person in Motorized Wheelchair',b:'1F9D1-200D-1F9BC',k:[47,37],o:12},man_in_motorized_wheelchair:{skin_variations:{'1F3FB':{unified:'1F468-1F3FB-200D-1F9BC',non_qualified:null,image:'1f468-1f3fb-200d-1f9bc.png',sheet_x:16,sheet_y:48,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F468-1F3FC-200D-1F9BC',non_qualified:null,image:'1f468-1f3fc-200d-1f9bc.png',sheet_x:16,sheet_y:49,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F468-1F3FD-200D-1F9BC',non_qualified:null,image:'1f468-1f3fd-200d-1f9bc.png',sheet_x:16,sheet_y:50,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F468-1F3FE-200D-1F9BC',non_qualified:null,image:'1f468-1f3fe-200d-1f9bc.png',sheet_x:16,sheet_y:51,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F468-1F3FF-200D-1F9BC',non_qualified:null,image:'1f468-1f3ff-200d-1f9bc.png',sheet_x:16,sheet_y:52,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man in Motorized Wheelchair',b:'1F468-200D-1F9BC',k:[16,47],o:12},'flag-sy':{a:'Syria Flag',b:'1F1F8-1F1FE',k:[4,20],o:2},roll_of_paper:{a:'Roll of Paper',b:'1F9FB',k:[51,46],o:11},woman_in_motorized_wheelchair:{skin_variations:{'1F3FB':{unified:'1F469-1F3FB-200D-1F9BC',non_qualified:null,image:'1f469-1f3fb-200d-1f9bc.png',sheet_x:19,sheet_y:33,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F469-1F3FC-200D-1F9BC',non_qualified:null,image:'1f469-1f3fc-200d-1f9bc.png',sheet_x:19,sheet_y:34,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F469-1F3FD-200D-1F9BC',non_qualified:null,image:'1f469-1f3fd-200d-1f9bc.png',sheet_x:19,sheet_y:35,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F469-1F3FE-200D-1F9BC',non_qualified:null,image:'1f469-1f3fe-200d-1f9bc.png',sheet_x:19,sheet_y:36,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F469-1F3FF-200D-1F9BC',non_qualified:null,image:'1f469-1f3ff-200d-1f9bc.png',sheet_x:19,sheet_y:37,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Woman in Motorized Wheelchair',b:'1F469-200D-1F9BC',k:[19,32],o:12},'flag-sz':{a:'Eswatini Flag',b:'1F1F8-1F1FF',k:[4,21],o:2},soap:{a:'Bar of Soap',b:'1F9FC',k:[51,47],o:11},'flag-ta':{a:'Tristan Da Cunha Flag',b:'1F1F9-1F1E6',k:[4,22],o:2},sponge:{a:'Sponge',b:'1F9FD',k:[51,48],o:11},person_in_manual_wheelchair:{skin_variations:{'1F3FB':{unified:'1F9D1-1F3FB-200D-1F9BD',non_qualified:null,image:'1f9d1-1f3fb-200d-1f9bd.png',sheet_x:47,sheet_y:44,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FC':{unified:'1F9D1-1F3FC-200D-1F9BD',non_qualified:null,image:'1f9d1-1f3fc-200d-1f9bd.png',sheet_x:47,sheet_y:45,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FD':{unified:'1F9D1-1F3FD-200D-1F9BD',non_qualified:null,image:'1f9d1-1f3fd-200d-1f9bd.png',sheet_x:47,sheet_y:46,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FE':{unified:'1F9D1-1F3FE-200D-1F9BD',non_qualified:null,image:'1f9d1-1f3fe-200d-1f9bd.png',sheet_x:47,sheet_y:47,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false},'1F3FF':{unified:'1F9D1-1F3FF-200D-1F9BD',non_qualified:null,image:'1f9d1-1f3ff-200d-1f9bd.png',sheet_x:47,sheet_y:48,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:false,has_img_facebook:false}},a:'Person in Manual Wheelchair',b:'1F9D1-200D-1F9BD',k:[47,43],o:12},fire_extinguisher:{a:'Fire Extinguisher',b:'1F9EF',k:[51,34],o:11},man_in_manual_wheelchair:{skin_variations:{'1F3FB':{unified:'1F468-1F3FB-200D-1F9BD',non_qualified:null,image:'1f468-1f3fb-200d-1f9bd.png',sheet_x:16,sheet_y:54,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F468-1F3FC-200D-1F9BD',non_qualified:null,image:'1f468-1f3fc-200d-1f9bd.png',sheet_x:16,sheet_y:55,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F468-1F3FD-200D-1F9BD',non_qualified:null,image:'1f468-1f3fd-200d-1f9bd.png',sheet_x:16,sheet_y:56,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F468-1F3FE-200D-1F9BD',non_qualified:null,image:'1f468-1f3fe-200d-1f9bd.png',sheet_x:17,sheet_y:0,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F468-1F3FF-200D-1F9BD',non_qualified:null,image:'1f468-1f3ff-200d-1f9bd.png',sheet_x:17,sheet_y:1,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man in Manual Wheelchair',b:'1F468-200D-1F9BD',k:[16,53],o:12},'flag-tc':{a:'Turks & Caicos Islands Flag',b:'1F1F9-1F1E8',k:[4,23],o:2},woman_in_manual_wheelchair:{skin_variations:{'1F3FB':{unified:'1F469-1F3FB-200D-1F9BD',non_qualified:null,image:'1f469-1f3fb-200d-1f9bd.png',sheet_x:19,sheet_y:39,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F469-1F3FC-200D-1F9BD',non_qualified:null,image:'1f469-1f3fc-200d-1f9bd.png',sheet_x:19,sheet_y:40,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F469-1F3FD-200D-1F9BD',non_qualified:null,image:'1f469-1f3fd-200d-1f9bd.png',sheet_x:19,sheet_y:41,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F469-1F3FE-200D-1F9BD',non_qualified:null,image:'1f469-1f3fe-200d-1f9bd.png',sheet_x:19,sheet_y:42,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F469-1F3FF-200D-1F9BD',non_qualified:null,image:'1f469-1f3ff-200d-1f9bd.png',sheet_x:19,sheet_y:43,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Woman in Manual Wheelchair',b:'1F469-200D-1F9BD',k:[19,38],o:12},'flag-td':{a:'Chad Flag',b:'1F1F9-1F1E9',k:[4,24],o:2},shopping_trolley:{a:'Shopping Trolley',b:'1F6D2',k:[36,40],o:4},runner:{skin_variations:{'1F3FB':{unified:'1F3C3-1F3FB',non_qualified:null,image:'1f3c3-1f3fb.png',sheet_x:9,sheet_y:2,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F3C3-1F3FC',non_qualified:null,image:'1f3c3-1f3fc.png',sheet_x:9,sheet_y:3,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F3C3-1F3FD',non_qualified:null,image:'1f3c3-1f3fd.png',sheet_x:9,sheet_y:4,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F3C3-1F3FE',non_qualified:null,image:'1f3c3-1f3fe.png',sheet_x:9,sheet_y:5,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F3C3-1F3FF',non_qualified:null,image:'1f3c3-1f3ff.png',sheet_x:9,sheet_y:6,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},obsoleted_by:'1F3C3-200D-2642-FE0F',a:'Runner',b:'1F3C3',k:[9,1],n:['running'],o:2},'flag-tf':{a:'French Southern Territories Flag',b:'1F1F9-1F1EB',k:[4,25],o:2},smoking:{a:'Smoking Symbol',b:'1F6AC',j:['kills','tobacco','cigarette','joint','smoke'],k:[35,3],o:2},coffin:{a:'Coffin',b:'26B0-FE0F',c:'26B0',j:['vampire','dead','die','death','rip','graveyard','cemetery','casket','funeral','box'],k:[53,54],o:2},'man-running':{skin_variations:{'1F3FB':{unified:'1F3C3-1F3FB-200D-2642-FE0F',non_qualified:'1F3C3-1F3FB-200D-2642',image:'1f3c3-1f3fb-200d-2642-fe0f.png',sheet_x:8,sheet_y:53,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F3C3-1F3FC-200D-2642-FE0F',non_qualified:'1F3C3-1F3FC-200D-2642',image:'1f3c3-1f3fc-200d-2642-fe0f.png',sheet_x:8,sheet_y:54,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F3C3-1F3FD-200D-2642-FE0F',non_qualified:'1F3C3-1F3FD-200D-2642',image:'1f3c3-1f3fd-200d-2642-fe0f.png',sheet_x:8,sheet_y:55,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F3C3-1F3FE-200D-2642-FE0F',non_qualified:'1F3C3-1F3FE-200D-2642',image:'1f3c3-1f3fe-200d-2642-fe0f.png',sheet_x:8,sheet_y:56,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F3C3-1F3FF-200D-2642-FE0F',non_qualified:'1F3C3-1F3FF-200D-2642',image:'1f3c3-1f3ff-200d-2642-fe0f.png',sheet_x:9,sheet_y:0,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},obsoletes:'1F3C3',a:'Man Running',b:'1F3C3-200D-2642-FE0F',c:'1F3C3-200D-2642',k:[8,52],o:4},'flag-tg':{a:'Togo Flag',b:'1F1F9-1F1EC',k:[4,26],o:2},'woman-running':{skin_variations:{'1F3FB':{unified:'1F3C3-1F3FB-200D-2640-FE0F',non_qualified:'1F3C3-1F3FB-200D-2640',image:'1f3c3-1f3fb-200d-2640-fe0f.png',sheet_x:8,sheet_y:47,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F3C3-1F3FC-200D-2640-FE0F',non_qualified:'1F3C3-1F3FC-200D-2640',image:'1f3c3-1f3fc-200d-2640-fe0f.png',sheet_x:8,sheet_y:48,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F3C3-1F3FD-200D-2640-FE0F',non_qualified:'1F3C3-1F3FD-200D-2640',image:'1f3c3-1f3fd-200d-2640-fe0f.png',sheet_x:8,sheet_y:49,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F3C3-1F3FE-200D-2640-FE0F',non_qualified:'1F3C3-1F3FE-200D-2640',image:'1f3c3-1f3fe-200d-2640-fe0f.png',sheet_x:8,sheet_y:50,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F3C3-1F3FF-200D-2640-FE0F',non_qualified:'1F3C3-1F3FF-200D-2640',image:'1f3c3-1f3ff-200d-2640-fe0f.png',sheet_x:8,sheet_y:51,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Woman Running',b:'1F3C3-200D-2640-FE0F',c:'1F3C3-200D-2640',k:[8,46],o:4},funeral_urn:{a:'Funeral Urn',b:'26B1-FE0F',c:'26B1',j:['dead','die','death','rip','ashes'],k:[53,55],o:2},'flag-th':{a:'Thailand Flag',b:'1F1F9-1F1ED',k:[4,27],o:2},moyai:{a:'Moyai',b:'1F5FF',j:['rock','easter island','moai'],k:[30,34],o:2},'flag-tj':{a:'Tajikistan Flag',b:'1F1F9-1F1EF',k:[4,28],o:2},dancer:{skin_variations:{'1F3FB':{unified:'1F483-1F3FB',non_qualified:null,image:'1f483-1f3fb.png',sheet_x:24,sheet_y:27,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F483-1F3FC',non_qualified:null,image:'1f483-1f3fc.png',sheet_x:24,sheet_y:28,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F483-1F3FD',non_qualified:null,image:'1f483-1f3fd.png',sheet_x:24,sheet_y:29,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F483-1F3FE',non_qualified:null,image:'1f483-1f3fe.png',sheet_x:24,sheet_y:30,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F483-1F3FF',non_qualified:null,image:'1f483-1f3ff.png',sheet_x:24,sheet_y:31,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Dancer',b:'1F483',j:['female','girl','woman','fun'],k:[24,26],o:2},'flag-tk':{a:'Tokelau Flag',b:'1F1F9-1F1F0',k:[4,29],o:2},man_dancing:{skin_variations:{'1F3FB':{unified:'1F57A-1F3FB',non_qualified:null,image:'1f57a-1f3fb.png',sheet_x:29,sheet_y:38,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F57A-1F3FC',non_qualified:null,image:'1f57a-1f3fc.png',sheet_x:29,sheet_y:39,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F57A-1F3FD',non_qualified:null,image:'1f57a-1f3fd.png',sheet_x:29,sheet_y:40,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F57A-1F3FE',non_qualified:null,image:'1f57a-1f3fe.png',sheet_x:29,sheet_y:41,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F57A-1F3FF',non_qualified:null,image:'1f57a-1f3ff.png',sheet_x:29,sheet_y:42,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man Dancing',b:'1F57A',j:['male','boy','fun','dancer'],k:[29,37],o:4},'flag-tl':{a:'Timor-Leste Flag',b:'1F1F9-1F1F1',k:[4,30],o:2},man_in_business_suit_levitating:{skin_variations:{'1F3FB':{unified:'1F574-1F3FB',non_qualified:null,image:'1f574-1f3fb.png',sheet_x:29,sheet_y:10,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F574-1F3FC',non_qualified:null,image:'1f574-1f3fc.png',sheet_x:29,sheet_y:11,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F574-1F3FD',non_qualified:null,image:'1f574-1f3fd.png',sheet_x:29,sheet_y:12,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F574-1F3FE',non_qualified:null,image:'1f574-1f3fe.png',sheet_x:29,sheet_y:13,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F574-1F3FF',non_qualified:null,image:'1f574-1f3ff.png',sheet_x:29,sheet_y:14,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man in Business Suit Levitating',b:'1F574-FE0F',c:'1F574',k:[29,9],o:2},'flag-tm':{a:'Turkmenistan Flag',b:'1F1F9-1F1F2',k:[4,31],o:2},dancers:{obsoleted_by:'1F46F-200D-2640-FE0F',a:'Woman with Bunny Ears',b:'1F46F',k:[22,0],o:2},'man-with-bunny-ears-partying':{a:'Man with Bunny Ears Partying',b:'1F46F-200D-2642-FE0F',c:'1F46F-200D-2642',k:[21,56],o:4},'flag-tn':{a:'Tunisia Flag',b:'1F1F9-1F1F3',k:[4,32],o:2},'flag-to':{a:'Tonga Flag',b:'1F1F9-1F1F4',k:[4,33],o:2},'woman-with-bunny-ears-partying':{obsoletes:'1F46F',a:'Woman with Bunny Ears Partying',b:'1F46F-200D-2640-FE0F',c:'1F46F-200D-2640',k:[21,55],o:4},'flag-tr':{a:'Turkey Flag',b:'1F1F9-1F1F7',k:[4,34],o:2},person_in_steamy_room:{skin_variations:{'1F3FB':{unified:'1F9D6-1F3FB',non_qualified:null,image:'1f9d6-1f3fb.png',sheet_x:48,sheet_y:53,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9D6-1F3FB-200D-2642-FE0F'},'1F3FC':{unified:'1F9D6-1F3FC',non_qualified:null,image:'1f9d6-1f3fc.png',sheet_x:48,sheet_y:54,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9D6-1F3FC-200D-2642-FE0F'},'1F3FD':{unified:'1F9D6-1F3FD',non_qualified:null,image:'1f9d6-1f3fd.png',sheet_x:48,sheet_y:55,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9D6-1F3FD-200D-2642-FE0F'},'1F3FE':{unified:'1F9D6-1F3FE',non_qualified:null,image:'1f9d6-1f3fe.png',sheet_x:48,sheet_y:56,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9D6-1F3FE-200D-2642-FE0F'},'1F3FF':{unified:'1F9D6-1F3FF',non_qualified:null,image:'1f9d6-1f3ff.png',sheet_x:49,sheet_y:0,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9D6-1F3FF-200D-2642-FE0F'}},obsoleted_by:'1F9D6-200D-2642-FE0F',a:'Person in Steamy Room',b:'1F9D6',k:[48,52],o:5},man_in_steamy_room:{skin_variations:{'1F3FB':{unified:'1F9D6-1F3FB-200D-2642-FE0F',non_qualified:'1F9D6-1F3FB-200D-2642',image:'1f9d6-1f3fb-200d-2642-fe0f.png',sheet_x:48,sheet_y:47,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9D6-1F3FB'},'1F3FC':{unified:'1F9D6-1F3FC-200D-2642-FE0F',non_qualified:'1F9D6-1F3FC-200D-2642',image:'1f9d6-1f3fc-200d-2642-fe0f.png',sheet_x:48,sheet_y:48,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9D6-1F3FC'},'1F3FD':{unified:'1F9D6-1F3FD-200D-2642-FE0F',non_qualified:'1F9D6-1F3FD-200D-2642',image:'1f9d6-1f3fd-200d-2642-fe0f.png',sheet_x:48,sheet_y:49,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9D6-1F3FD'},'1F3FE':{unified:'1F9D6-1F3FE-200D-2642-FE0F',non_qualified:'1F9D6-1F3FE-200D-2642',image:'1f9d6-1f3fe-200d-2642-fe0f.png',sheet_x:48,sheet_y:50,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9D6-1F3FE'},'1F3FF':{unified:'1F9D6-1F3FF-200D-2642-FE0F',non_qualified:'1F9D6-1F3FF-200D-2642',image:'1f9d6-1f3ff-200d-2642-fe0f.png',sheet_x:48,sheet_y:51,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9D6-1F3FF'}},obsoletes:'1F9D6',a:'Man in Steamy Room',b:'1F9D6-200D-2642-FE0F',c:'1F9D6-200D-2642',j:['male','man','spa','steamroom','sauna'],k:[48,46],o:5},'flag-tt':{a:'Trinidad & Tobago Flag',b:'1F1F9-1F1F9',k:[4,35],o:2},woman_in_steamy_room:{skin_variations:{'1F3FB':{unified:'1F9D6-1F3FB-200D-2640-FE0F',non_qualified:'1F9D6-1F3FB-200D-2640',image:'1f9d6-1f3fb-200d-2640-fe0f.png',sheet_x:48,sheet_y:41,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9D6-1F3FC-200D-2640-FE0F',non_qualified:'1F9D6-1F3FC-200D-2640',image:'1f9d6-1f3fc-200d-2640-fe0f.png',sheet_x:48,sheet_y:42,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9D6-1F3FD-200D-2640-FE0F',non_qualified:'1F9D6-1F3FD-200D-2640',image:'1f9d6-1f3fd-200d-2640-fe0f.png',sheet_x:48,sheet_y:43,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9D6-1F3FE-200D-2640-FE0F',non_qualified:'1F9D6-1F3FE-200D-2640',image:'1f9d6-1f3fe-200d-2640-fe0f.png',sheet_x:48,sheet_y:44,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9D6-1F3FF-200D-2640-FE0F',non_qualified:'1F9D6-1F3FF-200D-2640',image:'1f9d6-1f3ff-200d-2640-fe0f.png',sheet_x:48,sheet_y:45,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Woman in Steamy Room',b:'1F9D6-200D-2640-FE0F',c:'1F9D6-200D-2640',j:['female','woman','spa','steamroom','sauna'],k:[48,40],o:5},'flag-tv':{a:'Tuvalu Flag',b:'1F1F9-1F1FB',k:[4,36],o:2},'flag-tw':{a:'Taiwan Flag',b:'1F1F9-1F1FC',k:[4,37],o:2},person_climbing:{skin_variations:{'1F3FB':{unified:'1F9D7-1F3FB',non_qualified:null,image:'1f9d7-1f3fb.png',sheet_x:49,sheet_y:14,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9D7-1F3FB-200D-2640-FE0F'},'1F3FC':{unified:'1F9D7-1F3FC',non_qualified:null,image:'1f9d7-1f3fc.png',sheet_x:49,sheet_y:15,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9D7-1F3FC-200D-2640-FE0F'},'1F3FD':{unified:'1F9D7-1F3FD',non_qualified:null,image:'1f9d7-1f3fd.png',sheet_x:49,sheet_y:16,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9D7-1F3FD-200D-2640-FE0F'},'1F3FE':{unified:'1F9D7-1F3FE',non_qualified:null,image:'1f9d7-1f3fe.png',sheet_x:49,sheet_y:17,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9D7-1F3FE-200D-2640-FE0F'},'1F3FF':{unified:'1F9D7-1F3FF',non_qualified:null,image:'1f9d7-1f3ff.png',sheet_x:49,sheet_y:18,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9D7-1F3FF-200D-2640-FE0F'}},obsoleted_by:'1F9D7-200D-2640-FE0F',a:'Person Climbing',b:'1F9D7',k:[49,13],o:5},man_climbing:{skin_variations:{'1F3FB':{unified:'1F9D7-1F3FB-200D-2642-FE0F',non_qualified:'1F9D7-1F3FB-200D-2642',image:'1f9d7-1f3fb-200d-2642-fe0f.png',sheet_x:49,sheet_y:8,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9D7-1F3FC-200D-2642-FE0F',non_qualified:'1F9D7-1F3FC-200D-2642',image:'1f9d7-1f3fc-200d-2642-fe0f.png',sheet_x:49,sheet_y:9,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9D7-1F3FD-200D-2642-FE0F',non_qualified:'1F9D7-1F3FD-200D-2642',image:'1f9d7-1f3fd-200d-2642-fe0f.png',sheet_x:49,sheet_y:10,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9D7-1F3FE-200D-2642-FE0F',non_qualified:'1F9D7-1F3FE-200D-2642',image:'1f9d7-1f3fe-200d-2642-fe0f.png',sheet_x:49,sheet_y:11,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9D7-1F3FF-200D-2642-FE0F',non_qualified:'1F9D7-1F3FF-200D-2642',image:'1f9d7-1f3ff-200d-2642-fe0f.png',sheet_x:49,sheet_y:12,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man Climbing',b:'1F9D7-200D-2642-FE0F',c:'1F9D7-200D-2642',k:[49,7],o:5},'flag-tz':{a:'Tanzania Flag',b:'1F1F9-1F1FF',k:[4,38],o:2},'flag-ua':{a:'Ukraine Flag',b:'1F1FA-1F1E6',k:[4,39],o:2},woman_climbing:{skin_variations:{'1F3FB':{unified:'1F9D7-1F3FB-200D-2640-FE0F',non_qualified:'1F9D7-1F3FB-200D-2640',image:'1f9d7-1f3fb-200d-2640-fe0f.png',sheet_x:49,sheet_y:2,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9D7-1F3FB'},'1F3FC':{unified:'1F9D7-1F3FC-200D-2640-FE0F',non_qualified:'1F9D7-1F3FC-200D-2640',image:'1f9d7-1f3fc-200d-2640-fe0f.png',sheet_x:49,sheet_y:3,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9D7-1F3FC'},'1F3FD':{unified:'1F9D7-1F3FD-200D-2640-FE0F',non_qualified:'1F9D7-1F3FD-200D-2640',image:'1f9d7-1f3fd-200d-2640-fe0f.png',sheet_x:49,sheet_y:4,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9D7-1F3FD'},'1F3FE':{unified:'1F9D7-1F3FE-200D-2640-FE0F',non_qualified:'1F9D7-1F3FE-200D-2640',image:'1f9d7-1f3fe-200d-2640-fe0f.png',sheet_x:49,sheet_y:5,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9D7-1F3FE'},'1F3FF':{unified:'1F9D7-1F3FF-200D-2640-FE0F',non_qualified:'1F9D7-1F3FF-200D-2640',image:'1f9d7-1f3ff-200d-2640-fe0f.png',sheet_x:49,sheet_y:6,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9D7-1F3FF'}},obsoletes:'1F9D7',a:'Woman Climbing',b:'1F9D7-200D-2640-FE0F',c:'1F9D7-200D-2640',k:[49,1],o:5},'flag-ug':{a:'Uganda Flag',b:'1F1FA-1F1EC',k:[4,40],o:2},fencer:{a:'Fencer',b:'1F93A',k:[40,32],o:4},'flag-um':{a:'U.s. Outlying Islands Flag',b:'1F1FA-1F1F2',k:[4,41],o:2},horse_racing:{skin_variations:{'1F3FB':{unified:'1F3C7-1F3FB',non_qualified:null,image:'1f3c7-1f3fb.png',sheet_x:9,sheet_y:28,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F3C7-1F3FC',non_qualified:null,image:'1f3c7-1f3fc.png',sheet_x:9,sheet_y:29,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F3C7-1F3FD',non_qualified:null,image:'1f3c7-1f3fd.png',sheet_x:9,sheet_y:30,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F3C7-1F3FE',non_qualified:null,image:'1f3c7-1f3fe.png',sheet_x:9,sheet_y:31,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F3C7-1F3FF',non_qualified:null,image:'1f3c7-1f3ff.png',sheet_x:9,sheet_y:32,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Horse Racing',b:'1F3C7',j:['animal','betting','competition','gambling','luck'],k:[9,27],o:2},skier:{a:'Skier',b:'26F7-FE0F',c:'26F7',j:['sports','winter','snow'],k:[54,17],o:2},'flag-un':{a:'United Nations Flag',b:'1F1FA-1F1F3',k:[4,42],o:4},us:{a:'United States Flag',b:'1F1FA-1F1F8',j:['united','states','america','flag','nation','country','banner'],k:[4,43],n:['flag-us'],o:2},snowboarder:{skin_variations:{'1F3FB':{unified:'1F3C2-1F3FB',non_qualified:null,image:'1f3c2-1f3fb.png',sheet_x:8,sheet_y:41,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F3C2-1F3FC',non_qualified:null,image:'1f3c2-1f3fc.png',sheet_x:8,sheet_y:42,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F3C2-1F3FD',non_qualified:null,image:'1f3c2-1f3fd.png',sheet_x:8,sheet_y:43,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F3C2-1F3FE',non_qualified:null,image:'1f3c2-1f3fe.png',sheet_x:8,sheet_y:44,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F3C2-1F3FF',non_qualified:null,image:'1f3c2-1f3ff.png',sheet_x:8,sheet_y:45,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Snowboarder',b:'1F3C2',j:['sports','winter'],k:[8,40],o:2},golfer:{skin_variations:{'1F3FB':{unified:'1F3CC-1F3FB',non_qualified:null,image:'1f3cc-1f3fb.png',sheet_x:10,sheet_y:27,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F3CC-1F3FC',non_qualified:null,image:'1f3cc-1f3fc.png',sheet_x:10,sheet_y:28,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F3CC-1F3FD',non_qualified:null,image:'1f3cc-1f3fd.png',sheet_x:10,sheet_y:29,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F3CC-1F3FE',non_qualified:null,image:'1f3cc-1f3fe.png',sheet_x:10,sheet_y:30,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F3CC-1F3FF',non_qualified:null,image:'1f3cc-1f3ff.png',sheet_x:10,sheet_y:31,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},obsoleted_by:'1F3CC-FE0F-200D-2642-FE0F',a:'Golfer',b:'1F3CC-FE0F',c:'1F3CC',k:[10,26],o:2},'flag-uy':{a:'Uruguay Flag',b:'1F1FA-1F1FE',k:[4,44],o:2},'flag-uz':{a:'Uzbekistan Flag',b:'1F1FA-1F1FF',k:[4,45],o:2},'man-golfing':{skin_variations:{'1F3FB':{unified:'1F3CC-1F3FB-200D-2642-FE0F',non_qualified:'1F3CC-1F3FB-200D-2642',image:'1f3cc-1f3fb-200d-2642-fe0f.png',sheet_x:10,sheet_y:21,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F3CC-1F3FC-200D-2642-FE0F',non_qualified:'1F3CC-1F3FC-200D-2642',image:'1f3cc-1f3fc-200d-2642-fe0f.png',sheet_x:10,sheet_y:22,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F3CC-1F3FD-200D-2642-FE0F',non_qualified:'1F3CC-1F3FD-200D-2642',image:'1f3cc-1f3fd-200d-2642-fe0f.png',sheet_x:10,sheet_y:23,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F3CC-1F3FE-200D-2642-FE0F',non_qualified:'1F3CC-1F3FE-200D-2642',image:'1f3cc-1f3fe-200d-2642-fe0f.png',sheet_x:10,sheet_y:24,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F3CC-1F3FF-200D-2642-FE0F',non_qualified:'1F3CC-1F3FF-200D-2642',image:'1f3cc-1f3ff-200d-2642-fe0f.png',sheet_x:10,sheet_y:25,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},obsoletes:'1F3CC-FE0F',a:'Man Golfing',b:'1F3CC-FE0F-200D-2642-FE0F',k:[10,20],o:4},'flag-va':{a:'Vatican City Flag',b:'1F1FB-1F1E6',k:[4,46],o:2},'woman-golfing':{skin_variations:{'1F3FB':{unified:'1F3CC-1F3FB-200D-2640-FE0F',non_qualified:'1F3CC-1F3FB-200D-2640',image:'1f3cc-1f3fb-200d-2640-fe0f.png',sheet_x:10,sheet_y:15,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F3CC-1F3FC-200D-2640-FE0F',non_qualified:'1F3CC-1F3FC-200D-2640',image:'1f3cc-1f3fc-200d-2640-fe0f.png',sheet_x:10,sheet_y:16,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F3CC-1F3FD-200D-2640-FE0F',non_qualified:'1F3CC-1F3FD-200D-2640',image:'1f3cc-1f3fd-200d-2640-fe0f.png',sheet_x:10,sheet_y:17,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F3CC-1F3FE-200D-2640-FE0F',non_qualified:'1F3CC-1F3FE-200D-2640',image:'1f3cc-1f3fe-200d-2640-fe0f.png',sheet_x:10,sheet_y:18,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F3CC-1F3FF-200D-2640-FE0F',non_qualified:'1F3CC-1F3FF-200D-2640',image:'1f3cc-1f3ff-200d-2640-fe0f.png',sheet_x:10,sheet_y:19,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Woman Golfing',b:'1F3CC-FE0F-200D-2640-FE0F',k:[10,14],o:4},'flag-vc':{a:'St. Vincent & Grenadines Flag',b:'1F1FB-1F1E8',k:[4,47],o:2},surfer:{skin_variations:{'1F3FB':{unified:'1F3C4-1F3FB',non_qualified:null,image:'1f3c4-1f3fb.png',sheet_x:9,sheet_y:20,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F3C4-1F3FC',non_qualified:null,image:'1f3c4-1f3fc.png',sheet_x:9,sheet_y:21,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F3C4-1F3FD',non_qualified:null,image:'1f3c4-1f3fd.png',sheet_x:9,sheet_y:22,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F3C4-1F3FE',non_qualified:null,image:'1f3c4-1f3fe.png',sheet_x:9,sheet_y:23,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F3C4-1F3FF',non_qualified:null,image:'1f3c4-1f3ff.png',sheet_x:9,sheet_y:24,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},obsoleted_by:'1F3C4-200D-2642-FE0F',a:'Surfer',b:'1F3C4',k:[9,19],o:2},'man-surfing':{skin_variations:{'1F3FB':{unified:'1F3C4-1F3FB-200D-2642-FE0F',non_qualified:'1F3C4-1F3FB-200D-2642',image:'1f3c4-1f3fb-200d-2642-fe0f.png',sheet_x:9,sheet_y:14,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F3C4-1F3FC-200D-2642-FE0F',non_qualified:'1F3C4-1F3FC-200D-2642',image:'1f3c4-1f3fc-200d-2642-fe0f.png',sheet_x:9,sheet_y:15,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F3C4-1F3FD-200D-2642-FE0F',non_qualified:'1F3C4-1F3FD-200D-2642',image:'1f3c4-1f3fd-200d-2642-fe0f.png',sheet_x:9,sheet_y:16,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F3C4-1F3FE-200D-2642-FE0F',non_qualified:'1F3C4-1F3FE-200D-2642',image:'1f3c4-1f3fe-200d-2642-fe0f.png',sheet_x:9,sheet_y:17,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F3C4-1F3FF-200D-2642-FE0F',non_qualified:'1F3C4-1F3FF-200D-2642',image:'1f3c4-1f3ff-200d-2642-fe0f.png',sheet_x:9,sheet_y:18,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},obsoletes:'1F3C4',a:'Man Surfing',b:'1F3C4-200D-2642-FE0F',c:'1F3C4-200D-2642',k:[9,13],o:4},'flag-ve':{a:'Venezuela Flag',b:'1F1FB-1F1EA',k:[4,48],o:2},'flag-vg':{a:'British Virgin Islands Flag',b:'1F1FB-1F1EC',k:[4,49],o:2},'woman-surfing':{skin_variations:{'1F3FB':{unified:'1F3C4-1F3FB-200D-2640-FE0F',non_qualified:'1F3C4-1F3FB-200D-2640',image:'1f3c4-1f3fb-200d-2640-fe0f.png',sheet_x:9,sheet_y:8,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F3C4-1F3FC-200D-2640-FE0F',non_qualified:'1F3C4-1F3FC-200D-2640',image:'1f3c4-1f3fc-200d-2640-fe0f.png',sheet_x:9,sheet_y:9,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F3C4-1F3FD-200D-2640-FE0F',non_qualified:'1F3C4-1F3FD-200D-2640',image:'1f3c4-1f3fd-200d-2640-fe0f.png',sheet_x:9,sheet_y:10,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F3C4-1F3FE-200D-2640-FE0F',non_qualified:'1F3C4-1F3FE-200D-2640',image:'1f3c4-1f3fe-200d-2640-fe0f.png',sheet_x:9,sheet_y:11,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F3C4-1F3FF-200D-2640-FE0F',non_qualified:'1F3C4-1F3FF-200D-2640',image:'1f3c4-1f3ff-200d-2640-fe0f.png',sheet_x:9,sheet_y:12,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Woman Surfing',b:'1F3C4-200D-2640-FE0F',c:'1F3C4-200D-2640',k:[9,7],o:4},rowboat:{skin_variations:{'1F3FB':{unified:'1F6A3-1F3FB',non_qualified:null,image:'1f6a3-1f3fb.png',sheet_x:34,sheet_y:47,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F6A3-1F3FC',non_qualified:null,image:'1f6a3-1f3fc.png',sheet_x:34,sheet_y:48,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F6A3-1F3FD',non_qualified:null,image:'1f6a3-1f3fd.png',sheet_x:34,sheet_y:49,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F6A3-1F3FE',non_qualified:null,image:'1f6a3-1f3fe.png',sheet_x:34,sheet_y:50,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F6A3-1F3FF',non_qualified:null,image:'1f6a3-1f3ff.png',sheet_x:34,sheet_y:51,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},obsoleted_by:'1F6A3-200D-2642-FE0F',a:'Rowboat',b:'1F6A3',k:[34,46],o:2},'flag-vi':{a:'U.s. Virgin Islands Flag',b:'1F1FB-1F1EE',k:[4,50],o:2},'man-rowing-boat':{skin_variations:{'1F3FB':{unified:'1F6A3-1F3FB-200D-2642-FE0F',non_qualified:'1F6A3-1F3FB-200D-2642',image:'1f6a3-1f3fb-200d-2642-fe0f.png',sheet_x:34,sheet_y:41,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F6A3-1F3FC-200D-2642-FE0F',non_qualified:'1F6A3-1F3FC-200D-2642',image:'1f6a3-1f3fc-200d-2642-fe0f.png',sheet_x:34,sheet_y:42,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F6A3-1F3FD-200D-2642-FE0F',non_qualified:'1F6A3-1F3FD-200D-2642',image:'1f6a3-1f3fd-200d-2642-fe0f.png',sheet_x:34,sheet_y:43,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F6A3-1F3FE-200D-2642-FE0F',non_qualified:'1F6A3-1F3FE-200D-2642',image:'1f6a3-1f3fe-200d-2642-fe0f.png',sheet_x:34,sheet_y:44,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F6A3-1F3FF-200D-2642-FE0F',non_qualified:'1F6A3-1F3FF-200D-2642',image:'1f6a3-1f3ff-200d-2642-fe0f.png',sheet_x:34,sheet_y:45,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},obsoletes:'1F6A3',a:'Man Rowing Boat',b:'1F6A3-200D-2642-FE0F',c:'1F6A3-200D-2642',k:[34,40],o:4},'flag-vn':{a:'Vietnam Flag',b:'1F1FB-1F1F3',k:[4,51],o:2},'flag-vu':{a:'Vanuatu Flag',b:'1F1FB-1F1FA',k:[4,52],o:2},'woman-rowing-boat':{skin_variations:{'1F3FB':{unified:'1F6A3-1F3FB-200D-2640-FE0F',non_qualified:'1F6A3-1F3FB-200D-2640',image:'1f6a3-1f3fb-200d-2640-fe0f.png',sheet_x:34,sheet_y:35,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F6A3-1F3FC-200D-2640-FE0F',non_qualified:'1F6A3-1F3FC-200D-2640',image:'1f6a3-1f3fc-200d-2640-fe0f.png',sheet_x:34,sheet_y:36,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F6A3-1F3FD-200D-2640-FE0F',non_qualified:'1F6A3-1F3FD-200D-2640',image:'1f6a3-1f3fd-200d-2640-fe0f.png',sheet_x:34,sheet_y:37,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F6A3-1F3FE-200D-2640-FE0F',non_qualified:'1F6A3-1F3FE-200D-2640',image:'1f6a3-1f3fe-200d-2640-fe0f.png',sheet_x:34,sheet_y:38,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F6A3-1F3FF-200D-2640-FE0F',non_qualified:'1F6A3-1F3FF-200D-2640',image:'1f6a3-1f3ff-200d-2640-fe0f.png',sheet_x:34,sheet_y:39,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Woman Rowing Boat',b:'1F6A3-200D-2640-FE0F',c:'1F6A3-200D-2640',k:[34,34],o:4},swimmer:{skin_variations:{'1F3FB':{unified:'1F3CA-1F3FB',non_qualified:null,image:'1f3ca-1f3fb.png',sheet_x:9,sheet_y:48,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F3CA-1F3FC',non_qualified:null,image:'1f3ca-1f3fc.png',sheet_x:9,sheet_y:49,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F3CA-1F3FD',non_qualified:null,image:'1f3ca-1f3fd.png',sheet_x:9,sheet_y:50,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F3CA-1F3FE',non_qualified:null,image:'1f3ca-1f3fe.png',sheet_x:9,sheet_y:51,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F3CA-1F3FF',non_qualified:null,image:'1f3ca-1f3ff.png',sheet_x:9,sheet_y:52,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},obsoleted_by:'1F3CA-200D-2642-FE0F',a:'Swimmer',b:'1F3CA',k:[9,47],o:2},'flag-wf':{a:'Wallis & Futuna Flag',b:'1F1FC-1F1EB',k:[4,53],o:2},'man-swimming':{skin_variations:{'1F3FB':{unified:'1F3CA-1F3FB-200D-2642-FE0F',non_qualified:'1F3CA-1F3FB-200D-2642',image:'1f3ca-1f3fb-200d-2642-fe0f.png',sheet_x:9,sheet_y:42,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F3CA-1F3FC-200D-2642-FE0F',non_qualified:'1F3CA-1F3FC-200D-2642',image:'1f3ca-1f3fc-200d-2642-fe0f.png',sheet_x:9,sheet_y:43,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F3CA-1F3FD-200D-2642-FE0F',non_qualified:'1F3CA-1F3FD-200D-2642',image:'1f3ca-1f3fd-200d-2642-fe0f.png',sheet_x:9,sheet_y:44,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F3CA-1F3FE-200D-2642-FE0F',non_qualified:'1F3CA-1F3FE-200D-2642',image:'1f3ca-1f3fe-200d-2642-fe0f.png',sheet_x:9,sheet_y:45,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F3CA-1F3FF-200D-2642-FE0F',non_qualified:'1F3CA-1F3FF-200D-2642',image:'1f3ca-1f3ff-200d-2642-fe0f.png',sheet_x:9,sheet_y:46,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},obsoletes:'1F3CA',a:'Man Swimming',b:'1F3CA-200D-2642-FE0F',c:'1F3CA-200D-2642',k:[9,41],o:4},'flag-ws':{a:'Samoa Flag',b:'1F1FC-1F1F8',k:[4,54],o:2},'woman-swimming':{skin_variations:{'1F3FB':{unified:'1F3CA-1F3FB-200D-2640-FE0F',non_qualified:'1F3CA-1F3FB-200D-2640',image:'1f3ca-1f3fb-200d-2640-fe0f.png',sheet_x:9,sheet_y:36,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F3CA-1F3FC-200D-2640-FE0F',non_qualified:'1F3CA-1F3FC-200D-2640',image:'1f3ca-1f3fc-200d-2640-fe0f.png',sheet_x:9,sheet_y:37,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F3CA-1F3FD-200D-2640-FE0F',non_qualified:'1F3CA-1F3FD-200D-2640',image:'1f3ca-1f3fd-200d-2640-fe0f.png',sheet_x:9,sheet_y:38,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F3CA-1F3FE-200D-2640-FE0F',non_qualified:'1F3CA-1F3FE-200D-2640',image:'1f3ca-1f3fe-200d-2640-fe0f.png',sheet_x:9,sheet_y:39,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F3CA-1F3FF-200D-2640-FE0F',non_qualified:'1F3CA-1F3FF-200D-2640',image:'1f3ca-1f3ff-200d-2640-fe0f.png',sheet_x:9,sheet_y:40,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Woman Swimming',b:'1F3CA-200D-2640-FE0F',c:'1F3CA-200D-2640',k:[9,35],o:4},'flag-xk':{a:'Kosovo Flag',b:'1F1FD-1F1F0',k:[4,55],o:2},person_with_ball:{skin_variations:{'1F3FB':{unified:'26F9-1F3FB',non_qualified:null,image:'26f9-1f3fb.png',sheet_x:54,sheet_y:32,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'26F9-1F3FC',non_qualified:null,image:'26f9-1f3fc.png',sheet_x:54,sheet_y:33,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'26F9-1F3FD',non_qualified:null,image:'26f9-1f3fd.png',sheet_x:54,sheet_y:34,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'26F9-1F3FE',non_qualified:null,image:'26f9-1f3fe.png',sheet_x:54,sheet_y:35,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'26F9-1F3FF',non_qualified:null,image:'26f9-1f3ff.png',sheet_x:54,sheet_y:36,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},obsoleted_by:'26F9-FE0F-200D-2642-FE0F',a:'Person with Ball',b:'26F9-FE0F',c:'26F9',k:[54,31],o:2},'flag-ye':{a:'Yemen Flag',b:'1F1FE-1F1EA',k:[4,56],o:2},'man-bouncing-ball':{skin_variations:{'1F3FB':{unified:'26F9-1F3FB-200D-2642-FE0F',non_qualified:'26F9-1F3FB-200D-2642',image:'26f9-1f3fb-200d-2642-fe0f.png',sheet_x:54,sheet_y:26,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'26F9-1F3FC-200D-2642-FE0F',non_qualified:'26F9-1F3FC-200D-2642',image:'26f9-1f3fc-200d-2642-fe0f.png',sheet_x:54,sheet_y:27,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'26F9-1F3FD-200D-2642-FE0F',non_qualified:'26F9-1F3FD-200D-2642',image:'26f9-1f3fd-200d-2642-fe0f.png',sheet_x:54,sheet_y:28,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'26F9-1F3FE-200D-2642-FE0F',non_qualified:'26F9-1F3FE-200D-2642',image:'26f9-1f3fe-200d-2642-fe0f.png',sheet_x:54,sheet_y:29,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'26F9-1F3FF-200D-2642-FE0F',non_qualified:'26F9-1F3FF-200D-2642',image:'26f9-1f3ff-200d-2642-fe0f.png',sheet_x:54,sheet_y:30,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},obsoletes:'26F9-FE0F',a:'Man Bouncing Ball',b:'26F9-FE0F-200D-2642-FE0F',k:[54,25],o:4},'flag-yt':{a:'Mayotte Flag',b:'1F1FE-1F1F9',k:[5,0],o:2},'woman-bouncing-ball':{skin_variations:{'1F3FB':{unified:'26F9-1F3FB-200D-2640-FE0F',non_qualified:'26F9-1F3FB-200D-2640',image:'26f9-1f3fb-200d-2640-fe0f.png',sheet_x:54,sheet_y:20,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'26F9-1F3FC-200D-2640-FE0F',non_qualified:'26F9-1F3FC-200D-2640',image:'26f9-1f3fc-200d-2640-fe0f.png',sheet_x:54,sheet_y:21,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'26F9-1F3FD-200D-2640-FE0F',non_qualified:'26F9-1F3FD-200D-2640',image:'26f9-1f3fd-200d-2640-fe0f.png',sheet_x:54,sheet_y:22,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'26F9-1F3FE-200D-2640-FE0F',non_qualified:'26F9-1F3FE-200D-2640',image:'26f9-1f3fe-200d-2640-fe0f.png',sheet_x:54,sheet_y:23,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'26F9-1F3FF-200D-2640-FE0F',non_qualified:'26F9-1F3FF-200D-2640',image:'26f9-1f3ff-200d-2640-fe0f.png',sheet_x:54,sheet_y:24,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Woman Bouncing Ball',b:'26F9-FE0F-200D-2640-FE0F',k:[54,19],o:4},'flag-za':{a:'South Africa Flag',b:'1F1FF-1F1E6',k:[5,1],o:2},'flag-zm':{a:'Zambia Flag',b:'1F1FF-1F1F2',k:[5,2],o:2},weight_lifter:{skin_variations:{'1F3FB':{unified:'1F3CB-1F3FB',non_qualified:null,image:'1f3cb-1f3fb.png',sheet_x:10,sheet_y:9,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F3CB-1F3FC',non_qualified:null,image:'1f3cb-1f3fc.png',sheet_x:10,sheet_y:10,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F3CB-1F3FD',non_qualified:null,image:'1f3cb-1f3fd.png',sheet_x:10,sheet_y:11,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F3CB-1F3FE',non_qualified:null,image:'1f3cb-1f3fe.png',sheet_x:10,sheet_y:12,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F3CB-1F3FF',non_qualified:null,image:'1f3cb-1f3ff.png',sheet_x:10,sheet_y:13,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},obsoleted_by:'1F3CB-FE0F-200D-2642-FE0F',a:'Weight Lifter',b:'1F3CB-FE0F',c:'1F3CB',k:[10,8],o:2},'man-lifting-weights':{skin_variations:{'1F3FB':{unified:'1F3CB-1F3FB-200D-2642-FE0F',non_qualified:'1F3CB-1F3FB-200D-2642',image:'1f3cb-1f3fb-200d-2642-fe0f.png',sheet_x:10,sheet_y:3,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F3CB-1F3FC-200D-2642-FE0F',non_qualified:'1F3CB-1F3FC-200D-2642',image:'1f3cb-1f3fc-200d-2642-fe0f.png',sheet_x:10,sheet_y:4,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F3CB-1F3FD-200D-2642-FE0F',non_qualified:'1F3CB-1F3FD-200D-2642',image:'1f3cb-1f3fd-200d-2642-fe0f.png',sheet_x:10,sheet_y:5,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F3CB-1F3FE-200D-2642-FE0F',non_qualified:'1F3CB-1F3FE-200D-2642',image:'1f3cb-1f3fe-200d-2642-fe0f.png',sheet_x:10,sheet_y:6,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F3CB-1F3FF-200D-2642-FE0F',non_qualified:'1F3CB-1F3FF-200D-2642',image:'1f3cb-1f3ff-200d-2642-fe0f.png',sheet_x:10,sheet_y:7,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},obsoletes:'1F3CB-FE0F',a:'Man Lifting Weights',b:'1F3CB-FE0F-200D-2642-FE0F',k:[10,2],o:4},'flag-zw':{a:'Zimbabwe Flag',b:'1F1FF-1F1FC',k:[5,3],o:2},'woman-lifting-weights':{skin_variations:{'1F3FB':{unified:'1F3CB-1F3FB-200D-2640-FE0F',non_qualified:'1F3CB-1F3FB-200D-2640',image:'1f3cb-1f3fb-200d-2640-fe0f.png',sheet_x:9,sheet_y:54,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F3CB-1F3FC-200D-2640-FE0F',non_qualified:'1F3CB-1F3FC-200D-2640',image:'1f3cb-1f3fc-200d-2640-fe0f.png',sheet_x:9,sheet_y:55,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F3CB-1F3FD-200D-2640-FE0F',non_qualified:'1F3CB-1F3FD-200D-2640',image:'1f3cb-1f3fd-200d-2640-fe0f.png',sheet_x:9,sheet_y:56,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F3CB-1F3FE-200D-2640-FE0F',non_qualified:'1F3CB-1F3FE-200D-2640',image:'1f3cb-1f3fe-200d-2640-fe0f.png',sheet_x:10,sheet_y:0,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F3CB-1F3FF-200D-2640-FE0F',non_qualified:'1F3CB-1F3FF-200D-2640',image:'1f3cb-1f3ff-200d-2640-fe0f.png',sheet_x:10,sheet_y:1,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Woman Lifting Weights',b:'1F3CB-FE0F-200D-2640-FE0F',k:[9,53],o:4},'flag-england':{a:'England Flag',b:'1F3F4-E0067-E0062-E0065-E006E-E0067-E007F',k:[11,14],o:5},bicyclist:{skin_variations:{'1F3FB':{unified:'1F6B4-1F3FB',non_qualified:null,image:'1f6b4-1f3fb.png',sheet_x:35,sheet_y:24,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F6B4-1F3FC',non_qualified:null,image:'1f6b4-1f3fc.png',sheet_x:35,sheet_y:25,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F6B4-1F3FD',non_qualified:null,image:'1f6b4-1f3fd.png',sheet_x:35,sheet_y:26,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F6B4-1F3FE',non_qualified:null,image:'1f6b4-1f3fe.png',sheet_x:35,sheet_y:27,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F6B4-1F3FF',non_qualified:null,image:'1f6b4-1f3ff.png',sheet_x:35,sheet_y:28,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},obsoleted_by:'1F6B4-200D-2642-FE0F',a:'Bicyclist',b:'1F6B4',k:[35,23],o:2},'flag-scotland':{a:'Scotland Flag',b:'1F3F4-E0067-E0062-E0073-E0063-E0074-E007F',k:[11,15],o:5},'flag-wales':{a:'Wales Flag',b:'1F3F4-E0067-E0062-E0077-E006C-E0073-E007F',k:[11,16],o:5},'man-biking':{skin_variations:{'1F3FB':{unified:'1F6B4-1F3FB-200D-2642-FE0F',non_qualified:'1F6B4-1F3FB-200D-2642',image:'1f6b4-1f3fb-200d-2642-fe0f.png',sheet_x:35,sheet_y:18,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F6B4-1F3FC-200D-2642-FE0F',non_qualified:'1F6B4-1F3FC-200D-2642',image:'1f6b4-1f3fc-200d-2642-fe0f.png',sheet_x:35,sheet_y:19,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F6B4-1F3FD-200D-2642-FE0F',non_qualified:'1F6B4-1F3FD-200D-2642',image:'1f6b4-1f3fd-200d-2642-fe0f.png',sheet_x:35,sheet_y:20,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F6B4-1F3FE-200D-2642-FE0F',non_qualified:'1F6B4-1F3FE-200D-2642',image:'1f6b4-1f3fe-200d-2642-fe0f.png',sheet_x:35,sheet_y:21,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F6B4-1F3FF-200D-2642-FE0F',non_qualified:'1F6B4-1F3FF-200D-2642',image:'1f6b4-1f3ff-200d-2642-fe0f.png',sheet_x:35,sheet_y:22,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},obsoletes:'1F6B4',a:'Man Biking',b:'1F6B4-200D-2642-FE0F',c:'1F6B4-200D-2642',k:[35,17],o:4},'woman-biking':{skin_variations:{'1F3FB':{unified:'1F6B4-1F3FB-200D-2640-FE0F',non_qualified:'1F6B4-1F3FB-200D-2640',image:'1f6b4-1f3fb-200d-2640-fe0f.png',sheet_x:35,sheet_y:12,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F6B4-1F3FC-200D-2640-FE0F',non_qualified:'1F6B4-1F3FC-200D-2640',image:'1f6b4-1f3fc-200d-2640-fe0f.png',sheet_x:35,sheet_y:13,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F6B4-1F3FD-200D-2640-FE0F',non_qualified:'1F6B4-1F3FD-200D-2640',image:'1f6b4-1f3fd-200d-2640-fe0f.png',sheet_x:35,sheet_y:14,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F6B4-1F3FE-200D-2640-FE0F',non_qualified:'1F6B4-1F3FE-200D-2640',image:'1f6b4-1f3fe-200d-2640-fe0f.png',sheet_x:35,sheet_y:15,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F6B4-1F3FF-200D-2640-FE0F',non_qualified:'1F6B4-1F3FF-200D-2640',image:'1f6b4-1f3ff-200d-2640-fe0f.png',sheet_x:35,sheet_y:16,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Woman Biking',b:'1F6B4-200D-2640-FE0F',c:'1F6B4-200D-2640',k:[35,11],o:4},mountain_bicyclist:{skin_variations:{'1F3FB':{unified:'1F6B5-1F3FB',non_qualified:null,image:'1f6b5-1f3fb.png',sheet_x:35,sheet_y:42,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F6B5-1F3FC',non_qualified:null,image:'1f6b5-1f3fc.png',sheet_x:35,sheet_y:43,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F6B5-1F3FD',non_qualified:null,image:'1f6b5-1f3fd.png',sheet_x:35,sheet_y:44,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F6B5-1F3FE',non_qualified:null,image:'1f6b5-1f3fe.png',sheet_x:35,sheet_y:45,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F6B5-1F3FF',non_qualified:null,image:'1f6b5-1f3ff.png',sheet_x:35,sheet_y:46,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},obsoleted_by:'1F6B5-200D-2642-FE0F',a:'Mountain Bicyclist',b:'1F6B5',k:[35,41],o:2},'man-mountain-biking':{skin_variations:{'1F3FB':{unified:'1F6B5-1F3FB-200D-2642-FE0F',non_qualified:'1F6B5-1F3FB-200D-2642',image:'1f6b5-1f3fb-200d-2642-fe0f.png',sheet_x:35,sheet_y:36,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F6B5-1F3FC-200D-2642-FE0F',non_qualified:'1F6B5-1F3FC-200D-2642',image:'1f6b5-1f3fc-200d-2642-fe0f.png',sheet_x:35,sheet_y:37,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F6B5-1F3FD-200D-2642-FE0F',non_qualified:'1F6B5-1F3FD-200D-2642',image:'1f6b5-1f3fd-200d-2642-fe0f.png',sheet_x:35,sheet_y:38,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F6B5-1F3FE-200D-2642-FE0F',non_qualified:'1F6B5-1F3FE-200D-2642',image:'1f6b5-1f3fe-200d-2642-fe0f.png',sheet_x:35,sheet_y:39,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F6B5-1F3FF-200D-2642-FE0F',non_qualified:'1F6B5-1F3FF-200D-2642',image:'1f6b5-1f3ff-200d-2642-fe0f.png',sheet_x:35,sheet_y:40,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},obsoletes:'1F6B5',a:'Man Mountain Biking',b:'1F6B5-200D-2642-FE0F',c:'1F6B5-200D-2642',k:[35,35],o:4},'woman-mountain-biking':{skin_variations:{'1F3FB':{unified:'1F6B5-1F3FB-200D-2640-FE0F',non_qualified:'1F6B5-1F3FB-200D-2640',image:'1f6b5-1f3fb-200d-2640-fe0f.png',sheet_x:35,sheet_y:30,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F6B5-1F3FC-200D-2640-FE0F',non_qualified:'1F6B5-1F3FC-200D-2640',image:'1f6b5-1f3fc-200d-2640-fe0f.png',sheet_x:35,sheet_y:31,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F6B5-1F3FD-200D-2640-FE0F',non_qualified:'1F6B5-1F3FD-200D-2640',image:'1f6b5-1f3fd-200d-2640-fe0f.png',sheet_x:35,sheet_y:32,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F6B5-1F3FE-200D-2640-FE0F',non_qualified:'1F6B5-1F3FE-200D-2640',image:'1f6b5-1f3fe-200d-2640-fe0f.png',sheet_x:35,sheet_y:33,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F6B5-1F3FF-200D-2640-FE0F',non_qualified:'1F6B5-1F3FF-200D-2640',image:'1f6b5-1f3ff-200d-2640-fe0f.png',sheet_x:35,sheet_y:34,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Woman Mountain Biking',b:'1F6B5-200D-2640-FE0F',c:'1F6B5-200D-2640',k:[35,29],o:4},person_doing_cartwheel:{skin_variations:{'1F3FB':{unified:'1F938-1F3FB',non_qualified:null,image:'1f938-1f3fb.png',sheet_x:40,sheet_y:9,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F938-1F3FC',non_qualified:null,image:'1f938-1f3fc.png',sheet_x:40,sheet_y:10,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F938-1F3FD',non_qualified:null,image:'1f938-1f3fd.png',sheet_x:40,sheet_y:11,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F938-1F3FE',non_qualified:null,image:'1f938-1f3fe.png',sheet_x:40,sheet_y:12,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F938-1F3FF',non_qualified:null,image:'1f938-1f3ff.png',sheet_x:40,sheet_y:13,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},a:'Person Doing Cartwheel',b:'1F938',k:[40,8],o:4},'man-cartwheeling':{skin_variations:{'1F3FB':{unified:'1F938-1F3FB-200D-2642-FE0F',non_qualified:'1F938-1F3FB-200D-2642',image:'1f938-1f3fb-200d-2642-fe0f.png',sheet_x:40,sheet_y:3,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F938-1F3FC-200D-2642-FE0F',non_qualified:'1F938-1F3FC-200D-2642',image:'1f938-1f3fc-200d-2642-fe0f.png',sheet_x:40,sheet_y:4,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F938-1F3FD-200D-2642-FE0F',non_qualified:'1F938-1F3FD-200D-2642',image:'1f938-1f3fd-200d-2642-fe0f.png',sheet_x:40,sheet_y:5,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F938-1F3FE-200D-2642-FE0F',non_qualified:'1F938-1F3FE-200D-2642',image:'1f938-1f3fe-200d-2642-fe0f.png',sheet_x:40,sheet_y:6,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F938-1F3FF-200D-2642-FE0F',non_qualified:'1F938-1F3FF-200D-2642',image:'1f938-1f3ff-200d-2642-fe0f.png',sheet_x:40,sheet_y:7,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man Cartwheeling',b:'1F938-200D-2642-FE0F',c:'1F938-200D-2642',k:[40,2],o:4},'woman-cartwheeling':{skin_variations:{'1F3FB':{unified:'1F938-1F3FB-200D-2640-FE0F',non_qualified:'1F938-1F3FB-200D-2640',image:'1f938-1f3fb-200d-2640-fe0f.png',sheet_x:39,sheet_y:54,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F938-1F3FC-200D-2640-FE0F',non_qualified:'1F938-1F3FC-200D-2640',image:'1f938-1f3fc-200d-2640-fe0f.png',sheet_x:39,sheet_y:55,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F938-1F3FD-200D-2640-FE0F',non_qualified:'1F938-1F3FD-200D-2640',image:'1f938-1f3fd-200d-2640-fe0f.png',sheet_x:39,sheet_y:56,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F938-1F3FE-200D-2640-FE0F',non_qualified:'1F938-1F3FE-200D-2640',image:'1f938-1f3fe-200d-2640-fe0f.png',sheet_x:40,sheet_y:0,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F938-1F3FF-200D-2640-FE0F',non_qualified:'1F938-1F3FF-200D-2640',image:'1f938-1f3ff-200d-2640-fe0f.png',sheet_x:40,sheet_y:1,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Woman Cartwheeling',b:'1F938-200D-2640-FE0F',c:'1F938-200D-2640',k:[39,53],o:4},wrestlers:{a:'Wrestlers',b:'1F93C',k:[40,35],o:4},'man-wrestling':{a:'Man Wrestling',b:'1F93C-200D-2642-FE0F',c:'1F93C-200D-2642',k:[40,34],o:4},'woman-wrestling':{a:'Woman Wrestling',b:'1F93C-200D-2640-FE0F',c:'1F93C-200D-2640',k:[40,33],o:4},water_polo:{skin_variations:{'1F3FB':{unified:'1F93D-1F3FB',non_qualified:null,image:'1f93d-1f3fb.png',sheet_x:40,sheet_y:49,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F93D-1F3FC',non_qualified:null,image:'1f93d-1f3fc.png',sheet_x:40,sheet_y:50,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F93D-1F3FD',non_qualified:null,image:'1f93d-1f3fd.png',sheet_x:40,sheet_y:51,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F93D-1F3FE',non_qualified:null,image:'1f93d-1f3fe.png',sheet_x:40,sheet_y:52,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F93D-1F3FF',non_qualified:null,image:'1f93d-1f3ff.png',sheet_x:40,sheet_y:53,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},a:'Water Polo',b:'1F93D',k:[40,48],o:4},'man-playing-water-polo':{skin_variations:{'1F3FB':{unified:'1F93D-1F3FB-200D-2642-FE0F',non_qualified:'1F93D-1F3FB-200D-2642',image:'1f93d-1f3fb-200d-2642-fe0f.png',sheet_x:40,sheet_y:43,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F93D-1F3FC-200D-2642-FE0F',non_qualified:'1F93D-1F3FC-200D-2642',image:'1f93d-1f3fc-200d-2642-fe0f.png',sheet_x:40,sheet_y:44,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F93D-1F3FD-200D-2642-FE0F',non_qualified:'1F93D-1F3FD-200D-2642',image:'1f93d-1f3fd-200d-2642-fe0f.png',sheet_x:40,sheet_y:45,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F93D-1F3FE-200D-2642-FE0F',non_qualified:'1F93D-1F3FE-200D-2642',image:'1f93d-1f3fe-200d-2642-fe0f.png',sheet_x:40,sheet_y:46,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F93D-1F3FF-200D-2642-FE0F',non_qualified:'1F93D-1F3FF-200D-2642',image:'1f93d-1f3ff-200d-2642-fe0f.png',sheet_x:40,sheet_y:47,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man Playing Water Polo',b:'1F93D-200D-2642-FE0F',c:'1F93D-200D-2642',k:[40,42],o:4},'woman-playing-water-polo':{skin_variations:{'1F3FB':{unified:'1F93D-1F3FB-200D-2640-FE0F',non_qualified:'1F93D-1F3FB-200D-2640',image:'1f93d-1f3fb-200d-2640-fe0f.png',sheet_x:40,sheet_y:37,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F93D-1F3FC-200D-2640-FE0F',non_qualified:'1F93D-1F3FC-200D-2640',image:'1f93d-1f3fc-200d-2640-fe0f.png',sheet_x:40,sheet_y:38,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F93D-1F3FD-200D-2640-FE0F',non_qualified:'1F93D-1F3FD-200D-2640',image:'1f93d-1f3fd-200d-2640-fe0f.png',sheet_x:40,sheet_y:39,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F93D-1F3FE-200D-2640-FE0F',non_qualified:'1F93D-1F3FE-200D-2640',image:'1f93d-1f3fe-200d-2640-fe0f.png',sheet_x:40,sheet_y:40,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F93D-1F3FF-200D-2640-FE0F',non_qualified:'1F93D-1F3FF-200D-2640',image:'1f93d-1f3ff-200d-2640-fe0f.png',sheet_x:40,sheet_y:41,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Woman Playing Water Polo',b:'1F93D-200D-2640-FE0F',c:'1F93D-200D-2640',k:[40,36],o:4},handball:{skin_variations:{'1F3FB':{unified:'1F93E-1F3FB',non_qualified:null,image:'1f93e-1f3fb.png',sheet_x:41,sheet_y:10,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FC':{unified:'1F93E-1F3FC',non_qualified:null,image:'1f93e-1f3fc.png',sheet_x:41,sheet_y:11,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FD':{unified:'1F93E-1F3FD',non_qualified:null,image:'1f93e-1f3fd.png',sheet_x:41,sheet_y:12,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FE':{unified:'1F93E-1F3FE',non_qualified:null,image:'1f93e-1f3fe.png',sheet_x:41,sheet_y:13,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false},'1F3FF':{unified:'1F93E-1F3FF',non_qualified:null,image:'1f93e-1f3ff.png',sheet_x:41,sheet_y:14,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:false}},a:'Handball',b:'1F93E',k:[41,9],o:4},'man-playing-handball':{skin_variations:{'1F3FB':{unified:'1F93E-1F3FB-200D-2642-FE0F',non_qualified:'1F93E-1F3FB-200D-2642',image:'1f93e-1f3fb-200d-2642-fe0f.png',sheet_x:41,sheet_y:4,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F93E-1F3FC-200D-2642-FE0F',non_qualified:'1F93E-1F3FC-200D-2642',image:'1f93e-1f3fc-200d-2642-fe0f.png',sheet_x:41,sheet_y:5,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F93E-1F3FD-200D-2642-FE0F',non_qualified:'1F93E-1F3FD-200D-2642',image:'1f93e-1f3fd-200d-2642-fe0f.png',sheet_x:41,sheet_y:6,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F93E-1F3FE-200D-2642-FE0F',non_qualified:'1F93E-1F3FE-200D-2642',image:'1f93e-1f3fe-200d-2642-fe0f.png',sheet_x:41,sheet_y:7,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F93E-1F3FF-200D-2642-FE0F',non_qualified:'1F93E-1F3FF-200D-2642',image:'1f93e-1f3ff-200d-2642-fe0f.png',sheet_x:41,sheet_y:8,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man Playing Handball',b:'1F93E-200D-2642-FE0F',c:'1F93E-200D-2642',k:[41,3],o:4},'woman-playing-handball':{skin_variations:{'1F3FB':{unified:'1F93E-1F3FB-200D-2640-FE0F',non_qualified:'1F93E-1F3FB-200D-2640',image:'1f93e-1f3fb-200d-2640-fe0f.png',sheet_x:40,sheet_y:55,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F93E-1F3FC-200D-2640-FE0F',non_qualified:'1F93E-1F3FC-200D-2640',image:'1f93e-1f3fc-200d-2640-fe0f.png',sheet_x:40,sheet_y:56,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F93E-1F3FD-200D-2640-FE0F',non_qualified:'1F93E-1F3FD-200D-2640',image:'1f93e-1f3fd-200d-2640-fe0f.png',sheet_x:41,sheet_y:0,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F93E-1F3FE-200D-2640-FE0F',non_qualified:'1F93E-1F3FE-200D-2640',image:'1f93e-1f3fe-200d-2640-fe0f.png',sheet_x:41,sheet_y:1,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F93E-1F3FF-200D-2640-FE0F',non_qualified:'1F93E-1F3FF-200D-2640',image:'1f93e-1f3ff-200d-2640-fe0f.png',sheet_x:41,sheet_y:2,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Woman Playing Handball',b:'1F93E-200D-2640-FE0F',c:'1F93E-200D-2640',k:[40,54],o:4},juggling:{skin_variations:{'1F3FB':{unified:'1F939-1F3FB',non_qualified:null,image:'1f939-1f3fb.png',sheet_x:40,sheet_y:27,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F939-1F3FC',non_qualified:null,image:'1f939-1f3fc.png',sheet_x:40,sheet_y:28,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F939-1F3FD',non_qualified:null,image:'1f939-1f3fd.png',sheet_x:40,sheet_y:29,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F939-1F3FE',non_qualified:null,image:'1f939-1f3fe.png',sheet_x:40,sheet_y:30,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F939-1F3FF',non_qualified:null,image:'1f939-1f3ff.png',sheet_x:40,sheet_y:31,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Juggling',b:'1F939',k:[40,26],o:4},'man-juggling':{skin_variations:{'1F3FB':{unified:'1F939-1F3FB-200D-2642-FE0F',non_qualified:'1F939-1F3FB-200D-2642',image:'1f939-1f3fb-200d-2642-fe0f.png',sheet_x:40,sheet_y:21,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F939-1F3FC-200D-2642-FE0F',non_qualified:'1F939-1F3FC-200D-2642',image:'1f939-1f3fc-200d-2642-fe0f.png',sheet_x:40,sheet_y:22,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F939-1F3FD-200D-2642-FE0F',non_qualified:'1F939-1F3FD-200D-2642',image:'1f939-1f3fd-200d-2642-fe0f.png',sheet_x:40,sheet_y:23,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F939-1F3FE-200D-2642-FE0F',non_qualified:'1F939-1F3FE-200D-2642',image:'1f939-1f3fe-200d-2642-fe0f.png',sheet_x:40,sheet_y:24,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F939-1F3FF-200D-2642-FE0F',non_qualified:'1F939-1F3FF-200D-2642',image:'1f939-1f3ff-200d-2642-fe0f.png',sheet_x:40,sheet_y:25,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man Juggling',b:'1F939-200D-2642-FE0F',c:'1F939-200D-2642',k:[40,20],o:4},'woman-juggling':{skin_variations:{'1F3FB':{unified:'1F939-1F3FB-200D-2640-FE0F',non_qualified:'1F939-1F3FB-200D-2640',image:'1f939-1f3fb-200d-2640-fe0f.png',sheet_x:40,sheet_y:15,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F939-1F3FC-200D-2640-FE0F',non_qualified:'1F939-1F3FC-200D-2640',image:'1f939-1f3fc-200d-2640-fe0f.png',sheet_x:40,sheet_y:16,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F939-1F3FD-200D-2640-FE0F',non_qualified:'1F939-1F3FD-200D-2640',image:'1f939-1f3fd-200d-2640-fe0f.png',sheet_x:40,sheet_y:17,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F939-1F3FE-200D-2640-FE0F',non_qualified:'1F939-1F3FE-200D-2640',image:'1f939-1f3fe-200d-2640-fe0f.png',sheet_x:40,sheet_y:18,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F939-1F3FF-200D-2640-FE0F',non_qualified:'1F939-1F3FF-200D-2640',image:'1f939-1f3ff-200d-2640-fe0f.png',sheet_x:40,sheet_y:19,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Woman Juggling',b:'1F939-200D-2640-FE0F',c:'1F939-200D-2640',k:[40,14],o:4},person_in_lotus_position:{skin_variations:{'1F3FB':{unified:'1F9D8-1F3FB',non_qualified:null,image:'1f9d8-1f3fb.png',sheet_x:49,sheet_y:32,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9D8-1F3FB-200D-2640-FE0F'},'1F3FC':{unified:'1F9D8-1F3FC',non_qualified:null,image:'1f9d8-1f3fc.png',sheet_x:49,sheet_y:33,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9D8-1F3FC-200D-2640-FE0F'},'1F3FD':{unified:'1F9D8-1F3FD',non_qualified:null,image:'1f9d8-1f3fd.png',sheet_x:49,sheet_y:34,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9D8-1F3FD-200D-2640-FE0F'},'1F3FE':{unified:'1F9D8-1F3FE',non_qualified:null,image:'1f9d8-1f3fe.png',sheet_x:49,sheet_y:35,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9D8-1F3FE-200D-2640-FE0F'},'1F3FF':{unified:'1F9D8-1F3FF',non_qualified:null,image:'1f9d8-1f3ff.png',sheet_x:49,sheet_y:36,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoleted_by:'1F9D8-1F3FF-200D-2640-FE0F'}},obsoleted_by:'1F9D8-200D-2640-FE0F',a:'Person in Lotus Position',b:'1F9D8',k:[49,31],o:5},man_in_lotus_position:{skin_variations:{'1F3FB':{unified:'1F9D8-1F3FB-200D-2642-FE0F',non_qualified:'1F9D8-1F3FB-200D-2642',image:'1f9d8-1f3fb-200d-2642-fe0f.png',sheet_x:49,sheet_y:26,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F9D8-1F3FC-200D-2642-FE0F',non_qualified:'1F9D8-1F3FC-200D-2642',image:'1f9d8-1f3fc-200d-2642-fe0f.png',sheet_x:49,sheet_y:27,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F9D8-1F3FD-200D-2642-FE0F',non_qualified:'1F9D8-1F3FD-200D-2642',image:'1f9d8-1f3fd-200d-2642-fe0f.png',sheet_x:49,sheet_y:28,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F9D8-1F3FE-200D-2642-FE0F',non_qualified:'1F9D8-1F3FE-200D-2642',image:'1f9d8-1f3fe-200d-2642-fe0f.png',sheet_x:49,sheet_y:29,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F9D8-1F3FF-200D-2642-FE0F',non_qualified:'1F9D8-1F3FF-200D-2642',image:'1f9d8-1f3ff-200d-2642-fe0f.png',sheet_x:49,sheet_y:30,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man in Lotus Position',b:'1F9D8-200D-2642-FE0F',c:'1F9D8-200D-2642',j:['man','male','meditation','yoga','serenity','zen','mindfulness'],k:[49,25],o:5},woman_in_lotus_position:{skin_variations:{'1F3FB':{unified:'1F9D8-1F3FB-200D-2640-FE0F',non_qualified:'1F9D8-1F3FB-200D-2640',image:'1f9d8-1f3fb-200d-2640-fe0f.png',sheet_x:49,sheet_y:20,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9D8-1F3FB'},'1F3FC':{unified:'1F9D8-1F3FC-200D-2640-FE0F',non_qualified:'1F9D8-1F3FC-200D-2640',image:'1f9d8-1f3fc-200d-2640-fe0f.png',sheet_x:49,sheet_y:21,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9D8-1F3FC'},'1F3FD':{unified:'1F9D8-1F3FD-200D-2640-FE0F',non_qualified:'1F9D8-1F3FD-200D-2640',image:'1f9d8-1f3fd-200d-2640-fe0f.png',sheet_x:49,sheet_y:22,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9D8-1F3FD'},'1F3FE':{unified:'1F9D8-1F3FE-200D-2640-FE0F',non_qualified:'1F9D8-1F3FE-200D-2640',image:'1f9d8-1f3fe-200d-2640-fe0f.png',sheet_x:49,sheet_y:23,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9D8-1F3FE'},'1F3FF':{unified:'1F9D8-1F3FF-200D-2640-FE0F',non_qualified:'1F9D8-1F3FF-200D-2640',image:'1f9d8-1f3ff-200d-2640-fe0f.png',sheet_x:49,sheet_y:24,added_in:'5.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true,obsoletes:'1F9D8-1F3FF'}},obsoletes:'1F9D8',a:'Woman in Lotus Position',b:'1F9D8-200D-2640-FE0F',c:'1F9D8-200D-2640',j:['woman','female','meditation','yoga','serenity','zen','mindfulness'],k:[49,19],o:5},bath:{skin_variations:{'1F3FB':{unified:'1F6C0-1F3FB',non_qualified:null,image:'1f6c0-1f3fb.png',sheet_x:36,sheet_y:18,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F6C0-1F3FC',non_qualified:null,image:'1f6c0-1f3fc.png',sheet_x:36,sheet_y:19,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F6C0-1F3FD',non_qualified:null,image:'1f6c0-1f3fd.png',sheet_x:36,sheet_y:20,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F6C0-1F3FE',non_qualified:null,image:'1f6c0-1f3fe.png',sheet_x:36,sheet_y:21,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F6C0-1F3FF',non_qualified:null,image:'1f6c0-1f3ff.png',sheet_x:36,sheet_y:22,added_in:'2.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Bath',b:'1F6C0',j:['clean','shower','bathroom'],k:[36,17],o:2},sleeping_accommodation:{skin_variations:{'1F3FB':{unified:'1F6CC-1F3FB',non_qualified:null,image:'1f6cc-1f3fb.png',sheet_x:36,sheet_y:30,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F6CC-1F3FC',non_qualified:null,image:'1f6cc-1f3fc.png',sheet_x:36,sheet_y:31,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F6CC-1F3FD',non_qualified:null,image:'1f6cc-1f3fd.png',sheet_x:36,sheet_y:32,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F6CC-1F3FE',non_qualified:null,image:'1f6cc-1f3fe.png',sheet_x:36,sheet_y:33,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F6CC-1F3FF',non_qualified:null,image:'1f6cc-1f3ff.png',sheet_x:36,sheet_y:34,added_in:'4.0',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Sleeping Accommodation',b:'1F6CC',k:[36,29],o:2},people_holding_hands:{skin_variations:{'1F3FB-1F3FB':{unified:'1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FB',non_qualified:null,image:'1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb.png',sheet_x:46,sheet_y:39,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FB-1F3FC':{unified:'1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FC',non_qualified:null,image:'1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc.png',sheet_x:46,sheet_y:40,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FB-1F3FD':{unified:'1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FD',non_qualified:null,image:'1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd.png',sheet_x:46,sheet_y:41,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FB-1F3FE':{unified:'1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FE',non_qualified:null,image:'1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe.png',sheet_x:46,sheet_y:42,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FB-1F3FF':{unified:'1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FF',non_qualified:null,image:'1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff.png',sheet_x:46,sheet_y:43,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FC-1F3FB':{unified:'1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FB',non_qualified:null,image:'1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb.png',sheet_x:46,sheet_y:44,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC-1F3FC':{unified:'1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FC',non_qualified:null,image:'1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc.png',sheet_x:46,sheet_y:45,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC-1F3FD':{unified:'1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FD',non_qualified:null,image:'1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd.png',sheet_x:46,sheet_y:46,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FC-1F3FE':{unified:'1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FE',non_qualified:null,image:'1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe.png',sheet_x:46,sheet_y:47,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FC-1F3FF':{unified:'1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FF',non_qualified:null,image:'1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff.png',sheet_x:46,sheet_y:48,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FD-1F3FB':{unified:'1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FB',non_qualified:null,image:'1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb.png',sheet_x:46,sheet_y:49,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD-1F3FC':{unified:'1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FC',non_qualified:null,image:'1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc.png',sheet_x:46,sheet_y:50,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD-1F3FD':{unified:'1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FD',non_qualified:null,image:'1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd.png',sheet_x:46,sheet_y:51,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD-1F3FE':{unified:'1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FE',non_qualified:null,image:'1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe.png',sheet_x:46,sheet_y:52,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FD-1F3FF':{unified:'1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FF',non_qualified:null,image:'1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff.png',sheet_x:46,sheet_y:53,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FE-1F3FB':{unified:'1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FB',non_qualified:null,image:'1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb.png',sheet_x:46,sheet_y:54,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE-1F3FC':{unified:'1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FC',non_qualified:null,image:'1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc.png',sheet_x:46,sheet_y:55,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE-1F3FD':{unified:'1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FD',non_qualified:null,image:'1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd.png',sheet_x:46,sheet_y:56,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE-1F3FE':{unified:'1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FE',non_qualified:null,image:'1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe.png',sheet_x:47,sheet_y:0,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE-1F3FF':{unified:'1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FF',non_qualified:null,image:'1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff.png',sheet_x:47,sheet_y:1,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FF-1F3FB':{unified:'1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FB',non_qualified:null,image:'1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb.png',sheet_x:47,sheet_y:2,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF-1F3FC':{unified:'1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FC',non_qualified:null,image:'1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc.png',sheet_x:47,sheet_y:3,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF-1F3FD':{unified:'1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FD',non_qualified:null,image:'1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd.png',sheet_x:47,sheet_y:4,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF-1F3FE':{unified:'1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FE',non_qualified:null,image:'1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe.png',sheet_x:47,sheet_y:5,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF-1F3FF':{unified:'1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FF',non_qualified:null,image:'1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff.png',sheet_x:47,sheet_y:6,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'People Holding Hands',b:'1F9D1-200D-1F91D-200D-1F9D1',k:[46,38],o:12},two_women_holding_hands:{skin_variations:{'1F3FB':{unified:'1F46D-1F3FB',non_qualified:null,image:'1f46d-1f3fb.png',sheet_x:21,sheet_y:12,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F46D-1F3FC',non_qualified:null,image:'1f46d-1f3fc.png',sheet_x:21,sheet_y:13,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F46D-1F3FD',non_qualified:null,image:'1f46d-1f3fd.png',sheet_x:21,sheet_y:14,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F46D-1F3FE',non_qualified:null,image:'1f46d-1f3fe.png',sheet_x:21,sheet_y:15,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F46D-1F3FF',non_qualified:null,image:'1f46d-1f3ff.png',sheet_x:21,sheet_y:16,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FB-1F3FC':{unified:'1F469-1F3FB-200D-1F91D-200D-1F469-1F3FC',non_qualified:null,image:'1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc.png',sheet_x:21,sheet_y:17,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FB-1F3FD':{unified:'1F469-1F3FB-200D-1F91D-200D-1F469-1F3FD',non_qualified:null,image:'1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd.png',sheet_x:21,sheet_y:18,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FB-1F3FE':{unified:'1F469-1F3FB-200D-1F91D-200D-1F469-1F3FE',non_qualified:null,image:'1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe.png',sheet_x:21,sheet_y:19,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FB-1F3FF':{unified:'1F469-1F3FB-200D-1F91D-200D-1F469-1F3FF',non_qualified:null,image:'1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff.png',sheet_x:21,sheet_y:20,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FC-1F3FB':{unified:'1F469-1F3FC-200D-1F91D-200D-1F469-1F3FB',non_qualified:null,image:'1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb.png',sheet_x:21,sheet_y:21,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC-1F3FD':{unified:'1F469-1F3FC-200D-1F91D-200D-1F469-1F3FD',non_qualified:null,image:'1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd.png',sheet_x:21,sheet_y:22,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FC-1F3FE':{unified:'1F469-1F3FC-200D-1F91D-200D-1F469-1F3FE',non_qualified:null,image:'1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe.png',sheet_x:21,sheet_y:23,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FC-1F3FF':{unified:'1F469-1F3FC-200D-1F91D-200D-1F469-1F3FF',non_qualified:null,image:'1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff.png',sheet_x:21,sheet_y:24,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FD-1F3FB':{unified:'1F469-1F3FD-200D-1F91D-200D-1F469-1F3FB',non_qualified:null,image:'1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb.png',sheet_x:21,sheet_y:25,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD-1F3FC':{unified:'1F469-1F3FD-200D-1F91D-200D-1F469-1F3FC',non_qualified:null,image:'1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc.png',sheet_x:21,sheet_y:26,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD-1F3FE':{unified:'1F469-1F3FD-200D-1F91D-200D-1F469-1F3FE',non_qualified:null,image:'1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe.png',sheet_x:21,sheet_y:27,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FD-1F3FF':{unified:'1F469-1F3FD-200D-1F91D-200D-1F469-1F3FF',non_qualified:null,image:'1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff.png',sheet_x:21,sheet_y:28,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FE-1F3FB':{unified:'1F469-1F3FE-200D-1F91D-200D-1F469-1F3FB',non_qualified:null,image:'1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb.png',sheet_x:21,sheet_y:29,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE-1F3FC':{unified:'1F469-1F3FE-200D-1F91D-200D-1F469-1F3FC',non_qualified:null,image:'1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc.png',sheet_x:21,sheet_y:30,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE-1F3FD':{unified:'1F469-1F3FE-200D-1F91D-200D-1F469-1F3FD',non_qualified:null,image:'1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd.png',sheet_x:21,sheet_y:31,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE-1F3FF':{unified:'1F469-1F3FE-200D-1F91D-200D-1F469-1F3FF',non_qualified:null,image:'1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff.png',sheet_x:21,sheet_y:32,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FF-1F3FB':{unified:'1F469-1F3FF-200D-1F91D-200D-1F469-1F3FB',non_qualified:null,image:'1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb.png',sheet_x:21,sheet_y:33,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF-1F3FC':{unified:'1F469-1F3FF-200D-1F91D-200D-1F469-1F3FC',non_qualified:null,image:'1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc.png',sheet_x:21,sheet_y:34,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF-1F3FD':{unified:'1F469-1F3FF-200D-1F91D-200D-1F469-1F3FD',non_qualified:null,image:'1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd.png',sheet_x:21,sheet_y:35,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF-1F3FE':{unified:'1F469-1F3FF-200D-1F91D-200D-1F469-1F3FE',non_qualified:null,image:'1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe.png',sheet_x:21,sheet_y:36,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Two Women Holding Hands',b:'1F46D',j:['pair','friendship','couple','love','like','female','people','human'],k:[21,11],n:['women_holding_hands'],o:2},couple:{skin_variations:{'1F3FB':{unified:'1F46B-1F3FB',non_qualified:null,image:'1f46b-1f3fb.png',sheet_x:20,sheet_y:17,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F46B-1F3FC',non_qualified:null,image:'1f46b-1f3fc.png',sheet_x:20,sheet_y:18,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F46B-1F3FD',non_qualified:null,image:'1f46b-1f3fd.png',sheet_x:20,sheet_y:19,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F46B-1F3FE',non_qualified:null,image:'1f46b-1f3fe.png',sheet_x:20,sheet_y:20,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F46B-1F3FF',non_qualified:null,image:'1f46b-1f3ff.png',sheet_x:20,sheet_y:21,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FB-1F3FC':{unified:'1F469-1F3FB-200D-1F91D-200D-1F468-1F3FC',non_qualified:null,image:'1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc.png',sheet_x:20,sheet_y:22,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FB-1F3FD':{unified:'1F469-1F3FB-200D-1F91D-200D-1F468-1F3FD',non_qualified:null,image:'1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd.png',sheet_x:20,sheet_y:23,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FB-1F3FE':{unified:'1F469-1F3FB-200D-1F91D-200D-1F468-1F3FE',non_qualified:null,image:'1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe.png',sheet_x:20,sheet_y:24,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FB-1F3FF':{unified:'1F469-1F3FB-200D-1F91D-200D-1F468-1F3FF',non_qualified:null,image:'1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff.png',sheet_x:20,sheet_y:25,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC-1F3FB':{unified:'1F469-1F3FC-200D-1F91D-200D-1F468-1F3FB',non_qualified:null,image:'1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb.png',sheet_x:20,sheet_y:26,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC-1F3FD':{unified:'1F469-1F3FC-200D-1F91D-200D-1F468-1F3FD',non_qualified:null,image:'1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd.png',sheet_x:20,sheet_y:27,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC-1F3FE':{unified:'1F469-1F3FC-200D-1F91D-200D-1F468-1F3FE',non_qualified:null,image:'1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe.png',sheet_x:20,sheet_y:28,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC-1F3FF':{unified:'1F469-1F3FC-200D-1F91D-200D-1F468-1F3FF',non_qualified:null,image:'1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff.png',sheet_x:20,sheet_y:29,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD-1F3FB':{unified:'1F469-1F3FD-200D-1F91D-200D-1F468-1F3FB',non_qualified:null,image:'1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb.png',sheet_x:20,sheet_y:30,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD-1F3FC':{unified:'1F469-1F3FD-200D-1F91D-200D-1F468-1F3FC',non_qualified:null,image:'1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc.png',sheet_x:20,sheet_y:31,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD-1F3FE':{unified:'1F469-1F3FD-200D-1F91D-200D-1F468-1F3FE',non_qualified:null,image:'1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe.png',sheet_x:20,sheet_y:32,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD-1F3FF':{unified:'1F469-1F3FD-200D-1F91D-200D-1F468-1F3FF',non_qualified:null,image:'1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff.png',sheet_x:20,sheet_y:33,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE-1F3FB':{unified:'1F469-1F3FE-200D-1F91D-200D-1F468-1F3FB',non_qualified:null,image:'1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb.png',sheet_x:20,sheet_y:34,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE-1F3FC':{unified:'1F469-1F3FE-200D-1F91D-200D-1F468-1F3FC',non_qualified:null,image:'1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc.png',sheet_x:20,sheet_y:35,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE-1F3FD':{unified:'1F469-1F3FE-200D-1F91D-200D-1F468-1F3FD',non_qualified:null,image:'1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd.png',sheet_x:20,sheet_y:36,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE-1F3FF':{unified:'1F469-1F3FE-200D-1F91D-200D-1F468-1F3FF',non_qualified:null,image:'1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff.png',sheet_x:20,sheet_y:37,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF-1F3FB':{unified:'1F469-1F3FF-200D-1F91D-200D-1F468-1F3FB',non_qualified:null,image:'1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb.png',sheet_x:20,sheet_y:38,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF-1F3FC':{unified:'1F469-1F3FF-200D-1F91D-200D-1F468-1F3FC',non_qualified:null,image:'1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc.png',sheet_x:20,sheet_y:39,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF-1F3FD':{unified:'1F469-1F3FF-200D-1F91D-200D-1F468-1F3FD',non_qualified:null,image:'1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd.png',sheet_x:20,sheet_y:40,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF-1F3FE':{unified:'1F469-1F3FF-200D-1F91D-200D-1F468-1F3FE',non_qualified:null,image:'1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe.png',sheet_x:20,sheet_y:41,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Man and Woman Holding Hands',b:'1F46B',j:['pair','people','human','love','date','dating','like','affection','valentines','marriage'],k:[20,16],n:['man_and_woman_holding_hands','woman_and_man_holding_hands'],o:2},two_men_holding_hands:{skin_variations:{'1F3FB':{unified:'1F46C-1F3FB',non_qualified:null,image:'1f46c-1f3fb.png',sheet_x:20,sheet_y:43,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC':{unified:'1F46C-1F3FC',non_qualified:null,image:'1f46c-1f3fc.png',sheet_x:20,sheet_y:44,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD':{unified:'1F46C-1F3FD',non_qualified:null,image:'1f46c-1f3fd.png',sheet_x:20,sheet_y:45,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE':{unified:'1F46C-1F3FE',non_qualified:null,image:'1f46c-1f3fe.png',sheet_x:20,sheet_y:46,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF':{unified:'1F46C-1F3FF',non_qualified:null,image:'1f46c-1f3ff.png',sheet_x:20,sheet_y:47,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FB-1F3FC':{unified:'1F468-1F3FB-200D-1F91D-200D-1F468-1F3FC',non_qualified:null,image:'1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc.png',sheet_x:20,sheet_y:48,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FB-1F3FD':{unified:'1F468-1F3FB-200D-1F91D-200D-1F468-1F3FD',non_qualified:null,image:'1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd.png',sheet_x:20,sheet_y:49,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FB-1F3FE':{unified:'1F468-1F3FB-200D-1F91D-200D-1F468-1F3FE',non_qualified:null,image:'1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe.png',sheet_x:20,sheet_y:50,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FB-1F3FF':{unified:'1F468-1F3FB-200D-1F91D-200D-1F468-1F3FF',non_qualified:null,image:'1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff.png',sheet_x:20,sheet_y:51,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FC-1F3FB':{unified:'1F468-1F3FC-200D-1F91D-200D-1F468-1F3FB',non_qualified:null,image:'1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb.png',sheet_x:20,sheet_y:52,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FC-1F3FD':{unified:'1F468-1F3FC-200D-1F91D-200D-1F468-1F3FD',non_qualified:null,image:'1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd.png',sheet_x:20,sheet_y:53,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FC-1F3FE':{unified:'1F468-1F3FC-200D-1F91D-200D-1F468-1F3FE',non_qualified:null,image:'1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe.png',sheet_x:20,sheet_y:54,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FC-1F3FF':{unified:'1F468-1F3FC-200D-1F91D-200D-1F468-1F3FF',non_qualified:null,image:'1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff.png',sheet_x:20,sheet_y:55,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FD-1F3FB':{unified:'1F468-1F3FD-200D-1F91D-200D-1F468-1F3FB',non_qualified:null,image:'1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb.png',sheet_x:20,sheet_y:56,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD-1F3FC':{unified:'1F468-1F3FD-200D-1F91D-200D-1F468-1F3FC',non_qualified:null,image:'1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc.png',sheet_x:21,sheet_y:0,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FD-1F3FE':{unified:'1F468-1F3FD-200D-1F91D-200D-1F468-1F3FE',non_qualified:null,image:'1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe.png',sheet_x:21,sheet_y:1,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FD-1F3FF':{unified:'1F468-1F3FD-200D-1F91D-200D-1F468-1F3FF',non_qualified:null,image:'1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff.png',sheet_x:21,sheet_y:2,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FE-1F3FB':{unified:'1F468-1F3FE-200D-1F91D-200D-1F468-1F3FB',non_qualified:null,image:'1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb.png',sheet_x:21,sheet_y:3,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE-1F3FC':{unified:'1F468-1F3FE-200D-1F91D-200D-1F468-1F3FC',non_qualified:null,image:'1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc.png',sheet_x:21,sheet_y:4,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE-1F3FD':{unified:'1F468-1F3FE-200D-1F91D-200D-1F468-1F3FD',non_qualified:null,image:'1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd.png',sheet_x:21,sheet_y:5,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FE-1F3FF':{unified:'1F468-1F3FE-200D-1F91D-200D-1F468-1F3FF',non_qualified:null,image:'1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff.png',sheet_x:21,sheet_y:6,added_in:'12.1',has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_facebook:false},'1F3FF-1F3FB':{unified:'1F468-1F3FF-200D-1F91D-200D-1F468-1F3FB',non_qualified:null,image:'1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb.png',sheet_x:21,sheet_y:7,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF-1F3FC':{unified:'1F468-1F3FF-200D-1F91D-200D-1F468-1F3FC',non_qualified:null,image:'1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc.png',sheet_x:21,sheet_y:8,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF-1F3FD':{unified:'1F468-1F3FF-200D-1F91D-200D-1F468-1F3FD',non_qualified:null,image:'1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd.png',sheet_x:21,sheet_y:9,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true},'1F3FF-1F3FE':{unified:'1F468-1F3FF-200D-1F91D-200D-1F468-1F3FE',non_qualified:null,image:'1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe.png',sheet_x:21,sheet_y:10,added_in:'12.1',has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_facebook:true}},a:'Two Men Holding Hands',b:'1F46C',j:['pair','couple','love','like','bromance','friendship','people','human'],k:[20,42],n:['men_holding_hands'],o:2},couplekiss:{obsoleted_by:'1F469-200D-2764-FE0F-200D-1F48B-200D-1F468',a:'Kiss',b:'1F48F',k:[25,25],o:2},'woman-kiss-man':{obsoletes:'1F48F',a:'Woman Kiss Man',b:'1F469-200D-2764-FE0F-200D-1F48B-200D-1F468',c:'1F469-200D-2764-200D-1F48B-200D-1F468',k:[20,7],o:2},'man-kiss-man':{a:'Man Kiss Man',b:'1F468-200D-2764-FE0F-200D-1F48B-200D-1F468',c:'1F468-200D-2764-200D-1F48B-200D-1F468',k:[17,21],o:2},'woman-kiss-woman':{a:'Woman Kiss Woman',b:'1F469-200D-2764-FE0F-200D-1F48B-200D-1F469',c:'1F469-200D-2764-200D-1F48B-200D-1F469',k:[20,8],o:2},couple_with_heart:{obsoleted_by:'1F469-200D-2764-FE0F-200D-1F468',a:'Couple with Heart',b:'1F491',k:[25,27],o:2},'woman-heart-man':{obsoletes:'1F491',a:'Woman Heart Man',b:'1F469-200D-2764-FE0F-200D-1F468',c:'1F469-200D-2764-200D-1F468',k:[20,5],o:2},'man-heart-man':{a:'Man Heart Man',b:'1F468-200D-2764-FE0F-200D-1F468',c:'1F468-200D-2764-200D-1F468',k:[17,20],o:2},'woman-heart-woman':{a:'Woman Heart Woman',b:'1F469-200D-2764-FE0F-200D-1F469',c:'1F469-200D-2764-200D-1F469',k:[20,6],o:2},family:{obsoleted_by:'1F468-200D-1F469-200D-1F466',a:'Family',b:'1F46A',k:[20,15],n:['man-woman-boy'],o:2},'man-woman-boy':{obsoletes:'1F46A',a:'Man Woman Boy',b:'1F468-200D-1F469-200D-1F466',k:[15,33],n:['family'],o:2},'man-woman-girl':{a:'Man Woman Girl',b:'1F468-200D-1F469-200D-1F467',k:[15,35],o:2},'man-woman-girl-boy':{a:'Man Woman Girl Boy',b:'1F468-200D-1F469-200D-1F467-200D-1F466',k:[15,36],o:2},'man-woman-boy-boy':{a:'Man Woman Boy Boy',b:'1F468-200D-1F469-200D-1F466-200D-1F466',k:[15,34],o:2},'man-woman-girl-girl':{a:'Man Woman Girl Girl',b:'1F468-200D-1F469-200D-1F467-200D-1F467',k:[15,37],o:2},'man-man-boy':{a:'Man Man Boy',b:'1F468-200D-1F468-200D-1F466',k:[15,28],o:2},'man-man-girl':{a:'Man Man Girl',b:'1F468-200D-1F468-200D-1F467',k:[15,30],o:2},'man-man-girl-boy':{a:'Man Man Girl Boy',b:'1F468-200D-1F468-200D-1F467-200D-1F466',k:[15,31],o:2},'man-man-boy-boy':{a:'Man Man Boy Boy',b:'1F468-200D-1F468-200D-1F466-200D-1F466',k:[15,29],o:2},'man-man-girl-girl':{a:'Man Man Girl Girl',b:'1F468-200D-1F468-200D-1F467-200D-1F467',k:[15,32],o:2},'woman-woman-boy':{a:'Woman Woman Boy',b:'1F469-200D-1F469-200D-1F466',k:[18,18],o:2},'woman-woman-girl':{a:'Woman Woman Girl',b:'1F469-200D-1F469-200D-1F467',k:[18,20],o:2},'woman-woman-girl-boy':{a:'Woman Woman Girl Boy',b:'1F469-200D-1F469-200D-1F467-200D-1F466',k:[18,21],o:2},'woman-woman-boy-boy':{a:'Woman Woman Boy Boy',b:'1F469-200D-1F469-200D-1F466-200D-1F466',k:[18,19],o:2},'woman-woman-girl-girl':{a:'Woman Woman Girl Girl',b:'1F469-200D-1F469-200D-1F467-200D-1F467',k:[18,22],o:2},'man-boy':{a:'Man Boy',b:'1F468-200D-1F466',k:[15,24],o:4},'man-boy-boy':{a:'Man Boy Boy',b:'1F468-200D-1F466-200D-1F466',k:[15,23],o:4},'man-girl':{a:'Man Girl',b:'1F468-200D-1F467',k:[15,27],o:4},'man-girl-boy':{a:'Man Girl Boy',b:'1F468-200D-1F467-200D-1F466',k:[15,25],o:4},'man-girl-girl':{a:'Man Girl Girl',b:'1F468-200D-1F467-200D-1F467',k:[15,26],o:4},'woman-boy':{a:'Woman Boy',b:'1F469-200D-1F466',k:[18,14],o:4},'woman-boy-boy':{a:'Woman Boy Boy',b:'1F469-200D-1F466-200D-1F466',k:[18,13],o:4},'woman-girl':{a:'Woman Girl',b:'1F469-200D-1F467',k:[18,17],o:4},'woman-girl-boy':{a:'Woman Girl Boy',b:'1F469-200D-1F467-200D-1F466',k:[18,15],o:4},'woman-girl-girl':{a:'Woman Girl Girl',b:'1F469-200D-1F467-200D-1F467',k:[18,16],o:4},speaking_head_in_silhouette:{a:'Speaking Head in Silhouette',b:'1F5E3-FE0F',c:'1F5E3',k:[30,25],o:2},bust_in_silhouette:{a:'Bust in Silhouette',b:'1F464',j:['user','person','human'],k:[14,24],o:2},busts_in_silhouette:{a:'Busts in Silhouette',b:'1F465',j:['user','person','human','group','team'],k:[14,25],o:2},footprints:{a:'Footprints',b:'1F463',j:['feet','tracking','walking','beach'],k:[14,23],o:2}},aliases:{raised_hand:'hand',satisfied:'laughing',tshirt:'shirt',hand_with_index_and_middle_fingers_crossed:'crossed_fingers',sign_of_the_horns:'the_horns',grinning_face_with_star_eyes:'star-struck',reversed_hand_with_middle_finger_extended:'middle_finger',thumbsup:'+1',thumbsdown:'-1',punch:'facepunch',grinning_face_with_one_large_and_one_small_eye:'zany_face',shoe:'mans_shoe',smiling_face_with_smiling_eyes_and_hand_covering_mouth:'face_with_hand_over_mouth',face_with_finger_covering_closed_lips:'shushing_face',face_with_one_eyebrow_raised:'face_with_raised_eyebrow',face_with_open_mouth_vomiting:'face_vomiting',cooking:'fried_egg','flag-cn':'cn',shocked_face_with_exploding_head:'exploding_head',paw_prints:'feet','flag-de':'de',telephone:'phone','flag-es':'es',red_car:'car',flipper:'dolphin','flag-fr':'fr',uk:'gb','flag-gb':'gb',serious_face_with_symbols_covering_mouth:'face_with_symbols_on_mouth',poop:'hankey',shit:'hankey',honeybee:'bee',lantern:'izakaya_lantern',open_book:'book',sailboat:'boat',knife:'hocho','flag-it':'it',heavy_exclamation_mark:'exclamation','flag-jp':'jp',envelope:'email','flag-kr':'kr',collision:'boom',pencil:'memo',waxing_gibbous_moon:'moon',mother_christmas:'mrs_claus',sun_small_cloud:'mostly_sunny',sun_behind_cloud:'barely_sunny',sun_behind_rain_cloud:'partly_sunny_rain',lightning_cloud:'lightning',tornado_cloud:'tornado','flag-ru':'ru',running:'runner','flag-us':'us',women_holding_hands:'two_women_holding_hands',man_and_woman_holding_hands:'couple',woman_and_man_holding_hands:'couple',men_holding_hands:'two_men_holding_hands','man-woman-boy':'family',family:'man-woman-boy'}};/* harmony default export */ var emoji_list = (emojiList);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/emoji-picker/emoji-picker.vue?vue&type=script&lang=ts&










var emoji_pickervue_type_script_lang_ts_NEmojiPicker = /*#__PURE__*/function (_Vue) {
  _inherits(NEmojiPicker, _Vue);

  var _super = _createSuper(NEmojiPicker);

  function NEmojiPicker() {
    var _this;

    _classCallCheck(this, NEmojiPicker);

    _this = _super.apply(this, arguments);
    _this.emojiPickerOpen = false;
    _this.ei = new emoji_mart["EmojiIndex"](emoji_list, {
      recentLength: 8,
      exclude: ['flags', 'symbols']
    });
    return _this;
  }

  _createClass(NEmojiPicker, [{
    key: "toggleOpen",
    value: function toggleOpen() {
      this.emojiPickerOpen = !this.emojiPickerOpen;
    }
  }, {
    key: "insertEmoji",
    value: function insertEmoji(emoji) {
      this.toggleOpen();
      this.$emit('emojiSelect', emoji);
    }
  }]);

  return NEmojiPicker;
}(external_vue_default.a);

__decorate([Prop({
  default: '#062b80'
})], emoji_pickervue_type_script_lang_ts_NEmojiPicker.prototype, "accentColour", void 0);

emoji_pickervue_type_script_lang_ts_NEmojiPicker = __decorate([vue_class_component_esm({
  components: {
    Picker: emoji_mart["Picker"],
    NButton: button_button
  }
})], emoji_pickervue_type_script_lang_ts_NEmojiPicker);
/* harmony default export */ var emoji_pickervue_type_script_lang_ts_ = (emoji_pickervue_type_script_lang_ts_NEmojiPicker);
// CONCATENATED MODULE: ./src/components/visualisations/emoji-picker/emoji-picker.vue?vue&type=script&lang=ts&
 /* harmony default export */ var emoji_picker_emoji_pickervue_type_script_lang_ts_ = (emoji_pickervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/visualisations/emoji-picker/emoji-picker.vue?vue&type=style&index=0&id=5e1d87b0&lang=scss&scoped=true&
var emoji_pickervue_type_style_index_0_id_5e1d87b0_lang_scss_scoped_true_ = __webpack_require__("6e97");

// CONCATENATED MODULE: ./src/components/visualisations/emoji-picker/emoji-picker.vue






/* normalize component */

var emoji_picker_component = normalizeComponent(
  emoji_picker_emoji_pickervue_type_script_lang_ts_,
  emoji_pickervue_type_template_id_5e1d87b0_scoped_true_render,
  emoji_pickervue_type_template_id_5e1d87b0_scoped_true_staticRenderFns,
  false,
  null,
  "5e1d87b0",
  null
  
)

/* harmony default export */ var emoji_picker = (emoji_picker_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/conversation/message-composer.vue?vue&type=script&lang=ts&












var message_composervue_type_script_lang_ts_NMessageComposer = /*#__PURE__*/function (_Vue) {
  _inherits(NMessageComposer, _Vue);

  var _super = _createSuper(NMessageComposer);

  function NMessageComposer() {
    var _this;

    _classCallCheck(this, NMessageComposer);

    _this = _super.apply(this, arguments);
    _this.messageText = '';
    _this.selectionStart = 0;
    _this.selectionEnd = 0;
    _this.isInputFocused = false;
    _this.sentTyping = false;
    _this.stopTyping = Object(lodash["debounce"])(function (self) {
      self.sendTypingStop(); // eslint-disable-next-line no-param-reassign

      self.sentTyping = false;
    }, 10000);
    return _this;
  }

  _createClass(NMessageComposer, [{
    key: "mounted",
    value: function mounted() {
      autosize_esm(this.$refs.input);
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      this.isInputFocused = true;
    }
  }, {
    key: "onBlur",
    value: function onBlur(event) {
      this.selectionStart = event.target.selectionStart;
      this.selectionEnd = event.target.selectionEnd;
      this.isInputFocused = false;
    }
  }, {
    key: "insertEmoji",
    value: function insertEmoji(emoji) {
      var _this2 = this;

      this.messageText = this.messageText.substring(0, this.selectionStart) + emoji.native + this.messageText.substring(this.selectionEnd, this.messageText.length);
      this.$nextTick(function () {
        _this2.setCursorPosition(_this2.selectionStart + 2);

        autosize_esm.update(_this2.$refs.input);
      });
    }
  }, {
    key: "onInput",
    value: function onInput() {
      this.sendConversationRead();

      if (!this.sentTyping) {
        this.$emit('typingStart');
        this.sentTyping = true;
      }

      this.stopTyping(this);
    }
  }, {
    key: "setCursorPosition",
    value: function setCursorPosition(pos) {
      this.$refs.input.focus();
      this.$refs.input.setSelectionRange(pos, pos);
    }
  }, {
    key: "onSend",
    value: function onSend(e) {
      var _this3 = this;

      if (e) {
        e.preventDefault();
      }

      if (!this.messageText.trim().length) {
        this.messageText = '';
        return;
      }

      this.$emit('messageSend', this.messageText); // cancel the stop typing event so we don't send stop typing after we've sent the message

      this.sentTyping = false;
      this.messageText = ''; // reset height of textarea (in case it had to grow to accommmodate text)

      this.$nextTick(function () {
        autosize_esm.update(_this3.$refs.input);
      });
    }
  }, {
    key: "getOpacity",
    value: function getOpacity() {
      if (this.messageText && this.messageText.length === 0) {
        return 0.4;
      }

      return 1;
    }
  }, {
    key: "sendConversationRead",
    value: function sendConversationRead() {
      this.$emit('conversationRead');
    }
  }, {
    key: "sendTypingStop",
    value: function sendTypingStop() {
      this.$emit('typingStop');
    }
  }]);

  return NMessageComposer;
}(external_vue_default.a);

__decorate([Prop({
  default: '#062b80'
})], message_composervue_type_script_lang_ts_NMessageComposer.prototype, "accentColour", void 0);

__decorate([Prop()], message_composervue_type_script_lang_ts_NMessageComposer.prototype, "disabled", void 0);

message_composervue_type_script_lang_ts_NMessageComposer = __decorate([vue_class_component_esm({
  components: {
    NEmojiPicker: emoji_picker,
    NButton: button_button
  },
  name: 'n-message-composer'
})], message_composervue_type_script_lang_ts_NMessageComposer);
/* harmony default export */ var message_composervue_type_script_lang_ts_ = (message_composervue_type_script_lang_ts_NMessageComposer);
// CONCATENATED MODULE: ./src/components/visualisations/conversation/message-composer.vue?vue&type=script&lang=ts&
 /* harmony default export */ var conversation_message_composervue_type_script_lang_ts_ = (message_composervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/visualisations/conversation/message-composer.vue?vue&type=style&index=0&id=3e2f946a&lang=scss&scoped=true&
var message_composervue_type_style_index_0_id_3e2f946a_lang_scss_scoped_true_ = __webpack_require__("3012");

// CONCATENATED MODULE: ./src/components/visualisations/conversation/message-composer.vue






/* normalize component */

var message_composer_component = normalizeComponent(
  conversation_message_composervue_type_script_lang_ts_,
  message_composervue_type_template_id_3e2f946a_scoped_true_render,
  message_composervue_type_template_id_3e2f946a_scoped_true_staticRenderFns,
  false,
  null,
  "3e2f946a",
  null
  
)

/* harmony default export */ var message_composer = (message_composer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/visualisations/conversation/conversation.vue?vue&type=script&lang=ts&









var conversationvue_type_script_lang_ts_NConversation = /*#__PURE__*/function (_Vue) {
  _inherits(NConversation, _Vue);

  var _super = _createSuper(NConversation);

  function NConversation() {
    _classCallCheck(this, NConversation);

    return _super.apply(this, arguments);
  }

  return _createClass(NConversation);
}(external_vue_default.a);

__decorate([Prop()], conversationvue_type_script_lang_ts_NConversation.prototype, "messages", void 0);

__decorate([Prop({
  default: '#062b80'
})], conversationvue_type_script_lang_ts_NConversation.prototype, "outboundMessageColour", void 0);

__decorate([Prop({
  default: false
})], conversationvue_type_script_lang_ts_NConversation.prototype, "displayAvatar", void 0);

__decorate([Prop({
  default: false
})], conversationvue_type_script_lang_ts_NConversation.prototype, "enableAvatarTooltip", void 0);

__decorate([Prop({
  default: true
})], conversationvue_type_script_lang_ts_NConversation.prototype, "readonlyApps", void 0);

conversationvue_type_script_lang_ts_NConversation = __decorate([vue_class_component_esm({
  components: {
    NConversationThread: conversation_thread,
    NMessageComposer: message_composer
  },
  name: 'n-conversation'
})], conversationvue_type_script_lang_ts_NConversation);
/* harmony default export */ var conversationvue_type_script_lang_ts_ = (conversationvue_type_script_lang_ts_NConversation);
// CONCATENATED MODULE: ./src/components/visualisations/conversation/conversation.vue?vue&type=script&lang=ts&
 /* harmony default export */ var conversation_conversationvue_type_script_lang_ts_ = (conversationvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/visualisations/conversation/conversation.vue





/* normalize component */

var conversation_component = normalizeComponent(
  conversation_conversationvue_type_script_lang_ts_,
  conversationvue_type_template_id_2a7074df_render,
  conversationvue_type_template_id_2a7074df_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var conversation = (conversation_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"16fa0f94-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/layout/modal/modal.vue?vue&type=template&id=01a58372&scoped=true&
var modalvue_type_template_id_01a58372_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-modal"},[_c('div',{staticClass:"n-modal__background",on:{"click":function($event){return _vm.$emit('cancel')}}}),_c('div',{staticClass:"n-modal__modal"},[_c('header',{staticClass:"n-modal__header"},[_vm._t("title"),_c('button',{staticClass:"n-modal__close-button",attrs:{"aria-label":"close"},on:{"click":function($event){return _vm.$emit('cancel')}}})],2),_c('section',{staticClass:"n-modal__body"},[_vm._t("body")],2),_c('footer',{staticClass:"n-modal__footer"},[_vm._t("buttons")],2)])])}
var modalvue_type_template_id_01a58372_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/layout/modal/modal.vue?vue&type=template&id=01a58372&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/layout/modal/modal.vue?vue&type=script&lang=ts&







var modalvue_type_script_lang_ts_NModal = /*#__PURE__*/function (_Vue) {
  _inherits(NModal, _Vue);

  var _super = _createSuper(NModal);

  function NModal() {
    _classCallCheck(this, NModal);

    return _super.apply(this, arguments);
  }

  return _createClass(NModal);
}(external_vue_default.a);

modalvue_type_script_lang_ts_NModal = __decorate([vue_class_component_esm({
  name: 'n-modal'
})], modalvue_type_script_lang_ts_NModal);
/* harmony default export */ var modalvue_type_script_lang_ts_ = (modalvue_type_script_lang_ts_NModal);
// CONCATENATED MODULE: ./src/components/layout/modal/modal.vue?vue&type=script&lang=ts&
 /* harmony default export */ var modal_modalvue_type_script_lang_ts_ = (modalvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/layout/modal/modal.vue?vue&type=style&index=0&id=01a58372&lang=scss&scoped=true&
var modalvue_type_style_index_0_id_01a58372_lang_scss_scoped_true_ = __webpack_require__("a71b");

// CONCATENATED MODULE: ./src/components/layout/modal/modal.vue






/* normalize component */

var modal_component = normalizeComponent(
  modal_modalvue_type_script_lang_ts_,
  modalvue_type_template_id_01a58372_scoped_true_render,
  modalvue_type_template_id_01a58372_scoped_true_staticRenderFns,
  false,
  null,
  "01a58372",
  null
  
)

/* harmony default export */ var modal = (modal_component.exports);
// CONCATENATED MODULE: ./src/components/index.ts























// CONCATENATED MODULE: ./src/index.ts





var components = [button_button, text_input, select_select, toggle, badge, number_input, radio_button, checkbox_checkbox, checkbox_group, colour_picker, tooltip, button_group, read_only_input, split_input_button, datatable, date_picker, icon, conversation, conversation_thread, emoji_picker, modal, app, avatar];
var ComponentLibrary = {
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // components
    components.forEach(function (component) {
      Vue.component(component.options.name, component);
    });
  }
};
/* harmony default export */ var src_0 = (ComponentLibrary);

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(ComponentLibrary);
}


// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src_0);



/***/ }),

/***/ "fb6a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var isArray = __webpack_require__("e8b5");
var isConstructor = __webpack_require__("68ee");
var isObject = __webpack_require__("861d");
var toAbsoluteIndex = __webpack_require__("23cb");
var lengthOfArrayLike = __webpack_require__("07fa");
var toIndexedObject = __webpack_require__("fc6a");
var createProperty = __webpack_require__("8418");
var wellKnownSymbol = __webpack_require__("b622");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var un$Slice = __webpack_require__("f36a");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var Array = global.Array;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return un$Slice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fce3":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var global = __webpack_require__("da84");

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});


/***/ }),

/***/ "fd48":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_conversation_thread_vue_vue_type_style_index_0_id_86e34550_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("45ff");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_conversation_thread_vue_vue_type_style_index_0_id_86e34550_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_cli_service_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_conversation_thread_vue_vue_type_style_index_0_id_86e34550_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "fd7e":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var xPseudo = moment.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
            '_'
        ),
        monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
            '_'
        ),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return xPseudo;

})));


/***/ }),

/***/ "fdbc":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__("4930");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "fe95":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "fea9":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global.Promise;


/***/ }),

/***/ "ffff":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var se = moment.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
            '_'
        ),
        monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split(
            '_'
        ),
        weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
            '_'
        ),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return se;

})));


/***/ })

/******/ });
//# sourceMappingURL=componentLibrary.common.js.map